// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714%27 height=%278%27%3E%3Cpath fill=%27%231b1d21%27 d=%27M.293.293A1 1 0 0 1 1.613.21l.094.083L7 5.585 12.293.293a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 .083 1.32l-.083.094-6 6a1 1 0 0 1-1.32.083l-.094-.083-6-6a1 1 0 0 1 0-1.414z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%276%27 height=%2710%27%3E%3Cpath fill=%27%2311142d%27 d=%27M.293.293A1 1 0 0 1 1.613.21l.094.083 4 4a1 1 0 0 1 .083 1.32l-.083.094-4 4A1 1 0 0 1 .21 8.387l.083-.094L3.585 5 .293 1.707A1 1 0 0 1 .21.387L.293.293z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714%27 height=%278%27%3E%3Cpath fill=%27%23ffffff%27 d=%27M.293.293A1 1 0 0 1 1.613.21l.094.083L7 5.585 12.293.293a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 .083 1.32l-.083.094-6 6a1 1 0 0 1-1.32.083l-.094-.083-6-6a1 1 0 0 1 0-1.414z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%276%27 height=%2710%27%3E%3Cpath fill=%27%23ffffff%27 d=%27M.293.293A1 1 0 0 1 1.613.21l.094.083 4 4a1 1 0 0 1 .083 1.32l-.083.094-4 4A1 1 0 0 1 .21 8.387l.083-.094L3.585 5 .293 1.707A1 1 0 0 1 .21.387L.293.293z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg width=%2710%27 height=%279%27 viewBox=%270 0 10 9%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M3.5 5.375L1.5 3.375L0 4.875L3.5 8.375L10 1.875L8.5 0.375L3.5 5.375Z%27 fill=%27white%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%277%27 fill=%27none%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M9.293.333a.5.5 0 0 1 .39.812L5.39 6.512a.5.5 0 0 1-.781 0L.317 1.146a.5.5 0 0 1 .39-.812h8.586z%27 fill=%27%23b5b5be%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%2710%27 viewBox=%270 0 10 10%27%3E%3Cpath fill=%27%2311142d%27 d=%27M1.613.2l.094.083L5 3.585 8.293.293a1 1 0 0 1 1.414 0 1 1 0 0 1 .083 1.32l-.083.094L6.415 5l3.292 3.293a1 1 0 0 1-1.32 1.497l-.094-.083L5 6.415 1.707 9.707A1 1 0 0 1 .21 8.387l.083-.094L3.585 5 .293 1.707a1 1 0 0 1 0-1.414A1 1 0 0 1 1.613.21z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%2710%27 viewBox=%270 0 10 10%27%3E%3Cpath fill=%27%23ffffff%27 d=%27M1.613.2l.094.083L5 3.585 8.293.293a1 1 0 0 1 1.414 0 1 1 0 0 1 .083 1.32l-.083.094L6.415 5l3.292 3.293a1 1 0 0 1-1.32 1.497l-.094-.083L5 6.415 1.707 9.707A1 1 0 0 1 .21 8.387l.083-.094L3.585 5 .293 1.707a1 1 0 0 1 0-1.414A1 1 0 0 1 1.613.21z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --main-color: #53c0cc;
    --secondary-color: #f4c257;
    --placeholder-color: rgba(228, 228, 228, 0.3);
    --disabled-color: #cccccc;
    --gray-color: #cbd5e1;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
}

html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
}

img,
fieldset,
a img {
    border: none;
}

input[type='text'],
input[type='email'],
input[type='tel'],
textarea {
    -webkit-appearance: none;
}

input[type='submit'],
button {
    cursor: pointer;
    background: none;
}

input[type='submit']::-moz-focus-inner,
button::-moz-focus-inner {
    padding: 0;
    border: 0;
}

textarea {
    overflow: auto;
}

input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

input,
button {
    margin: 0;
    padding: 0;
    border: 0;
}

div,
input,
textarea,
select,
button,
h1,
h2,
h3,
h4,
h5,
h6,
a,
span,
a:focus {
    outline: none;
}

select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
}

ul,
ol {
    list-style-type: none;
}

table {
    border-spacing: 0;
    border-collapse: collapse;
    width: 100%;
}

html {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

*,
*:before,
*:after {
    -webkit-box-sizing: inherit;
    box-sizing: inherit;
}

a {
    text-decoration: none;
}

a,
button {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.icon-arrow-down-fat {
    width: 1.33em;
    height: 1em;
    fill: #fff;
}

.icon-arrow-left {
    width: 0.6em;
    height: 1em;
    fill: #11142d;
}

.icon-arrow-next-fat {
    width: 1.3em;
    height: 1em;
    fill: #11142d;
}

.icon-arrow-next {
    width: 1.2em;
    height: 1em;
    fill: #11142d;
}

.icon-arrow-prev {
    width: 1.2em;
    height: 1em;
    fill: #11142d;
}

.icon-arrow-right {
    width: 0.6em;
    height: 1em;
    fill: #11142d;
}

.icon-arrow-up-fat {
    width: 1.33em;
    height: 1em;
    fill: #fff;
}

.icon-arrows {
    width: 0.63em;
    height: 1em;
    fill: #11142d;
}

.icon-bag {
    width: 0.95em;
    height: 1em;
    fill: #1b1d21;
}

.icon-bell {
    width: 0.92em;
    height: 1em;
    fill: #11142d;
}

.icon-box {
    width: 1.13em;
    height: 1em;
    fill: #11142d;
}

.icon-chart {
    width: 1em;
    height: 1em;
    fill: #1b1d21;
}

.icon-chat {
    width: 1em;
    height: 1em;
    fill: #1b1d21;
}

.icon-close {
    width: 1em;
    height: 1em;
    fill: #1b1d21;
}

.icon-comment {
    width: 1em;
    height: 1em;
    fill: #1b1d21;
}

.icon-discovery {
    width: 1em;
    height: 1em;
    fill: #1b1d21;
}

.icon-document {
    width: 0.95em;
    height: 1em;
    fill: #1b1d21;
}

.icon-dots-border {
    width: 4em;
    height: 1em;
    fill: #11142d;
}

.icon-download-fat {
    width: 0.94em;
    height: 1em;
    fill: #11142d;
}

.icon-download {
    width: 0.95em;
    height: 1em;
    fill: #7fba7a;
}

.icon-edit {
    width: 1em;
    height: 1em;
    fill: #11142d;
}

.icon-editor-bold {
    width: 0.83em;
    height: 1em;
    fill: #fff;
}

.icon-editor-italic {
    width: 0.5em;
    height: 1em;
    fill: #808191;
}

.icon-editor-pic {
    width: 1.08em;
    height: 1em;
    fill: #808191;
}

.icon-editor-smile {
    width: 1em;
    height: 1em;
    fill: #808191;
}

.icon-folder {
    width: 1.06em;
    height: 1em;
    fill: #11142d;
}

.icon-like {
    width: 1em;
    height: 1em;
    fill: #fff;
}

.icon-logout {
    width: 1em;
    height: 1em;
    fill: #1b1d21;
}

.icon-message {
    width: 1.11em;
    height: 1em;
    fill: #1b1d21;
}

.icon-moon {
    width: 1em;
    height: 1em;
    fill: #f4c257;
}

.icon-more {
    width: 1em;
    height: 1em;
    fill: #1b1d21;
}

.icon-notification {
    width: 0.91em;
    height: 1em;
    fill: #1b1d21;
}

.icon-overview {
    width: 0.95em;
    height: 1em;
    fill: #fff;
}

.icon-plus-square {
    width: 1em;
    height: 1em;
    fill: #fff;
}

.icon-print {
    width: 1em;
    height: 1em;
    fill: #11142d;
}

.icon-profile {
    width: 0.81em;
    height: 1em;
    fill: #1b1d21;
}

.icon-remove {
    width: 1em;
    height: 1em;
    fill: #11142d;
}

.icon-search {
    width: 1em;
    height: 1em;
    fill: #11142d;
}

.icon-settings {
    width: 0.91em;
    height: 1em;
    fill: #1b1d21;
}

.icon-star {
    width: 1em;
    height: 1em;
    fill: #1b1d21;
}

.icon-sun {
    width: 1em;
    height: 1em;
    fill: #f4c257;
}

.icon-wallet {
    width: 1.1em;
    height: 1em;
    fill: #1b1d21;
}

/**
* Owl Carousel v2.3.4
* Copyright 2013-2018 David Deutsch
* Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
*/
/*
*  Owl Carousel - Core
*/
.owl-carousel {
    display: none;
    width: 100%;
    -webkit-tap-highlight-color: transparent;
    /* position relative and z-index fix webkit rendering fonts issue */
    position: relative;
    z-index: 1;
}

.owl-carousel .owl-stage {
    position: relative;
    -ms-touch-action: pan-Y;
    touch-action: manipulation;
    -moz-backface-visibility: hidden;
    /* fix firefox animation glitch */
}

.owl-carousel .owl-stage:after {
    content: '.';
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
}

.owl-carousel .owl-stage-outer {
    position: relative;
    overflow: hidden;
    /* fix for flashing background */
    -webkit-transform: translate3d(0px, 0px, 0px);
}

.owl-carousel .owl-wrapper,
.owl-carousel .owl-item {
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -ms-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
}

.owl-carousel .owl-item {
    position: relative;
    min-height: 1px;
    float: left;
    -webkit-backface-visibility: hidden;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
}

.owl-carousel .owl-item img {
    display: block;
    width: 100%;
}

.owl-carousel .owl-nav.disabled,
.owl-carousel .owl-dots.disabled {
    display: none;
}

.owl-carousel .owl-nav .owl-prev,
.owl-carousel .owl-nav .owl-next,
.owl-carousel .owl-dot {
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.owl-carousel .owl-nav button.owl-prev,
.owl-carousel .owl-nav button.owl-next,
.owl-carousel button.owl-dot {
    background: none;
    color: inherit;
    border: none;
    padding: 0 !important;
    font: inherit;
}

.owl-carousel.owl-loaded {
    display: block;
}

.owl-carousel.owl-loading {
    opacity: 0;
    display: block;
}

.owl-carousel.owl-hidden {
    opacity: 0;
}

.owl-carousel.owl-refresh .owl-item {
    visibility: hidden;
}

.owl-carousel.owl-drag .owl-item {
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.owl-carousel.owl-grab {
    cursor: move;
    cursor: -webkit-grab;
    cursor: grab;
}

.owl-carousel.owl-rtl {
    direction: rtl;
}

.owl-carousel.owl-rtl .owl-item {
    float: right;
}

/* No Js */
.no-js .owl-carousel {
    display: block;
}

/*
*  Owl Carousel - Animate Plugin
*/
.owl-carousel .animated {
    -webkit-animation-duration: 1000ms;
    animation-duration: 1000ms;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}

.owl-carousel .owl-animated-in {
    z-index: 0;
}

.owl-carousel .owl-animated-out {
    z-index: 1;
}

.owl-carousel .fadeOut {
    -webkit-animation-name: fadeOut;
    animation-name: fadeOut;
}

@-webkit-keyframes fadeOut {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

@keyframes fadeOut {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

/*
* 	Owl Carousel - Auto Height Plugin
*/
.owl-height {
    -webkit-transition: height 500ms ease-in-out;
    -o-transition: height 500ms ease-in-out;
    transition: height 500ms ease-in-out;
}

/*
* 	Owl Carousel - Lazy Load Plugin
*/
.owl-carousel .owl-item {
    /**
    This is introduced due to a bug in IE11 where lazy loading combined with autoheight plugin causes a wrong
    calculation of the height of the owl-item that breaks page layouts
   */
}

.owl-carousel .owl-item .owl-lazy {
    opacity: 0;
    -webkit-transition: opacity 400ms ease;
    -o-transition: opacity 400ms ease;
    transition: opacity 400ms ease;
}

.owl-carousel .owl-item .owl-lazy[src^=''],
.owl-carousel .owl-item .owl-lazy:not([src]) {
    max-height: 0;
}

.owl-carousel .owl-item img.owl-lazy {
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;
}

/*
* 	Owl Carousel - Video Plugin
*/
.owl-carousel .owl-video-wrapper {
    position: relative;
    height: 100%;
    background: #000;
}

.owl-carousel .owl-video-play-icon {
    position: absolute;
    height: 80px;
    width: 80px;
    left: 50%;
    top: 50%;
    margin-left: -40px;
    margin-top: -40px;
    /* background: url("owl.video.play.png") no-repeat; */
    cursor: pointer;
    z-index: 1;
    -webkit-backface-visibility: hidden;
    -webkit-transition: -webkit-transform 100ms ease;
    transition: -webkit-transform 100ms ease;
    -o-transition: transform 100ms ease;
    transition: transform 100ms ease;
    transition: transform 100ms ease, -webkit-transform 100ms ease;
}

.owl-carousel .owl-video-play-icon:hover {
    -ms-transform: scale(1.3, 1.3);
    -webkit-transform: scale(1.3, 1.3);
    transform: scale(1.3, 1.3);
}

.owl-carousel .owl-video-playing .owl-video-tn,
.owl-carousel .owl-video-playing .owl-video-play-icon {
    display: none;
}

.owl-carousel .owl-video-tn {
    opacity: 0;
    height: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    -webkit-transition: opacity 400ms ease;
    -o-transition: opacity 400ms ease;
    transition: opacity 400ms ease;
}

.owl-carousel .owl-video-frame {
    position: relative;
    z-index: 1;
    height: 100%;
    width: 100%;
}

/* Magnific Popup CSS */
.mfp-bg {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1042;
    overflow: hidden;
    position: fixed;
    background: #0b0b0b;
    opacity: 0.8;
}

.mfp-wrap {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1043;
    position: fixed;
    outline: none !important;
    -webkit-backface-visibility: hidden;
}

.mfp-container {
    text-align: center;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    padding: 0 8px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.mfp-container:before {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
}

.mfp-align-top .mfp-container:before {
    display: none;
}

.mfp-content {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    margin: 0 auto;
    text-align: left;
    z-index: 1045;
}

.mfp-inline-holder .mfp-content,
.mfp-ajax-holder .mfp-content {
    width: 100%;
    cursor: auto;
}

.mfp-ajax-cur {
    cursor: progress;
}

.mfp-zoom-out-cur,
.mfp-zoom-out-cur .mfp-image-holder .mfp-close {
    cursor: -webkit-zoom-out;
    cursor: zoom-out;
}

.mfp-zoom {
    cursor: pointer;
    cursor: -webkit-zoom-in;
    cursor: zoom-in;
}

.mfp-auto-cursor .mfp-content {
    cursor: auto;
}

.mfp-close,
.mfp-arrow,
.mfp-preloader,
.mfp-counter {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.mfp-loading.mfp-figure {
    display: none;
}

.mfp-hide {
    display: none !important;
}

.mfp-preloader {
    color: #ccc;
    position: absolute;
    top: 50%;
    width: auto;
    text-align: center;
    margin-top: -0.8em;
    left: 8px;
    right: 8px;
    z-index: 1044;
}

.mfp-preloader a {
    color: #ccc;
}

.mfp-preloader a:hover {
    color: #fff;
}

.mfp-s-ready .mfp-preloader {
    display: none;
}

.mfp-s-error .mfp-content {
    display: none;
}

button.mfp-close,
button.mfp-arrow {
    overflow: visible;
    cursor: pointer;
    background: transparent;
    border: 0;
    -webkit-appearance: none;
    display: block;
    outline: none;
    padding: 0;
    z-index: 1046;
    -webkit-box-shadow: none;
    box-shadow: none;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
}

button::-moz-focus-inner {
    padding: 0;
    border: 0;
}

.mfp-close {
    width: 44px;
    height: 44px;
    line-height: 44px;
    position: absolute;
    right: 0;
    top: 0;
    text-decoration: none;
    text-align: center;
    opacity: 0.65;
    padding: 0 0 18px 10px;
    color: #fff;
    font-style: normal;
    font-size: 28px;
    font-family: Arial, Baskerville, monospace;
}

.mfp-close:hover,
.mfp-close:focus {
    opacity: 1;
}

.mfp-close:active {
    top: 1px;
}

.mfp-close-btn-in .mfp-close {
    color: #333;
}

.mfp-image-holder .mfp-close,
.mfp-iframe-holder .mfp-close {
    color: #fff;
    right: -6px;
    text-align: right;
    padding-right: 6px;
    width: 100%;
}

.mfp-counter {
    position: absolute;
    top: 0;
    right: 0;
    color: #ccc;
    font-size: 12px;
    line-height: 18px;
    white-space: nowrap;
}

.mfp-arrow {
    position: absolute;
    opacity: 0.65;
    margin: 0;
    top: 50%;
    margin-top: -55px;
    padding: 0;
    width: 90px;
    height: 110px;
    -webkit-tap-highlight-color: transparent;
}

.mfp-arrow:active {
    margin-top: -54px;
}

.mfp-arrow:hover,
.mfp-arrow:focus {
    opacity: 1;
}

.mfp-arrow:before,
.mfp-arrow:after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    left: 0;
    top: 0;
    margin-top: 35px;
    margin-left: 35px;
    border: medium inset transparent;
}

.mfp-arrow:after {
    border-top-width: 13px;
    border-bottom-width: 13px;
    top: 8px;
}

.mfp-arrow:before {
    border-top-width: 21px;
    border-bottom-width: 21px;
    opacity: 0.7;
}

.mfp-arrow-left {
    left: 0;
}

.mfp-arrow-left:after {
    border-right: 17px solid #fff;
    margin-left: 31px;
}

.mfp-arrow-left:before {
    margin-left: 25px;
    border-right: 27px solid #3f3f3f;
}

.mfp-arrow-right {
    right: 0;
}

.mfp-arrow-right:after {
    border-left: 17px solid #fff;
    margin-left: 39px;
}

.mfp-arrow-right:before {
    border-left: 27px solid #3f3f3f;
}

.mfp-iframe-holder {
    padding-top: 40px;
    padding-bottom: 40px;
}

.mfp-iframe-holder .mfp-content {
    line-height: 0;
    width: 100%;
    max-width: 900px;
}

.mfp-iframe-holder .mfp-close {
    top: -40px;
}

.mfp-iframe-scaler {
    width: 100%;
    height: 0;
    overflow: hidden;
    padding-top: 56.25%;
}

.mfp-iframe-scaler iframe {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
    background: #000;
}

/* Main image in popup */
img.mfp-img {
    width: auto;
    max-width: 100%;
    height: auto;
    display: block;
    line-height: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 40px 0 40px;
    margin: 0 auto;
}

/* The shadow behind the image */
.mfp-figure {
    line-height: 0;
}

.mfp-figure:after {
    content: '';
    position: absolute;
    left: 0;
    top: 40px;
    bottom: 40px;
    display: block;
    right: 0;
    width: auto;
    height: auto;
    z-index: -1;
    -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
    background: #444;
}

.mfp-figure small {
    color: #bdbdbd;
    display: block;
    font-size: 12px;
    line-height: 14px;
}

.mfp-figure figure {
    margin: 0;
}

.mfp-bottom-bar {
    margin-top: -36px;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    cursor: auto;
}

.mfp-title {
    text-align: left;
    line-height: 18px;
    color: #f3f3f3;
    word-wrap: break-word;
    padding-right: 36px;
}

.mfp-image-holder .mfp-content {
    max-width: 100%;
}

.mfp-gallery .mfp-image-holder .mfp-figure {
    cursor: pointer;
}

body {
    min-width: 375px;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    line-height: 1.71429;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #11142d;
}

body.dark {
    background: #242731;
    color: #ffffff;
}

body.no-scroll {
    overflow: hidden;
}

button,
input,
textarea,
select {
    font-family: 'Inter', sans-serif;
}

img {
    display: block;
    max-width: 100%;
}

body.dark .apexcharts-tooltip.apexcharts-theme-light {
    color: #11142d;
}

body.dark .apexcharts-gridlines-horizontal line {
    stroke: rgba(228, 228, 228, 0.1);
}

.page {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    min-height: 100vh;
}

.page__wrapper {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
    padding-left: 256px;
}

.page__center {
    max-width: 1200px;
    margin: 0 auto;
}

.page__row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.page__row_head .page__col {
    padding-top: 48px;
}

.page__row_border .page__col:nth-child(2) {
    border-left: 1px solid #e4e4e4;
}

.page__col {
    padding: 0 64px 44px;
}

.page__col:first-child {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 calc(100% - 426px);
    flex: 0 0 calc(100% - 426px);
    max-width: calc(100% - 426px);
}

.page__col:nth-child(2) {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 426px;
}

.page .page__col.page__col_w50 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
}

.page__widgets {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 0 -16px;
}

.page__widgets:not(:last-child) {
    margin-bottom: 43px;
}

.page__widgets .widget {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 calc(50% - 32px);
    flex: 0 0 calc(50% - 32px);
    width: calc(50% - 32px);
    margin: 0 16px;
}

.page__group .widget:not(:last-child) {
    margin-bottom: 69px;
}

.page__content {
    padding: 0 64px 64px;
}

.page__content_pt64 {
    padding-top: 64px;
    border-top: 1px solid #e4e4e4;
}

.page__stat {
    position: relative;
    padding: 50px 32px 40px;
    border-radius: 24px;
    background: #ffffff;
}

.page__stat:before {
    content: '';
    position: absolute;
    top: 43px;
    left: 32px;
    right: 32px;
    bottom: -43px;
    z-index: -1;
    background: #e3e6ec;
    opacity: 0.91;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

.page__stat_pt32 {
    padding-top: 32px;
}

.page__stat_sm .sorting {
    position: absolute;
    top: 32px;
    right: 40px;
}

.page__flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.page__flex .widget:first-child {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 298px;
    margin-right: 32px;
}

.page__flex .widget:nth-child(2) {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
}

.page__title {
    margin-bottom: 32px;
}

.page__nav {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 48px;
}

.page__nav .page__link {
    padding: 7px 18px;
    border-radius: 12px;
    font-weight: 600;
    color: #808191;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.page__nav .page__link:hover,
.page__nav .page__link.active {
    background: var(--main-color);
    color: #ffffff;
}

body.dark .page__row_border .page__col:nth-child(2) {
    border-color: rgba(228, 228, 228, 0.1);
}

body.dark .page__stat {
    background: #242731;
}

body.dark .page__stat:before {
    background: #000;
    opacity: 0.51;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

body.dark .page__content_pt64 {
    border-color: rgba(228, 228, 228, 0.1);
}

.sidebar {
    position: fixed;
    top: 0;
    left: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 256px;
    height: 100vh;
    padding: 140px 0 72px;
    background: #ffffff;
    border-right: 1px solid #e4e4e4;
    z-index: 99;
}

.sidebar__wrapper {
    max-height: 100%;
    padding: 0 20px 30px;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
}

.sidebar__wrapper::-webkit-scrollbar {
    display: none;
}

.sidebar__inner {
    width: 215px;
    overflow: hidden;
    -webkit-transition: width 0.25s;
    -o-transition: width 0.25s;
    transition: width 0.25s;
}

.sidebar__top {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 140px;
}

.sidebar__logo {
    font-size: 0;
}

.sidebar__logo .sidebar__pic {
    width: 176px;
}

.sidebar__logo .sidebar__pic_white {
    display: none;
}

.sidebar__close {
    position: relative;
    top: -3px;
    display: none;
    margin-right: 25px;
    font-size: 0;
}

.sidebar__close .icon {
    font-size: 20px;
    fill: #11142d;
}

.sidebar__wrapper .sidebar__logo {
    display: none;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 0;
    overflow: hidden;
    margin: 0 -20px;
}

.sidebar__burger {
    position: fixed;
    top: 0;
    left: 0;
    display: none;
    padding: 20px;
    font-size: 72px;
    z-index: 45;
}

.sidebar__list {
    margin-bottom: 20px;
}

.sidebar__group:not(:last-child) {
    position: relative;
    margin-bottom: 40px;
    padding-bottom: 30px;
}

.sidebar__group:not(:last-child):before {
    content: '';
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 0;
    height: 1px;
    background: #f0f3f6;
}

.sidebar__caption {
    margin-bottom: 16px;
    padding-left: 20px;
    color: #808191;
}

.sidebar__item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 56px;
    padding: 0 20px;
    border-radius: 12px;
    background: transparent;
    font-size: 14px;
    font-weight: 600;
    color: #808191;
    -webkit-transition: color 0.25s;
    -o-transition: color 0.25s;
    transition: color 0.25s;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.sidebar__item:hover {
    color: var(--main-color);
}

.sidebar__item.active {
    background: var(--main-color);
    color: #ffffff;
}

.sidebar__icon {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    margin-right: 16px;
    font-size: 0;
}

.sidebar__icon .icon {
    font-size: 21px;
    fill: #1b1d21;
    opacity: 0.4;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.sidebar__icon .icon-message {
    font-size: 19px;
}

.sidebar__item:hover .icon {
    fill: var(--main-color);
    opacity: 1;
}

.sidebar__item.active .icon {
    opacity: 1;
    fill: #ffffff;
}

.sidebar__item .sidebar__text {
    margin-right: auto;
}

.sidebar__counter {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    min-width: 24px;
    margin-left: 10px;
    padding: 0 3px;
    border-radius: 12px;
    background: #ff754c;
    text-align: center;
    font-size: 12px;
    line-height: 24px;
    font-weight: 500;
    color: #ffffff;
}

.sidebar__profile {
    margin-top: 25px;
}

.sidebar__details {
    position: relative;
    display: none;
    padding: 20px 10px 33px;
    margin-bottom: -15px;
    background: #f7f7f7;
    border-radius: 12px;
    -webkit-transition: padding 0.25s, background 0.25s;
    -o-transition: padding 0.25s, background 0.25s;
    transition: padding 0.25s, background 0.25s;
}

.sidebar__details:before {
    content: '';
    position: absolute;
    top: 8px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 72px;
    height: 4px;
    border-radius: 2px;
    background: #e4e4e4;
}

.sidebar__link {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 56px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    color: #808191;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.sidebar__link:hover {
    background: #ffffff;
    -webkit-box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.04);
    box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.04);
}

.sidebar__link .sidebar__icon {
    width: 50px;
    margin: 0;
    padding-right: 6px;
    text-align: center;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.sidebar__img {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 50px;
    height: 56px;
    padding-right: 5px;
}

.sidebar__img .icon {
    font-size: 19px;
}

.sidebar__user {
    position: relative;
    z-index: 2;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0 20px;
    height: 62px;
    border-radius: 12px;
    color: #11142d;
    cursor: pointer;
    -webkit-transition: background 0.25s;
    -o-transition: background 0.25s;
    transition: background 0.25s;
}

.sidebar__user:hover,
.sidebar__user.active {
    background: var(--main-color);
    color: #ffffff;
}

.sidebar__user:hover .sidebar__status,
.sidebar__user.active .sidebar__status {
    color: #ffffff;
}

.sidebar__user:hover .icon,
.sidebar__user.active .icon {
    fill: #ffffff;
}

.sidebar__ava {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    font-size: 0;
}

.sidebar__ava .sidebar__pic {
    width: 100%;
    min-height: 100%;
    border-radius: 50%;
}

.sidebar__arrow {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 24px;
    height: 24px;
    font-size: 0;
}

.sidebar__arrow .icon {
    font-size: 16px;
    fill: #11142d;
}

.sidebar__desc {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 calc(100% - 64px);
    flex: 0 0 calc(100% - 64px);
    width: calc(100% - 64px);
    padding: 0 5px 0 16px;
}

.sidebar__man {
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    line-height: 1.42857;
    font-weight: 600;
}

.sidebar__status {
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #808191;
}

.sidebar__bottom {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 72px;
    padding: 0 40px;
    -webkit-box-shadow: inset 0px 1px 0px rgba(0, 0, 0, 0.05);
    box-shadow: inset 0px 1px 0px rgba(0, 0, 0, 0.05);
}

.sidebar .switch {
    margin-right: auto;
}

.sidebar__banner {
    position: relative;
    margin-top: 50px;
    padding: 8px 8px 20px;
    border-radius: 16px;
    background: #cfc8ff;
    text-align: center;
}

.sidebar__banner:before {
    content: '';
    position: absolute;
    top: 8px;
    left: 8px;
    right: 8px;
    bottom: -8px;
    z-index: -1;
    border-radius: 12px;
    background: rgba(207, 200, 255, 0.5);
}

.sidebar__banner:not(:last-child) {
    margin-bottom: 40px;
}

.sidebar__preview {
    margin-bottom: 6px;
    font-size: 0;
}

.sidebar__banner .sidebar__btn {
    min-width: 171px;
    color: var(--main-color);
}

.sidebar__banner .sidebar__btn:hover {
    color: var(--main-color);
}

.sidebar.active .sidebar__top {
    padding: 0;
}

.sidebar.active .sidebar__icon {
    margin-right: 21px;
}

.sidebar.active .sidebar__wrapper .sidebar__logo {
    height: 80px;
}

.sidebar.active .sidebar__details {
    padding: 5px 0 17px;
    background: none;
}

.sidebar.active .sidebar__link .sidebar__icon {
    width: 56px;
    padding: 0;
}

body.dark .sidebar {
    background: #242731;
    border-color: rgba(228, 228, 228, 0.1);
}

body.dark .sidebar__pic_black {
    display: none;
}

body.dark .sidebar__pic_white {
    display: inline-block;
}

body.dark .sidebar__icon .icon {
    fill: #ffffff;
}

body.dark .sidebar__item:hover {
    color: #ffffff;
}

body.dark .sidebar__group:before {
    background: rgba(228, 228, 228, 0.1);
}

body.dark .sidebar__details {
    background: rgba(228, 228, 228, 0.04);
}

body.dark .sidebar__details:before {
    background: rgba(228, 228, 228, 0.1);
}

body.dark .sidebar__link:hover {
    background: rgba(228, 228, 228, 0.04);
    color: #ffffff;
}

body.dark .sidebar__link:hover .icon {
    fill: #ffffff;
    opacity: 1;
}

body.dark .sidebar__man {
    color: #ffffff;
}

body.dark .sidebar__arrow .icon {
    fill: #ffffff;
}

body.dark .sidebar__bottom {
    -webkit-box-shadow: inset 0px 1px 0px rgba(228, 228, 228, 0.1);
    box-shadow: inset 0px 1px 0px rgba(228, 228, 228, 0.1);
}

body.dark .sidebar__burger:before,
body.dark .sidebar__burger:after {
    background: #ffffff;
}

body.dark .sidebar__close .icon {
    fill: #ffffff;
}

body.dark .sidebar__btn.btn_white {
    background: var(--main-color);
    color: #ffffff;
}

body.dark .sidebar__btn.btn_white:hover {
    background: #1b1d21;
}

body.dark .sidebar.active .sidebar__burger {
    border-color: rgba(228, 228, 228, 0.1);
}

.switch {
    display: inline-block;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-size: 0;
    -webkit-transition: opacity 0.25s;
    -o-transition: opacity 0.25s;
    transition: opacity 0.25s;
}

.switch__input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
}

.switch__in {
    display: inline-block;
}

.switch__box {
    position: relative;
    display: block;
    width: 64px;
    height: 24px;
    background: rgba(228, 228, 228, 0.5);
    border-radius: 16px;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.switch__box:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 2px;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 4px solid #ffffff;
    -webkit-box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
    background: #f4c257;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.switch__icon {
    position: absolute;
    top: 50%;
    left: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 0;
}

.switch__icon .icon {
    font-size: 24px;
    fill: #f4c257;
}

.switch__icon .icon-moon {
    display: none;
}

.switch__input:checked+.switch__flex .switch__box:before {
    -webkit-transform: translate(24px, -50%);
    -ms-transform: translate(24px, -50%);
    transform: translate(24px, -50%);
}

.switch_theme .switch__in {
    padding-left: 56px;
}

body.dark .switch_theme .switch__input+.switch__in .switch__box {
    background: #12141b;
}

body.dark .switch_theme .switch__input+.switch__in .switch__box:before {
    width: 4px;
    height: 16px;
    border-width: 2px;
    border-radius: 2px;
    -webkit-transform: translate(48px, -50%);
    -ms-transform: translate(48px, -50%);
    transform: translate(48px, -50%);
    border-color: #f4c257;
}

body.dark .switch_theme .switch__input+.switch__in .icon-moon {
    display: inline-block;
}

body.dark .switch_theme .switch__input+.switch__in .icon-sun {
    display: none;
}

.slider {
    margin-bottom: 56px;
}

.slider__container {
    position: relative;
    background: var(--main-color);
    border-radius: 24px;
}

.slider__container:before,
.slider__container:after {
    content: '';
    position: absolute;
    background: #cfc8ff;
    border-radius: 24px;
}

.slider__container:before {
    top: 8px;
    left: 8px;
    right: 8px;
    bottom: -8px;
    z-index: -1;
}

.slider__container:after {
    top: 16px;
    left: 20px;
    right: 20px;
    bottom: -16px;
    z-index: -2;
}

.slider__item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 42px 0 56px 32px;
    color: #ffffff;
}

.slider__details {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 185px;
    padding-top: 13px;
}

.slider__preview {
    margin: 0 auto;
    font-size: 0;
}

.slider__pic {
    max-width: 214px;
    max-height: 214px;
}

.slider__title {
    margin-bottom: 14px;
}

.slider__text {
    margin-bottom: 14px;
}

.slider__close {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #ffffff;
    font-size: 0;
}

.slider__close .icon {
    font-size: 12px;
    -webkit-transition: -webkit-transform 0.25s;
    transition: -webkit-transform 0.25s;
    -o-transition: transform 0.25s;
    transition: transform 0.25s;
    transition: transform 0.25s, -webkit-transform 0.25s;
}

.slider__close:hover .icon {
    -webkit-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
}

.slider .owl-dots {
    position: absolute;
    left: 217px;
    right: 0;
    bottom: 30px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.slider .owl-carousel button.owl-dot {
    position: relative;
    width: 12px;
    height: 12px;
}

.slider .owl-carousel button.owl-dot:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 4px;
    height: 4px;
    background: #ffffff;
    border-radius: 50%;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.slider .owl-carousel button.owl-dot:hover:before,
.slider .owl-carousel button.owl-dot.active:before {
    -webkit-box-shadow: 0 0 0 2px #a0d7e7;
    box-shadow: 0 0 0 2px #a0d7e7;
}

.slider .owl-carousel button.owl-dot:not(:last-child) {
    margin-right: 10px;
}

body.dark .slider__close {
    background: #242731;
    -webkit-box-shadow: 0 10px 10px rgba(0, 0, 0, 0.3);
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.3);
}

body.dark .slider__close .icon {
    fill: #ffffff;
}

.btn {
    min-width: 166px;
    height: 56px;
    padding: 0 20px;
    border-radius: 16px/16px;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    line-height: 1.42857;
    font-weight: 700;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.btn .icon,
.btn__text {
    display: inline-block;
    vertical-align: middle;
}

.btn .icon {
    position: relative;
    top: -2px;
    font-size: 20px;
}

.btn .icon:not(:last-child) {
    margin-right: 10px;
}

.btn_white {
    background: #ffffff;
    color: #1b1d21;
}

.btn_white:hover {
    color: var(--main-color);
}

.btn_purple {
    background: var(--main-color);
    color: #ffffff;
}

.btn_purple:hover {
    background: #5a49ce;
}

.btn_blue {
    background: #f4c257;
    color: #ffffff;
}

.btn_blue:hover {
    background: #1b77ff;
}

.btn_blue-dark {
    background: #0049c6;
    color: #ffffff;
}

.btn_blue-dark:hover {
    background: #0056ea;
}

.btn_primary {
    background: #1b1d21;
    color: #ffffff;
}

.btn_primary .icon {
    fill: #ffffff;
}

.btn_primary:hover {
    background: var(--main-color);
}

.btn_gray {
    background: #e4e4e4;
    color: #11142d;
}

.btn_gray:hover {
    background: rgba(228, 228, 228, 0.5);
}

.btn_wide {
    min-width: 100%;
}

.btn[href] {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

body.dark .btn_white {
    background: #242731;
    color: #ffffff;
}

body.dark .btn_white:hover {
    background: #1b1d21;
}

body.dark .btn_gray {
    background: rgba(228, 228, 228, 0.1);
    color: #ffffff;
}

body.dark .btn_gray:hover {
    opacity: 0.8;
}

.widget {
    padding: 32px;
    border-radius: 24px;
    background: #ffffff;
}

.widget__head {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 88px;
    padding: 0 32px;
}

.widget>.widget__title {
    margin-bottom: 32px;
}

.widget__title {
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    line-height: 1.33333;
}

.widget__top {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 32px;
}

.widget__next {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 24px;
    height: 24px;
    font-size: 0;
}

.widget__next .icon {
    font-size: 10px;
    fill: #11142d;
    -webkit-transition: fill 0.25s;
    -o-transition: fill 0.25s;
    transition: fill 0.25s;
}

.widget__next:hover .icon {
    fill: var(--main-color);
}

.widget__item {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.widget__item:before {
    content: '';
    position: absolute;
    top: -12px;
    left: -12px;
    right: -12px;
    bottom: -12px;
    border-radius: 16px;
    background: var(--main-color);
    opacity: 0;
    -webkit-transition: opacity 0.25s;
    -o-transition: opacity 0.25s;
    transition: opacity 0.25s;
}

.widget__item:hover:before {
    opacity: 1;
}

.widget__item:not(:last-child) {
    margin-bottom: 40px;
}

.widget__preview {
    position: relative;
    z-index: 2;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 56px;
    height: 56px;
    border-radius: 16px;
    overflow: hidden;
    font-size: 0;
}

.widget__pic {
    max-width: 100%;
    max-height: 100%;
}

.widget__details {
    position: relative;
    z-index: 2;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    padding-left: 24px;
}

.widget__item .widget__category {
    position: relative;
    margin-bottom: 3px;
    padding-right: 30px;
    color: #11142d;
    -webkit-transition: color 0.25s;
    -o-transition: color 0.25s;
    transition: color 0.25s;
}

.widget__item .widget__category .icon {
    position: absolute;
    top: 50%;
    right: 9px;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 10px;
    fill: #11142d;
    -webkit-transition: fill 0.25s;
    -o-transition: fill 0.25s;
    transition: fill 0.25s;
}

.widget__info {
    color: #808191;
    -webkit-transition: color 0.25s;
    -o-transition: color 0.25s;
    transition: color 0.25s;
}

.widget__item:hover .widget__category,
.widget__item:hover .widget__info {
    color: #ffffff;
}

.widget__item:hover .widget__category .icon,
.widget__item:hover .widget__info .icon {
    fill: #ffffff;
}

.widget__wrap {
    padding: 24px;
    border-radius: 16px;
    background: #ffffff;
}

.widget__chart_earning {
    height: 205px;
    margin-top: -20px;
    margin-left: -20px;
    margin-bottom: 15px;
}

.widget__chart_impressions {
    height: 320px;
    margin-left: -20px;
}

.widget__chart_users {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 120px;
    height: 80px;
    margin-top: -5px;
}

.widget__chart_earning-month {
    max-width: 120px;
    height: 120px;
    margin: 0 auto;
}

.widget__chart_items {
    height: 240px;
}

.widget__col:first-child {
    margin-bottom: 32px;
}

.widget__counter {
    margin-bottom: 12px;
}

.widget__foot {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 40px;
}

.widget__foot .widget__link {
    color: var(--main-color);
    -webkit-transition: color 0.25s;
    -o-transition: color 0.25s;
    transition: color 0.25s;
}

.widget__foot .widget__link:hover {
    color: var(--main-color);
}

.widget__flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.widget__legend {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.widget__color {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    color: #808191;
}

.widget__color:not(:last-child) {
    margin-right: 24px;
}

.widget__bg {
    width: 20px;
    height: 20px;
    border-radius: 8px;
    margin-right: 8px;
}

.widget__text_mb32 {
    margin-bottom: 32px;
}

.widget__text_mb40 {
    margin-bottom: 40px;
}

.widget_shadow {
    position: relative;
}

.widget_shadow:before {
    content: '';
    position: absolute;
    top: 22px;
    left: 18px;
    right: 18px;
    bottom: -40px;
    z-index: -2;
    background: #e3e6ec;
    opacity: 0.91;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

.widget_chart {
    padding: 32px 8px 8px;
}

.widget_chart .widget__title {
    padding: 0 24px;
}

.widget_pink {
    background: #ffebf6;
}

.widget_purple {
    background: var(--main-color);
}

.widget_stat {
    position: relative;
    text-align: center;
}

.widget_stat:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background: #e3e6ec;
    opacity: 0.91;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

.widget_stat .widget__title {
    margin-bottom: 12px;
}

.widget_stat>.widget__text {
    max-width: 185px;
    margin: 0 auto 18px;
    color: #808191;
}

.widget_stat .widget__btn.btn_white {
    -webkit-box-shadow: 0 10px 20px rgba(227, 230, 236, 0.6);
    box-shadow: 0 10px 20px rgba(227, 230, 236, 0.6);
    color: var(--main-color);
}

.widget_stat .widget__btn.btn_white:hover {
    color: #1b1d21;
}

.widget_empty {
    background: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    border-radius: 0;
}

.widget_stat.widget_empty:before {
    display: none;
}

.widget_p0 {
    padding: 0;
}

.widget_pt0 {
    padding-top: 0;
}

.widget_pb60 {
    padding-bottom: 58px;
}

.widget_users .widget__flex {
    padding: 26px 32px 40px;
    -webkit-box-shadow: inset 0px -1px 0px #e4e4e4;
    box-shadow: inset 0px -1px 0px #e4e4e4;
}

.widget_users .widget__flex:first-child {
    padding-top: 0;
}

.widget_users .widget__desc {
    margin-right: auto;
}

.widget_users .widget__category {
    line-height: 1.3;
    color: #808191;
}

.widget_users .widget__percent {
    font-weight: 600;
    line-height: 1.3;
    color: #7fba7a;
}

.widget_after:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: -1;
    bottom: -8px;
    border-radius: 24px;
    background: rgba(255, 255, 255, 0.5);
}

body.dark .widget {
    background: #242731;
}

body.dark .widget__item .widget__category {
    color: #ffffff;
}

body.dark .widget__item .widget__category .icon {
    fill: #ffffff;
}

body.dark .widget__wrap {
    background: #242731;
}

body.dark .widget__next .icon {
    fill: #ffffff;
}

body.dark .widget_shadow:before {
    background: #000;
    opacity: 0.51;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

body.dark .widget_pink {
    background: #f4c257;
}

body.dark .widget_stat:before {
    background: #000;
    opacity: 0.51;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

body.dark .widget_stat .widget__btn.btn_white {
    -webkit-box-shadow: none;
    box-shadow: none;
    background: #1f2128;
}

body.dark .widget_stat .widget__btn.btn_white:hover {
    color: #ffffff;
}

body.dark .widget_empty {
    background: none;
    -webkit-box-shadow: none;
    box-shadow: none;
}

body.dark .widget_users .widget__flex {
    -webkit-box-shadow: inset 0px -1px 0px rgba(228, 228, 228, 0.1);
    box-shadow: inset 0px -1px 0px rgba(228, 228, 228, 0.1);
}

body.dark .widget_purple {
    background: var(--main-color);
}

body.dark .widget_after:after {
    background: rgba(36, 39, 49, 0.5);
}

.header {
    position: relative;
    z-index: 10;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    max-width: 298px;
    margin-left: auto;
}

.header .search {
    width: 214px;
    margin-left: -8px;
    margin-right: auto;
}

.header__user {
    display: none;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    font-size: 0;
}

.header__pic {
    width: 100%;
    min-height: 100%;
    border-radius: 50%;
}

.header__burger {
    display: none;
    width: 32px;
    height: 40px;
    margin-right: auto;
    font-size: 0;
}

.header__burger:before,
.header__burger:after {
    content: '';
    display: inline-block;
    width: 32px;
    height: 2px;
    margin: 3px auto;
    border-radius: 1px;
    background: #1b1d21;
}

.header__search {
    display: none;
    width: 40px;
    height: 40px;
    margin-right: 25px;
    border-radius: 50%;
    -webkit-box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);
    box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);
    font-size: 0;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.header__search .icon {
    font-size: 20px;
    fill: #1b1d21;
}

.header__search.active {
    background: var(--main-color);
}

.header__search.active .icon {
    fill: #ffffff;
}

body.dark .header__burger:before,
body.dark .header__burger:after {
    background: #ffffff;
}

body.dark .header__search {
    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
}

body.dark .header__search .icon {
    fill: #ffffff;
}

.search {
    position: relative;
    z-index: 3;
}

.search__field {
    position: relative;
    z-index: 2;
}

.search__input {
    width: 100%;
    height: 48px;
    padding: 0 10px 0 44px;
    border-radius: 12px;
    background: transparent;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    color: #11142d;
    -webkit-transition: background 0.25s;
    -o-transition: background 0.25s;
    transition: background 0.25s;
}

.search__input::-webkit-input-placeholder {
    color: #808191;
}

.search__input::-ms-input-placeholder {
    color: #808191;
}

.search__input::placeholder {
    color: #808191;
}

.search__toggle {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 42px;
    font-size: 0;
}

.search__toggle .icon {
    fill: #1b1d21;
    -webkit-transition: fill 0.25s;
    -o-transition: fill 0.25s;
    transition: fill 0.25s;
}

.search__toggle .icon-search {
    font-size: 20px;
}

.search__toggle .icon-close {
    display: none;
    font-size: 16px;
}

.search__toggle:hover .icon {
    fill: var(--main-color);
}

.search__result {
    position: absolute;
    top: -4px;
    left: -4px;
    right: -4px;
    padding: 70px 16px 24px;
    border-radius: 12px;
    background: #ffffff;
    -webkit-box-shadow: 0 10px 30px rgba(227, 230, 236, 0.5);
    box-shadow: 0 10px 30px rgba(227, 230, 236, 0.5);
    visibility: hidden;
    opacity: 0;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.search__info {
    color: #808191;
}

.search__item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 16px 0;
    color: #11142d;
    -webkit-transition: color 0.25s;
    -o-transition: color 0.25s;
    transition: color 0.25s;
}

.search__item:hover {
    color: var(--main-color);
}

.search__item:not(:last-child) {
    border-bottom: 1px solid #e4e4e4;
}

.search__preview {
    position: relative;
    z-index: 2;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    margin-right: 15px;
    border-radius: 12px;
    overflow: hidden;
    font-size: 0;
}

.search__pic {
    max-width: 100%;
    max-height: 100%;
}

.search__text {
    position: relative;
    padding-right: 30px;
    line-height: 1.42857;
    font-weight: 600;
}

.search__text .icon {
    position: absolute;
    top: 5px;
    right: 9px;
    font-size: 10px;
    fill: #11142d;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.search__item:hover .icon {
    -webkit-transform: translateX(4px);
    -ms-transform: translateX(4px);
    transform: translateX(4px);
    fill: var(--main-color);
}

.search__btn {
    height: 40px;
}

.search.active .search__input {
    background: rgba(228, 228, 228, 0.3);
}

.search.active .search__toggle .icon-search {
    display: none;
}

.search.active .search__toggle .icon-close {
    display: inline-block;
}

.search.active .search__result {
    visibility: visible;
    opacity: 1;
}

body.dark .search__toggle .icon {
    fill: #ffffff;
}

body.dark .search__toggle:hover .icon {
    fill: var(--main-color);
}

body.dark .search__input {
    color: #ffffff;
}

body.dark .search__result {
    background: #242731;
    -webkit-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

body.dark .search__item {
    color: #ffffff;
}

body.dark .search__text .icon {
    fill: #ffffff;
}

body.dark .search__item:not(:last-child) {
    border-color: rgba(228, 228, 228, 0.1);
}

body.dark .search.active .search__input {
    background: rgba(228, 228, 228, 0.03);
}

.notifications {
    position: relative;
}

.notifications__open {
    position: relative;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    font-size: 0;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.notifications__open .icon {
    font-size: 24px;
    fill: #1b1d21;
    -webkit-transition: fill 0.25s;
    -o-transition: fill 0.25s;
    transition: fill 0.25s;
}

.notifications__open:hover {
    -webkit-box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);
    box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);
}

.notifications__counter {
    position: absolute;
    top: 0;
    right: -12px;
    display: inline-block;
    min-width: 24px;
    line-height: 24px;
    border-radius: 50%;
    background: #ff754c;
    font-size: 12px;
    font-weight: 600;
    color: #ffffff;
}

.notifications__wrap {
    position: absolute;
    top: calc(100% + 24px);
    right: -12px;
    width: 360px;
    padding: 32px 8px 36px;
    -webkit-box-shadow: 0 10px 36px rgba(227, 230, 236, 0.6);
    box-shadow: 0 10px 36px rgba(227, 230, 236, 0.6);
    background: #ffffff;
    border-radius: 24px;
    visibility: hidden;
    opacity: 0;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.notifications__info {
    margin-bottom: 32px;
    padding: 0 24px;
}

.notifications__list {
    margin-bottom: 32px;
}

.notifications__item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 16px 28px 16px 20px;
    border-radius: 12px;
    background: transparent;
    cursor: pointer;
    -webkit-transition: background 0.25s;
    -o-transition: background 0.25s;
    transition: background 0.25s;
}

.notifications__item:hover {
    background: var(--main-color);
}

.notifications__ava {
    position: relative;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    margin-right: 24px;
    font-size: 0;
}

.notifications__ava>.notifications__pic {
    width: 100%;
    min-height: 100%;
    border-radius: 50%;
}

.notifications__status {
    position: absolute;
    top: 0;
    right: -1px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 21px;
    height: 21px;
    border: 2px solid #ffffff;
    border-radius: 50%;
    font-size: 0;
}

.notifications__status .notifications__pic {
    max-width: 10px;
}

.notifications__details {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
}

.notifications__line {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 6px;
}

.notifications__user {
    margin-right: auto;
    color: #11142d;
    -webkit-transition: color 0.25s;
    -o-transition: color 0.25s;
    transition: color 0.25s;
}

.notifications__time,
.notifications__text {
    color: #b2b3bd;
    -webkit-transition: color 0.25s;
    -o-transition: color 0.25s;
    transition: color 0.25s;
}

.notifications__time {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    margin-left: 20px;
}

.notifications__project {
    padding-left: 5px;
    color: var(--main-color);
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.notifications__item:hover .notifications__user,
.notifications__item:hover .notifications__time,
.notifications__item:hover .notifications__text,
.notifications__item:hover .notifications__project {
    color: #ffffff;
}

.notifications__btns {
    text-align: center;
}

.notifications__btn {
    min-width: 230px;
}

.notifications.active .notifications__open {
    background: var(--main-color);
    -webkit-box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);
    box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);
}

.notifications.active .notifications__open .icon {
    fill: #ffffff;
}

.notifications.active .notifications__wrap {
    visibility: visible;
    opacity: 1;
}

body.dark .notifications__open {
    background: #242731;
}

body.dark .notifications__open .icon {
    fill: #ffffff;
}

body.dark .notifications__open:hover {
    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
}

body.dark .notifications__wrap {
    background: #242731;
    -webkit-box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

body.dark .notifications__user {
    color: #ffffff;
}

body.dark .notifications.active .notifications__open {
    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.7);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.7);
}

.banner__container {
    position: relative;
    padding: 64px 64px 76px;
    border-radius: 24px;
    background: var(--main-color);
    overflow: hidden;
}

.banner__wrap {
    max-width: 400px;
    color: #ffffff;
}

.banner__text {
    margin-bottom: 16px;
}

.banner__btn {
    min-width: 209px;
}

.banner__preview {
    position: absolute;
    top: 40px;
    right: 90px;
    width: 543px;
    font-size: 0;
}

.banner__preview .banner__pic {
    width: 100%;
}

.banner:not(:last-child) {
    margin-bottom: 32px;
}

.sorting__row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 0 -8px;
}

.sorting__col {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 calc(50% - 16px);
    flex: 0 0 calc(50% - 16px);
    width: calc(50% - 16px);
    margin: 0 8px;
}

.sorting__dropdowns {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 0 -8px;
}

.sorting__dropdowns .dropdown {
    margin: 0 8px;
}

.sorting__line {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.sorting__search {
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
}

.sorting__line .sorting__search {
    margin-right: 45px;
}

.sorting__input {
    width: 100%;
    height: 43px;
    padding: 0 20px 0 55px;
    border: none;
    border-radius: 16px;
    background: rgba(228, 228, 228, 0.2);
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #1b1d21;
}

.sorting__input::-webkit-input-placeholder {
    color: #808191;
}

.sorting__input::-ms-input-placeholder {
    color: #808191;
}

.sorting__input::placeholder {
    color: #808191;
}

.sorting__open {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 55px;
    font-size: 0;
}

.sorting__open .icon {
    font-size: 20px;
    fill: #11142d;
    -webkit-transition: fill 0.25s;
    -o-transition: fill 0.25s;
    transition: fill 0.25s;
}

.sorting__open:hover .icon {
    fill: var(--main-color);
}

.sorting__actions {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.sorting__action {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #ffffff;
    font-size: 0;
    -webkit-transition: -webkit-box-shadow 0.25s;
    transition: -webkit-box-shadow 0.25s;
    -o-transition: box-shadow 0.25s;
    transition: box-shadow 0.25s;
    transition: box-shadow 0.25s, -webkit-box-shadow 0.25s;
}

.sorting__action .icon {
    font-size: 17px;
    fill: #11142d;
}

.sorting__action .icon-edit {
    font-size: 19px;
}

.sorting__action .icon-box {
    font-size: 15px;
}

.sorting__action:hover {
    -webkit-box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);
    box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);
}

.sorting__action:not(:last-child) {
    margin-right: 0;
}

.sorting:not(:last-child) {
    margin-bottom: 15px;
}

body.dark .sorting__input {
    background: rgba(228, 228, 228, 0.04);
    color: #ffffff;
}

body.dark .sorting__open .icon {
    fill: #ffffff;
}

body.dark .sorting__action {
    background: #242731;
}

body.dark .sorting__action .icon {
    fill: #ffffff;
}

body.dark .sorting__action:hover {
    -webkit-box-shadow: 0 12px 20px rgba(0, 0, 0, 0.25);
    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.25);
}

.dropdown {
    position: relative;
}

.dropdown__head {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 43px;
    padding: 0 46px 0 21px;
    border: 2px solid transparent;
    background: rgba(228, 228, 228, 0.3);
    border-radius: 16px;
    font-weight: 600;
    color: #808191;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.dropdown__head:before {
    content: '';
    position: absolute;
    top: 50%;
    right: 20px;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 14px;
    height: 8px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50% 50%/100% auto;
    -webkit-transition: -webkit-transform 0.25s;
    transition: -webkit-transform 0.25s;
    -o-transition: transform 0.25s;
    transition: transform 0.25s;
    transition: transform 0.25s, -webkit-transform 0.25s;
}

.dropdown__body {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    z-index: 20;
    width: 310px;
    padding: 32px;
    border: 1px solid #e4e4e4;
    background: #ffffff;
    border-radius: 24px;
    visibility: hidden;
    opacity: 0;
    -webkit-box-shadow: 0 20px 16px rgba(227, 230, 236, 0.6);
    box-shadow: 0 20px 16px rgba(227, 230, 236, 0.6);
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.dropdown__item {
    display: block;
}

.dropdown__item:not(:last-child) {
    margin-bottom: 24px;
}

.dropdown__title {
    position: relative;
    margin-bottom: 3px;
    padding-right: 30px;
    color: #11142d;
    -webkit-transition: color 0.25s;
    -o-transition: color 0.25s;
    transition: color 0.25s;
}

.dropdown__title:before {
    content: '';
    position: absolute;
    top: 5px;
    right: 8px;
    width: 6px;
    height: 10px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat 50% 50%/100% auto;
    -webkit-transition: -webkit-transform 0.25s;
    transition: -webkit-transform 0.25s;
    -o-transition: transform 0.25s;
    transition: transform 0.25s;
    transition: transform 0.25s, -webkit-transform 0.25s;
}

.dropdown__info {
    color: #808191;
    -webkit-transition: color 0.25s;
    -o-transition: color 0.25s;
    transition: color 0.25s;
}

.dropdown__item:hover .dropdown__title:before {
    -webkit-transform: translateX(5px);
    -ms-transform: translateX(5px);
    transform: translateX(5px);
}

.dropdown__item:hover .dropdown__title,
.dropdown__item:hover .dropdown__info {
    color: var(--main-color);
}

.dropdown.active .dropdown__head {
    border-color: var(--main-color);
    background: #ffffff;
    color: #11142d;
}

.dropdown.active .dropdown__head:before {
    -webkit-transform: translateY(-50%) rotate(180deg);
    -ms-transform: translateY(-50%) rotate(180deg);
    transform: translateY(-50%) rotate(180deg);
}

.dropdown.active .dropdown__body {
    visibility: visible;
    opacity: 1;
}

body.dark .dropdown__head {
    background: rgba(228, 228, 228, 0.04);
}

body.dark .dropdown__head:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

body.dark .dropdown__body {
    border-color: rgba(228, 228, 228, 0.1);
    background: #242731;
    -webkit-box-shadow: 0 20px 16px rgba(0, 0, 0, 0.5);
    box-shadow: 0 20px 16px rgba(0, 0, 0, 0.5);
}

body.dark .dropdown__title {
    color: #ffffff;
}

body.dark .dropdown__title:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

body.dark .dropdown.active .dropdown__head {
    background: rgba(228, 228, 228, 0.04);
    color: #ffffff;
}

.products>.products__title {
    margin-bottom: 16px;
}

.products>.products__info {
    margin-bottom: 20px;
    color: #808191;
}

.products__table {
    display: table;
    width: 100%;
}

.products__row {
    display: table-row;
    height: 48px;
    min-height: 48px;
}

.products__row_head .products__cell {
    padding-top: 24px;
    padding-bottom: 24px;
    font-size: 13px;
    line-height: 1.38462;
    font-weight: 500;
    color: #b2b3bd;
}

.products__cell {
    display: table-cell;
    vertical-align: middle;
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e4e4e4;
}

.products__cell:first-child {
    width: 20px;
    padding: 0;
    font-size: 0;
}

.products__item {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    color: #11142d;
}

.products__preview {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 96px;
    height: 72px;
    border-radius: 8px;
    font-size: 0;
}

.products__preview:before {
    content: '';
    position: absolute;
    top: 100%;
    left: 7px;
    right: 7px;
    height: 8px;
    border-radius: 0 0 8px 8px;
    background: #e7faff;
}

.products__pic {
    max-height: 100%;
}

.products__details {
    padding-left: 24px;
}

.products__cell .products__title {
    margin-bottom: 9px;
}

.products__color {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.products__bg {
    width: 20px;
    height: 20px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    border-radius: 4px;
}

.products__rating {
    color: #808191;
}

.products__color .products__text {
    margin-left: 8px;
}

.products__more {
    padding-top: 40px;
    text-align: center;
}

.products__cost {
    position: relative;
    cursor: pointer;
}

.products__cost .products__tooltip {
    position: absolute;
    top: 10%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    min-width: 160px;
    padding: 32px 26px;
    background: #ffffff;
    border-radius: 24px;
    -webkit-box-shadow: 0 20px 30px rgba(227, 230, 236, 0.9);
    box-shadow: 0 20px 30px rgba(227, 230, 236, 0.9);
    visibility: hidden;
    opacity: 0;
    -webkit-transition: all 0.2s;
    -o-transition: all 0.2s;
    transition: all 0.2s;
}

.products__cost:hover .products__tooltip {
    visibility: visible;
    opacity: 1;
}

.products__sale {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 8px;
    color: #808191;
}

.products__sale .products__icon {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    margin-right: 8px;
    border-radius: 6px;
}

.products__sale .products__pic {
    max-width: 8px;
}

.products__progress {
    position: relative;
    width: 100%;
    height: 2px;
    border-radius: 1px;
    background: #e4e4e4;
}

.products__progress span {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    border-radius: 1px;
    background: var(--main-color);
}

.products__price:not(:last-child) {
    margin-bottom: 10px;
}

.products__transaction {
    color: #808191;
}

.products__status {
    display: inline-block;
    padding: 3px 16px;
    border-radius: 4px;
    color: #ffffff;
}

.products__body {
    display: none;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 0 24px 24px;
    padding: 4px;
    border: 1px solid #e4e4e4;
    border-radius: 8px;
}

.products__line {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
}

.products_main .products__money {
    color: var(--main-color);
}

.products_main .products__col:first-child {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 30%;
    flex: 0 0 30%;
    padding-right: 8px;
}

.products_main .products__col:nth-child(2) {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 44%;
    flex: 0 0 44%;
    padding-right: 8px;
}

.products_main .products__col:nth-child(3) {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 26%;
    flex: 0 0 26%;
}

.products_history .products__col:first-child {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 42%;
    flex: 0 0 42%;
    padding-right: 8px;
}

.products_history .products__col:nth-child(2) {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 32%;
    flex: 0 0 32%;
    padding-right: 8px;
}

.products_history .products__col:nth-child(3) {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 26%;
    flex: 0 0 26%;
}

.products_statement .products__col:first-child {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 42%;
    flex: 0 0 42%;
    padding-right: 8px;
}

.products_statement .products__col:nth-child(2) {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 32%;
    flex: 0 0 32%;
    padding-right: 8px;
}

.products_statement .products__col:nth-child(3) {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 26%;
    flex: 0 0 26%;
}

body.dark .products__cell {
    border-color: rgba(228, 228, 228, 0.1);
}

body.dark .products__item {
    color: #ffffff;
}

body.dark .products__body {
    border-color: rgba(228, 228, 228, 0.1);
}

.checkbox {
    display: inline-block;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.checkbox__input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
}

.checkbox__in {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.checkbox__tick {
    position: relative;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 20px;
    flex: 0 0 20px;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 2px solid #e4e4e4;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.checkbox__tick:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 10px;
    height: 9px;
    opacity: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat 50% 50%/100% auto;
    -webkit-transition: opacity 0.25s;
    -o-transition: opacity 0.25s;
    transition: opacity 0.25s;
}

.checkbox__text {
    margin-left: 8px;
    padding-top: 2px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.3;
    color: #808191;
}

.checkbox:hover .checkbox__tick {
    border-color: var(--main-color);
}

.checkbox__input:checked+.checkbox__in .checkbox__tick {
    background: var(--main-color);
    border-color: var(--main-color);
}

.checkbox__input:checked+.checkbox__in .checkbox__tick:before {
    opacity: 1;
}

.checkbox__input:checked+.checkbox__in .checkbox__text {
    color: #11142d;
}

body.dark .checkbox__tick {
    border-color: rgba(228, 228, 228, 0.1);
}

body.dark .checkbox__input:checked+.checkbox__in .checkbox__text {
    color: #ffffff;
}

.radio {
    display: inline-block;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.radio__input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
}

.radio__in {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.radio__tick {
    position: relative;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 20px;
    flex: 0 0 20px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #e4e4e4;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.radio__tick:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #ffffff;
    -webkit-box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
    opacity: 0;
    -webkit-transition: opacity 0.25s;
    -o-transition: opacity 0.25s;
    transition: opacity 0.25s;
}

.radio__text {
    margin-left: 8px;
    padding-top: 3px;
    font-size: 13px;
    line-height: 1.2;
    color: #808191;
    -webkit-transition: color 0.25s;
    -o-transition: color 0.25s;
    transition: color 0.25s;
}

.radio:hover .radio__tick {
    background: var(--main-color);
}

.radio__input:checked+.radio__in .radio__tick {
    background: var(--main-color);
}

.radio__input:checked+.radio__in .radio__tick:before {
    opacity: 1;
}

.radio__input:checked+.radio__in .radio__text {
    color: #11142d;
}

body.dark .radio__tick {
    background: rgba(228, 228, 228, 0.1);
}

body.dark .radio__input:checked+.radio__in .radio__text {
    color: #ffffff;
}

.details__container {
    position: relative;
    padding: 32px 32px 38px;
    background: #ffffff;
    border-radius: 24px;
}

.details__container:before {
    content: '';
    position: absolute;
    top: 28px;
    left: 18px;
    right: 18px;
    bottom: -28px;
    z-index: -1;
    background: #e3e6ec;
    opacity: 0.91;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

.details__title {
    margin-bottom: 40px;
}

.details__row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 30px;
}

.details__col:first-child {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 145px;
    padding-right: 16px;
}

.details__col:nth-child(2) {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
}

.details__top {
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e4e4e4;
}

.details__number {
    margin-bottom: 16px;
}

.details__line {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    color: var(--main-color);
    -webkit-transition: color 0.25s;
    -o-transition: color 0.25s;
    transition: color 0.25s;
}

.details__line:hover {
    color: var(--main-color);
}

.details__preview {
    font-size: 0;
}

.details__line .details__preview {
    width: 32px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    margin-right: 16px;
}

.details__statistics {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 20px;
}

.details__status {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.details__status .details__icon {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    margin-right: 4px;
    border-radius: 50%;
    font-size: 0;
}

.details__status .details__icon .icon {
    font-size: 6px;
    fill: #ffffff;
}

.details__box {
    position: relative;
    padding: 5px 5px 13px;
    border-radius: 16px;
    background: #f4c257;
}

.details__chart_activity {
    height: 25px;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    padding-right: 13px;
}

.details__chart_counter {
    height: 200px;
}

.details__chart_counter .apexcharts-tooltip.apexcharts-theme-light {
    background: #1b1d21;
    border: none;
    color: #ffffff;
}

.details__chart_report {
    height: 215px;
}

.details__info {
    color: #b2b3bd;
}

.details__list {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    border-radius: 16px;
    border: 1px solid #e4e4e4;
}

.details__item {
    padding: 24px;
}

.details__item:not(:last-child) {
    border-right: 1px solid #e4e4e4;
}

.details__list_three .details__item {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 33.333%;
    flex: 0 0 33.333%;
    width: 33.333%;
}

.details__list_four .details__item {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    width: 25%;
}

.details__head {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 8px;
}

.details__head .details__preview {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    margin-right: 8px;
    border-radius: 6px;
    font-size: 0;
}

.details__head .details__pic {
    max-width: 8px;
}

.details__indicator {
    position: relative;
    height: 2px;
    border-radius: 1px;
    background: #e4e4e4;
}

.details__progress {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
}

.details__remove {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #ffffff;
    font-size: 0;
}

.details__remove .icon {
    font-size: 10px;
    -webkit-transition: -webkit-transform 0.25s;
    transition: -webkit-transform 0.25s;
    -o-transition: transform 0.25s;
    transition: transform 0.25s;
    transition: transform 0.25s, -webkit-transform 0.25s;
}

.details__remove:hover .icon {
    -webkit-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
}

.details .dropdown {
    position: absolute;
    top: 16px;
    right: 20px;
    width: 200px;
}

.details:not(:last-child) {
    margin-bottom: 28px;
}

.details_statements:not(:last-child) {
    margin-bottom: 68px;
}

.details_statements .details__col:first-child {
    width: 170px;
    padding-right: 25px;
}

.details_statements .details__counter {
    margin-bottom: 10px;
}

.details_statements .details__line .details__info {
    color: var(--main-color);
}

body.dark .details__container {
    background: #242731;
}

body.dark .details__container:before {
    background: #000;
    opacity: 0.51;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

body.dark .details__remove {
    background: #242731;
}

body.dark .details__remove .icon {
    fill: #ffffff;
}

body.dark .details__list {
    border-color: rgba(228, 228, 228, 0.1);
}

body.dark .details__top {
    border-color: rgba(228, 228, 228, 0.1);
}

body.dark .details__item {
    border-color: rgba(228, 228, 228, 0.1);
}

body.dark .details__indicator {
    background: rgba(228, 228, 228, 0.1);
}

.quality__item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.quality__item_chart {
    position: relative;
    padding-right: 60px;
}

.quality__item[href] {
    color: #11142d;
}

.quality__item:not(:last-child) {
    margin-bottom: 48px;
}

.quality__preview {
    position: relative;
    z-index: 2;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    margin-right: 14px;
    border-radius: 12px;
    font-size: 0;
}

.quality__preview .quality__pic {
    max-height: 100%;
}

.quality__chart {
    position: absolute;
    top: 73%;
    right: -32px;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 110px;
    height: 110px;
}

.quality__details {
    position: relative;
    z-index: 2;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
}

.quality__percent {
    position: absolute;
    top: 39%;
    left: 51%;
    pointer-events: none;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.quality__info {
    margin-top: 5px;
    color: #808191;
}

.quality__btn {
    margin-top: 40px;
}

.quality__btn_mt30 {
    margin-top: 30px;
}

.quality__line {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.quality__line .quality__price {
    margin-left: auto;
    padding-left: 10px;
    color: #7fba7a;
}

.quality__category {
    position: relative;
    padding-right: 20px;
}

.quality__category .icon {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 10px;
    -webkit-transition: -webkit-transform 0.25s;
    transition: -webkit-transform 0.25s;
    -o-transition: transform 0.25s;
    transition: transform 0.25s;
    transition: transform 0.25s, -webkit-transform 0.25s;
}

.quality__money {
    display: inline-block;
    margin-top: 8px;
    padding: 3px 10px;
    background: var(--main-color);
    border-radius: 8px;
    color: #ffffff;
}

.quality_big .quality__list {
    margin: -8px -16px;
}

.quality_big .quality__item {
    position: relative;
    padding: 8px 16px;
    background: transparent;
    border-radius: 12px;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.quality_big .quality__item:before {
    content: '';
    position: absolute;
    top: 100%;
    left: 10px;
    right: 10px;
    height: 0;
    border-radius: 0 0 8px 8px;
    background: #cfc8ff;
    -webkit-transition: height 0.25s;
    -o-transition: height 0.25s;
    transition: height 0.25s;
}

.quality_big .quality__item:hover {
    background: var(--main-color);
    color: #ffffff;
}

.quality_big .quality__item:hover:before {
    height: 6px;
}

.quality_big .quality__item:not(:last-child) {
    margin-bottom: 24px;
}

.quality_big .quality__item:hover .quality__category {
    color: #ffffff;
}

.quality_big .quality__item:hover .quality__category .icon {
    fill: #ffffff;
}

.quality_big .quality__item:hover .quality__info {
    color: #ffffff;
}

.quality_big .quality__preview {
    position: relative;
    width: 88px;
    height: 80px;
    margin-right: 24px;
}

.quality_big .quality__preview:before {
    content: '';
    position: absolute;
}

body.dark .quality__item {
    color: #ffffff;
}

body.dark .quality__category .icon {
    fill: #ffffff;
}

.goal__container {
    min-height: 220px;
    margin: 0 -16px 26px;
}

.goal__preview {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 220px;
    font-size: 0;
}

.goal__pic {
    position: relative;
    z-index: 2;
    max-height: 100%;
}

.goal__bg {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 50%;
    border-radius: 16px;
}

.goal__item:not(:last-child) {
    margin-bottom: 32px;
}

.goal__head {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 13px;
}

.goal__percent {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    margin-left: auto;
    padding-left: 15px;
}

.goal__indicator {
    position: relative;
    height: 8px;
    background: #e4e4e4;
    border-radius: 4px;
}

.goal__progress {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    border-radius: 4px;
}

.goal .owl-carousel .owl-item img {
    width: auto;
}

.goal .owl-nav {
    position: absolute;
    top: 0;
    left: 16px;
    z-index: 2;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.goal .owl-carousel .owl-nav button.owl-prev,
.goal .owl-carousel .owl-nav button.owl-next {
    width: 24px;
    height: 24px;
    background: #ffffff;
    border-radius: 50%;
    -webkit-box-shadow: 0 5px 10px #e3e6ec;
    box-shadow: 0 5px 10px #e3e6ec;
    font-size: 0;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.goal .owl-carousel .owl-nav button.owl-prev .icon,
.goal .owl-carousel .owl-nav button.owl-next .icon {
    font-size: 10px;
    fill: #11142d;
    -webkit-transition: fill 0.25s;
    -o-transition: fill 0.25s;
    transition: fill 0.25s;
}

.goal .owl-carousel .owl-nav button.owl-prev:hover,
.goal .owl-carousel .owl-nav button.owl-next:hover {
    background: var(--main-color);
}

.goal .owl-carousel .owl-nav button.owl-prev:hover .icon,
.goal .owl-carousel .owl-nav button.owl-next:hover .icon {
    fill: #ffffff;
}

.goal .owl-carousel .owl-nav button.owl-prev {
    margin-right: 8px;
}

body.dark .goal__indicator {
    background: rgba(228, 228, 228, 0.1);
}

body.dark .goal .owl-carousel .owl-nav button.owl-prev,
body.dark .goal .owl-carousel .owl-nav button.owl-next {
    background: #242731;
    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
}

body.dark .goal .owl-carousel .owl-nav button.owl-prev .icon,
body.dark .goal .owl-carousel .owl-nav button.owl-next .icon {
    fill: #ffffff;
}

body.dark .goal .owl-carousel .owl-nav button.owl-prev:hover,
body.dark .goal .owl-carousel .owl-nav button.owl-next:hover {
    background: var(--main-color);
}

.schedules__container {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 32px 32px 32px 16px;
    border-radius: 24px;
    background: #ffffff;
}

.schedules__container:before {
    content: '';
    position: absolute;
    top: 35px;
    left: 35px;
    right: 35px;
    bottom: -35px;
    z-index: -5;
    background: #e3e6ec;
    opacity: 0.91;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

.schedules__col:first-child {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 310px;
}

.schedules__col:first-child .schedules__title {
    display: none;
}

.schedules__col:nth-child(2) {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    padding-left: 16px;
}

.schedules__list {
    margin-top: -8px;
}

.schedules__item {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 8px 16px;
    border-radius: 12px;
    background: transparent;
    color: #11142d;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.schedules__item:before {
    content: '';
    position: absolute;
    top: 100%;
    left: 10px;
    right: 10px;
    height: 6px;
    border-radius: 0 0 6px 6px;
    background: #cfc8ff;
    opacity: 0;
    -webkit-transition: opacity 0.25s;
    -o-transition: opacity 0.25s;
    transition: opacity 0.25s;
}

.schedules__item:hover {
    color: var(--main-color);
}

.schedules__item:hover .icon {
    fill: var(--main-color);
}

.schedules__item.active {
    background: var(--main-color);
    color: #ffffff;
}

.schedules__item.active:before {
    opacity: 1;
}

.schedules__item:not(:last-child) {
    margin-bottom: 24px;
}

.schedules__date {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 88px;
    height: 80px;
    margin-right: 24px;
    padding-top: 7px;
    border-radius: 12px;
}

.schedules__date:before {
    content: '';
    position: absolute;
    top: 100%;
    left: 9px;
    right: 9px;
    height: 7px;
    border-radius: 0 0 10px 10px;
}

.schedules__date.bg-pink-light:before {
    background: rgba(255, 235, 246, 0.5);
}

.schedules__date.bg-purple-light:before {
    background: rgba(207, 200, 255, 0.5);
}

.schedules__date.bg-blue-light:before {
    background: rgba(160, 215, 231, 0.5);
}

.schedules__date.bg-yellow-light:before {
    background: rgba(255, 226, 172, 0.5);
}

.schedules__name {
    line-height: 1;
    color: #808191;
}

.schedules__details {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
}

.schedules__category {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 5px;
    padding-right: 35px;
}

.schedules__category .icon {
    position: absolute;
    top: 5px;
    right: 20px;
    font-size: 10px;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.schedules__info {
    margin-bottom: 8px;
    color: #808191;
}

.schedules__time {
    display: inline-block;
    padding: 3px 10px;
    background: var(--main-color);
    border-radius: 8px;
    color: #ffffff;
}

.schedules__item.active .schedules__name,
.schedules__item.active .schedules__info {
    color: #ffffff;
}

.schedules__item.active .schedules__category .icon {
    -webkit-transform: translateX(4px);
    -ms-transform: translateX(4px);
    transform: translateX(4px);
    fill: #ffffff;
}

.schedules__item.active .schedules__date {
    background: transparent;
}

.schedules__item.active .schedules__date:before {
    background: transparent;
}

.schedules__item.active .schedules__time {
    background: #ffebf6;
    color: #11142d;
}

.schedules__top {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 32px;
}

.schedules__arrows {
    display: none;
    margin-left: auto;
    margin-right: -16px;
}

.schedules__arrow {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    -webkit-box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);
    box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);
    background: #ffffff;
    font-size: 0;
    -webkit-transition: background 0.25s;
    -o-transition: background 0.25s;
    transition: background 0.25s;
}

.schedules__arrow .icon {
    font-size: 10px;
    fill: #11142d;
    -webkit-transition: fill 0.25s;
    -o-transition: fill 0.25s;
    transition: fill 0.25s;
}

.schedules__arrow:hover {
    background: var(--main-color);
}

.schedules__arrow:hover .icon {
    fill: #ffffff;
}

.schedules__arrow:not(:last-child) {
    margin-right: 8px;
}

.schedules__col>.schedules__title {
    margin-bottom: 32px;
}

.schedules__btn {
    display: none;
}

.schedules__graphic {
    position: relative;
    max-width: 586px;
    border-radius: 16px;
    border: 1px solid #e4e4e4;
}

.schedules__graphic:before {
    content: '';
    position: absolute;
    top: 100%;
    left: 14px;
    right: 14px;
    height: 7px;
    border-radius: 0 0 7px 7px;
    border-width: 0 1px 1px;
    border-style: solid;
    border-color: #e4e4e4;
}

.schedules__head {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 68px;
    border-bottom: 1px solid #e4e4e4;
}

.schedules__option {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 138px;
    padding-left: 32px;
    font-size: 13px;
    font-weight: 600;
    color: #808191;
}

.schedules__week {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
}

.schedules__cell {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 16.666%;
    flex: 0 0 16.666%;
    width: 16.666%;
}

.schedules__day {
    position: relative;
    display: inline-block;
    min-width: 32px;
    margin-left: -16px;
    background: transparent;
    border-radius: 50%;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    line-height: 32px;
}

.schedules__day:before {
    content: '';
    position: absolute;
    top: 6px;
    right: -4px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
}

.schedules__day.active {
    background: #ff754c;
    color: #ffffff;
}

.schedules__day.green:before {
    background: #7fba7a;
}

.schedules__day.purple:before {
    background: var(--main-color);
}

.schedules__day.gray:before {
    background: #e4e4e4;
}

.schedules__body {
    position: relative;
    padding: 26px 0 22px;
}

.schedules__grid {
    position: absolute;
    top: 0;
    left: 138px;
    right: 0;
    bottom: 0;
}

.schedules__line {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 1px;
    background: #e4e4e4;
    pointer-events: none;
}

.schedules__line:first-child {
    left: 8.33%;
}

.schedules__line:nth-child(2) {
    left: 25%;
}

.schedules__line:nth-child(3) {
    left: 41.66%;
}

.schedules__line:nth-child(4) {
    left: 58.33%;
}

.schedules__line:nth-child(5) {
    left: 75%;
}

.schedules__row {
    position: relative;
    z-index: 2;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.schedules__row:not(:last-child) {
    margin-bottom: 18px;
}

.schedules__task {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 32px;
    padding: 0 2px;
    border-radius: 8px;
}

.schedules__task .schedules__text {
    padding: 0 15px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    line-height: 28px;
}

.schedules__legend {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-top: 32px;
    padding: 0 16px;
}

.schedules__status {
    position: relative;
    padding-left: 20px;
    font-size: 12px;
    line-height: 1.2;
    font-weight: 500;
    color: #808191;
}

.schedules__status:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 12px;
    height: 12px;
    border-radius: 50%;
}

.schedules__status.green:before {
    background: #7fba7a;
}

.schedules__status.purple:before {
    background: var(--main-color);
}

.schedules__status.gray:before {
    background: #e4e4e4;
}

.schedules__status:not(:last-child) {
    margin-right: 120px;
}

.schedules:not(:last-child) {
    margin-bottom: 36px;
}

body.dark .schedules__container {
    background: #242731;
}

body.dark .schedules__container:before {
    background: #000;
    opacity: 0.51;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

body.dark .schedules__item {
    color: #ffffff;
}

body.dark .schedules__category .icon {
    fill: #ffffff;
}

body.dark .schedules__name,
body.dark .schedules__number {
    color: var(--main-color);
}

body.dark .schedules__item:hover {
    color: var(--main-color);
}

body.dark .schedules__item:hover .icon {
    fill: var(--main-color);
}

body.dark .schedules__item.active,
body.dark .schedules__item.active .schedules__number {
    color: #ffffff;
}

body.dark .schedules__item.active .icon {
    fill: #ffffff;
}

body.dark .schedules__graphic {
    border-color: rgba(228, 228, 228, 0.1);
}

body.dark .schedules__graphic:before {
    border-color: rgba(228, 228, 228, 0.1);
}

body.dark .schedules__head {
    border-color: rgba(228, 228, 228, 0.1);
}

body.dark .schedules__day.gray:before,
body.dark .schedules__status.gray:before {
    background: rgba(228, 228, 228, 0.1);
}

body.dark .schedules__line {
    background: rgba(228, 228, 228, 0.1);
}

body.dark .schedules__task .schedules__text {
    background: rgba(36, 39, 49, 0.8);
}

body.dark .schedules__arrow {
    background: #242731;
    -webkit-box-shadow: 0 5px 20px rgba(0, 0, 0, 0.35);
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.35);
}

body.dark .schedules__arrow .icon {
    fill: #ffffff;
}

.tabs__row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: -20px 0 14px -16px;
}

.tabs__col:first-child {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 53%;
    flex: 0 0 53%;
    width: 53%;
}

.tabs__col:nth-child(2) {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 47%;
    flex: 0 0 47%;
    width: 47%;
    padding-top: 20px;
}

.tabs__list {
    margin-left: -16px;
}

.tabs__item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 20px 16px;
    border-radius: 16px;
    color: #11142d;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.tabs__item:hover {
    color: var(--main-color);
}

.tabs__item:hover .icon {
    fill: var(--main-color);
}

.tabs__item.active {
    background: #ffebf6;
    color: #11142d;
}

.tabs__item.active .icon {
    fill: #11142d;
}

.tabs__preview {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 88px;
    height: 80px;
    margin-right: 16px;
    border-radius: 12px;
    font-size: 0;
}

.tabs__pic {
    max-height: 100%;
}

.tabs__details {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
}

.tabs__category {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 3px;
    padding-right: 20px;
}

.tabs__category .icon {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 10px;
    -webkit-transition: -webkit-transform 0.25s;
    transition: -webkit-transform 0.25s;
    -o-transition: transform 0.25s;
    transition: transform 0.25s;
    transition: transform 0.25s, -webkit-transform 0.25s;
}

.tabs__info {
    margin-bottom: 8px;
    color: #808191;
}

.tabs__price {
    display: inline-block;
    padding: 3px 10px;
    background: var(--main-color);
    border-radius: 8px;
    color: #ffffff;
}

.tabs__nav {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 3px;
    border-radius: 12px;
    border: 1px solid #e4e4e4;
}

.tabs__link {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    width: 25%;
    padding: 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.2;
    color: #808191;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.tabs__link:hover {
    color: var(--main-color);
}

.tabs__link:hover .icon {
    fill: var(--main-color);
}

.tabs__link.active {
    background: var(--main-color);
    color: #ffffff;
}

.tabs__link.active .icon {
    fill: #ffffff;
}

.tabs__icon {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 24px;
    height: 24px;
    margin-bottom: 5px;
    font-size: 0;
}

.tabs__icon .icon {
    font-size: 18px;
    fill: #11142d;
    -webkit-transition: fill 0.25s;
    -o-transition: fill 0.25s;
    transition: fill 0.25s;
}

.tabs__chart {
    max-width: 190px;
    height: 140px;
    margin: 0 auto 20px;
}

.tabs__desc {
    text-align: center;
}

.tabs__title {
    margin-bottom: 10px;
}

.tabs__date {
    margin-bottom: 50px;
    color: #808191;
}

.tabs__btn {
    min-width: 180px;
}

body.dark .tabs__item {
    color: #ffffff;
}

body.dark .tabs__item:hover {
    color: var(--main-color);
}

body.dark .tabs__item:hover .icon {
    fill: var(--main-color);
}

body.dark .tabs__item.active {
    color: #11142d;
}

body.dark .tabs__item.active .tabs__category .icon {
    fill: #11142d;
}

body.dark .tabs__category .icon {
    fill: #ffffff;
}

body.dark .tabs__nav {
    border-color: rgba(228, 228, 228, 0.1);
}

body.dark .tabs__icon .icon {
    fill: #ffffff;
}

body.dark .tabs__link:hover {
    color: #ffffff;
}

.payment__row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.payment__details {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 225px;
    margin-right: 16px;
    padding: 32px;
    border-radius: 16px;
    -webkit-box-shadow: 0 10px 36px rgba(227, 230, 236, 0.6);
    box-shadow: 0 10px 36px rgba(227, 230, 236, 0.6);
    text-align: center;
}

.payment__preview {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 80px;
    height: 80px;
    margin-bottom: 32px;
    border-radius: 24px;
    font-size: 0;
}

.payment__preview .payment__pic {
    max-height: 100%;
}

.payment__pic_white {
    display: none;
}

.payment__mail {
    margin-bottom: 16px;
    color: #7fba7a;
}

.payment__info {
    width: 100%;
    max-width: 140px;
    color: #b2b3bd;
}

.payment__details .payment__info {
    margin: 0 auto 32px;
}

.payment__logo {
    font-size: 0;
}

.payment__details .payment__logo {
    display: inline-block;
}

.payment__logo .payment__pic {
    max-width: 87px;
    max-height: 30px;
}

.payment__variants {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
}

.payment__label {
    display: block;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.payment__label:not(:last-child) {
    margin-bottom: 18px;
}

.payment__radio {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
}

.payment__in {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 34px 32px;
    border-radius: 16px;
    -webkit-box-shadow: inset 0 0 0 1px #e3e6ec;
    box-shadow: inset 0 0 0 1px #e3e6ec;
    -webkit-transition: -webkit-box-shadow 0.25s;
    transition: -webkit-box-shadow 0.25s;
    -o-transition: box-shadow 0.25s;
    transition: box-shadow 0.25s;
    transition: box-shadow 0.25s, -webkit-box-shadow 0.25s;
}

.payment__tick {
    position: relative;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 16px;
    flex: 0 0 16px;
    width: 16px;
    height: 16px;
    margin-right: 36px;
    border-radius: 4px;
    border: 2px solid #e4e4e4;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.payment__tick:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 8px;
    height: 7px;
    opacity: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat 50% 50%/100% auto;
    -webkit-transition: opacity 0.25s;
    -o-transition: opacity 0.25s;
    transition: opacity 0.25s;
}

.payment__desc .payment__logo {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 30px;
    margin-top: -8px;
}

.payment__desc .payment__info {
    display: block;
    margin-top: 16px;
}

.payment__btn {
    min-width: 132px;
    height: 40px;
    margin-top: 16px;
}

.payment__label:hover .payment__in {
    -webkit-box-shadow: inset 0 0 0 1px var(--main-color);
    box-shadow: inset 0 0 0 1px var(--main-color);
}

.payment__radio:checked+.payment__in {
    -webkit-box-shadow: inset 0 0 0 2px var(--main-color);
    box-shadow: inset 0 0 0 2px var(--main-color);
}

.payment__radio:checked+.payment__in .payment__tick {
    background: var(--main-color);
    border-color: var(--main-color);
}

.payment__radio:checked+.payment__in .payment__tick:before {
    opacity: 1;
}

body.dark .payment__pic_black {
    display: none;
}

body.dark .payment__pic_white {
    display: inline-block;
}

body.dark .payment__details {
    -webkit-box-shadow: 0 10px 36px rgba(0, 0, 0, 0.35);
    box-shadow: 0 10px 36px rgba(0, 0, 0, 0.35);
}

body.dark .payment__tick {
    border-color: rgba(228, 228, 228, 0.1);
}

body.dark .payment__in {
    -webkit-box-shadow: inset 0 0 0 1px rgba(228, 228, 228, 0.1);
    box-shadow: inset 0 0 0 1px rgba(228, 228, 228, 0.1);
}

.inbox__tags {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin: -18px 0 28px -18px;
}

.inbox__tag {
    margin: 18px 0 0 18px;
    border: 2px solid #ff754c;
    border-radius: 12px;
    padding: 6px 16px;
    line-height: 1.42857;
    font-weight: 600;
    color: #11142d;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.inbox__tag:hover,
.inbox__tag.active {
    background: var(--main-color);
    border-color: var(--main-color);
    color: #ffffff;
}

.inbox__container {
    position: relative;
    padding: 32px;
    border-radius: 24px;
    background: #ffffff;
}

.inbox__container:before {
    content: '';
    position: absolute;
    top: 32px;
    left: 18px;
    right: 18px;
    bottom: -32px;
    z-index: -1;
    background: #e3e6ec;
    opacity: 0.91;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

.inbox__container>.inbox__title {
    margin-bottom: 16px;
}

.inbox__list {
    margin: 0 -16px;
}

.inbox__item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 32px 16px;
    border-radius: 12px;
    background: transparent;
    color: #808191;
    cursor: pointer;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.inbox__ava {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    font-size: 0;
}

.inbox__ava .inbox__pic {
    width: 100%;
    min-height: 100%;
    border-radius: 50%;
}

.inbox__details {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 calc(100% - 48px);
    flex: 0 0 calc(100% - 48px);
    width: calc(100% - 48px);
    padding-left: 24px;
}

.inbox__head {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 16px;
}

.inbox__author {
    color: var(--main-color);
    -webkit-transition: color 0.25s;
    -o-transition: color 0.25s;
    transition: color 0.25s;
}

.inbox__time {
    margin-left: 10px;
}

.inbox__item .inbox__title {
    margin-bottom: 18px;
    color: #11142d;
    -webkit-transition: color 0.25s;
    -o-transition: color 0.25s;
    transition: color 0.25s;
}

.inbox__text {
    margin-bottom: 16px;
}

.inbox__text p:not(:last-child) {
    margin-bottom: 20px;
}

.inbox__item:hover {
    background: rgba(228, 228, 228, 0.3);
}

.inbox__item.active {
    background: var(--main-color);
    color: #ffffff;
}

.inbox__item.active .actions__btn {
    border-color: #ffffff;
}

.inbox__item.active .actions__btn .icon {
    fill: #ffffff;
}

.inbox__item.active .inbox__title,
.inbox__item.active .inbox__author {
    color: #ffffff;
}

.inbox__foot {
    padding-top: 12px;
    text-align: center;
}

.inbox__foot .inbox__btn {
    min-width: 180px;
}

.inbox__control {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 60px;
}

.inbox__btns {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-right: auto;
}

.inbox__btns .inbox__btn {
    min-width: 140px;
}

.inbox__btns .inbox__btn:not(:last-child) {
    margin-right: 16px;
}

.inbox__more {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    font-size: 0;
    -webkit-transition: -webkit-box-shadow 0.25s;
    transition: -webkit-box-shadow 0.25s;
    -o-transition: box-shadow 0.25s;
    transition: box-shadow 0.25s;
    transition: box-shadow 0.25s, -webkit-box-shadow 0.25s;
}

.inbox__more .icon {
    font-size: 6px;
    fill: #11142d;
}

.inbox__more:hover {
    -webkit-box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);
    box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);
}

.inbox__box {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.inbox__box:not(:last-child) {
    margin-bottom: 40px;
    padding-bottom: 40px;
    border-bottom: 1px solid #e4e4e4;
}

.inbox__box .inbox__author {
    color: #11142d;
}

.inbox__box .inbox__time {
    margin-left: 24px;
    color: #b2b3bd;
}

.inbox__box .inbox__title {
    margin-bottom: 32px;
}

.inbox__box .inbox__text {
    color: #808191;
}

.inbox .files {
    margin-top: 24px;
}

.inbox .sorting {
    margin-bottom: 24px;
}

body.dark .inbox__tag {
    color: #ffffff;
}

body.dark .inbox__container {
    background: #242731;
}

body.dark .inbox__container:before {
    background: #000;
    opacity: 0.51;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

body.dark .inbox__item:hover {
    background: rgba(228, 228, 228, 0.04);
}

body.dark .inbox__item.active {
    background: var(--main-color);
}

body.dark .inbox__title {
    color: #ffffff;
}

body.dark .inbox__item.active .inbox__title {
    color: #ffffff;
}

body.dark .inbox__item.active .inbox__author {
    color: #ffffff;
}

body.dark .inbox__more .icon {
    fill: #ffffff;
}

body.dark .inbox__more:hover {
    -webkit-box-shadow: 0 12px 20px rgba(0, 0, 0, 0.35);
    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.35);
}

body.dark .inbox__box {
    border-color: rgba(228, 228, 228, 0.1);
}

body.dark .inbox__box .inbox__author {
    color: #ffffff;
}

.actions {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.actions__btn {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid #e4e4e4;
    font-size: 0;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.actions__btn .icon {
    font-size: 12px;
    fill: #1b1d21;
    opacity: 0.4;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.actions__btn:hover .icon {
    opacity: 0.75;
}

.actions__btn:not(:last-child) {
    margin-right: 16px;
}

body.dark .actions__btn {
    border-color: rgba(228, 228, 228, 0.1);
}

body.dark .actions__btn .icon {
    fill: #ffffff;
}

.files__list {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: -8px -4px 0;
}

.files__item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 4px;
    border-radius: 16px;
    color: #11142d;
    -webkit-transition: opacity 0.25s;
    -o-transition: opacity 0.25s;
    transition: opacity 0.25s;
}

.files__item.purple {
    background: rgba(207, 200, 255, 0.5);
}

.files__item.purple .files__preview {
    background: #cfc8ff;
}

.files__item.blue {
    background: #e7faff;
}

.files__item.blue .files__preview {
    background: #a0d7e7;
}

.files__item:hover {
    opacity: 0.8;
}

.files>.files__item:not(:last-child) {
    margin-bottom: 10px;
}

.files__list .files__item {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 calc(50% - 8px);
    flex: 0 0 calc(50% - 8px);
    width: calc(50% - 8px);
    margin: 4px 4px 0;
}

.files__preview {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: 12px;
    overflow: hidden;
    font-size: 0;
}

.files__pic {
    max-width: 100%;
    max-height: 100%;
}

.files__details {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 calc(100% - 48px);
    flex: 0 0 calc(100% - 48px);
    width: calc(100% - 48px);
    padding-left: 16px;
}

.files__title {
    max-width: 100%;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--main-color);
}

body.dark .files__item {
    background: rgba(228, 228, 228, 0.1);
    color: #ffffff;
}

body.dark .files__title {
    color: #ffffff;
}

.editor__wrap {
    background: #fafafa;
    border-radius: 12px;
}

.editor__head {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 24px;
    border-bottom: 1px solid #e4e4e4;
}

.editor__control {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin: -16px auto 0 -16px;
}

.editor__action {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    margin: 16px 0 0 16px;
    border-radius: 4px;
    background: #e4e4e4;
    font-size: 0;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.editor__action .icon {
    font-size: 12px;
    fill: #808191;
    -webkit-transition: fill 0.25s;
    -o-transition: fill 0.25s;
    transition: fill 0.25s;
}

.editor__action:hover,
.editor__action.active {
    background: rgba(27, 29, 33, 0.3);
}

.editor__action:hover .icon,
.editor__action.active .icon {
    fill: #ffffff;
}

.editor__add {
    position: relative;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    margin-left: 30px;
    border-radius: 50%;
    background: #1b1d21;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.editor__add:before,
.editor__add:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background: #ffffff;
}

.editor__add:before {
    width: 8px;
    height: 2px;
}

.editor__add:after {
    width: 2px;
    height: 8px;
}

.editor__add:hover {
    background: rgba(27, 29, 33, 0.8);
}

.editor__body {
    padding: 32px 24px;
}

.editor__textarea {
    width: 100%;
    height: 110px;
    border: none;
    background: none;
    resize: none;
    font-size: 14px;
}

.editor__gallery {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    max-width: 360px;
    margin: -16px 0 0 -8px;
}

.editor__preview {
    position: relative;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 calc(50% - 16px);
    flex: 0 0 calc(50% - 16px);
    width: calc(50% - 16px);
    margin: 16px 8px 0;
    font-size: 0;
    cursor: pointer;
}

.editor__pic {
    border-radius: 8px;
}

.editor__close {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #ffffff;
    font-size: 0;
    visibility: hidden;
    opacity: 0;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.editor__close .icon {
    font-size: 6px;
    fill: #1b1d21;
    -webkit-transition: -webkit-transform 0.25s;
    transition: -webkit-transform 0.25s;
    -o-transition: transform 0.25s;
    transition: transform 0.25s;
    transition: transform 0.25s, -webkit-transform 0.25s;
}

.editor__close:hover .icon {
    -webkit-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
}

.editor__preview:hover .editor__close {
    visibility: visible;
    opacity: 1;
}

.editor__btn {
    min-width: 232px;
    margin-top: 24px;
}

.editor__btn.btn_wide {
    min-width: 100%;
}

.editor .files {
    width: 100%;
    margin-top: 24px;
}

body.dark .editor__wrap {
    background: rgba(228, 228, 228, 0.03);
}

body.dark .editor__head {
    border-color: rgba(228, 228, 228, 0.1);
}

body.dark .editor__action {
    background: rgba(228, 228, 228, 0.1);
}

body.dark .editor__action.active {
    background: #1b1d21;
}

body.dark .editor__textarea {
    color: #ffffff;
}

body.dark .editor__close {
    background: #242731;
}

body.dark .editor__close .icon {
    fill: #ffffff;
}

.notification__tags {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin: -18px 0 28px -18px;
}

.notification__tag {
    margin: 18px 0 0 18px;
    border: 2px solid #e4e4e4;
    border-radius: 12px;
    padding: 6px 16px;
    line-height: 1.42857;
    font-weight: 600;
    color: #11142d;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.notification__tag:hover,
.notification__tag.active {
    background: var(--main-color);
    border-color: var(--main-color);
    color: #ffffff;
}

.notification__container {
    position: relative;
    padding: 32px;
    border-radius: 24px;
    background: #ffffff;
}

.notification__container:before {
    content: '';
    position: absolute;
    top: 32px;
    left: 32px;
    right: 32px;
    bottom: -32px;
    z-index: -1;
    background: #e3e6ec;
    opacity: 0.91;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

.notification__title {
    margin-bottom: 32px;
}

.notification__list {
    margin: 0 -16px;
}

.notification__item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 32px 16px;
    border-radius: 12px;
    background: transparent;
    color: #808191;
    cursor: pointer;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.notification__ava {
    position: relative;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    font-size: 0;
}

.notification__ava>.notification__pic {
    width: 100%;
    min-height: 100%;
    border-radius: 50%;
}

.notification__status {
    position: absolute;
    top: 0;
    right: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #ffffff;
    font-size: 0;
}

.notification__details {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    padding: 0 24px;
}

.notification__author {
    margin-bottom: 9px;
    color: #11142d;
    -webkit-transition: color 0.25s;
    -o-transition: color 0.25s;
    transition: color 0.25s;
}

.notification__line {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-bottom: 16px;
}

.notification__line .notification__category {
    margin-right: 8px;
}

.notification__info {
    margin-right: 8px;
    color: var(--main-color);
}

.notification__item .notification__text {
    margin-bottom: 16px;
}

.notification__item .notification__text p:not(:last-child) {
    margin-bottom: 20px;
}

.notification__item:hover {
    background: rgba(228, 228, 228, 0.3);
}

.notification__item.active {
    background: var(--main-color);
    color: #ffffff;
}

.notification__item.active .actions__btn {
    border-color: #ffffff;
}

.notification__item.active .actions__btn .icon {
    fill: #ffffff;
}

.notification__item.active .notification__title,
.notification__item.active .notification__author,
.notification__item.active .notification__info {
    color: #ffffff;
}

.notification__preview {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 96px;
    height: 96px;
    border-radius: 8px;
    font-size: 0;
}

.notification__preview:before {
    content: '';
    position: absolute;
    top: 100%;
    left: 7px;
    right: 7px;
    height: 7px;
    border-radius: 0 0 7px 7px;
}

.notification__preview.bg-purple-light:before {
    background: rgba(207, 200, 255, 0.5);
}

.notification__preview.bg-blue-light:before {
    background: rgba(160, 215, 231, 0.5);
}

.notification__preview.bg-yellow:before {
    background: rgba(255, 206, 115, 0.5);
}

.notification__preview .notification__pic {
    max-height: 100%;
}

.notification__btns {
    padding-top: 24px;
    text-align: center;
}

.notification__btn {
    min-width: 180px;
}

.notification__photo {
    margin-bottom: 40px;
    font-size: 0;
}

.notification__photo .notification__pic {
    width: 100%;
}

.notification__body {
    padding: 0 24px;
}

.notification__body:not(:last-child) {
    margin-bottom: 32px;
}

.notification__stage {
    margin-bottom: 16px;
}

.notification__parameters {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 24px;
}

.notification__parameter {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    color: var(--main-color);
}

.notification__parameter:not(:last-child) {
    margin-right: 16px;
}

.notification__icon {
    margin-right: 10px;
    font-size: 0;
}

body.dark .notification__container {
    background: #242731;
}

body.dark .notification__container:before {
    background: #000;
    opacity: 0.51;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

body.dark .notification__tag {
    border-color: rgba(228, 228, 228, 0.1);
    color: #ffffff;
}

body.dark .notification__tag:hover {
    border-color: var(--main-color);
}

body.dark .notification__item:hover {
    background: rgba(228, 228, 228, 0.04);
}

body.dark .notification__item.active {
    background: var(--main-color);
}

body.dark .notification__item.active .notification__author {
    color: #ffffff;
}

body.dark .notification__item.active .notification__info {
    color: var(--main-color);
}

body.dark .notification__author {
    color: #ffffff;
}

.filters__container {
    position: relative;
    padding: 32px;
    background: #ffffff;
    border-radius: 24px;
}

.filters__container:before {
    content: '';
    position: absolute;
    top: 32px;
    left: 17px;
    right: 17px;
    bottom: -32px;
    z-index: -1;
    background: #e3e6ec;
    opacity: 0.91;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

.filters__item:not(:last-child) {
    margin-bottom: 32px;
    padding-bottom: 32px;
    border-bottom: 1px solid #e4e4e4;
}

.filters__title {
    margin-bottom: 24px;
}

.filters__variants {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    margin-bottom: 32px;
}

.filters .checkbox:not(:last-child) {
    margin-bottom: 20px;
}

.filters__control {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.filters__btns {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 0 -5px;
}

.filters__btn {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 calc(50% - 10px);
    flex: 0 0 calc(50% - 10px);
    min-width: calc(50% - 10px);
    height: 44px;
    margin: 0 5px;
    padding: 0;
    font-size: 14px;
}

.filters__line {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 32px;
}

.filters .radio:not(:last-child) {
    margin-right: 32px;
}

.filters__reset {
    line-height: 1.42857;
    font-weight: 600;
    color: #808191;
    -webkit-transition: color 0.25s;
    -o-transition: color 0.25s;
    transition: color 0.25s;
}

.filters__reset:hover {
    color: var(--main-color);
}

body.dark .filters__container {
    background: #242731;
}

body.dark .filters__container:before {
    background: #000;
    opacity: 0.51;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

body.dark .filters__item {
    border-color: rgba(228, 228, 228, 0.1);
}

.activity__row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.activity__col:first-child {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
}

.activity__col:nth-child(2) {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 426px;
    padding: 32px 0 0 65px;
}

.activity__container {
    position: relative;
    padding: 32px;
    background: #ffffff;
    border-radius: 24px;
}

.activity__container:before {
    content: '';
    position: absolute;
    top: 26px;
    left: 19px;
    right: 19px;
    bottom: -26px;
    z-index: -1;
    background: #e3e6ec;
    opacity: 0.91;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

.activity__title {
    margin-bottom: 32px;
}

.activity__inner {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.activity__variants {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 130px;
    padding-right: 15px;
}

.activity__variants .checkbox:not(:last-child) {
    margin-bottom: 16px;
}

.activity__list {
    margin-right: -16px;
}

.activity__item {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 32px 16px;
    overflow: hidden;
    border-radius: 12px;
    color: #808191;
    cursor: pointer;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.activity__item:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    -webkit-transition: background 0.25s;
    -o-transition: background 0.25s;
    transition: background 0.25s;
}

.activity__item:hover {
    background: rgba(228, 228, 228, 0.3);
}

.activity__item.active {
    color: #ffffff;
}

.activity__item.active:before {
    background: var(--main-color);
}

.activity__ava {
    position: relative;
    z-index: 2;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    font-size: 0;
}

.activity__ava>.activity__pic {
    width: 100%;
    min-height: 100%;
    border-radius: 50%;
}

.activity__status {
    position: absolute;
    top: 0;
    right: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #ff9a7b;
    border: 2px solid #ffffff;
    font-size: 0;
}

.activity__details {
    position: relative;
    z-index: 2;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    padding: 0 32px 0 24px;
}

.activity__author {
    margin-bottom: 9px;
    color: #11142d;
    -webkit-transition: color 0.25s;
    -o-transition: color 0.25s;
    transition: color 0.25s;
}

.activity__details .activity__line {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-bottom: 16px;
}

.activity__line .activity__category {
    margin-right: 8px;
}

.activity__info {
    margin-right: 8px;
    color: var(--main-color);
    -webkit-transition: color 0.25s;
    -o-transition: color 0.25s;
    transition: color 0.25s;
}

.activity__item .activity__text p:not(:last-child) {
    margin-bottom: 20px;
}

.activity__item.active .activity__author,
.activity__item.active .activity__info {
    color: #ffffff;
}

.activity__preview {
    position: relative;
    z-index: 2;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 96px;
    height: 84px;
    background: #a0d7e7;
    border-radius: 8px;
    font-size: 0;
}

.activity__preview:before {
    content: '';
    position: absolute;
    top: 100%;
    left: 7px;
    right: 7px;
    height: 7px;
    border-radius: 0 0 7px 7px;
    background: #e7faff;
}

.activity__preview .activity__pic {
    max-height: 100%;
}

.activity__btns {
    padding-top: 24px;
    text-align: center;
}

.activity__btn {
    min-width: 180px;
}

.activity:not(:first-child) {
    margin-top: 48px;
}

body.dark .activity__container {
    background: #242731;
}

body.dark .activity__container:before {
    background: #000;
    opacity: 0.51;
    -webkit-filter: blur(86.985px);
    filter: blur(86.985px);
    border-radius: 24px;
}

body.dark .activity__author {
    color: #ffffff;
}

body.dark .activity__item:hover {
    background: rgba(228, 228, 228, 0.04);
}

body.dark .activity__item.active .activity__author {
    color: #ffffff;
}

.field__label {
    margin: 16px 0;
    line-height: 1.33333;
    font-weight: 500;
    font-weight: bold;
    font-size: 14px;
    letter-spacing: 0.3px;
    color: #334155;
}

.field__input,
.field__textarea {
    width: 100%;
    border-radius: 8px;
    background: transparent;
    border: 1px solid var(--gray-color);
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    color: #11142d;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.field__input:disabled,
.field__textarea:disabled {
    background-color: var(--disabled-color);
    border: none;
}

.field__input {
    height: 38px;
    padding: 0 23px;
}

.field__textarea {
    height: 157px;
    padding: 15px 23px;
    resize: none;
}

body.dark .field__input,
body.dark .field__textarea {
    color: #ffffff;
    background: rgba(228, 228, 228, 0.04);
}

.popup {
    position: relative;
    max-width: 630px;
    margin: 15px auto;
    background: #ffffff;
    border-radius: 24px;
}

.popup__form {
    border-radius: 24px;
}

.popup__title {
    margin-bottom: 48px;
}

.popup__tags {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin: -13px 0 32px -13px;
}

.popup__tag {
    margin: 13px 0 0 13px;
    border: 2px solid #ff754c;
    border-radius: 12px;
    padding: 6px 16px;
    line-height: 1.42857;
    font-weight: 600;
    color: #11142d;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.popup__tag:hover,
.popup__tag.active {
    background: var(--main-color);
    border-color: var(--main-color);
    color: #ffffff;
}

.popup__select {
    min-width: 100%;
    height: 56px;
    margin-bottom: 32px;
    padding: 0 40px 0 24px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: none;
    border-radius: 12px;
    background: rgba(228, 228, 228, 0.25) url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat calc(100% - 16px) 50%/11px 7px;
    font-size: 14px;
    font-weight: 600;
    color: #808191;
    -webkit-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
}

.popup__select::-ms-expand {
    display: none;
}

.popup__select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
}

.popup__user:not(:last-child) {
    margin-bottom: 32px;
    padding-bottom: 32px;
    border-bottom: 1px solid #e4e4e4;
}

.popup__category {
    margin-bottom: 32px;
    color: #b2b3bd;
}

.popup__line {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.popup__ava {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 64px;
    height: 64px;
    font-size: 0;
}

.popup__ava .popup__pic {
    width: 100%;
    min-height: 100%;
    border-radius: 50%;
    image-orientation: from-image;
}

.popup__details {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 calc(100% - 64px);
    flex: 0 0 calc(100% - 64px);
    width: calc(100% - 64px);
    padding-left: 40px;
}

.popup__btns {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 16px;
}

.popup__btns .popup__btn {
    min-width: 166px;
    height: 40px;
}

.popup__btns .popup__btn:not(:last-child),
.popup__loading:not(:last-child) {
    margin-right: 16px;
}

.popup__loading {
    position: relative;
    overflow: hidden;
    border-radius: 16px;
}

.popup__file {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 140px;
    opacity: 0;
}

.popup__loading:hover .popup__btn {
    background: #5a49ce;
}

.popup__text {
    color: #b2b3bd;
}

.popup__fieldset {
    margin-bottom: 24px;
}

.popup__fieldset>.popup__field:not(:last-child) {
    margin-bottom: 5px;
}

.popup__row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 0 -8px;
}

.popup__row:not(:last-child) {
    margin-bottom: 20px;
}

.popup__row .popup__field {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 calc(50% - 16px);
    flex: 0 0 calc(50% - 16px);
    width: calc(50% - 16px);
    margin: 0 8px;
}

.popup .mfp-close {
    position: absolute;
    top: 20px;
    right: 32px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    line-height: normal;
    opacity: 1;
    font-size: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat 50% 50%/10px auto;
    -webkit-transition: -webkit-box-shadow 0.25s;
    transition: -webkit-box-shadow 0.25s;
    -o-transition: box-shadow 0.25s;
    transition: box-shadow 0.25s;
    transition: box-shadow 0.25s, -webkit-box-shadow 0.25s;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.popup .mfp-close:hover {
    -webkit-box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);
    box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);
}

.mfp-container {
    padding: 20px;
}

.mfp-bg {
    background: rgba(27, 29, 33, 0.7);
}

.mfp-zoom-in .popup {
    opacity: 0;
    -webkit-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
    -webkit-transform: scale(0.8);
    -ms-transform: scale(0.8);
    transform: scale(0.8);
}

.mfp-zoom-in.mfp-bg {
    opacity: 0;
    -webkit-transition: all 0.2s ease-out;
    -o-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
}

.mfp-zoom-in.mfp-ready .popup {
    opacity: 1;
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
}

.mfp-zoom-in.mfp-ready.mfp-bg {
    opacity: 0.8;
}

.mfp-zoom-in.mfp-removing .popup {
    -webkit-transform: scale(0.8);
    -ms-transform: scale(0.8);
    transform: scale(0.8);
    opacity: 0;
}

.mfp-zoom-in.mfp-removing.mfp-bg {
    opacity: 0;
}

body.dark .popup {
    background: #242731;
}

body.dark .popup__tag {
    color: #ffffff;
}

body.dark .popup__user {
    border-color: rgba(228, 228, 228, 0.1);
}

body.dark .popup .mfp-close {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

body.dark .popup .mfp-close:hover {
    -webkit-box-shadow: 0 5px 20px rgba(0, 0, 0, 0.35);
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.35);
}

body.dark .popup__select {
    background-color: rgba(228, 228, 228, 0.04);
}

body.dark .popup__btns .popup__btn.btn_gray {
    background: none;
}

body.dark .mfp-bg {
    background: rgba(27, 29, 33, 0.9);
}

.color-green {
    color: #7fba7a;
}

.color-red {
    color: #ff754c;
}

.color-white {
    color: #ffffff;
}

.color-blue {
    color: #f4c257;
}

.color-blue-dark {
    color: var(--main-color);
}

.color-purple {
    color: var(--main-color);
}

.color-gray {
    color: #808191;
}

.bg-blue {
    background: #f4c257;
}

.bg-blue-opacity {
    background: rgba(63, 140, 255, 0.3);
}

.bg-blue-light {
    background: #a0d7e7;
}

.bg-blue-light-opacity {
    background: rgba(160, 215, 231, 0.3);
}

.bg-yellow {
    background: #ffce73;
}

.bg-yellow-opacity {
    background: rgba(255, 206, 115, 0.3);
}

.bg-yellow-light {
    background: #ffe2ac;
}

.bg-pink {
    background: #ffa2c0;
}

.bg-pink-opacity {
    background: rgba(255, 162, 192, 0.3);
}

.bg-pink-light {
    background: #ffebf6;
}

.bg-green {
    background: #7fba7a;
}

.bg-green-opacity {
    background: rgba(127, 186, 122, 0.3);
}

.bg-purple {
    background: var(--main-color);
}

.bg-purple-opacity {
    background: rgba(108, 93, 211, 0.3);
}

.bg-purple-light {
    background: #cfc8ff;
}

.bg-red {
    background: #ff754c;
}

.bg-red-opacity {
    background: rgba(255, 117, 76, 0.3);
}

.text-right {
    text-align: right;
}

.text-center {
    text-align: center;
}

.text-uppercase {
    text-transform: uppercase;
}

.m-auto {
    margin: auto;
}

.ml-auto {
    margin-left: auto;
}

.mr-auto {
    margin-right: auto;
}

.align-baseline {
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    align-items: baseline;
}

.desktop-show {
    display: none;
}

.tablet-show {
    display: none;
}

.mobile-show {
    display: none;
}

.title {
    font-size: 16px;
    line-height: 1.1875;
    font-weight: 600;
}

.title_lg,
.title_md,
.title_sm {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    letter-spacing: -1px;
}

.title_lg {
    font-size: 96px;
    line-height: 1.25;
}

.title_md {
    font-size: 72px;
    line-height: 1.22222;
}

.title_sm {
    font-size: 64px;
    line-height: 1.125;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
    font-family: 'Poppins', sans-serif;
}

.h1,
.h2,
.h3 {
    font-weight: 600;
    letter-spacing: -1px;
}

.h4,
.h5,
.h6 {
    font-weight: 500;
}

.h1 {
    font-size: 56px;
    line-height: 1.14286;
}

.h2 {
    font-size: 48px;
    line-height: 1.5;
}

.h3 {
    font-size: 40px;
    line-height: 1.5;
}

.h4 {
    font-size: 32px;
    line-height: 1.5;
    letter-spacing: -0.5px;
}

.h5 {
    font-size: 24px;
    line-height: 1.33333;
}

.h6 {
    font-size: 18px;
    line-height: 1.33333;
}

.caption {
    font-size: 13px;
    font-weight: 600;
    line-height: 1.38462;
}

.caption-sm {
    font-size: 12px;
    font-weight: 500;
    line-height: 1.33333;
}

@media only screen and (max-width: 1339px) and (max-width: 767px) {
    .widget_responsive:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    .schedules__col:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    body.dark .schedules__col:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }
}

@media (hover: hover) {
    .switch:hover {
        opacity: 0.8;
    }
}

@media screen and (max-width: 800px) and (orientation: landscape),
screen and (max-height: 300px) {

    /**
     * Remove all paddings around the image on small screen
     */
    .mfp-img-mobile .mfp-image-holder {
        padding-left: 0;
        padding-right: 0;
    }

    .mfp-img-mobile img.mfp-img {
        padding: 0;
    }

    .mfp-img-mobile .mfp-figure:after {
        top: 0;
        bottom: 0;
    }

    .mfp-img-mobile .mfp-figure small {
        display: inline;
        margin-left: 5px;
    }

    .mfp-img-mobile .mfp-bottom-bar {
        background: rgba(0, 0, 0, 0.6);
        bottom: 0;
        margin: 0;
        top: auto;
        padding: 3px 5px;
        position: fixed;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .mfp-img-mobile .mfp-bottom-bar:empty {
        padding: 0;
    }

    .mfp-img-mobile .mfp-counter {
        right: 5px;
        top: 3px;
    }

    .mfp-img-mobile .mfp-close {
        top: 0;
        right: 0;
        width: 35px;
        height: 35px;
        line-height: 35px;
        background: rgba(0, 0, 0, 0.6);
        position: fixed;
        text-align: center;
        padding: 0;
    }
}

@media only screen and (max-width: 1419px) {
    .page__col {
        padding: 0 48px 44px;
    }

    .page__col:first-child {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 calc(100% - 390px);
        flex: 0 0 calc(100% - 390px);
        max-width: calc(100% - 390px);
    }

    .page__col:nth-child(2) {
        width: 390px;
    }

    .page__content {
        padding: 0 48px 48px;
    }

    .widget__details {
        padding-left: 16px;
    }

    .banner__preview {
        width: 450px;
    }
}

@media only screen and (max-width: 1339px) {
    .page__center {
        width: 100%;
        max-width: 930px;
    }

    .page__row {
        display: block;
    }

    .page__row_head {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin: 0 -16px;
        padding: 40px 0;
    }

    .page__row_head .page__col {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 calc(50% - 32px);
        flex: 0 0 calc(50% - 32px);
        max-width: calc(50% - 32px);
        margin: 0 16px;
        padding: 0;
    }

    .page__row_border .page__col:nth-child(2) {
        border: none;
    }

    .page__row_responsive {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin: 0 -40px;
    }

    .page__row_responsive.page__row_head {
        padding: 0;
    }

    .page__row_responsive.page__row_head .page__col {
        padding-top: 40px;
        padding-bottom: 40px;
    }

    .page__row_responsive .page__col {
        margin: 0;
        padding-left: 40px;
        padding-right: 40px;
    }

    .page__row_responsive .page__col:first-child {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 55%;
        flex: 0 0 55%;
        max-width: 55%;
    }

    .page__row_responsive .page__col:nth-child(2) {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 45%;
        flex: 0 0 45%;
        max-width: 45%;
        border-left: 1px solid #e4e4e4;
    }

    .page__col {
        padding: 0;
    }

    .page__col:first-child {
        max-width: 100%;
    }

    .page__col:nth-child(2) {
        width: 100%;
    }

    .page__row:not(.page__row_head):not(.page__row_responsive) .page__col:nth-child(2) {
        margin-top: 32px;
    }

    .page .page__col.page__col_w50 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 50%;
        margin: 0;
        padding-left: 40px;
        padding-right: 40px;
    }

    .page__group {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        margin: 0 -16px;
    }

    .page__group .widget {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 calc(50% - 32px);
        flex: 0 0 calc(50% - 32px);
        max-width: calc(50% - 32px);
        margin: 0 16px;
    }

    .page__group .widget:not(:last-child) {
        margin-bottom: 0;
    }

    .page__content {
        padding: 0 0 40px;
    }

    .page__content_pt64 {
        margin-top: 32px;
        padding: 0;
        border: none;
    }

    .page__hello {
        font-size: 18px;
        line-height: 1.33333;
    }

    .page_other .page__center {
        padding-bottom: 0;
    }

    .sidebar__details {
        padding: 10px 10px 25px;
    }

    .sidebar__details:before {
        display: none;
    }

    .widget__details {
        padding-left: 24px;
    }

    .widget_responsive {
        position: relative;
        padding: 32px;
        background: #ffffff;
        border-radius: 24px;
    }

    .widget_responsive:before {
        content: '';
        position: absolute;
        top: 22px;
        left: 18px;
        right: 18px;
        bottom: -40px;
        z-index: -2;
        background: #e3e6ec;
        opacity: 0.91;
        -webkit-filter: blur(86.985px);
        filter: blur(86.985px);
        border-radius: 24px;
    }

    .header {
        max-width: 100%;
    }

    .header .search {
        width: auto;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        margin-right: 50px;
    }

    .banner__container {
        padding: 50px 56px;
    }

    .banner__preview {
        right: 50px;
        width: 330px;
    }

    .sorting__row {
        display: block;
        margin: 0;
    }

    .sorting__col {
        width: 100%;
        margin: 0;
    }

    .sorting__col:not(:last-child) {
        margin-bottom: 16px;
    }

    .schedules__container {
        display: block;
        padding: 0;
        background: none;
        border-radius: 0;
    }

    .schedules__container:before {
        display: none;
    }

    .schedules__col {
        position: relative;
        padding: 32px;
        border-radius: 24px;
        background: #ffffff;
    }

    .schedules__col:before {
        content: '';
        position: absolute;
        top: 35px;
        left: 35px;
        right: 35px;
        bottom: -35px;
        z-index: -5;
        background: #e3e6ec;
        opacity: 0.91;
        -webkit-filter: blur(86.985px);
        filter: blur(86.985px);
        border-radius: 24px;
    }

    .schedules__col:first-child {
        width: 100%;
        margin-bottom: 32px;
    }

    .schedules__col:first-child .schedules__title {
        display: block;
    }

    .schedules__col:nth-child(2) {
        padding-left: 32px;
    }

    .schedules__list {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        margin: -32px -32px 0;
    }

    .schedules__item {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 calc(50% - 32px);
        flex: 0 0 calc(50% - 32px);
        width: calc(50% - 32px);
        margin: 32px 16px 0;
    }

    .schedules__item:not(:last-child) {
        margin-bottom: 0;
    }

    .schedules__btn {
        display: inline-block;
        margin-top: 32px;
    }

    .schedules__graphic {
        max-width: 100%;
    }

    .schedules__status:not(:last-child) {
        margin-right: auto;
    }

    body.dark .schedules__container {
        background: none;
    }

    body.dark .schedules__col {
        background: #242731;
    }

    body.dark .schedules__col:before {
        background: #000;
        opacity: 0.51;
        -webkit-filter: blur(86.985px);
        filter: blur(86.985px);
        border-radius: 24px;
    }

    .tabs__preview {
        display: none;
    }

    .inbox__details {
        padding-left: 16px;
    }

    .inbox__control {
        margin-bottom: 32px;
    }

    .inbox__btns .inbox__btn {
        min-width: 120px;
        height: 48px;
    }

    .files__list {
        display: block;
        margin: 0;
    }

    .files__list .files__item {
        width: 100%;
        margin: 0;
    }

    .files__list .files__item:not(:last-child) {
        margin-bottom: 16px;
    }

    .notification__details {
        padding-right: 0;
    }

    .notification__preview {
        display: none;
    }

    .activity__col:nth-child(2) {
        width: 370px;
        padding-left: 32px;
    }

    .activity__inner {
        display: block;
    }

    .activity__variants {
        display: none;
    }

    .activity__details {
        padding-right: 0;
    }

    .activity__preview {
        display: none;
    }

    .h1 {
        font-size: 48px;
        line-height: 1.5;
    }

    .h2 {
        font-size: 40px;
        line-height: 1.5;
    }
}

@media only screen and (max-width: 1179px) {
    .page__row_responsive {
        display: block;
        margin: 0;
    }

    .page__row_responsive.page__row_head {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin: 0 -16px;
        padding: 40px 0;
    }

    .page__row_responsive.page__row_head .page__col {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 calc(50% - 32px);
        flex: 0 0 calc(50% - 32px);
        max-width: calc(50% - 32px);
        margin: 0 16px;
        padding: 0;
    }

    .page__row_responsive .page__col {
        padding-left: 0;
        padding-right: 0;
    }

    .page__row_responsive .page__col:first-child {
        max-width: 100%;
    }

    .page__row_responsive .page__col:nth-child(2) {
        max-width: 100%;
        border: none;
    }

    .page__row:not(.page__row_head) .page__col:nth-child(2) {
        margin-top: 32px;
    }

    .page .page__col.page__col_w50 {
        padding: 0;
    }

    .page .page__col.page__col_w50:first-child {
        max-width: 100%;
        margin-bottom: 30px;
    }

    .page .page__col.page__col_w50:nth-child(2) {
        max-width: 100%;
    }

    .page .page__col.page__col_w50:not(:last-child) {
        margin-bottom: 0;
    }

    .page__row:not(.page__row_head) .page__col.page__col_w50:not(:last-child) {
        margin-bottom: 32px;
    }

    .page__flex {
        display: block;
    }

    .page__flex .widget:first-child {
        width: 100%;
        margin: 0 0 32px;
    }

    .page__welcome_sm {
        font-size: 32px;
    }

    .page__nav {
        margin-bottom: 32px;
    }

    .page_other {
        overflow: hidden;
    }

    .page_other .page__center {
        padding-bottom: 40px;
    }

    .sidebar {
        padding-top: 96px;
        overflow: hidden;
        -webkit-transition: width 0.25s, -webkit-transform 0.25s;
        transition: width 0.25s, -webkit-transform 0.25s;
        -o-transition: width 0.25s, transform 0.25s;
        transition: width 0.25s, transform 0.25s;
        transition: width 0.25s, transform 0.25s, -webkit-transform 0.25s;
    }

    .sidebar__top {
        -webkit-box-pack: stretch;
        -ms-flex-pack: stretch;
        justify-content: stretch;
        height: 96px;
        padding-left: 40px;
        -webkit-transition: all 0.25s;
        -o-transition: all 0.25s;
        transition: all 0.25s;
    }

    .sidebar__top .sidebar__logo {
        -webkit-transition: opacity 0.2s;
        -o-transition: opacity 0.2s;
        transition: opacity 0.2s;
    }

    .sidebar__logo .sidebar__pic {
        width: 140px;
    }

    .sidebar__wrapper .sidebar__logo {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
    }

    .sidebar__group:not(:last-child):before {
        -webkit-transition: all 0.25s;
        -o-transition: all 0.25s;
        transition: all 0.25s;
    }

    .sidebar__caption {
        white-space: nowrap;
        -webkit-transition: padding 0.25s;
        -o-transition: padding 0.25s;
        transition: padding 0.25s;
    }

    .sidebar__item {
        position: relative;
        padding-left: 3px;
    }

    .sidebar__icon {
        width: 56px;
        height: 56px;
        margin-right: 0;
        -webkit-transition: margin 0.25s;
        -o-transition: margin 0.25s;
        transition: margin 0.25s;
    }

    .sidebar__counter {
        -webkit-transition: all 0.25s;
        -o-transition: all 0.25s;
        transition: all 0.25s;
    }

    .sidebar__user {
        -webkit-transition: all 0.25s;
        -o-transition: all 0.25s;
        transition: all 0.25s;
    }

    .sidebar__bottom {
        -webkit-transition: padding 0.25s;
        -o-transition: padding 0.25s;
        transition: padding 0.25s;
    }

    .sidebar__banner {
        display: none;
    }

    .sidebar.active {
        width: 96px;
    }

    .sidebar.active .sidebar__inner {
        width: 56px;
    }

    .sidebar.active .sidebar__burger {
        border-color: #e4e4e4;
    }

    .sidebar.active .sidebar__top .sidebar__logo {
        opacity: 0;
    }

    .sidebar.active .sidebar__caption {
        padding: 0;
        text-align: center;
    }

    .sidebar.active .sidebar__caption span {
        display: none;
    }

    .sidebar.active .sidebar__group:before {
        left: -20px;
        right: -20px;
    }

    .sidebar.active .sidebar__item {
        padding-left: 0;
    }

    .sidebar.active .sidebar__counter {
        position: absolute;
        top: 15px;
        left: 22px;
        min-width: 10px;
        height: 10px;
        font-size: 0;
    }

    .sidebar.active .sidebar__bottom {
        padding: 0 35px;
    }

    .sidebar.active .sidebar__bottom .switch_theme .switch__in {
        padding-left: 60px;
    }

    .banner__wrap {
        max-width: 300px;
    }

    .banner__title {
        margin-bottom: 6px;
        line-height: 1.2;
    }

    .banner__preview {
        top: 50%;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        width: 180px;
    }

    .sorting__line .sorting__search {
        margin-right: 30px;
    }

    .dropdown__body {
        right: 0;
        width: auto;
        padding: 24px 21px;
    }

    .products__cell {
        padding-left: 15px;
    }

    .products__preview {
        width: 86px;
        height: 64px;
    }

    .products__details {
        padding-left: 16px;
    }

    .products__bg {
        border-radius: 50%;
    }

    .products__color .products__text {
        display: none;
    }

    .tabs__preview {
        display: block;
    }

    .inbox__control {
        display: block;
    }

    .inbox__btns {
        margin: 0 -8px;
    }

    .inbox__btns .inbox__btn {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 calc(50% - 16px);
        flex: 0 0 calc(50% - 16px);
        min-width: calc(50% - 16px);
        margin: 0 8px;
    }

    .inbox__btns .inbox__btn:not(:last-child) {
        margin-right: 8px;
    }

    .inbox__more {
        display: none;
    }

    .inbox__box:not(:last-child) {
        margin-bottom: 32px;
        padding: 0;
        border: none;
    }

    .inbox__box .inbox__title {
        font-size: 18px;
    }

    .notification__details {
        padding: 0 24px;
    }

    .notification__preview {
        display: block;
    }

    .activity__row {
        display: block;
    }

    .activity__col:first-child {
        margin-bottom: 32px;
    }

    .activity__col:nth-child(2) {
        width: 100%;
        padding: 0;
    }

    .activity__details {
        padding: 0 24px;
    }

    .activity__preview {
        display: block;
    }

    .desktop-hide {
        display: none;
    }

    .desktop-show {
        display: block;
    }

    .desktop-text-right {
        text-align: right;
    }
}

@media only screen and (max-width: 1023px) {
    .page {
        overflow: hidden;
    }

    .page__wrapper {
        padding-left: 0;
    }

    .page__center {
        padding: 0 32px 40px;
    }

    .page__row_head {
        -webkit-box-orient: vertical;
        -webkit-box-direction: reverse;
        -ms-flex-direction: column-reverse;
        flex-direction: column-reverse;
        margin: 0;
        padding: 25px 0;
    }

    .page__row_head .page__col {
        max-width: 100%;
        margin: 0;
    }

    .page__row_head .page__col:nth-child(2) {
        margin-bottom: 30px;
    }

    .page__row_responsive.page__row_head {
        margin: 0;
        padding: 25px 0;
    }

    .page__row_responsive.page__row_head .page__col {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        margin: auto;
    }

    .page__row_responsive.page__row_head .page__col:nth-child(2) {
        margin-bottom: 30px;
    }

    .page__content {
        padding: 0;
    }

    .page.toggle .page__wrapper {
        -webkit-transform: translateX(160px);
        -ms-transform: translateX(160px);
        transform: translateX(160px);
    }

    .sidebar {
        transform: translateX(-100%);
    }

    .sidebar.show {
        transform: translateX(0);
    }

    .sidebar__burger {
        display: inline-block;
    }

    .sidebar__top {
        padding: 0;
    }

    .sidebar__top .sidebar__logo {
        opacity: 0;
    }

    .sidebar__wrapper .sidebar__logo {
        height: 80px;
    }

    .sidebar__burger {
        border-color: #e4e4e4;
    }

    .sidebar__group:not(:last-child):before {
        left: -20px;
        right: -20px;
    }

    .sidebar__caption {
        padding-left: 0;
        text-align: center;
    }

    .sidebar__caption span {
        display: none;
    }

    .sidebar__item {
        padding-left: 0;
    }

    .sidebar__item:hover {
        color: #808191;
    }

    .sidebar__icon {
        margin-right: 21px;
    }

    .sidebar__item:hover .icon {
        fill: #1b1d21;
        opacity: 0.4;
    }

    .sidebar__counter {
        position: absolute;
        top: 15px;
        left: 22px;
        min-width: 10px;
        height: 10px;
        font-size: 0;
    }

    .sidebar__profile {
        margin-top: 20px;
    }

    .sidebar__details {
        padding: 5px 0 17px;
        background: none;
    }

    .sidebar__link .sidebar__icon {
        width: 56px;
        margin-right: 24px;
        padding: 0;
    }

    .sidebar__bottom {
        padding: 0 35px;
    }

    .sidebar .switch_theme .switch__in {
        padding-left: 60px;
    }

    .sidebar.active {
        width: 256px;
    }

    .sidebar.active .sidebar__inner {
        width: 100%;
    }

    .sidebar.active .sidebar__burger {
        border-color: transparent;
    }

    .sidebar.active .sidebar__top {
        padding-left: 40px;
    }

    .sidebar.active .sidebar__top .sidebar__logo {
        opacity: 1;
    }

    .sidebar.active .sidebar__icon {
        margin-right: 0;
    }

    .sidebar.active .sidebar__caption {
        padding: 0 20px;
        text-align: left;
    }

    .sidebar.active .sidebar__caption span {
        display: inline;
    }

    .sidebar.active .sidebar__group:before {
        left: 20px;
        right: 20px;
    }

    .sidebar.active .sidebar__wrapper .sidebar__logo {
        height: 0;
    }

    .sidebar.active .sidebar__item {
        padding-left: 3px;
    }

    .sidebar.active .sidebar__counter {
        position: static;
        min-width: 24px;
        height: 24px;
        font-size: 12px;
    }

    .sidebar.active .sidebar__user {
        padding: 0 20px;
    }

    .sidebar.active .sidebar__bottom {
        padding: 0 40px;
    }

    .sidebar.active .sidebar__bottom .switch_theme .switch__in {
        padding-left: 56px;
    }

    body.dark .sidebar__burger {
        border-color: rgba(228, 228, 228, 0.1);
    }

    body.dark .sidebar.active .sidebar__burger {
        border-color: transparent;
    }

    .banner__container {
        padding: 50px 40px;
    }

    .products__preview {
        display: none;
    }

    .products__details {
        padding: 0;
    }

    .products__more {
        padding-top: 32px;
    }

    .schedules__task .schedules__text {
        padding: 0 10px;
    }

    .editor__close {
        top: 5px;
        right: 5px;
        visibility: visible;
        opacity: 1;
    }

    .tablet-hide {
        display: none;
    }

    .tablet-show {
        display: block;
    }

    .tablet-text-right {
        text-align: right;
    }

    .h3 {
        font-size: 32px;
        line-height: 1.5;
        letter-spacing: -0.5px;
    }
}

@media all and (max-width: 900px) {
    .mfp-arrow {
        -webkit-transform: scale(0.75);
        -ms-transform: scale(0.75);
        transform: scale(0.75);
    }

    .mfp-arrow-left {
        -webkit-transform-origin: 0;
        -ms-transform-origin: 0;
        transform-origin: 0;
    }

    .mfp-arrow-right {
        -webkit-transform-origin: 100%;
        -ms-transform-origin: 100%;
        transform-origin: 100%;
    }

    .mfp-container {
        padding-left: 6px;
        padding-right: 6px;
    }
}

@media (max-width: 900px) {
    .mfp-container {
        padding: 30px 20px;
    }
}

@media only screen and (max-width: 767px) {
    .page__wrapper {
        padding-left: 0;
    }

    .page__center {
        padding: 0 16px 32px;
    }

    .page__row_head {
        padding: 0;
    }

    .page__row_head .page__col:first-child {
        padding: 16px 16px 28px;
    }

    .page__row_head .page__col:nth-child(2) {
        margin: 0;
    }

    .page__row_responsive.page__row_head {
        padding: 0;
    }

    .page__row_responsive.page__row_head .page__col:nth-child(2) {
        margin-bottom: 0;
    }

    .page__widgets {
        display: block;
        margin: 0;
    }

    .page__widgets:not(:last-child) {
        margin-bottom: 32px;
    }

    .page__widgets .widget {
        width: 100%;
        margin: 0;
    }

    .page__widgets .widget:not(:last-child) {
        margin-bottom: 32px;
    }

    .page__group {
        display: block;
        margin: 0;
    }

    .page__group .widget {
        max-width: 100%;
        margin: 0;
    }

    .page__group .widget:not(:last-child) {
        margin-bottom: 32px;
    }

    .page__stat {
        padding: 32px 0;
    }

    .page__stat:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    .page__stat_sm .sorting {
        position: relative;
        top: auto;
        right: auto;
    }

    .page__hello {
        font-size: 16px;
    }

    .page__title {
        padding: 0 24px;
    }

    .page.toggle .page__wrapper {
        padding-left: 0;
        -webkit-transform: translateX(256px);
        -ms-transform: translateX(256px);
        transform: translateX(256px);
    }

    body.dark .page__stat:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    .sidebar__wrapper {
        padding: 20px;
    }

    .sidebar__inner {
        width: 100%;
    }

    .sidebar__top {
        padding-left: 40px;
        border-bottom: 1px solid #e4e4e4;
    }

    .sidebar__top .sidebar__logo {
        opacity: 1;
    }

    .sidebar__close {
        display: inline-block;
    }

    .sidebar__wrapper .sidebar__logo {
        display: none;
    }

    .sidebar__list {
        margin: 0;
    }

    .sidebar__group:not(:last-child) {
        margin-bottom: 20px;
        padding-bottom: 15px;
    }

    .sidebar__group:not(:last-child):before {
        left: 20px;
        right: 20px;
    }

    .sidebar__caption {
        padding-left: 20px;
        text-align: left;
    }

    .sidebar__caption span {
        display: inline;
    }

    .sidebar__item {
        padding-left: 3px;
    }

    .sidebar__icon {
        margin-right: 0;
    }

    .sidebar__counter {
        position: static;
        min-width: 24px;
        height: 24px;
        font-size: 12px;
    }

    .sidebar__bottom {
        padding: 0 40px;
    }

    .sidebar .switch_theme .switch__in {
        padding-left: 56px;
    }

    .sidebar.active {
        -webkit-transform: translateX(0);
        -ms-transform: translateX(0);
        transform: translateX(0);
    }

    .sidebar.active .sidebar__caption {
        padding-left: 15px;
    }

    .sidebar.active .sidebar__item {
        padding-left: 0;
    }

    body.dark .sidebar__top {
        border-color: rgba(228, 228, 228, 0.1);
    }

    .slider {
        margin-bottom: 48px;
    }

    .slider__item {
        -webkit-box-orient: vertical;
        -webkit-box-direction: reverse;
        -ms-flex-direction: column-reverse;
        flex-direction: column-reverse;
        padding: 0 32px 54px;
        text-align: center;
    }

    .slider__details {
        width: 100%;
        padding: 0;
    }

    .slider__preview {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        width: 282px;
        height: 282px;
        padding: 20px;
    }

    .slider__text {
        margin-bottom: 24px;
    }

    .slider .owl-dots {
        left: 0;
        right: 0;
        bottom: 24px;
    }

    .widget__chart_impressions {
        margin-left: -10px;
        margin-right: 10px;
    }

    .widget__chart_items {
        margin-bottom: 16px;
    }

    .widget_shadow:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    .widget_stat:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    body.dark .widget_shadow:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    body.dark .widget_stat:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    .header {
        height: 96px;
        max-width: calc(100% + 32px);
        margin: 0 -16px;
        padding: 0 32px;
        border-bottom: 1px solid #e4e4e4;
    }

    .header .search {
        -webkit-box-flex: 0;
        -ms-flex-positive: 0;
        flex-grow: 0;
        margin-left: 0;
        margin-right: 0;
    }

    .header .notifications {
        margin-right: 25px;
    }

    .header__user {
        display: block;
    }

    .header__burger {
        display: inline-block;
    }

    .header__search {
        display: inline-block;
    }

    body.dark .header {
        border-color: rgba(228, 228, 228, 0.1);
    }

    .search {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        z-index: 10;
        visibility: hidden;
    }

    .search.show {
        visibility: visible;
        opacity: 1;
    }

    .search__input {
        height: 56px;
        background: #e4e4e4;
        border-radius: 0;
    }

    .search__result {
        top: 0;
        left: 0;
        right: 0;
        -webkit-box-shadow: 0 30px 30px rgba(27, 29, 33, 0.3);
        box-shadow: 0 30px 30px rgba(27, 29, 33, 0.3);
    }

    .search.active .search__input {
        background: #e4e4e4;
    }

    body.dark .search__input {
        background: #1f2128;
    }

    body.dark .search__result {
        -webkit-box-shadow: 0 30px 30px rgba(0, 0, 0, 0.5);
        box-shadow: 0 30px 30px rgba(0, 0, 0, 0.5);
    }

    body.dark .search.active .search__input {
        background: #1f2128;
    }

    .notifications {
        position: static;
    }

    .notifications__open {
        width: 40px;
        height: 40px;
        -webkit-box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);
        box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);
    }

    .notifications__open .icon {
        font-size: 20px;
    }

    .notifications__counter {
        top: 5px;
        right: 5px;
        min-width: 12px;
        height: 12px;
        font-size: 0;
    }

    .notifications__wrap {
        top: calc(100% + 1px);
        right: 0;
        left: 0;
        width: auto;
        padding: 24px 16px;
        -webkit-box-shadow: 0 30px 30px rgba(27, 29, 33, 0.3);
        box-shadow: 0 30px 30px rgba(27, 29, 33, 0.3);
    }

    .notifications__info {
        margin-bottom: 16px;
        padding: 0;
    }

    .notifications__list {
        margin-bottom: 24px;
    }

    .notifications__item {
        padding: 0;
    }

    .notifications__item:hover {
        background: none;
    }

    .notifications__item:not(:last-child) {
        margin-bottom: 20px;
    }

    .notifications__ava {
        margin-right: 16px;
    }

    body.dark .notifications__open {
        -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
    }

    body.dark .notifications__wrap {
        -webkit-box-shadow: 0 30px 30px rgba(0, 0, 0, 0.5);
        box-shadow: 0 30px 30px rgba(0, 0, 0, 0.5);
    }

    .banner__container {
        padding: 10px 32px 32px;
        text-align: center;
    }

    .banner__wrap {
        max-width: 100%;
    }

    .banner__preview {
        position: static;
        -webkit-transform: translateY(0);
        -ms-transform: translateY(0);
        transform: translateY(0);
        width: 260px;
        height: 260px;
        padding: 30px;
        margin: 0 auto;
        text-align: center;
    }

    .sorting__dropdowns {
        display: flex;
        margin: 0;
        align-items: baseline;
    }

    .sorting__dropdowns .dropdown {
        width: 100%;
        margin: 0;
    }

    .sorting__dropdowns .dropdown:not(:last-child) {
        margin-bottom: 16px;
    }

    .sorting__line {
        display: block;
    }

    .sorting__line .sorting__search {
        margin: 0 0 16px;
    }

    .sorting__actions {
        -webkit-box-pack: end;
        -ms-flex-pack: end;
        justify-content: flex-end;
    }

    .products__table {
        display: block;
        margin-top: -72px;
    }

    .products__row {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 24px;
    }

    .products__row:not(.products__row_head) {
        border-top: 1px solid #e4e4e4;
    }

    .products__row_head .products__cell {
        padding: 0;
    }

    .products__cell {
        display: block;
        padding: 0;
        border: none;
    }

    .products__cell:first-child {
        margin-right: 24px;
    }

    .products__cell:nth-child(n + 3) {
        display: none;
    }

    .products__preview {
        display: block;
        width: 72px;
        height: 55px;
    }

    .products__details {
        padding-left: 24px;
    }

    .products__bg {
        width: 9px;
        height: 32px;
        margin-right: 31px;
        border-radius: 9px;
    }

    .products__more {
        border-top: 1px solid #e4e4e4;
        padding: 24px 24px 0;
    }

    .products__more .products__btn {
        min-width: 100%;
    }

    .products__body {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
    }

    .products_statement .products__cell {
        display: block;
    }

    .products_statement .products__cell:not(:first-child):not(:nth-child(3)) {
        display: none;
    }

    body.dark .products__row:not(.products__row_head) {
        border-color: rgba(228, 228, 228, 0.1);
    }

    body.dark .products__more {
        border-color: rgba(228, 228, 228, 0.1);
    }

    .details__container {
        padding-bottom: 32px;
    }

    .details__container:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    .details__title {
        margin-bottom: 24px;
    }

    .details__row {
        display: block;
    }

    .details__col:first-child {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: end;
        -ms-flex-align: end;
        align-items: flex-end;
        width: auto;
        margin: 0 -5px 32px;
        padding: 0;
    }

    .details__top {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 calc(50% - 10px);
        flex: 0 0 calc(50% - 10px);
        margin: 0 5px;
        padding: 0;
        border: none;
    }

    .details__bottom {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 calc(50% - 10px);
        flex: 0 0 calc(50% - 10px);
        margin: 0 5px;
    }

    .details__statistics {
        margin-bottom: 32px;
    }

    .details__list {
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }

    .details__item:not(:last-child) {
        border-right: none;
    }

    .details__list_three .details__item {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        width: 100%;
    }

    .details__list_three .details__item:not(:first-child) {
        border-top: 1px solid #e4e4e4;
    }

    .details__list_four .details__item {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        width: 50%;
    }

    .details__list_four .details__item:nth-child(2n + 1) {
        border-right: 1px solid #e4e4e4;
    }

    .details__list_four .details__item:nth-child(n + 3) {
        border-top: 1px solid #e4e4e4;
    }

    .details .dropdown {
        position: relative;
        top: auto;
        right: auto;
        width: 100%;
        margin-bottom: 20px;
    }

    .details_statements:not(:last-child) {
        margin-bottom: 32px;
    }

    .details_statements .details__col:first-child {
        width: auto;
        padding: 0;
    }

    body.dark .details__container:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    body.dark .details__list_four .details__item:nth-child(n + 3) {
        border-color: rgba(228, 228, 228, 0.1);
    }

    body.dark .details__list_three .details__item:not(:first-child) {
        border-color: rgba(228, 228, 228, 0.1);
    }

    .schedules__container:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    .schedules__list {
        display: block;
        margin: 0 -16px;
    }

    .schedules__item {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        width: 100%;
        margin: 0;
    }

    .schedules__item:not(:last-child) {
        margin-bottom: 24px;
    }

    .schedules__top {
        margin: -16px 0 20px;
    }

    .schedules__arrows {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
    }

    .schedules__inner {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin: 0 -32px;
        padding-bottom: 32px;
        overflow: auto;
        overflow-x: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
        -webkit-overflow-scrolling: touch;
    }

    .schedules__inner::-webkit-scrollbar {
        display: none;
    }

    .schedules__inner:before,
    .schedules__inner:after {
        content: '';
        display: inline-block;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        width: 32px;
        height: 1px;
    }

    .schedules__graphic {
        min-width: 586px;
        margin-bottom: 7px;
    }

    .schedules__legend {
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        margin-top: -10px;
        padding: 0;
    }

    .schedules__status {
        margin-top: 10px;
    }

    .schedules__status:not(:last-child) {
        margin-right: 15px;
    }

    body.dark .schedules__container:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    .tabs__row {
        display: block;
        margin: -20px -16px;
    }

    .tabs__col:first-child {
        width: 100%;
    }

    .tabs__col:nth-child(2) {
        display: none;
    }

    .tabs__nav {
        display: none;
    }

    .payment__row {
        display: block;
    }

    .payment__details {
        width: 100%;
        margin: 0 0 32px;
    }

    .payment__tick {
        margin-right: 24px;
    }

    .inbox__tags {
        margin: -10px 0 24px -10px;
    }

    .inbox__tag {
        margin: 10px 0 0 10px;
    }

    .inbox__container {
        padding: 32px 24px;
    }

    .inbox__container:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    .inbox__container>.inbox__title {
        margin: 0;
    }

    .inbox__list {
        margin: 0;
    }

    .inbox__item {
        padding: 24px 0;
        border-radius: 0;
        border-bottom: 1px solid #e4e4e4;
    }

    .inbox__head {
        height: 48px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .inbox__item .inbox__title {
        margin-left: -64px;
    }

    .inbox__text {
        margin-left: -64px;
    }

    .inbox__item:hover {
        background: none;
    }

    .inbox__item.active {
        background: none;
        color: #808191;
    }

    .inbox__item.active .actions__btn {
        border-color: #e4e4e4;
    }

    .inbox__item.active .actions__btn .icon {
        fill: #1b1d21;
    }

    .inbox__item.active .inbox__title {
        color: #11142d;
    }

    .inbox__item.active .inbox__author {
        color: #808191;
    }

    .inbox .actions {
        margin-left: -64px;
    }

    .inbox__foot {
        padding-top: 24px;
    }

    .inbox__box:not(:last-child) {
        margin-bottom: 24px;
    }

    .inbox__box .inbox__title {
        margin: 0 0 24px -64px;
    }

    .inbox .files {
        margin: 16px 0 0 -64px;
    }

    .inbox .sorting {
        padding: 0;
    }

    body.dark .inbox__container:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    body.dark .inbox__item {
        border-color: rgba(228, 228, 228, 0.1);
    }

    body.dark .inbox__item:hover {
        background: none;
    }

    body.dark .inbox__item.active {
        background: none;
    }

    body.dark .inbox__author {
        color: #ffffff;
    }

    body.dark .inbox__item.active .actions__btn {
        border-color: rgba(228, 228, 228, 0.1);
    }

    body.dark .inbox__item.active .actions__btn .icon {
        fill: #ffffff;
    }

    .editor__head {
        padding: 24px 16px;
    }

    .editor__body {
        padding: 24px 16px;
    }

    .editor__btn {
        min-width: 100%;
        margin-top: 16px;
    }

    .notification__tags {
        margin: -10px 0 24px -10px;
    }

    .notification__tag {
        margin: 10px 0 0 10px;
    }

    .notification__container {
        padding: 32px 24px;
    }

    .notification__container:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    .notification__title {
        margin-bottom: 16px;
    }

    .notification__list {
        margin: 0;
    }

    .notification__item {
        padding: 24px 0;
        border-radius: 0;
        border-bottom: 1px solid #e4e4e4;
    }

    .notification__details {
        padding: 0 0 0 16px;
    }

    .notification .actions {
        margin-left: -64px;
    }

    .notification__item:hover {
        background: none;
    }

    .notification__item.active {
        background: none;
        color: #808191;
    }

    .notification__item.active .actions__btn {
        border-color: #e4e4e4;
    }

    .notification__item.active .actions__btn .icon {
        fill: #1b1d21;
    }

    .notification__item.active .notification__title {
        color: #11142d;
    }

    .notification__item.active .notification__author {
        color: var(--main-color);
    }

    .notification__item.active .notification__info {
        color: #808191;
    }

    .notification__preview {
        display: none;
    }

    body.dark .notification__container:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    body.dark .notification__item {
        border-color: rgba(228, 228, 228, 0.1);
    }

    body.dark .notification__item:hover {
        background: none;
    }

    body.dark .notification__item.active {
        background: none;
    }

    body.dark .notification__item.active .actions__btn {
        border-color: rgba(228, 228, 228, 0.1);
    }

    body.dark .notification__item.active .actions__btn .icon {
        fill: #ffffff;
    }

    .filters__container:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    body.dark .filters__container:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    .activity__col:nth-child(2) {
        padding: 0 16px;
    }

    .activity__container {
        padding: 32px 24px;
    }

    .activity__container:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    .activity__title {
        margin-bottom: 16px;
    }

    .activity__list {
        margin: 0;
    }

    .activity__item {
        padding: 24px 0;
        border-radius: 0;
        border-bottom: 1px solid #e4e4e4;
    }

    .activity__item:before {
        display: none;
    }

    .activity__item.active {
        color: #808191;
    }

    .activity__details {
        padding: 0 0 0 16px;
    }

    .activity__item.active .activity__author {
        color: #11142d;
    }

    .activity__item.active .activity__info {
        color: var(--main-color);
    }

    .activity__preview {
        display: none;
    }

    .activity:not(:first-child) {
        margin-top: 32px;
    }

    body.dark .activity__container:before {
        -webkit-filter: blur(46.985px);
        filter: blur(46.985px);
    }

    body.dark .activity__item {
        border-color: rgba(228, 228, 228, 0.1);
    }

    body.dark .activity__item:hover {
        background: none;
    }

    .popup__title {
        margin-bottom: 42px;
    }

    .popup__tags {
        display: none;
    }

    .popup__user:not(:last-child) {
        padding-bottom: 24px;
    }

    .popup__ava {
        width: 80px;
        height: 80px;
    }

    .popup__details {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 calc(100% - 80px);
        flex: 0 0 calc(100% - 80px);
        width: calc(100% - 80px);
        padding-left: 24px;
    }

    .popup__btns {
        display: block;
        margin: 0 0 32px;
    }

    .popup__btns .popup__btn {
        min-width: 100%;
    }

    .popup__btns .popup__btn.btn_gray {
        background: #ffffff;
    }

    .popup__btns .popup__btn:not(:last-child),
    .popup__loading:not(:last-child) {
        margin: 0;
    }

    .popup__text {
        margin-left: -104px;
    }

    .popup__row {
        display: block;
        margin: 0;
    }

    .popup__row .popup__field {
        width: 100%;
        margin: 0;
    }

    .popup__row .popup__field:not(:last-child) {
        margin-bottom: 24px;
    }

    .popup__form>.popup__btn {
        min-width: 100%;
    }

    .popup .mfp-close {
        right: 20px;
        -webkit-box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);
        box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);
    }

    .mfp-container {
        padding: 0;
    }

    body.dark .popup .mfp-close {
        -webkit-box-shadow: 0 5px 20px rgba(0, 0, 0, 0.35);
        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.35);
    }

    .mobile-hide {
        display: none;
    }

    .mobile-show {
        display: block;
    }

    .mobile-text-right {
        text-align: right;
    }

    .h1 {
        font-size: 40px;
        line-height: 1.5;
    }

    .h2 {
        font-size: 32px;
        line-height: 1.5;
        letter-spacing: -0.5px;
    }
}

/*# sourceMappingURL=app.css.map */`, "",{"version":3,"sources":["webpack://./public/unity/css/helpers/_reset.sass","webpack://./public/unity/css/unity.css","webpack://./public/unity/css/generated/_sprite-svg.scss","webpack://./public/unity/css/lib/owl.carousel.css","webpack://./public/unity/css/app.css","webpack://./public/unity/css/lib/magnific-popup.css","webpack://./public/unity/css/_common.sass","webpack://./public/unity/css/_variables.sass","webpack://./public/unity/css/helpers/_mixins.sass","webpack://./public/unity/css/components/_page.sass","webpack://./public/unity/css/components/_sidebar.sass","webpack://./public/unity/css/components/_switch.sass","webpack://./public/unity/css/components/_slider.sass","webpack://./public/unity/css/components/_btn.sass","webpack://./public/unity/css/components/_widget.sass","webpack://./public/unity/css/components/_header.sass","webpack://./public/unity/css/components/_search.sass","webpack://./public/unity/css/components/_notifications.sass","webpack://./public/unity/css/components/_banner.sass","webpack://./public/unity/css/components/_sorting.sass","webpack://./public/unity/css/components/_dropdown.sass","webpack://./public/unity/css/components/_products.sass","webpack://./public/unity/css/components/_checkbox.sass","webpack://./public/unity/css/components/_radio.sass","webpack://./public/unity/css/components/_details.sass","webpack://./public/unity/css/components/_quality.sass","webpack://./public/unity/css/components/_goal.sass","webpack://./public/unity/css/components/_schedules.sass","webpack://./public/unity/css/components/_tabs.sass","webpack://./public/unity/css/components/_payment.sass","webpack://./public/unity/css/components/_inbox.sass","webpack://./public/unity/css/components/_actions.sass","webpack://./public/unity/css/components/_files.sass","webpack://./public/unity/css/components/_editor.sass","webpack://./public/unity/css/components/_notification.sass","webpack://./public/unity/css/components/_filters.sass","webpack://./public/unity/css/components/_activity.sass","webpack://./public/unity/css/components/_field.sass","webpack://./public/unity/css/components/_popup.sass","webpack://./public/unity/css/_modificators.sass"],"names":[],"mappings":"AAAA;ICCI,qBAAqB;IACrB,0BAA0B;IAC1B,6CAA6C;IAC7C,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;ID+CI,SAAA;IAAwB,UAAA;ICoCxB,SAAS;IDnCb,wBAAA;ACqCA;;AAEA;IACI,0BAA0B;IChG9B,8BAAA;ADkGA;;AAEA;;;IC/FA,YAAA;ADmGA;;AAEA;;;;IC/FE,wBAAY;ADoGd;;AAEA;;IClGA,eAAA;IACE,gBAAY;ADqGd;;AAEA;;ICnGA,UAAA;IACE,SAAA;ADsGF;;AAEA;IACI,cAAc;ACrGlB;;ADwGA;ICrGE,wBAAa;IACd,qBAAA;IDuGG,gBAAgB;ACtGpB;;ADyGA;;ICrGC,SAAA;IDwGG,UAAU;ICvGd,SAAA;ADyGA;;AAEA;;;;;;;;;;;;;;IAcI,aAAa;AC1GjB;;AD6GA;IC1GE,kBAAa;IACd,uBAAA;AD4GD;;AAEA;;IC1GE,qBAAa;AD6Gf;;AC3GA;IACE,iBAAU;IACV,yBAAW;IACX,WAAA;AD8GF;;AC5GA;IACE,8BAAU;IACV,sBAAW;AD+Gb;;AAEA;;;IC5GE,2BAAW;IACX,mBAAa;ADgHf;;AC9GA;IACE,qBAAU;ADiHZ;;AAEA;;IC/GA,6CAAA;ADkHA;;AAEA;IChHC,aAAA;IDkHG,WAAW;ICjHf,UAAA;ADmHA;;AAEA;ICjHC,YAAA;IDmHG,WAAW;IClHf,aAAA;ADoHA;;AAEA;IClHC,YAAA;IDoHG,WAAW;ICnHf,aAAA;ADqHA;;AAEA;ICnHC,YAAA;IDqHG,WAAW;ICpHf,aAAA;ADsHA;;AAEA;ICpHC,YAAA;IDsHG,WAAW;ICrHf,aAAA;ADuHA;;AAEA;ICrHC,YAAA;IDuHG,WAAW;ICtHf,aAAA;ADwHA;;AAEA;ICtHC,aAAA;IDwHG,WAAW;ICvHf,UAAA;ADyHA;;AAEA;ICvHC,aAAA;IDyHG,WAAW;ICxHf,aAAA;AD0HA;;AAEA;ICxHC,aAAA;ID0HG,WAAW;ICzHf,aAAA;AD2HA;;AAEA;ICzHC,aAAA;ID2HG,WAAW;IC1Hf,aAAA;AD4HA;;AAEA;IC1HC,aAAA;ID4HG,WAAW;IC3Hf,aAAA;AD6HA;;AAEA;IC3HC,UAAA;ID6HG,WAAW;IC5Hf,aAAA;AD8HA;;AAEA;IC5HC,UAAA;ID8HG,WAAW;IC7Hf,aAAA;AD+HA;;AAEA;IC7HC,UAAA;ID+HG,WAAW;IC9Hf,aAAA;ADgIA;;AAEA;IC9HC,UAAA;IDgIG,WAAW;IC/Hf,aAAA;ADiIA;;AAEA;IC/HC,UAAA;IDiIG,WAAW;IChIf,aAAA;ADkIA;;AAEA;IChIC,aAAA;IDkIG,WAAW;ICjIf,aAAA;ADmIA;;AAEA;ICjIC,UAAA;IDmIG,WAAW;IClIf,aAAA;ADoIA;;AAEA;IClIC,aAAA;IDoIG,WAAW;ICnIf,aAAA;ADqIA;;AAEA;ICnIC,aAAA;IDqIG,WAAW;ICpIf,aAAA;ADsIA;;AAEA;ICpIC,UAAA;IDsIG,WAAW;ICrIf,aAAA;ADuIA;;AAEA;ICrIC,aAAA;IDuIG,WAAW;ICtIf,UAAA;ADwIA;;AAEA;ICtIC,YAAA;IDwIG,WAAW;ICvIf,aAAA;ADyIA;;AAEA;ICvIC,aAAA;IDyIG,WAAW;ICxIf,aAAA;AD0IA;;AAEA;ICxIC,UAAA;ID0IG,WAAW;ICzIf,aAAA;AD2IA;;AAEA;ICzIC,aAAA;ID2IG,WAAW;IE5Vf,aAAA;AF8VA;;AAEA;IE5VG,UAAA;IACH,WAAA;IF8VI,UAAU;AACd;;AAEA;IE5VE,UAAW;IACX,WAAA;IACA,aAAA;AF8VF;;AAEA;IACI,aAAa;IE9Vf,WAAA;IACE,aAAA;AFgWJ;;AAEA;IE9VI,UAAA;IAAoC,WAAA;IFiWpC,aAAa;AEhWf;;AFmWF;IEhWI,UAAW;IACX,WAAA;IACA,aAAc;AFkWlB;;AAEA;IElWE,aAAA;IACE,WAAA;IACA,aAAA;AFoWJ;;AAEA;IACI,aAAa;IEpWf,WAAA;IFsWE,UAAU;AACd;;AAEA;IEpWI,UAAA;IACA,WAAA;IACA,UAAA;AFsWJ;;AErWE;IACE,UAAA;IACA,WAAA;IACA,aAAW;AFwWf;;AAEA;IEvWkC,aAAA;IFyW9B,WAAW;IExWb,aAAA;AF0WF;;AAEA;IACI,UAAU;IE1WZ,WAAA;IF4WE,aAAa;AACjB;;AAEA;IE5WE,UAAA;IF8WE,WAAW;IACX,aAAa;AACjB;;AAEA;IE3WI,aAAA;IACA,WAAA;IAAoB,aAAA;AF8WxB;;AAEA;IACI,UAAU;IE7WV,WAAA;IACA,aAAc;AF+WlB;;AAEA;IE9WoB,UAAA;IFgXhB,WAAW;IE/Wb,aAAA;AFiXF;;AAEA;IEjXE,YAAA;IACE,WAAU;IACV,aAAc;AFmXlB;;AElXE;;;;CAEA;AFuXF;;CAEC;AEvXC;IACE,aAAA;IACI,WAAA;IACJ,wCAAyB;IACzB,mEAAsB;IACtB,kBAAA;IACA,UAAA;AFyXJ;;AExXE;IACE,kBAAY;IACZ,uBAAY;IAAZ,0BAAY;IAAG,gCAAA;IF6Xf,iCAAiC;AE5XnC;;AF+XF;IACI,YAAY;IE9Xd,cAAA;IACE,WAAY;IAAG,kBAAA;IFiYf,cAAc;IE/XlB,SAAW;AACX;;AFkYA;IACI,kBAAkB;IEhYtB,gBAAA;IFkYI,gCAAgC;IEhYjC,6CAAA;AACH;;AFmYA;;IEjYE,mCAAyB;IAAG,gCAAA;IFqY1B,+BAA+B;IEnYnC,uCAAA;IACE,oCAAU;IAAG,mCAAA;AFsYf;;AAEA;IErYe,kBAAA;IFuYX,eAAe;IErYnB,WAAA;IACE,mCAAuB;IAAvB,wCAAuB;IAAG,2BAAA;AFyY5B;;AAEA;IEvYI,cAAU;ICkYX,WAAA;AHQH;;AAEA;;IAEI,aAAa;AEhZjB;;AFmZA;;;IE/YI,eAAU;ICmYX,yBAAA;IACF,sBAAA;IHiBG,qBAAqB;IEnZzB,iBAAA;AFqZA;;AElZA;;;IACE,gBAAA;IAAuC,cAAA;IFwZrC,YAAY;IEtZhB,qBAAA;IFwZI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IExZZ,cAAA;AF0ZF;;AAEA;IE1ZI,UAAA;AF4ZJ;;AE3ZE;IACE,kBAAa;AF8ZjB;;AE7ZE;IACE,uBAAA;IAAA,mBAAA;IAA+B,yBAAA;IFka/B,sBAAsB;IEha1B,qBAAA;IFkaI,iBAAiB;AACrB;;AAEA;IEhaE,YAAY;IACZ,oBAAgB;IAAG,YAAA;AFmarB;;AAEA;IEjaE,cAAY;AFmad;;AAEA;IEjaE,YAAA;AFmaF;;AAEA,UElaE;AFmaF;IEjaE,cAAA;AFmaF;;AAEA;;CAEC;AACD;IACI,kCAAkC;IEtatC,0BAAA;IACE,iCAA8B;IAC1B,yBAAA;AFwaN;;AAEA;IExaA,UAAA;AF0aA;;AAEA;IACI,UAAU;AEzad;;AF4aA;IEzaE,+BAAA;IACA,uBAAA;AF2aF;;AAEA;IE3aE;QAAiC,UAAA;IF8a/B;;IE3aF;QACA,UAAU;IACV;AF8aF;;AAEA;IIxmBA;QACA,UAAA;IACE;;IAEA;QACA,UAAY;IACZ;AJ0mBF;;AAEA;;CIxmBiB;AJ2mBjB;IIzmBA,4CAAA;IACE,uCAAM;IACN,oCAAO;AJ2mBT;;AAEA;;CAEC;AACD;II1mBwC;;;IAGtC;AJ4mBF;;AAEA;II1mBE,UAAO;IACP,sCAAM;IACN,iCAAc;IACd,8BAAsB;AJ4mBxB;;AAEA;;II3mBE,aAAW;AJ8mBb;;AAEA;II7mB2B,oCAAA;IJ+mBvB,4BAA4B;AI7mBhC;;AJgnBA;;CI7mBA;AJgnBA;II9mBE,kBAAA;IACA,YAAA;IACA,gBAAc;AJgnBhB;;AAEA;IACI,kBAAkB;II/mBtB,YAAA;IJinBI,WAAW;II/mBb,SAAA;IACA,QAAA;IAAe,kBAAA;IJknBb,iBAAiB;IIhnBrB,qDAAA;IACE,eAAgB;IAAG,UAAA;IJmnBjB,mCAAmC;IIjnBvC,gDAAA;IAEE,wCAAwB;IACxB,mCAAgB;IAAG,gCAAA;IJmnBjB,8DAA8D;AIjnBlE;;AJonBA;IIhnBE,8BAAe;IAAG,kCAAA;IJmnBhB,0BAA0B;AIjnB9B;;AJonBA;;IIjnBA,aAAA;AJonBA;;AAEA;IIlnBE,UAAA;IACA,YAAA;IACA,kCAAiB;IAAjB,4BAAiB;IAAG,wBAAA;IJsnBlB,sCAAsC;IIpnB1C,iCAAA;IACE,8BAAa;AJsnBf;;AIpnBA;IACE,kBAAA;IAA2B,UAAA;IJwnBzB,YAAY;IItnBhB,WAAA;AJwnBA;;AAEA,uBIvnBU;AJwnBV;IItnBE,MAAA;IACA,OAAA;IACA,WAAS;IACT,YAAU;IACV,aAAa;IAAG,gBAAA;IJynBd,eAAe;IIxnBjB,mBAAA;IACE,YAAW;AJ0nBf;;AIznBI;IACE,MAAA;IAAc,OAAA;IJ6nBhB,WAAW;II3nBf,YAAA;IACE,aAAa;IAAG,eAAA;IJ8nBd,wBAAwB;II5nB5B,mCAAA;AJ8nBA;;AAEA;II7nBA,kBAAA;IJ+nBI,kBAAkB;II7nBpB,WAAA;IACA,YAAA;IACA,OAAA;IACA,MAAA;IACA,cAAA;IACA,8BAAc;IACd,sBAAa;AJ+nBf;;AAEA;II9nBE,WAAA;IACA,qBAAA;IAAA,YAAA;IAA6B,sBAAA;AJkoB/B;;AAEA;IIhoBE,aAAS;AJkoBX;;AIhoBA;IACE,kBAAW;IACX,qBAAY;IACZ,sBAAiB;IACjB,cAAA;IACA,gBAAQ;IACR,aAAM;AJmoBR;;AAEA;;IIhoBE,WAAW;IACX,YAAA;AJmoBF;;AAEA;IACI,gBAAgB;AInoBlB;;AJsoBF;;IAEI,wBAAwB;IIroB1B,gBAAA;AJuoBF;;AAEA;IItoBA,eAAA;IACE,uBAAW;IAAG,eAAA;AJyoBhB;;AAEA;IIvoBE,YAAW;AJyoBb;;AAEA;;;;IIroBA,yBAAA;IACE,sBAAkB;IAClB,qBAAM;IACN,iBAAQ;AJ0oBV;;AAEA;IIxoBE,aAAA;AJ0oBF;;AIxoBA;IACE,wBAAkB;AJ2oBpB;;AAEA;IIzoBE,WAAA;IACA,kBAAU;IACV,QAAA;IACA,WAAA;IACA,kBAAA;IAA2C,kBAAA;IJ4oBzC,SAAS;II3oBX,UAAA;IACE,aAAA;AJ6oBJ;;AI5oBE;IJ+oBE,WAAW;AACf;;AAEA;II/oBE,WAAA;AJipBF;;AAEA;II/oBI,aAAQ;AJipBZ;;AAEA;II/oBI,aAAM;AJipBV;;AAEA;;IAEI,iBAAiB;IIjpBnB,eAAA;IACE,uBAAsB;IACtB,SAAA;IACA,wBAAQ;IAAG,cAAA;IJopBX,aAAa;IInpBf,UAAA;IACE,aAAA;IACA,wBAAyB;IACzB,gBAAY;IAAG,8BAAA;IJspBf,0BAA0B;AIppB9B;;AJupBA;IACI,UAAU;IItpBZ,SAAA;AJwpBF;;AAEA;IACI,WAAW;IIxpBb,YAAA;IACE,iBAAiB;IACjB,kBAAA;IAAmC,QAAA;IJ2pBnC,MAAM;IIzpBV,qBAAA;IACE,kBAAQ;IAAG,aAAA;IJ4pBT,sBAAsB;II3pBxB,WAAA;IACE,kBAAA;IACA,eAAA;IAAoB,0CAAA;AJ8pBxB;;AAEA;;IAEI,UAAU;AI9pBd;;AJiqBA;II/pByB,QAAA;AJiqBzB;;AAEA;IIhqBI,WAAW;AJkqBf;;AAEA;;IIjqBI,WAAU;IAAG,WAAA;IJqqBb,iBAAiB;IInqBrB,kBAAA;IACE,WAAW;AJqqBb;;AAEA;IIpqBwB,kBAAA;IJsqBpB,MAAM;IIrqBR,QAAA;IACE,WAAA;IACA,eAAc;IACd,iBAAM;IACN,mBAAO;AJuqBX;;AAEA;IItqBI,kBAAA;IACA,aAAA;IAAmB,SAAA;IJyqBnB,QAAQ;IIvqBZ,iBAAA;IACA,UAAA;IACE,WAAW;IACX,aAAA;IACA,wCAAY;AJyqBd;;AAEA;IIxqBE,iBAAA;AJ0qBF;;AAEA;;IIxqBA,UAAA;AACA;;AJ4qBA;;II1qBE,WAAA;IACE,cAAW;IACX,QAAA;IACA,SAAO;IACP,kBAAS;IACT,OAAA;IACA,MAAA;IACA,gBAAQ;IACR,iBAAW;IACX,gCAAY;AJ6qBhB;;AAEA;II5qBI,sBAAgB;IAAG,yBAAA;IJ+qBnB,QAAQ;AI9qBV;;AJirBF;II9qBI,sBAAe;IACf,yBAAiB;IAAG,YAAA;AJirBxB;;AAEA;IIjrBgB,OAAA;AJmrBhB;;AAEA;IIjrBE,6BAAkB;IAClB,iBAAS;AJmrBX;;AAEA;IIlrBiB,iBAAA;IJorBb,gCAAgC;AIlrBpC;;AJqrBA;IIlrBE,QAAA;AJorBF;;AAEA;IACI,4BAA4B;IInrBhC,iBAAA;AJqrBA;;AAEA;IIprBA,+BAAA;AJsrBA;;AAEA;IKh+BA,iBAAA;IACC,oBAAgB;ALk+BjB;;AAEA;IKh+BC,cAAA;IACA,WAAA;IACA,gBC0Ba;ANw8Bd;;AKz+BA;IASE,UAAA;ALo+BF;;AAEA;IK/+BA,WAAA;IAYE,SAAA;IAAmB,gBAAA;ILu+BjB,mBAAmB;AKr+BvB;;ALw+BA;IACI,kBAAkB;IM99BpB,cAAA;IDPa,MAAA;ILw+BX,OAAO;IKt+BX,WAAA;IACC,YAAA;IACA,8CAAe;IAAG,sCAAA;ILy+Bf,gBAAgB;AO5uBlB;;AP+uBF,wBKx+BiB;ALy+BjB;IOhvBE,WAAA;IFtPA,eAAA;IAAuB,YAAA;IL0+BrB,cAAc;IQvgClB,cAAA;IACC,8BAAa;IAAb,sBAAa;IAAb,oBAAa;IACb,cAAA;AR2gCD;;AAEA,gCQ7gCuB;AR8gCvB;IQntB8B,cAAA;ARqtB9B;;AAEA;IQ7gCE,WAAA;IAAA,kBAAY;IACZ,OAAA;IACA,SAAA;IAAA,YAAA;IAAA,cAAA;IAIqB,QAAA;IR+gCnB,WAAW;IQ9gCd,YAAA;IACC,WAAA;IACA,8CAAc;IAQY,sCAAA;IRygCxB,gBAAgB;AQxgCnB;;AR2gCD;IQ1gCE,cAAa;IAgGc,cAAA;IR66BzB,eAAe;IQ1gChB,iBAAA;AR4gCH;;AAEA;IQl/BG,SAAA;ARo/BH;;AAEA;IQp7BC,iBAAA;IACC,kBAAA;IAmBoB,SAAA;IRo6BlB,OAAO;IQx7BT,WAAA;IAOC,YAAA;ARo7BH;;AAEA;IQh7BwB,gBAAA;IRk7BpB,iBAAiB;IQ/7BnB,cAAA;IAeC,qBAAc;IAAd,mBAAc;ARo7BjB;;AAEA;IQhkCA,eAAA;ARkkCA;;AAEA;IQ16BE,eAAc;AR46BhB;;AQr5BC;IACC,gBAAA;IAAA,gCAAa;IAAb,eAAa;IACb,oBAAe;IAOa,mCAAA;IRo5B1B,kCAAkC;IO5kCpC,cAAA;AP8kCF;;AAEA;IQv5BC,mBAAA;IACC,cAAA;ARy5BF;;AAEA;IQz5BE,gBAAc;AR25BhB;;AOvlCE;;;;ICwND,gCAAA;ARs4BD;;AAEA;IQh4BE,cAAA;IACC,eAAA;ARk4BH;;AAEA;IQ93BC,cAAA;ARg4BD;;AAEA;IQ93BE,gCF/MU;AN+kCZ;;AQp4BE;IAQC,oBAAW;IACX,oBAAkB;IAClB,aAAS;IACT,4BAAU;IACV,6BAAW;IACX,0BAAa;IACb,sBAAW;IFjMZ,iBAAA;ANkkCF;;AAEA;IMjkCE,mBAAmB;IE+LA,oBAAA;IRq4BjB,6BAA6B;IQp4B/B,wBAAA;IACC,qBAAiB;IAAG,mBAAA;ARu4BvB;;AAEA;IQr4BI,iBAAS;IACT,cAAW;ARu4Bf;;AQl4BC;IACC,oBAAa;IAAb,oBAAa;IAAb,aAAa;ARu4Bf;;AQx4BE;IAME,iBAAA;ARs4BJ;;AAEA;IQn4B0B,8BAAA;ARq4B1B;;AAEA;IQr4BI,oBAAY;ARu4BhB;;AAEA;IQ/3BC,mBAAA;IACC,gCAAmB;IAEE,4BAAA;IRg4BnB,6BAA6B;AQ/3BhC;;ARk4BD;IQj4BE,oBAAa;IACb,cAAA;IAEyB,YAAA;ARk4B3B;;AAEA;IQj4BE,mBAAmB;IACnB,iBAAgB;IAChB,aFtQiB;IEuQjB,cAAA;ARm4BF;;AAEA;IACI,oBAAoB;IQ34BtB,oBAAA;IAQC,aAAA;IACA,eF/QS;ANqpCZ;;AOh6BE;IC+CC,mBAAA;ARq3BH;;AOp6BE;ICiDC,mBFnRW;IEqRe,8BAAA;IRs3BzB,0BAA0B;IOz6B5B,uBAAA;IDrNA,cAAA;ANioCF;;AAEA;IMhoCE,mBAAmB;ANkoCrB;;AOh7BE;ICqDC,oBAAA;AR+3BH;;ASvsCA;IACC,iBAAe;IACf,6BAAM;AT0sCP;;AAEA;ISzsCC,kBAAY;IACZ,uBAAa;IACb,mBAAA;IACA,mBHsBW;ANqrCZ;;AAEA;ISjsCC,WAAA;IACC,kBAAgB;IAChB,SAAA;IACA,UAAA;IACA,WAAA;IACA,aAAA;IACA,WAAA;IAImB,mBAAA;ITgsCjB,aAAa;IS1sCf,8BAAA;IAUC,sBAAa;IAAG,mBAAA;ATosCnB;;AAEA;ISnsCE,iBAAgB;ATqsClB;;AAEA;ISlsCmB,kBAAA;ITosCf,SAAS;ISnsCZ,WAAA;ATqsCD;;AAEA;ISnsCE,oBAAQ;IACR,oBAAa;IAAb,aAAA;ATssCF;;AAEA;ISvsCE,oBAAA;IACA,cAAA;IAAA,YAAA;IAAA,kBAAmB;AT2sCrB;;AAEA;ISjsCC,mBAAA;IACC,oBAAY;IAAG,YAAA;ATosCjB;;AAEA;ISzrCqB,mBAAA;AT2rCrB;;AAEA;IS7rCmB,oBAAA;IT+rCf,oBAAoB;IS9rCvB,aAAA;IACC,mBAAkB;ATgsCpB;;AAEA;IS9rCE,iBAAY;IAKK,mBAAA;IT4rCf,gBAAgB;IStsClB,cAAA;IASC,6BAAe;IACf,wBHlDW;IGkDG,qBAAA;ATisCjB;;AAEA;;IShsCE,6BAAuB;IAAvB,cAAA;ATosCF;;AAEA;ISpsCE,sCAAS;ATssCX;;AAEA;IACI,mBAAmB;AShsCtB;;ATmsCD;IShsCE,gBAAQ;IACR,aAAa;IACb,8BAAW;IACX,sBAAY;IACZ,mBAAa;ATksCf;;AAEA;IACI,sCAAsC;AS5sCxC;;AT+sCF;IS3rCG,eAAW;IACX,MAAA;IACA,OAAA;IACA,oBAAkB;IAClB,cAAA;IAAkB,YAAA;IT8rCjB,aAAa;IS7rChB,qBAAA;IACC,mBAAmB;IAEJ,+BAAA;IT8rCb,WAAW;AOzzCb;;AP4zCF;IS5rCG,gBAAA;IF/HY,oBAAA;IP8zCX,gBAAgB;ISnsClB,wBAAA;IASE,qBAAW;IACX,iCAAkB;AT6rCtB;;AAEA;IS3rCI,aAAW;AT6rCf;;AAEA;ISrrCC,YAAA;IACC,gBAAA;IACA,+BAAkB;IAClB,0BHvHiB;IGoIO,uBAAA;AT2qC1B;;AAEA;IS3qCE,kBAAA;IAAA,MAAA;IACA,OAAA;IAAA,QAAA;IAAA,oBAAmB;IACnB,oBAAY;IACZ,aAAA;IACA,wBAAmB;IACnB,qBAAA;IACA,uBAAe;IACf,yBAAgB;IAChB,sBH9IiB;IG+IjB,mBAAA;IAAA,aAAA;ATirCF;;AAEA;ISlrCE,YAAA;ATorCF;;AS/rCE;IAoBC,YAAA;AT+qCH;;ASnsCE;IAwBC,aAAA;AT+qCH;;AAEA;IS/qCC,kBAAA;IACC,SAAA;IAAA,aAAA;IAAA,kBAAa;IACb,YAAA;ATmrCF;;AAEA;ISprCE,eAAA;IAAA,aAAA;ATurCF;;AAEA;IStrCE,aAAY;IACZ,wBAAkB;IAClB,qBAAY;IAgBY,uBAAA;ITyqCtB,yBAAyB;ISjsC3B,sBAAA;IAmBC,mBAAe;IACf,SAAA;IACA,gBAAY;IACZ,eAAA;ATirCH;;AAEA;IACI,eAAe;IS1sCjB,MAAA;IAwBE,OAAA;IAAkB,aAAA;ITsrClB,aAAa;ISrrChB,eAAA;IACC,WAAA;ATurCF;;AAEA;ISprCC,mBAAA;ATsrCD;;AAEA;IACI,kBAAkB;IStrCrB,mBAAA;IACC,oBAAkB;ATwrCpB;;ASvrCC;IACC,WAAA;IAAA,kBAAc;IACd,UAAA;IACA,WAAA;IACA,SAAA;IACA,WAAA;IACA,mBHvMW;ANk4Cb;;AAEA;ISzrCE,mBAAgB;IAChB,kBHlNU;IGgOW,cAAA;AT8qCvB;;AAEA;IS1qCqB,oBAAA;IT4qCjB,oBAAoB;IS3qCvB,aAAA;IACC,yBAAkB;IAClB,sBAAa;IACb,mBAAA;IACA,YAAA;IACA,eAAA;IACA,mBAAmB;IACnB,uBAAA;IAAA,eAAA;IAAA,gBAAA;IAiBsB,cAAA;IT+pCpB,+BAA+B;ISvrCjC,0BAAA;IAcC,uBAAW;IACX,6BAAkB;IAClB,wBAAQ;IACR,qBAAS;AT4qCZ;;AAEA;IS5qCG,wBAAW;AT8qCd;;AAEA;IS3qCsB,6BAAA;IT6qClB,cAAc;AS5qCjB;;AT+qCD;IS9qCE,oBAAa;IACb,oBAAA;IAAA,aAAA;IAAA,wBAAmB;IACnB,qBAAY;IACZ,uBAAmB;IACnB,yBAAe;IACf,sBAAgB;IAChB,mBHnQiB;IGoQjB,oBAAA;IAAA,cAAA;IAAA,WAAA;IAGiD,YAAA;ITkrC/C,kBAAkB;IS7rCpB,YAAA;AT+rCF;;AAEA;IStrCiD,eAAA;ITwrC7C,aAAa;ISvrChB,YAAA;IACC,6BAAW;IACX,wBAAS;IACT,qBAAkB;ATyrCpB;;AAEA;ISzrCE,eAAA;AT2rCF;;AStrCC;IACC,uBAAa;IAAb,UAAA;AT0rCF;;AAEA;IS3rCE,UAAA;IACA,aAAA;AT6rCF;;AAEA;IS7rCE,kBAAY;AT+rCd;;AAEA;IStsCE,oBAAA;IAQC,cAAe;IAAG,eAAA;ITksCjB,iBAAiB;ISjsCpB,cAAA;IACC,mBAAkB;IAClB,mBAAU;IACV,kBAAA;IAAA,eAAA;IAAA,iBAAa;IACb,gBAAA;IAAA,cAAA;ATssCF;;AAEA;ISrsCE,gBAAA;ATusCF;;AAEA;IStsCE,kBAAA;IAAA,aAAA;IAYuB,uBAAA;IT8rCrB,oBAAoB;ISptCtB,mBAAA;IAaC,mBHjSW;IGkSX,mDH7SS;IGiTM,8CAAA;ITusCd,2CAA2C;ASztC7C;;AT4tCF;IACI,WAAW;IS7tCb,kBAAA;IAkBE,QAAA;IAAY,SAAA;IT+sCZ,mCAAmC;IS1sCtC,+BAAA;IACC,2BAAc;IAAd,WAAA;IACA,WAAW;IACX,kBAAY;IACZ,mBAAY;AT6sCd;;AS5sCC;IACC,oBAAW;IACX,oBAAgB;IAChB,aAAA;IAAqB,yBAAA;ITgtCnB,sBAAsB;IS/sCzB,mBAAA;IACC,YAAA;IAAA,mBAAc;IACd,eAAA;IAAA,gBAAA;IAAA,cAAa;IACb,6BAAuB;IAAvB,wBAAuB;IAAvB,qBAAA;ATstCF;;AAEA;ISttCE,mBAAW;IACX,mDAAY;IACZ,2CAAY;ATwtCd;;AS/tCE;IASC,WAAA;IACA,SAAA;IAAc,kBAAA;IT2tCb,kBAAkB;IS1tCrB,6BAAA;IACC,wBAA2B;IAA3B,qBAAA;AT6tCF;;AAEA;IS7tC0B,oBAAA;IT+tCtB,oBAAoB;IS9tCvB,aAAA;IF7UC,wBAAgB;IAChB,qBAAA;IAAA,uBAAuB;IACvB,yBAAmB;IE6UnB,sBAAe;IACf,mBAAgB;IAChB,WAAA;IAAmB,YAAA;ITouCjB,kBAAkB;ASnuCrB;;ATsuCD;IOvjDE,eAAA;APyjDF;;AAEA;IACI,kBAAkB;ISxuCrB,UAAA;IACC,oBAAkB;IAClB,oBAAO;IACP,aAAQ;IACR,yBAAS;IACT,sBAAa;IAAb,mBAAa;IAAb,eAAa;IACb,YAAA;IAAA,mBAAA;IAAA,cAAA;IACA,eAAY;IACZ,oCAAe;IACf,+BAAA;IAAA,4BAAA;AT+uCF;;AS5mDA;;IAqYuB,6BAAA;IT4uCnB,cAAc;AStuCjB;;ATyuCD;;ISruCE,cAAA;ATwuCF;;AAEA;;IS9uCE,aAAA;ATivCF;;AAEA;IStuCG,oBAAS;IACT,cAAU;IACV,WAAY;IACZ,YAAW;IACX,YAAA;ATwuCH;;AAEA;IOpoDE,WAAA;IE6ZC,gBAAA;IF5ZY,kBAAA;APuoDf;;AAEA;IS1uCE,oBAAY;IAAG,cAAA;IT6uCb,oBAAoB;IS5uCvB,oBAAA;IACC,aAAA;IACA,wBHvXY;IGyXQ,qBAAA;IT6uClB,uBAAuB;ISjvCzB,yBAAA;IAIC,sBHxYa;IGwYI,mBAAA;ITivChB,WAAW;ISxpDf,YAAA;IA0bE,YAAU;ATiuCZ;;AS3pDA;IAmcE,eAAA;IAEqB,aAAA;AT2tCvB;;AAEA;ISrsCiB,mBAAA;ITusCb,+BAA+B;ISpqDnC,2BAAA;IAmfE,wBAAmB;IACnB,qBAAgB;ATorClB;;ASxqDA;IAsfE,gBAAW;IACX,0BAAU;IAAG,uBAAA;ITurCX,mBAAmB;IO35CrB,eAAA;IEsPA,oBAAmB;IACnB,gBAAA;ATwqCF;;AO/5CE;IEyPC,gBAAa;IAAG,0BAAA;IT2qCf,uBAAuB;IOp6CzB,mBAAA;IE2PC,cAAA;AT4qCH;;AOv6CE;IE6PC,kBHlfS;IGkfG,OAAA;IT+qCX,QAAQ;IO56CV,SAAA;IE+PC,oBHpfS;IGofI,oBAAA;ITirCZ,aAAa;IOh7Cf,yBAAA;IEiQC,sBAAA;IAAqC,mBAAA;ITmrCpC,YAAY;IOp7Cd,eAAA;IEmQC,yDH1ea;IG4eiB,iDAAA;ATmrCjC;;AAEA;ISrrC+B,kBAAA;ATurC/B;;AAEA;IStrCG,kBH7fS;IGggBO,gBAAA;ITsrCf,qBAAqB;IOj8CvB,mBAAA;IE0QE,mBH/fQ;IGggBR,kBAAU;AT0rCd;;AOr8CE;IE6QC,WAAA;IAAa,kBAAA;IT6rCZ,QAAQ;IO18CV,SAAA;IE+QC,UAAA;IAAY,YAAA;IT+rCX,WAAW;IO98Cb,mBAAA;IEiRC,oCAAA;ATgsCH;;AAEA;IOn9CE,mBAAA;APq9CF;;AAEA;IOv9CE,kBAAA;IE6RE,YHlhBQ;AN+sDZ;;AO19CE;IE+RC,gBAAA;IACA,wBHrhBS;ANotDZ;;AO/9CE;IEkSE,wBHxhBQ;ANytDZ;;AOn+CE;IEoSC,UAAA;ATmsCH;;AU1vDA;IACC,kBAAA;AV6vDD;;AAEA;IU7vDC,YAAA;AV+vDD;;AAEA;IU9vDC,mBAAY;IACZ,gBAAA;AVgwDD;;AAEA;IACI,WAAW;IUlwDd,UAAA;AVowDD;;AAEA;IUlwDE,mBAAU;IAAG,sCAAA;AVqwDf;;AAEA;IUrwD0B,aAAA;AVuwD1B;;AAEA;IUtwDE,qBAAc;AVwwDhB;;AAEA;IUtwDE,aAAA;AVwwDF;;AAEA;IU5vD4B,cAAA;AV8vD5B;;AAEA;IU1wDG,oCAAkB;AV4wDrB;;AAEA;IU3wDG,qCAA2B;AV6wD9B;;AAEA;IU5wDG,oCAAkB;AV8wDrB;;AAEA;IU7wDG,qCJOW;IINX,cAAA;AV+wDH;;AAEA;IACI,aAAa;IUjxDhB,UAAA;AVmxDD;;AAEA;IUjxDE,cAAA;AVmxDF;;AAEA;IU/wDqB,aAAA;AVixDrB;;AAEA;IUrxDG,8DJHW;IIGG,sDAAA;AVwxDjB;;AAEA;;IAEI,mBAAmB;AUzxDtB;;AV4xDD;IU3xDE,aAAA;AV6xDF;;AU5xDC;IACC,6BAAkB;IAAG,cAAA;AVgyDvB;;AAEA;IU5xDwB,mBAAA;AV8xDxB;;AAEA;IU7xDE,sCAAY;AV+xDd;;AAEA;IU9xDE,qBAAA;IAAA,kBAAA;IACA,yBJtBY;IIsBU,sBAAA;IVkyDpB,qBAAqB;IO9kDvB,iBAAA;IGlNA,eAAA;IAAwB,6CAAA;IVoyDtB,YAAY;IOllDd,iCAAA;IGhNA,4BAAa;IAAG,yBAAA;AVsyDlB;;AAEA;IWjwD4B,kBAAA;IXmwDxB,MAAM;IWz2DT,OAAA;IACC,UAAA;AX22DF;;AAEA;IACI,qBAAqB;AW/2DvB;;AXk3DF;IW12DG,kBAAmB;IACnB,cAAA;IAAsB,WAAA;IX62DrB,YAAY;IWt3Dd,oCAAA;IAWC,mBAAQ;IACR,6BAAS;IACT,wBAAU;IACV,qBAAY;AX82Df;;AAEA;IW93DE,WAAA;IAiBC,kBAAS;IACT,QAAA;IACA,SAAA;IACA,mCAAa;IACb,+BAAW;IAAG,2BAAA;IXi3Db,WAAW;IWh3Dd,YAAA;IACC,kBAAA;IAAA,yBAAa;IAAb,mDAAa;IACb,2CAAyB;IACzB,mBLCU;IKGc,6BAAA;IXi3DtB,wBAAwB;IWh3D3B,qBAAA;AXk3DD;;AAEA;IWj3DE,kBAAiB;IAGD,QAAA;IXi3Dd,OAAO;IWh3DV,mCAAA;IACC,+BAAc;IACd,2BAAY;IAOO,YAAA;AX42DrB;;AAEA;IW32DE,eAAA;IAAoB,aAAA;AX82DtB;;AAEA;IW92DwB,aAAA;AXg3DxB;;AAEA;IW92D2B,wCAAA;IXg3DvB,oCAAoC;IW/2DvC,gCAAA;AXi3DD;;AAEA;IW/2DE,kBAAU;AXi3DZ;;AAEA;IW/2DE,mBLtCU;ANu5DZ;;AAEA;IW33DE,UAAA;IAWC,YAAA;IACA,iBAAA;IAAA,kBAAA;IAAA,wCAA0B;IAA1B,oCAA0B;IAA1B,gCAAA;IAA6B,qBAAA;AXw3DhC;;AAEA;IWx3DG,qBAAA;AX03DH;;AAEA;IWt8DA,aAAA;AXw8DA;;AAEA;IW33DE,mBAAY;AX63Dd;;AAEA;IW73DE,kBAAA;IAAA,6BAAuB;IAAvB,mBAAA;AXi4DF;;AAEA;;IAEI,WAAW;IWt9Df,kBAAA;IAwFE,mBAAkB;IAClB,mBAAW;AXi4Db;;AAEA;IW59DA,QAAA;IA4FG,SAAA;IACA,UAAA;IACA,YAAQ;IACR,WAAS;AXm4DZ;;AAEA;IWj4DG,SAAA;IACA,UAAA;IAAA,WAAA;IAAA,aAAA;IAAuB,WAAA;AXs4D1B;;AAEA;IWp4DI,oBAAA;IAAgC,oBAAA;IXu4DhC,aAAa;IO7+Df,yBAAA;IIwGC,cAAA;AXw4DH;;AO/tDE;IIpKC,oBL9DW;IK+DX,cAAA;IAAA,YAAA;IAEe,iBAAA;AXu4DlB;;AAEA;IWz4DgB,cAAA;IX24DZ,YAAY;AY7/DhB;;AZggEA;IY7/DC,gBAAe;IACf,iBAAA;AZ+/DD;;AAEA;IY7/DC,mBAAgB;AZ+/DjB;;AAEA;IYh9D0B,mBAAA;AZk9D1B;;AAEA;IYhgEE,kBAAA;IAAyB,QAAA;IZmgEvB,UAAU;IYhhEd,UAAA;IAeE,WAAA;IACA,YAAS;IACT,kBAAe;IAES,mBAAA;IZmgEtB,YAAY;AOphEd;;APuhEF;IACI,eAAe;IYtgElB,2CAAA;IACC,mCNSU;IMRV,8BNOU;IMLU,2BAAA;IZugElB,oDAAoD;AY3gEtD;;AZ8gEF;IACI,gCAAgC;IY1gEnC,4BAAA;IACC,wBNKc;ANugEhB;;AAEA;IY/gEE,kBAAA;IAIC,WAAA;IAAiC,QAAA;IZ+gEhC,YAAY;IY9gEf,oBAAA;IACC,oBNUY;IMTZ,aNFU;IMIwB,wBAAA;IZ+gEhC,qBAAqB;IYnhEvB,uBAAA;IAIC,yBAA4B;IAAG,sBAAA;IZmhE9B,mBAAmB;AYlhEtB;;AZqhED;IYjhE0C,kBAAA;IZmhEtC,WAAW;IYvhEb,YAAA;AZyhEF;;AAEA;IYthEC,WAAA;IACC,kBNZU;IMaV,QAAA;IAIyB,SAAA;IZqhEvB,UAAU;IY3hEZ,WAAA;IAIC,mBNdS;IMcG,kBAAA;IZ2hEX,6BAA6B;IY/hE/B,wBAAA;IAMC,qBNfa;AN2iEhB;;AY3hEC;;IAEC,qCNhBY;IMkBuB,6BAAA;AZ6hErC;;AAEA;IY/hEmC,kBAAA;AZiiEnC;;AAEA;IYjiEoB,mBAAA;IZmiEhB,kDAAkD;IYxlEtD,0CAAA;AZ0lEA;;AAEA;IYpiEE,aAAA;AZsiEF;;AAEA;IYviEE,gBAAA;IAAA,YAAA;IAAsB,eAAA;IZ2iEpB,wBAAwB;IOj1D1B,gCAAA;IKrNC,eAAA;IACA,oBNjCS;IMmCY,gBAAA;IZwiEpB,6BAA6B;IOt1D/B,wBAAA;IKlNE,qBNpCQ;AN+kEZ;;AOz1DE;;IK/MC,qBNtCS;IMwCQ,sBAAA;AZ4iEpB;;AAEA;IY9iEkB,kBAAA;IZgjEd,SAAS;IatnEb,eAAA;AbwnEA;;AAEA;Iah4DgC,kBAAA;Abk4DhC;;AAEA;IaznEE,mBAAa;IAAb,cAAa;Ab4nEf;;AAEA;Ia5nEE,wBAAY;Ab8nEd;;AAEA;IavoEA,6BAAA;IAUE,cAAA;AbgoEF;;Aa/nEC;IPgBC,mBAAA;ANmnEF;;AAEA;IACI,mBAAmB;IaloEtB,cAAA;AbooED;;AAEA;IapoEE,mBAAA;AbsoEF;;AAEA;IavoEwB,mBAAA;IbyoEpB,cAAc;AaxoEjB;;Ab2oED;Ia1oEE,mBAAa;Ab4oEf;;AAEA;Ia5oEE,mBAAA;IAAA,cAAA;Ab+oEF;;AAEA;Ia9oEE,aAAY;AbgpEd;;AatpEE;IAQC,6BAAe;AbkpElB;;AAEA;IalpEG,mBAAA;IAAwB,cAAA;AbqpE3B;;AAEA;IarpEmB,oCAAA;AbupEnB;;AAEA;IatpEE,eAAA;AbwpEF;;AAEA;IazpEE,2BAAmB;IAAnB,2BAAmB;IAeM,oBAAA;Ib8oEvB,wBAAwB;IahqE1B,qBAAA;IAKC,uBAAW;IACX,yBAAkB;IAClB,sBAAU;IACV,mBAAW;Ab8pEd;;AAEA;Ia5pEG,mBPba;IOcb,cAAU;Ab8pEb;;AAEA;Ia/pE8B,mBAAA;AbiqE9B;;AAEA;IajqEgB,oCAAA;IbmqEZ,cAAc;AOjtEhB;;APotEF;IACI,YAAY;AapqEf;;AbuqED;IapqEE,aAAA;IAAA,mBAAa;IAAb,mBAAa;AbwqEf;;AAEA;IaxqEE,oBAAA;IAAA,oBAAA;IAAA,aAAA;IACA,yBAAc;IAAd,sBAAc;IACd,mBAAW;IACX,YAAY;IACZ,eAAA;Ab6qEF;;AAEA;IACI,mBAAmB;Aa7qEtB;;AbgrED;Ia9qEqB,kCAAA;IbgrEjB,eAAe;Ia/qElB,oBAAA;AbirED;;AAEA;IahrEE,oBAAY;IAAZ,oBAAY;IACZ,aAAA;IAIwB,yBAAA;IbgrEtB,sBAAsB;Ia/qEzB,mBAAA;IACC,mBAAkB;AbirEpB;;AAEA;Ia/qEE,oBAAA;IAAA,oBAAA;IAAA,aAAA;IAQ2B,wBAAA;Ib4qEzB,qBAAqB;IazrEvB,uBAAA;IAOC,yBAAkB;IAClB,sBAAQ;IACR,mBAAU;IACV,WAAA;IAAA,YAAA;IAAA,YAAA;AburEH;;AAEA;IatrEG,eAAA;IAAA,aAAA;IAAwB,8BAAA;Ib0rEvB,yBAAyB;IazrE5B,sBAAA;Ab2rED;;AAEA;Ia3rEE,uBAAsB;Ab6rExB;;Aa5rEC;Ib+rEG,kBAAkB;Ia7rEpB,oBPhEU;IOkEK,oBAAA;Ib8rEb,aAAa;IalsEf,yBAAA;IbosEE,sBAAsB;IahsEvB,mBPlES;ANowEZ;;AajsEC;IACC,WAAA;IACA,kBAAmB;IACnB,UAAA;IAAkB,WAAA;IbqsEhB,YAAY;IansEd,aAAA;IACC,mBAAa;IACb,6BAAiB;IACjB,UAAA;IACA,iCAAmB;IAAG,4BAAA;IbssErB,yBAAyB;AarsE3B;;AbwsEF;IansE2B,UAAA;AbqsE3B;;AAEA;IarsEG,mBAAc;AbusEjB;;AAEA;IatsEsB,kBAAA;IbwsElB,UAAU;IavsEZ,oBAAA;IACC,oBAAgB;IAChB,aAAa;IACb,wBAAc;IAAG,qBAAA;Ib0sEhB,uBAAuB;IazsEzB,yBAAA;IACC,sBAAa;IAEY,mBAAA;Ib0sExB,oBAAoB;IazsEvB,cAAA;IACC,WAAA;IAAsB,YAAA;Ib4sEpB,mBAAmB;Ia3sEtB,gBAAA;IACC,YAAA;Ab6sEF;;Aa5sEC;IACC,eAAA;IAAA,gBAAA;AbgtEF;;AAEA;IajtEE,kBAAA;IACA,UAAA;IAAA,mBAAA;IAAA,oBAAmB;IACnB,YAAY;IAAG,kBAAA;AbstEjB;;AAEA;IartEE,kBAAA;IAAA,kBAAA;IAAA,mBAAA;IAEoB,cAAA;IbwtElB,+BAA+B;Ia5tEjC,0BAAA;IAIC,uBP5Ga;ANu0EhB;;Aa1tEC;IACC,kBAAA;IAAA,QAAA;IAAA,UAAA;IAAgB,mCAAA;IbguEd,+BAA+B;Ia/tElC,2BAAA;IACC,eAAA;IAAA,aAAA;IAAA,8BAAa;IACb,yBAAuB;IAAvB,sBAAuB;AbouEzB;;AAEA;IaruEC,cAAA;IACC,+BAAa;IAAb,0BAAa;IAAb,uBAAa;AbyuEf;;AAEA;;IavuE0B,cAAA;Ab0uE1B;;AAEA;;IAEI,aAAa;Aa7uEhB;;AbgvED;Ia7uEE,aAAA;IACA,mBAAiB;IAAG,mBAAA;AbgvEtB;;AAEA;Ia/uEyB,aAAA;IbivErB,iBAAiB;IahvEnB,kBAAA;IACC,mBAAmB;AbkvEtB;;AajvEC;IACC,aAAA;IASqB,kBAAA;Ab4uEvB;;AAEA;IapvEG,oBAAkB;IAClB,cAAS;IACT,YAAU;IACV,YAAW;IACX,gBAAa;AbsvEhB;;AAEA;IMz2EE,gBAAA;IAAA,aAAA;IACA,cAAA;AN42EF;;Aa1uEC;IACC,aAAA;Ab6uEF;;Aa9uEE;IAGC,mBAAe;Ab+uElB;;Aa9uEC;IACC,mBAAmB;AbivErB;;AahvEC;IACC,oBPnKc;IOmKQ,oBAAA;IbovEpB,aAAa;IalvEhB,wBAAA;IACC,qBAAkB;IAClB,uBAAkB;IAKG,yBAAA;IbgvEnB,sBAAsB;IavvExB,mBAAA;IAIC,YAAW;AbsvEd;;AAEA;IO14EE,wBAAW;IACX,+BAAY;IMmJX,0BAAW;IPpJZ,uBAAmB;AN+4ErB;;AAEA;IM94EE,wBAAmB;ANg5ErB;;Aa7vEC;IACC,oBAAmB;IAAG,oBAAA;IbiwEpB,aAAa;AahwEhB;;AbmwED;IahwEE,oBP/KiB;IO+KG,oBAAA;IbmwElB,aAAa;IalwEhB,wBAAA;IACC,qBAAA;IAAA,uBAAA;AbqwEF;;AAEA;IaxwEE,oBAAA;IAIC,oBPzLS;IOyLI,aAAA;IbwwEZ,yBAAyB;IavwE5B,sBAAA;IACC,mBAAgB;IAChB,cAAA;AbywEF;;AAEA;IACI,kBAAkB;Aa1wErB;;Ab6wED;IACI,WAAW;Ia5wEd,YAAA;IACC,kBAAU;IAAG,iBAAA;Ab+wEf;;AAEA;Ia/wEmB,mBAAA;AbixEnB;;AAEA;IajxEyB,mBAAA;AbmxEzB;;AAEA;IalxEE,kBAAA;AboxEF;;AAEA;IaxxEE,WAAA;IAIC,kBAAc;IAAG,SAAA;IbwxEhB,UAAU;IavxEb,WAAA;IACC,aAAA;IAAqB,WAAA;Ib0xEnB,mBAAmB;IazxEtB,aAAA;IACC,8BAAgB;IAChB,sBP1MiB;IO0MG,mBAAA;Ab4xEtB;;AAEA;Ia3xEE,qBAAgB;Ab6xElB;;AAEA;Ia7xEC,eAAA;Ab+xED;;AAEA;Ia7xEE,mBAAO;Ab+xET;;AAEA;Ia7xEE,6BAAmB;Ab+xErB;;AAEA;IOvwEE,kBAAA;IMrBA,kBP7MY;AN4+Ed;;AO1wEE;IMnBC,WAAA;IAEe,kBAAA;IbgyEd,MAAM;IO/wER,OAAA;IMjBE,WAAA;IAAY,YAAA;IboyEZ,WAAW;IOnxEb,mBAAA;IMfC,aAAA;IAAoB,8BAAA;IbsyEnB,sBAAsB;IOvxExB,mBAAA;APyxEF;;AAEA;IO3xEE,mBAAA;AP6xEF;;AAEA;IMl/EE,gBAAA;IACA,mBAAmB;IOuMK,cAAA;Ab8yE1B;;AAEA;Ia9yEuB,wDAAA;IbgzEnB,gDAAgD;IOvyElD,wBAAA;APyyEF;;AAEA;IM9/EE,cAAA;ANggFF;;AAEA;IO/yEE,gBAAA;IMLC,wBAAgB;IAAhB,gBAAgB;IAChB,gBAAA;AbwzEH;;AOpzEE;IMFE,aPnPQ;AN6iFZ;;AOxzEE;IMAC,UAAA;Ab4zEH;;AAEA;IACI,cAAc;AO/zEhB;;APk0EF;Ia/zEiD,oBAAA;Abi0EjD;;AAEA;Iaj0EyB,uBAAA;Ibm0ErB,8CAA8C;IOx0EhD,sCAAA;AP00EF;;AAEA;Ic/lFA,cAAA;AdimFA;;AAEA;IchmFC,kBAAA;AdkmFD;;AAEA;IcnmFC,gBAAA;IACA,cAAA;AdqmFD;;AAEA;Ic5mFA,gBAAA;IAgBE,gBAAY;IACZ,cAAA;Ad+lFF;;AAEA;IcplFC,WAAA;IACC,kBAAa;IACb,MAAA;IAAA,OAAA;IACA,QAAA;IACA,WAAY;IACZ,YAAY;IAEQ,mBAAA;IdslFlB,oCAAoC;AcrlFvC;;AdwlFD;IcrlFE,mBAAkB;AdulFpB;;ActlFC;IACC,cAAa;AdylFf;;AAEA;IcvlFE,aAAY;AdylFd;;Ac9lFE;IAUC,mBAAW;AdwlFd;;AAEA;IctlFG,aAAA;AdwlFH;;AAEA;IACI,gBAAgB;IcxlFnB,aAAA;IACC,8BAAa;IACb,sBAAW;IACX,mBAAY;Ad0lFd;;AAEA;IczlFE,mBAAA;Ad2lFF;;AAEA;Ic3lFE,gBAAA;IASkB,aAAA;IdqlFhB,8BAA8B;IctmFhC,sBAAA;IAYC,mBAAe;Ad6lFlB;;AAEA;Ic3mFE,wBAAA;IAeC,gBAAA;IAEe,mBAAA;Ad8lFlB;;AAEA;IchmFgB,cAAA;AdkmFhB;;AAEA;Ic7lFsB,gBAAA;Id+lFlB,wBAAwB;IO/5E1B,gBAAA;APi6EF;;AAEA;IACI,+DAA+D;IOp6EjE,uDAAA;APs6EF;;AAEA;Ie3rFA,6BAAA;Af6rFA;;AAEA;IACI,iCAAiC;AelrFpC;;AfqrFD;IenrFe,kBAAA;IfqrFX,WAAW;IeprFd,oBAAA;IACC,oBAAW;IACX,aAAY;IACZ,yBAAsB;IACtB,sBAAmB;IACnB,mBAAA;ITGA,gBAAA;ISDA,iBAAe;AfsrFjB;;AAEA;IetrFE,YAAA;IAMuB,iBAAA;IfmrFrB,kBAAkB;AO5jFpB;;AP+jFF;IACI,aAAa;IOhkFf,oBAAA;IQvHC,cTEgB;ICsHJ,WAAA;IPmkFX,YAAY;IOpkFd,YAAA;APskFF;;AAEA;Ie9rFC,WAAA;IACC,gBAAA;IACA,kBAAM;AfgsFR;;AAEA;Ie9rFE,aAAY;IAUO,WAAA;IfurFjB,YAAY;IevsFd,kBAAA;IAQC,YTZS;AN8sFZ;;AAEA;;IAEI,WAAW;Ie9sFb,qBAAA;IAWE,WAAA;IAAkB,WAAA;IfusFlB,gBAAgB;IeltFlB,kBAAA;IAaE,mBAAa;AfwsFjB;;AAEA;IevtFE,aAAA;IAgBC,WAAA;IAAgB,YAAA;If2sFf,kBAAkB;Ie1sFrB,kBAAA;IACC,uDAAkB;IAClB,+CAAS;IACT,YAAU;IACV,6BAAW;IACX,wBAAuB;IACvB,qBAAmB;Af4sFrB;;AAEA;Ie3sFE,eAAA;IACA,aAAU;Af6sFZ;;AAEA;IezsF6C,6BAAA;Af2sF7C;;AAEA;Ie3sFsB,aAAA;Af6sFtB;;AAEA;;Ie7sFE,mBAAa;AfgtFf;;AAEA;IehtFE,iDAAe;IACf,yCTxCY;AN0vFd;;AAEA;Ie/sFwC,aAAA;AfitFxC;;AAEA;IertFoB,kBAAA;IfutFhB,UAAU;AOjyFZ;;APoyFF;IACI,kBAAkB;IextFrB,UAAA;Af0tFD;;AAEA;IeztFE,WAAA;IAAA,YAAa;IACb,sBAAA;IAAA,mBAAA;IAAA,uBAAuB;IACvB,gCAAmB;IAAnB,eAAA;IAAA,cAAA;IACA,oCAAc;IAAd,+BAAc;IACd,4BAAW;AfiuFb;;AAEA;Ie/tFE,cAAA;AfiuFF;;AAEA;IejuFC,cAAA;AfmuFD;;AAEA;IACI,cAAc;AenuFjB;;AfsuFD;IenuFE,kBAAA;IACA,MAAA;IAO0B,OAAA;If+tFxB,SAAS;Ie1uFX,WAAA;IAMC,YAAA;AfuuFH;;AAEA;IeruFG,aTxEW;ISyEX,8BAAoB;IAApB,yBAAoB;IAApB,sBAAoB;AfyuFvB;;AexuFC;IACC,eAAA;Af2uFF;;AAEA;Ie5uFkB,aAAA;If8uFd,eAAe;Ae7uFlB;;AfgvFD;IACI,uBAAuB;Ae/1F3B;;Afk2FA;IACI,kBAAkB;Ien2FtB,SAAA;IAuHI,UAAA;IAAgB,WAAA;IfgvFhB,uBAAuB;Iev2F3B,mBAAA;IAyHI,mBAAA;IAAwB,wDAAA;IfkvFxB,gDAAgD;Ie32FpD,kBAAA;IA2HE,UAAA;IACA,6BAAU;IAAG,wBAAA;IfovFX,qBAAqB;AO7lFvB;;APgmFF;IACI,cAAc;AOjmFhB;;APomFF;IACI,oBAAoB;IOrmFtB,oBAAA;IQ7IC,aTxGS;IS0Ge,yBAAA;IfovFvB,sBAAsB;IOzmFxB,mBAAA;IQzIC,eAAA;IACA,cAAA;IAAA,+BAAA;IAE4C,0BAAA;IfqvF3C,uBAAuB;AO/mFzB;;APknFF;IACI,wBAAwB;AOnnF1B;;APsnFF;IACI,gCAAgC;AOvnFlC;;AP0nFF;IACI,kBAAkB;IO3nFpB,UAAA;IQ9HC,oBAAA;IAEwB,oBAAA;If2vFvB,aAAa;IgBl5FjB,wBAAA;IACC,qBAAkB;IAqJF,uBAAA;IhBgwFb,yBAAyB;IgBl5F5B,sBAAA;IACC,mBAAkB;IAClB,oBAAW;IACX,cAAY;IACZ,WAAA;IACA,YAAY;IACZ,kBAAA;IAAA,mBAAA;IAAA,gBAAA;IAY8C,YAAA;AhB24FhD;;AAEA;IgBl5FG,eVYS;IUXT,gBAAA;AhBo5FH;;AAEA;IACI,kBAAkB;IgBr6FpB,mBAAA;IAkBC,oBAAA;IAAA,gBAAA;AhBu5FH;;AgBt5FC;IACC,kBAAkB;IAClB,QAAM;IACN,UAAA;IACA,eAAA;IACA,aAAA;IACA,6BAAiB;IACjB,wBAAkB;IAClB,qBVKW;ANo5Fb;;AAEA;IgBl5FoB,kCAAA;IhBo5FhB,8BAA8B;IgBn5FjC,0BAAA;IACC,uBAAkB;AhBq5FpB;;AAEA;IgBn5FE,YAAA;AhBq5FF;;AAEA;IgBp5FE,oCAAmB;AhBs5FrB;;AAEA;IgBr5FE,aAAA;AhBu5FF;;AAEA;IgBj5FC,qBAAA;AhBm5FD;;AAEA;IACI,mBAAmB;IgBh5FtB,UAAA;AhBk5FD;;AAEA;IgBh5FC,aAAA;AhBk5FD;;AAEA;IgBl5FE,uBAAA;AhBo5FF;;AAEA;IgBp5FE,cAAA;AhBs5FF;;AAEA;IgBr5FE,mBAAA;IAAA,kDAA2B;IASC,0CAAA;AhBg5F9B;;AAEA;IgBr5FyB,cAAA;AhBu5FzB;;AAEA;IgBn5FE,aAAA;AhBq5FF;;AAEA;IgBp5FE,sCAAkB;AhBs5FpB;;AAEA;IgBp5FC,qCAAA;AhBs5FD;;AAEA;IgBr5FuB,kBAAA;AhBu5FvB;;AAEA;IgBt5FE,kBAAM;IACN,WAAW;IACX,YAAA;IAAA,kBAAA;IAAA,YAAa;IACb,6BAAuB;IAAvB,wBAAuB;IAAvB,qBAAA;AhB45FF;;AAEA;IgB55FE,eAAW;IACX,aAAY;IACZ,8BV/EU;IUgFV,yBAAkB;IAClB,sBAAY;AhB85Fd;;AgB75FC;IACC,uDAAe;IAAG,+CAAA;AhBi6FpB;;AAEA;IgBj6FE,kBAAA;IAAA,MAAA;IAAe,YAAA;IhBq6Fb,qBAAqB;IgBp6FxB,eAAA;IACC,iBAAA;IAAA,kBAAA;IAAA,mBAAa;IACb,eAAA;IAAqB,gBAAA;IhBy6FnB,cAAc;AgBx6FjB;;AhB26FD;IgBx6FE,kBAAA;IAAA,sBAAA;IAAA,YAAA;IAAyB,YAAA;IhB66FvB,sBAAsB;IgB56FzB,wDAAA;IAEC,gDV1FkB;IU2FlB,mBAAA;IAAA,mBAAA;IAAA,kBAAA;IAAyB,UAAA;IhBg7FvB,6BAA6B;IgB/6FhC,wBAAA;IACC,qBAAc;AhBi7FhB;;AAEA;IACI,mBAAmB;IgBl7FtB,eAAA;AhBo7FD;;AAEA;IgBn7FE,mBAAA;AhBq7FF;;AAEA;IgBt7FC,oBAAA;IhBw7FG,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IgBt7F3B,sBV5GU;IU4GG,mBAAA;IhBy7FX,4BAA4B;IgBx7F/B,mBAAA;IACC,uBAAkB;IAAG,eAAA;IhB27FnB,oCAAoC;IgB17FvC,+BAAA;IACC,4BAAgB;AhB47FlB;;AgB1kGA;IAgJE,6BVjHc;AN+iGhB;;AAEA;IACI,kBAAkB;IgBjlGtB,oBAAA;IAmJG,cVrHS;IUqHG,WAAA;IhBk8FX,YAAY;IgBrlGhB,kBAAA;IAqJE,YAAA;AhBm8FF;;AAEA;IOv0FE,WAAA;ISxHC,gBAAA;IAM2C,kBAAA;AhB67F9C;;AAEA;IgBj8FgB,kBAAA;IhBm8FZ,MAAM;IO/0FR,WAAA;ISlHE,oBAAA;IAAA,oBAAA;IAAwC,aAAA;IhBs8FxC,wBAAwB;IOp1F1B,qBAAA;IShHC,uBVlHW;IUmHX,yBAAA;IAAA,sBAAA;IAE4C,mBAAA;IhBu8F3C,WAAW;IO11Fb,YAAA;IS3GC,yBV1IS;IU0II,kBAAA;IhBy8FZ,YAAY;AO91Fd;;APi2FF;IgB18F2C,eAAA;AhB48F3C;;AAEA;IiBrnGE,mBAAA;IACA,oBAAmB;IACnB,YAAA;AjBunGF;;AAEA;IiBhnGC,oBAAA;IACC,oBAAgB;IAChB,aXcU;IWVW,kBAAA;AjB+mGvB;;AAEA;IiB3mGwB,kBAAA;IjB6mGpB,cAAc;IiB5mGjB,+BAAA;IACC,0BAAgB;IAAG,uBAAA;AjB+mGrB;;AAEA;;IiB7mGE,cAAW;IACX,+BAAY;IACZ,0BAAY;IAiBY,uBAAA;AjBgmG1B;;AAEA;IiBhmGgB,oBAAA;IjBkmGZ,cAAc;IOrpGhB,iBAAA;APupGF;;AAEA;IkBxpGC,iBAAA;IACC,wBAAa;IAAb,6BAAa;IAAb,wBAAa;IACb,qBAAc;AlB4pGhB;;AkBxpGC;;;;IAEC,cAAA;AlB6pGF;;AAEA;IkBvpGC,kBAAA;AlBypGD;;AAEA;IkBzpGE,gBAAc;AlB2pGhB;;AkB7pGE;IAOC,6BAA0B;IAA1B,uDAA0B;IAA1B,+CAA0B;AlB4pG7B;;AAEA;IACI,aAAa;AkBtpGhB;;AlBypGD;IkBxpGE,mBAAa;IACb,UAAA;AlB0pGF;;AAEA;IACI,mBAAmB;AkB1pGtB;;AlB6pGD;IkB3pGE,aAAA;AlB6pGF;;AAEA;IkB9pGC,iDAAA;IACC,yCAAkB;AlBgqGpB;;AkB3pGC;IACC,mBAAW;IACX,kDAAY;IACZ,0CAAsB;AlB8pGxB;;AAEA;IM3rGE,cAAA;AN6rGF;;AAEA;IkB3pGyB,iDAAA;IlB6pGrB,yCAAyC;AOnkG3C;;APskGF;IACI,kBAAkB;IOvkGpB,uBAAA;IW1FC,mBZ3BgB;ICsHJ,6BAAA;IP0kGX,gBAAgB;AO3kGlB;;AP8kGF;IACI,gBAAgB;IkBxqGnB,cAAA;AlB0qGD;;AAEA;IkBxqGE,mBAAS;AlB0qGX;;AAEA;IACI,gBAAgB;AkBjrGlB;;AlBorGF;IkB1qGG,kBAAA;IAAA,SAAA;IAAA,WAAA;IAAwB,YAAA;IlB+qGvB,YAAY;AkBzrGd;;AlB4rGF;IACI,WAAW;AkBhrGd;;AlBmrGD;IkBlrGE,mBAAa;AlBorGf;;AAEA;IkBnrGiC,oBAAA;IlBqrG7B,oBAAoB;IkBprGvB,aAAA;IACC,cAAA;AlBsrGF;;AAEA;IkBrrGE,mBAAkB;IAClB,8BZvDU;IYwDV,0BAAY;IACZ,uBAAA;IAAA,aAAA;AlBwrGF;;AAEA;IkB/qG0B,oBAAA;IlBirGtB,oBAAoB;IkBnsGtB,aAAA;IASC,cAAe;AlB6rGlB;;AAEA;IkBxsGE,aAAA;AlB0sGF;;AAEA;IkB5sGE,oBAAA;IAcE,oBAAe;IAAG,aAAA;IlBksGlB,yBAAyB;IkBhtG3B,sBAAA;IAgBC,mBAAA;AlBmsGH;;AAEA;IOnyGE,kBAAA;IWgGC,mBAAkB;IX/FN,oBAAA;IPsyGX,YAAY;AOvyGd;;AP0yGF;IACI,kBAAkB;AO1hGpB;;AP6hGF;IkBtsGgB,WAAA;IlBwsGZ,YAAY;IO/hGd,sBAAA;IWtKE,YZ/EQ;IY+EI,mBAAA;IlBysGZ,oCAAoC;IOniGtC,gCAAA;IWpKC,eAAA;IAI6C,gBAAA;IlBusG5C,cAAc;AOviGhB;;AP0iGF;IACI,cAAc;AO3iGhB;;AP8iGF;IkB9sG8C,cAAA;AlBgtG9C;;AAEA;ImBtvGiB,cAAA;AnBwvGjB;;AAEA;ImBr0GE,kBAAA;IAAA,MAAA;IAAA,OAAA;IACA,SAAA;IAAA,WAAA;IAAA,YAAA;AnB20GF;;AAEA;ImBz0GE,eAAA;IACA,aAAA;IACA,8BAAgB;IAChB,yBbsBiB;IarBjB,sBAAA;AnB20GF;;AAEA;ImB30GE,uBAAA;AnB60GF;;AmB11GE;IAeC,oBAAW;IACX,oBAAkB;IAClB,aAAQ;IACR,yBAAW;IACX,sBAAA;IAAA,mBAAA;AnBg1GH;;AAEA;ImB/0GG,oBAAA;IACA,cAAA;IAAA,WAAA;IAAA,YAAA;IAAA,kBAAA;IAAA,mBAAA;IAA6B,YAAA;InBs1G5B,4CAA4C;ImBr1G/C,oCAAA;IACC,+BAAkB;IAClB,4BAAqB;IACrB,sDAAO;AnBu1GT;;AAEA;ImBr1GE,eAAA;IACA,aAAA;AnBu1GF;;AAEA;ImBr1GE,eAAA;AnBu1GF;;AAEA;ImBx1GE,eAAA;AnB01GF;;AmBr1GC;IACC,wDAAc;IAEW,gDAAA;AnBu1G3B;;AAEA;IOr4Ge,eAAA;APu4Gf;;AAEA;ImB11GE,mBAAkB;AnB41GpB;;AAEA;ImB31GE,qCAAsB;IAAtB,cAAA;AnB81GF;;AmBn2GE;IAOC,aAAW;AnBg2Gd;;AAEA;ImB91GG,mBAAU;AnBg2Gb;;AAEA;ImB/1GG,aAAA;AnBi2GH;;AAEA;ImBn2GgC,mDAAA;InBq2G5B,2CAA2C;AmBp2G9C;;AnBu2GD;ImBr2GE,kBAAA;AnBu2GF;;AAEA;ImBx2GC,kBAAA;IACC,oBAAA;IAAA,oBAAA;IAAA,aAAA;IAA6B,yBAAA;InB62G3B,sBAAsB;ImB52GzB,mBAAA;InB82GG,YAAY;ImB52Gd,sBbvCc;IauCG,6BAAA;InB+2Gf,oCAAoC;ImBr7GxC,mBAAA;IAwEE,gBAAA;IACA,cAAA;IACA,6BbzCY;Ia2CoC,wBAAA;InB+2G9C,qBAAqB;ImB37GzB,eAAA;IA4EG,6CAAA;AnBk3GH;;AAEA;IACI,WAAW;ImBj8Gf,kBAAA;IA8EE,QAAA;IACA,WAAU;IAAG,mCAAA;InBu3GX,+BAA+B;IOnrGjC,2BAAA;IY/LC,WAAA;IAE2U,WAAA;InBo3G1U,+EAA2V;IOvrG7V,2CAAA;IY7LE,mCAAA;IAAwU,8BAAA;InBw3GxU,2BAA2B;IO3rG7B,oDAAA;AP6rGF;;AAEA;ImBx3GG,kBAAA;IAAyC,qBAAA;InB23GxC,OAAO;IOlsGT,WAAA;IYvLC,YAAA;IAEuT,aAAA;InB23GtT,yBAAyB;IOtsG3B,mBAAA;IYrLE,mBAAA;IAAoT,kBAAA;InB+3GpT,UAAU;IO1sGZ,wDAAA;IYnLC,gDbpDa;IaqDb,6BbnES;IamEI,wBAAA;InBi4GZ,qBAAqB;AoBl+GzB;;ApBq+GA;IACI,cAAc;AoBt+GlB;;ApBy+GA;IoBp+GsB,mBAAA;ApBs+GtB;;AAEA;IoBr+GE,kBAAW;IAGY,kBAAA;IpBq+GrB,mBAAmB;IoBp+GtB,cAAA;IACC,+BAAkB;IAOoB,0BAAA;IpBg+GpC,uBAAuB;AoB/9G1B;;ApBk+GD;IoB/9GE,WAAA;IACA,kBAAA;IACA,QAAA;IACA,UAAA;IAEgB,UAAA;IpBg+Gd,YAAY;IoB/9Gf,+EAAA;IACC,2CAAmB;IACnB,mCAAsB;IACtB,8BAAkB;IAClB,2BAAiB;IACjB,oDAAoB;ApBi+GtB;;AAEA;IoBx+GE,cAAA;IAcC,+BAAW;IACX,0BAAU;IACV,uBAAY;ApB69Gf;;AoBv9GC;IACC,kCAAoB;IAApB,8BAAoB;IAApB,0BAAoB;ApB49GtB;;AAEA;;IoB59GiB,wBAAA;ApB+9GjB;;AAEA;IoB99GE,+BAAa;IAAb,mBAAa;IAAb,cAAa;ApBk+Gf;;AAEA;IoBl+GE,kDAAmB;IAAnB,8CAAmB;IAAnB,0CAAmB;ApBs+GrB;;AAEA;IoBr+GE,mBAAY;IACZ,UAAA;ApBu+GF;;AAEA;IACI,qCAAqC;AoBl/GvC;;ApBq/GF;IoB99GG,yDAAS;ApBg+GZ;;AAEA;IoB99GG,sCAA0B;IAC1B,mBAAmB;IAAG,kDAAA;IpBi+GrB,0CAA0C;AoBh+G7C;;ApBm+GD;IACI,cAAc;AoBl+GjB;;ApBq+GD;IACI,yDAAiT;AoB99GpT;;ApBi+GD;IACI,qCAAqC;IoBh+GxC,cAAA;ApBk+GD;;AAEA;IoBl+GE,mBAAA;ApBo+GF;;AAEA;IACI,mBAAmB;IoBt+GtB,cAAA;ApBw+GD;;AAEA;IoBv+GE,cAAc;IACd,WAAA;ApBy+GF;;AoBj+GC;IACC,kBd/EiB;Ic+EG,YAAA;IpBq+GlB,gBAAgB;AoBp+GnB;;ApBu+GD;IACI,iBAAiB;IoBp+GpB,oBAAA;IACC,eAAA;IACA,oBAAkB;IAKQ,gBAAA;IpBk+GxB,cAAc;AoB99GjB;;ApBi+GD;IoB/9GoB,mBAAA;IpBi+GhB,sBAAsB;IoBh+GzB,kBAAA;IACC,iBAAkB;IAClB,oBAAQ;IACR,gCAAS;ApBk+GX;;AAEA;IoBl+GE,WAAA;IACA,UAAA;IACA,YAAA;ApBo+GF;;AAEA;IoBn+GE,2BAAkB;IAClB,2BAAU;IACV,oBAAA;IAAA,yBAAmB;IAAnB,sBAAmB;IAAG,mBAAA;IpBw+GpB,cAAc;AoBv+GjB;;ApB0+GD;IoBx+Ge,kBAAA;IpB0+GX,oBAAoB;IoBz+GvB,oBAAA;IACC,aAAA;IAAA,wBAAa;IAAb,qBAAa;IACb,uBAAA;IAAA,yBAAmB;IAAnB,sBAAmB;IACnB,mBAAkB;IAClB,oBdtHiB;IcsHG,cAAA;IpBg/GlB,WAAW;IoB/+Gd,YAAA;IACC,kBAAA;IAAA,YAAA;ApBk/GF;;AAEA;IoBn/GE,WAAA;IACA,kBAAA;IAAA,SAAA;IAAA,SAAA;IACA,UAAA;IAAA,WAAA;IACA,0BAAW;IACX,mBAAY;ApBw/Gd;;AAEA;IACI,gBAAgB;AoBx/GnB;;ApB2/GD;IACI,kBAAkB;AoB1/GrB;;ApB6/GD;IoB1/GE,kBAAW;ApB4/Gb;;AAEA;IACI,oBAAoB;IoBlgHtB,oBAAA;IAOC,aAAc;IACd,yBAAkB;IAClB,sBAAM;IACN,mBAAO;ApB8/GV;;AAEA;IoB7/GyB,WAAA;IpB+/GrB,YAAY;IO9qHd,oBAAA;IakLC,cAAA;IbjLY,kBAAA;APirHf;;AAEA;IoBhgHsB,cAAA;ApBkgHtB;;AAEA;IoBjgHE,gBAAiB;ApBmgHnB;;AAEA;IACI,iBAAiB;IoBngHpB,kBAAA;ApBqgHD;;AAEA;IoBrgHE,kBAAmB;IACnB,eAAA;ApBugHF;;AAEA;IoBpgHqB,kBAAA;IpBsgHjB,QAAQ;IoBrgHX,SAAA;IACC,wCAAa;IAAb,oCAAa;IAAb,gCAAa;IACb,gBAAA;IAAA,kBAAA;IAAA,mBAAmB;IACnB,mBAAY;IAAZ,wDAAY;IAAZ,gDAAY;IAAG,kBAAA;IpB8gHb,UAAU;IoB7gHb,4BAAA;IACC,uBd5JY;Ic4JG,oBAAA;ApBghHjB;;AAEA;IoBhhHiB,mBAAA;IpBkhHb,UAAU;AoBjhHZ;;ApBohHF;IoBlhHG,oBAAa;IACb,oBAAkB;IAAG,aAAA;IpBqhHpB,yBAAyB;IoBxhH3B,sBAAA;IAKC,mBAAa;IAAb,kBAAa;IAAb,cAAa;ApBwhHhB;;AAEA;IoB/hHE,oBAAA;IAQC,oBAAa;IAAb,aAAA;IAAA,wBAAa;IAAG,qBAAA;IpB6hHf,uBAAuB;IoB5hHzB,yBAAA;IAEC,sBAAa;IAAb,mBAAa;IAAb,oBAAa;IACb,cAAA;IAAqB,WAAA;IpBgiHpB,YAAY;IoBniHd,iBAAA;IAKC,kBAAa;ApBiiHhB;;AAEA;IoBliHwB,cAAA;ApBoiHxB;;AAEA;IoBpiHG,kBAAa;IAAb,WAAA;IAAgB,WAAA;IpBwiHf,kBAAkB;IoBjiHpB,mBAAA;ApBmiHF;;AAEA;IoBliHG,cAAA;IAAqB,kBAAA;IpBqiHpB,MAAM;IoBxiHR,OAAA;IAKC,SAAA;IAAA,kBAAa;IAAb,6BAAa;ApBwiHhB;;AAEA;IoB/iHE,mBAAA;ApBijHF;;AAEA;IoB3iHmB,cAAA;ApB6iHnB;;AAEA;IoBviHgC,qBAAA;IpByiH5B,iBAAiB;IO3gHnB,kBAAA;Ia5BC,cdzNS;ANmwHZ;;AO9gHE;Ia1BC,aAAA;IAA6B,yBAAA;IpB6iH5B,sBAAsB;IqBtyH1B,mBAAA;IACC,mBAAA;IACA,YAAA;IACA,yBAAiB;IAAjB,kBAAA;ArByyHD;;AAEA;IqBzyHC,oBAAA;IA0CkB,oBAAA;IrBkwHf,aAAa;IqB3yHhB,yBAAA;IACC,sBAAkB;IAClB,mBAAM;IACN,mBAAO;IACP,oBAAU;IAAG,YAAA;ArB8yHf;;AAEA;IqB9yHE,wBAAa;ArBgzHf;;AAEA;IqBjzHC,mBAAA;IACC,iBAAkB;IAClB,aAAA;IAAA,kBAAc;ArBozHhB;;AAEA;IqBnzHE,mBAAkB;IAClB,iBAAA;IACA,aAAA;IAAA,kBAAA;ArBszHF;;AAEA;IqB/zHE,mBAAA;IASC,iBAAW;IACX,aAAA;ArByzHH;;AAEA;IqBxzHG,mBAAA;IAAA,iBAAA;IACA,aAAW;IACX,kBAAW;ArB2zHd;;AAEA;IqB1zHG,mBAAA;IAAA,iBAAA;IAA2B,aAAA;IrB8zH1B,kBAAkB;AqB7zHrB;;ArBg0HD;IqB7zHE,mBAAe;IACf,iBAAgB;IAChB,aAAA;ArB+zHF;;AAEA;IqBt2HA,mBAAA;IAwCE,iBAAA;IAAwB,aAAA;IrBk0HtB,kBAAkB;AqBj0HrB;;ArBo0HD;IqBh0HkB,mBAAA;IrBk0Hd,iBAAiB;IqBt0HnB,aAAA;IAIC,kBAAU;ArBq0Hb;;AqBp0HC;IACC,mBfdY;IecG,iBAAA;IrBw0Hb,aAAa;AOpmHf;;APumHF;IACI,sCAAsC;AOxmHxC;;AP2mHF;IACI,cAAc;AsB/3HlB;;AtBk4HA;IsB/3HC,sCAAiB;AtBi4HlB;;AAEA;IsBl4HC,qBAAe;IACf,kBAAA;IA2CkB,yBAAA;ItB01Hf,sBAAsB;IsBp4HzB,qBAAA;IACC,iBAAkB;IAClB,eAAM;IACN,6CAAO;AtBs4HT;;AAEA;IsBt4HC,kBAAA;IACC,MAAA;IAAA,OAAA;IAAA,UAAA;AtB04HF;;AsBz4HC;IACC,oBAAkB;IAClB,oBAAc;IAAd,aAAA;AtB64HF;;AAEA;IsB54HE,kBAAkB;IAClB,mBhByBc;IgBxBd,kBAAA;IAAA,cAAA;IAAA,WAAA;IAa8B,YAAA;ItBo4H5B,kBAAkB;IsBx5HpB,yBAAA;IASC,6BAAW;IACX,wBAAkB;IAClB,qBAAQ;AtBk5HX;;AAEA;IsBl5HG,WAAA;IACA,kBAAW;IACX,QAAA;IACA,SAAA;IACA,wChBAS;IgBCT,oCAAA;IAAA,gCAAA;IACA,WAAU;IACV,WAAA;IAAA,UAAA;IAAA,+EAAwB;IAAG,iCAAA;ItBw5H1B,4BAA4B;IsBv5H/B,yBAAA;AtBy5HD;;AAEA;IsBv5HE,gBAAgB;IAChB,gBhBLiB;IgBMjB,eAAA;IAAA,gBAAA;IAAA,gBAAA;IAAyB,cAAA;AtB45H3B;;AAEA;IsB55HwB,+BAAA;AtB85HxB;;AAEA;IsB55HkB,6BAAA;ItB85Hd,+BAA+B;AsBj6HjC;;AtBo6HF;IACI,UAAU;AsBj6Hb;;AtBo6HD;IACI,cAAc;AOjsHhB;;APosHF;IACI,sCAAsC;AOrsHxC;;APwsHF;IACI,cAAc;AuB39HjB;;AvB89HD;IuB39HE,qBjB0BU;IiBzBV,kBAAmB;IAWE,yBAAA;IvBm9HnB,sBAAsB;IuBl+HxB,qBAAA;IAQC,iBAAW;IACX,eAAA;IACA,6CAAS;AvB69HZ;;AAEA;IuB39HG,kBAAW;IjBuCZ,MAAA;IACA,OAAA;IACA,UAAA;ANu7HF;;AAEA;IACI,oBAAoB;IuBj+HvB,oBAAA;IACC,aAAA;AvBm+HF;;AuBh+HC;IACC,kBAAA;IAAA,mBAAa;IAAb,kBAAa;IACb,cAAA;IAEoB,WAAA;IvBo+HlB,YAAY;IuBn+Hd,kBAAA;IAEC,mBAAc;IAAd,6BAAc;IACd,wBAAY;IACZ,qBAAmB;AvBq+HtB;;AuBz+HE;IAYC,WAAA;IAAA,kBAAA;IAAA,QAAA;IAAe,SAAA;IvBo+Hd,wCAAwC;IuBn+H3C,oCAAA;IACC,gCAAmB;IACnB,WAAA;IACA,YAAA;IAKkB,kBAAA;IvBi+HhB,mBAAmB;IuB59HtB,kDAAA;IACC,0CAAmB;IAAG,UAAA;IvB+9HpB,iCAAiC;IuB99HpC,4BAAA;IACC,yBAAa;AvBg+Hf;;AAEA;IuBj+HE,gBAAA;IAAA,gBAAA;IACA,ejBXY;IiBYZ,gBAAA;IAAA,cAAA;IAAA,+BAAsB;IAEF,0BAAA;IvBq+HlB,uBAAuB;AuB3+HzB;;AvB8+HF;IACI,6BAA6B;AuBx+HhC;;AvB2+HD;IACI,6BAA6B;AuB1+HhC;;AvB6+HD;IuB3+HE,UAAA;AvB6+HF;;AAEA;IuB7+HC,cAAA;AvB++HD;;AAEA;IuB/+HE,oCAAmB;AvBi/HrB;;AAEA;IuBh/H2B,cAAA;AvBk/H3B;;AAEA;IuBl/HE,kBAAA;IAAA,uBAAa;IACb,mBAAA;IAAA,mBAAA;AvBs/HF;;AAEA;IuBv/HC,WAAA;IACC,kBAAA;IAAA,SAAA;IAAA,UAAA;IACA,WAAA;IAAA,aAAA;IAAA,WAAA;IACA,mBAAA;IAAA,aAAA;IAAA,8BAAmB;IACnB,sBAAc;IAAd,mBAAc;AvBggIhB;;AAEA;IuB9/HE,mBAAkB;AvBggIpB;;AAEA;IuB1gIE,oBAAA;IAWC,oBAAc;IACd,ajB1DS;IiB0DG,mBAAA;AvBmgIf;;AAEA;IuBlgIE,oBAAqB;IACrB,cAAA;IACA,YAAA;IAAoB,mBAAA;AvBqgItB;;AAEA;IuBngIG,mBAAY;IAAZ,oBAAY;IAAZ,YAAY;AvBugIf;;AAEA;IuBvgIE,mBAAA;IACC,oBAAa;IAIG,gCAAA;AvBsgInB;;AAEA;IuBzgII,mBAAY;AvB2gIhB;;AAEA;IuB3gIE,oBAAA;IACC,oBAAa;IAAG,aAAA;IvB8gIf,yBAAyB;IuB7gI5B,sBAAA;IACC,mBjBzEkB;IiByEG,wBAAA;IvBghInB,+BAA+B;IuB/gIlC,0BAAA;IACC,uBAAa;AvBihIf;;AAEA;IuBjhIE,wBjBpEc;ANulIhB;;AuBhhIC;IACC,YAAa;AvBmhIf;;AOroIE;IgBoHC,WAAA;IhBnHY,oBAAA;IPyoIX,cAAc;IuBnhIjB,kBAAA;AvBqhID;;AAEA;IuBrhIE,oBAAc;IAMwB,oBAAA;IvBkhIpC,aAAa;IuBjhIhB,yBAAA;IACC,sBAAa;IAAb,mBAAa;IAAb,mBAAa;AvBqhIf;;AAEA;IuB5gIC,oBAAA;IACC,oBAAa;IAAb,aAAA;IAAA,yBAAa;IACb,sBAAA;IAAA,mBAAA;AvBihIF;;AAEA;IACI,oBAAoB;IuBlhIvB,oBAAA;IACC,aAAA;IAAA,wBAAa;IAAb,qBAAa;IACb,uBAAuB;IAAvB,yBAAuB;IAAvB,sBAAuB;IACvB,mBAAA;IAAA,oBAAA;IAAA,cAAA;IACA,WAAA;IAAA,YAAA;IACA,iBAAW;IACX,kBAAY;IACZ,YAAA;AvB2hIF;;AAEA;IACI,cAAc;IuB3hIjB,aAAA;AvB6hID;;AAEA;IuB7hIC,kBAAA;IACC,qBAAkB;IAClB,mBAAW;IACX,mBAAkB;AvB+hIpB;;AAEA;IuB/hIC,YAAA;IACC,mBAAkB;IAClB,oBAAM;IACN,YAAO;IACP,mBAAS;AvBiiIX;;AuBhiIC;IACC,aAAA;AvBmiIF;;AAEA;IuBjiIE,mBAAW;IACX,YAAY;IACZ,cAAA;AvBmiIF;;AAEA;IACI,aAAa;AuB7iIf;;AvBgjIF;IuBpiIG,cAAA;AvBsiIH;;AAEA;IuBxiIgC,oBAAA;IvB0iI5B,oBAAoB;IuBtjItB,aAAA;IAcC,mBAAA;IAAA,yBAAA;AvB4iIH;;AAEA;IuBpuIA,aAAA;AvBsuIA;;AAEA;IuB7iIE,+BAAY;AvB+iId;;AOxuIE;IgBiMA,mBAAmB;IhBhMN,qBAAA;IP4uIX,iBAAiB;IO7uInB,cAAA;AP+uIF;;AAEA;IuB1iIC,mBAAA;IACC,iBAAY;IACZ,aAAA;IAGgB,UAAA;AvB0iIlB;;AAEA;IuB1iIwB,oBAAA;IvB4iIpB,oBAAoB;IuB3iIvB,aAAA;IACC,yBjBpKY;IiBoKG,sBAAA;IvB8iIb,mBAAmB;IO7+HrB,kBAAA;AP++HF;;AAEA;IOj/HE,oBAAA;IDrNA,oBAAgB;IAChB,aAAa;IACb,wBAAA;IAAA,qBAAsB;IACtB,uBAAmB;IiBwJM,yBAAA;IvBmjIvB,sBAAsB;IOz/HxB,mBAAA;IgBxDC,oBjB1KW;IiB4KI,cAAA;IvBmjId,WAAW;IO7/Hb,YAAA;IgBtDE,iBjB/LQ;IiB+LI,kBAAA;IvBujIZ,YAAY;AOjgId;;APogIF;IACI,cAAc;AOrgIhB;;APwgIF;IACI,kBAAkB;IOzgIpB,WAAA;IgBhDC,kBAAA;IAA6B,mBAAA;AvB6jIhC;;AAEA;IuB7jI8B,kBAAA;IvB+jI1B,MAAM;IwBnyIT,OAAA;IACC,SAAA;AxBqyIF;;AAEA;IwBtyIE,kBAAA;IAAA,QAAA;IAOyB,UAAA;IxBmyIvB,UAAU;IwBzyIZ,WAAA;IACC,YAAA;IACA,kBAAmB;IAAG,mBAAA;IxB4yIrB,YAAY;AwBjzId;;AxBozIF;IACI,eAAe;IOpzIjB,2CAAA;IiBQC,mCAAmB;IjBPP,8BAAA;IPuzIX,2BAA2B;IwB/yI9B,oDAAA;AxBizID;;AAEA;IwBhzIE,gCAAa;IAAb,4BAAa;IACb,wBAAuB;AxBmzIzB;;AAEA;IwBpzIE,kBAAA;IAAA,SAAA;IACA,WAAA;IAAA,YAAA;AxBwzIF;;AAEA;IwBtzIE,mBAAmB;AxBwzIrB;;AAEA;IwBxzIC,mBAAA;AxB0zID;;AAEA;IwB1zIC,YAAA;IACC,mBAAkB;AxB4zIpB;;AAEA;IwB3zIE,mBAAA;AxB6zIF;;AAEA;IwB7zIkB,wBAAA;AxB+zIlB;;AAEA;IwB9zIE,mBAAU;AxBg0IZ;;AAEA;IwBj0IiB,gBAAA;IxBm0Ib,aAAa;IwBl0IhB,8BAAA;IACC,sBAAkB;IAClB,mBAAQ;AxBo0IV;;AAEA;IwBn0IE,mBAAA;AxBq0IF;;AAEA;IwBt0IC,aAAA;AxBw0ID;;AAEA;IACI,sCAAsC;AwBx0IzC;;AxB20ID;IACI,sCAAsC;AwB10IxC;;AxB60IF;IACI,sCAAsC;AwB50IzC;;AxB+0ID;IwB90IE,oCAAa;AxBg1If;;AwB/0IC;IACC,oBAAiB;IACjB,oBAAkB;IAClB,alBTa;IkBSG,yBAAA;IxBm1Id,sBAAsB;IwBl1IzB,mBAAA;AxBo1ID;;AAEA;IACI,kBAAkB;IwBv1IpB,mBAAA;AxBy1IF;;AAEA;IwBp1IG,cAAe;AxBs1IlB;;AAEA;IwBv1IG,mBAAA;AxBy1IH;;AAEA;IwB11IC,kBAAA;IACC,UAAA;IACA,oBAAe;IACf,oBAAiB;IACjB,aAAA;IACA,wBAAkB;IAClB,qBlBxCU;IkBwCG,uBAAA;IxB61IX,yBAAyB;IwB51I5B,sBAAA;IACC,mBAAkB;IAAG,oBAAA;IxB+1InB,cAAc;IwB91IjB,WAAA;IACC,YAAA;IACA,kBAAiB;IACjB,mBAAA;IACA,YAAA;AxBg2IF;;AAEA;IwBh1I2B,gBAAA;AxBk1I3B;;AAEA;IwBl2IG,kBAAkB;IAClB,QAAS;IACT,YAAU;IACV,mCAAW;IACX,+BAAS;IACT,2BAA0B;IAC1B,YAAA;IACA,aAAA;AxBo2IH;;AAEA;IACI,kBAAkB;IwBt3IpB,UAAA;IAiBC,mBlB3Da;IkB4Db,oBlB7DS;IkB+DQ,YAAA;AxBu2IpB;;AAEA;IwBz2IkB,kBAAA;IxB22Id,QAAQ;IOt8IV,SAAA;IiB6FC,oBAAmB;IjB5FP,wCAAA;IPy8IX,oCAAoC;IwB52IvC,gCAAA;AxB82ID;;AAEA;IwBh3IE,eAAA;IAGC,clBrES;ANq7IZ;;AwB/2IC;IACC,gBlBvEU;ANy7IZ;;AwBj3IC;IACC,gBAAA;AxBo3IF;;AAEA;IwBh3I0B,oBAAA;IxBk3ItB,oBAAoB;IwBz3ItB,aAAA;AxB23IF;;AAEA;IACI,iBAAiB;IOjtInB,kBAAA;IiBjKC,clBpFS;ANy8IZ;;AOptIE;IiB/JC,kBlBtFS;IkBsFG,mBAAA;AxBw3If;;AAEA;IyB3+IE,kBAAA;IAAuB,QAAA;IzB8+IrB,UAAU;IyB7+Ib,eAAA;IACC,2CAAkB;IAClB,mCAAa;IAAb,8BAAa;IAAb,2BAAa;IACb,oDAAuB;AzBi/IzB;;AAEA;IyBl/IE,qBAAmB;IAAnB,eAAA;IACA,iBAAa;IACb,6BAAY;IAAG,kBAAA;IzBs/Ib,cAAc;AyBr/IjB;;AzBw/ID;IyBr/IE,kBAAgB;AzBu/IlB;;AyBt/IC;IACC,kBAAkB;IAClB,iBAAM;IACN,uBAAS;IACT,mBAAQ;IACR,6BAAU;IACV,wBAAmB;IAAG,qBAAA;AzB0/IxB;;AAEA;IO9gJe,WAAA;IPghJX,kBAAkB;IyB1/IrB,SAAA;IACC,UAAA;IAAA,WAAA;IAAA,SAAA;IACA,0BAAmB;IAAG,mBAAA;IzB+/IpB,gCAAgC;IyB9/InC,2BAAA;IACC,wBAAc;AzBggJhB;;AAEA;IyBhgJuB,6BAAA;IzBkgJnB,cAAc;AyBjgJjB;;AzBogJD;IyBjgJE,WAAA;AzBmgJF;;AAEA;IyBngJC,mBAAA;AzBqgJD;;AAEA;IyBngJE,cAAS;AzBqgJX;;AAEA;IyBhjJA,aAAA;AzBkjJA;;AAEA;IyBpjJA,cAAA;AzBsjJA;;AAEA;IyBvgJE,kBAAU;IACV,WAAA;IAAA,YAAA;IAAA,kBAAa;AzB2gJf;;AyB7jJA;IzBgkJI,WAAW;IyB3gJb,kBAAW;AzB6gJb;;AAEA;IyB3gJE,cAAA;AzB6gJF;;AAEA;IyB7gJE,aAAA;AzB+gJF;;AAEA;IyB5kJA,iBAAA;IzB8kJI,oBAAoB;AACxB;;AAEA;IyBlhJG,kBAAA;IAAA,oBAAqB;IAAG,oBAAA;IzBshJvB,aAAa;IyBrlJjB,wBAAA;IzBulJI,qBAAqB;IyBthJtB,uBnBlCa;ImBoCE,yBAAA;IzBuhJd,sBAAsB;IyB1lJ1B,mBAAA;IzB4lJI,aAAa;IyBzhJb,YnBrCQ;ANgkJZ;;AyB9lJA;IAqEE,kBAAiB;IAAG,UAAA;IzB8hJlB,gBAAgB;AOh1IlB;;APm1IF;IACI,kBAAkB;IOp1IpB,MAAA;IPs1IE,SAAS;IyB5hJV,QAAA;IACA,UAAA;IAAA,mBAAA;AzB+hJH;;AO11IE;IP61IE,mBAAmB;AACvB;;AAEA;IOh2IE,oBAAA;IPk2IE,oBAAoB;IyBniJpB,aAAA;IAAsB,mBAAA;AzBsiJ1B;;AAEA;I0BvnJE,oBAAa;IAAb,cAAA;IAAA,iBAAa;IACb,kBAAA;A1B2nJF;;AAEA;IACI,kBAAkB;I0BjoJpB,WAAA;IAYC,mBAAW;IACX,kBAAkB;A1BwnJrB;;AAEA;I0BtnJG,kBAAa;IACb,MAAA;IpBmCD,OAAA;IACA,SAAA;IACA,kBAAA;ANslJF;;AAEA;IACI,WAAW;A0B1nJb;;A1B6nJF;I0B5mJG,kBAAY;IAOW,MAAA;I1BwmJtB,UAAU;I0BhoJZ,UAAA;IAsBE,oBAAa;IAEO,oBAAA;I1B4mJpB,aAAa;A0BpoJf;;A1BuoJF;;I0B5mJG,WAAA;IAEwB,YAAA;I1B8mJvB,mBAAmB;I0B7mJtB,kBAAA;IACC,sCAAgB;IAOK,8BAAA;I1BymJnB,YAAY;I0BxmJf,6BAAA;IACC,wBAAkB;IAClB,qBAAa;A1B0mJf;;AAEA;;I0B3mJE,eAAA;IACA,aAAA;IACA,8BAAmB;IACnB,yBAAuB;IACvB,sBpBpCY;ANkpJd;;AAEA;;IAEI,6BAA6B;A0BznJ/B;;A1B4nJF;;I0BvmJG,aAAU;A1B0mJb;;AAEA;I0BxmJG,iBAAA;A1B0mJH;;AAEA;I0B1mJG,oCAAwB;A1B4mJ3B;;A0BvoJE;;IA+BoB,mBAAA;I1B6mJlB,iDAAiD;I0B5oJnD,yCAAA;A1B8oJF;;AAEA;;I0B/mJG,aAAA;A1BknJH;;AAEA;;I0BjnJI,6BAAU;A1BonJd;;AOptJE;ImBkGC,kBAAmB;InBjGP,oBAAA;IPwtJX,oBAAoB;I0BlnJvB,aAAA;IACC,4BAAkB;IAClB,mBAAa;IAAb,mBAAa;A1BqnJf;;AAEA;I0BtnJE,WAAA;IAAA,kBAAA;IACA,SAAA;IAAA,UAAA;IAAA,WAAA;IACA,aAAA;IAAA,WAAA;IAAA,mBAAmB;IACnB,aAAA;IAAA,8BAAc;IACd,sBAAW;IACX,mBAAY;A1B8nJd;;AAEA;I0B7mJ2C,oBAAA;I1B+mJvC,cAAc;I0B1oJhB,YAAA;A1B4oJF;;AAEA;I0B9nJG,aAAS;A1BgoJZ;;AAEA;I0B/nJkC,mBAAA;I1BioJ9B,oBAAoB;I0BppJtB,YAAA;IAqBC,kBAAA;A1BkoJH;;A0BvpJE;IAuBC,gBAAA;A1BooJH;;A0B3pJE;IAyBC,kBAAA;IAAoC,oBAAA;I1BuoJnC,oBAAoB;I0BhqJtB,aAAA;IA2BC,yBAAA;IAAsC,sBAAA;I1ByoJrC,mBAAmB;I0BxoJtB,iBAAA;IACC,mBAAc;IACd,uBpBrGiB;IoBqGG,cAAA;I1B2oJlB,6BAA6B;I0B1oJhC,wBAAA;IACC,qBAAY;A1B4oJd;;AAEA;IACI,WAAW;I0B9oJd,kBAAA;IACC,SAAA;IACA,UAAA;IAAA,WAAA;IAAA,WAAA;IACA,0BAAmB;IAAnB,mBAAA;IAAA,UAAA;IACA,iCAAkB;IAClB,4BAAmB;IAMO,yBAAA;A1B+oJ5B;;AAEA;I0BppJG,wBAAQ;A1BspJX;;AAEA;I0BrpJG,uBAAoB;A1BupJvB;;AAEA;I0BxpJC,6BAAA;IACC,cAAA;A1B0pJF;;AAEA;I0B1pJC,UAAA;A1B4pJD;;AAEA;I0B1pJE,mBAAkB;A1B4pJpB;;AAEA;I0B5pJC,kBAAA;I1B8pJG,oBAAoB;I0B5pJtB,oBpBnIU;IoBmIG,aAAA;I1B+pJX,4BAA4B;I0B9pJ/B,6BAAA;IACC,0BAAA;IAAA,sBAAA;IAAA,wBAAA;IACA,qBpBtIU;IoBsIE,uBAAA;I1BmqJV,yBAAyB;I0BlqJ5B,sBAAA;IACC,mBAAA;IAE6B,oBAAA;I1BmqJ3B,cAAc;I0BtqJhB,WAAA;IAGC,YAAA;IAA0B,kBAAA;I1BuqJzB,gBAAgB;I0BtqJnB,mBAAA;A1BwqJD;;AAEA;IACI,WAAW;I0BxqJd,kBAAA;IACC,SAAA;IAAA,SAAA;IAAA,UAAA;IACA,WAAA;IAAA,4BAAmB;A1B6qJrB;;AAEA;IACI,oCAAoC;A0B5qJvC;;A1B+qJD;I0B5qJE,oCAAmB;A1B8qJrB;;A0B3qJC;IACC,oCAAc;A1B8qJhB;;AAEA;I0B7qJE,oCAAkB;A1B+qJpB;;AAEA;I0B9qJE,cAAY;IACZ,cAAA;A1BgrJF;;AAEA;IACI,mBAAmB;I0B3rJrB,oBAAA;IAUC,YAAA;A1BorJH;;AAEA;I0BprJG,kBAAA;IAAwB,oBAAA;I1BurJvB,oBAAoB;I0BnsJtB,aAAA;IAcC,yBpBvKa;IoByKE,sBAAA;I1BurJd,mBAAmB;I0BvsJrB,kBAAA;IAgBE,mBpB1KQ;ANo2JZ;;AOh4JE;ImBwMC,kBAAiB;InBvML,QAAA;IPo4JX,WAAW;I0B5rJd,eAAA;IACC,6BAAmB;IAAG,wBAAA;I1B+rJpB,qBAAqB;A0B9rJxB;;A1BisJD;IACI,kBAAkB;I0BzqJrB,cAAA;A1B2qJD;;AAEA;I0BzqJE,qBAAA;IAgB2B,iBAAA;I1B4pJzB,6BAA6B;I0BhrJ/B,kBAAA;IAWC,cAAW;A1BwqJd;;AAEA;;I0BrqJG,cAAW;A1BwqJd;;AAEA;I0BtqJG,kCpB9Ma;IoB8MW,8BAAA;I1ByqJvB,0BAA0B;I0BxqJ7B,aAAA;A1B0qJD;;AAEA;I0B1qJE,uBAAA;A1B4qJF;;AAEA;I0B5qJE,uBAAA;A1B8qJF;;A0B7qJC;IACC,mBAAc;IAAd,cAAc;A1BirJhB;;AAEA;I0B/qJE,oBAAgB;IAChB,oBpBpOiB;IoBoOG,aAAA;I1BkrJlB,yBAAyB;I0BjrJ5B,sBAAA;IACC,mBAAa;IAAb,mBAAa;A1BorJf;;AAEA;I0BrrJE,aAAY;IAAG,iBAAA;I1BwrJb,mBAAmB;A0BvrJtB;;A1B0rJD;I0BzrJE,oBAAiB;IACjB,cAAc;IAAG,WAAA;I1B4rJf,YAAY;I0B3rJf,kBAAA;IACC,wDAAkB;IAClB,gDAAqB;IACrB,mBAAe;IACf,YAAA;IACA,oCAAuB;IACvB,+BAAkB;IAClB,4BAAkB;A1B6rJpB;;AAEA;I0B3qJ2B,eAAA;I1B6qJvB,aAAa;I0BxsJf,8BAAA;IAYC,yBAAW;IACX,sBAAkB;A1B+rJrB;;AAEA;I0B7rJG,6BAAY;A1B+rJf;;AAEA;I0BltJE,aAAA;A1BotJF;;AAEA;IACI,iBAAiB;A0BvtJnB;;A1B0tJF;IACI,mBAAmB;A0B3tJrB;;A1B8tJF;IACI,aAAa;A0B/tJf;;A1BkuJF;IACI,kBAAkB;I0BvsJrB,gBAAA;IACC,mBAAkB;IAClB,yBAAoB;A1BysJtB;;A0BxsJC;IACC,WAAA;IACA,kBAAM;IACN,SAAA;IACA,UAAQ;IACR,WAAS;IAAG,WAAA;I1B4sJV,0BAA0B;I0B3sJ7B,uBAAA;IACC,mBAAkB;IAClB,qBAAM;A1B6sJR;;AAEA;I0B3sJE,oBAAoB;IAUL,oBAAA;I1BosJb,aAAa;I0BptJf,yBAAA;IAQC,sBAAW;IAAG,mBAAA;I1BgtJb,YAAY;I0BxtJd,gCAAA;A1B0tJF;;AAEA;I0B5tJE,oBAAA;IAYC,cAAY;IAAG,YAAA;I1BotJd,kBAAkB;I0BhuJpB,eAAA;IAcC,gBAAY;IAAG,cAAA;A1BstJlB;;AAEA;I0BttJe,oBAAA;I1BwtJX,oBAAoB;I0BvtJvB,aAAA;IACC,mBAAkB;IAClB,oBAAU;IACV,YAAA;A1BytJF;;AAEA;I0B1tJE,mBAAA;IAAA,qBAAmB;IAEM,iBAAA;I1B4tJvB,cAAc;AOniKhB;;APsiKF;IACI,kBAAkB;I0B/tJrB,qBAAA;IACC,eAAA;IAAA,kBAAA;IAAA,uBAAa;IACb,kBAAA;IAAA,kBAAyB;IAAzB,eAAA;IACA,gBAAA;IAAA,iBAAA;A1BsuJF;;AAEA;I0BruJE,WAAA;IAAqB,kBAAA;I1BwuJnB,QAAQ;I0BvuJX,WAAA;IACC,WAAA;IACA,YAAA;IACA,kBAAkB;A1ByuJpB;;AAEA;I0BtuJuB,mBAAA;I1BwuJnB,cAAc;A0BvuJjB;;A1B0uJD;I0BzuJE,mBAAa;A1B2uJf;;AAEA;IACI,6BAA6B;A0BvuJhC;;A1B0uJD;I0BvuJE,mBAAe;A1ByuJjB;;AAEA;I0BltJ6B,kBAAA;I1BotJzB,oBAAoB;A0BhvJtB;;A1BmvJF;I0BvuJG,kBAAM;IACN,MAAO;IACP,WAAW;IACX,QAAA;IACA,SAAA;A1ByuJH;;A0BzvJE;IAkBC,kBpBvUY;IoBuUS,MAAA;I1B4uJpB,SAAS;I0B9vJX,UAAA;IAoBC,mBpBvVa;IoBuVS,oBAAA;A1B8uJzB;;AAEA;I0B9uJyB,WAAA;A1BgvJzB;;AAEA;IOvmKe,SAAA;APymKf;;AAEA;IO3mKe,YAAA;AP6mKf;;AAEA;I0BzuJ6B,YAAA;A1B2uJ7B;;AAEA;IMvjKE,SAAA;ANyjKF;;AAEA;I0BjvJ2B,kBAAA;I1BmvJvB,UAAU;IOz2JZ,oBAAA;ImB6HC,oBpBlXS;IoBkXI,aAAA;I1BgvJZ,yBAAyB;IO72J3B,sBAAA;ImB+HC,mBpBpXS;ANqmKZ;;AOh3JE;ImBkIC,mBpBvWW;ANylKd;;AOp3JE;ImBoIC,oBpBxXa;IoB0XM,oBAAA;I1BmvJlB,aAAa;IOz3Jf,qBAAA;ImBsIE,kBpB1XY;IoB0XI,yBAAA;I1BuvJhB,yBAAyB;IO73J3B,sBAAA;IP+3JE,mBAAmB;I0BtvJpB,YAAA;IAAa,cAAA;I1ByvJZ,kBAAkB;AOl4JpB;;APq4JF;IACI,eAAe;IOt4JjB,oCAAA;ImB6IC,kBAAA;IAEgC,eAAA;I1B2vJ/B,gBAAgB;IO14JlB,iBAAA;AP44JF;;AAEA;IO94JE,oBAAA;ImBiJC,oBAAA;IAA6B,aAAA;I1BiwJ5B,gBAAgB;IOl5JlB,eAAA;APo5JF;;AAEA;IOt5JE,kBAAA;ImBsJC,kBAAA;IAA2B,eAAA;I1BowJ1B,gBAAgB;IO15JlB,gBAAA;ImBwJC,cAAA;A1BqwJH;;AO75JE;ImB0JC,WAAA;IACA,kBAAA;IAAA,MAAA;IAEe,OAAA;I1BuwJd,WAAW;IOp6Jb,YAAA;ImB6JE,kBpBlZQ;AN4pKZ;;A2BzrKC;IACC,mBAAa;A3B4rKf;;AAEA;I2B1rK2B,6BAAA;A3B4rK3B;;AAEA;I2B3rKG,mBAAa;A3B6rKhB;;AAEA;IACI,mBAAmB;A2BlsKrB;;A3BqsKF;I2B9rKG,mBAAa;A3BgsKhB;;AAEA;IACI,mBAAmB;A2B9rKtB;;A3BisKD;IACI,gBAAgB;I2BhsKnB,aAAA;IACC,8BAAa;IAAb,sBAAa;IAAb,mBAAa;A3BosKf;;AAEA;I2BpsKE,cAAA;A3BssKF;;AAEA;I2BrsKE,aAAA;A3BusKF;;AAEA;;I2BvsKG,wBrBEa;ANwsKhB;;A2BltKE;IAUE,wBrBAY;AN4sKhB;;A2BttKE;IAYC,uBrBKiB;ANysKpB;;AAEA;;I2B7sKI,crBHU;ANmtKd;;A2B/sKC;IACC,aAAA;A3BktKF;;AAEA;I2BntKE,sCAAuB;A3BqtKzB;;AAEA;I2BttKE,sCAAmB;A3BwtKrB;;AAEA;I2BvtKE,sCAAY;A3BytKd;;AAEA;;IAEI,oCAAoC;A2BrtKvC;;A3BwtKD;IACI,oCAAoC;A2BvtKvC;;A3B0tKD;I2BztKE,iCAAY;A3B2tKd;;A2B1tKC;IACC,mBAAkB;IAClB,kDAAa;IAAb,0CAAa;A3B8tKf;;AAEA;I2B/tKE,aAAA;A3BiuKF;;AAEA;IACI,oBAAoB;I2BvuKtB,oBAAA;IAOC,aAAA;IACA,0BAAQ;A3BmuKX;;AAEA;I2BluKG,mBAAA;IAAA,iBAAA;IAAA,aAAA;IAAA,UAAA;A3BuuKH;;A2BruKC;IACC,mBAAkB;IAClB,iBrBpCiB;IqBoCG,aAAA;I3ByuKlB,UAAU;I2BxuKb,iBAAA;A3B0uKD;;AAEA;I2BxuKE,kBAAkB;A3B0uKpB;;AAEA;I2B1uKC,oBAAA;IACC,oBAAa;IAAb,aAAA;IAAA,yBAAa;IACb,sBAAY;IACZ,mBAAmB;IACnB,kBAAA;IAEmB,mBAAA;I3B6uKjB,cAAc;I2B5uKjB,6BAAA;IACC,wBAAa;IAAb,qBAAa;A3B+uKf;;AAEA;I2BhvKE,wBAAA;A3BkvKF;;AAEA;I2BnvKE,uBAAuB;A3BqvKzB;;AAEA;I2BrvKE,mBAAa;IAAb,cAAA;A3BwvKF;;AAEA;I2BvvKE,aAAA;A3ByvKF;;AAEA;I2BvvKE,oBrB9DiB;IqB+DjB,oBAAA;IAAA,aAAA;IAAA,wBAAoB;IASF,qBAAA;I3BmvKhB,uBAAuB;I2BzwKzB,yBAAA;IAeC,sBrBpEa;IqBsEM,mBAAA;I3B4vKlB,oBAAoB;I2B7wKtB,cAAA;IAiBE,WAAA;IAAgB,YAAA;I3BgwKhB,kBAAkB;I2BjxKpB,mBAAA;IAmBC,YAAA;A3BiwKH;;AAEA;I2BtxKE,gBAAA;A3BwxKF;;AAEA;I2BnwKC,mBAAA;IACC,oBAAa;IAAb,YAAA;A3BswKF;;AAEA;I2BvwKE,kBAAA;IACA,oBAAA;IAAA,oBAAA;IAAA,aAAA;IACA,yBAAW;IACX,sBAAY;IACZ,mBAAkB;IAClB,kBAAY;IAIe,mBAAA;A3BwwK7B;;AAEA;I2B3wKG,kBrBpFW;IqBqFX,QAAA;IAAA,UAAA;IAAA,eAAA;IAAwB,2CAAA;I3BgxKvB,mCAAmC;I2B/wKtC,8BAAA;IACC,2BAAgB;IAChB,oDAAa;A3BixKf;;AAEA;I2BjxKC,kBAAA;IACC,cAAA;A3BmxKF;;A2BlxKC;IACC,qBAAmB;IAAG,iBAAA;I3BsxKpB,6BAA6B;I2BrxKhC,kBAAA;IACC,cAAA;A3BuxKF;;AAEA;I2BvxKC,oBAAA;IACC,oBAAgB;IAAG,aAAA;I3B0xKjB,YAAY;IO1oKd,mBAAA;IoB3IC,yBrB1GS;ANk4KZ;;AO7oKE;IoBzIE,oBrB3GY;IqB6GO,oBAAA;I3ByxKnB,aAAa;IOlpKf,4BAAA;IoBvIG,6BrB7GW;IqB6GK,0BAAA;I3B6xKjB,sBAAsB;IOtpKxB,wBAAA;IoBrIE,qBrB7GU;IqB+GO,uBAAA;I3B6xKjB,yBAAyB;IO1pK3B,sBAAA;IoBnIG,mBrB/GS;IqB+GK,mBAAA;I3BiyKf,iBAAiB;IO9pKnB,aAAA;IoBjIC,UAAA;IAAY,YAAA;I3BmyKX,mBAAmB;IOlqKrB,eAAA;IoB/HC,gBAAA;IAA6B,gBAAA;I3BqyK5B,cAAc;IOtqKhB,6BAAA;IoB7HC,wBrBxHS;IqBwHG,qBAAA;A3BuyKf;;AAEA;I2BvyKgB,wBAAA;A3ByyKhB;;AAEA;I4Bj8KE,uBAAa;A5Bm8Kf;;AAEA;I4Bl8KC,6BAAA;IACC,cAAA;A5Bo8KF;;AAEA;I4Bn8KE,aAAa;A5Bq8Kf;;AAEA;I4Bp8KE,oBAAkB;IAGI,oBAAA;I5Bo8KpB,aAAa;I4Bn8KhB,wBAAA;IACC,qBAAA;IAAA,uBAAA;IAAA,yBAAoB;IACpB,sBAAA;IAAA,mBAAA;IAAA,WAAA;IACA,YAAA;IAAA,kBAAA;IAAA,YAAA;A5B28KF;;AAEA;I4Bz8KE,eAAA;IACA,aAAY;IAAG,8BAAA;I5B48Kb,yBAAyB;I4B38K5B,sBAAA;A5B68KD;;AAEA;I4B78KC,gBAAA;IACC,aAAa;IAAG,mBAAA;A5Bg9KlB;;AAEA;I4B/8KE,kBtBca;ANm8Kf;;A4Bh9KC;IACC,mBAAW;A5Bm9Kb;;AAEA;IACI,mBAAmB;I4Bn9KtB,cAAA;A5Bq9KD;;AAEA;I4Br9KC,gBAAA;A5Bu9KD;;AAEA;I4Bv9KC,cAAA;A5By9KD;;AAEA;I4Bz9KC,wBAAA;A5B29KD;;AAEA;IACI,uBAAuB;A4B39K1B;;A5B89KD;I4B79KE,cAAY;A5B+9Kd;;A4B99KC;IACC,aAAc;A5Bi+KhB;;AAEA;I4Bj+KE,aAAA;A5Bm+KF;;AAEA;I4Bj+K2B,sCAAA;A5Bm+K3B;;AAEA;IOxhLe,aAAA;AP0hLf;;AAEA;I4Bt+KE,cAAM;A5Bw+KR;;AAEA;IACI,oBAAoB;I4Bx+KvB,oBAAA;IACC,aAAA;A5B0+KF;;AAEA;I4B1+KE,oBAAmB;IACnB,cAAA;IAAA,YAAA;IACA,kBAAA;IAAA,aAAA;IAAA,mBAAA;IAAA,wDAA2B;IAA3B,gDAAA;IAA8B,kBAAA;A5Bk/KhC;;AAEA;I4Bj/KE,2BAAc;IAAd,2BAAc;IAAd,oBAAc;IACd,wBAAW;IACX,qBAAY;IACZ,uBAAkB;IAClB,yBAAkB;IAClB,sBAAA;IACA,mBAAA;IAAA,WAAA;IAAA,YAAA;IAa8B,mBAAA;I5B2+K5B,mBAAmB;I4BhgLrB,YAAA;A5BkgLF;;AAEA;I4Br/KG,gBAAS;A5Bu/KZ;;AAEA;I4Bv/KG,aAAU;A5By/Kb;;AAEA;I4Bv/KG,mBAAA;IAAA,cAAA;A5B0/KH;;AAEA;I4B3/KC,WAAA;IACC,gBAAA;IAAA,cAAA;A5B8/KF;;AAEA;I4B//KE,mBAAmB;A5BigLrB;;AAEA;IACI,YAAY;A4BjgLf;;A5BogLD;I4BlgLqB,qBAAA;A5BogLrB;;AAEA;I4BngLE,eAAY;IACZ,gBAAgB;A5BqgLlB;;A4BpgLC;IACC,mBAAA;IAAA,oBAAA;IAAsC,YAAA;A5BygLxC;;AAEA;I4BzgLE,cAAA;IAAsC,kBAAA;I5B4gLpC,yBAAyB;I4B3gL5B,sBAAA;IACC,qBtB1Ec;IsB2Ed,iBAAA;IAEgB,eAAA;I5B4gLd,6CAA6C;A4BhhL/C;;A5BmhLF;IACI,mBAAmB;AOz2KrB;;AP42KF;IACI,kBAAkB;IO72KpB,MAAA;IqBhKC,OAAA;IAAwB,UAAA;A5BihL3B;;AAEA;I4BjhLG,oBAAA;IAA0C,oBAAA;I5BohLzC,aAAa;IOt3Kf,kBAAA;IqB5JC,mBAAA;IAA6B,2CAAA;I5BshL5B,mCAAmC;IO13KrC,4CAAA;IqB1JC,oCAAA;IAAA,+BAAA;IAA2C,4BAAA;I5ByhL1C,sDAAsD;A6BjpLzD;;A7BopLD;I6BnpLE,kBAAa;IACb,mBAAe;IAAf,kBAAe;IACf,cAAA;IAEgC,WAAA;I7BqpL9B,YAAY;I6BppLf,kBAAA;IACC,kBAAA;IACA,yBvB2BW;IuB1BX,6BAAmB;IACnB,wBAAiB;IACjB,qBAAgB;A7BspLlB;;AAEA;I6BrpLE,WAAA;IAAA,kBAAA;IAOgB,QAAA;I7BkpLd,SAAS;I6BjqLX,wCAAA;IAaC,oCvBWa;IuBVb,gCvBUa;IuBTb,UAAA;IAAa,WAAA;I7BwpLZ,UAAU;I6BvpLb,+EAAA;IACC,iCAAkB;IAClB,4BAAa;IACb,yBAAmB;A7BypLrB;;AAEA;I6B9pLE,oBAAA;IAQC,oBAAW;IACX,aAAA;IACA,yBAAS;IACT,sBAAU;IACV,mBAAW;IACX,YAAa;IACb,gBAAW;A7BypLd;;AAEA;IMxoLE,cAAA;IACA,gBAAA;AN0oLF;;A6B5pLC;IACC,gBAAA;IAEe,YAAA;I7B8pLb,gBAAgB;A6B7pLnB;;A7BgqLD;IACI,qDAAqD;I6B7pLxD,6CAAA;A7B+pLD;;AAEA;I6B/pLE,qDAAkB;IAClB,6CAAmB;A7BiqLrB;;AAEA;I6B/pLE,6BAAoB;IAApB,+BAAoB;A7BkqLtB;;AAEA;IACI,UAAU;A6B/pLb;;A7BkqLD;I6BhqLE,aAAW;A7BkqLb;;AAEA;IACI,qBAAqB;A6BlqLxB;;A7BqqLD;I6BlqLE,mDAAkB;IAAG,2CAAA;A7BqqLvB;;AAEA;I6BrqLE,sCAA2B;A7BuqL7B;;AAEA;I6BrqL0B,4DAAA;I7BuqLtB,oDAAoD;A6BtqLvD;;A7ByqLD;I6BxqLE,oBAAa;IACb,oBAAe;IAAf,aAAA;IACA,mBAAA;IAAA,eAAA;IAAA,0BAAmB;A7B6qLrB;;AAEA;I6BzqLC,qBAAA;IACC,yBvBvCY;IuBwCZ,mBAAA;IAAA,iBAAA;IAAA,oBAAA;IAAyB,gBAAA;I7B8qLvB,cAAc;I6B7qLjB,6BAAA;IACC,wBAAiB;IAAG,qBAAA;A7BgrLtB;;AAEA;;I6B9qLE,6BAAsB;IAAtB,+BAAsB;IAAtB,cAAA;A7BmrLF;;A6BhrLC;IACC,kBAAmB;IAKS,aAAA;I7B+qL1B,mBAAmB;IOlxLrB,mBAAA;APoxLF;;AAEA;I6BlrLC,WAAA;IACC,kBAAA;IAEsB,SAAA;I7BmrLpB,UAAU;I6BlrLb,WAAA;IACC,aAAA;IACA,WAAA;IAoB0B,mBAAA;I7BiqLxB,aAAa;I6BvrLf,8BAAA;IAOC,sBvBnFS;IuByFS,mBAAA;A7B8qLrB;;AAEA;I6BhrLmB,mBAAA;A7BkrLnB;;AAEA;I6BjrLG,evB5FS;AN+wLZ;;A6BzqLC;IACC,oBAAiB;IACjB,oBAAkB;IAEK,aAAA;I7B2qLrB,kBAAkB;I6B1qLrB,mBAAA;IACC,uBAAgB;IAAG,cAAA;I7B6qLjB,eAAe;I6B5qLlB,6BAAA;IACC,wBAAa;IAAb,qBAAa;IAAb,6CAAa;A7BgrLf;;AAEA;I6B5qLC,oBAAA;IACC,cAAA;IAAA,WAAA;IAAA,YAAa;IACb,YAAA;A7BgrLF;;AAEA;I6B/qLsB,WAAA;I7BirLlB,gBAAgB;I6BhrLnB,kBAAA;A7BkrLD;;AAEA;IO10LE,mBAAA;IsBgKC,+BAAkB;ItB/JN,2BAAA;IP60LX,wBAAwB;I6B3qL3B,kBAAA;A7B6qLD;;AAEA;I6B7qLE,oBAAA;IAAA,oBAAuB;IAAvB,aAAA;IACA,mBAAA;IAAA,eAAA;IAAA,yBAAmB;IACnB,sBAAc;IAAd,mBAAc;IACd,mBAAW;A7BorLb;;AAEA;I6BlrLE,wBAAA;IAAA,+BAAA;IAAA,0BAAA;IAAA,uBAAA;A7BurLF;;AAEA;I6BlsLE,iBAAA;A7BosLF;;AAEA;IACI,mBAAmB;I6BvsLrB,cAAA;IAgBC,+BAAA;IAAA,0BAAA;IAA4C,uBAAA;A7B4rL/C;;AAEA;I6B5rLE,mBAAa;A7B8rLf;;AAEA;IOr3LE,mBAAA;APu3LF;;AAEA;IOx3Le,oCAAA;AP03Lf;;AAEA;I6B5rLiB,6BAAA;I7B8rLb,cAAc;A6B7rLjB;;A7BgsLD;I6B9rLuB,qBAAA;A7BgsLvB;;AAEA;I6B5rL8B,aAAA;A7B8rL9B;;AAEA;;IAEI,cAAc;A6B94LlB;;A7Bi5LA;IACI,iBAAiB;I6Bl5LrB,kBAAA;A7Bo5LA;;AAEA;IOnoLE,gBAAA;APqoLF;;AAEA;IOvoLE,oBAAA;IsBtDC,oBvB5KW;IuB8Ke,aAAA;I7B+rLzB,mBAAmB;AO3oLrB;;AP8oLF;IMj2LE,oBAAA;IAAA,oBAAA;IACA,aAAA;IuB8JyB,yBAAA;I7BusLvB,sBAAsB;IOnpLxB,mBAAA;IsB/CC,kBAAA;A7BqsLH;;AOtpLE;IsB3CC,gBAAA;A7BqsLH;;AO1pLE;IsBvCC,kBvB9MS;ANm5LZ;;AO9pLE;IsBlCC,oBvBnNS;IuBmNI,oBAAA;I7BqsLZ,aAAa;IOnqLf,wBAAA;IsBhCC,qBvBrNS;IuBqNI,uBAAA;I7BusLZ,yBAAyB;IOvqL3B,sBAAA;IsBxBE,mBvB7NQ;IuB6NI,oBAAA;I7BmsLZ,cAAc;IO3qLhB,WAAA;IsBtBE,YAAA;IAAA,kBAAA;IAA0C,YAAA;I7BssL1C,4CAA4C;IOhrL9C,oCAAA;IsBpBC,+BAAA;IAA6B,4BAAA;I7BwsL5B,sDAAsD;AOprLxD;;APurLF;IACI,cAAc;I8B38LlB,aAAA;A9B68LA;;AAEA;I8B17L4B,wDAAA;I9B47LxB,gDAAgD;A8B/8LnD;;A9Bk9LD;I8Bj9LE,oBAAa;IACb,oBAAA;IAAA,aAAA;A9Bo9LF;;AAEA;I8Br9LE,mBAAmB;IACnB,oBAAc;IAAd,gCAAc;A9Bw9LhB;;AAEA;I8Bt9LE,cAAA;A9Bw9LF;;AAEA;I8Bx9LE,iBAAA;IASwB,cAAA;A9Bk9L1B;;AAEA;I8B19LG,mBxBcS;AN88LZ;;AAEA;I8B59LG,cAAA;A9B89LH;;A8B7+LE;IAiBC,gBAAY;A9Bg+Lf;;AOj/LE;IuBmBC,mBAAkB;A9Bk+LrB;;AOpuLE;IuBzPC,cAAA;A9Bi+LH;;AOxuLE;IuBvPE,mBxBEQ;ANi+LZ;;A+B9/LC;IACC,gBAAA;IAAA,aAAA;IAAA,8BAAa;IACb,sBAAmB;IAGJ,mBAAA;A/BigMjB;;AAEA;I+BjgME,qCAAa;A/BmgMf;;AAEA;I+BpgME,6BAAmB;A/BsgMrB;;AAEA;I+BpgME,cAAA;A/BsgMF;;AAEA;IACI,cAAc;A+B/gMhB;;A/BkhMF;IACI,cAAc;A+BnhMhB;;A/BshMF;IACI,aAAa;A+BvhMf;;A/B0hMF;IACI,mDAAmD;I+B3hMrD,2CAAA;A/B6hMF;;AAEA;I+B/hME,sCAAA;A/BiiMF;;AAEA;IOxiME,cAAA;AP0iMF;;AAEA;I+BnhMC,oBAAA;IACC,oBAAyB;IAAzB,aAAA;A/BshMF;;AAEA;I+BhhM8B,oBAAA;I/BkhM1B,oBAAoB;I+BjhMvB,aAAA;IACC,wBAAc;IAAd,qBAAc;IACd,uBAAW;IACX,yBAAY;IACZ,sBAAmB;IACnB,mBAAgB;IAChB,oBAAY;IAAG,cAAA;I/BqhMb,WAAW;I+BphMd,YAAA;IACC,kBAAe;IACf,yBAAgB;IAAG,YAAA;I/BuhMjB,6BAA6B;I+BthMhC,wBAAA;IACC,qBAA2B;A/BwhM7B;;AAEA;I+BxhME,eAAA;IAAqB,aAAA;I/B2hMnB,YAAY;I+B1hMf,6BAAA;IACC,wBAAe;IxBrBf,qBAAgB;APkjMlB;;AAEA;I+B7hME,azBRY;ANuiMd;;AOl0LE;IwBxNC,kBAAA;A/B8hMH;;AAEA;IOx0LE,sCAAA;AP00LF;;AAEA;IgC9lMC,aAAA;AhCgmMD;;AAEA;IACI,oBAAoB;IgChmMvB,oBAAA;IACC,aAAA;IAAA,mBAAa;AhCmmMf;;AAEA;IgCjmM0B,oBAAA;IhCmmMtB,oBAAoB;IgClmMvB,aAAA;IACC,yBAAa;IAAb,sBAAa;IAAb,mBAAa;IACb,YAAA;IAAA,mBAAe;IACf,cAAA;IAA6B,iCAAA;IhCwmM3B,4BAA4B;IgCvmM/B,yBAAA;AhCymMD;;AAEA;IgCzmME,oCAAuB;AhC2mMzB;;AAEA;IgC5mME,mBAAA;AhC8mMF;;AAEA;IgC9mME,mBAAW;AhCgnMb;;AAEA;IgC9mME,mB1BqBc;AN2lMhB;;AAEA;IgChnME,YAAA;AhCknMF;;AgC7nME;IAaC,mBAAe;AhConMlB;;AAEA;IgCpnMG,mBAAA;IAAwB,6BAAA;IhCunMvB,yBAAyB;IgCtoM3B,sBAAA;IAkBC,iBAAA;AhCunMH;;AgCzoME;IAoBE,oB1BJQ;I0BII,cAAA;IhC0nMZ,WAAW;IgCznMd,YAAA;IACC,mBAAkB;IAClB,gBAAA;IAAA,YAAA;AhC4nMF;;AAEA;IgC1nME,eAAA;IACA,gBAAA;AhC4nMF;;AAEA;IgC7mMiC,mBAAA;IhC+mM7B,+BAA+B;IgCvoMjC,2BAAA;IAWC,wBAAW;IACX,kBAAkB;AhC+nMrB;;AAEA;IgC9nMG,eAAA;IAAA,gBAAA;IACA,0B1BrBS;I0BqBS,uBAAA;IhCkoMjB,mBAAmB;IgClpMrB,wBAAA;AhCopMF;;AAEA;IACI,oCAAoC;IgCvpMtC,cAAA;AhCypMF;;AAEA;IACI,cAAc;AgC5pMhB;;AhC+pMF;IACI,mBAAmB;IgCvoMtB,mBAAA;AhCyoMD;;AAEA;IgCvoMC,oBAAA;IACC,oBAAW;IACX,aAAa;IACb,aAAY;IACZ,gCAAgB;AhCyoMlB;;AAEA;IACI,oBAAoB;IgCzoMvB,oBAAA;IACC,aAAA;IAAA,mBAAa;IAAb,eAAa;IACb,0BAAe;AhC6oMjB;;AAEA;IgC7oM2B,oBAAA;IhC+oMvB,oBAAoB;IgC9oMvB,aAAA;IACC,wBAAkB;IAClB,qBAA0B;IAA1B,uBAAA;IAAA,yBAA0B;IAC1B,sBAAuB;IACvB,mBAAkB;IAClB,oBAAY;IACZ,cAAe;IAAG,WAAA;IhCmpMhB,YAAY;IgClpMf,qBAAA;IACC,kBAAkB;IAAG,mBAAA;IhCqpMnB,YAAY;IgCppMf,6BAAA;IACC,wBAAkB;IAClB,qBAAQ;AhCspMV;;AAEA;IgCppME,eAAY;IACZ,aAAA;IACA,8B1B/DU;I0BgEV,yBAAY;IACZ,sBAAkB;AhCspMpB;;AAEA;;IgC3oMgC,iCAAA;AhC8oMhC;;AAEA;;IgClpMG,aAAA;AhCqpMH;;AAEA;IgCvpMG,kBAAA;IAA6B,oBAAA;IhC0pM5B,cAAc;IgC/qMhB,WAAA;IAuBC,YAAA;IAAA,iBAAA;IAAA,kBAAA;IAA2B,mBAAA;IhC8pM1B,6BAA6B;IgC7pMhC,wBAAA;IACC,qBAAmB;AhC+pMrB;;AAEA;;IgC9pME,WAAA;IACA,kBAAgB;IAKK,QAAA;IhC6pMnB,SAAS;IgCpqMX,wCAAA;IAOC,oCAAe;IAAG,gCAAA;IhCiqMjB,mBAAmB;AgCxxMvB;;AhC2xMA;IgCjqMqB,UAAA;IhCmqMjB,WAAW;AO1gMb;;AP6gMF;IACI,UAAU;IO9gMZ,WAAA;APghMF;;AAEA;IOlhME,iCAAA;APohMF;;AAEA;IOthME,kBAAA;APwhMF;;AAEA;IO1hME,WAAA;IyB5IC,a1BzGS;I0ByGI,YAAA;IhC0qMZ,gBAAgB;IO9hMlB,YAAA;IyB1IC,eAAA;AhC2qMH;;AOjiME;IyBxIE,oB1B7GQ;I0B6GI,oBAAA;IhC8qMZ,aAAa;IiCxzMhB,mBAAA;IACC,eAAA;IAAA,gBAAA;IAAA,sBAAa;AjC4zMf;;AAEA;IiC1zMkC,kBAAA;IjC4zM9B,mBAAmB;IiC3zMtB,8BAAA;IACC,0BAAqB;IACrB,uBAAA;IACA,kBAAmB;IACnB,YAAA;IACA,eAAA;AjC6zMF;;AAEA;IiC5zME,kBAAA;AjC8zMF;;AAEA;IiCx0ME,kBAAA;IAaC,QAAA;IACA,UAAA;IACA,UAAA;IAAa,WAAA;IjC+zMZ,YAAY;IiC9zMf,kBAAA;IACC,mBAAkB;IAClB,YAAa;IACb,kBAAmB;IACnB,UAAA;IAWqB,6BAAA;IjCszMnB,wBAAwB;IiCr0M1B,qBAAA;AjCu0MF;;AAEA;IiC9zMG,cAAU;IACV,aAAW;IACX,2CAAa;IACb,mCAAW;I3BiBZ,8BAAmB;IACnB,2BAAa;IACb,oDAAsB;ANgzMxB;;AAEA;IACI,gCAAgC;IiCp0MnC,4BAAA;IACC,wBAAmB;AjCs0MrB;;AiCn0MC;IACC,mBAAe;IAEA,UAAA;AjCq0MjB;;AAEA;IiCr0ME,gBAAA;IAAA,gBAAa;AjCw0Mf;;AAEA;IiCt0ME,e3BlBiB;AN01MnB;;AAEA;IiCx0ME,WAAA;IACA,gBAAA;AjC00MF;;AiCr0MC;IACC,qCAAkB;AjCw0MpB;;AAEA;IiCv0ME,sCAAY;AjCy0Md;;AAEA;IiCz0MC,oCAAA;AjC20MD;;AAEA;IiC10MuB,mBAAA;AjC40MvB;;AAEA;IiC30ME,cAAM;AjC60MR;;AAEA;IiC70ME,mBAAa;AjC+0Mf;;AAEA;IiC/0ME,aAAA;AjCi1MF;;AAEA;IiCj1ME,oBAAY;IACZ,oBAAkB;IAClB,aAAA;IACA,mBAAY;IAAG,eAAA;IjCo1Mb,0BAA0B;AiCn1M7B;;AjCs1MD;IiCr1ME,qBAAY;IACZ,yBAAe;IAMU,mBAAA;IjCk1MvB,iBAAiB;IiCj1MpB,oBAAA;IACC,gBAAA;IACA,c3B5DY;I2B6DZ,6BAAsB;IAAtB,wBAAsB;IAAtB,qBAAsB;AjCq1MxB;;AiCp1MC;;IACC,6BAAa;IAAb,+BAAa;IACb,cAAA;AjCy1MF;;AAEA;IACI,kBAAkB;IiC11MrB,aAAA;IACC,mBAAiB;IAAG,mBAAA;AjC61MtB;;AAEA;IiC51ME,WAAA;IAAe,kBAAA;IjC+1Mb,SAAS;IiC31MZ,UAAA;IACC,WAAA;IAG4B,aAAA;IjC21M1B,WAAW;IOx8Mb,mBAAA;I0B6GE,aAAA;I1B5GW,8BAAA;IP28MX,sBAAsB;IiC91MzB,mBAAA;AjCg2MD;;AAEA;IiC91MC,mBAAA;AjCg2MD;;AAEA;IACI,eAAe;AiCn2MjB;;AjCs2MF;IACI,oBAAoB;IiCv2MtB,oBAAA;IAWE,a3BjGQ;I2BmGO,kBAAA;IjC81Mf,mBAAmB;IiC32MrB,uBAAA;IjC62ME,cAAc;IACd,eAAe;IiC71MhB,6B3BvGS;I2BuGI,wBAAA;IjCg2MZ,qBAAqB;IiCt1MxB,6CAAA;AjCw1MD;;AAEA;IiCx1ME,kBAAa;IACb,oBAAA;IAAA,cAAA;IAAA,WAAA;IACA,YAAA;IAAA,YAAA;AjC61MF;;AAEA;IiC71ME,WAAW;IACX,gBAAY;IACZ,kBAAkB;AjC+1MpB;;AAEA;IiCz2ME,kBAAA;IAiBC,MAAA;IACA,QAAA;IACA,oBAAS;IACT,oBAAS;IACT,aAAU;IACV,wBAAW;IACX,qBAAA;IAA6B,uBAAA;IjC41M5B,yBAAyB;IiCn3M3B,sBAAA;IAyBC,mBAAA;IAAsC,WAAA;IjC81MrC,YAAY;IiCv3Md,kBAAA;IA2BC,yBAAA;IAAoC,YAAA;AjCg2MvC;;AAEA;IiCh2MmC,mBAAA;IjCk2M/B,oBAAoB;IiCj2MvB,YAAA;IACC,eAAgB;AjCm2MlB;;AiCl2MC;IACC,kBAAiB;IACjB,cAAA;IAAqB,+BAAA;IjCs2MnB,0BAA0B;IiCr2M7B,uBAAA;AjCu2MD;;AAEA;IiCv2MC,oBAAA;IACC,oBAAmB;IACnB,aAAY;IAAG,mBAAA;IjC02Mb,eAAe;IiCz2MlB,mBAAA;AjC22MD;;AAEA;IiC32MC,iBAAA;AjC62MD;;AAEA;IOtiNE,iBAAA;I0B0LC,wBAAmB;AjC+2MtB;;AiC92MC;IACC,mBAAmB;AjCi3MrB;;AiCh3MC;IACC,mBAAa;AjCm3Mf;;AAEA;IiCp3MwB,oCAAA;AjCs3MxB;;AAEA;IiCt3ME,6BAAa;IAAb,cAAa;AjCy3Mf;;AAEA;IiCz3ME,qB3BvJY;ANkhNd;;AO9jNE;I0BqMC,aAAA;AjC63MH;;AiC53MC;;;IAEgB,cAAA;AjCg4MjB;;AAEA;IiC33M6B,kBAAA;IjC63MzB,oBAAoB;IO3zMtB,oBAAA;IDrNA,aAAA;IACA,wBAAa;IACb,qBAAA;IAAA,uBAAsB;IACtB,yBAAmB;I2BgJM,sBAAA;IjCq4MvB,mBAAmB;IOn0MrB,oBAAA;I0BhEC,cAAA;IACA,WAAA;IAE2B,YAAA;IjCq4M1B,kBAAkB;IOx0MpB,YAAA;AP00MF;;AAEA;IO50ME,WAAA;I0BxDC,kBAAA;IAEsB,SAAA;IjCs4MrB,SAAS;IOh1MX,UAAA;I0BpDC,WAAA;IAEsB,0BAAA;AjCs4MzB;;AAEA;IiCj4MgB,oCAAA;AjCm4MhB;;AAEA;IiCn4MkB,oCAAA;AjCq4MlB;;AAEA;IiCr4MgB,oCAAA;AjCu4MhB;;AAEA;IkClnNE,gBAAa;AlConNf;;AAEA;IACI,iBAAiB;IkCznNnB,kBAAA;AlC2nNF;;AAEA;IkCpnNG,gBAAU;AlCsnNb;;AAEA;IM5kNE,mBAAmB;IACnB,YAAa;AN8kNf;;AAEA;IkCznNqB,WAAA;AlC2nNrB;;AAEA;IkCznNG,eAAA;AlC2nNH;;AAEA;IkC3nNC,mBAAA;AlC6nND;;AAEA;IkC7nNC,mBAAA;AlC+nND;;AAEA;IkC/nNE,oBAAA;IAAA,oBAAA;IAAA,aAAA;IAAA,mBAAA;AlCooNF;;AAEA;IkCpoNE,oBAAmB;IAAG,oBAAA;IlCuoNpB,aAAa;IO/pNf,yBAAA;I2B2BC,sBAAmB;I3B1BP,mBAAA;IPkqNX,wBAAwB;AkCvoN3B;;AlC0oND;IkCzoNE,kBAAa;AlC2oNf;;AAEA;IkC5oNwB,kBAAA;IlC8oNpB,YAAY;AkC7oNf;;AlCgpND;IkC/oNE,mBAAa;AlCipNf;;AAEA;IkCjpNC,gBAAA;IACC,aAAA;IAAA,8BAA0B;IAA1B,sBAAA;IACA,mBAAA;AlCqpNF;;AAEA;IkCnpNE,sCAAe;IAAG,cAAA;AlCspNpB;;AAEA;IkCtpNE,+BAAa;AlCwpNf;;AAEA;IACI,qCAAqC;AOrsNvC;;APwsNF;IACI,6BAA6B;AkC1pNhC;;AlC6pND;IkC1pNE,c5BlBiB;AN8qNnB;;AAEA;IkC3pNsB,wBAAA;AlC6pNtB;;AAEA;IkC/pNoB,cAAA;AlCiqNpB;;AAEA;IkC5pN6B,kBAAA;IlC8pNzB,aAAa;IOz8Mf,mBAAA;IDrNA,mBAAgB;ANiqNlB;;AAEA;IMhqNE,WAAA;I4BHyB,kBAAA;IlCsqNvB,SAAS;IOj9MX,UAAA;I2BnNC,WAAA;IAA6B,aAAA;IlCwqN5B,WAAW;ImCvuNd,mBAAA;IACC,aAAA;IAAA,8BAAa;IAAb,sBAAa;IAEO,mBAAA;AnC0uNtB;;AAEA;ImCzuNG,mBAAY;IAAZ,oBAAY;IAEa,gCAAA;AnC2uN5B;;AAEA;ImC3uNG,mBAAc;AnC6uNjB;;AAEA;IACI,oBAAoB;ImCruNvB,oBAAA;IACC,aAAA;IACA,4BAAa;IACb,6B7BKU;I6BJV,0BAAmB;IAWE,sBAAA;InC6tNnB,wBAAwB;ImC5uN1B,qBAAA;IAQC,uBAAW;IACX,mBAAkB;AnCuuNrB;;AAEA;ImCruNG,mBAAa;AnCuuNhB;;AAEA;IMptNE,oBAAA;IAAA,oBAAA;IACA,aAAA;I6BpBmB,yBAAA;InC4uNjB,sBAAsB;ImC3uNzB,mBAAA;AnC6uND;;AAEA;ImC3uNC,oBAAA;IACC,oBAAa;IAAb,aAAA;IAAA,cAAa;AnC+uNf;;AmC5uNC;IACC,mBAAa;IAAb,8BAAa;IAAb,0BAAa;IACb,2BAAsB;IAAtB,YAAA;IAAA,aAAA;IAAA,UAAA;IACA,eAAA;AnCovNF;;AAEA;ImCrvNE,oBAAc;IACd,oBAAY;IACZ,aAAA;IAK4B,mBAAA;AnCmvN9B;;AAEA;IO3yNe,kBAAA;AP6yNf;;AAEA;ImCrvNiB,oBAAA;InCuvNb,gBAAgB;ImCtvNnB,cAAA;IACC,+BAAkB;IAClB,0BAAa;IAAb,uBAAa;AnCyvNf;;AAEA;ImCxvNE,wBAAmB;AnC0vNrB;;AAEA;ImCzvNE,mBAAA;AnC2vNF;;AAEA;IACI,gBAAgB;ImCtwNlB,aAAA;IAeC,8BAAW;I5B1BZ,sBAAkB;IAClB,mBAAM;APqxNR;;AAEA;ImC5vNG,sCAAuB;AnC8vN1B;;AAEA;ImC7vNsB,oBAAA;InC+vNlB,oBAAoB;ImCnxNtB,aAAA;AnCqxNF;;AAEA;ImCvxNE,mBAAA;IAwBC,oB7BxDS;I6B4DgB,YAAA;AnC+vN5B;;AAEA;ImCjwN0B,oBAAA;InCmwNtB,cAAc;ImClwNjB,YAAA;IACC,sBAAkB;AnCowNpB;;AAEA;ImCnwNE,kBAAW;IACX,aAAY;IACZ,mBAAY;IAAG,mBAAA;AnCswNjB;;AAEA;ImCrwNE,WAAA;IACA,kBAAkB;IAAG,SAAA;InCwwNnB,UAAU;ImCvwNb,WAAA;IACC,aAAA;IACA,WAAM;IACN,mBAAQ;IACR,aAAA;IAAA,8BAAa;IAAb,sBAAa;IACb,mBAAA;AnC2wNF;;AAEA;ImC5wNE,mBAAA;AnC8wNF;;AAEA;ImC7wNE,oBAAkB;IAClB,oBAAmB;IACnB,aAAA;AnC+wNF;;AAEA;ImC/wNC,oBAAA;IACC,oBAAkB;IAClB,aAAU;IACV,4BAAY;IAAZ,6BAAY;IAAZ,0BAAY;IACZ,sBAAsB;IAMG,wBAAA;InC8wNvB,qBAAqB;ImC7wNxB,uBAAA;IACC,oBAAkB;IAClB,c7B/FY;I6BgGZ,YAAA;IAAA,mBAAA;AnCgxNF;;AAEA;ImCjxNC,mBAAA;AnCmxND;;AAEA;ImCnxNE,mBAAe;AnCqxNjB;;AAEA;IACI,kBAAkB;ImCtxNrB,oBAAA;IACC,oBAAiB;IAAG,aAAA;InCyxNlB,kBAAkB;ImCxxNrB,gBAAA;IACC,mBAAiB;IACjB,c7B5FY;I6B6FZ,eAAA;IAAA,6BAAsB;IAAtB,wBAAsB;IAAG,qBAAA;InC6xNvB,6CAA6C;AOt6N/C;;APy6NF;IACI,WAAW;ImC5xNb,kBAAA;InC8xNE,MAAM;ImC3xNP,OAAA;IAAa,WAAA;InC8xNZ,YAAY;ImCvxNf,uBAAA;IACC,oCAAkB;IAClB,+BAAU;IACV,4BAAa;AnCyxNf;;AAEA;ImC1xNE,oCAAuB;AnC4xNzB;;AAEA;ImC7xNE,cAAA;AnC+xNF;;AAEA;ImC9xNE,6BAAY;AnCgyNd;;AAEA;ImChxN2B,kBAAA;InCkxNvB,UAAU;ImC5yNZ,oBAAA;IAmBC,cAAW;IACX,WAAA;IACA,YAAS;IACT,YAAS;AnC4xNZ;;AAEA;ImC1xNG,WAAA;IAAsB,gBAAA;InC6xNrB,kBAAkB;AmC5xNrB;;AnC+xND;IACI,kBAAkB;ImC9xNrB,MAAA;IACC,QAAA;IACA,oBAAkB;IAAG,oBAAA;InCiyNnB,aAAa;ImChyNhB,wBAAA;IACC,qBAAgB;IAAG,uBAAA;InCmyNjB,yBAAyB;IOz9N3B,sBAAA;I4BwLA,mBAAgB;I5BvLH,WAAA;IP49NX,YAAY;IO/sNd,kBAAA;I4B/EC,mB7BnJW;I6BqJe,yBAAA;InCgyNzB,YAAY;AOntNd;;APstNF;IMz6NE,kBAAA;IAAA,UAAA;IACA,mBAAmB;I6BqIM,oBAAA;InCwyNvB,YAAY;IO3tNd,sBAAA;AP6tNF;;AAEA;IO/tNE,kBAAA;I4BtEC,cAAA;IAEsB,+BAAA;InCuyNrB,0BAA0B;IOnuN5B,uBAAA;APquNF;;AAEA;IoCz/NC,oBAAA;IACC,oBAAmB;IACnB,aAAA;IACA,mBAAgB;IAChB,eAAgB;IAChB,mB9B6BkB;AN89NpB;;AoC1/NC;IAEC,iBAAW;ApC4/Nb;;AAEA;IM9+NE,iBAAA;I8BXA,wBAAe;IACf,+BAAgB;IAChB,0B9BiBY;I8BhBZ,uBAAA;ApC4/NF;;AAEA;IACI,mBAAmB;AoCzgOrB;;ApC4gOF;;IAEI,cAAc;AoChgOjB;;ApCmgOD;IoCjgOoB,kBAAA;IpCmgOhB,UAAU;IoClgOb,oBAAA;IACC,oBAAa;IACb,aAAA;IACA,wBAAY;IAAG,qBAAA;IpCqgOb,uBAAuB;IO7wNzB,yBAAA;I6BlPC,sB9BHS;I8BIT,mBAAA;IAAsC,oBAAA;IpCmgOrC,cAAc;IqCriOlB,WAAA;IACC,YAAA;IACA,mBAAgB;IAChB,kBAAiB;IACjB,YAAA;ArCuiOD;;AAEA;IqCviOC,WAAA;IACC,kBAAa;IACb,SAAA;IAAsB,SAAA;IrC0iOpB,UAAU;IqCziOb,WAAA;IACC,0BAAmB;IAEM,mBAAA;ArC0iO3B;;AAEA;IqC1iOE,gBAAA;ArC4iOF;;AAEA;IqC5iOE,iBAAA;IAEmB,kBAAA;ArC6iOrB;;AAEA;IqC5iOE,gBAAA;ArC8iOF;;AAEA;IqC5iOE,gBAAgB;ArC8iOlB;;AAEA;IqC9iOE,mBAAoB;ArCgjOtB;;AqCxjOE;IAWC,gBAAA;IACA,aAAA;IACA,8B/BFS;I+BEI,sBAAA;IrCkjOZ,mBAAmB;AqCjjOtB;;ArCojOD;IqCjjOE,cAAA;ArCmjOF;;AAEA;IqCjjOE,qCAAgB;ArCmjOlB;;AAEA;IqCjjOE,cAAe;ArCmjOjB;;AAEA;IqCljOE,cAAA;IAAA,oBAAoB;IAKS,gBAAA;IrCijO3B,iBAAiB;IqCpkOnB,eAAA;IAgBC,qBAAa;IAAG,cAAA;ArCwjOnB;;AAEA;;IqCvjO6B,WAAA;IrC0jOzB,kBAAkB;IO5mOpB,uBAAA;I8BqDC,mCAAmB;IACnB,gCAAoB;IACpB,eAAA;I9BtDY,cAAA;IPinOX,6BAA6B;IqCxjOhC,wBAAA;IACC,qBAAmB;ArC0jOrB;;AAEA;;IqCzjOE,uCAAa;IAAb,YAAA;ArC6jOF;;AAEA;IqC9jOC,YAAA;IACC,eAAA;ArCgkOF;;AAEA;IqC/jOE,aAAY;IAGM,kBAAA;IrC+jOhB,YAAY;AqC9jOf;;ArCikOD;;IqC7jOE,cAAA;IAAgC,qCAAA;ArCikOlC;;AAEA;IqCjkOE,kBAAA;IAAA,gBAAA;IACA,iBAAA;IACA,mBAAkB;IAIM,mBAAA;ArCikO1B;;AAEA;IqCjkOE,mBAAa;ArCmkOf;;AAEA;IACI,mBAAmB;AqCjkOtB;;ArCokOD;IqC7jO0B,oBAAA;IrC+jOtB,oBAAoB;IOhqOtB,aAAA;I8BqGC,mBAAkB;I9BpGN,eAAA;IPmqOX,0BAA0B;AqC5jO7B;;ArC+jOD;IqC5jOE,qBAAmB;IAAG,yBAAA;IrC+jOpB,mBAAmB;IqC9jOtB,iBAAA;IACC,oBAAkB;IAClB,gBAAM;IACN,cAAO;IACP,6BAAgB;IAChB,wBAAU;IAAG,qBAAA;ArCikOf;;AAEA;;IAEI,6BAA6B;IqClkOhC,+BAAA;IACC,c/BpFkB;ANwpOpB;;AqCjkOC;IACC,eAAA;IAAsB,YAAA;IrCqkOpB,mBAAmB;IO9rOrB,sBAAA;I8B4HC,wBAAmB;I9B3HP,qBAAA;IPisOX,gBAAgB;IqCrkOnB,YAAA;IACC,mBAAa;IAAb,sHAAa;IAAb,eAAa;IACb,gBAAc;IAKW,cAAA;IrCqkOvB,6BAA6B;IOzsO/B,wBAAA;I8BoIC,qBAAmB;ArCwkOtB;;AqCvkOC;IACC,aAAA;ArC0kOF;;AAEA;IqC1kOE,kBAAa;IAMe,uBAAA;ArCukO9B;;AAEA;IqCnkOE,mBAAS;IACT,oBAAW;IACX,gCAAW;ArCqkOb;;AAEA;IqCnkOE,mBAAU;IACV,cAAY;ArCqkOd;;AAEA;IqCrkOE,oBAAA;IAAA,oBAAA;IAAA,aAAA;ArCykOF;;AAEA;IqC1uOA,oBAAA;IAqKG,cAAA;IAAA,WAAA;IAA4C,YAAA;IrC0kO3C,YAAY;AqCxkOhB;;ArC2kOA;IACI,WAAW;IqCnkOf,gBAAA;IACC,kBAAA;IAA4B,6BAAA;ArCskO7B;;AAEA;IqCnkOI,mBAAA;IAAA,+BAAA;IAAA,2BAAA;IACA,wBAAA;IAAA,kBAAA;ArCwkOJ;;AAEA;IqC9kOA,oBAAA;IAMI,oBAAU;IACV,aAAA;IAAA,mBAAA;ArC4kOJ;;AAEA;IqCrlOA,gBAAA;IAUM,YAAU;ArC8kOhB;;AAEA;;IAEI,kBAAkB;AqC5lOtB;;ArC+lOA;IACI,kBAAkB;IqChmOtB,gBAAA;IAgBM,mBAAA;ArCmlON;;AAEA;IqCplOmB,kBAAA;IrCslOf,MAAM;IqCvmOV,OAAA;IAmBM,gBAAU;IAAG,UAAA;ArCwlOnB;;AAEA;IqCxkOwB,mBAAA;ArC0kOxB;;AAEA;IqCxlOgB,cAAA;ArC0lOhB;;AAEA;IqC1lOgC,mBAAA;ArC4lOhC;;AAEA;IqCxlO+C,kBAAA;ArC0lO/C;;AAEA;IqC5lOI,oBAAA;IAAyC,oBAAA;IrC+lOzC,aAAa;IOhiOf,cAAA;APkiOF;;AAEA;IOpiOE,mBAAA;APsiOF;;AAEA;IOxiOE,mBAAA;I8BxDA,8BAAA;IAA4B,0BAAA;IrComO1B,uBAAuB;IsC9zOzB,aAAA;AtCg0OF;;AAEA;IsCh0OE,kBAAA;IACC,SAAA;IAAc,WAAA;ItCm0Ob,WAAW;IsCl0Ob,YAAA;IACC,kBhCwBS;IgCxBI,mBAAA;ItCq0OZ,UAAU;IsCp0OZ,YAAA;IACC,+EhCiCW;IgCjCI,4CAAA;ItCu0Od,oCAAoC;IsCt0OtC,+BAAA;IACC,4BhCoCW;IgCpCI,sDAAA;ItCy0Od,6CAA6C;AsCt0O/C;;AtCy0OF;IACI,wDAAwD;IsCx0O1D,gDAAA;AtC00OF;;AAEA;IsCt0OC,aAAA;AtCw0OD;;AAEA;IsCx0OE,iCAAA;AtC00OF;;AAEA;IsC10OC,UAAA;IACC,wChCgBkB;IgCdqB,mCAAA;ItC20OrC,gCAAgC;IsC50OlC,6BAAA;IACC,yBAAA;IAAoC,qBAAA;AtC+0OvC;;AAEA;IsC70OqC,UAAA;ItC+0OjC,qCAAqC;IsCh1OvC,gCAAA;IACC,6BAAA;AtCk1OH;;AsCj1OC;IACC,UAAA;IAA4B,2BAAA;ItCq1O1B,uBAAuB;IsCp1O1B,mBAAA;AtCs1OD;;AAEA;IsCt1OE,YAAA;AtCw1OF;;AAEA;IsCx1OC,6BAAA;IACC,yBhCFkB;IgCEQ,qBAAA;ItC21OxB,UAAU;AsC11Ob;;AtC61OD;IACI,UAAU;AsC51OZ;;AtC+1OF;IACI,mBAAmB;AsC91OtB;;AtCi2OD;IACI,cAAc;AsCh2OhB;;AtCm2OF;IACI,sCAAsC;AsCl2OzC;;AtCq2OD;IACI,yDAAga;AsCp2Ona;;AtCu2OD;IACI,kDAAkD;IsCt2OpD,0CAAA;AtCw2OF;;AAEA;IsCt2OC,2CAAA;AtCw2OD;;AAEA;IsCx2OC,gBAAA;AtC02OD;;AAEA;IsC12OC,iCAAA;AtC42OD;;AAEA;IsC32OA,cAAA;AtC62OA;;AAEA;IsC72OA,cAAA;AtC+2OA;;AAEA;IsC/2OA,cAAA;AtCi3OA;;AAEA;IsC/2OC,cAAA;AtCi3OD;;AAEA;IsCl3O0B,wBAAA;AtCo3O1B;;AAEA;IsC72OsB,wBAAA;AtC+2OtB;;AAEA;IsCr2OsB,cAAA;AtCu2OtB;;AAEA;IsC71OsB,mBAAA;AtC+1OtB;;AAEA;IsC11OC,mCAAgB;AtC41OjB;;AAEA;IsC51OC,mBAAA;AtC81OD;;AAEA;IsC31OyB,oCAAA;AtC61OzB;;AAEA;IsC51OE,mBAAiB;AtC81OnB;;AsC71OC;IACC,oCAAe;AtCg2OjB;;AAEA;IsCh2OC,mBAAA;AtCk2OD;;AAEA;IACI,mBAAmB;AsCj2OvB;;AtCo2OA;IACI,oCAAoC;AACxC;;AAEA;IsCl2Oe,mBAAA;AtCo2Of;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AsCn2OxC;;AtCs2OA;IsCn2OC,6BAAgB;AtCq2OjB;;AsCn2OA;IACC,mCAAe;AtCs2OhB;;AAEA;IsC/1OA,mBAAA;AtCi2OA;;AAEA;IACI,mBAAmB;AsCz1OvB;;AtC41OA;IsCt1O4B,mCAAA;AtCw1O5B;;AAEA;IsCt1OC,iBAAgB;AtCw1OjB;;AAEA;IsCv1OA,kBAAA;AtCy1OA;;AAEA;IACI,yBAAyB;AsCx1O7B;;AtC21OA;IsCz1OwB,YAAA;AtC21OxB;;AAEA;IsCz1OC,iBAAgB;AtC21OjB;;AAEA;IsC11OA,kBAAA;AtC41OA;;AAEA;IsC31OwB,2BAAA;ItC61OpB,wBAAwB;IMvhP1B,qBAAA;ANyhPF;;AAEA;Ia/2OsB,aAAA;Abi3OtB;;AAEA;I0BxgPsB,aAAA;A1B0gPtB;;AAEA;I0BnqO4B,aAAA;A1BqqO5B;;AO/gPE;IACE,eAAA;IGeF,mBAAW;IHdI,gBAAA;APmhPjB;;AI9wOA;;;IJmxOI,kCIhxOK;IACP,gBAAA;IACE,oBAAe;AJixOnB;;AAEA;IIhxOI,eAAU;IAAG,iBAAA;AJmxOjB;;AAEA;IIlxOgB,eAAA;IACd,oBAAA;AJoxOF;;AAEA;IInxOE,eAAA;IACE,kBAAA;AJqxOJ;;AAEA;;;;;;IIhxOI,kCAAA;AJuxOJ;;AAEA;;;IIrxOe,gBAAA;IACb,oBAAA;AJyxOF;;AAEA;;;IIrxOI,gBAAA;AJyxOJ;;AAEA;IIxxOiB,eAAA;ID8pBhB,oBAAA;AH6nND;;AAEA;IQ/+OG,eAAA;IAiBmB,gBAAA;ARi+OtB;;AAEA;IQ7+OI,eAAA;IACA,gBAAA;AR++OJ;;AAEA;IQx+OoB,eAAA;IA2EnB,gBAAA;IAGE,sBAAoB;AR85OvB;;AAEA;IanjP0B,eAAA;II7CzB,oBAAA;AjBmmPD;;AAEA;IACI,eAAe;IM9nPjB,oBAAA;ANgoPF;;AAEA;IQnnPG,eAAA;IAIyB,gBAAA;IAC3B,oBAAA;ARknPD;;AAEA;IQ9mPI,eAAA;IAAA,gBAAA;IAAA,oBAAa;ARknPjB;;AAEA;IQtnPG;QAcE,8BAA0B;QAA1B,sBAAA;IAAA;;IAEA;QACA,8BAAU;QAUO,sBAAA;IACnB;;IAKoB;QACrB,8BAAA;QAEE,sBAAa;IAAb;ARimPJ;;AAEA;IQrmPG;QASE,YAAU;IASK;ARulPpB;;AAEA;;;IQnkPK;;MAEA;IAiBoB;QA3DtB,eAAA;QAgDG,gBAAa;IAAb;;IACA;QAEoB,UAAA;IAnDvB;;IAsDG;QAAA,MAAA;QACA,SAAA;IACA;;IAIL;QAKE,eAAU;QAeS,gBAAA;IApBpB;;IAasB;QAbtB,8BAAA;QAoBE,SAAW;QAAK,SAAA;QACnB,SAAA;QAEE,gBAAgB;QAAK,eAAA;QAlJxB,8BAAA;QA4JG,sBAAa;IAAb;;IACA;QACA,UAAS;IACT;;IAawB;QAwB1B,UAAA;QAEE,QAAA;IAAA;;IACA;QAAA,MAAA;QAAA,QAAA;QACA,WAAA;QAiB8B,YAAA;QArB/B,iBAAA;QAUE,8BAA0B;QAA1B,eAAA;QAAA,kBAAA;QACA,UAAA;IACA;ARkhPJ;;AAEA;IOjuPe;QCuNd,oBAAA;IAKE;;IAGD;QAIE,mBAAgB;QAChB,gCAAU;QACV,4BAAY;QAAK,6BAAA;IA6CpB;;IAGE;QAEoB,YAAA;IA+BtB;;IAI2B;QCxD3B,oBAAA;IASE;;IATD;QAwBE,kBAAa;IAAK;;IInNnB;QAAuB,YAAA;IAkGzB;AbmlPD;;AAEA;IahlPG;QASuB,WAAA;QAdxB,gBAAA;IAOE;;IAEA;QACA,cAAU;IACV;;IAEA;QPnIF,oBAAmB;QACnB,oBAAa;QACb,aAAA;QAAA,eAAA;QACA,eAAA;IOiIoB;;IClLpB;QAoEoB,mBAAA;QA5EtB,8BAAA;QAoBG,0BAAW;QACX,2BAAY;QAAZ,cAAA;QAAA,UAAY;IACZ;;IGrBF;QAOE,YAAA;IAKuB;;IAyBvB;QACA,oBAAY;QAYW,oBAAA;QChDzB,aAAA;QAIE,eAAc;IACd;;IACF;QAKE,UAAW;IACX;;IXbD;QWgBE,iBAAmB;QXfR,oBAAA;ImBFd;;IAQE;QACA,SAAA;QACA,kBAAgB;QAWK,mBAAA;IArBtB;;IAqBoB;QACrB,mBAAA;QAEE,iBAAkB;QAClB,aAAa;QACb,cAAA;IACA;;IALD;QAOE,mBAAW;QACX,iBAAkB;QAClB,aAAS;QACT,cAAU;QACV,8BAAW;IACX;;IpBmBF;QACA,UAAa;IACb;;IACA;QoBpBoB,eAAA;IAdpB;;IAoBE;QAIsB,WAAA;IAxBxB;;IAwBsB;QAxBtB,gBAAA;IA6BE;;IACH;QAGE,mBAAa;QAAb,iBAAa;QAAb,aAAa;QACb,cAAA;QAAA,SAAA;QACA,kBAAqB;QAGD,mBAAA;IACtB;;IAUE;QAAA,oBAAA;QACA,oBAAuB;QACvB,aAAA;QA8B2B,wBAAA;QnBtG5B,qBAAA;QmBoGE,uBAAgB;QnBnGL,eAAA;ImB0Md;;IAIE;QAAqB,mBAAA;QAqBvB,8BAAA;QAME,0BAAe;QAcW,2BAAA;QnBxP3B,cAAA;ImB0XE;;InBzGF;QmBoHE,gBAAgB;IAES;;IAGzB;QAE4B,iBAAA;InB3H9B;;IDpNA;QACA,gBAAA;QAAA,UAAA;QACA,YAAA;IoB6U0B;;IC9VzB;QAEmB,eAAA;QEmBrB,oBAAA;IAKE;;IAiEF;QAIE,iBAAmB;IAEA;;IAUnB;QACA,uBAAY;IAQa;;IE/JzB;QACA,aAAS;IAAK;;IA0Bd;QACA,kBAAS;IAGkB;;IAA1B;QxBjCW,kBAAA;Q0B+Ed,aAAA;QAIE,mBAAgB;QAIQ,mBAAA;IAqD1B;;IA6BoC;QEvKnC,WAAA;QAUE,kBAAY;QACZ,SAAA;QAKoB,UAAA;QAqBvB,WAAA;QAGE,aAAc;QAAK,WAAA;QACrB,mBAAA;QAQE,aAAa;QAGc,8BAAA;QA0D7B,sBAAA;QAME,mBAAgB;IAIQ;;IA0CxB;QAawB,eAAA;IG9B3B;;IAKE;QAGyB,WAAA;QAE3B,mBAAA;QAIE,oBAAe;QACf,YAAA;QAI0B,kBAAA;InC06B3B;;IG3kCC;QEuDA,kBAAA;IAKE;;IAsDuB;QA3DxB,WAAA;QAWE,YAAA;IAAA;;IACA;QACA,cAAe;QAKA,SAAA;IAlBjB;;IAwBE;QAAA,WAAA;QACA,SAAA;IACA;;IAWwB;QArC1B,mBAAA;IA4CE;;IAeoB;QA3DtB,cAAA;QAmDG,UAAA;QAAoB,gBAAA;QAnDvB,gBAAA;IA0DG;;IACiB;QAyBtB,aAAA;IAEE;;IArJH;QAkKG,kBAAU;QAUc,aAAA;QA5K3B,mBAAA;QAqKI,mBAAe;IACf;;IAtKJ;QAyKI,WAAA;QAAoB,kBAAA;QDvKtB,SAAA;QC0KE,UAAA;QDzKW,WAAA;QADb,aAAA;QC8KE,WAAA;QD7KW,mBAAA;QCiQd,aAAA;QAGE,8BAAc;QAUM,sBAAA;QAbrB,mBAAA;IAUG;;IACqB;QAGzB,WAAA;QAEE,mBAAe;IAAK;;IAepB;QAAwB,cAAA;IAnS3B;;IAqToC;QACnC,kBAAA;IAEE;;IACF;QAIE,oBAAoB;QAAK,oBAAA;QC7T5B,aAAA;QAWE,mBAAiB;QACjB,eAAgB;QAChB,qBAAA;IAAA;;IAAA;QAAA,mBAAA;QAwf6B,8BAAA;QA9d9B,0BAAA;QAUE,uBAAwB;QAAxB,mBAAwB;IAAxB;;IAEA;QACA,gBAAA;IAAA;;IAKqC;QAGvC,qBAAA;QAEE,gBAAA;IAAA;;IAIe;QACjB,eAAA;IAGE;;IAcF;QAQE,kBAAa;IAAb;;IAIkB;QACpB,gBAAA;IAWE;;IAkBD;QAiBG,mBAAA;IAAA;;IAMgB;QACpB,gBAAA;QAKE,aAAA;QACA,8BAAwB;QAAxB,sBAAA;QAAA,mBAAA;IAUuB;;IAcvB;QACA,aAAA;IAWe;;IAWf;QACA,kBAAY;IACZ;;IACA;QAAA,mBAAA;IAWuB;;IAyBvB;QAAA,gBAAA;QAAA,YAAA;IAYoB;;IAmFpB;QAAA,cAAA;QAAA,SAAA;IAEsB;;IA4CtB;QAAA,WAAA;QAAA,SAAA;IAIoB;;IAgBpB;QAYwB,mBAAA;IA/Z3B;;IA8agC;QA9ahC,gBAAA;IAibG;;IAjbH;QAsbG,aAAA;IAE8B;;IAO9B;QAEe,YAAA;QAjclB,kBAAA;IAwcG;;IAUuB;QAld1B,cAAA;IA2cI;;IA3cJ;QAqdG,aAAW;IACX;;IAtdH;QAgeG,gBAAe;IAIK;;IAGpB;QACA,aAAS;IACT;;IAEA;QACA,eAAY;QAKQ,gBAAA;IAjfvB;;IA4fuB;QA5fvB,eAAA;QA+fG,gBAAe;IAMW;AT6mP7B;;AAEA;IiBtmQC;QAIE,cAAgB;QAEI,SAAA;IACtB;;IAGE;QAAqB,oBAAA;QAKvB,oBAAA;QAYE,aAAQ;QACR,eAAA;QAAA,eAAA;IAAA;;IASuB;QCRzB,mBAAA;QAGE,8BAAkB;QAEG,0BAAA;QCtBvB,2BAAA;QAeE,cAAQ;QACR,UAAW;IACX;;ICbF;QAQE,eAAkB;QAaG,gBAAA;IAKvB;;IAaE;QAewB,eAAA;IAG1B;;IAOyB;QAMzB,eAAA;QAME,YAAA;IAKuB;;IAMvB;QAAkB,gBAAA;IOhFpB;;IAaqB;QEyFrB,UAAA;IAME;;IACF;QAKE,eAAc;QAAK,mBAAA;IACrB;;IAME;QAAA,eAAA;IACA;;IAKyB;QtBlK1B,gBAAA;IsBkKE;;IACH;QAWE,mBAAa;IAKiC;;IAQ7C;QACA,cAAU;IACV;;IAQH;QAGE,WAAA;QAE2B,gBAAA;II1H7B;;IAQ0B;QAqD1B,eAAA;IAaE;;IE3JF;QAGE,mBAAc;IAAK;;IAKlB;QAAwB,gBAAA;IAJ1B;;IAcE;QAEoB,oBAAA;IA8FvB;;IAU0B;QA6B1B,iBAAA;QAeE,gBAAc;QAWU,wDAAA;QGxG1B,gDAAA;QAEE,2CAAa;QAAK,wCAAA;QACpB,iEAAA;IAGE;;IACF;QAEE,yBAAiB;QAAK,sBAAA;QnCkmCxB,wBAAA;QHkiOO,YAAY;QM9sQlB,kBAAA;QEXF,6BAAA;QAKE,wBAAgB;QAwTY,qBAAA;IAvT7B;;IAOsB;QACtB,gCAAA;QAQE,2BAAoB;QAEK,wBAAA;IAK1B;;IAME;QAAA,YAAA;IAAA;;IAEA;QAmBoB,oBAAA;QA3BrB,oBAAA;QAmBE,aAAe;IACf;;IApBF;QAsBG,6BAAmB;QAAG,wBAAA;QAYzB,qBAAA;IAeE;;IAGe;QAlBjB,mBAAA;QA6BE,iCAAc;QAAd,4BAAc;QAAd,yBAAc;IACd;;IAEA;QAKwB,kBAAA;QArC1B,iBAAA;IAmCG;;IAwHL;QAOE,WAAU;QAOU,YAAA;QAxOvB,eAAA;QAkTG,gCAAA;QAAA,2BAAA;QAAA,wBAAA;IAGiC;;ICtSlC;QACA,6BAAW;QAqfkB,wBAAA;QAte9B,qBAAA;IAKE;;IAGF;QAeE,6BAAU;QAG2B,wBAAA;QAGvC,qBAAA;IAIE;;IAoBF;QAUE,iCAAY;QAEM,4BAAA;QACpB,yBAAA;IAaE;;IAgBD;QAmBG,aAAW;IACX;;IAIJ;QAQE,WAAA;IACA;;IATD;QAWE,WAAa;IAAG;;IAsBjB;QASe,qBAAA;IAzBhB;;IAsBwB;QAIzB,UAAA;IAeE;;IAUF;QAIE,UHjMS;QGkMT,kBAAW;IAAK;;IAqBhB;QACA,aAAS;IACT;;IAEA;QACA,WAAY;QAKQ,YAAA;IACtB;;IAKoB;QACpB,eAAA;IAWE;;IAaqB;QAavB,kBAAA;QAOE,SAAW;QACX,UAAA;QACA,eAAU;QAAK,YAAA;QAUjB,YAAA;IAsBE;;IAiCF;QAaE,eAAe;IAEK;;IAKpB;QAEuB,kBAAA;IA1Y1B;;IA8agC;QA9ahC,gBAAA;IAmbG;;IAnbH;QAwbG,kBAAA;QAA8B,gBAAA;IAxbjC;;IA4b0B;QA5b1B,QAAA;QAicG,mCAAU;QAAK,+BAAA;QAjclB,2BAAA;QAqcG,YAAe;IAAK;;IAQpB;QACA,kBAAgB;IAIO;;IAFtB;QAAkB,QAAA;QAhdtB,WAAA;QAwdG,kBAAU;IACV;;IAzdH;QA6dG,kBAAS;IAAK;;IAKd;QAEoB,WAAA;QApevB,YAAA;IA8eG;;IAEA;QACA,kBAAe;IAAK;;IAWpB;QAAoB,kBAAA;IA5fvB;;IAqgB6B;QArgB7B,aAAA;IAqgBI;;IFlPF;QEoRE,cAAA;IAGoB;;IAepB;QAA8B,cAAA;IQxjBjC;;IAYyB;QG2CzB,cAAA;IAeE;;IAgBF;QAKE,mBAAU;QAEa,8BAAA;QAwBzB,0BAAA;QAIE,2BAAiB;QAGQ,aAAA;IMoN3B;;IAQsB;QMpQtB,iBAAA;IAcE;;IAEA;QACA,aAAU;IAMmB;;IMlB7B;QAAkB,mBAAA;QACpB,UAAA;QAGE,YAAc;IAAK;;IAGnB;QAAsB,eAAA;IA0EzB;;IAKE;QACA,eAAA;IAA0B;;ItC6vQxB;QI5lQJ,cAAA;IACE;;IAEE;QAAA,cAAA;IAAyB;;IAEzB;QACA,mBAAA;IAAA;;IACF;QACE,WAAA;QACA,UAAA;IAAA;;IACF;QACE,eAAiB;IACjB;;IDmqBH;QHm8OO,cAAc;IqCxxQtB;;IAEE;QAAqB,aAAA;IlC8+RtB;;IG9oSC;QERD,cAAA;IAOE;;IACF;QAUE,iBAAoB;IAAK;AR07Q5B;;AAEA;IQv7QG;QAyBG,gBAAA;IAA0B;;IAE1B;QAAY,eAAA;IAOf;;IAkBiB;QAlBjB,oBAAA;IAqCG;;IA6EL;QAIE,4BAAc;QACd,8BAAS;QAIkB,kCAAA;QDxL5B,8BAAA;QCwLE,SAAA;QDvLW,eAAA;ICwLd;;IAME;QAE2B,eAAA;QDjM5B,SAAA;ICiME;;IACH;QAME,mBAAc;IACd;;IAPD;QAcE,SAAA;QACA,eAAS;IAMkB;;IAA1B;QDtNU,mBAAA;QCsOd,kBAAA;QAME,cAAe;QAoBO,eAAA;QA1BvB,WAAA;QF9KE,YAAA;IAAA;;IEgMD;QAME,mBAAkB;IAClB;;IACgB;QAkBpB,UAAA;IAKE;;IACF;QAGE,oCAAe;QAAK,gCAAA;QA9RvB,4BAAA;IAoTG;;IACA;QAAA,4BAA4B;IAAK;;IFlPhC;QAAA,wBAAsB;IEmQC;;ICpTzB;QACA,qBAAA;IAAA;;IAkf6B;QAjf9B,UAAA;IAQE;;IAGF;QAOE,UAAW;IAAK;;IAkBhB;QACA,YAAA;IAAqC;;IASrC;QAAe,qBAAA;IAOjB;;IAUkB;QAClB,WAAA;QAYE,YAAa;IAAK;;IAgBlB;QASoB,eAAA;QACtB,kBAAA;IAGE;;IF3HD;QEkIE,aAAA;IACA;;IAPF;QAsBG,eAAU;IACV;;IACJ;QAaE,cAAA;IACA;;IAdD;QAgBE,kBAAe;IAAG;;IAmBnB;QAOe,aAAA;QACjB,YAAA;IAiBE;;IAmBF;QAsBE,kBAAgB;QAChB,SAAA;QACA,UAAY;QACZ,eAAe;QAAK,YAAA;QACtB,YAAA;IAKE;;IAgHF;QAeE,gBAAe;IAAK;;IAOpB;QAAuB,mBAAA;QA1Y1B,gBAAA;IA8aG;;IAAA;QAA6B,WAAA;QA9ahC,kBAAA;QAkdG,UAAA;IAAuB;;IAkBvB;QAAoB,eAAA;IFjNrB;;IE0RiC;QE7iBnC,kBAAA;IAGE;;IAuBD;QAKE,YAAA;IAAA;;IAAA;QACA,WAAA;IACA;;IACF;QAKE,yBAAW;IACX;;IACF;QAIE,kBAAa;IAAb;;IACA;QAAA,UAAA;IAAA;;IACA;QAAA,eAAA;IACA;;IAEA;QAAkB,eAAA;QAMpB,gBAAA;IAGE;;IA3DH;QAoFG,eAAO;IACP;;IACiB;QEqBlB,UAAA;QAIE,WAAA;IACA;;IAUF;QAGE,SAAA;IAAwB;;IPlExB;QAAA,iBAAA;IOgHiB;;IPhHjB;QAAA,gBAAA;QOgJiB,eAAA;QNwEnB,YAAA;QDhNE,eAAA;IAAA;;ICgNF;QDhNE,eAAA;IAAA;;IQnEJ;QAUE,eAAY;IACZ;;IAEA;QACA,kBAAA;IA8DoB;;IApDnB;QAAA,sCAAY;IAAZ;;IAEA;QAAoB,yBAAA;IA1BvB;;IA6B0B;QACzB,kBAAA;IAOE;;IAKF;QAOE,aAAA;IASoB;;IAWpB;QAOiB,UAAA;IPuMlB;;IO1LgC;QCzFlC,iBAAA;IAIE;;IAEA;QACA,eAAQ;IACR;;IAoHe;QA5HjB,QAAA;QAYG,UAAA;QACA,mBAAU;QAAG,UAAA;IAIf;;IAYE;QACA,aAAgB;IAEM;;IA+BtB;QACA,cAAO;IACP;;IACA;QAA0C,iBAAA;IAlE7C;;IAmH2B;QRgKzB,eAAA;QQ3IE,gBTtFW;QSsFY,sBAAA;IR2IzB;AP48QF;;AAEA;IO98QE;QQ5HE,8BTrGW;QSqGY,0BAAA;QCvJ3B,sBAAA;IAGE;;IACD;QAQE,2BAAW;QACX,uBAAY;QACZ,mBAAA;IAAA;;IAVD;QAgBE,8BAAe;QAAK,0BAAA;QAGvB,sBAAA;IAaE;;IAEA;QACA,iBAAY;QACZ,kBAAY;IAAK;AhBgtRpB;;AAEA;IgBlsRG;QACA,kBAAW;IACX;AhBosRH;;AAEA;IgBpsRC;QAIE,eAAA;IACA;;IACF;QAGE,oBAAmB;IAAK;;IAUxB;QAO2B,UAAA;IAhB5B;;IAauB;QTjFvB,uBAAA;ISoFE;;IACH;QAQE,SAAA;IAAuB;;IA8DtB;QAAA,UAAA;IAI0C;;IAK1C;QAAA,gBAAA;IAA2C;;IC1J5C;QACA,cAAA;QAAuB,SAAA;IACzB;;IAMsB;QAStB,mBAAA;IAgBE;;IACA;QAAA,WAAA;QACA,SAAY;IACZ;;IAEA;QACA,mBAAkB;IAAK;;ICjDxB;QAkGwB,cAAA;QAjFzB,SAAA;IAIE;;IAW8B;QAf/B,eAAA;QAWE,SAAW;IACX;;IX7BF;QWgCG,mBAAmB;IX/BT;;IWoCZ;QAAmB,eAAA;IAIrB;;IAKuB;QA2BvB,8BAAA;QAIE,sBAAyB;IAAzB;;IAA8B;QEzEhC,kBAAA;QAIE,SAAA;QACA,WAAA;IAAsB;;IAItB;QAAA,eAAA;IAAA;;IACA;QAAA,eAAA;IACA;;IALD;QAQE,eAAA;QAAkC,oCAAA;QACrC,gCAAA;QAQE,4BAAU;IAAK;;IAWf;QACA,8BAAU;QACV,sBAAY;IASS;;IAHpB;QAAuB,aAAA;IAlBzB;;IAqBoB;QAKrB,WAAA;IAiBE;;IAEA;QASwB,kBAAA;QAG1B,gCAAA;IAOE;;IAMF;QAQE,UAAU;IACV;;IAEA;QAAuB,qBAAA;IAOzB;;IAOE;QAAyB,aAAA;IAC3B;;IAEsB;QA4DtB,SAAA;IAQE;;IAAA;QAAkB,mBAAA;QA2BpB,oBAAA;IAEE;;IAFD;QAKE,UAAa;QAAK,WAAA;Ib+CpB;;IahCiC;QbgCjC,kBAAA;QavBE,gBAAA;IAA+B;;IGrPhC;QASoB,eAAA;IAfrB;;IjB0DE;QiB3CiB,iBAAA;IACpB;;IAG0B;QAC1B,eAAA;IAIE;;IACD;QAME,gBAAA;QAAA,eAAA;QAAA,YAAa;QACb,eAAA;IAAA;;IACA;QACA,eAAA;IACA;;IAGH;QAKE,kBAA0B;IAA1B;;IACA;QACA,gCAAU;QACV,4BAAY;QAAK,wBAAA;IACnB;;IAEE;QAAA,kBAAA;IACA;;IAgBF;QAKE,eAAA;IAAwB;;IA0CxB;QAAA,sCAAe;IAAK;;IAMnB;QhBrHW,mBAAA;IgBsHd;;IAIE;QAAA,4BAAc;QACd,8BAAW;QAG0B,kCAAA;QhB5HtC,8BAAA;QgB4HE,oBAAA;QhB3HW,kBAAA;IgB4Hd;;IAIE;QAAA,WAAa;QACb,UAAU;IAM2B;;IAHpC;QAAoC,oBAAA;QARtC,oBAAA;QAWE,aAAA;QAAkC,wBAAA;QA7ItC,qBAAA;QA6LG,uBAAkB;QAClB,yBAAS;QACT,sBAAW;QACX,mBAAW;QACX,YAAA;QAAwB,aAAA;QhB/LzB,aAAA;IgBsME;;IACH;QAIE,mBAAW;IACX;;IhBqED;QDhNE,OAAA;QAAA,QAAA;QiBsJuB,YAAA;IhB0DzB;;IgB3CiC;QhBnOjC,kBAAA;QgBuOG,kBAAA;IhBtOU;;IDqDX;QAAA,mBAAsB;IoBrCJ;;IAsCnB;QACA,8BAAe;QAAK,sBAAA;IACtB;;IAcE;QAAA,8BAAc;QACd,sBAAW;IACX;;InB5ED;QmBsGE,8BAAmB;QnBrGR,sBAAA;ImByKd;;IAK2B;QAC3B,8BAAA;QAKE,sBAAa;IAAb;;IAAkB;QA2BpB,YAAA;QAEE,4BAAa;QAAb,eAAA;QAAA,eAAa;QACb,gCAAe;IACf;;IAGA;QACA,mBAAA;QACA,oBAAqB;QACrB,YAAA;QASmB,cAAA;QAnBpB,eAAA;IAYG;;IAZH;QAeE,kBAAW;IACX;;IACA;QACA,cAAW;IACX;;IACH;QAQE,qBAAgB;IAChB;;IA2GF;QAKE,qBAAe;IAAf;;IAEA;QAAe,sCAAA;IACjB;;IA4B4B;QnB5X3B,kBAAA;QmB4XE,SAAA;QnB3XW,OAAA;QAgRb,QAAA;QDhNE,WAAA;QAAA,kBAAA;IoBsUuB;;ICpYxB;QACA,mBAAmB;QAAK,UAAA;IACzB;;IAKkB;QALlB,YAAA;QAWE,mBAAa;QAAK,gBAAA;IA2DrB;;IAMoB;QClFpB,MAAA;QAGE,OAAA;QAAmB,QAAA;QACrB,qDAAA;QASE,6CAAW;IACX;;IAmDF;QAUE,mBAAkB;IAWW;;ICjF7B;QAA+B,mBAAA;IACjC;;IAeiB;QACjB,kDAAA;QAME,0CAAkB;IASE;;IvBqBnB;QAAA,mBAAsB;IuBrBL;;IAIlB;QAAc,gBAAA;IAChB;;IAGgB;QAChB,WAAA;QAUE,YAAe;QACf,uDAAgB;QAChB,+CvBfa;IuBewB;;IAsBrC;QACA,eAAA;IAAA;;IACA;QAAA,QAAA;QAAA,UAAA;QAAwB,eAAA;QAM1B,YAAA;QAKE,YAAA;IAAuB;;IAIvB;QAG2B,qBAAA;QAC7B,QAAA;QAGE,OAAA;QAAqB,WAAA;QACvB,kBAAA;QAIE,qDAAgB;QAChB,6CvB7EgB;IuB8FS;;IAbxB;QAIiB,mBAAA;QAbnB,UAAA;IAaG;;IAbH;QAmBE,mBvB5FU;IuB4FO;;IAGjB;QAAsB,UAAA;IAhI1B;;IAmI0B;QACzB,gBAAA;IAIE;;ItBtID;QsB+LE,mBAAmB;ItB9LR;;IsByMZ;QAA2B,kBAAA;IA5M9B;;IAkN8B;QAlN9B,iDAAA;QAsNG,yCAAU;IAAK;;IvBnJd;QAAA,kDAAsB;QuB4JC,0CAAA;ItBoDzB;;IsBjDiC;QtBiDjC,uBAAA;QsB7CE,kBAAgB;IAAK;;IAIrB;QAAqB,eAAA;ItByCvB;;IsBpCiB;QtBoCjB,gBAAA;QsB7BE,gCAAA;QAEiB,4BAAA;QtB2BnB,wBAAA;QsB3BG,YvB1NO;QuB0NK,aAAA;QGpPhB,aAAA;QAKE,cAAA;QAAuB,kBAAA;IAmDzB;;IAGyB;QAiDzB,aAAA;QAIE,SAAA;QACA,qBAAgB;IAEI;;ICjHpB;QAA+B,WAAA;QACjC,SAAA;IAUE;;IAMF;QAME,mBAAkB;IASE;;I3BqBnB;QAAA,cAAA;I2BrBiB;;IAIlB;QAAwB,gBAAA;IAC1B;;IAGgB;QAChB,qBAAA;QAUE,kBAAe;QACf,yBAAgB;IAChB;;IAuBF;QAQE,cAAA;QAAwB,iBAAA;IA1F3B;;IA0G0B;QAMzB,oBAAA;QAGE,oBAAgB;QAAK,aAAA;QACvB,yBAAA;QAIE,sBAAgB;QAChB,mB3BvFgB;Q2B4GS,aAAA;IA1B1B;;IAamB;QAbnB,6BAAA;IAaG;;IAbH;QAoBE,UAAA;IAAiB;;IAGjB;QAAiB,cAAA;QAvBnB,UAAA;QA0BE,Y3B5Ge;I2B4GO;;IAgBvB;QAckC,kBAAA;I1BuGnC;;IDhNE;Q2B8IuB,aAAA;I1BkEzB;;I0B1DiC;Q1B0DjC,cAAA;Q0BtDE,WAAA;QAAqB,YAAA;I1BsDvB;;I0BlDuB;Q1BkDvB,kBAAA;I0B/CE;;I1B+CF;Q0B7CG,U3BxMO;Q2BwMK,YAAA;QCrOf,kBAAA;Q5B0DE,kBAAA;IAAA;;ICwNF;QDhNE,6BAAsB;QAAtB,oBAAsB;I4BLC;;ICzCvB;QAAoB,eAAA;IACvB;;IAesB;QAfrB,oBAAA;Q7BqCE,oBAAA;QAAA,aAAA;I6BtBiB;;IAIlB;QAAwB,cAAA;IAiB1B;;IAGgB;QAChB,aAAA;IAWE;;IAEA;QAe2B,sCAAA;IA5B5B;;IAoBoB;QApBpB,sCAAA;IA0BE;;IA2BH;QAUE,oBAAmB;IAAK;;IAyBvB;QAAiB,8BAAA;QANnB,sBAAA;IASE;;IACH;QAiBE,mBAAa;IASW;;IAWxB;Q5BzLY,cAAA;IA6Qb;;IDhNE;Q6BmIuB,oBAAA;Q5B6EzB,oBAAA;Q4BxEE,aAAA;QAA+B,sBAAA;Q5BwEjC,mBAAA;Q4BpEE,qBAAgB;QAAK,WAAA;QEtMxB,mBAAA;QAGE,UAAA;IAAwB;;IAMxB;QAAkB,mBAAA;Q9BhBnB,8BAAA;Q8ByDE,0BAAoB;Q9BxDT,aAAA;Q8B8Dd,UAAA;QAME,YAAW;IACX;;IAMF;QAKE,mBAA2B;QAA3B,8BAA2B;QAA3B,0BAA2B;QAC3B,aAAA;IACA;;IACF;QAIE,mBAAc;IACd;;IACF;QAIE,mBAAe;QAGQ,eAAA;IAPxB;;IAOsB;Q9BjGtB,kBAAA;I8BuGE;;IAaH;QAGE,mBAAmB;QAAK,kBAAA;QAM1B,cAAA;QAIE,WAAc;IACd;;IAGF;QAKE,6BAAW;IACX;;I9B3ID;Q8B8IE,mBAAmB;Q9B7IR,iBAAA;Q8B8Id,aAAA;QAEE,UAAA;IAAoB;;IAepB;QACA,+BAAA;IAAA;;IAIH;QAGE,6BAAU;IAAK;;IAwCb;QAAA,kBAAA;QAE2C,SAAA;QChH9C,WAAA;QAEE,WAAa;QAAK,mBAAA;IACpB;;IAGqB;QACrB,mBAAA;IAEE;;IAyCH;QAOE,WAAA;QACA,UAAA;IAAyB;;IASzB;QACA,8BAAgB;QAChB,sBAAqB;IAAK;;ItC8tSxB;QACI,sCAAsC;IAC1C;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,8BAA8B;QAC9B,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,cAAc;QACd,WAAW;QACX,SAAS;IACb;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;QACpB,oBAAoB;QACpB,aAAa;IACjB;;IAEA;QACI,oBAAoB;QACpB,oBAAoB;QACpB,aAAa;QACb,eAAe;QACf,oBAAoB;QACpB,cAAc;QACd,gBAAgB;QAChB,wBAAwB;QACxB,qBAAqB;QACrB,iCAAiC;IACrC;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,WAAW;QACX,qBAAqB;QACrB,oBAAoB;QACpB,cAAc;QACd,WAAW;QACX,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,eAAe;QACf,iBAAiB;QACjB,UAAU;IACd;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,8BAA8B;QAC9B,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,8BAA8B;QAC9B,sBAAsB;IAC1B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,gCAAgC;IACpC;;IAEA;QACI,YAAY;QACZ,oBAAoB;QACpB,oBAAoB;QACpB,aAAa;QACb,yBAAyB;QACzB,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,8BAA8B;QAC9B,sBAAsB;IAC1B;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,8BAA8B;QAC9B,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,gCAAgC;IACpC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,8BAA8B;QAC9B,sBAAsB;IAC1B;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,8BAA8B;QAC9B,sBAAsB;IAC1B;;IAEA;QACI,8BAA8B;QAC9B,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,8BAA8B;QAC9B,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,gCAAgC;IACpC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;QAC9B,sBAAsB;IAC1B;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,+BAA+B;QAC/B,2BAA2B;QAC3B,wBAAwB;QACxB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;QAEI,SAAS;IACb;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,SAAS;IACb;;IAEA;QACI,WAAW;QACX,SAAS;IACb;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,wDAAwD;QACxD,gDAAgD;IACpD;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,kDAAkD;QAClD,0CAA0C;IAC9C;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,sBAAsB;IAC1B;AACJ;;AAEA,kCAAkC","sourcesContent":["html, body, div, span, applet, object, iframe,h1, h2, h3, h4, h5,\nh6, p, blockquote, pre,a, abbr, acronym, address, big,\ncite, code,del, dfn, em, img, ins, kbd, q, s, samp,small,\nstrike, strong, sub, sup, tt, var,b, u, i, center,dl, dt,\ndd, ol, ul, li,fieldset, form, label, legend,table, caption,\ntbody, tfoot, thead, tr, th, td,article, aside, canvas, details,\nembed, figure, figcaption, footer, header, hgroup, menu, nav,\noutput, ruby, section, summary,time, mark, audio, video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    vertical-align: baseline; }\nhtml {\n    -ms-text-size-adjust: 100%;\n    -webkit-text-size-adjust: 100%; }\nimg,fieldset, a img {\n    border: none; }\ninput[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"tel\"],\ntextarea {\n    -webkit-appearance: none; }\ninput[type=\"submit\"],\nbutton {\n    cursor: pointer;\n    background: none;\n    &::-moz-focus-inner {\n        padding: 0;\n        border: 0; } }\ntextarea {\n    overflow: auto; }\ninput {\n    appearance: none; }\ninput, button {\n    margin: 0;\n    padding: 0;\n    border: 0; }\ndiv, input, textarea, select,button,\nh1,h2,h3,h4,h5,h6,a,span,a:focus {\n    outline: none; }\nselect {\n    &:-moz-focusring {\n      color: transparent;\n      text-shadow: 0 0 0 #000; } }\nul,ol {\n    list-style-type: none; }\ntable {\n    border-spacing: 0;\n    border-collapse: collapse;\n    width: 100%; }\nhtml {\n    box-sizing: border-box; }\n*, *:before, *:after {\n    box-sizing: inherit; }\na {\n    text-decoration: none; }\na,\nbutton {\n  -webkit-tap-highlight-color: rgba(0,0,0,0); }\n",":root {\n    --main-color: #53c0cc;\n    --secondary-color: #f4c257;\n    --placeholder-color: rgba(228, 228, 228, 0.3);\n    --disabled-color: #cccccc;\n    --gray-color: #cbd5e1;\n}\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    vertical-align: baseline;\n}\n\nhtml {\n    -ms-text-size-adjust: 100%;\n    -webkit-text-size-adjust: 100%;\n}\n\nimg,\nfieldset,\na img {\n    border: none;\n}\n\ninput[type='text'],\ninput[type='email'],\ninput[type='tel'],\ntextarea {\n    -webkit-appearance: none;\n}\n\ninput[type='submit'],\nbutton {\n    cursor: pointer;\n    background: none;\n}\n\ninput[type='submit']::-moz-focus-inner,\nbutton::-moz-focus-inner {\n    padding: 0;\n    border: 0;\n}\n\ntextarea {\n    overflow: auto;\n}\n\ninput {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\ninput,\nbutton {\n    margin: 0;\n    padding: 0;\n    border: 0;\n}\n\ndiv,\ninput,\ntextarea,\nselect,\nbutton,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\na,\nspan,\na:focus {\n    outline: none;\n}\n\nselect:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #000;\n}\n\nul,\nol {\n    list-style-type: none;\n}\n\ntable {\n    border-spacing: 0;\n    border-collapse: collapse;\n    width: 100%;\n}\n\nhtml {\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n}\n\n*,\n*:before,\n*:after {\n    -webkit-box-sizing: inherit;\n    box-sizing: inherit;\n}\n\na {\n    text-decoration: none;\n}\n\na,\nbutton {\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.icon-arrow-down-fat {\n    width: 1.33em;\n    height: 1em;\n    fill: #fff;\n}\n\n.icon-arrow-left {\n    width: 0.6em;\n    height: 1em;\n    fill: #11142d;\n}\n\n.icon-arrow-next-fat {\n    width: 1.3em;\n    height: 1em;\n    fill: #11142d;\n}\n\n.icon-arrow-next {\n    width: 1.2em;\n    height: 1em;\n    fill: #11142d;\n}\n\n.icon-arrow-prev {\n    width: 1.2em;\n    height: 1em;\n    fill: #11142d;\n}\n\n.icon-arrow-right {\n    width: 0.6em;\n    height: 1em;\n    fill: #11142d;\n}\n\n.icon-arrow-up-fat {\n    width: 1.33em;\n    height: 1em;\n    fill: #fff;\n}\n\n.icon-arrows {\n    width: 0.63em;\n    height: 1em;\n    fill: #11142d;\n}\n\n.icon-bag {\n    width: 0.95em;\n    height: 1em;\n    fill: #1b1d21;\n}\n\n.icon-bell {\n    width: 0.92em;\n    height: 1em;\n    fill: #11142d;\n}\n\n.icon-box {\n    width: 1.13em;\n    height: 1em;\n    fill: #11142d;\n}\n\n.icon-chart {\n    width: 1em;\n    height: 1em;\n    fill: #1b1d21;\n}\n\n.icon-chat {\n    width: 1em;\n    height: 1em;\n    fill: #1b1d21;\n}\n\n.icon-close {\n    width: 1em;\n    height: 1em;\n    fill: #1b1d21;\n}\n\n.icon-comment {\n    width: 1em;\n    height: 1em;\n    fill: #1b1d21;\n}\n\n.icon-discovery {\n    width: 1em;\n    height: 1em;\n    fill: #1b1d21;\n}\n\n.icon-document {\n    width: 0.95em;\n    height: 1em;\n    fill: #1b1d21;\n}\n\n.icon-dots-border {\n    width: 4em;\n    height: 1em;\n    fill: #11142d;\n}\n\n.icon-download-fat {\n    width: 0.94em;\n    height: 1em;\n    fill: #11142d;\n}\n\n.icon-download {\n    width: 0.95em;\n    height: 1em;\n    fill: #7fba7a;\n}\n\n.icon-edit {\n    width: 1em;\n    height: 1em;\n    fill: #11142d;\n}\n\n.icon-editor-bold {\n    width: 0.83em;\n    height: 1em;\n    fill: #fff;\n}\n\n.icon-editor-italic {\n    width: 0.5em;\n    height: 1em;\n    fill: #808191;\n}\n\n.icon-editor-pic {\n    width: 1.08em;\n    height: 1em;\n    fill: #808191;\n}\n\n.icon-editor-smile {\n    width: 1em;\n    height: 1em;\n    fill: #808191;\n}\n\n.icon-folder {\n    width: 1.06em;\n    height: 1em;\n    fill: #11142d;\n}\n\n.icon-like {\n    width: 1em;\n    height: 1em;\n    fill: #fff;\n}\n\n.icon-logout {\n    width: 1em;\n    height: 1em;\n    fill: #1b1d21;\n}\n\n.icon-message {\n    width: 1.11em;\n    height: 1em;\n    fill: #1b1d21;\n}\n\n.icon-moon {\n    width: 1em;\n    height: 1em;\n    fill: #f4c257;\n}\n\n.icon-more {\n    width: 1em;\n    height: 1em;\n    fill: #1b1d21;\n}\n\n.icon-notification {\n    width: 0.91em;\n    height: 1em;\n    fill: #1b1d21;\n}\n\n.icon-overview {\n    width: 0.95em;\n    height: 1em;\n    fill: #fff;\n}\n\n.icon-plus-square {\n    width: 1em;\n    height: 1em;\n    fill: #fff;\n}\n\n.icon-print {\n    width: 1em;\n    height: 1em;\n    fill: #11142d;\n}\n\n.icon-profile {\n    width: 0.81em;\n    height: 1em;\n    fill: #1b1d21;\n}\n\n.icon-remove {\n    width: 1em;\n    height: 1em;\n    fill: #11142d;\n}\n\n.icon-search {\n    width: 1em;\n    height: 1em;\n    fill: #11142d;\n}\n\n.icon-settings {\n    width: 0.91em;\n    height: 1em;\n    fill: #1b1d21;\n}\n\n.icon-star {\n    width: 1em;\n    height: 1em;\n    fill: #1b1d21;\n}\n\n.icon-sun {\n    width: 1em;\n    height: 1em;\n    fill: #f4c257;\n}\n\n.icon-wallet {\n    width: 1.1em;\n    height: 1em;\n    fill: #1b1d21;\n}\n\n/**\n* Owl Carousel v2.3.4\n* Copyright 2013-2018 David Deutsch\n* Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE\n*/\n/*\n*  Owl Carousel - Core\n*/\n.owl-carousel {\n    display: none;\n    width: 100%;\n    -webkit-tap-highlight-color: transparent;\n    /* position relative and z-index fix webkit rendering fonts issue */\n    position: relative;\n    z-index: 1;\n}\n\n.owl-carousel .owl-stage {\n    position: relative;\n    -ms-touch-action: pan-Y;\n    touch-action: manipulation;\n    -moz-backface-visibility: hidden;\n    /* fix firefox animation glitch */\n}\n\n.owl-carousel .owl-stage:after {\n    content: '.';\n    display: block;\n    clear: both;\n    visibility: hidden;\n    line-height: 0;\n    height: 0;\n}\n\n.owl-carousel .owl-stage-outer {\n    position: relative;\n    overflow: hidden;\n    /* fix for flashing background */\n    -webkit-transform: translate3d(0px, 0px, 0px);\n}\n\n.owl-carousel .owl-wrapper,\n.owl-carousel .owl-item {\n    -webkit-backface-visibility: hidden;\n    -moz-backface-visibility: hidden;\n    -ms-backface-visibility: hidden;\n    -webkit-transform: translate3d(0, 0, 0);\n    -moz-transform: translate3d(0, 0, 0);\n    -ms-transform: translate3d(0, 0, 0);\n}\n\n.owl-carousel .owl-item {\n    position: relative;\n    min-height: 1px;\n    float: left;\n    -webkit-backface-visibility: hidden;\n    -webkit-tap-highlight-color: transparent;\n    -webkit-touch-callout: none;\n}\n\n.owl-carousel .owl-item img {\n    display: block;\n    width: 100%;\n}\n\n.owl-carousel .owl-nav.disabled,\n.owl-carousel .owl-dots.disabled {\n    display: none;\n}\n\n.owl-carousel .owl-nav .owl-prev,\n.owl-carousel .owl-nav .owl-next,\n.owl-carousel .owl-dot {\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.owl-carousel .owl-nav button.owl-prev,\n.owl-carousel .owl-nav button.owl-next,\n.owl-carousel button.owl-dot {\n    background: none;\n    color: inherit;\n    border: none;\n    padding: 0 !important;\n    font: inherit;\n}\n\n.owl-carousel.owl-loaded {\n    display: block;\n}\n\n.owl-carousel.owl-loading {\n    opacity: 0;\n    display: block;\n}\n\n.owl-carousel.owl-hidden {\n    opacity: 0;\n}\n\n.owl-carousel.owl-refresh .owl-item {\n    visibility: hidden;\n}\n\n.owl-carousel.owl-drag .owl-item {\n    -ms-touch-action: pan-y;\n    touch-action: pan-y;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.owl-carousel.owl-grab {\n    cursor: move;\n    cursor: -webkit-grab;\n    cursor: grab;\n}\n\n.owl-carousel.owl-rtl {\n    direction: rtl;\n}\n\n.owl-carousel.owl-rtl .owl-item {\n    float: right;\n}\n\n/* No Js */\n.no-js .owl-carousel {\n    display: block;\n}\n\n/*\n*  Owl Carousel - Animate Plugin\n*/\n.owl-carousel .animated {\n    -webkit-animation-duration: 1000ms;\n    animation-duration: 1000ms;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n}\n\n.owl-carousel .owl-animated-in {\n    z-index: 0;\n}\n\n.owl-carousel .owl-animated-out {\n    z-index: 1;\n}\n\n.owl-carousel .fadeOut {\n    -webkit-animation-name: fadeOut;\n    animation-name: fadeOut;\n}\n\n@-webkit-keyframes fadeOut {\n    0% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n}\n\n@keyframes fadeOut {\n    0% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n}\n\n/*\n* \tOwl Carousel - Auto Height Plugin\n*/\n.owl-height {\n    -webkit-transition: height 500ms ease-in-out;\n    -o-transition: height 500ms ease-in-out;\n    transition: height 500ms ease-in-out;\n}\n\n/*\n* \tOwl Carousel - Lazy Load Plugin\n*/\n.owl-carousel .owl-item {\n    /**\n    This is introduced due to a bug in IE11 where lazy loading combined with autoheight plugin causes a wrong\n    calculation of the height of the owl-item that breaks page layouts\n   */\n}\n\n.owl-carousel .owl-item .owl-lazy {\n    opacity: 0;\n    -webkit-transition: opacity 400ms ease;\n    -o-transition: opacity 400ms ease;\n    transition: opacity 400ms ease;\n}\n\n.owl-carousel .owl-item .owl-lazy[src^=''],\n.owl-carousel .owl-item .owl-lazy:not([src]) {\n    max-height: 0;\n}\n\n.owl-carousel .owl-item img.owl-lazy {\n    -webkit-transform-style: preserve-3d;\n    transform-style: preserve-3d;\n}\n\n/*\n* \tOwl Carousel - Video Plugin\n*/\n.owl-carousel .owl-video-wrapper {\n    position: relative;\n    height: 100%;\n    background: #000;\n}\n\n.owl-carousel .owl-video-play-icon {\n    position: absolute;\n    height: 80px;\n    width: 80px;\n    left: 50%;\n    top: 50%;\n    margin-left: -40px;\n    margin-top: -40px;\n    /* background: url(\"owl.video.play.png\") no-repeat; */\n    cursor: pointer;\n    z-index: 1;\n    -webkit-backface-visibility: hidden;\n    -webkit-transition: -webkit-transform 100ms ease;\n    transition: -webkit-transform 100ms ease;\n    -o-transition: transform 100ms ease;\n    transition: transform 100ms ease;\n    transition: transform 100ms ease, -webkit-transform 100ms ease;\n}\n\n.owl-carousel .owl-video-play-icon:hover {\n    -ms-transform: scale(1.3, 1.3);\n    -webkit-transform: scale(1.3, 1.3);\n    transform: scale(1.3, 1.3);\n}\n\n.owl-carousel .owl-video-playing .owl-video-tn,\n.owl-carousel .owl-video-playing .owl-video-play-icon {\n    display: none;\n}\n\n.owl-carousel .owl-video-tn {\n    opacity: 0;\n    height: 100%;\n    background-position: center center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    -webkit-transition: opacity 400ms ease;\n    -o-transition: opacity 400ms ease;\n    transition: opacity 400ms ease;\n}\n\n.owl-carousel .owl-video-frame {\n    position: relative;\n    z-index: 1;\n    height: 100%;\n    width: 100%;\n}\n\n/* Magnific Popup CSS */\n.mfp-bg {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1042;\n    overflow: hidden;\n    position: fixed;\n    background: #0b0b0b;\n    opacity: 0.8;\n}\n\n.mfp-wrap {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1043;\n    position: fixed;\n    outline: none !important;\n    -webkit-backface-visibility: hidden;\n}\n\n.mfp-container {\n    text-align: center;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    padding: 0 8px;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n}\n\n.mfp-container:before {\n    content: '';\n    display: inline-block;\n    height: 100%;\n    vertical-align: middle;\n}\n\n.mfp-align-top .mfp-container:before {\n    display: none;\n}\n\n.mfp-content {\n    position: relative;\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0 auto;\n    text-align: left;\n    z-index: 1045;\n}\n\n.mfp-inline-holder .mfp-content,\n.mfp-ajax-holder .mfp-content {\n    width: 100%;\n    cursor: auto;\n}\n\n.mfp-ajax-cur {\n    cursor: progress;\n}\n\n.mfp-zoom-out-cur,\n.mfp-zoom-out-cur .mfp-image-holder .mfp-close {\n    cursor: -webkit-zoom-out;\n    cursor: zoom-out;\n}\n\n.mfp-zoom {\n    cursor: pointer;\n    cursor: -webkit-zoom-in;\n    cursor: zoom-in;\n}\n\n.mfp-auto-cursor .mfp-content {\n    cursor: auto;\n}\n\n.mfp-close,\n.mfp-arrow,\n.mfp-preloader,\n.mfp-counter {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.mfp-loading.mfp-figure {\n    display: none;\n}\n\n.mfp-hide {\n    display: none !important;\n}\n\n.mfp-preloader {\n    color: #ccc;\n    position: absolute;\n    top: 50%;\n    width: auto;\n    text-align: center;\n    margin-top: -0.8em;\n    left: 8px;\n    right: 8px;\n    z-index: 1044;\n}\n\n.mfp-preloader a {\n    color: #ccc;\n}\n\n.mfp-preloader a:hover {\n    color: #fff;\n}\n\n.mfp-s-ready .mfp-preloader {\n    display: none;\n}\n\n.mfp-s-error .mfp-content {\n    display: none;\n}\n\nbutton.mfp-close,\nbutton.mfp-arrow {\n    overflow: visible;\n    cursor: pointer;\n    background: transparent;\n    border: 0;\n    -webkit-appearance: none;\n    display: block;\n    outline: none;\n    padding: 0;\n    z-index: 1046;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    -ms-touch-action: manipulation;\n    touch-action: manipulation;\n}\n\nbutton::-moz-focus-inner {\n    padding: 0;\n    border: 0;\n}\n\n.mfp-close {\n    width: 44px;\n    height: 44px;\n    line-height: 44px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    text-decoration: none;\n    text-align: center;\n    opacity: 0.65;\n    padding: 0 0 18px 10px;\n    color: #fff;\n    font-style: normal;\n    font-size: 28px;\n    font-family: Arial, Baskerville, monospace;\n}\n\n.mfp-close:hover,\n.mfp-close:focus {\n    opacity: 1;\n}\n\n.mfp-close:active {\n    top: 1px;\n}\n\n.mfp-close-btn-in .mfp-close {\n    color: #333;\n}\n\n.mfp-image-holder .mfp-close,\n.mfp-iframe-holder .mfp-close {\n    color: #fff;\n    right: -6px;\n    text-align: right;\n    padding-right: 6px;\n    width: 100%;\n}\n\n.mfp-counter {\n    position: absolute;\n    top: 0;\n    right: 0;\n    color: #ccc;\n    font-size: 12px;\n    line-height: 18px;\n    white-space: nowrap;\n}\n\n.mfp-arrow {\n    position: absolute;\n    opacity: 0.65;\n    margin: 0;\n    top: 50%;\n    margin-top: -55px;\n    padding: 0;\n    width: 90px;\n    height: 110px;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.mfp-arrow:active {\n    margin-top: -54px;\n}\n\n.mfp-arrow:hover,\n.mfp-arrow:focus {\n    opacity: 1;\n}\n\n.mfp-arrow:before,\n.mfp-arrow:after {\n    content: '';\n    display: block;\n    width: 0;\n    height: 0;\n    position: absolute;\n    left: 0;\n    top: 0;\n    margin-top: 35px;\n    margin-left: 35px;\n    border: medium inset transparent;\n}\n\n.mfp-arrow:after {\n    border-top-width: 13px;\n    border-bottom-width: 13px;\n    top: 8px;\n}\n\n.mfp-arrow:before {\n    border-top-width: 21px;\n    border-bottom-width: 21px;\n    opacity: 0.7;\n}\n\n.mfp-arrow-left {\n    left: 0;\n}\n\n.mfp-arrow-left:after {\n    border-right: 17px solid #fff;\n    margin-left: 31px;\n}\n\n.mfp-arrow-left:before {\n    margin-left: 25px;\n    border-right: 27px solid #3f3f3f;\n}\n\n.mfp-arrow-right {\n    right: 0;\n}\n\n.mfp-arrow-right:after {\n    border-left: 17px solid #fff;\n    margin-left: 39px;\n}\n\n.mfp-arrow-right:before {\n    border-left: 27px solid #3f3f3f;\n}\n\n.mfp-iframe-holder {\n    padding-top: 40px;\n    padding-bottom: 40px;\n}\n\n.mfp-iframe-holder .mfp-content {\n    line-height: 0;\n    width: 100%;\n    max-width: 900px;\n}\n\n.mfp-iframe-holder .mfp-close {\n    top: -40px;\n}\n\n.mfp-iframe-scaler {\n    width: 100%;\n    height: 0;\n    overflow: hidden;\n    padding-top: 56.25%;\n}\n\n.mfp-iframe-scaler iframe {\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);\n    background: #000;\n}\n\n/* Main image in popup */\nimg.mfp-img {\n    width: auto;\n    max-width: 100%;\n    height: auto;\n    display: block;\n    line-height: 0;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    padding: 40px 0 40px;\n    margin: 0 auto;\n}\n\n/* The shadow behind the image */\n.mfp-figure {\n    line-height: 0;\n}\n\n.mfp-figure:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 40px;\n    bottom: 40px;\n    display: block;\n    right: 0;\n    width: auto;\n    height: auto;\n    z-index: -1;\n    -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);\n    background: #444;\n}\n\n.mfp-figure small {\n    color: #bdbdbd;\n    display: block;\n    font-size: 12px;\n    line-height: 14px;\n}\n\n.mfp-figure figure {\n    margin: 0;\n}\n\n.mfp-bottom-bar {\n    margin-top: -36px;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    cursor: auto;\n}\n\n.mfp-title {\n    text-align: left;\n    line-height: 18px;\n    color: #f3f3f3;\n    word-wrap: break-word;\n    padding-right: 36px;\n}\n\n.mfp-image-holder .mfp-content {\n    max-width: 100%;\n}\n\n.mfp-gallery .mfp-image-holder .mfp-figure {\n    cursor: pointer;\n}\n\nbody {\n    min-width: 375px;\n    font-family: 'Inter', sans-serif;\n    font-size: 14px;\n    line-height: 1.71429;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    color: #11142d;\n}\n\nbody.dark {\n    background: #242731;\n    color: #ffffff;\n}\n\nbody.no-scroll {\n    overflow: hidden;\n}\n\nbutton,\ninput,\ntextarea,\nselect {\n    font-family: 'Inter', sans-serif;\n}\n\nimg {\n    display: block;\n    max-width: 100%;\n}\n\nbody.dark .apexcharts-tooltip.apexcharts-theme-light {\n    color: #11142d;\n}\n\nbody.dark .apexcharts-gridlines-horizontal line {\n    stroke: rgba(228, 228, 228, 0.1);\n}\n\n.page {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    min-height: 100vh;\n}\n\n.page__wrapper {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n    padding-left: 256px;\n}\n\n.page__center {\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.page__row {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.page__row_head .page__col {\n    padding-top: 48px;\n}\n\n.page__row_border .page__col:nth-child(2) {\n    border-left: 1px solid #e4e4e4;\n}\n\n.page__col {\n    padding: 0 64px 44px;\n}\n\n.page__col:first-child {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 calc(100% - 426px);\n    flex: 0 0 calc(100% - 426px);\n    max-width: calc(100% - 426px);\n}\n\n.page__col:nth-child(2) {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 426px;\n}\n\n.page .page__col.page__col_w50 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n}\n\n.page__widgets {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin: 0 -16px;\n}\n\n.page__widgets:not(:last-child) {\n    margin-bottom: 43px;\n}\n\n.page__widgets .widget {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 calc(50% - 32px);\n    flex: 0 0 calc(50% - 32px);\n    width: calc(50% - 32px);\n    margin: 0 16px;\n}\n\n.page__group .widget:not(:last-child) {\n    margin-bottom: 69px;\n}\n\n.page__content {\n    padding: 0 64px 64px;\n}\n\n.page__content_pt64 {\n    padding-top: 64px;\n    border-top: 1px solid #e4e4e4;\n}\n\n.page__stat {\n    position: relative;\n    padding: 50px 32px 40px;\n    border-radius: 24px;\n    background: #ffffff;\n}\n\n.page__stat:before {\n    content: '';\n    position: absolute;\n    top: 43px;\n    left: 32px;\n    right: 32px;\n    bottom: -43px;\n    z-index: -1;\n    background: #e3e6ec;\n    opacity: 0.91;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\n.page__stat_pt32 {\n    padding-top: 32px;\n}\n\n.page__stat_sm .sorting {\n    position: absolute;\n    top: 32px;\n    right: 40px;\n}\n\n.page__flex {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.page__flex .widget:first-child {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 298px;\n    margin-right: 32px;\n}\n\n.page__flex .widget:nth-child(2) {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n\n.page__title {\n    margin-bottom: 32px;\n}\n\n.page__nav {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-bottom: 48px;\n}\n\n.page__nav .page__link {\n    padding: 7px 18px;\n    border-radius: 12px;\n    font-weight: 600;\n    color: #808191;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.page__nav .page__link:hover,\n.page__nav .page__link.active {\n    background: var(--main-color);\n    color: #ffffff;\n}\n\nbody.dark .page__row_border .page__col:nth-child(2) {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .page__stat {\n    background: #242731;\n}\n\nbody.dark .page__stat:before {\n    background: #000;\n    opacity: 0.51;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\nbody.dark .page__content_pt64 {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\n.sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 256px;\n    height: 100vh;\n    padding: 140px 0 72px;\n    background: #ffffff;\n    border-right: 1px solid #e4e4e4;\n    z-index: 99;\n}\n\n.sidebar__wrapper {\n    max-height: 100%;\n    padding: 0 20px 30px;\n    overflow-y: auto;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    -webkit-overflow-scrolling: touch;\n}\n\n.sidebar__wrapper::-webkit-scrollbar {\n    display: none;\n}\n\n.sidebar__inner {\n    width: 215px;\n    overflow: hidden;\n    -webkit-transition: width 0.25s;\n    -o-transition: width 0.25s;\n    transition: width 0.25s;\n}\n\n.sidebar__top {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    height: 140px;\n}\n\n.sidebar__logo {\n    font-size: 0;\n}\n\n.sidebar__logo .sidebar__pic {\n    width: 176px;\n}\n\n.sidebar__logo .sidebar__pic_white {\n    display: none;\n}\n\n.sidebar__close {\n    position: relative;\n    top: -3px;\n    display: none;\n    margin-right: 25px;\n    font-size: 0;\n}\n\n.sidebar__close .icon {\n    font-size: 20px;\n    fill: #11142d;\n}\n\n.sidebar__wrapper .sidebar__logo {\n    display: none;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    height: 0;\n    overflow: hidden;\n    margin: 0 -20px;\n}\n\n.sidebar__burger {\n    position: fixed;\n    top: 0;\n    left: 0;\n    display: none;\n    padding: 20px;\n    font-size: 72px;\n    z-index: 45;\n}\n\n.sidebar__list {\n    margin-bottom: 20px;\n}\n\n.sidebar__group:not(:last-child) {\n    position: relative;\n    margin-bottom: 40px;\n    padding-bottom: 30px;\n}\n\n.sidebar__group:not(:last-child):before {\n    content: '';\n    position: absolute;\n    left: 20px;\n    right: 20px;\n    bottom: 0;\n    height: 1px;\n    background: #f0f3f6;\n}\n\n.sidebar__caption {\n    margin-bottom: 16px;\n    padding-left: 20px;\n    color: #808191;\n}\n\n.sidebar__item {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    height: 56px;\n    padding: 0 20px;\n    border-radius: 12px;\n    background: transparent;\n    font-size: 14px;\n    font-weight: 600;\n    color: #808191;\n    -webkit-transition: color 0.25s;\n    -o-transition: color 0.25s;\n    transition: color 0.25s;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.sidebar__item:hover {\n    color: var(--main-color);\n}\n\n.sidebar__item.active {\n    background: var(--main-color);\n    color: #ffffff;\n}\n\n.sidebar__icon {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 24px;\n    height: 24px;\n    margin-right: 16px;\n    font-size: 0;\n}\n\n.sidebar__icon .icon {\n    font-size: 21px;\n    fill: #1b1d21;\n    opacity: 0.4;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.sidebar__icon .icon-message {\n    font-size: 19px;\n}\n\n.sidebar__item:hover .icon {\n    fill: var(--main-color);\n    opacity: 1;\n}\n\n.sidebar__item.active .icon {\n    opacity: 1;\n    fill: #ffffff;\n}\n\n.sidebar__item .sidebar__text {\n    margin-right: auto;\n}\n\n.sidebar__counter {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    min-width: 24px;\n    margin-left: 10px;\n    padding: 0 3px;\n    border-radius: 12px;\n    background: #ff754c;\n    text-align: center;\n    font-size: 12px;\n    line-height: 24px;\n    font-weight: 500;\n    color: #ffffff;\n}\n\n.sidebar__profile {\n    margin-top: 25px;\n}\n\n.sidebar__details {\n    position: relative;\n    display: none;\n    padding: 20px 10px 33px;\n    margin-bottom: -15px;\n    background: #f7f7f7;\n    border-radius: 12px;\n    -webkit-transition: padding 0.25s, background 0.25s;\n    -o-transition: padding 0.25s, background 0.25s;\n    transition: padding 0.25s, background 0.25s;\n}\n\n.sidebar__details:before {\n    content: '';\n    position: absolute;\n    top: 8px;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n    transform: translateX(-50%);\n    width: 72px;\n    height: 4px;\n    border-radius: 2px;\n    background: #e4e4e4;\n}\n\n.sidebar__link {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    height: 56px;\n    border-radius: 12px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #808191;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.sidebar__link:hover {\n    background: #ffffff;\n    -webkit-box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.04);\n    box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.04);\n}\n\n.sidebar__link .sidebar__icon {\n    width: 50px;\n    margin: 0;\n    padding-right: 6px;\n    text-align: center;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.sidebar__img {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    width: 50px;\n    height: 56px;\n    padding-right: 5px;\n}\n\n.sidebar__img .icon {\n    font-size: 19px;\n}\n\n.sidebar__user {\n    position: relative;\n    z-index: 2;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    padding: 0 20px;\n    height: 62px;\n    border-radius: 12px;\n    color: #11142d;\n    cursor: pointer;\n    -webkit-transition: background 0.25s;\n    -o-transition: background 0.25s;\n    transition: background 0.25s;\n}\n\n.sidebar__user:hover,\n.sidebar__user.active {\n    background: var(--main-color);\n    color: #ffffff;\n}\n\n.sidebar__user:hover .sidebar__status,\n.sidebar__user.active .sidebar__status {\n    color: #ffffff;\n}\n\n.sidebar__user:hover .icon,\n.sidebar__user.active .icon {\n    fill: #ffffff;\n}\n\n.sidebar__ava {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 40px;\n    height: 40px;\n    font-size: 0;\n}\n\n.sidebar__ava .sidebar__pic {\n    width: 100%;\n    min-height: 100%;\n    border-radius: 50%;\n}\n\n.sidebar__arrow {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    width: 24px;\n    height: 24px;\n    font-size: 0;\n}\n\n.sidebar__arrow .icon {\n    font-size: 16px;\n    fill: #11142d;\n}\n\n.sidebar__desc {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 calc(100% - 64px);\n    flex: 0 0 calc(100% - 64px);\n    width: calc(100% - 64px);\n    padding: 0 5px 0 16px;\n}\n\n.sidebar__man {\n    overflow: hidden;\n    -o-text-overflow: ellipsis;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 14px;\n    line-height: 1.42857;\n    font-weight: 600;\n}\n\n.sidebar__status {\n    overflow: hidden;\n    -o-text-overflow: ellipsis;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: #808191;\n}\n\n.sidebar__bottom {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    height: 72px;\n    padding: 0 40px;\n    -webkit-box-shadow: inset 0px 1px 0px rgba(0, 0, 0, 0.05);\n    box-shadow: inset 0px 1px 0px rgba(0, 0, 0, 0.05);\n}\n\n.sidebar .switch {\n    margin-right: auto;\n}\n\n.sidebar__banner {\n    position: relative;\n    margin-top: 50px;\n    padding: 8px 8px 20px;\n    border-radius: 16px;\n    background: #cfc8ff;\n    text-align: center;\n}\n\n.sidebar__banner:before {\n    content: '';\n    position: absolute;\n    top: 8px;\n    left: 8px;\n    right: 8px;\n    bottom: -8px;\n    z-index: -1;\n    border-radius: 12px;\n    background: rgba(207, 200, 255, 0.5);\n}\n\n.sidebar__banner:not(:last-child) {\n    margin-bottom: 40px;\n}\n\n.sidebar__preview {\n    margin-bottom: 6px;\n    font-size: 0;\n}\n\n.sidebar__banner .sidebar__btn {\n    min-width: 171px;\n    color: var(--main-color);\n}\n\n.sidebar__banner .sidebar__btn:hover {\n    color: var(--main-color);\n}\n\n.sidebar.active .sidebar__top {\n    padding: 0;\n}\n\n.sidebar.active .sidebar__icon {\n    margin-right: 21px;\n}\n\n.sidebar.active .sidebar__wrapper .sidebar__logo {\n    height: 80px;\n}\n\n.sidebar.active .sidebar__details {\n    padding: 5px 0 17px;\n    background: none;\n}\n\n.sidebar.active .sidebar__link .sidebar__icon {\n    width: 56px;\n    padding: 0;\n}\n\nbody.dark .sidebar {\n    background: #242731;\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .sidebar__pic_black {\n    display: none;\n}\n\nbody.dark .sidebar__pic_white {\n    display: inline-block;\n}\n\nbody.dark .sidebar__icon .icon {\n    fill: #ffffff;\n}\n\nbody.dark .sidebar__item:hover {\n    color: #ffffff;\n}\n\nbody.dark .sidebar__group:before {\n    background: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .sidebar__details {\n    background: rgba(228, 228, 228, 0.04);\n}\n\nbody.dark .sidebar__details:before {\n    background: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .sidebar__link:hover {\n    background: rgba(228, 228, 228, 0.04);\n    color: #ffffff;\n}\n\nbody.dark .sidebar__link:hover .icon {\n    fill: #ffffff;\n    opacity: 1;\n}\n\nbody.dark .sidebar__man {\n    color: #ffffff;\n}\n\nbody.dark .sidebar__arrow .icon {\n    fill: #ffffff;\n}\n\nbody.dark .sidebar__bottom {\n    -webkit-box-shadow: inset 0px 1px 0px rgba(228, 228, 228, 0.1);\n    box-shadow: inset 0px 1px 0px rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .sidebar__burger:before,\nbody.dark .sidebar__burger:after {\n    background: #ffffff;\n}\n\nbody.dark .sidebar__close .icon {\n    fill: #ffffff;\n}\n\nbody.dark .sidebar__btn.btn_white {\n    background: var(--main-color);\n    color: #ffffff;\n}\n\nbody.dark .sidebar__btn.btn_white:hover {\n    background: #1b1d21;\n}\n\nbody.dark .sidebar.active .sidebar__burger {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\n.switch {\n    display: inline-block;\n    position: relative;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    cursor: pointer;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    font-size: 0;\n    -webkit-transition: opacity 0.25s;\n    -o-transition: opacity 0.25s;\n    transition: opacity 0.25s;\n}\n\n.switch__input {\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n}\n\n.switch__in {\n    display: inline-block;\n}\n\n.switch__box {\n    position: relative;\n    display: block;\n    width: 64px;\n    height: 24px;\n    background: rgba(228, 228, 228, 0.5);\n    border-radius: 16px;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.switch__box:before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 2px;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    border: 4px solid #ffffff;\n    -webkit-box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);\n    background: #f4c257;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.switch__icon {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    font-size: 0;\n}\n\n.switch__icon .icon {\n    font-size: 24px;\n    fill: #f4c257;\n}\n\n.switch__icon .icon-moon {\n    display: none;\n}\n\n.switch__input:checked+.switch__flex .switch__box:before {\n    -webkit-transform: translate(24px, -50%);\n    -ms-transform: translate(24px, -50%);\n    transform: translate(24px, -50%);\n}\n\n.switch_theme .switch__in {\n    padding-left: 56px;\n}\n\nbody.dark .switch_theme .switch__input+.switch__in .switch__box {\n    background: #12141b;\n}\n\nbody.dark .switch_theme .switch__input+.switch__in .switch__box:before {\n    width: 4px;\n    height: 16px;\n    border-width: 2px;\n    border-radius: 2px;\n    -webkit-transform: translate(48px, -50%);\n    -ms-transform: translate(48px, -50%);\n    transform: translate(48px, -50%);\n    border-color: #f4c257;\n}\n\nbody.dark .switch_theme .switch__input+.switch__in .icon-moon {\n    display: inline-block;\n}\n\nbody.dark .switch_theme .switch__input+.switch__in .icon-sun {\n    display: none;\n}\n\n.slider {\n    margin-bottom: 56px;\n}\n\n.slider__container {\n    position: relative;\n    background: var(--main-color);\n    border-radius: 24px;\n}\n\n.slider__container:before,\n.slider__container:after {\n    content: '';\n    position: absolute;\n    background: #cfc8ff;\n    border-radius: 24px;\n}\n\n.slider__container:before {\n    top: 8px;\n    left: 8px;\n    right: 8px;\n    bottom: -8px;\n    z-index: -1;\n}\n\n.slider__container:after {\n    top: 16px;\n    left: 20px;\n    right: 20px;\n    bottom: -16px;\n    z-index: -2;\n}\n\n.slider__item {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 42px 0 56px 32px;\n    color: #ffffff;\n}\n\n.slider__details {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 185px;\n    padding-top: 13px;\n}\n\n.slider__preview {\n    margin: 0 auto;\n    font-size: 0;\n}\n\n.slider__pic {\n    max-width: 214px;\n    max-height: 214px;\n}\n\n.slider__title {\n    margin-bottom: 14px;\n}\n\n.slider__text {\n    margin-bottom: 14px;\n}\n\n.slider__close {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    z-index: 2;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: #ffffff;\n    font-size: 0;\n}\n\n.slider__close .icon {\n    font-size: 12px;\n    -webkit-transition: -webkit-transform 0.25s;\n    transition: -webkit-transform 0.25s;\n    -o-transition: transform 0.25s;\n    transition: transform 0.25s;\n    transition: transform 0.25s, -webkit-transform 0.25s;\n}\n\n.slider__close:hover .icon {\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n}\n\n.slider .owl-dots {\n    position: absolute;\n    left: 217px;\n    right: 0;\n    bottom: 30px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.slider .owl-carousel button.owl-dot {\n    position: relative;\n    width: 12px;\n    height: 12px;\n}\n\n.slider .owl-carousel button.owl-dot:before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 4px;\n    height: 4px;\n    background: #ffffff;\n    border-radius: 50%;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.slider .owl-carousel button.owl-dot:hover:before,\n.slider .owl-carousel button.owl-dot.active:before {\n    -webkit-box-shadow: 0 0 0 2px #a0d7e7;\n    box-shadow: 0 0 0 2px #a0d7e7;\n}\n\n.slider .owl-carousel button.owl-dot:not(:last-child) {\n    margin-right: 10px;\n}\n\nbody.dark .slider__close {\n    background: #242731;\n    -webkit-box-shadow: 0 10px 10px rgba(0, 0, 0, 0.3);\n    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.3);\n}\n\nbody.dark .slider__close .icon {\n    fill: #ffffff;\n}\n\n.btn {\n    min-width: 166px;\n    height: 56px;\n    padding: 0 20px;\n    border-radius: 16px/16px;\n    font-family: 'Inter', sans-serif;\n    font-size: 14px;\n    line-height: 1.42857;\n    font-weight: 700;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.btn .icon,\n.btn__text {\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.btn .icon {\n    position: relative;\n    top: -2px;\n    font-size: 20px;\n}\n\n.btn .icon:not(:last-child) {\n    margin-right: 10px;\n}\n\n.btn_white {\n    background: #ffffff;\n    color: #1b1d21;\n}\n\n.btn_white:hover {\n    color: var(--main-color);\n}\n\n.btn_purple {\n    background: var(--main-color);\n    color: #ffffff;\n}\n\n.btn_purple:hover {\n    background: #5a49ce;\n}\n\n.btn_blue {\n    background: #f4c257;\n    color: #ffffff;\n}\n\n.btn_blue:hover {\n    background: #1b77ff;\n}\n\n.btn_blue-dark {\n    background: #0049c6;\n    color: #ffffff;\n}\n\n.btn_blue-dark:hover {\n    background: #0056ea;\n}\n\n.btn_primary {\n    background: #1b1d21;\n    color: #ffffff;\n}\n\n.btn_primary .icon {\n    fill: #ffffff;\n}\n\n.btn_primary:hover {\n    background: var(--main-color);\n}\n\n.btn_gray {\n    background: #e4e4e4;\n    color: #11142d;\n}\n\n.btn_gray:hover {\n    background: rgba(228, 228, 228, 0.5);\n}\n\n.btn_wide {\n    min-width: 100%;\n}\n\n.btn[href] {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\nbody.dark .btn_white {\n    background: #242731;\n    color: #ffffff;\n}\n\nbody.dark .btn_white:hover {\n    background: #1b1d21;\n}\n\nbody.dark .btn_gray {\n    background: rgba(228, 228, 228, 0.1);\n    color: #ffffff;\n}\n\nbody.dark .btn_gray:hover {\n    opacity: 0.8;\n}\n\n.widget {\n    padding: 32px;\n    border-radius: 24px;\n    background: #ffffff;\n}\n\n.widget__head {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    height: 88px;\n    padding: 0 32px;\n}\n\n.widget>.widget__title {\n    margin-bottom: 32px;\n}\n\n.widget__title {\n    font-family: 'Poppins', sans-serif;\n    font-size: 18px;\n    line-height: 1.33333;\n}\n\n.widget__top {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin-bottom: 32px;\n}\n\n.widget__next {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    width: 24px;\n    height: 24px;\n    font-size: 0;\n}\n\n.widget__next .icon {\n    font-size: 10px;\n    fill: #11142d;\n    -webkit-transition: fill 0.25s;\n    -o-transition: fill 0.25s;\n    transition: fill 0.25s;\n}\n\n.widget__next:hover .icon {\n    fill: var(--main-color);\n}\n\n.widget__item {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.widget__item:before {\n    content: '';\n    position: absolute;\n    top: -12px;\n    left: -12px;\n    right: -12px;\n    bottom: -12px;\n    border-radius: 16px;\n    background: var(--main-color);\n    opacity: 0;\n    -webkit-transition: opacity 0.25s;\n    -o-transition: opacity 0.25s;\n    transition: opacity 0.25s;\n}\n\n.widget__item:hover:before {\n    opacity: 1;\n}\n\n.widget__item:not(:last-child) {\n    margin-bottom: 40px;\n}\n\n.widget__preview {\n    position: relative;\n    z-index: 2;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 56px;\n    height: 56px;\n    border-radius: 16px;\n    overflow: hidden;\n    font-size: 0;\n}\n\n.widget__pic {\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.widget__details {\n    position: relative;\n    z-index: 2;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    padding-left: 24px;\n}\n\n.widget__item .widget__category {\n    position: relative;\n    margin-bottom: 3px;\n    padding-right: 30px;\n    color: #11142d;\n    -webkit-transition: color 0.25s;\n    -o-transition: color 0.25s;\n    transition: color 0.25s;\n}\n\n.widget__item .widget__category .icon {\n    position: absolute;\n    top: 50%;\n    right: 9px;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    font-size: 10px;\n    fill: #11142d;\n    -webkit-transition: fill 0.25s;\n    -o-transition: fill 0.25s;\n    transition: fill 0.25s;\n}\n\n.widget__info {\n    color: #808191;\n    -webkit-transition: color 0.25s;\n    -o-transition: color 0.25s;\n    transition: color 0.25s;\n}\n\n.widget__item:hover .widget__category,\n.widget__item:hover .widget__info {\n    color: #ffffff;\n}\n\n.widget__item:hover .widget__category .icon,\n.widget__item:hover .widget__info .icon {\n    fill: #ffffff;\n}\n\n.widget__wrap {\n    padding: 24px;\n    border-radius: 16px;\n    background: #ffffff;\n}\n\n.widget__chart_earning {\n    height: 205px;\n    margin-top: -20px;\n    margin-left: -20px;\n    margin-bottom: 15px;\n}\n\n.widget__chart_impressions {\n    height: 320px;\n    margin-left: -20px;\n}\n\n.widget__chart_users {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 120px;\n    height: 80px;\n    margin-top: -5px;\n}\n\n.widget__chart_earning-month {\n    max-width: 120px;\n    height: 120px;\n    margin: 0 auto;\n}\n\n.widget__chart_items {\n    height: 240px;\n}\n\n.widget__col:first-child {\n    margin-bottom: 32px;\n}\n\n.widget__counter {\n    margin-bottom: 12px;\n}\n\n.widget__foot {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    height: 40px;\n}\n\n.widget__foot .widget__link {\n    color: var(--main-color);\n    -webkit-transition: color 0.25s;\n    -o-transition: color 0.25s;\n    transition: color 0.25s;\n}\n\n.widget__foot .widget__link:hover {\n    color: var(--main-color);\n}\n\n.widget__flex {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.widget__legend {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n.widget__color {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    color: #808191;\n}\n\n.widget__color:not(:last-child) {\n    margin-right: 24px;\n}\n\n.widget__bg {\n    width: 20px;\n    height: 20px;\n    border-radius: 8px;\n    margin-right: 8px;\n}\n\n.widget__text_mb32 {\n    margin-bottom: 32px;\n}\n\n.widget__text_mb40 {\n    margin-bottom: 40px;\n}\n\n.widget_shadow {\n    position: relative;\n}\n\n.widget_shadow:before {\n    content: '';\n    position: absolute;\n    top: 22px;\n    left: 18px;\n    right: 18px;\n    bottom: -40px;\n    z-index: -2;\n    background: #e3e6ec;\n    opacity: 0.91;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\n.widget_chart {\n    padding: 32px 8px 8px;\n}\n\n.widget_chart .widget__title {\n    padding: 0 24px;\n}\n\n.widget_pink {\n    background: #ffebf6;\n}\n\n.widget_purple {\n    background: var(--main-color);\n}\n\n.widget_stat {\n    position: relative;\n    text-align: center;\n}\n\n.widget_stat:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n    background: #e3e6ec;\n    opacity: 0.91;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\n.widget_stat .widget__title {\n    margin-bottom: 12px;\n}\n\n.widget_stat>.widget__text {\n    max-width: 185px;\n    margin: 0 auto 18px;\n    color: #808191;\n}\n\n.widget_stat .widget__btn.btn_white {\n    -webkit-box-shadow: 0 10px 20px rgba(227, 230, 236, 0.6);\n    box-shadow: 0 10px 20px rgba(227, 230, 236, 0.6);\n    color: var(--main-color);\n}\n\n.widget_stat .widget__btn.btn_white:hover {\n    color: #1b1d21;\n}\n\n.widget_empty {\n    background: none;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    border-radius: 0;\n}\n\n.widget_stat.widget_empty:before {\n    display: none;\n}\n\n.widget_p0 {\n    padding: 0;\n}\n\n.widget_pt0 {\n    padding-top: 0;\n}\n\n.widget_pb60 {\n    padding-bottom: 58px;\n}\n\n.widget_users .widget__flex {\n    padding: 26px 32px 40px;\n    -webkit-box-shadow: inset 0px -1px 0px #e4e4e4;\n    box-shadow: inset 0px -1px 0px #e4e4e4;\n}\n\n.widget_users .widget__flex:first-child {\n    padding-top: 0;\n}\n\n.widget_users .widget__desc {\n    margin-right: auto;\n}\n\n.widget_users .widget__category {\n    line-height: 1.3;\n    color: #808191;\n}\n\n.widget_users .widget__percent {\n    font-weight: 600;\n    line-height: 1.3;\n    color: #7fba7a;\n}\n\n.widget_after:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: -1;\n    bottom: -8px;\n    border-radius: 24px;\n    background: rgba(255, 255, 255, 0.5);\n}\n\nbody.dark .widget {\n    background: #242731;\n}\n\nbody.dark .widget__item .widget__category {\n    color: #ffffff;\n}\n\nbody.dark .widget__item .widget__category .icon {\n    fill: #ffffff;\n}\n\nbody.dark .widget__wrap {\n    background: #242731;\n}\n\nbody.dark .widget__next .icon {\n    fill: #ffffff;\n}\n\nbody.dark .widget_shadow:before {\n    background: #000;\n    opacity: 0.51;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\nbody.dark .widget_pink {\n    background: #f4c257;\n}\n\nbody.dark .widget_stat:before {\n    background: #000;\n    opacity: 0.51;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\nbody.dark .widget_stat .widget__btn.btn_white {\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    background: #1f2128;\n}\n\nbody.dark .widget_stat .widget__btn.btn_white:hover {\n    color: #ffffff;\n}\n\nbody.dark .widget_empty {\n    background: none;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n}\n\nbody.dark .widget_users .widget__flex {\n    -webkit-box-shadow: inset 0px -1px 0px rgba(228, 228, 228, 0.1);\n    box-shadow: inset 0px -1px 0px rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .widget_purple {\n    background: var(--main-color);\n}\n\nbody.dark .widget_after:after {\n    background: rgba(36, 39, 49, 0.5);\n}\n\n.header {\n    position: relative;\n    z-index: 10;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    max-width: 298px;\n    margin-left: auto;\n}\n\n.header .search {\n    width: 214px;\n    margin-left: -8px;\n    margin-right: auto;\n}\n\n.header__user {\n    display: none;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 40px;\n    height: 40px;\n    font-size: 0;\n}\n\n.header__pic {\n    width: 100%;\n    min-height: 100%;\n    border-radius: 50%;\n}\n\n.header__burger {\n    display: none;\n    width: 32px;\n    height: 40px;\n    margin-right: auto;\n    font-size: 0;\n}\n\n.header__burger:before,\n.header__burger:after {\n    content: '';\n    display: inline-block;\n    width: 32px;\n    height: 2px;\n    margin: 3px auto;\n    border-radius: 1px;\n    background: #1b1d21;\n}\n\n.header__search {\n    display: none;\n    width: 40px;\n    height: 40px;\n    margin-right: 25px;\n    border-radius: 50%;\n    -webkit-box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);\n    box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);\n    font-size: 0;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.header__search .icon {\n    font-size: 20px;\n    fill: #1b1d21;\n}\n\n.header__search.active {\n    background: var(--main-color);\n}\n\n.header__search.active .icon {\n    fill: #ffffff;\n}\n\nbody.dark .header__burger:before,\nbody.dark .header__burger:after {\n    background: #ffffff;\n}\n\nbody.dark .header__search {\n    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);\n    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);\n}\n\nbody.dark .header__search .icon {\n    fill: #ffffff;\n}\n\n.search {\n    position: relative;\n    z-index: 3;\n}\n\n.search__field {\n    position: relative;\n    z-index: 2;\n}\n\n.search__input {\n    width: 100%;\n    height: 48px;\n    padding: 0 10px 0 44px;\n    border-radius: 12px;\n    background: transparent;\n    font-family: 'Inter', sans-serif;\n    font-size: 14px;\n    color: #11142d;\n    -webkit-transition: background 0.25s;\n    -o-transition: background 0.25s;\n    transition: background 0.25s;\n}\n\n.search__input::-webkit-input-placeholder {\n    color: #808191;\n}\n\n.search__input::-ms-input-placeholder {\n    color: #808191;\n}\n\n.search__input::placeholder {\n    color: #808191;\n}\n\n.search__toggle {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 42px;\n    font-size: 0;\n}\n\n.search__toggle .icon {\n    fill: #1b1d21;\n    -webkit-transition: fill 0.25s;\n    -o-transition: fill 0.25s;\n    transition: fill 0.25s;\n}\n\n.search__toggle .icon-search {\n    font-size: 20px;\n}\n\n.search__toggle .icon-close {\n    display: none;\n    font-size: 16px;\n}\n\n.search__toggle:hover .icon {\n    fill: var(--main-color);\n}\n\n.search__result {\n    position: absolute;\n    top: -4px;\n    left: -4px;\n    right: -4px;\n    padding: 70px 16px 24px;\n    border-radius: 12px;\n    background: #ffffff;\n    -webkit-box-shadow: 0 10px 30px rgba(227, 230, 236, 0.5);\n    box-shadow: 0 10px 30px rgba(227, 230, 236, 0.5);\n    visibility: hidden;\n    opacity: 0;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.search__info {\n    color: #808191;\n}\n\n.search__item {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    padding: 16px 0;\n    color: #11142d;\n    -webkit-transition: color 0.25s;\n    -o-transition: color 0.25s;\n    transition: color 0.25s;\n}\n\n.search__item:hover {\n    color: var(--main-color);\n}\n\n.search__item:not(:last-child) {\n    border-bottom: 1px solid #e4e4e4;\n}\n\n.search__preview {\n    position: relative;\n    z-index: 2;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 40px;\n    height: 40px;\n    margin-right: 15px;\n    border-radius: 12px;\n    overflow: hidden;\n    font-size: 0;\n}\n\n.search__pic {\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.search__text {\n    position: relative;\n    padding-right: 30px;\n    line-height: 1.42857;\n    font-weight: 600;\n}\n\n.search__text .icon {\n    position: absolute;\n    top: 5px;\n    right: 9px;\n    font-size: 10px;\n    fill: #11142d;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.search__item:hover .icon {\n    -webkit-transform: translateX(4px);\n    -ms-transform: translateX(4px);\n    transform: translateX(4px);\n    fill: var(--main-color);\n}\n\n.search__btn {\n    height: 40px;\n}\n\n.search.active .search__input {\n    background: rgba(228, 228, 228, 0.3);\n}\n\n.search.active .search__toggle .icon-search {\n    display: none;\n}\n\n.search.active .search__toggle .icon-close {\n    display: inline-block;\n}\n\n.search.active .search__result {\n    visibility: visible;\n    opacity: 1;\n}\n\nbody.dark .search__toggle .icon {\n    fill: #ffffff;\n}\n\nbody.dark .search__toggle:hover .icon {\n    fill: var(--main-color);\n}\n\nbody.dark .search__input {\n    color: #ffffff;\n}\n\nbody.dark .search__result {\n    background: #242731;\n    -webkit-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n}\n\nbody.dark .search__item {\n    color: #ffffff;\n}\n\nbody.dark .search__text .icon {\n    fill: #ffffff;\n}\n\nbody.dark .search__item:not(:last-child) {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .search.active .search__input {\n    background: rgba(228, 228, 228, 0.03);\n}\n\n.notifications {\n    position: relative;\n}\n\n.notifications__open {\n    position: relative;\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    font-size: 0;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.notifications__open .icon {\n    font-size: 24px;\n    fill: #1b1d21;\n    -webkit-transition: fill 0.25s;\n    -o-transition: fill 0.25s;\n    transition: fill 0.25s;\n}\n\n.notifications__open:hover {\n    -webkit-box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);\n    box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);\n}\n\n.notifications__counter {\n    position: absolute;\n    top: 0;\n    right: -12px;\n    display: inline-block;\n    min-width: 24px;\n    line-height: 24px;\n    border-radius: 50%;\n    background: #ff754c;\n    font-size: 12px;\n    font-weight: 600;\n    color: #ffffff;\n}\n\n.notifications__wrap {\n    position: absolute;\n    top: calc(100% + 24px);\n    right: -12px;\n    width: 360px;\n    padding: 32px 8px 36px;\n    -webkit-box-shadow: 0 10px 36px rgba(227, 230, 236, 0.6);\n    box-shadow: 0 10px 36px rgba(227, 230, 236, 0.6);\n    background: #ffffff;\n    border-radius: 24px;\n    visibility: hidden;\n    opacity: 0;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.notifications__info {\n    margin-bottom: 32px;\n    padding: 0 24px;\n}\n\n.notifications__list {\n    margin-bottom: 32px;\n}\n\n.notifications__item {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    padding: 16px 28px 16px 20px;\n    border-radius: 12px;\n    background: transparent;\n    cursor: pointer;\n    -webkit-transition: background 0.25s;\n    -o-transition: background 0.25s;\n    transition: background 0.25s;\n}\n\n.notifications__item:hover {\n    background: var(--main-color);\n}\n\n.notifications__ava {\n    position: relative;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 48px;\n    height: 48px;\n    margin-right: 24px;\n    font-size: 0;\n}\n\n.notifications__ava>.notifications__pic {\n    width: 100%;\n    min-height: 100%;\n    border-radius: 50%;\n}\n\n.notifications__status {\n    position: absolute;\n    top: 0;\n    right: -1px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    width: 21px;\n    height: 21px;\n    border: 2px solid #ffffff;\n    border-radius: 50%;\n    font-size: 0;\n}\n\n.notifications__status .notifications__pic {\n    max-width: 10px;\n}\n\n.notifications__details {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n\n.notifications__line {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-bottom: 6px;\n}\n\n.notifications__user {\n    margin-right: auto;\n    color: #11142d;\n    -webkit-transition: color 0.25s;\n    -o-transition: color 0.25s;\n    transition: color 0.25s;\n}\n\n.notifications__time,\n.notifications__text {\n    color: #b2b3bd;\n    -webkit-transition: color 0.25s;\n    -o-transition: color 0.25s;\n    transition: color 0.25s;\n}\n\n.notifications__time {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    margin-left: 20px;\n}\n\n.notifications__project {\n    padding-left: 5px;\n    color: var(--main-color);\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.notifications__item:hover .notifications__user,\n.notifications__item:hover .notifications__time,\n.notifications__item:hover .notifications__text,\n.notifications__item:hover .notifications__project {\n    color: #ffffff;\n}\n\n.notifications__btns {\n    text-align: center;\n}\n\n.notifications__btn {\n    min-width: 230px;\n}\n\n.notifications.active .notifications__open {\n    background: var(--main-color);\n    -webkit-box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);\n    box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);\n}\n\n.notifications.active .notifications__open .icon {\n    fill: #ffffff;\n}\n\n.notifications.active .notifications__wrap {\n    visibility: visible;\n    opacity: 1;\n}\n\nbody.dark .notifications__open {\n    background: #242731;\n}\n\nbody.dark .notifications__open .icon {\n    fill: #ffffff;\n}\n\nbody.dark .notifications__open:hover {\n    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);\n    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);\n}\n\nbody.dark .notifications__wrap {\n    background: #242731;\n    -webkit-box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\nbody.dark .notifications__user {\n    color: #ffffff;\n}\n\nbody.dark .notifications.active .notifications__open {\n    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.7);\n    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.7);\n}\n\n.banner__container {\n    position: relative;\n    padding: 64px 64px 76px;\n    border-radius: 24px;\n    background: var(--main-color);\n    overflow: hidden;\n}\n\n.banner__wrap {\n    max-width: 400px;\n    color: #ffffff;\n}\n\n.banner__text {\n    margin-bottom: 16px;\n}\n\n.banner__btn {\n    min-width: 209px;\n}\n\n.banner__preview {\n    position: absolute;\n    top: 40px;\n    right: 90px;\n    width: 543px;\n    font-size: 0;\n}\n\n.banner__preview .banner__pic {\n    width: 100%;\n}\n\n.banner:not(:last-child) {\n    margin-bottom: 32px;\n}\n\n.sorting__row {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin: 0 -8px;\n}\n\n.sorting__col {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 calc(50% - 16px);\n    flex: 0 0 calc(50% - 16px);\n    width: calc(50% - 16px);\n    margin: 0 8px;\n}\n\n.sorting__dropdowns {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin: 0 -8px;\n}\n\n.sorting__dropdowns .dropdown {\n    margin: 0 8px;\n}\n\n.sorting__line {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.sorting__search {\n    position: relative;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n\n.sorting__line .sorting__search {\n    margin-right: 45px;\n}\n\n.sorting__input {\n    width: 100%;\n    height: 43px;\n    padding: 0 20px 0 55px;\n    border: none;\n    border-radius: 16px;\n    background: rgba(228, 228, 228, 0.2);\n    font-family: 'Inter', sans-serif;\n    font-size: 14px;\n    font-weight: 600;\n    color: #1b1d21;\n}\n\n.sorting__input::-webkit-input-placeholder {\n    color: #808191;\n}\n\n.sorting__input::-ms-input-placeholder {\n    color: #808191;\n}\n\n.sorting__input::placeholder {\n    color: #808191;\n}\n\n.sorting__open {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 55px;\n    font-size: 0;\n}\n\n.sorting__open .icon {\n    font-size: 20px;\n    fill: #11142d;\n    -webkit-transition: fill 0.25s;\n    -o-transition: fill 0.25s;\n    transition: fill 0.25s;\n}\n\n.sorting__open:hover .icon {\n    fill: var(--main-color);\n}\n\n.sorting__actions {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.sorting__action {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background: #ffffff;\n    font-size: 0;\n    -webkit-transition: -webkit-box-shadow 0.25s;\n    transition: -webkit-box-shadow 0.25s;\n    -o-transition: box-shadow 0.25s;\n    transition: box-shadow 0.25s;\n    transition: box-shadow 0.25s, -webkit-box-shadow 0.25s;\n}\n\n.sorting__action .icon {\n    font-size: 17px;\n    fill: #11142d;\n}\n\n.sorting__action .icon-edit {\n    font-size: 19px;\n}\n\n.sorting__action .icon-box {\n    font-size: 15px;\n}\n\n.sorting__action:hover {\n    -webkit-box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);\n    box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);\n}\n\n.sorting__action:not(:last-child) {\n    margin-right: 0;\n}\n\n.sorting:not(:last-child) {\n    margin-bottom: 15px;\n}\n\nbody.dark .sorting__input {\n    background: rgba(228, 228, 228, 0.04);\n    color: #ffffff;\n}\n\nbody.dark .sorting__open .icon {\n    fill: #ffffff;\n}\n\nbody.dark .sorting__action {\n    background: #242731;\n}\n\nbody.dark .sorting__action .icon {\n    fill: #ffffff;\n}\n\nbody.dark .sorting__action:hover {\n    -webkit-box-shadow: 0 12px 20px rgba(0, 0, 0, 0.25);\n    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.25);\n}\n\n.dropdown {\n    position: relative;\n}\n\n.dropdown__head {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    height: 43px;\n    padding: 0 46px 0 21px;\n    border: 2px solid transparent;\n    background: rgba(228, 228, 228, 0.3);\n    border-radius: 16px;\n    font-weight: 600;\n    color: #808191;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n    cursor: pointer;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.dropdown__head:before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    right: 20px;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    width: 14px;\n    height: 8px;\n    background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='8'%3E%3Cpath fill='%231b1d21' d='M.293.293A1 1 0 0 1 1.613.21l.094.083L7 5.585 12.293.293a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 .083 1.32l-.083.094-6 6a1 1 0 0 1-1.32.083l-.094-.083-6-6a1 1 0 0 1 0-1.414z'/%3E%3C/svg%3E\") no-repeat 50% 50%/100% auto;\n    -webkit-transition: -webkit-transform 0.25s;\n    transition: -webkit-transform 0.25s;\n    -o-transition: transform 0.25s;\n    transition: transform 0.25s;\n    transition: transform 0.25s, -webkit-transform 0.25s;\n}\n\n.dropdown__body {\n    position: absolute;\n    top: calc(100% + 8px);\n    left: 0;\n    z-index: 20;\n    width: 310px;\n    padding: 32px;\n    border: 1px solid #e4e4e4;\n    background: #ffffff;\n    border-radius: 24px;\n    visibility: hidden;\n    opacity: 0;\n    -webkit-box-shadow: 0 20px 16px rgba(227, 230, 236, 0.6);\n    box-shadow: 0 20px 16px rgba(227, 230, 236, 0.6);\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.dropdown__item {\n    display: block;\n}\n\n.dropdown__item:not(:last-child) {\n    margin-bottom: 24px;\n}\n\n.dropdown__title {\n    position: relative;\n    margin-bottom: 3px;\n    padding-right: 30px;\n    color: #11142d;\n    -webkit-transition: color 0.25s;\n    -o-transition: color 0.25s;\n    transition: color 0.25s;\n}\n\n.dropdown__title:before {\n    content: '';\n    position: absolute;\n    top: 5px;\n    right: 8px;\n    width: 6px;\n    height: 10px;\n    background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='10'%3E%3Cpath fill='%2311142d' d='M.293.293A1 1 0 0 1 1.613.21l.094.083 4 4a1 1 0 0 1 .083 1.32l-.083.094-4 4A1 1 0 0 1 .21 8.387l.083-.094L3.585 5 .293 1.707A1 1 0 0 1 .21.387L.293.293z'/%3E%3C/svg%3E\") no-repeat 50% 50%/100% auto;\n    -webkit-transition: -webkit-transform 0.25s;\n    transition: -webkit-transform 0.25s;\n    -o-transition: transform 0.25s;\n    transition: transform 0.25s;\n    transition: transform 0.25s, -webkit-transform 0.25s;\n}\n\n.dropdown__info {\n    color: #808191;\n    -webkit-transition: color 0.25s;\n    -o-transition: color 0.25s;\n    transition: color 0.25s;\n}\n\n.dropdown__item:hover .dropdown__title:before {\n    -webkit-transform: translateX(5px);\n    -ms-transform: translateX(5px);\n    transform: translateX(5px);\n}\n\n.dropdown__item:hover .dropdown__title,\n.dropdown__item:hover .dropdown__info {\n    color: var(--main-color);\n}\n\n.dropdown.active .dropdown__head {\n    border-color: var(--main-color);\n    background: #ffffff;\n    color: #11142d;\n}\n\n.dropdown.active .dropdown__head:before {\n    -webkit-transform: translateY(-50%) rotate(180deg);\n    -ms-transform: translateY(-50%) rotate(180deg);\n    transform: translateY(-50%) rotate(180deg);\n}\n\n.dropdown.active .dropdown__body {\n    visibility: visible;\n    opacity: 1;\n}\n\nbody.dark .dropdown__head {\n    background: rgba(228, 228, 228, 0.04);\n}\n\nbody.dark .dropdown__head:before {\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='8'%3E%3Cpath fill='%23ffffff' d='M.293.293A1 1 0 0 1 1.613.21l.094.083L7 5.585 12.293.293a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 .083 1.32l-.083.094-6 6a1 1 0 0 1-1.32.083l-.094-.083-6-6a1 1 0 0 1 0-1.414z'/%3E%3C/svg%3E\");\n}\n\nbody.dark .dropdown__body {\n    border-color: rgba(228, 228, 228, 0.1);\n    background: #242731;\n    -webkit-box-shadow: 0 20px 16px rgba(0, 0, 0, 0.5);\n    box-shadow: 0 20px 16px rgba(0, 0, 0, 0.5);\n}\n\nbody.dark .dropdown__title {\n    color: #ffffff;\n}\n\nbody.dark .dropdown__title:before {\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='10'%3E%3Cpath fill='%23ffffff' d='M.293.293A1 1 0 0 1 1.613.21l.094.083 4 4a1 1 0 0 1 .083 1.32l-.083.094-4 4A1 1 0 0 1 .21 8.387l.083-.094L3.585 5 .293 1.707A1 1 0 0 1 .21.387L.293.293z'/%3E%3C/svg%3E\");\n}\n\nbody.dark .dropdown.active .dropdown__head {\n    background: rgba(228, 228, 228, 0.04);\n    color: #ffffff;\n}\n\n.products>.products__title {\n    margin-bottom: 16px;\n}\n\n.products>.products__info {\n    margin-bottom: 20px;\n    color: #808191;\n}\n\n.products__table {\n    display: table;\n    width: 100%;\n}\n\n.products__row {\n    display: table-row;\n    height: 48px;\n    min-height: 48px;\n}\n\n.products__row_head .products__cell {\n    padding-top: 24px;\n    padding-bottom: 24px;\n    font-size: 13px;\n    line-height: 1.38462;\n    font-weight: 500;\n    color: #b2b3bd;\n}\n\n.products__cell {\n    display: table-cell;\n    vertical-align: middle;\n    padding-left: 20px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #e4e4e4;\n}\n\n.products__cell:first-child {\n    width: 20px;\n    padding: 0;\n    font-size: 0;\n}\n\n.products__item {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    color: #11142d;\n}\n\n.products__preview {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 96px;\n    height: 72px;\n    border-radius: 8px;\n    font-size: 0;\n}\n\n.products__preview:before {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 7px;\n    right: 7px;\n    height: 8px;\n    border-radius: 0 0 8px 8px;\n    background: #e7faff;\n}\n\n.products__pic {\n    max-height: 100%;\n}\n\n.products__details {\n    padding-left: 24px;\n}\n\n.products__cell .products__title {\n    margin-bottom: 9px;\n}\n\n.products__color {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.products__bg {\n    width: 20px;\n    height: 20px;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    border-radius: 4px;\n}\n\n.products__rating {\n    color: #808191;\n}\n\n.products__color .products__text {\n    margin-left: 8px;\n}\n\n.products__more {\n    padding-top: 40px;\n    text-align: center;\n}\n\n.products__cost {\n    position: relative;\n    cursor: pointer;\n}\n\n.products__cost .products__tooltip {\n    position: absolute;\n    top: 10%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    min-width: 160px;\n    padding: 32px 26px;\n    background: #ffffff;\n    border-radius: 24px;\n    -webkit-box-shadow: 0 20px 30px rgba(227, 230, 236, 0.9);\n    box-shadow: 0 20px 30px rgba(227, 230, 236, 0.9);\n    visibility: hidden;\n    opacity: 0;\n    -webkit-transition: all 0.2s;\n    -o-transition: all 0.2s;\n    transition: all 0.2s;\n}\n\n.products__cost:hover .products__tooltip {\n    visibility: visible;\n    opacity: 1;\n}\n\n.products__sale {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin-bottom: 8px;\n    color: #808191;\n}\n\n.products__sale .products__icon {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 16px;\n    height: 16px;\n    margin-right: 8px;\n    border-radius: 6px;\n}\n\n.products__sale .products__pic {\n    max-width: 8px;\n}\n\n.products__progress {\n    position: relative;\n    width: 100%;\n    height: 2px;\n    border-radius: 1px;\n    background: #e4e4e4;\n}\n\n.products__progress span {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    border-radius: 1px;\n    background: var(--main-color);\n}\n\n.products__price:not(:last-child) {\n    margin-bottom: 10px;\n}\n\n.products__transaction {\n    color: #808191;\n}\n\n.products__status {\n    display: inline-block;\n    padding: 3px 16px;\n    border-radius: 4px;\n    color: #ffffff;\n}\n\n.products__body {\n    display: none;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin: 0 24px 24px;\n    padding: 4px;\n    border: 1px solid #e4e4e4;\n    border-radius: 8px;\n}\n\n.products__line {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n\n.products_main .products__money {\n    color: var(--main-color);\n}\n\n.products_main .products__col:first-child {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 30%;\n    flex: 0 0 30%;\n    padding-right: 8px;\n}\n\n.products_main .products__col:nth-child(2) {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 44%;\n    flex: 0 0 44%;\n    padding-right: 8px;\n}\n\n.products_main .products__col:nth-child(3) {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 26%;\n    flex: 0 0 26%;\n}\n\n.products_history .products__col:first-child {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 42%;\n    flex: 0 0 42%;\n    padding-right: 8px;\n}\n\n.products_history .products__col:nth-child(2) {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 32%;\n    flex: 0 0 32%;\n    padding-right: 8px;\n}\n\n.products_history .products__col:nth-child(3) {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 26%;\n    flex: 0 0 26%;\n}\n\n.products_statement .products__col:first-child {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 42%;\n    flex: 0 0 42%;\n    padding-right: 8px;\n}\n\n.products_statement .products__col:nth-child(2) {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 32%;\n    flex: 0 0 32%;\n    padding-right: 8px;\n}\n\n.products_statement .products__col:nth-child(3) {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 26%;\n    flex: 0 0 26%;\n}\n\nbody.dark .products__cell {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .products__item {\n    color: #ffffff;\n}\n\nbody.dark .products__body {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\n.checkbox {\n    display: inline-block;\n    position: relative;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    cursor: pointer;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.checkbox__input {\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n}\n\n.checkbox__in {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.checkbox__tick {\n    position: relative;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 20px;\n    flex: 0 0 20px;\n    width: 20px;\n    height: 20px;\n    border-radius: 4px;\n    border: 2px solid #e4e4e4;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.checkbox__tick:before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    width: 10px;\n    height: 9px;\n    opacity: 0;\n    background: url(\"data:image/svg+xml,%3Csvg width='10' height='9' viewBox='0 0 10 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.5 5.375L1.5 3.375L0 4.875L3.5 8.375L10 1.875L8.5 0.375L3.5 5.375Z' fill='white'/%3E%3C/svg%3E%0A\") no-repeat 50% 50%/100% auto;\n    -webkit-transition: opacity 0.25s;\n    -o-transition: opacity 0.25s;\n    transition: opacity 0.25s;\n}\n\n.checkbox__text {\n    margin-left: 8px;\n    padding-top: 2px;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.3;\n    color: #808191;\n}\n\n.checkbox:hover .checkbox__tick {\n    border-color: var(--main-color);\n}\n\n.checkbox__input:checked+.checkbox__in .checkbox__tick {\n    background: var(--main-color);\n    border-color: var(--main-color);\n}\n\n.checkbox__input:checked+.checkbox__in .checkbox__tick:before {\n    opacity: 1;\n}\n\n.checkbox__input:checked+.checkbox__in .checkbox__text {\n    color: #11142d;\n}\n\nbody.dark .checkbox__tick {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .checkbox__input:checked+.checkbox__in .checkbox__text {\n    color: #ffffff;\n}\n\n.radio {\n    display: inline-block;\n    position: relative;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    cursor: pointer;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.radio__input {\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n}\n\n.radio__in {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.radio__tick {\n    position: relative;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 20px;\n    flex: 0 0 20px;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    background: #e4e4e4;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.radio__tick:before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #ffffff;\n    -webkit-box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);\n    opacity: 0;\n    -webkit-transition: opacity 0.25s;\n    -o-transition: opacity 0.25s;\n    transition: opacity 0.25s;\n}\n\n.radio__text {\n    margin-left: 8px;\n    padding-top: 3px;\n    font-size: 13px;\n    line-height: 1.2;\n    color: #808191;\n    -webkit-transition: color 0.25s;\n    -o-transition: color 0.25s;\n    transition: color 0.25s;\n}\n\n.radio:hover .radio__tick {\n    background: var(--main-color);\n}\n\n.radio__input:checked+.radio__in .radio__tick {\n    background: var(--main-color);\n}\n\n.radio__input:checked+.radio__in .radio__tick:before {\n    opacity: 1;\n}\n\n.radio__input:checked+.radio__in .radio__text {\n    color: #11142d;\n}\n\nbody.dark .radio__tick {\n    background: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .radio__input:checked+.radio__in .radio__text {\n    color: #ffffff;\n}\n\n.details__container {\n    position: relative;\n    padding: 32px 32px 38px;\n    background: #ffffff;\n    border-radius: 24px;\n}\n\n.details__container:before {\n    content: '';\n    position: absolute;\n    top: 28px;\n    left: 18px;\n    right: 18px;\n    bottom: -28px;\n    z-index: -1;\n    background: #e3e6ec;\n    opacity: 0.91;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\n.details__title {\n    margin-bottom: 40px;\n}\n\n.details__row {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-bottom: 30px;\n}\n\n.details__col:first-child {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 145px;\n    padding-right: 16px;\n}\n\n.details__col:nth-child(2) {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n\n.details__top {\n    margin-bottom: 16px;\n    padding-bottom: 16px;\n    border-bottom: 1px solid #e4e4e4;\n}\n\n.details__number {\n    margin-bottom: 16px;\n}\n\n.details__line {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    color: var(--main-color);\n    -webkit-transition: color 0.25s;\n    -o-transition: color 0.25s;\n    transition: color 0.25s;\n}\n\n.details__line:hover {\n    color: var(--main-color);\n}\n\n.details__preview {\n    font-size: 0;\n}\n\n.details__line .details__preview {\n    width: 32px;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    margin-right: 16px;\n}\n\n.details__statistics {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.details__status {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.details__status .details__icon {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 16px;\n    height: 16px;\n    margin-right: 4px;\n    border-radius: 50%;\n    font-size: 0;\n}\n\n.details__status .details__icon .icon {\n    font-size: 6px;\n    fill: #ffffff;\n}\n\n.details__box {\n    position: relative;\n    padding: 5px 5px 13px;\n    border-radius: 16px;\n    background: #f4c257;\n}\n\n.details__chart_activity {\n    height: 25px;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    padding-right: 13px;\n}\n\n.details__chart_counter {\n    height: 200px;\n}\n\n.details__chart_counter .apexcharts-tooltip.apexcharts-theme-light {\n    background: #1b1d21;\n    border: none;\n    color: #ffffff;\n}\n\n.details__chart_report {\n    height: 215px;\n}\n\n.details__info {\n    color: #b2b3bd;\n}\n\n.details__list {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    border-radius: 16px;\n    border: 1px solid #e4e4e4;\n}\n\n.details__item {\n    padding: 24px;\n}\n\n.details__item:not(:last-child) {\n    border-right: 1px solid #e4e4e4;\n}\n\n.details__list_three .details__item {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 33.333%;\n    flex: 0 0 33.333%;\n    width: 33.333%;\n}\n\n.details__list_four .details__item {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    width: 25%;\n}\n\n.details__head {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.details__head .details__preview {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 16px;\n    height: 16px;\n    margin-right: 8px;\n    border-radius: 6px;\n    font-size: 0;\n}\n\n.details__head .details__pic {\n    max-width: 8px;\n}\n\n.details__indicator {\n    position: relative;\n    height: 2px;\n    border-radius: 1px;\n    background: #e4e4e4;\n}\n\n.details__progress {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n}\n\n.details__remove {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    z-index: 2;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: #ffffff;\n    font-size: 0;\n}\n\n.details__remove .icon {\n    font-size: 10px;\n    -webkit-transition: -webkit-transform 0.25s;\n    transition: -webkit-transform 0.25s;\n    -o-transition: transform 0.25s;\n    transition: transform 0.25s;\n    transition: transform 0.25s, -webkit-transform 0.25s;\n}\n\n.details__remove:hover .icon {\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n}\n\n.details .dropdown {\n    position: absolute;\n    top: 16px;\n    right: 20px;\n    width: 200px;\n}\n\n.details:not(:last-child) {\n    margin-bottom: 28px;\n}\n\n.details_statements:not(:last-child) {\n    margin-bottom: 68px;\n}\n\n.details_statements .details__col:first-child {\n    width: 170px;\n    padding-right: 25px;\n}\n\n.details_statements .details__counter {\n    margin-bottom: 10px;\n}\n\n.details_statements .details__line .details__info {\n    color: var(--main-color);\n}\n\nbody.dark .details__container {\n    background: #242731;\n}\n\nbody.dark .details__container:before {\n    background: #000;\n    opacity: 0.51;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\nbody.dark .details__remove {\n    background: #242731;\n}\n\nbody.dark .details__remove .icon {\n    fill: #ffffff;\n}\n\nbody.dark .details__list {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .details__top {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .details__item {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .details__indicator {\n    background: rgba(228, 228, 228, 0.1);\n}\n\n.quality__item {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.quality__item_chart {\n    position: relative;\n    padding-right: 60px;\n}\n\n.quality__item[href] {\n    color: #11142d;\n}\n\n.quality__item:not(:last-child) {\n    margin-bottom: 48px;\n}\n\n.quality__preview {\n    position: relative;\n    z-index: 2;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 48px;\n    height: 48px;\n    margin-right: 14px;\n    border-radius: 12px;\n    font-size: 0;\n}\n\n.quality__preview .quality__pic {\n    max-height: 100%;\n}\n\n.quality__chart {\n    position: absolute;\n    top: 73%;\n    right: -32px;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    width: 110px;\n    height: 110px;\n}\n\n.quality__details {\n    position: relative;\n    z-index: 2;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n\n.quality__percent {\n    position: absolute;\n    top: 39%;\n    left: 51%;\n    pointer-events: none;\n    -webkit-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n}\n\n.quality__info {\n    margin-top: 5px;\n    color: #808191;\n}\n\n.quality__btn {\n    margin-top: 40px;\n}\n\n.quality__btn_mt30 {\n    margin-top: 30px;\n}\n\n.quality__line {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.quality__line .quality__price {\n    margin-left: auto;\n    padding-left: 10px;\n    color: #7fba7a;\n}\n\n.quality__category {\n    position: relative;\n    padding-right: 20px;\n}\n\n.quality__category .icon {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    font-size: 10px;\n    -webkit-transition: -webkit-transform 0.25s;\n    transition: -webkit-transform 0.25s;\n    -o-transition: transform 0.25s;\n    transition: transform 0.25s;\n    transition: transform 0.25s, -webkit-transform 0.25s;\n}\n\n.quality__money {\n    display: inline-block;\n    margin-top: 8px;\n    padding: 3px 10px;\n    background: var(--main-color);\n    border-radius: 8px;\n    color: #ffffff;\n}\n\n.quality_big .quality__list {\n    margin: -8px -16px;\n}\n\n.quality_big .quality__item {\n    position: relative;\n    padding: 8px 16px;\n    background: transparent;\n    border-radius: 12px;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.quality_big .quality__item:before {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 10px;\n    right: 10px;\n    height: 0;\n    border-radius: 0 0 8px 8px;\n    background: #cfc8ff;\n    -webkit-transition: height 0.25s;\n    -o-transition: height 0.25s;\n    transition: height 0.25s;\n}\n\n.quality_big .quality__item:hover {\n    background: var(--main-color);\n    color: #ffffff;\n}\n\n.quality_big .quality__item:hover:before {\n    height: 6px;\n}\n\n.quality_big .quality__item:not(:last-child) {\n    margin-bottom: 24px;\n}\n\n.quality_big .quality__item:hover .quality__category {\n    color: #ffffff;\n}\n\n.quality_big .quality__item:hover .quality__category .icon {\n    fill: #ffffff;\n}\n\n.quality_big .quality__item:hover .quality__info {\n    color: #ffffff;\n}\n\n.quality_big .quality__preview {\n    position: relative;\n    width: 88px;\n    height: 80px;\n    margin-right: 24px;\n}\n\n.quality_big .quality__preview:before {\n    content: '';\n    position: absolute;\n}\n\nbody.dark .quality__item {\n    color: #ffffff;\n}\n\nbody.dark .quality__category .icon {\n    fill: #ffffff;\n}\n\n.goal__container {\n    min-height: 220px;\n    margin: 0 -16px 26px;\n}\n\n.goal__preview {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    height: 220px;\n    font-size: 0;\n}\n\n.goal__pic {\n    position: relative;\n    z-index: 2;\n    max-height: 100%;\n}\n\n.goal__bg {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    width: 50%;\n    border-radius: 16px;\n}\n\n.goal__item:not(:last-child) {\n    margin-bottom: 32px;\n}\n\n.goal__head {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-bottom: 13px;\n}\n\n.goal__percent {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    margin-left: auto;\n    padding-left: 15px;\n}\n\n.goal__indicator {\n    position: relative;\n    height: 8px;\n    background: #e4e4e4;\n    border-radius: 4px;\n}\n\n.goal__progress {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    border-radius: 4px;\n}\n\n.goal .owl-carousel .owl-item img {\n    width: auto;\n}\n\n.goal .owl-nav {\n    position: absolute;\n    top: 0;\n    left: 16px;\n    z-index: 2;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.goal .owl-carousel .owl-nav button.owl-prev,\n.goal .owl-carousel .owl-nav button.owl-next {\n    width: 24px;\n    height: 24px;\n    background: #ffffff;\n    border-radius: 50%;\n    -webkit-box-shadow: 0 5px 10px #e3e6ec;\n    box-shadow: 0 5px 10px #e3e6ec;\n    font-size: 0;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.goal .owl-carousel .owl-nav button.owl-prev .icon,\n.goal .owl-carousel .owl-nav button.owl-next .icon {\n    font-size: 10px;\n    fill: #11142d;\n    -webkit-transition: fill 0.25s;\n    -o-transition: fill 0.25s;\n    transition: fill 0.25s;\n}\n\n.goal .owl-carousel .owl-nav button.owl-prev:hover,\n.goal .owl-carousel .owl-nav button.owl-next:hover {\n    background: var(--main-color);\n}\n\n.goal .owl-carousel .owl-nav button.owl-prev:hover .icon,\n.goal .owl-carousel .owl-nav button.owl-next:hover .icon {\n    fill: #ffffff;\n}\n\n.goal .owl-carousel .owl-nav button.owl-prev {\n    margin-right: 8px;\n}\n\nbody.dark .goal__indicator {\n    background: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .goal .owl-carousel .owl-nav button.owl-prev,\nbody.dark .goal .owl-carousel .owl-nav button.owl-next {\n    background: #242731;\n    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);\n    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);\n}\n\nbody.dark .goal .owl-carousel .owl-nav button.owl-prev .icon,\nbody.dark .goal .owl-carousel .owl-nav button.owl-next .icon {\n    fill: #ffffff;\n}\n\nbody.dark .goal .owl-carousel .owl-nav button.owl-prev:hover,\nbody.dark .goal .owl-carousel .owl-nav button.owl-next:hover {\n    background: var(--main-color);\n}\n\n.schedules__container {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 32px 32px 32px 16px;\n    border-radius: 24px;\n    background: #ffffff;\n}\n\n.schedules__container:before {\n    content: '';\n    position: absolute;\n    top: 35px;\n    left: 35px;\n    right: 35px;\n    bottom: -35px;\n    z-index: -5;\n    background: #e3e6ec;\n    opacity: 0.91;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\n.schedules__col:first-child {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 310px;\n}\n\n.schedules__col:first-child .schedules__title {\n    display: none;\n}\n\n.schedules__col:nth-child(2) {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    padding-left: 16px;\n}\n\n.schedules__list {\n    margin-top: -8px;\n}\n\n.schedules__item {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    padding: 8px 16px;\n    border-radius: 12px;\n    background: transparent;\n    color: #11142d;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.schedules__item:before {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 10px;\n    right: 10px;\n    height: 6px;\n    border-radius: 0 0 6px 6px;\n    background: #cfc8ff;\n    opacity: 0;\n    -webkit-transition: opacity 0.25s;\n    -o-transition: opacity 0.25s;\n    transition: opacity 0.25s;\n}\n\n.schedules__item:hover {\n    color: var(--main-color);\n}\n\n.schedules__item:hover .icon {\n    fill: var(--main-color);\n}\n\n.schedules__item.active {\n    background: var(--main-color);\n    color: #ffffff;\n}\n\n.schedules__item.active:before {\n    opacity: 1;\n}\n\n.schedules__item:not(:last-child) {\n    margin-bottom: 24px;\n}\n\n.schedules__date {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 88px;\n    height: 80px;\n    margin-right: 24px;\n    padding-top: 7px;\n    border-radius: 12px;\n}\n\n.schedules__date:before {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 9px;\n    right: 9px;\n    height: 7px;\n    border-radius: 0 0 10px 10px;\n}\n\n.schedules__date.bg-pink-light:before {\n    background: rgba(255, 235, 246, 0.5);\n}\n\n.schedules__date.bg-purple-light:before {\n    background: rgba(207, 200, 255, 0.5);\n}\n\n.schedules__date.bg-blue-light:before {\n    background: rgba(160, 215, 231, 0.5);\n}\n\n.schedules__date.bg-yellow-light:before {\n    background: rgba(255, 226, 172, 0.5);\n}\n\n.schedules__name {\n    line-height: 1;\n    color: #808191;\n}\n\n.schedules__details {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n\n.schedules__category {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin-bottom: 5px;\n    padding-right: 35px;\n}\n\n.schedules__category .icon {\n    position: absolute;\n    top: 5px;\n    right: 20px;\n    font-size: 10px;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.schedules__info {\n    margin-bottom: 8px;\n    color: #808191;\n}\n\n.schedules__time {\n    display: inline-block;\n    padding: 3px 10px;\n    background: var(--main-color);\n    border-radius: 8px;\n    color: #ffffff;\n}\n\n.schedules__item.active .schedules__name,\n.schedules__item.active .schedules__info {\n    color: #ffffff;\n}\n\n.schedules__item.active .schedules__category .icon {\n    -webkit-transform: translateX(4px);\n    -ms-transform: translateX(4px);\n    transform: translateX(4px);\n    fill: #ffffff;\n}\n\n.schedules__item.active .schedules__date {\n    background: transparent;\n}\n\n.schedules__item.active .schedules__date:before {\n    background: transparent;\n}\n\n.schedules__item.active .schedules__time {\n    background: #ffebf6;\n    color: #11142d;\n}\n\n.schedules__top {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin-bottom: 32px;\n}\n\n.schedules__arrows {\n    display: none;\n    margin-left: auto;\n    margin-right: -16px;\n}\n\n.schedules__arrow {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    -webkit-box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);\n    box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);\n    background: #ffffff;\n    font-size: 0;\n    -webkit-transition: background 0.25s;\n    -o-transition: background 0.25s;\n    transition: background 0.25s;\n}\n\n.schedules__arrow .icon {\n    font-size: 10px;\n    fill: #11142d;\n    -webkit-transition: fill 0.25s;\n    -o-transition: fill 0.25s;\n    transition: fill 0.25s;\n}\n\n.schedules__arrow:hover {\n    background: var(--main-color);\n}\n\n.schedules__arrow:hover .icon {\n    fill: #ffffff;\n}\n\n.schedules__arrow:not(:last-child) {\n    margin-right: 8px;\n}\n\n.schedules__col>.schedules__title {\n    margin-bottom: 32px;\n}\n\n.schedules__btn {\n    display: none;\n}\n\n.schedules__graphic {\n    position: relative;\n    max-width: 586px;\n    border-radius: 16px;\n    border: 1px solid #e4e4e4;\n}\n\n.schedules__graphic:before {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 14px;\n    right: 14px;\n    height: 7px;\n    border-radius: 0 0 7px 7px;\n    border-width: 0 1px 1px;\n    border-style: solid;\n    border-color: #e4e4e4;\n}\n\n.schedules__head {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    height: 68px;\n    border-bottom: 1px solid #e4e4e4;\n}\n\n.schedules__option {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 138px;\n    padding-left: 32px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #808191;\n}\n\n.schedules__week {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n\n.schedules__cell {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 16.666%;\n    flex: 0 0 16.666%;\n    width: 16.666%;\n}\n\n.schedules__day {\n    position: relative;\n    display: inline-block;\n    min-width: 32px;\n    margin-left: -16px;\n    background: transparent;\n    border-radius: 50%;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 32px;\n}\n\n.schedules__day:before {\n    content: '';\n    position: absolute;\n    top: 6px;\n    right: -4px;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n}\n\n.schedules__day.active {\n    background: #ff754c;\n    color: #ffffff;\n}\n\n.schedules__day.green:before {\n    background: #7fba7a;\n}\n\n.schedules__day.purple:before {\n    background: var(--main-color);\n}\n\n.schedules__day.gray:before {\n    background: #e4e4e4;\n}\n\n.schedules__body {\n    position: relative;\n    padding: 26px 0 22px;\n}\n\n.schedules__grid {\n    position: absolute;\n    top: 0;\n    left: 138px;\n    right: 0;\n    bottom: 0;\n}\n\n.schedules__line {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 1px;\n    background: #e4e4e4;\n    pointer-events: none;\n}\n\n.schedules__line:first-child {\n    left: 8.33%;\n}\n\n.schedules__line:nth-child(2) {\n    left: 25%;\n}\n\n.schedules__line:nth-child(3) {\n    left: 41.66%;\n}\n\n.schedules__line:nth-child(4) {\n    left: 58.33%;\n}\n\n.schedules__line:nth-child(5) {\n    left: 75%;\n}\n\n.schedules__row {\n    position: relative;\n    z-index: 2;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.schedules__row:not(:last-child) {\n    margin-bottom: 18px;\n}\n\n.schedules__task {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    justify-content: flex-end;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    height: 32px;\n    padding: 0 2px;\n    border-radius: 8px;\n}\n\n.schedules__task .schedules__text {\n    padding: 0 15px;\n    background: rgba(255, 255, 255, 0.8);\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 28px;\n}\n\n.schedules__legend {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-top: 32px;\n    padding: 0 16px;\n}\n\n.schedules__status {\n    position: relative;\n    padding-left: 20px;\n    font-size: 12px;\n    line-height: 1.2;\n    font-weight: 500;\n    color: #808191;\n}\n\n.schedules__status:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n}\n\n.schedules__status.green:before {\n    background: #7fba7a;\n}\n\n.schedules__status.purple:before {\n    background: var(--main-color);\n}\n\n.schedules__status.gray:before {\n    background: #e4e4e4;\n}\n\n.schedules__status:not(:last-child) {\n    margin-right: 120px;\n}\n\n.schedules:not(:last-child) {\n    margin-bottom: 36px;\n}\n\nbody.dark .schedules__container {\n    background: #242731;\n}\n\nbody.dark .schedules__container:before {\n    background: #000;\n    opacity: 0.51;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\nbody.dark .schedules__item {\n    color: #ffffff;\n}\n\nbody.dark .schedules__category .icon {\n    fill: #ffffff;\n}\n\nbody.dark .schedules__name,\nbody.dark .schedules__number {\n    color: var(--main-color);\n}\n\nbody.dark .schedules__item:hover {\n    color: var(--main-color);\n}\n\nbody.dark .schedules__item:hover .icon {\n    fill: var(--main-color);\n}\n\nbody.dark .schedules__item.active,\nbody.dark .schedules__item.active .schedules__number {\n    color: #ffffff;\n}\n\nbody.dark .schedules__item.active .icon {\n    fill: #ffffff;\n}\n\nbody.dark .schedules__graphic {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .schedules__graphic:before {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .schedules__head {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .schedules__day.gray:before,\nbody.dark .schedules__status.gray:before {\n    background: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .schedules__line {\n    background: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .schedules__task .schedules__text {\n    background: rgba(36, 39, 49, 0.8);\n}\n\nbody.dark .schedules__arrow {\n    background: #242731;\n    -webkit-box-shadow: 0 5px 20px rgba(0, 0, 0, 0.35);\n    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.35);\n}\n\nbody.dark .schedules__arrow .icon {\n    fill: #ffffff;\n}\n\n.tabs__row {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin: -20px 0 14px -16px;\n}\n\n.tabs__col:first-child {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 53%;\n    flex: 0 0 53%;\n    width: 53%;\n}\n\n.tabs__col:nth-child(2) {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 47%;\n    flex: 0 0 47%;\n    width: 47%;\n    padding-top: 20px;\n}\n\n.tabs__list {\n    margin-left: -16px;\n}\n\n.tabs__item {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    padding: 20px 16px;\n    border-radius: 16px;\n    color: #11142d;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.tabs__item:hover {\n    color: var(--main-color);\n}\n\n.tabs__item:hover .icon {\n    fill: var(--main-color);\n}\n\n.tabs__item.active {\n    background: #ffebf6;\n    color: #11142d;\n}\n\n.tabs__item.active .icon {\n    fill: #11142d;\n}\n\n.tabs__preview {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 88px;\n    height: 80px;\n    margin-right: 16px;\n    border-radius: 12px;\n    font-size: 0;\n}\n\n.tabs__pic {\n    max-height: 100%;\n}\n\n.tabs__details {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n\n.tabs__category {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin-bottom: 3px;\n    padding-right: 20px;\n}\n\n.tabs__category .icon {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    font-size: 10px;\n    -webkit-transition: -webkit-transform 0.25s;\n    transition: -webkit-transform 0.25s;\n    -o-transition: transform 0.25s;\n    transition: transform 0.25s;\n    transition: transform 0.25s, -webkit-transform 0.25s;\n}\n\n.tabs__info {\n    margin-bottom: 8px;\n    color: #808191;\n}\n\n.tabs__price {\n    display: inline-block;\n    padding: 3px 10px;\n    background: var(--main-color);\n    border-radius: 8px;\n    color: #ffffff;\n}\n\n.tabs__nav {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 3px;\n    border-radius: 12px;\n    border: 1px solid #e4e4e4;\n}\n\n.tabs__link {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    width: 25%;\n    padding: 8px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.2;\n    color: #808191;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.tabs__link:hover {\n    color: var(--main-color);\n}\n\n.tabs__link:hover .icon {\n    fill: var(--main-color);\n}\n\n.tabs__link.active {\n    background: var(--main-color);\n    color: #ffffff;\n}\n\n.tabs__link.active .icon {\n    fill: #ffffff;\n}\n\n.tabs__icon {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    width: 24px;\n    height: 24px;\n    margin-bottom: 5px;\n    font-size: 0;\n}\n\n.tabs__icon .icon {\n    font-size: 18px;\n    fill: #11142d;\n    -webkit-transition: fill 0.25s;\n    -o-transition: fill 0.25s;\n    transition: fill 0.25s;\n}\n\n.tabs__chart {\n    max-width: 190px;\n    height: 140px;\n    margin: 0 auto 20px;\n}\n\n.tabs__desc {\n    text-align: center;\n}\n\n.tabs__title {\n    margin-bottom: 10px;\n}\n\n.tabs__date {\n    margin-bottom: 50px;\n    color: #808191;\n}\n\n.tabs__btn {\n    min-width: 180px;\n}\n\nbody.dark .tabs__item {\n    color: #ffffff;\n}\n\nbody.dark .tabs__item:hover {\n    color: var(--main-color);\n}\n\nbody.dark .tabs__item:hover .icon {\n    fill: var(--main-color);\n}\n\nbody.dark .tabs__item.active {\n    color: #11142d;\n}\n\nbody.dark .tabs__item.active .tabs__category .icon {\n    fill: #11142d;\n}\n\nbody.dark .tabs__category .icon {\n    fill: #ffffff;\n}\n\nbody.dark .tabs__nav {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .tabs__icon .icon {\n    fill: #ffffff;\n}\n\nbody.dark .tabs__link:hover {\n    color: #ffffff;\n}\n\n.payment__row {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.payment__details {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 225px;\n    margin-right: 16px;\n    padding: 32px;\n    border-radius: 16px;\n    -webkit-box-shadow: 0 10px 36px rgba(227, 230, 236, 0.6);\n    box-shadow: 0 10px 36px rgba(227, 230, 236, 0.6);\n    text-align: center;\n}\n\n.payment__preview {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    width: 80px;\n    height: 80px;\n    margin-bottom: 32px;\n    border-radius: 24px;\n    font-size: 0;\n}\n\n.payment__preview .payment__pic {\n    max-height: 100%;\n}\n\n.payment__pic_white {\n    display: none;\n}\n\n.payment__mail {\n    margin-bottom: 16px;\n    color: #7fba7a;\n}\n\n.payment__info {\n    width: 100%;\n    max-width: 140px;\n    color: #b2b3bd;\n}\n\n.payment__details .payment__info {\n    margin: 0 auto 32px;\n}\n\n.payment__logo {\n    font-size: 0;\n}\n\n.payment__details .payment__logo {\n    display: inline-block;\n}\n\n.payment__logo .payment__pic {\n    max-width: 87px;\n    max-height: 30px;\n}\n\n.payment__variants {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n\n.payment__label {\n    display: block;\n    position: relative;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    cursor: pointer;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.payment__label:not(:last-child) {\n    margin-bottom: 18px;\n}\n\n.payment__radio {\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n}\n\n.payment__in {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 34px 32px;\n    border-radius: 16px;\n    -webkit-box-shadow: inset 0 0 0 1px #e3e6ec;\n    box-shadow: inset 0 0 0 1px #e3e6ec;\n    -webkit-transition: -webkit-box-shadow 0.25s;\n    transition: -webkit-box-shadow 0.25s;\n    -o-transition: box-shadow 0.25s;\n    transition: box-shadow 0.25s;\n    transition: box-shadow 0.25s, -webkit-box-shadow 0.25s;\n}\n\n.payment__tick {\n    position: relative;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 16px;\n    flex: 0 0 16px;\n    width: 16px;\n    height: 16px;\n    margin-right: 36px;\n    border-radius: 4px;\n    border: 2px solid #e4e4e4;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.payment__tick:before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    width: 8px;\n    height: 7px;\n    opacity: 0;\n    background: url(\"data:image/svg+xml,%3Csvg width='10' height='9' viewBox='0 0 10 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.5 5.375L1.5 3.375L0 4.875L3.5 8.375L10 1.875L8.5 0.375L3.5 5.375Z' fill='white'/%3E%3C/svg%3E%0A\") no-repeat 50% 50%/100% auto;\n    -webkit-transition: opacity 0.25s;\n    -o-transition: opacity 0.25s;\n    transition: opacity 0.25s;\n}\n\n.payment__desc .payment__logo {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    height: 30px;\n    margin-top: -8px;\n}\n\n.payment__desc .payment__info {\n    display: block;\n    margin-top: 16px;\n}\n\n.payment__btn {\n    min-width: 132px;\n    height: 40px;\n    margin-top: 16px;\n}\n\n.payment__label:hover .payment__in {\n    -webkit-box-shadow: inset 0 0 0 1px var(--main-color);\n    box-shadow: inset 0 0 0 1px var(--main-color);\n}\n\n.payment__radio:checked+.payment__in {\n    -webkit-box-shadow: inset 0 0 0 2px var(--main-color);\n    box-shadow: inset 0 0 0 2px var(--main-color);\n}\n\n.payment__radio:checked+.payment__in .payment__tick {\n    background: var(--main-color);\n    border-color: var(--main-color);\n}\n\n.payment__radio:checked+.payment__in .payment__tick:before {\n    opacity: 1;\n}\n\nbody.dark .payment__pic_black {\n    display: none;\n}\n\nbody.dark .payment__pic_white {\n    display: inline-block;\n}\n\nbody.dark .payment__details {\n    -webkit-box-shadow: 0 10px 36px rgba(0, 0, 0, 0.35);\n    box-shadow: 0 10px 36px rgba(0, 0, 0, 0.35);\n}\n\nbody.dark .payment__tick {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .payment__in {\n    -webkit-box-shadow: inset 0 0 0 1px rgba(228, 228, 228, 0.1);\n    box-shadow: inset 0 0 0 1px rgba(228, 228, 228, 0.1);\n}\n\n.inbox__tags {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    margin: -18px 0 28px -18px;\n}\n\n.inbox__tag {\n    margin: 18px 0 0 18px;\n    border: 2px solid #ff754c;\n    border-radius: 12px;\n    padding: 6px 16px;\n    line-height: 1.42857;\n    font-weight: 600;\n    color: #11142d;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.inbox__tag:hover,\n.inbox__tag.active {\n    background: var(--main-color);\n    border-color: var(--main-color);\n    color: #ffffff;\n}\n\n.inbox__container {\n    position: relative;\n    padding: 32px;\n    border-radius: 24px;\n    background: #ffffff;\n}\n\n.inbox__container:before {\n    content: '';\n    position: absolute;\n    top: 32px;\n    left: 18px;\n    right: 18px;\n    bottom: -32px;\n    z-index: -1;\n    background: #e3e6ec;\n    opacity: 0.91;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\n.inbox__container>.inbox__title {\n    margin-bottom: 16px;\n}\n\n.inbox__list {\n    margin: 0 -16px;\n}\n\n.inbox__item {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 32px 16px;\n    border-radius: 12px;\n    background: transparent;\n    color: #808191;\n    cursor: pointer;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.inbox__ava {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 48px;\n    height: 48px;\n    font-size: 0;\n}\n\n.inbox__ava .inbox__pic {\n    width: 100%;\n    min-height: 100%;\n    border-radius: 50%;\n}\n\n.inbox__details {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 calc(100% - 48px);\n    flex: 0 0 calc(100% - 48px);\n    width: calc(100% - 48px);\n    padding-left: 24px;\n}\n\n.inbox__head {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin-bottom: 16px;\n}\n\n.inbox__author {\n    color: var(--main-color);\n    -webkit-transition: color 0.25s;\n    -o-transition: color 0.25s;\n    transition: color 0.25s;\n}\n\n.inbox__time {\n    margin-left: 10px;\n}\n\n.inbox__item .inbox__title {\n    margin-bottom: 18px;\n    color: #11142d;\n    -webkit-transition: color 0.25s;\n    -o-transition: color 0.25s;\n    transition: color 0.25s;\n}\n\n.inbox__text {\n    margin-bottom: 16px;\n}\n\n.inbox__text p:not(:last-child) {\n    margin-bottom: 20px;\n}\n\n.inbox__item:hover {\n    background: rgba(228, 228, 228, 0.3);\n}\n\n.inbox__item.active {\n    background: var(--main-color);\n    color: #ffffff;\n}\n\n.inbox__item.active .actions__btn {\n    border-color: #ffffff;\n}\n\n.inbox__item.active .actions__btn .icon {\n    fill: #ffffff;\n}\n\n.inbox__item.active .inbox__title,\n.inbox__item.active .inbox__author {\n    color: #ffffff;\n}\n\n.inbox__foot {\n    padding-top: 12px;\n    text-align: center;\n}\n\n.inbox__foot .inbox__btn {\n    min-width: 180px;\n}\n\n.inbox__control {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-bottom: 60px;\n}\n\n.inbox__btns {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin-right: auto;\n}\n\n.inbox__btns .inbox__btn {\n    min-width: 140px;\n}\n\n.inbox__btns .inbox__btn:not(:last-child) {\n    margin-right: 16px;\n}\n\n.inbox__more {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    font-size: 0;\n    -webkit-transition: -webkit-box-shadow 0.25s;\n    transition: -webkit-box-shadow 0.25s;\n    -o-transition: box-shadow 0.25s;\n    transition: box-shadow 0.25s;\n    transition: box-shadow 0.25s, -webkit-box-shadow 0.25s;\n}\n\n.inbox__more .icon {\n    font-size: 6px;\n    fill: #11142d;\n}\n\n.inbox__more:hover {\n    -webkit-box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);\n    box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);\n}\n\n.inbox__box {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.inbox__box:not(:last-child) {\n    margin-bottom: 40px;\n    padding-bottom: 40px;\n    border-bottom: 1px solid #e4e4e4;\n}\n\n.inbox__box .inbox__author {\n    color: #11142d;\n}\n\n.inbox__box .inbox__time {\n    margin-left: 24px;\n    color: #b2b3bd;\n}\n\n.inbox__box .inbox__title {\n    margin-bottom: 32px;\n}\n\n.inbox__box .inbox__text {\n    color: #808191;\n}\n\n.inbox .files {\n    margin-top: 24px;\n}\n\n.inbox .sorting {\n    margin-bottom: 24px;\n}\n\nbody.dark .inbox__tag {\n    color: #ffffff;\n}\n\nbody.dark .inbox__container {\n    background: #242731;\n}\n\nbody.dark .inbox__container:before {\n    background: #000;\n    opacity: 0.51;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\nbody.dark .inbox__item:hover {\n    background: rgba(228, 228, 228, 0.04);\n}\n\nbody.dark .inbox__item.active {\n    background: var(--main-color);\n}\n\nbody.dark .inbox__title {\n    color: #ffffff;\n}\n\nbody.dark .inbox__item.active .inbox__title {\n    color: #ffffff;\n}\n\nbody.dark .inbox__item.active .inbox__author {\n    color: #ffffff;\n}\n\nbody.dark .inbox__more .icon {\n    fill: #ffffff;\n}\n\nbody.dark .inbox__more:hover {\n    -webkit-box-shadow: 0 12px 20px rgba(0, 0, 0, 0.35);\n    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.35);\n}\n\nbody.dark .inbox__box {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .inbox__box .inbox__author {\n    color: #ffffff;\n}\n\n.actions {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.actions__btn {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: 1px solid #e4e4e4;\n    font-size: 0;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.actions__btn .icon {\n    font-size: 12px;\n    fill: #1b1d21;\n    opacity: 0.4;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.actions__btn:hover .icon {\n    opacity: 0.75;\n}\n\n.actions__btn:not(:last-child) {\n    margin-right: 16px;\n}\n\nbody.dark .actions__btn {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .actions__btn .icon {\n    fill: #ffffff;\n}\n\n.files__list {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin: -8px -4px 0;\n}\n\n.files__item {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    padding: 4px;\n    border-radius: 16px;\n    color: #11142d;\n    -webkit-transition: opacity 0.25s;\n    -o-transition: opacity 0.25s;\n    transition: opacity 0.25s;\n}\n\n.files__item.purple {\n    background: rgba(207, 200, 255, 0.5);\n}\n\n.files__item.purple .files__preview {\n    background: #cfc8ff;\n}\n\n.files__item.blue {\n    background: #e7faff;\n}\n\n.files__item.blue .files__preview {\n    background: #a0d7e7;\n}\n\n.files__item:hover {\n    opacity: 0.8;\n}\n\n.files>.files__item:not(:last-child) {\n    margin-bottom: 10px;\n}\n\n.files__list .files__item {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 calc(50% - 8px);\n    flex: 0 0 calc(50% - 8px);\n    width: calc(50% - 8px);\n    margin: 4px 4px 0;\n}\n\n.files__preview {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 48px;\n    height: 48px;\n    border-radius: 12px;\n    overflow: hidden;\n    font-size: 0;\n}\n\n.files__pic {\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.files__details {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 calc(100% - 48px);\n    flex: 0 0 calc(100% - 48px);\n    width: calc(100% - 48px);\n    padding-left: 16px;\n}\n\n.files__title {\n    max-width: 100%;\n    overflow: hidden;\n    -o-text-overflow: ellipsis;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: var(--main-color);\n}\n\nbody.dark .files__item {\n    background: rgba(228, 228, 228, 0.1);\n    color: #ffffff;\n}\n\nbody.dark .files__title {\n    color: #ffffff;\n}\n\n.editor__wrap {\n    background: #fafafa;\n    border-radius: 12px;\n}\n\n.editor__head {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 24px;\n    border-bottom: 1px solid #e4e4e4;\n}\n\n.editor__control {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    margin: -16px auto 0 -16px;\n}\n\n.editor__action {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 24px;\n    height: 24px;\n    margin: 16px 0 0 16px;\n    border-radius: 4px;\n    background: #e4e4e4;\n    font-size: 0;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.editor__action .icon {\n    font-size: 12px;\n    fill: #808191;\n    -webkit-transition: fill 0.25s;\n    -o-transition: fill 0.25s;\n    transition: fill 0.25s;\n}\n\n.editor__action:hover,\n.editor__action.active {\n    background: rgba(27, 29, 33, 0.3);\n}\n\n.editor__action:hover .icon,\n.editor__action.active .icon {\n    fill: #ffffff;\n}\n\n.editor__add {\n    position: relative;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 24px;\n    height: 24px;\n    margin-left: 30px;\n    border-radius: 50%;\n    background: #1b1d21;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.editor__add:before,\n.editor__add:after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    background: #ffffff;\n}\n\n.editor__add:before {\n    width: 8px;\n    height: 2px;\n}\n\n.editor__add:after {\n    width: 2px;\n    height: 8px;\n}\n\n.editor__add:hover {\n    background: rgba(27, 29, 33, 0.8);\n}\n\n.editor__body {\n    padding: 32px 24px;\n}\n\n.editor__textarea {\n    width: 100%;\n    height: 110px;\n    border: none;\n    background: none;\n    resize: none;\n    font-size: 14px;\n}\n\n.editor__gallery {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    max-width: 360px;\n    margin: -16px 0 0 -8px;\n}\n\n.editor__preview {\n    position: relative;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 calc(50% - 16px);\n    flex: 0 0 calc(50% - 16px);\n    width: calc(50% - 16px);\n    margin: 16px 8px 0;\n    font-size: 0;\n    cursor: pointer;\n}\n\n.editor__pic {\n    border-radius: 8px;\n}\n\n.editor__close {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    z-index: 2;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    background: #ffffff;\n    font-size: 0;\n    visibility: hidden;\n    opacity: 0;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.editor__close .icon {\n    font-size: 6px;\n    fill: #1b1d21;\n    -webkit-transition: -webkit-transform 0.25s;\n    transition: -webkit-transform 0.25s;\n    -o-transition: transform 0.25s;\n    transition: transform 0.25s;\n    transition: transform 0.25s, -webkit-transform 0.25s;\n}\n\n.editor__close:hover .icon {\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n}\n\n.editor__preview:hover .editor__close {\n    visibility: visible;\n    opacity: 1;\n}\n\n.editor__btn {\n    min-width: 232px;\n    margin-top: 24px;\n}\n\n.editor__btn.btn_wide {\n    min-width: 100%;\n}\n\n.editor .files {\n    width: 100%;\n    margin-top: 24px;\n}\n\nbody.dark .editor__wrap {\n    background: rgba(228, 228, 228, 0.03);\n}\n\nbody.dark .editor__head {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .editor__action {\n    background: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .editor__action.active {\n    background: #1b1d21;\n}\n\nbody.dark .editor__textarea {\n    color: #ffffff;\n}\n\nbody.dark .editor__close {\n    background: #242731;\n}\n\nbody.dark .editor__close .icon {\n    fill: #ffffff;\n}\n\n.notification__tags {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    margin: -18px 0 28px -18px;\n}\n\n.notification__tag {\n    margin: 18px 0 0 18px;\n    border: 2px solid #e4e4e4;\n    border-radius: 12px;\n    padding: 6px 16px;\n    line-height: 1.42857;\n    font-weight: 600;\n    color: #11142d;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.notification__tag:hover,\n.notification__tag.active {\n    background: var(--main-color);\n    border-color: var(--main-color);\n    color: #ffffff;\n}\n\n.notification__container {\n    position: relative;\n    padding: 32px;\n    border-radius: 24px;\n    background: #ffffff;\n}\n\n.notification__container:before {\n    content: '';\n    position: absolute;\n    top: 32px;\n    left: 32px;\n    right: 32px;\n    bottom: -32px;\n    z-index: -1;\n    background: #e3e6ec;\n    opacity: 0.91;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\n.notification__title {\n    margin-bottom: 32px;\n}\n\n.notification__list {\n    margin: 0 -16px;\n}\n\n.notification__item {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 32px 16px;\n    border-radius: 12px;\n    background: transparent;\n    color: #808191;\n    cursor: pointer;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.notification__ava {\n    position: relative;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 48px;\n    height: 48px;\n    font-size: 0;\n}\n\n.notification__ava>.notification__pic {\n    width: 100%;\n    min-height: 100%;\n    border-radius: 50%;\n}\n\n.notification__status {\n    position: absolute;\n    top: 0;\n    right: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    border: 2px solid #ffffff;\n    font-size: 0;\n}\n\n.notification__details {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    padding: 0 24px;\n}\n\n.notification__author {\n    margin-bottom: 9px;\n    color: #11142d;\n    -webkit-transition: color 0.25s;\n    -o-transition: color 0.25s;\n    transition: color 0.25s;\n}\n\n.notification__line {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    margin-bottom: 16px;\n}\n\n.notification__line .notification__category {\n    margin-right: 8px;\n}\n\n.notification__info {\n    margin-right: 8px;\n    color: var(--main-color);\n}\n\n.notification__item .notification__text {\n    margin-bottom: 16px;\n}\n\n.notification__item .notification__text p:not(:last-child) {\n    margin-bottom: 20px;\n}\n\n.notification__item:hover {\n    background: rgba(228, 228, 228, 0.3);\n}\n\n.notification__item.active {\n    background: var(--main-color);\n    color: #ffffff;\n}\n\n.notification__item.active .actions__btn {\n    border-color: #ffffff;\n}\n\n.notification__item.active .actions__btn .icon {\n    fill: #ffffff;\n}\n\n.notification__item.active .notification__title,\n.notification__item.active .notification__author,\n.notification__item.active .notification__info {\n    color: #ffffff;\n}\n\n.notification__preview {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 96px;\n    height: 96px;\n    border-radius: 8px;\n    font-size: 0;\n}\n\n.notification__preview:before {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 7px;\n    right: 7px;\n    height: 7px;\n    border-radius: 0 0 7px 7px;\n}\n\n.notification__preview.bg-purple-light:before {\n    background: rgba(207, 200, 255, 0.5);\n}\n\n.notification__preview.bg-blue-light:before {\n    background: rgba(160, 215, 231, 0.5);\n}\n\n.notification__preview.bg-yellow:before {\n    background: rgba(255, 206, 115, 0.5);\n}\n\n.notification__preview .notification__pic {\n    max-height: 100%;\n}\n\n.notification__btns {\n    padding-top: 24px;\n    text-align: center;\n}\n\n.notification__btn {\n    min-width: 180px;\n}\n\n.notification__photo {\n    margin-bottom: 40px;\n    font-size: 0;\n}\n\n.notification__photo .notification__pic {\n    width: 100%;\n}\n\n.notification__body {\n    padding: 0 24px;\n}\n\n.notification__body:not(:last-child) {\n    margin-bottom: 32px;\n}\n\n.notification__stage {\n    margin-bottom: 16px;\n}\n\n.notification__parameters {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-bottom: 24px;\n}\n\n.notification__parameter {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    color: var(--main-color);\n}\n\n.notification__parameter:not(:last-child) {\n    margin-right: 16px;\n}\n\n.notification__icon {\n    margin-right: 10px;\n    font-size: 0;\n}\n\nbody.dark .notification__container {\n    background: #242731;\n}\n\nbody.dark .notification__container:before {\n    background: #000;\n    opacity: 0.51;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\nbody.dark .notification__tag {\n    border-color: rgba(228, 228, 228, 0.1);\n    color: #ffffff;\n}\n\nbody.dark .notification__tag:hover {\n    border-color: var(--main-color);\n}\n\nbody.dark .notification__item:hover {\n    background: rgba(228, 228, 228, 0.04);\n}\n\nbody.dark .notification__item.active {\n    background: var(--main-color);\n}\n\nbody.dark .notification__item.active .notification__author {\n    color: #ffffff;\n}\n\nbody.dark .notification__item.active .notification__info {\n    color: var(--main-color);\n}\n\nbody.dark .notification__author {\n    color: #ffffff;\n}\n\n.filters__container {\n    position: relative;\n    padding: 32px;\n    background: #ffffff;\n    border-radius: 24px;\n}\n\n.filters__container:before {\n    content: '';\n    position: absolute;\n    top: 32px;\n    left: 17px;\n    right: 17px;\n    bottom: -32px;\n    z-index: -1;\n    background: #e3e6ec;\n    opacity: 0.91;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\n.filters__item:not(:last-child) {\n    margin-bottom: 32px;\n    padding-bottom: 32px;\n    border-bottom: 1px solid #e4e4e4;\n}\n\n.filters__title {\n    margin-bottom: 24px;\n}\n\n.filters__variants {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    margin-bottom: 32px;\n}\n\n.filters .checkbox:not(:last-child) {\n    margin-bottom: 20px;\n}\n\n.filters__control {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.filters__btns {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin: 0 -5px;\n}\n\n.filters__btn {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 calc(50% - 10px);\n    flex: 0 0 calc(50% - 10px);\n    min-width: calc(50% - 10px);\n    height: 44px;\n    margin: 0 5px;\n    padding: 0;\n    font-size: 14px;\n}\n\n.filters__line {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-bottom: 32px;\n}\n\n.filters .radio:not(:last-child) {\n    margin-right: 32px;\n}\n\n.filters__reset {\n    line-height: 1.42857;\n    font-weight: 600;\n    color: #808191;\n    -webkit-transition: color 0.25s;\n    -o-transition: color 0.25s;\n    transition: color 0.25s;\n}\n\n.filters__reset:hover {\n    color: var(--main-color);\n}\n\nbody.dark .filters__container {\n    background: #242731;\n}\n\nbody.dark .filters__container:before {\n    background: #000;\n    opacity: 0.51;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\nbody.dark .filters__item {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\n.activity__row {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.activity__col:first-child {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n\n.activity__col:nth-child(2) {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 426px;\n    padding: 32px 0 0 65px;\n}\n\n.activity__container {\n    position: relative;\n    padding: 32px;\n    background: #ffffff;\n    border-radius: 24px;\n}\n\n.activity__container:before {\n    content: '';\n    position: absolute;\n    top: 26px;\n    left: 19px;\n    right: 19px;\n    bottom: -26px;\n    z-index: -1;\n    background: #e3e6ec;\n    opacity: 0.91;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\n.activity__title {\n    margin-bottom: 32px;\n}\n\n.activity__inner {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.activity__variants {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 130px;\n    padding-right: 15px;\n}\n\n.activity__variants .checkbox:not(:last-child) {\n    margin-bottom: 16px;\n}\n\n.activity__list {\n    margin-right: -16px;\n}\n\n.activity__item {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 32px 16px;\n    overflow: hidden;\n    border-radius: 12px;\n    color: #808191;\n    cursor: pointer;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.activity__item:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: transparent;\n    -webkit-transition: background 0.25s;\n    -o-transition: background 0.25s;\n    transition: background 0.25s;\n}\n\n.activity__item:hover {\n    background: rgba(228, 228, 228, 0.3);\n}\n\n.activity__item.active {\n    color: #ffffff;\n}\n\n.activity__item.active:before {\n    background: var(--main-color);\n}\n\n.activity__ava {\n    position: relative;\n    z-index: 2;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 48px;\n    height: 48px;\n    font-size: 0;\n}\n\n.activity__ava>.activity__pic {\n    width: 100%;\n    min-height: 100%;\n    border-radius: 50%;\n}\n\n.activity__status {\n    position: absolute;\n    top: 0;\n    right: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    background: #ff9a7b;\n    border: 2px solid #ffffff;\n    font-size: 0;\n}\n\n.activity__details {\n    position: relative;\n    z-index: 2;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    padding: 0 32px 0 24px;\n}\n\n.activity__author {\n    margin-bottom: 9px;\n    color: #11142d;\n    -webkit-transition: color 0.25s;\n    -o-transition: color 0.25s;\n    transition: color 0.25s;\n}\n\n.activity__details .activity__line {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    margin-bottom: 16px;\n}\n\n.activity__line .activity__category {\n    margin-right: 8px;\n}\n\n.activity__info {\n    margin-right: 8px;\n    color: var(--main-color);\n    -webkit-transition: color 0.25s;\n    -o-transition: color 0.25s;\n    transition: color 0.25s;\n}\n\n.activity__item .activity__text p:not(:last-child) {\n    margin-bottom: 20px;\n}\n\n.activity__item.active .activity__author,\n.activity__item.active .activity__info {\n    color: #ffffff;\n}\n\n.activity__preview {\n    position: relative;\n    z-index: 2;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 96px;\n    height: 84px;\n    background: #a0d7e7;\n    border-radius: 8px;\n    font-size: 0;\n}\n\n.activity__preview:before {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 7px;\n    right: 7px;\n    height: 7px;\n    border-radius: 0 0 7px 7px;\n    background: #e7faff;\n}\n\n.activity__preview .activity__pic {\n    max-height: 100%;\n}\n\n.activity__btns {\n    padding-top: 24px;\n    text-align: center;\n}\n\n.activity__btn {\n    min-width: 180px;\n}\n\n.activity:not(:first-child) {\n    margin-top: 48px;\n}\n\nbody.dark .activity__container {\n    background: #242731;\n}\n\nbody.dark .activity__container:before {\n    background: #000;\n    opacity: 0.51;\n    -webkit-filter: blur(86.985px);\n    filter: blur(86.985px);\n    border-radius: 24px;\n}\n\nbody.dark .activity__author {\n    color: #ffffff;\n}\n\nbody.dark .activity__item:hover {\n    background: rgba(228, 228, 228, 0.04);\n}\n\nbody.dark .activity__item.active .activity__author {\n    color: #ffffff;\n}\n\n.field__label {\n    margin: 16px 0;\n    line-height: 1.33333;\n    font-weight: 500;\n    font-weight: bold;\n    font-size: 14px;\n    letter-spacing: 0.3px;\n    color: #334155;\n}\n\n.field__input,\n.field__textarea {\n    width: 100%;\n    border-radius: 8px;\n    background: transparent;\n    border: 1px solid var(--gray-color);\n    font-family: 'Inter', sans-serif;\n    font-size: 14px;\n    color: #11142d;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.field__input:disabled,\n.field__textarea:disabled {\n    background-color: var(--disabled-color);\n    border: none;\n}\n\n.field__input {\n    height: 38px;\n    padding: 0 23px;\n}\n\n.field__textarea {\n    height: 157px;\n    padding: 15px 23px;\n    resize: none;\n}\n\nbody.dark .field__input,\nbody.dark .field__textarea {\n    color: #ffffff;\n    background: rgba(228, 228, 228, 0.04);\n}\n\n.popup {\n    position: relative;\n    max-width: 630px;\n    margin: 15px auto;\n    background: #ffffff;\n    border-radius: 24px;\n}\n\n.popup__form {\n    border-radius: 24px;\n}\n\n.popup__title {\n    margin-bottom: 48px;\n}\n\n.popup__tags {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    margin: -13px 0 32px -13px;\n}\n\n.popup__tag {\n    margin: 13px 0 0 13px;\n    border: 2px solid #ff754c;\n    border-radius: 12px;\n    padding: 6px 16px;\n    line-height: 1.42857;\n    font-weight: 600;\n    color: #11142d;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.popup__tag:hover,\n.popup__tag.active {\n    background: var(--main-color);\n    border-color: var(--main-color);\n    color: #ffffff;\n}\n\n.popup__select {\n    min-width: 100%;\n    height: 56px;\n    margin-bottom: 32px;\n    padding: 0 40px 0 24px;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    border: none;\n    border-radius: 12px;\n    background: rgba(228, 228, 228, 0.25) url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='7' fill='none'%3E%3Cpath fill-rule='evenodd' d='M9.293.333a.5.5 0 0 1 .39.812L5.39 6.512a.5.5 0 0 1-.781 0L.317 1.146a.5.5 0 0 1 .39-.812h8.586z' fill='%23b5b5be'/%3E%3C/svg%3E\") no-repeat calc(100% - 16px) 50%/11px 7px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #808191;\n    -webkit-transition: all 0.25s;\n    -o-transition: all 0.25s;\n    transition: all 0.25s;\n}\n\n.popup__select::-ms-expand {\n    display: none;\n}\n\n.popup__select:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #000;\n}\n\n.popup__user:not(:last-child) {\n    margin-bottom: 32px;\n    padding-bottom: 32px;\n    border-bottom: 1px solid #e4e4e4;\n}\n\n.popup__category {\n    margin-bottom: 32px;\n    color: #b2b3bd;\n}\n\n.popup__line {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.popup__ava {\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    width: 64px;\n    height: 64px;\n    font-size: 0;\n}\n\n.popup__ava .popup__pic {\n    width: 100%;\n    min-height: 100%;\n    border-radius: 50%;\n    image-orientation: from-image;\n}\n\n.popup__details {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 calc(100% - 64px);\n    flex: 0 0 calc(100% - 64px);\n    width: calc(100% - 64px);\n    padding-left: 40px;\n}\n\n.popup__btns {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-bottom: 16px;\n}\n\n.popup__btns .popup__btn {\n    min-width: 166px;\n    height: 40px;\n}\n\n.popup__btns .popup__btn:not(:last-child),\n.popup__loading:not(:last-child) {\n    margin-right: 16px;\n}\n\n.popup__loading {\n    position: relative;\n    overflow: hidden;\n    border-radius: 16px;\n}\n\n.popup__file {\n    position: absolute;\n    top: 0;\n    left: 0;\n    font-size: 140px;\n    opacity: 0;\n}\n\n.popup__loading:hover .popup__btn {\n    background: #5a49ce;\n}\n\n.popup__text {\n    color: #b2b3bd;\n}\n\n.popup__fieldset {\n    margin-bottom: 24px;\n}\n\n.popup__fieldset>.popup__field:not(:last-child) {\n    margin-bottom: 5px;\n}\n\n.popup__row {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin: 0 -8px;\n}\n\n.popup__row:not(:last-child) {\n    margin-bottom: 20px;\n}\n\n.popup__row .popup__field {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 calc(50% - 16px);\n    flex: 0 0 calc(50% - 16px);\n    width: calc(50% - 16px);\n    margin: 0 8px;\n}\n\n.popup .mfp-close {\n    position: absolute;\n    top: 20px;\n    right: 32px;\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    line-height: normal;\n    opacity: 1;\n    font-size: 0;\n    background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'%3E%3Cpath fill='%2311142d' d='M1.613.2l.094.083L5 3.585 8.293.293a1 1 0 0 1 1.414 0 1 1 0 0 1 .083 1.32l-.083.094L6.415 5l3.292 3.293a1 1 0 0 1-1.32 1.497l-.094-.083L5 6.415 1.707 9.707A1 1 0 0 1 .21 8.387l.083-.094L3.585 5 .293 1.707a1 1 0 0 1 0-1.414A1 1 0 0 1 1.613.21z'/%3E%3C/svg%3E\") no-repeat 50% 50%/10px auto;\n    -webkit-transition: -webkit-box-shadow 0.25s;\n    transition: -webkit-box-shadow 0.25s;\n    -o-transition: box-shadow 0.25s;\n    transition: box-shadow 0.25s;\n    transition: box-shadow 0.25s, -webkit-box-shadow 0.25s;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.popup .mfp-close:hover {\n    -webkit-box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);\n    box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);\n}\n\n.mfp-container {\n    padding: 20px;\n}\n\n.mfp-bg {\n    background: rgba(27, 29, 33, 0.7);\n}\n\n.mfp-zoom-in .popup {\n    opacity: 0;\n    -webkit-transition: all 0.2s ease-in-out;\n    -o-transition: all 0.2s ease-in-out;\n    transition: all 0.2s ease-in-out;\n    -webkit-transform: scale(0.8);\n    -ms-transform: scale(0.8);\n    transform: scale(0.8);\n}\n\n.mfp-zoom-in.mfp-bg {\n    opacity: 0;\n    -webkit-transition: all 0.2s ease-out;\n    -o-transition: all 0.2s ease-out;\n    transition: all 0.2s ease-out;\n}\n\n.mfp-zoom-in.mfp-ready .popup {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    -ms-transform: scale(1);\n    transform: scale(1);\n}\n\n.mfp-zoom-in.mfp-ready.mfp-bg {\n    opacity: 0.8;\n}\n\n.mfp-zoom-in.mfp-removing .popup {\n    -webkit-transform: scale(0.8);\n    -ms-transform: scale(0.8);\n    transform: scale(0.8);\n    opacity: 0;\n}\n\n.mfp-zoom-in.mfp-removing.mfp-bg {\n    opacity: 0;\n}\n\nbody.dark .popup {\n    background: #242731;\n}\n\nbody.dark .popup__tag {\n    color: #ffffff;\n}\n\nbody.dark .popup__user {\n    border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .popup .mfp-close {\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'%3E%3Cpath fill='%23ffffff' d='M1.613.2l.094.083L5 3.585 8.293.293a1 1 0 0 1 1.414 0 1 1 0 0 1 .083 1.32l-.083.094L6.415 5l3.292 3.293a1 1 0 0 1-1.32 1.497l-.094-.083L5 6.415 1.707 9.707A1 1 0 0 1 .21 8.387l.083-.094L3.585 5 .293 1.707a1 1 0 0 1 0-1.414A1 1 0 0 1 1.613.21z'/%3E%3C/svg%3E\");\n}\n\nbody.dark .popup .mfp-close:hover {\n    -webkit-box-shadow: 0 5px 20px rgba(0, 0, 0, 0.35);\n    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.35);\n}\n\nbody.dark .popup__select {\n    background-color: rgba(228, 228, 228, 0.04);\n}\n\nbody.dark .popup__btns .popup__btn.btn_gray {\n    background: none;\n}\n\nbody.dark .mfp-bg {\n    background: rgba(27, 29, 33, 0.9);\n}\n\n.color-green {\n    color: #7fba7a;\n}\n\n.color-red {\n    color: #ff754c;\n}\n\n.color-white {\n    color: #ffffff;\n}\n\n.color-blue {\n    color: #f4c257;\n}\n\n.color-blue-dark {\n    color: var(--main-color);\n}\n\n.color-purple {\n    color: var(--main-color);\n}\n\n.color-gray {\n    color: #808191;\n}\n\n.bg-blue {\n    background: #f4c257;\n}\n\n.bg-blue-opacity {\n    background: rgba(63, 140, 255, 0.3);\n}\n\n.bg-blue-light {\n    background: #a0d7e7;\n}\n\n.bg-blue-light-opacity {\n    background: rgba(160, 215, 231, 0.3);\n}\n\n.bg-yellow {\n    background: #ffce73;\n}\n\n.bg-yellow-opacity {\n    background: rgba(255, 206, 115, 0.3);\n}\n\n.bg-yellow-light {\n    background: #ffe2ac;\n}\n\n.bg-pink {\n    background: #ffa2c0;\n}\n\n.bg-pink-opacity {\n    background: rgba(255, 162, 192, 0.3);\n}\n\n.bg-pink-light {\n    background: #ffebf6;\n}\n\n.bg-green {\n    background: #7fba7a;\n}\n\n.bg-green-opacity {\n    background: rgba(127, 186, 122, 0.3);\n}\n\n.bg-purple {\n    background: var(--main-color);\n}\n\n.bg-purple-opacity {\n    background: rgba(108, 93, 211, 0.3);\n}\n\n.bg-purple-light {\n    background: #cfc8ff;\n}\n\n.bg-red {\n    background: #ff754c;\n}\n\n.bg-red-opacity {\n    background: rgba(255, 117, 76, 0.3);\n}\n\n.text-right {\n    text-align: right;\n}\n\n.text-center {\n    text-align: center;\n}\n\n.text-uppercase {\n    text-transform: uppercase;\n}\n\n.m-auto {\n    margin: auto;\n}\n\n.ml-auto {\n    margin-left: auto;\n}\n\n.mr-auto {\n    margin-right: auto;\n}\n\n.align-baseline {\n    -webkit-box-align: baseline;\n    -ms-flex-align: baseline;\n    align-items: baseline;\n}\n\n.desktop-show {\n    display: none;\n}\n\n.tablet-show {\n    display: none;\n}\n\n.mobile-show {\n    display: none;\n}\n\n.title {\n    font-size: 16px;\n    line-height: 1.1875;\n    font-weight: 600;\n}\n\n.title_lg,\n.title_md,\n.title_sm {\n    font-family: 'Poppins', sans-serif;\n    font-weight: 600;\n    letter-spacing: -1px;\n}\n\n.title_lg {\n    font-size: 96px;\n    line-height: 1.25;\n}\n\n.title_md {\n    font-size: 72px;\n    line-height: 1.22222;\n}\n\n.title_sm {\n    font-size: 64px;\n    line-height: 1.125;\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n    font-family: 'Poppins', sans-serif;\n}\n\n.h1,\n.h2,\n.h3 {\n    font-weight: 600;\n    letter-spacing: -1px;\n}\n\n.h4,\n.h5,\n.h6 {\n    font-weight: 500;\n}\n\n.h1 {\n    font-size: 56px;\n    line-height: 1.14286;\n}\n\n.h2 {\n    font-size: 48px;\n    line-height: 1.5;\n}\n\n.h3 {\n    font-size: 40px;\n    line-height: 1.5;\n}\n\n.h4 {\n    font-size: 32px;\n    line-height: 1.5;\n    letter-spacing: -0.5px;\n}\n\n.h5 {\n    font-size: 24px;\n    line-height: 1.33333;\n}\n\n.h6 {\n    font-size: 18px;\n    line-height: 1.33333;\n}\n\n.caption {\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.38462;\n}\n\n.caption-sm {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.33333;\n}\n\n@media only screen and (max-width: 1339px) and (max-width: 767px) {\n    .widget_responsive:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    .schedules__col:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    body.dark .schedules__col:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n}\n\n@media (hover: hover) {\n    .switch:hover {\n        opacity: 0.8;\n    }\n}\n\n@media screen and (max-width: 800px) and (orientation: landscape),\nscreen and (max-height: 300px) {\n\n    /**\n     * Remove all paddings around the image on small screen\n     */\n    .mfp-img-mobile .mfp-image-holder {\n        padding-left: 0;\n        padding-right: 0;\n    }\n\n    .mfp-img-mobile img.mfp-img {\n        padding: 0;\n    }\n\n    .mfp-img-mobile .mfp-figure:after {\n        top: 0;\n        bottom: 0;\n    }\n\n    .mfp-img-mobile .mfp-figure small {\n        display: inline;\n        margin-left: 5px;\n    }\n\n    .mfp-img-mobile .mfp-bottom-bar {\n        background: rgba(0, 0, 0, 0.6);\n        bottom: 0;\n        margin: 0;\n        top: auto;\n        padding: 3px 5px;\n        position: fixed;\n        -webkit-box-sizing: border-box;\n        box-sizing: border-box;\n    }\n\n    .mfp-img-mobile .mfp-bottom-bar:empty {\n        padding: 0;\n    }\n\n    .mfp-img-mobile .mfp-counter {\n        right: 5px;\n        top: 3px;\n    }\n\n    .mfp-img-mobile .mfp-close {\n        top: 0;\n        right: 0;\n        width: 35px;\n        height: 35px;\n        line-height: 35px;\n        background: rgba(0, 0, 0, 0.6);\n        position: fixed;\n        text-align: center;\n        padding: 0;\n    }\n}\n\n@media only screen and (max-width: 1419px) {\n    .page__col {\n        padding: 0 48px 44px;\n    }\n\n    .page__col:first-child {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 calc(100% - 390px);\n        flex: 0 0 calc(100% - 390px);\n        max-width: calc(100% - 390px);\n    }\n\n    .page__col:nth-child(2) {\n        width: 390px;\n    }\n\n    .page__content {\n        padding: 0 48px 48px;\n    }\n\n    .widget__details {\n        padding-left: 16px;\n    }\n\n    .banner__preview {\n        width: 450px;\n    }\n}\n\n@media only screen and (max-width: 1339px) {\n    .page__center {\n        width: 100%;\n        max-width: 930px;\n    }\n\n    .page__row {\n        display: block;\n    }\n\n    .page__row_head {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        margin: 0 -16px;\n        padding: 40px 0;\n    }\n\n    .page__row_head .page__col {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 calc(50% - 32px);\n        flex: 0 0 calc(50% - 32px);\n        max-width: calc(50% - 32px);\n        margin: 0 16px;\n        padding: 0;\n    }\n\n    .page__row_border .page__col:nth-child(2) {\n        border: none;\n    }\n\n    .page__row_responsive {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        margin: 0 -40px;\n    }\n\n    .page__row_responsive.page__row_head {\n        padding: 0;\n    }\n\n    .page__row_responsive.page__row_head .page__col {\n        padding-top: 40px;\n        padding-bottom: 40px;\n    }\n\n    .page__row_responsive .page__col {\n        margin: 0;\n        padding-left: 40px;\n        padding-right: 40px;\n    }\n\n    .page__row_responsive .page__col:first-child {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 55%;\n        flex: 0 0 55%;\n        max-width: 55%;\n    }\n\n    .page__row_responsive .page__col:nth-child(2) {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 45%;\n        flex: 0 0 45%;\n        max-width: 45%;\n        border-left: 1px solid #e4e4e4;\n    }\n\n    .page__col {\n        padding: 0;\n    }\n\n    .page__col:first-child {\n        max-width: 100%;\n    }\n\n    .page__col:nth-child(2) {\n        width: 100%;\n    }\n\n    .page__row:not(.page__row_head):not(.page__row_responsive) .page__col:nth-child(2) {\n        margin-top: 32px;\n    }\n\n    .page .page__col.page__col_w50 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n        max-width: 50%;\n        margin: 0;\n        padding-left: 40px;\n        padding-right: 40px;\n    }\n\n    .page__group {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: start;\n        -ms-flex-align: start;\n        align-items: flex-start;\n        margin: 0 -16px;\n    }\n\n    .page__group .widget {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 calc(50% - 32px);\n        flex: 0 0 calc(50% - 32px);\n        max-width: calc(50% - 32px);\n        margin: 0 16px;\n    }\n\n    .page__group .widget:not(:last-child) {\n        margin-bottom: 0;\n    }\n\n    .page__content {\n        padding: 0 0 40px;\n    }\n\n    .page__content_pt64 {\n        margin-top: 32px;\n        padding: 0;\n        border: none;\n    }\n\n    .page__hello {\n        font-size: 18px;\n        line-height: 1.33333;\n    }\n\n    .page_other .page__center {\n        padding-bottom: 0;\n    }\n\n    .sidebar__details {\n        padding: 10px 10px 25px;\n    }\n\n    .sidebar__details:before {\n        display: none;\n    }\n\n    .widget__details {\n        padding-left: 24px;\n    }\n\n    .widget_responsive {\n        position: relative;\n        padding: 32px;\n        background: #ffffff;\n        border-radius: 24px;\n    }\n\n    .widget_responsive:before {\n        content: '';\n        position: absolute;\n        top: 22px;\n        left: 18px;\n        right: 18px;\n        bottom: -40px;\n        z-index: -2;\n        background: #e3e6ec;\n        opacity: 0.91;\n        -webkit-filter: blur(86.985px);\n        filter: blur(86.985px);\n        border-radius: 24px;\n    }\n\n    .header {\n        max-width: 100%;\n    }\n\n    .header .search {\n        width: auto;\n        -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n        flex-grow: 1;\n        margin-right: 50px;\n    }\n\n    .banner__container {\n        padding: 50px 56px;\n    }\n\n    .banner__preview {\n        right: 50px;\n        width: 330px;\n    }\n\n    .sorting__row {\n        display: block;\n        margin: 0;\n    }\n\n    .sorting__col {\n        width: 100%;\n        margin: 0;\n    }\n\n    .sorting__col:not(:last-child) {\n        margin-bottom: 16px;\n    }\n\n    .schedules__container {\n        display: block;\n        padding: 0;\n        background: none;\n        border-radius: 0;\n    }\n\n    .schedules__container:before {\n        display: none;\n    }\n\n    .schedules__col {\n        position: relative;\n        padding: 32px;\n        border-radius: 24px;\n        background: #ffffff;\n    }\n\n    .schedules__col:before {\n        content: '';\n        position: absolute;\n        top: 35px;\n        left: 35px;\n        right: 35px;\n        bottom: -35px;\n        z-index: -5;\n        background: #e3e6ec;\n        opacity: 0.91;\n        -webkit-filter: blur(86.985px);\n        filter: blur(86.985px);\n        border-radius: 24px;\n    }\n\n    .schedules__col:first-child {\n        width: 100%;\n        margin-bottom: 32px;\n    }\n\n    .schedules__col:first-child .schedules__title {\n        display: block;\n    }\n\n    .schedules__col:nth-child(2) {\n        padding-left: 32px;\n    }\n\n    .schedules__list {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        margin: -32px -32px 0;\n    }\n\n    .schedules__item {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 calc(50% - 32px);\n        flex: 0 0 calc(50% - 32px);\n        width: calc(50% - 32px);\n        margin: 32px 16px 0;\n    }\n\n    .schedules__item:not(:last-child) {\n        margin-bottom: 0;\n    }\n\n    .schedules__btn {\n        display: inline-block;\n        margin-top: 32px;\n    }\n\n    .schedules__graphic {\n        max-width: 100%;\n    }\n\n    .schedules__status:not(:last-child) {\n        margin-right: auto;\n    }\n\n    body.dark .schedules__container {\n        background: none;\n    }\n\n    body.dark .schedules__col {\n        background: #242731;\n    }\n\n    body.dark .schedules__col:before {\n        background: #000;\n        opacity: 0.51;\n        -webkit-filter: blur(86.985px);\n        filter: blur(86.985px);\n        border-radius: 24px;\n    }\n\n    .tabs__preview {\n        display: none;\n    }\n\n    .inbox__details {\n        padding-left: 16px;\n    }\n\n    .inbox__control {\n        margin-bottom: 32px;\n    }\n\n    .inbox__btns .inbox__btn {\n        min-width: 120px;\n        height: 48px;\n    }\n\n    .files__list {\n        display: block;\n        margin: 0;\n    }\n\n    .files__list .files__item {\n        width: 100%;\n        margin: 0;\n    }\n\n    .files__list .files__item:not(:last-child) {\n        margin-bottom: 16px;\n    }\n\n    .notification__details {\n        padding-right: 0;\n    }\n\n    .notification__preview {\n        display: none;\n    }\n\n    .activity__col:nth-child(2) {\n        width: 370px;\n        padding-left: 32px;\n    }\n\n    .activity__inner {\n        display: block;\n    }\n\n    .activity__variants {\n        display: none;\n    }\n\n    .activity__details {\n        padding-right: 0;\n    }\n\n    .activity__preview {\n        display: none;\n    }\n\n    .h1 {\n        font-size: 48px;\n        line-height: 1.5;\n    }\n\n    .h2 {\n        font-size: 40px;\n        line-height: 1.5;\n    }\n}\n\n@media only screen and (max-width: 1179px) {\n    .page__row_responsive {\n        display: block;\n        margin: 0;\n    }\n\n    .page__row_responsive.page__row_head {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        margin: 0 -16px;\n        padding: 40px 0;\n    }\n\n    .page__row_responsive.page__row_head .page__col {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 calc(50% - 32px);\n        flex: 0 0 calc(50% - 32px);\n        max-width: calc(50% - 32px);\n        margin: 0 16px;\n        padding: 0;\n    }\n\n    .page__row_responsive .page__col {\n        padding-left: 0;\n        padding-right: 0;\n    }\n\n    .page__row_responsive .page__col:first-child {\n        max-width: 100%;\n    }\n\n    .page__row_responsive .page__col:nth-child(2) {\n        max-width: 100%;\n        border: none;\n    }\n\n    .page__row:not(.page__row_head) .page__col:nth-child(2) {\n        margin-top: 32px;\n    }\n\n    .page .page__col.page__col_w50 {\n        padding: 0;\n    }\n\n    .page .page__col.page__col_w50:first-child {\n        max-width: 100%;\n        margin-bottom: 30px;\n    }\n\n    .page .page__col.page__col_w50:nth-child(2) {\n        max-width: 100%;\n    }\n\n    .page .page__col.page__col_w50:not(:last-child) {\n        margin-bottom: 0;\n    }\n\n    .page__row:not(.page__row_head) .page__col.page__col_w50:not(:last-child) {\n        margin-bottom: 32px;\n    }\n\n    .page__flex {\n        display: block;\n    }\n\n    .page__flex .widget:first-child {\n        width: 100%;\n        margin: 0 0 32px;\n    }\n\n    .page__welcome_sm {\n        font-size: 32px;\n    }\n\n    .page__nav {\n        margin-bottom: 32px;\n    }\n\n    .page_other {\n        overflow: hidden;\n    }\n\n    .page_other .page__center {\n        padding-bottom: 40px;\n    }\n\n    .sidebar {\n        padding-top: 96px;\n        overflow: hidden;\n        -webkit-transition: width 0.25s, -webkit-transform 0.25s;\n        transition: width 0.25s, -webkit-transform 0.25s;\n        -o-transition: width 0.25s, transform 0.25s;\n        transition: width 0.25s, transform 0.25s;\n        transition: width 0.25s, transform 0.25s, -webkit-transform 0.25s;\n    }\n\n    .sidebar__top {\n        -webkit-box-pack: stretch;\n        -ms-flex-pack: stretch;\n        justify-content: stretch;\n        height: 96px;\n        padding-left: 40px;\n        -webkit-transition: all 0.25s;\n        -o-transition: all 0.25s;\n        transition: all 0.25s;\n    }\n\n    .sidebar__top .sidebar__logo {\n        -webkit-transition: opacity 0.2s;\n        -o-transition: opacity 0.2s;\n        transition: opacity 0.2s;\n    }\n\n    .sidebar__logo .sidebar__pic {\n        width: 140px;\n    }\n\n    .sidebar__wrapper .sidebar__logo {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n\n    .sidebar__group:not(:last-child):before {\n        -webkit-transition: all 0.25s;\n        -o-transition: all 0.25s;\n        transition: all 0.25s;\n    }\n\n    .sidebar__caption {\n        white-space: nowrap;\n        -webkit-transition: padding 0.25s;\n        -o-transition: padding 0.25s;\n        transition: padding 0.25s;\n    }\n\n    .sidebar__item {\n        position: relative;\n        padding-left: 3px;\n    }\n\n    .sidebar__icon {\n        width: 56px;\n        height: 56px;\n        margin-right: 0;\n        -webkit-transition: margin 0.25s;\n        -o-transition: margin 0.25s;\n        transition: margin 0.25s;\n    }\n\n    .sidebar__counter {\n        -webkit-transition: all 0.25s;\n        -o-transition: all 0.25s;\n        transition: all 0.25s;\n    }\n\n    .sidebar__user {\n        -webkit-transition: all 0.25s;\n        -o-transition: all 0.25s;\n        transition: all 0.25s;\n    }\n\n    .sidebar__bottom {\n        -webkit-transition: padding 0.25s;\n        -o-transition: padding 0.25s;\n        transition: padding 0.25s;\n    }\n\n    .sidebar__banner {\n        display: none;\n    }\n\n    .sidebar.active {\n        width: 96px;\n    }\n\n    .sidebar.active .sidebar__inner {\n        width: 56px;\n    }\n\n    .sidebar.active .sidebar__burger {\n        border-color: #e4e4e4;\n    }\n\n    .sidebar.active .sidebar__top .sidebar__logo {\n        opacity: 0;\n    }\n\n    .sidebar.active .sidebar__caption {\n        padding: 0;\n        text-align: center;\n    }\n\n    .sidebar.active .sidebar__caption span {\n        display: none;\n    }\n\n    .sidebar.active .sidebar__group:before {\n        left: -20px;\n        right: -20px;\n    }\n\n    .sidebar.active .sidebar__item {\n        padding-left: 0;\n    }\n\n    .sidebar.active .sidebar__counter {\n        position: absolute;\n        top: 15px;\n        left: 22px;\n        min-width: 10px;\n        height: 10px;\n        font-size: 0;\n    }\n\n    .sidebar.active .sidebar__bottom {\n        padding: 0 35px;\n    }\n\n    .sidebar.active .sidebar__bottom .switch_theme .switch__in {\n        padding-left: 60px;\n    }\n\n    .banner__wrap {\n        max-width: 300px;\n    }\n\n    .banner__title {\n        margin-bottom: 6px;\n        line-height: 1.2;\n    }\n\n    .banner__preview {\n        top: 50%;\n        -webkit-transform: translateY(-50%);\n        -ms-transform: translateY(-50%);\n        transform: translateY(-50%);\n        width: 180px;\n    }\n\n    .sorting__line .sorting__search {\n        margin-right: 30px;\n    }\n\n    .dropdown__body {\n        right: 0;\n        width: auto;\n        padding: 24px 21px;\n    }\n\n    .products__cell {\n        padding-left: 15px;\n    }\n\n    .products__preview {\n        width: 86px;\n        height: 64px;\n    }\n\n    .products__details {\n        padding-left: 16px;\n    }\n\n    .products__bg {\n        border-radius: 50%;\n    }\n\n    .products__color .products__text {\n        display: none;\n    }\n\n    .tabs__preview {\n        display: block;\n    }\n\n    .inbox__control {\n        display: block;\n    }\n\n    .inbox__btns {\n        margin: 0 -8px;\n    }\n\n    .inbox__btns .inbox__btn {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 calc(50% - 16px);\n        flex: 0 0 calc(50% - 16px);\n        min-width: calc(50% - 16px);\n        margin: 0 8px;\n    }\n\n    .inbox__btns .inbox__btn:not(:last-child) {\n        margin-right: 8px;\n    }\n\n    .inbox__more {\n        display: none;\n    }\n\n    .inbox__box:not(:last-child) {\n        margin-bottom: 32px;\n        padding: 0;\n        border: none;\n    }\n\n    .inbox__box .inbox__title {\n        font-size: 18px;\n    }\n\n    .notification__details {\n        padding: 0 24px;\n    }\n\n    .notification__preview {\n        display: block;\n    }\n\n    .activity__row {\n        display: block;\n    }\n\n    .activity__col:first-child {\n        margin-bottom: 32px;\n    }\n\n    .activity__col:nth-child(2) {\n        width: 100%;\n        padding: 0;\n    }\n\n    .activity__details {\n        padding: 0 24px;\n    }\n\n    .activity__preview {\n        display: block;\n    }\n\n    .desktop-hide {\n        display: none;\n    }\n\n    .desktop-show {\n        display: block;\n    }\n\n    .desktop-text-right {\n        text-align: right;\n    }\n}\n\n@media only screen and (max-width: 1023px) {\n    .page {\n        overflow: hidden;\n    }\n\n    .page__wrapper {\n        padding-left: 0;\n    }\n\n    .page__center {\n        padding: 0 32px 40px;\n    }\n\n    .page__row_head {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: reverse;\n        -ms-flex-direction: column-reverse;\n        flex-direction: column-reverse;\n        margin: 0;\n        padding: 25px 0;\n    }\n\n    .page__row_head .page__col {\n        max-width: 100%;\n        margin: 0;\n    }\n\n    .page__row_head .page__col:nth-child(2) {\n        margin-bottom: 30px;\n    }\n\n    .page__row_responsive.page__row_head {\n        margin: 0;\n        padding: 25px 0;\n    }\n\n    .page__row_responsive.page__row_head .page__col {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n        max-width: 100%;\n        width: 100%;\n        margin: auto;\n    }\n\n    .page__row_responsive.page__row_head .page__col:nth-child(2) {\n        margin-bottom: 30px;\n    }\n\n    .page__content {\n        padding: 0;\n    }\n\n    .page.toggle .page__wrapper {\n        -webkit-transform: translateX(160px);\n        -ms-transform: translateX(160px);\n        transform: translateX(160px);\n    }\n\n    .sidebar {\n        transform: translateX(-100%);\n    }\n\n    .sidebar.show {\n        transform: translateX(0);\n    }\n\n    .sidebar__burger {\n        display: inline-block;\n    }\n\n    .sidebar__top {\n        padding: 0;\n    }\n\n    .sidebar__top .sidebar__logo {\n        opacity: 0;\n    }\n\n    .sidebar__wrapper .sidebar__logo {\n        height: 80px;\n    }\n\n    .sidebar__burger {\n        border-color: #e4e4e4;\n    }\n\n    .sidebar__group:not(:last-child):before {\n        left: -20px;\n        right: -20px;\n    }\n\n    .sidebar__caption {\n        padding-left: 0;\n        text-align: center;\n    }\n\n    .sidebar__caption span {\n        display: none;\n    }\n\n    .sidebar__item {\n        padding-left: 0;\n    }\n\n    .sidebar__item:hover {\n        color: #808191;\n    }\n\n    .sidebar__icon {\n        margin-right: 21px;\n    }\n\n    .sidebar__item:hover .icon {\n        fill: #1b1d21;\n        opacity: 0.4;\n    }\n\n    .sidebar__counter {\n        position: absolute;\n        top: 15px;\n        left: 22px;\n        min-width: 10px;\n        height: 10px;\n        font-size: 0;\n    }\n\n    .sidebar__profile {\n        margin-top: 20px;\n    }\n\n    .sidebar__details {\n        padding: 5px 0 17px;\n        background: none;\n    }\n\n    .sidebar__link .sidebar__icon {\n        width: 56px;\n        margin-right: 24px;\n        padding: 0;\n    }\n\n    .sidebar__bottom {\n        padding: 0 35px;\n    }\n\n    .sidebar .switch_theme .switch__in {\n        padding-left: 60px;\n    }\n\n    .sidebar.active {\n        width: 256px;\n    }\n\n    .sidebar.active .sidebar__inner {\n        width: 100%;\n    }\n\n    .sidebar.active .sidebar__burger {\n        border-color: transparent;\n    }\n\n    .sidebar.active .sidebar__top {\n        padding-left: 40px;\n    }\n\n    .sidebar.active .sidebar__top .sidebar__logo {\n        opacity: 1;\n    }\n\n    .sidebar.active .sidebar__icon {\n        margin-right: 0;\n    }\n\n    .sidebar.active .sidebar__caption {\n        padding: 0 20px;\n        text-align: left;\n    }\n\n    .sidebar.active .sidebar__caption span {\n        display: inline;\n    }\n\n    .sidebar.active .sidebar__group:before {\n        left: 20px;\n        right: 20px;\n    }\n\n    .sidebar.active .sidebar__wrapper .sidebar__logo {\n        height: 0;\n    }\n\n    .sidebar.active .sidebar__item {\n        padding-left: 3px;\n    }\n\n    .sidebar.active .sidebar__counter {\n        position: static;\n        min-width: 24px;\n        height: 24px;\n        font-size: 12px;\n    }\n\n    .sidebar.active .sidebar__user {\n        padding: 0 20px;\n    }\n\n    .sidebar.active .sidebar__bottom {\n        padding: 0 40px;\n    }\n\n    .sidebar.active .sidebar__bottom .switch_theme .switch__in {\n        padding-left: 56px;\n    }\n\n    body.dark .sidebar__burger {\n        border-color: rgba(228, 228, 228, 0.1);\n    }\n\n    body.dark .sidebar.active .sidebar__burger {\n        border-color: transparent;\n    }\n\n    .banner__container {\n        padding: 50px 40px;\n    }\n\n    .products__preview {\n        display: none;\n    }\n\n    .products__details {\n        padding: 0;\n    }\n\n    .products__more {\n        padding-top: 32px;\n    }\n\n    .schedules__task .schedules__text {\n        padding: 0 10px;\n    }\n\n    .editor__close {\n        top: 5px;\n        right: 5px;\n        visibility: visible;\n        opacity: 1;\n    }\n\n    .tablet-hide {\n        display: none;\n    }\n\n    .tablet-show {\n        display: block;\n    }\n\n    .tablet-text-right {\n        text-align: right;\n    }\n\n    .h3 {\n        font-size: 32px;\n        line-height: 1.5;\n        letter-spacing: -0.5px;\n    }\n}\n\n@media all and (max-width: 900px) {\n    .mfp-arrow {\n        -webkit-transform: scale(0.75);\n        -ms-transform: scale(0.75);\n        transform: scale(0.75);\n    }\n\n    .mfp-arrow-left {\n        -webkit-transform-origin: 0;\n        -ms-transform-origin: 0;\n        transform-origin: 0;\n    }\n\n    .mfp-arrow-right {\n        -webkit-transform-origin: 100%;\n        -ms-transform-origin: 100%;\n        transform-origin: 100%;\n    }\n\n    .mfp-container {\n        padding-left: 6px;\n        padding-right: 6px;\n    }\n}\n\n@media (max-width: 900px) {\n    .mfp-container {\n        padding: 30px 20px;\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    .page__wrapper {\n        padding-left: 0;\n    }\n\n    .page__center {\n        padding: 0 16px 32px;\n    }\n\n    .page__row_head {\n        padding: 0;\n    }\n\n    .page__row_head .page__col:first-child {\n        padding: 16px 16px 28px;\n    }\n\n    .page__row_head .page__col:nth-child(2) {\n        margin: 0;\n    }\n\n    .page__row_responsive.page__row_head {\n        padding: 0;\n    }\n\n    .page__row_responsive.page__row_head .page__col:nth-child(2) {\n        margin-bottom: 0;\n    }\n\n    .page__widgets {\n        display: block;\n        margin: 0;\n    }\n\n    .page__widgets:not(:last-child) {\n        margin-bottom: 32px;\n    }\n\n    .page__widgets .widget {\n        width: 100%;\n        margin: 0;\n    }\n\n    .page__widgets .widget:not(:last-child) {\n        margin-bottom: 32px;\n    }\n\n    .page__group {\n        display: block;\n        margin: 0;\n    }\n\n    .page__group .widget {\n        max-width: 100%;\n        margin: 0;\n    }\n\n    .page__group .widget:not(:last-child) {\n        margin-bottom: 32px;\n    }\n\n    .page__stat {\n        padding: 32px 0;\n    }\n\n    .page__stat:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    .page__stat_sm .sorting {\n        position: relative;\n        top: auto;\n        right: auto;\n    }\n\n    .page__hello {\n        font-size: 16px;\n    }\n\n    .page__title {\n        padding: 0 24px;\n    }\n\n    .page.toggle .page__wrapper {\n        padding-left: 0;\n        -webkit-transform: translateX(256px);\n        -ms-transform: translateX(256px);\n        transform: translateX(256px);\n    }\n\n    body.dark .page__stat:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    .sidebar__wrapper {\n        padding: 20px;\n    }\n\n    .sidebar__inner {\n        width: 100%;\n    }\n\n    .sidebar__top {\n        padding-left: 40px;\n        border-bottom: 1px solid #e4e4e4;\n    }\n\n    .sidebar__top .sidebar__logo {\n        opacity: 1;\n    }\n\n    .sidebar__close {\n        display: inline-block;\n    }\n\n    .sidebar__wrapper .sidebar__logo {\n        display: none;\n    }\n\n    .sidebar__list {\n        margin: 0;\n    }\n\n    .sidebar__group:not(:last-child) {\n        margin-bottom: 20px;\n        padding-bottom: 15px;\n    }\n\n    .sidebar__group:not(:last-child):before {\n        left: 20px;\n        right: 20px;\n    }\n\n    .sidebar__caption {\n        padding-left: 20px;\n        text-align: left;\n    }\n\n    .sidebar__caption span {\n        display: inline;\n    }\n\n    .sidebar__item {\n        padding-left: 3px;\n    }\n\n    .sidebar__icon {\n        margin-right: 0;\n    }\n\n    .sidebar__counter {\n        position: static;\n        min-width: 24px;\n        height: 24px;\n        font-size: 12px;\n    }\n\n    .sidebar__bottom {\n        padding: 0 40px;\n    }\n\n    .sidebar .switch_theme .switch__in {\n        padding-left: 56px;\n    }\n\n    .sidebar.active {\n        -webkit-transform: translateX(0);\n        -ms-transform: translateX(0);\n        transform: translateX(0);\n    }\n\n    .sidebar.active .sidebar__caption {\n        padding-left: 15px;\n    }\n\n    .sidebar.active .sidebar__item {\n        padding-left: 0;\n    }\n\n    body.dark .sidebar__top {\n        border-color: rgba(228, 228, 228, 0.1);\n    }\n\n    .slider {\n        margin-bottom: 48px;\n    }\n\n    .slider__item {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: reverse;\n        -ms-flex-direction: column-reverse;\n        flex-direction: column-reverse;\n        padding: 0 32px 54px;\n        text-align: center;\n    }\n\n    .slider__details {\n        width: 100%;\n        padding: 0;\n    }\n\n    .slider__preview {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        width: 282px;\n        height: 282px;\n        padding: 20px;\n    }\n\n    .slider__text {\n        margin-bottom: 24px;\n    }\n\n    .slider .owl-dots {\n        left: 0;\n        right: 0;\n        bottom: 24px;\n    }\n\n    .widget__chart_impressions {\n        margin-left: -10px;\n        margin-right: 10px;\n    }\n\n    .widget__chart_items {\n        margin-bottom: 16px;\n    }\n\n    .widget_shadow:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    .widget_stat:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    body.dark .widget_shadow:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    body.dark .widget_stat:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    .header {\n        height: 96px;\n        max-width: calc(100% + 32px);\n        margin: 0 -16px;\n        padding: 0 32px;\n        border-bottom: 1px solid #e4e4e4;\n    }\n\n    .header .search {\n        -webkit-box-flex: 0;\n        -ms-flex-positive: 0;\n        flex-grow: 0;\n        margin-left: 0;\n        margin-right: 0;\n    }\n\n    .header .notifications {\n        margin-right: 25px;\n    }\n\n    .header__user {\n        display: block;\n    }\n\n    .header__burger {\n        display: inline-block;\n    }\n\n    .header__search {\n        display: inline-block;\n    }\n\n    body.dark .header {\n        border-color: rgba(228, 228, 228, 0.1);\n    }\n\n    .search {\n        position: absolute;\n        top: 100%;\n        left: 0;\n        right: 0;\n        z-index: 10;\n        visibility: hidden;\n    }\n\n    .search.show {\n        visibility: visible;\n        opacity: 1;\n    }\n\n    .search__input {\n        height: 56px;\n        background: #e4e4e4;\n        border-radius: 0;\n    }\n\n    .search__result {\n        top: 0;\n        left: 0;\n        right: 0;\n        -webkit-box-shadow: 0 30px 30px rgba(27, 29, 33, 0.3);\n        box-shadow: 0 30px 30px rgba(27, 29, 33, 0.3);\n    }\n\n    .search.active .search__input {\n        background: #e4e4e4;\n    }\n\n    body.dark .search__input {\n        background: #1f2128;\n    }\n\n    body.dark .search__result {\n        -webkit-box-shadow: 0 30px 30px rgba(0, 0, 0, 0.5);\n        box-shadow: 0 30px 30px rgba(0, 0, 0, 0.5);\n    }\n\n    body.dark .search.active .search__input {\n        background: #1f2128;\n    }\n\n    .notifications {\n        position: static;\n    }\n\n    .notifications__open {\n        width: 40px;\n        height: 40px;\n        -webkit-box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);\n        box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);\n    }\n\n    .notifications__open .icon {\n        font-size: 20px;\n    }\n\n    .notifications__counter {\n        top: 5px;\n        right: 5px;\n        min-width: 12px;\n        height: 12px;\n        font-size: 0;\n    }\n\n    .notifications__wrap {\n        top: calc(100% + 1px);\n        right: 0;\n        left: 0;\n        width: auto;\n        padding: 24px 16px;\n        -webkit-box-shadow: 0 30px 30px rgba(27, 29, 33, 0.3);\n        box-shadow: 0 30px 30px rgba(27, 29, 33, 0.3);\n    }\n\n    .notifications__info {\n        margin-bottom: 16px;\n        padding: 0;\n    }\n\n    .notifications__list {\n        margin-bottom: 24px;\n    }\n\n    .notifications__item {\n        padding: 0;\n    }\n\n    .notifications__item:hover {\n        background: none;\n    }\n\n    .notifications__item:not(:last-child) {\n        margin-bottom: 20px;\n    }\n\n    .notifications__ava {\n        margin-right: 16px;\n    }\n\n    body.dark .notifications__open {\n        -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);\n        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);\n    }\n\n    body.dark .notifications__wrap {\n        -webkit-box-shadow: 0 30px 30px rgba(0, 0, 0, 0.5);\n        box-shadow: 0 30px 30px rgba(0, 0, 0, 0.5);\n    }\n\n    .banner__container {\n        padding: 10px 32px 32px;\n        text-align: center;\n    }\n\n    .banner__wrap {\n        max-width: 100%;\n    }\n\n    .banner__preview {\n        position: static;\n        -webkit-transform: translateY(0);\n        -ms-transform: translateY(0);\n        transform: translateY(0);\n        width: 260px;\n        height: 260px;\n        padding: 30px;\n        margin: 0 auto;\n        text-align: center;\n    }\n\n    .sorting__dropdowns {\n        display: flex;\n        margin: 0;\n        align-items: baseline;\n    }\n\n    .sorting__dropdowns .dropdown {\n        width: 100%;\n        margin: 0;\n    }\n\n    .sorting__dropdowns .dropdown:not(:last-child) {\n        margin-bottom: 16px;\n    }\n\n    .sorting__line {\n        display: block;\n    }\n\n    .sorting__line .sorting__search {\n        margin: 0 0 16px;\n    }\n\n    .sorting__actions {\n        -webkit-box-pack: end;\n        -ms-flex-pack: end;\n        justify-content: flex-end;\n    }\n\n    .products__table {\n        display: block;\n        margin-top: -72px;\n    }\n\n    .products__row {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        padding: 24px;\n    }\n\n    .products__row:not(.products__row_head) {\n        border-top: 1px solid #e4e4e4;\n    }\n\n    .products__row_head .products__cell {\n        padding: 0;\n    }\n\n    .products__cell {\n        display: block;\n        padding: 0;\n        border: none;\n    }\n\n    .products__cell:first-child {\n        margin-right: 24px;\n    }\n\n    .products__cell:nth-child(n + 3) {\n        display: none;\n    }\n\n    .products__preview {\n        display: block;\n        width: 72px;\n        height: 55px;\n    }\n\n    .products__details {\n        padding-left: 24px;\n    }\n\n    .products__bg {\n        width: 9px;\n        height: 32px;\n        margin-right: 31px;\n        border-radius: 9px;\n    }\n\n    .products__more {\n        border-top: 1px solid #e4e4e4;\n        padding: 24px 24px 0;\n    }\n\n    .products__more .products__btn {\n        min-width: 100%;\n    }\n\n    .products__body {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n\n    .products_statement .products__cell {\n        display: block;\n    }\n\n    .products_statement .products__cell:not(:first-child):not(:nth-child(3)) {\n        display: none;\n    }\n\n    body.dark .products__row:not(.products__row_head) {\n        border-color: rgba(228, 228, 228, 0.1);\n    }\n\n    body.dark .products__more {\n        border-color: rgba(228, 228, 228, 0.1);\n    }\n\n    .details__container {\n        padding-bottom: 32px;\n    }\n\n    .details__container:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    .details__title {\n        margin-bottom: 24px;\n    }\n\n    .details__row {\n        display: block;\n    }\n\n    .details__col:first-child {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: end;\n        -ms-flex-align: end;\n        align-items: flex-end;\n        width: auto;\n        margin: 0 -5px 32px;\n        padding: 0;\n    }\n\n    .details__top {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 calc(50% - 10px);\n        flex: 0 0 calc(50% - 10px);\n        margin: 0 5px;\n        padding: 0;\n        border: none;\n    }\n\n    .details__bottom {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 calc(50% - 10px);\n        flex: 0 0 calc(50% - 10px);\n        margin: 0 5px;\n    }\n\n    .details__statistics {\n        margin-bottom: 32px;\n    }\n\n    .details__list {\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    }\n\n    .details__item:not(:last-child) {\n        border-right: none;\n    }\n\n    .details__list_three .details__item {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n        width: 100%;\n    }\n\n    .details__list_three .details__item:not(:first-child) {\n        border-top: 1px solid #e4e4e4;\n    }\n\n    .details__list_four .details__item {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n        width: 50%;\n    }\n\n    .details__list_four .details__item:nth-child(2n + 1) {\n        border-right: 1px solid #e4e4e4;\n    }\n\n    .details__list_four .details__item:nth-child(n + 3) {\n        border-top: 1px solid #e4e4e4;\n    }\n\n    .details .dropdown {\n        position: relative;\n        top: auto;\n        right: auto;\n        width: 100%;\n        margin-bottom: 20px;\n    }\n\n    .details_statements:not(:last-child) {\n        margin-bottom: 32px;\n    }\n\n    .details_statements .details__col:first-child {\n        width: auto;\n        padding: 0;\n    }\n\n    body.dark .details__container:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    body.dark .details__list_four .details__item:nth-child(n + 3) {\n        border-color: rgba(228, 228, 228, 0.1);\n    }\n\n    body.dark .details__list_three .details__item:not(:first-child) {\n        border-color: rgba(228, 228, 228, 0.1);\n    }\n\n    .schedules__container:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    .schedules__list {\n        display: block;\n        margin: 0 -16px;\n    }\n\n    .schedules__item {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n        width: 100%;\n        margin: 0;\n    }\n\n    .schedules__item:not(:last-child) {\n        margin-bottom: 24px;\n    }\n\n    .schedules__top {\n        margin: -16px 0 20px;\n    }\n\n    .schedules__arrows {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n\n    .schedules__inner {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        margin: 0 -32px;\n        padding-bottom: 32px;\n        overflow: auto;\n        overflow-x: auto;\n        -ms-overflow-style: none;\n        scrollbar-width: none;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    .schedules__inner::-webkit-scrollbar {\n        display: none;\n    }\n\n    .schedules__inner:before,\n    .schedules__inner:after {\n        content: '';\n        display: inline-block;\n        -ms-flex-negative: 0;\n        flex-shrink: 0;\n        width: 32px;\n        height: 1px;\n    }\n\n    .schedules__graphic {\n        min-width: 586px;\n        margin-bottom: 7px;\n    }\n\n    .schedules__legend {\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        margin-top: -10px;\n        padding: 0;\n    }\n\n    .schedules__status {\n        margin-top: 10px;\n    }\n\n    .schedules__status:not(:last-child) {\n        margin-right: 15px;\n    }\n\n    body.dark .schedules__container:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    .tabs__row {\n        display: block;\n        margin: -20px -16px;\n    }\n\n    .tabs__col:first-child {\n        width: 100%;\n    }\n\n    .tabs__col:nth-child(2) {\n        display: none;\n    }\n\n    .tabs__nav {\n        display: none;\n    }\n\n    .payment__row {\n        display: block;\n    }\n\n    .payment__details {\n        width: 100%;\n        margin: 0 0 32px;\n    }\n\n    .payment__tick {\n        margin-right: 24px;\n    }\n\n    .inbox__tags {\n        margin: -10px 0 24px -10px;\n    }\n\n    .inbox__tag {\n        margin: 10px 0 0 10px;\n    }\n\n    .inbox__container {\n        padding: 32px 24px;\n    }\n\n    .inbox__container:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    .inbox__container>.inbox__title {\n        margin: 0;\n    }\n\n    .inbox__list {\n        margin: 0;\n    }\n\n    .inbox__item {\n        padding: 24px 0;\n        border-radius: 0;\n        border-bottom: 1px solid #e4e4e4;\n    }\n\n    .inbox__head {\n        height: 48px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n    }\n\n    .inbox__item .inbox__title {\n        margin-left: -64px;\n    }\n\n    .inbox__text {\n        margin-left: -64px;\n    }\n\n    .inbox__item:hover {\n        background: none;\n    }\n\n    .inbox__item.active {\n        background: none;\n        color: #808191;\n    }\n\n    .inbox__item.active .actions__btn {\n        border-color: #e4e4e4;\n    }\n\n    .inbox__item.active .actions__btn .icon {\n        fill: #1b1d21;\n    }\n\n    .inbox__item.active .inbox__title {\n        color: #11142d;\n    }\n\n    .inbox__item.active .inbox__author {\n        color: #808191;\n    }\n\n    .inbox .actions {\n        margin-left: -64px;\n    }\n\n    .inbox__foot {\n        padding-top: 24px;\n    }\n\n    .inbox__box:not(:last-child) {\n        margin-bottom: 24px;\n    }\n\n    .inbox__box .inbox__title {\n        margin: 0 0 24px -64px;\n    }\n\n    .inbox .files {\n        margin: 16px 0 0 -64px;\n    }\n\n    .inbox .sorting {\n        padding: 0;\n    }\n\n    body.dark .inbox__container:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    body.dark .inbox__item {\n        border-color: rgba(228, 228, 228, 0.1);\n    }\n\n    body.dark .inbox__item:hover {\n        background: none;\n    }\n\n    body.dark .inbox__item.active {\n        background: none;\n    }\n\n    body.dark .inbox__author {\n        color: #ffffff;\n    }\n\n    body.dark .inbox__item.active .actions__btn {\n        border-color: rgba(228, 228, 228, 0.1);\n    }\n\n    body.dark .inbox__item.active .actions__btn .icon {\n        fill: #ffffff;\n    }\n\n    .editor__head {\n        padding: 24px 16px;\n    }\n\n    .editor__body {\n        padding: 24px 16px;\n    }\n\n    .editor__btn {\n        min-width: 100%;\n        margin-top: 16px;\n    }\n\n    .notification__tags {\n        margin: -10px 0 24px -10px;\n    }\n\n    .notification__tag {\n        margin: 10px 0 0 10px;\n    }\n\n    .notification__container {\n        padding: 32px 24px;\n    }\n\n    .notification__container:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    .notification__title {\n        margin-bottom: 16px;\n    }\n\n    .notification__list {\n        margin: 0;\n    }\n\n    .notification__item {\n        padding: 24px 0;\n        border-radius: 0;\n        border-bottom: 1px solid #e4e4e4;\n    }\n\n    .notification__details {\n        padding: 0 0 0 16px;\n    }\n\n    .notification .actions {\n        margin-left: -64px;\n    }\n\n    .notification__item:hover {\n        background: none;\n    }\n\n    .notification__item.active {\n        background: none;\n        color: #808191;\n    }\n\n    .notification__item.active .actions__btn {\n        border-color: #e4e4e4;\n    }\n\n    .notification__item.active .actions__btn .icon {\n        fill: #1b1d21;\n    }\n\n    .notification__item.active .notification__title {\n        color: #11142d;\n    }\n\n    .notification__item.active .notification__author {\n        color: var(--main-color);\n    }\n\n    .notification__item.active .notification__info {\n        color: #808191;\n    }\n\n    .notification__preview {\n        display: none;\n    }\n\n    body.dark .notification__container:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    body.dark .notification__item {\n        border-color: rgba(228, 228, 228, 0.1);\n    }\n\n    body.dark .notification__item:hover {\n        background: none;\n    }\n\n    body.dark .notification__item.active {\n        background: none;\n    }\n\n    body.dark .notification__item.active .actions__btn {\n        border-color: rgba(228, 228, 228, 0.1);\n    }\n\n    body.dark .notification__item.active .actions__btn .icon {\n        fill: #ffffff;\n    }\n\n    .filters__container:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    body.dark .filters__container:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    .activity__col:nth-child(2) {\n        padding: 0 16px;\n    }\n\n    .activity__container {\n        padding: 32px 24px;\n    }\n\n    .activity__container:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    .activity__title {\n        margin-bottom: 16px;\n    }\n\n    .activity__list {\n        margin: 0;\n    }\n\n    .activity__item {\n        padding: 24px 0;\n        border-radius: 0;\n        border-bottom: 1px solid #e4e4e4;\n    }\n\n    .activity__item:before {\n        display: none;\n    }\n\n    .activity__item.active {\n        color: #808191;\n    }\n\n    .activity__details {\n        padding: 0 0 0 16px;\n    }\n\n    .activity__item.active .activity__author {\n        color: #11142d;\n    }\n\n    .activity__item.active .activity__info {\n        color: var(--main-color);\n    }\n\n    .activity__preview {\n        display: none;\n    }\n\n    .activity:not(:first-child) {\n        margin-top: 32px;\n    }\n\n    body.dark .activity__container:before {\n        -webkit-filter: blur(46.985px);\n        filter: blur(46.985px);\n    }\n\n    body.dark .activity__item {\n        border-color: rgba(228, 228, 228, 0.1);\n    }\n\n    body.dark .activity__item:hover {\n        background: none;\n    }\n\n    .popup__title {\n        margin-bottom: 42px;\n    }\n\n    .popup__tags {\n        display: none;\n    }\n\n    .popup__user:not(:last-child) {\n        padding-bottom: 24px;\n    }\n\n    .popup__ava {\n        width: 80px;\n        height: 80px;\n    }\n\n    .popup__details {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 calc(100% - 80px);\n        flex: 0 0 calc(100% - 80px);\n        width: calc(100% - 80px);\n        padding-left: 24px;\n    }\n\n    .popup__btns {\n        display: block;\n        margin: 0 0 32px;\n    }\n\n    .popup__btns .popup__btn {\n        min-width: 100%;\n    }\n\n    .popup__btns .popup__btn.btn_gray {\n        background: #ffffff;\n    }\n\n    .popup__btns .popup__btn:not(:last-child),\n    .popup__loading:not(:last-child) {\n        margin: 0;\n    }\n\n    .popup__text {\n        margin-left: -104px;\n    }\n\n    .popup__row {\n        display: block;\n        margin: 0;\n    }\n\n    .popup__row .popup__field {\n        width: 100%;\n        margin: 0;\n    }\n\n    .popup__row .popup__field:not(:last-child) {\n        margin-bottom: 24px;\n    }\n\n    .popup__form>.popup__btn {\n        min-width: 100%;\n    }\n\n    .popup .mfp-close {\n        right: 20px;\n        -webkit-box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);\n        box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);\n    }\n\n    .mfp-container {\n        padding: 0;\n    }\n\n    body.dark .popup .mfp-close {\n        -webkit-box-shadow: 0 5px 20px rgba(0, 0, 0, 0.35);\n        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.35);\n    }\n\n    .mobile-hide {\n        display: none;\n    }\n\n    .mobile-show {\n        display: block;\n    }\n\n    .mobile-text-right {\n        text-align: right;\n    }\n\n    .h1 {\n        font-size: 40px;\n        line-height: 1.5;\n    }\n\n    .h2 {\n        font-size: 32px;\n        line-height: 1.5;\n        letter-spacing: -0.5px;\n    }\n}\n\n/*# sourceMappingURL=app.css.map */",".icon-arrow-down-fat {\n  width: 1.33em;\n  height: 1em;\n  fill: #FFF;\n}\n.icon-arrow-left {\n  width: 0.6em;\n  height: 1em;\n  fill: #11142D;\n}\n.icon-arrow-next-fat {\n  width: 1.3em;\n  height: 1em;\n  fill: #11142d;\n}\n.icon-arrow-next {\n  width: 1.2em;\n  height: 1em;\n  fill: #11142D;\n}\n.icon-arrow-prev {\n  width: 1.2em;\n  height: 1em;\n  fill: #11142d;\n}\n.icon-arrow-right {\n  width: 0.6em;\n  height: 1em;\n  fill: #11142D;\n}\n.icon-arrow-up-fat {\n  width: 1.33em;\n  height: 1em;\n  fill: #FFF;\n}\n.icon-arrows {\n  width: 0.63em;\n  height: 1em;\n  fill: #11142d;\n}\n.icon-bag {\n  width: 0.95em;\n  height: 1em;\n  fill: #1b1d21;\n}\n.icon-bell {\n  width: 0.92em;\n  height: 1em;\n  fill: #11142D;\n}\n.icon-box {\n  width: 1.13em;\n  height: 1em;\n  fill: #11142D;\n}\n.icon-chart {\n  width: 1em;\n  height: 1em;\n  fill: #1b1d21;\n}\n.icon-chat {\n  width: 1em;\n  height: 1em;\n  fill: #1b1d21;\n}\n.icon-close {\n  width: 1em;\n  height: 1em;\n  fill: #1B1D21;\n}\n.icon-comment {\n  width: 1em;\n  height: 1em;\n  fill: #1B1D21;\n}\n.icon-discovery {\n  width: 1em;\n  height: 1em;\n  fill: #1b1d21;\n}\n.icon-document {\n  width: 0.95em;\n  height: 1em;\n  fill: #1b1d21;\n}\n.icon-dots-border {\n  width: 4em;\n  height: 1em;\n  fill: #11142D;\n}\n.icon-download-fat {\n  width: 0.94em;\n  height: 1em;\n  fill: #11142d;\n}\n.icon-download {\n  width: 0.95em;\n  height: 1em;\n  fill: #7fba7a;\n}\n.icon-edit {\n  width: 1em;\n  height: 1em;\n  fill: #11142D;\n}\n.icon-editor-bold {\n  width: 0.83em;\n  height: 1em;\n  fill: #fff;\n}\n.icon-editor-italic {\n  width: 0.5em;\n  height: 1em;\n  fill: #808191;\n}\n.icon-editor-pic {\n  width: 1.08em;\n  height: 1em;\n  fill: #808191;\n}\n.icon-editor-smile {\n  width: 1em;\n  height: 1em;\n  fill: #808191;\n}\n.icon-folder {\n  width: 1.06em;\n  height: 1em;\n  fill: #11142D;\n}\n.icon-like {\n  width: 1em;\n  height: 1em;\n  fill: #fff;\n}\n.icon-logout {\n  width: 1em;\n  height: 1em;\n  fill: #1b1d21;\n}\n.icon-message {\n  width: 1.11em;\n  height: 1em;\n  fill: #1b1d21;\n}\n.icon-moon {\n  width: 1em;\n  height: 1em;\n  fill: #3f8cff;\n}\n.icon-more {\n  width: 1em;\n  height: 1em;\n  fill: #1B1D21;\n}\n.icon-notification {\n  width: 0.91em;\n  height: 1em;\n  fill: #1b1d21;\n}\n.icon-overview {\n  width: 0.95em;\n  height: 1em;\n  fill: #fff;\n}\n.icon-plus-square {\n  width: 1em;\n  height: 1em;\n  fill: #FFF;\n}\n.icon-print {\n  width: 1em;\n  height: 1em;\n  fill: #11142d;\n}\n.icon-profile {\n  width: 0.81em;\n  height: 1em;\n  fill: #1b1d21;\n}\n.icon-remove {\n  width: 1em;\n  height: 1em;\n  fill: #11142D;\n}\n.icon-search {\n  width: 1em;\n  height: 1em;\n  fill: #11142D;\n}\n.icon-settings {\n  width: 0.91em;\n  height: 1em;\n  fill: #1b1d21;\n}\n.icon-star {\n  width: 1em;\n  height: 1em;\n  fill: #1B1D21;\n}\n.icon-sun {\n  width: 1em;\n  height: 1em;\n  fill: #3f8cff;\n}\n.icon-wallet {\n  width: 1.1em;\n  height: 1em;\n  fill: #1b1d21;\n}\n","/**\n * Owl Carousel v2.3.4\n * Copyright 2013-2018 David Deutsch\n * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE\n */\n/*\n *  Owl Carousel - Core\n */\n.owl-carousel {\n  display: none;\n  width: 100%;\n  -webkit-tap-highlight-color: transparent;\n  /* position relative and z-index fix webkit rendering fonts issue */\n  position: relative;\n  z-index: 1; }\n  .owl-carousel .owl-stage {\n    position: relative;\n    -ms-touch-action: pan-Y;\n    touch-action: manipulation;\n    -moz-backface-visibility: hidden;\n    /* fix firefox animation glitch */ }\n  .owl-carousel .owl-stage:after {\n    content: \".\";\n    display: block;\n    clear: both;\n    visibility: hidden;\n    line-height: 0;\n    height: 0; }\n  .owl-carousel .owl-stage-outer {\n    position: relative;\n    overflow: hidden;\n    /* fix for flashing background */\n    -webkit-transform: translate3d(0px, 0px, 0px); }\n  .owl-carousel .owl-wrapper,\n  .owl-carousel .owl-item {\n    -webkit-backface-visibility: hidden;\n    -moz-backface-visibility: hidden;\n    -ms-backface-visibility: hidden;\n    -webkit-transform: translate3d(0, 0, 0);\n    -moz-transform: translate3d(0, 0, 0);\n    -ms-transform: translate3d(0, 0, 0); }\n  .owl-carousel .owl-item {\n    position: relative;\n    min-height: 1px;\n    float: left;\n    -webkit-backface-visibility: hidden;\n    -webkit-tap-highlight-color: transparent;\n    -webkit-touch-callout: none; }\n  .owl-carousel .owl-item img {\n    display: block;\n    width: 100%; }\n  .owl-carousel .owl-nav.disabled,\n  .owl-carousel .owl-dots.disabled {\n    display: none; }\n  .owl-carousel .owl-nav .owl-prev,\n  .owl-carousel .owl-nav .owl-next,\n  .owl-carousel .owl-dot {\n    cursor: pointer;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none; }\n  .owl-carousel .owl-nav button.owl-prev,\n  .owl-carousel .owl-nav button.owl-next,\n  .owl-carousel button.owl-dot {\n    background: none;\n    color: inherit;\n    border: none;\n    padding: 0 !important;\n    font: inherit; }\n  .owl-carousel.owl-loaded {\n    display: block; }\n  .owl-carousel.owl-loading {\n    opacity: 0;\n    display: block; }\n  .owl-carousel.owl-hidden {\n    opacity: 0; }\n  .owl-carousel.owl-refresh .owl-item {\n    visibility: hidden; }\n  .owl-carousel.owl-drag .owl-item {\n    -ms-touch-action: pan-y;\n        touch-action: pan-y;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none; }\n  .owl-carousel.owl-grab {\n    cursor: move;\n    cursor: grab; }\n  .owl-carousel.owl-rtl {\n    direction: rtl; }\n  .owl-carousel.owl-rtl .owl-item {\n    float: right; }\n\n/* No Js */\n.no-js .owl-carousel {\n  display: block; }\n\n/*\n *  Owl Carousel - Animate Plugin\n */\n.owl-carousel .animated {\n  animation-duration: 1000ms;\n  animation-fill-mode: both; }\n\n.owl-carousel .owl-animated-in {\n  z-index: 0; }\n\n.owl-carousel .owl-animated-out {\n  z-index: 1; }\n\n.owl-carousel .fadeOut {\n  animation-name: fadeOut; }\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n/*\n * \tOwl Carousel - Auto Height Plugin\n */\n.owl-height {\n  transition: height 500ms ease-in-out; }\n\n/*\n * \tOwl Carousel - Lazy Load Plugin\n */\n.owl-carousel .owl-item {\n  /**\n\t\t\tThis is introduced due to a bug in IE11 where lazy loading combined with autoheight plugin causes a wrong\n\t\t\tcalculation of the height of the owl-item that breaks page layouts\n\t\t */ }\n  .owl-carousel .owl-item .owl-lazy {\n    opacity: 0;\n    transition: opacity 400ms ease; }\n  .owl-carousel .owl-item .owl-lazy[src^=\"\"], .owl-carousel .owl-item .owl-lazy:not([src]) {\n    max-height: 0; }\n  .owl-carousel .owl-item img.owl-lazy {\n    transform-style: preserve-3d; }\n\n/*\n * \tOwl Carousel - Video Plugin\n */\n.owl-carousel .owl-video-wrapper {\n  position: relative;\n  height: 100%;\n  background: #000; }\n\n.owl-carousel .owl-video-play-icon {\n  position: absolute;\n  height: 80px;\n  width: 80px;\n  left: 50%;\n  top: 50%;\n  margin-left: -40px;\n  margin-top: -40px;\n  background: url(\"owl.video.play.png\") no-repeat;\n  cursor: pointer;\n  z-index: 1;\n  -webkit-backface-visibility: hidden;\n  transition: transform 100ms ease; }\n\n.owl-carousel .owl-video-play-icon:hover {\n  -ms-transform: scale(1.3, 1.3);\n      transform: scale(1.3, 1.3); }\n\n.owl-carousel .owl-video-playing .owl-video-tn,\n.owl-carousel .owl-video-playing .owl-video-play-icon {\n  display: none; }\n\n.owl-carousel .owl-video-tn {\n  opacity: 0;\n  height: 100%;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  transition: opacity 400ms ease; }\n\n.owl-carousel .owl-video-frame {\n  position: relative;\n  z-index: 1;\n  height: 100%;\n  width: 100%; }\n","html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5,\nh6, p, blockquote, pre, a, abbr, acronym, address, big,\ncite, code, del, dfn, em, img, ins, kbd, q, s, samp, small,\nstrike, strong, sub, sup, tt, var, b, u, i, center, dl, dt,\ndd, ol, ul, li, fieldset, form, label, legend, table, caption,\ntbody, tfoot, thead, tr, th, td, article, aside, canvas, details,\nembed, figure, figcaption, footer, header, hgroup, menu, nav,\noutput, ruby, section, summary, time, mark, audio, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  vertical-align: baseline;\n}\n\nhtml {\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n}\n\nimg, fieldset, a img {\n  border: none;\n}\n\ninput[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"tel\"],\ntextarea {\n  -webkit-appearance: none;\n}\n\ninput[type=\"submit\"],\nbutton {\n  cursor: pointer;\n  background: none;\n}\n\ninput[type=\"submit\"]::-moz-focus-inner,\nbutton::-moz-focus-inner {\n  padding: 0;\n  border: 0;\n}\n\ntextarea {\n  overflow: auto;\n}\n\ninput {\n  appearance: none;\n}\n\ninput, button {\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\ndiv, input, textarea, select, button,\nh1, h2, h3, h4, h5, h6, a, span, a:focus {\n  outline: none;\n}\n\nselect:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #000;\n}\n\nul, ol {\n  list-style-type: none;\n}\n\ntable {\n  border-spacing: 0;\n  border-collapse: collapse;\n  width: 100%;\n}\n\nhtml {\n  box-sizing: border-box;\n}\n\n*, *:before, *:after {\n  box-sizing: inherit;\n}\n\na {\n  text-decoration: none;\n}\n\na,\nbutton {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.icon-arrow-down-fat {\n  width: 1.33em;\n  height: 1em;\n  fill: #FFF;\n}\n\n.icon-arrow-left {\n  width: 0.6em;\n  height: 1em;\n  fill: #11142D;\n}\n\n.icon-arrow-next-fat {\n  width: 1.3em;\n  height: 1em;\n  fill: #11142d;\n}\n\n.icon-arrow-next {\n  width: 1.2em;\n  height: 1em;\n  fill: #11142D;\n}\n\n.icon-arrow-prev {\n  width: 1.2em;\n  height: 1em;\n  fill: #11142d;\n}\n\n.icon-arrow-right {\n  width: 0.6em;\n  height: 1em;\n  fill: #11142D;\n}\n\n.icon-arrow-up-fat {\n  width: 1.33em;\n  height: 1em;\n  fill: #FFF;\n}\n\n.icon-arrows {\n  width: 0.63em;\n  height: 1em;\n  fill: #11142d;\n}\n\n.icon-bag {\n  width: 0.95em;\n  height: 1em;\n  fill: #1b1d21;\n}\n\n.icon-bell {\n  width: 0.92em;\n  height: 1em;\n  fill: #11142D;\n}\n\n.icon-box {\n  width: 1.13em;\n  height: 1em;\n  fill: #11142D;\n}\n\n.icon-chart {\n  width: 1em;\n  height: 1em;\n  fill: #1b1d21;\n}\n\n.icon-chat {\n  width: 1em;\n  height: 1em;\n  fill: #1b1d21;\n}\n\n.icon-close {\n  width: 1em;\n  height: 1em;\n  fill: #1B1D21;\n}\n\n.icon-comment {\n  width: 1em;\n  height: 1em;\n  fill: #1B1D21;\n}\n\n.icon-discovery {\n  width: 1em;\n  height: 1em;\n  fill: #1b1d21;\n}\n\n.icon-document {\n  width: 0.95em;\n  height: 1em;\n  fill: #1b1d21;\n}\n\n.icon-dots-border {\n  width: 4em;\n  height: 1em;\n  fill: #11142D;\n}\n\n.icon-download-fat {\n  width: 0.94em;\n  height: 1em;\n  fill: #11142d;\n}\n\n.icon-download {\n  width: 0.95em;\n  height: 1em;\n  fill: #7fba7a;\n}\n\n.icon-edit {\n  width: 1em;\n  height: 1em;\n  fill: #11142D;\n}\n\n.icon-editor-bold {\n  width: 0.83em;\n  height: 1em;\n  fill: #fff;\n}\n\n.icon-editor-italic {\n  width: 0.5em;\n  height: 1em;\n  fill: #808191;\n}\n\n.icon-editor-pic {\n  width: 1.08em;\n  height: 1em;\n  fill: #808191;\n}\n\n.icon-editor-smile {\n  width: 1em;\n  height: 1em;\n  fill: #808191;\n}\n\n.icon-folder {\n  width: 1.06em;\n  height: 1em;\n  fill: #11142D;\n}\n\n.icon-like {\n  width: 1em;\n  height: 1em;\n  fill: #fff;\n}\n\n.icon-logout {\n  width: 1em;\n  height: 1em;\n  fill: #1b1d21;\n}\n\n.icon-message {\n  width: 1.11em;\n  height: 1em;\n  fill: #1b1d21;\n}\n\n.icon-moon {\n  width: 1em;\n  height: 1em;\n  fill: #3f8cff;\n}\n\n.icon-more {\n  width: 1em;\n  height: 1em;\n  fill: #1B1D21;\n}\n\n.icon-notification {\n  width: 0.91em;\n  height: 1em;\n  fill: #1b1d21;\n}\n\n.icon-overview {\n  width: 0.95em;\n  height: 1em;\n  fill: #fff;\n}\n\n.icon-plus-square {\n  width: 1em;\n  height: 1em;\n  fill: #FFF;\n}\n\n.icon-print {\n  width: 1em;\n  height: 1em;\n  fill: #11142d;\n}\n\n.icon-profile {\n  width: 0.81em;\n  height: 1em;\n  fill: #1b1d21;\n}\n\n.icon-remove {\n  width: 1em;\n  height: 1em;\n  fill: #11142D;\n}\n\n.icon-search {\n  width: 1em;\n  height: 1em;\n  fill: #11142D;\n}\n\n.icon-settings {\n  width: 0.91em;\n  height: 1em;\n  fill: #1b1d21;\n}\n\n.icon-star {\n  width: 1em;\n  height: 1em;\n  fill: #1B1D21;\n}\n\n.icon-sun {\n  width: 1em;\n  height: 1em;\n  fill: #3f8cff;\n}\n\n.icon-wallet {\n  width: 1.1em;\n  height: 1em;\n  fill: #1b1d21;\n}\n\n/**\n * Owl Carousel v2.3.4\n * Copyright 2013-2018 David Deutsch\n * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE\n */\n/*\n *  Owl Carousel - Core\n */\n.owl-carousel {\n  display: none;\n  width: 100%;\n  -webkit-tap-highlight-color: transparent;\n  /* position relative and z-index fix webkit rendering fonts issue */\n  position: relative;\n  z-index: 1;\n}\n\n.owl-carousel .owl-stage {\n  position: relative;\n  -ms-touch-action: pan-Y;\n  touch-action: manipulation;\n  -moz-backface-visibility: hidden;\n  /* fix firefox animation glitch */\n}\n\n.owl-carousel .owl-stage:after {\n  content: \".\";\n  display: block;\n  clear: both;\n  visibility: hidden;\n  line-height: 0;\n  height: 0;\n}\n\n.owl-carousel .owl-stage-outer {\n  position: relative;\n  overflow: hidden;\n  /* fix for flashing background */\n  -webkit-transform: translate3d(0px, 0px, 0px);\n}\n\n.owl-carousel .owl-wrapper,\n.owl-carousel .owl-item {\n  -webkit-backface-visibility: hidden;\n  -moz-backface-visibility: hidden;\n  -ms-backface-visibility: hidden;\n  -webkit-transform: translate3d(0, 0, 0);\n  -moz-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n}\n\n.owl-carousel .owl-item {\n  position: relative;\n  min-height: 1px;\n  float: left;\n  -webkit-backface-visibility: hidden;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n}\n\n.owl-carousel .owl-item img {\n  display: block;\n  width: 100%;\n}\n\n.owl-carousel .owl-nav.disabled,\n.owl-carousel .owl-dots.disabled {\n  display: none;\n}\n\n.owl-carousel .owl-nav .owl-prev,\n.owl-carousel .owl-nav .owl-next,\n.owl-carousel .owl-dot {\n  cursor: pointer;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.owl-carousel .owl-nav button.owl-prev,\n.owl-carousel .owl-nav button.owl-next,\n.owl-carousel button.owl-dot {\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0 !important;\n  font: inherit;\n}\n\n.owl-carousel.owl-loaded {\n  display: block;\n}\n\n.owl-carousel.owl-loading {\n  opacity: 0;\n  display: block;\n}\n\n.owl-carousel.owl-hidden {\n  opacity: 0;\n}\n\n.owl-carousel.owl-refresh .owl-item {\n  visibility: hidden;\n}\n\n.owl-carousel.owl-drag .owl-item {\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.owl-carousel.owl-grab {\n  cursor: move;\n  cursor: grab;\n}\n\n.owl-carousel.owl-rtl {\n  direction: rtl;\n}\n\n.owl-carousel.owl-rtl .owl-item {\n  float: right;\n}\n\n/* No Js */\n.no-js .owl-carousel {\n  display: block;\n}\n\n/*\n *  Owl Carousel - Animate Plugin\n */\n.owl-carousel .animated {\n  animation-duration: 1000ms;\n  animation-fill-mode: both;\n}\n\n.owl-carousel .owl-animated-in {\n  z-index: 0;\n}\n\n.owl-carousel .owl-animated-out {\n  z-index: 1;\n}\n\n.owl-carousel .fadeOut {\n  animation-name: fadeOut;\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n/*\n * \tOwl Carousel - Auto Height Plugin\n */\n.owl-height {\n  transition: height 500ms ease-in-out;\n}\n\n/*\n * \tOwl Carousel - Lazy Load Plugin\n */\n.owl-carousel .owl-item {\n  /**\n\t\t\tThis is introduced due to a bug in IE11 where lazy loading combined with autoheight plugin causes a wrong\n\t\t\tcalculation of the height of the owl-item that breaks page layouts\n\t\t */\n}\n\n.owl-carousel .owl-item .owl-lazy {\n  opacity: 0;\n  transition: opacity 400ms ease;\n}\n\n.owl-carousel .owl-item .owl-lazy[src^=\"\"], .owl-carousel .owl-item .owl-lazy:not([src]) {\n  max-height: 0;\n}\n\n.owl-carousel .owl-item img.owl-lazy {\n  transform-style: preserve-3d;\n}\n\n/*\n * \tOwl Carousel - Video Plugin\n */\n.owl-carousel .owl-video-wrapper {\n  position: relative;\n  height: 100%;\n  background: #000;\n}\n\n.owl-carousel .owl-video-play-icon {\n  position: absolute;\n  height: 80px;\n  width: 80px;\n  left: 50%;\n  top: 50%;\n  margin-left: -40px;\n  margin-top: -40px;\n  background: url(\"owl.video.play.png\") no-repeat;\n  cursor: pointer;\n  z-index: 1;\n  -webkit-backface-visibility: hidden;\n  transition: transform 100ms ease;\n}\n\n.owl-carousel .owl-video-play-icon:hover {\n  -ms-transform: scale(1.3, 1.3);\n  transform: scale(1.3, 1.3);\n}\n\n.owl-carousel .owl-video-playing .owl-video-tn,\n.owl-carousel .owl-video-playing .owl-video-play-icon {\n  display: none;\n}\n\n.owl-carousel .owl-video-tn {\n  opacity: 0;\n  height: 100%;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  transition: opacity 400ms ease;\n}\n\n.owl-carousel .owl-video-frame {\n  position: relative;\n  z-index: 1;\n  height: 100%;\n  width: 100%;\n}\n\n/* Magnific Popup CSS */\n.mfp-bg {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1042;\n  overflow: hidden;\n  position: fixed;\n  background: #0b0b0b;\n  opacity: 0.8;\n}\n\n.mfp-wrap {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1043;\n  position: fixed;\n  outline: none !important;\n  -webkit-backface-visibility: hidden;\n}\n\n.mfp-container {\n  text-align: center;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  padding: 0 8px;\n  box-sizing: border-box;\n}\n\n.mfp-container:before {\n  content: '';\n  display: inline-block;\n  height: 100%;\n  vertical-align: middle;\n}\n\n.mfp-align-top .mfp-container:before {\n  display: none;\n}\n\n.mfp-content {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0 auto;\n  text-align: left;\n  z-index: 1045;\n}\n\n.mfp-inline-holder .mfp-content,\n.mfp-ajax-holder .mfp-content {\n  width: 100%;\n  cursor: auto;\n}\n\n.mfp-ajax-cur {\n  cursor: progress;\n}\n\n.mfp-zoom-out-cur, .mfp-zoom-out-cur .mfp-image-holder .mfp-close {\n  cursor: -moz-zoom-out;\n  cursor: -webkit-zoom-out;\n  cursor: zoom-out;\n}\n\n.mfp-zoom {\n  cursor: pointer;\n  cursor: -webkit-zoom-in;\n  cursor: -moz-zoom-in;\n  cursor: zoom-in;\n}\n\n.mfp-auto-cursor .mfp-content {\n  cursor: auto;\n}\n\n.mfp-close,\n.mfp-arrow,\n.mfp-preloader,\n.mfp-counter {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n}\n\n.mfp-loading.mfp-figure {\n  display: none;\n}\n\n.mfp-hide {\n  display: none !important;\n}\n\n.mfp-preloader {\n  color: #CCC;\n  position: absolute;\n  top: 50%;\n  width: auto;\n  text-align: center;\n  margin-top: -0.8em;\n  left: 8px;\n  right: 8px;\n  z-index: 1044;\n}\n\n.mfp-preloader a {\n  color: #CCC;\n}\n\n.mfp-preloader a:hover {\n  color: #FFF;\n}\n\n.mfp-s-ready .mfp-preloader {\n  display: none;\n}\n\n.mfp-s-error .mfp-content {\n  display: none;\n}\n\nbutton.mfp-close,\nbutton.mfp-arrow {\n  overflow: visible;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  -webkit-appearance: none;\n  display: block;\n  outline: none;\n  padding: 0;\n  z-index: 1046;\n  box-shadow: none;\n  touch-action: manipulation;\n}\n\nbutton::-moz-focus-inner {\n  padding: 0;\n  border: 0;\n}\n\n.mfp-close {\n  width: 44px;\n  height: 44px;\n  line-height: 44px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  text-decoration: none;\n  text-align: center;\n  opacity: 0.65;\n  padding: 0 0 18px 10px;\n  color: #FFF;\n  font-style: normal;\n  font-size: 28px;\n  font-family: Arial, Baskerville, monospace;\n}\n\n.mfp-close:hover,\n.mfp-close:focus {\n  opacity: 1;\n}\n\n.mfp-close:active {\n  top: 1px;\n}\n\n.mfp-close-btn-in .mfp-close {\n  color: #333;\n}\n\n.mfp-image-holder .mfp-close,\n.mfp-iframe-holder .mfp-close {\n  color: #FFF;\n  right: -6px;\n  text-align: right;\n  padding-right: 6px;\n  width: 100%;\n}\n\n.mfp-counter {\n  position: absolute;\n  top: 0;\n  right: 0;\n  color: #CCC;\n  font-size: 12px;\n  line-height: 18px;\n  white-space: nowrap;\n}\n\n.mfp-arrow {\n  position: absolute;\n  opacity: 0.65;\n  margin: 0;\n  top: 50%;\n  margin-top: -55px;\n  padding: 0;\n  width: 90px;\n  height: 110px;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.mfp-arrow:active {\n  margin-top: -54px;\n}\n\n.mfp-arrow:hover,\n.mfp-arrow:focus {\n  opacity: 1;\n}\n\n.mfp-arrow:before,\n.mfp-arrow:after {\n  content: '';\n  display: block;\n  width: 0;\n  height: 0;\n  position: absolute;\n  left: 0;\n  top: 0;\n  margin-top: 35px;\n  margin-left: 35px;\n  border: medium inset transparent;\n}\n\n.mfp-arrow:after {\n  border-top-width: 13px;\n  border-bottom-width: 13px;\n  top: 8px;\n}\n\n.mfp-arrow:before {\n  border-top-width: 21px;\n  border-bottom-width: 21px;\n  opacity: 0.7;\n}\n\n.mfp-arrow-left {\n  left: 0;\n}\n\n.mfp-arrow-left:after {\n  border-right: 17px solid #FFF;\n  margin-left: 31px;\n}\n\n.mfp-arrow-left:before {\n  margin-left: 25px;\n  border-right: 27px solid #3F3F3F;\n}\n\n.mfp-arrow-right {\n  right: 0;\n}\n\n.mfp-arrow-right:after {\n  border-left: 17px solid #FFF;\n  margin-left: 39px;\n}\n\n.mfp-arrow-right:before {\n  border-left: 27px solid #3F3F3F;\n}\n\n.mfp-iframe-holder {\n  padding-top: 40px;\n  padding-bottom: 40px;\n}\n\n.mfp-iframe-holder .mfp-content {\n  line-height: 0;\n  width: 100%;\n  max-width: 900px;\n}\n\n.mfp-iframe-holder .mfp-close {\n  top: -40px;\n}\n\n.mfp-iframe-scaler {\n  width: 100%;\n  height: 0;\n  overflow: hidden;\n  padding-top: 56.25%;\n}\n\n.mfp-iframe-scaler iframe {\n  position: absolute;\n  display: block;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);\n  background: #000;\n}\n\n/* Main image in popup */\nimg.mfp-img {\n  width: auto;\n  max-width: 100%;\n  height: auto;\n  display: block;\n  line-height: 0;\n  box-sizing: border-box;\n  padding: 40px 0 40px;\n  margin: 0 auto;\n}\n\n/* The shadow behind the image */\n.mfp-figure {\n  line-height: 0;\n}\n\n.mfp-figure:after {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 40px;\n  bottom: 40px;\n  display: block;\n  right: 0;\n  width: auto;\n  height: auto;\n  z-index: -1;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);\n  background: #444;\n}\n\n.mfp-figure small {\n  color: #BDBDBD;\n  display: block;\n  font-size: 12px;\n  line-height: 14px;\n}\n\n.mfp-figure figure {\n  margin: 0;\n}\n\n.mfp-bottom-bar {\n  margin-top: -36px;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  cursor: auto;\n}\n\n.mfp-title {\n  text-align: left;\n  line-height: 18px;\n  color: #F3F3F3;\n  word-wrap: break-word;\n  padding-right: 36px;\n}\n\n.mfp-image-holder .mfp-content {\n  max-width: 100%;\n}\n\n.mfp-gallery .mfp-image-holder .mfp-figure {\n  cursor: pointer;\n}\n\n@media screen and (max-width: 800px) and (orientation: landscape), screen and (max-height: 300px) {\n  /**\n       * Remove all paddings around the image on small screen\n       */\n  .mfp-img-mobile .mfp-image-holder {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .mfp-img-mobile img.mfp-img {\n    padding: 0;\n  }\n  .mfp-img-mobile .mfp-figure:after {\n    top: 0;\n    bottom: 0;\n  }\n  .mfp-img-mobile .mfp-figure small {\n    display: inline;\n    margin-left: 5px;\n  }\n  .mfp-img-mobile .mfp-bottom-bar {\n    background: rgba(0, 0, 0, 0.6);\n    bottom: 0;\n    margin: 0;\n    top: auto;\n    padding: 3px 5px;\n    position: fixed;\n    box-sizing: border-box;\n  }\n  .mfp-img-mobile .mfp-bottom-bar:empty {\n    padding: 0;\n  }\n  .mfp-img-mobile .mfp-counter {\n    right: 5px;\n    top: 3px;\n  }\n  .mfp-img-mobile .mfp-close {\n    top: 0;\n    right: 0;\n    width: 35px;\n    height: 35px;\n    line-height: 35px;\n    background: rgba(0, 0, 0, 0.6);\n    position: fixed;\n    text-align: center;\n    padding: 0;\n  }\n}\n\n@media all and (max-width: 900px) {\n  .mfp-arrow {\n    -webkit-transform: scale(0.75);\n    transform: scale(0.75);\n  }\n  .mfp-arrow-left {\n    -webkit-transform-origin: 0;\n    transform-origin: 0;\n  }\n  .mfp-arrow-right {\n    -webkit-transform-origin: 100%;\n    transform-origin: 100%;\n  }\n  .mfp-container {\n    padding-left: 6px;\n    padding-right: 6px;\n  }\n}\n\nbody {\n  min-width: 375px;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  line-height: 1.71429;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #11142D;\n}\n\nbody.dark {\n  background: #242731;\n  color: #ffffff;\n}\n\nbody.no-scroll {\n  overflow: hidden;\n}\n\nbutton,\ninput,\ntextarea,\nselect {\n  font-family: 'Inter', sans-serif;\n}\n\nimg {\n  display: block;\n  max-width: 100%;\n}\n\nbody.dark .apexcharts-tooltip.apexcharts-theme-light {\n  color: #11142D;\n}\n\nbody.dark .apexcharts-gridlines-horizontal line {\n  stroke: rgba(228, 228, 228, 0.1);\n}\n\n.page {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n@media only screen and (max-width: 1023px) {\n  .page {\n    overflow: hidden;\n  }\n}\n\n.page__wrapper {\n  flex-grow: 1;\n  padding-left: 256px;\n  transition: all .25s;\n}\n\n@media only screen and (max-width: 1023px) {\n  .page__wrapper {\n    padding-left: 96px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .page__wrapper {\n    padding-left: 0;\n  }\n}\n\n.page__center {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__center {\n    width: 100%;\n    max-width: 930px;\n    padding: 0 70px 40px;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .page__center {\n    padding: 0 32px 40px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .page__center {\n    padding: 0 16px 32px;\n  }\n}\n\n.page__row {\n  display: flex;\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__row {\n    display: block;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__row_head {\n    display: flex;\n    margin: 0 -16px;\n    padding: 40px 0;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .page__row_head {\n    flex-direction: column-reverse;\n    margin: 0;\n    padding: 25px 0;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .page__row_head {\n    padding: 0;\n  }\n}\n\n.page__row_head .page__col {\n  padding-top: 48px;\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__row_head .page__col {\n    flex: 0 0 calc(50% - 32px);\n    max-width: calc(50% - 32px);\n    margin: 0 16px;\n    padding: 0;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .page__row_head .page__col {\n    max-width: 100%;\n    margin: 0;\n  }\n  .page__row_head .page__col:nth-child(2) {\n    margin-bottom: 30px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .page__row_head .page__col:first-child {\n    padding: 16px 16px 28px;\n  }\n  .page__row_head .page__col:nth-child(2) {\n    margin: 0;\n  }\n}\n\n.page__row_border .page__col:nth-child(2) {\n  border-left: 1px solid #E4E4E4;\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__row_border .page__col:nth-child(2) {\n    border: none;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__row_responsive {\n    display: flex;\n    margin: 0 -40px;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .page__row_responsive {\n    display: block;\n    margin: 0;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__row_responsive.page__row_head {\n    padding: 0;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .page__row_responsive.page__row_head {\n    display: flex;\n    margin: 0 -16px;\n    padding: 40px 0;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .page__row_responsive.page__row_head {\n    margin: 0;\n    padding: 25px 0;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .page__row_responsive.page__row_head {\n    padding: 0;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__row_responsive.page__row_head .page__col {\n    padding-top: 40px;\n    padding-bottom: 40px;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .page__row_responsive.page__row_head .page__col {\n    flex: 0 0 calc(50% - 32px);\n    max-width: calc(50% - 32px);\n    margin: 0 16px;\n    padding: 0;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .page__row_responsive.page__row_head .page__col {\n    flex: 0 0 100%;\n    max-width: 100%;\n    width: 100%;\n    margin: auto;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .page__row_responsive.page__row_head .page__col:nth-child(2) {\n    margin-bottom: 30px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .page__row_responsive.page__row_head .page__col:nth-child(2) {\n    margin-bottom: 0;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__row_responsive .page__col {\n    margin: 0;\n    padding-left: 40px;\n    padding-right: 40px;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .page__row_responsive .page__col {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__row_responsive .page__col:first-child {\n    flex: 0 0 55%;\n    max-width: 55%;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .page__row_responsive .page__col:first-child {\n    max-width: 100%;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__row_responsive .page__col:nth-child(2) {\n    flex: 0 0 45%;\n    max-width: 45%;\n    border-left: 1px solid #E4E4E4;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .page__row_responsive .page__col:nth-child(2) {\n    max-width: 100%;\n    border: none;\n  }\n}\n\n.page__col {\n  padding: 0 64px 44px;\n}\n\n@media only screen and (max-width: 1419px) {\n  .page__col {\n    padding: 0 48px 44px;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__col {\n    padding: 0;\n  }\n}\n\n.page__col:first-child {\n  flex: 0 0 calc(100% - 426px);\n  max-width: calc(100% - 426px);\n}\n\n@media only screen and (max-width: 1419px) {\n  .page__col:first-child {\n    flex: 0 0 calc(100% - 390px);\n    max-width: calc(100% - 390px);\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__col:first-child {\n    max-width: 100%;\n  }\n}\n\n.page__col:nth-child(2) {\n  flex-shrink: 0;\n  width: 426px;\n}\n\n@media only screen and (max-width: 1419px) {\n  .page__col:nth-child(2) {\n    width: 390px;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__col:nth-child(2) {\n    width: 100%;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__row:not(.page__row_head):not(.page__row_responsive) .page__col:nth-child(2) {\n    margin-top: 32px;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .page__row:not(.page__row_head) .page__col:nth-child(2) {\n    margin-top: 32px;\n  }\n}\n\n.page .page__col.page__col_w50 {\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n@media only screen and (max-width: 1339px) {\n  .page .page__col.page__col_w50 {\n    flex: 0 0 50%;\n    max-width: 50%;\n    margin: 0;\n    padding-left: 40px;\n    padding-right: 40px;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .page .page__col.page__col_w50 {\n    padding: 0;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .page .page__col.page__col_w50:first-child {\n    max-width: 100%;\n    margin-bottom: 30px;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .page .page__col.page__col_w50:nth-child(2) {\n    max-width: 100%;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .page .page__col.page__col_w50:not(:last-child) {\n    margin-bottom: 0;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .page__row:not(.page__row_head) .page__col.page__col_w50:not(:last-child) {\n    margin-bottom: 32px;\n  }\n}\n\n.page__widgets {\n  display: flex;\n  margin: 0 -16px;\n}\n\n@media only screen and (max-width: 767px) {\n  .page__widgets {\n    display: block;\n    margin: 0;\n  }\n}\n\n.page__widgets:not(:last-child) {\n  margin-bottom: 43px;\n}\n\n@media only screen and (max-width: 767px) {\n  .page__widgets:not(:last-child) {\n    margin-bottom: 32px;\n  }\n}\n\n.page__widgets .widget {\n  flex: 0 0 calc(50% - 32px);\n  width: calc(50% - 32px);\n  margin: 0 16px;\n}\n\n@media only screen and (max-width: 767px) {\n  .page__widgets .widget {\n    width: 100%;\n    margin: 0;\n  }\n  .page__widgets .widget:not(:last-child) {\n    margin-bottom: 32px;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__group {\n    display: flex;\n    align-items: flex-start;\n    margin: 0 -16px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .page__group {\n    display: block;\n    margin: 0;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__group .widget {\n    flex: 0 0 calc(50% - 32px);\n    max-width: calc(50% - 32px);\n    margin: 0 16px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .page__group .widget {\n    max-width: 100%;\n    margin: 0;\n  }\n}\n\n.page__group .widget:not(:last-child) {\n  margin-bottom: 69px;\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__group .widget:not(:last-child) {\n    margin-bottom: 0;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .page__group .widget:not(:last-child) {\n    margin-bottom: 32px;\n  }\n}\n\n.page__content {\n  padding: 0 64px 64px;\n}\n\n@media only screen and (max-width: 1419px) {\n  .page__content {\n    padding: 0 48px 48px;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__content {\n    padding: 0 0 40px;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .page__content {\n    padding: 0;\n  }\n}\n\n.page__content_pt64 {\n  padding-top: 64px;\n  border-top: 1px solid #E4E4E4;\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__content_pt64 {\n    margin-top: 32px;\n    padding: 0;\n    border: none;\n  }\n}\n\n.page__stat {\n  position: relative;\n  padding: 50px 32px 40px;\n  border-radius: 24px;\n  background: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  .page__stat {\n    padding: 32px 0;\n  }\n}\n\n.page__stat:before {\n  content: \"\";\n  position: absolute;\n  top: 43px;\n  left: 32px;\n  right: 32px;\n  bottom: -43px;\n  z-index: -1;\n  background: #E3E6EC;\n  opacity: 0.91;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  .page__stat:before {\n    filter: blur(46.985px);\n  }\n}\n\n.page__stat_pt32 {\n  padding-top: 32px;\n}\n\n.page__stat_sm .sorting {\n  position: absolute;\n  top: 32px;\n  right: 40px;\n}\n\n@media only screen and (max-width: 767px) {\n  .page__stat_sm .sorting {\n    position: relative;\n    top: auto;\n    right: auto;\n  }\n}\n\n.page__flex {\n  display: flex;\n}\n\n@media only screen and (max-width: 1179px) {\n  .page__flex {\n    display: block;\n  }\n}\n\n.page__flex .widget:first-child {\n  flex-shrink: 0;\n  width: 298px;\n  margin-right: 32px;\n}\n\n@media only screen and (max-width: 1179px) {\n  .page__flex .widget:first-child {\n    width: 100%;\n    margin: 0 0 32px;\n  }\n}\n\n.page__flex .widget:nth-child(2) {\n  flex-grow: 1;\n}\n\n@media only screen and (max-width: 1179px) {\n  .page__welcome_sm {\n    font-size: 32px;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .page__hello {\n    font-size: 18px;\n    line-height: 1.33333;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .page__hello {\n    font-size: 16px;\n  }\n}\n\n.page__title {\n  margin-bottom: 32px;\n}\n\n@media only screen and (max-width: 767px) {\n  .page__title {\n    padding: 0 24px;\n  }\n}\n\n.page__nav {\n  display: flex;\n  margin-bottom: 48px;\n}\n\n@media only screen and (max-width: 1179px) {\n  .page__nav {\n    margin-bottom: 32px;\n  }\n}\n\n.page__nav .page__link {\n  padding: 7px 18px;\n  border-radius: 12px;\n  font-weight: 600;\n  color: #808191;\n  transition: all .25s;\n}\n\n.page__nav .page__link:hover, .page__nav .page__link.active {\n  background: #6C5DD3;\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 1179px) {\n  .page.toggle .page__wrapper {\n    padding-left: 96px;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .page.toggle .page__wrapper {\n    transform: translateX(160px);\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .page.toggle .page__wrapper {\n    padding-left: 0;\n    transform: translateX(256px);\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .page_other {\n    overflow: hidden;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .page_other .page__center {\n    padding-bottom: 0;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .page_other .page__center {\n    padding-bottom: 40px;\n  }\n}\n\nbody.dark .page__row_border .page__col:nth-child(2) {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .page__stat {\n  background: #242731;\n}\n\nbody.dark .page__stat:before {\n  background: #000;\n  opacity: 0.51;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .page__stat:before {\n    filter: blur(46.985px);\n  }\n}\n\nbody.dark .page__content_pt64 {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  flex-shrink: 0;\n  width: 256px;\n  height: 100vh;\n  padding: 140px 0 72px;\n  background: #ffffff;\n  border-right: 1px solid #E4E4E4;\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar {\n    padding-top: 96px;\n    overflow: hidden;\n    transition: width .25s, transform .25s;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar {\n    z-index: 10;\n    width: 96px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar {\n    width: 256px;\n    transform: translateX(-100%);\n  }\n}\n\n.sidebar__wrapper {\n  max-height: 100%;\n  padding: 0 20px 30px;\n  overflow-y: auto;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar__wrapper {\n    padding: 20px;\n  }\n}\n\n.sidebar__wrapper::-webkit-scrollbar {\n  display: none;\n}\n\n.sidebar__inner {\n  width: 215px;\n  overflow: hidden;\n  transition: width .25s;\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar__inner {\n    width: 56px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar__inner {\n    width: 100%;\n  }\n}\n\n.sidebar__top {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 140px;\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar__top {\n    justify-content: stretch;\n    height: 96px;\n    padding-left: 40px;\n    transition: all .25s;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar__top {\n    padding: 0;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar__top {\n    padding-left: 40px;\n    border-bottom: 1px solid #E4E4E4;\n  }\n}\n\n.sidebar__logo {\n  font-size: 0;\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar__top .sidebar__logo {\n    transition: opacity .2s;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar__top .sidebar__logo {\n    opacity: 0;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar__top .sidebar__logo {\n    opacity: 1;\n  }\n}\n\n.sidebar__logo .sidebar__pic {\n  width: 176px;\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar__logo .sidebar__pic {\n    width: 140px;\n  }\n}\n\n.sidebar__logo .sidebar__pic_white {\n  display: none;\n}\n\n.sidebar__close {\n  position: relative;\n  top: -3px;\n  display: none;\n  margin-right: 25px;\n  font-size: 0;\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar__close {\n    display: inline-block;\n  }\n}\n\n.sidebar__close .icon {\n  font-size: 20px;\n  fill: #11142D;\n}\n\n.sidebar__wrapper .sidebar__logo {\n  display: none;\n  justify-content: center;\n  align-items: center;\n  height: 0;\n  overflow: hidden;\n  margin: 0 -20px;\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar__wrapper .sidebar__logo {\n    display: flex;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar__wrapper .sidebar__logo {\n    height: 80px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar__wrapper .sidebar__logo {\n    display: none;\n  }\n}\n\n.sidebar__burger {\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: none;\n  width: 96px;\n  height: 96px;\n  padding: 20px;\n  border-bottom: 1px solid transparent;\n  font-size: 0;\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar__burger {\n    display: inline-block;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar__burger {\n    border-color: #E4E4E4;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar__burger {\n    display: none;\n  }\n}\n\n.sidebar__burger:before, .sidebar__burger:after {\n  content: \"\";\n  display: inline-block;\n  width: 32px;\n  height: 2px;\n  margin: 3px auto;\n  border-radius: 1px;\n  background: #1B1D21;\n}\n\n.sidebar__list {\n  margin-bottom: 20px;\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar__list {\n    margin: 0;\n  }\n}\n\n.sidebar__group:not(:last-child) {\n  position: relative;\n  margin-bottom: 40px;\n  padding-bottom: 30px;\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar__group:not(:last-child) {\n    margin-bottom: 20px;\n    padding-bottom: 15px;\n  }\n}\n\n.sidebar__group:not(:last-child):before {\n  content: \"\";\n  position: absolute;\n  left: 20px;\n  right: 20px;\n  bottom: 0;\n  height: 1px;\n  background: #F0F3F6;\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar__group:not(:last-child):before {\n    transition: all .25s;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar__group:not(:last-child):before {\n    left: -20px;\n    right: -20px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar__group:not(:last-child):before {\n    left: 20px;\n    right: 20px;\n  }\n}\n\n.sidebar__caption {\n  margin-bottom: 16px;\n  padding-left: 20px;\n  color: #808191;\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar__caption {\n    white-space: nowrap;\n    transition: padding .25s;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar__caption {\n    padding-left: 0;\n    text-align: center;\n  }\n  .sidebar__caption span {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar__caption {\n    padding-left: 20px;\n    text-align: left;\n  }\n  .sidebar__caption span {\n    display: inline;\n  }\n}\n\n.sidebar__item {\n  display: flex;\n  align-items: center;\n  height: 56px;\n  padding: 0 20px;\n  border-radius: 12px;\n  background: transparent;\n  font-size: 14px;\n  font-weight: 600;\n  color: #808191;\n  transition: color .25s;\n  transition: all .25s;\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar__item {\n    position: relative;\n    padding-left: 3px;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar__item {\n    padding-left: 0;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar__item {\n    padding-left: 3px;\n  }\n}\n\n.sidebar__item:hover {\n  color: #6C5DD3;\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar__item:hover {\n    color: #808191;\n  }\n}\n\n.sidebar__item.active {\n  background: #6C5DD3;\n  color: #ffffff;\n}\n\n.sidebar__icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  margin-right: 16px;\n  font-size: 0;\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar__icon {\n    width: 56px;\n    height: 56px;\n    margin-right: 0;\n    transition: margin .25s;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar__icon {\n    margin-right: 21px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar__icon {\n    margin-right: 0;\n  }\n}\n\n.sidebar__icon .icon {\n  font-size: 21px;\n  fill: #1B1D21;\n  opacity: 0.4;\n  transition: all .25s;\n}\n\n.sidebar__icon .icon-message {\n  font-size: 19px;\n}\n\n.sidebar__item:hover .icon {\n  fill: #6C5DD3;\n  opacity: 1;\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar__item:hover .icon {\n    fill: #1B1D21;\n    opacity: .4;\n  }\n}\n\n.sidebar__item.active .icon {\n  opacity: 1;\n  fill: #ffffff;\n}\n\n.sidebar__item .sidebar__text {\n  margin-right: auto;\n}\n\n.sidebar__counter {\n  flex-shrink: 0;\n  min-width: 24px;\n  margin-left: 10px;\n  padding: 0 3px;\n  border-radius: 12px;\n  background: #FF754C;\n  text-align: center;\n  font-size: 12px;\n  line-height: 24px;\n  font-weight: 500;\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar__counter {\n    transition: all .25s;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar__counter {\n    position: absolute;\n    top: 15px;\n    left: 22px;\n    min-width: 10px;\n    height: 10px;\n    font-size: 0;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar__counter {\n    position: static;\n    min-width: 24px;\n    height: 24px;\n    font-size: 12px;\n  }\n}\n\n.sidebar__profile {\n  margin-top: 25px;\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar__profile {\n    margin-top: 20px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar__profile {\n    display: none;\n  }\n}\n\n.sidebar__details {\n  position: relative;\n  display: none;\n  padding: 20px 10px 33px;\n  margin-bottom: -15px;\n  background: #F7F7F7;\n  border-radius: 12px;\n  transition: padding .25s, background .25s;\n}\n\n@media only screen and (max-width: 1339px) {\n  .sidebar__details {\n    padding: 10px 10px 25px;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar__details {\n    padding: 5px 0 17px;\n    background: none;\n  }\n}\n\n.sidebar__details:before {\n  content: \"\";\n  position: absolute;\n  top: 8px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 72px;\n  height: 4px;\n  border-radius: 2px;\n  background: #E4E4E4;\n}\n\n@media only screen and (max-width: 1339px) {\n  .sidebar__details:before {\n    display: none;\n  }\n}\n\n.sidebar__link {\n  display: flex;\n  align-items: center;\n  height: 56px;\n  border-radius: 12px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #808191;\n  transition: all .25s;\n}\n\n.sidebar__link:hover {\n  background: #ffffff;\n  box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.04);\n}\n\n.sidebar__link .sidebar__icon {\n  width: 50px;\n  margin: 0;\n  padding-right: 6px;\n  text-align: center;\n  transition: all .25s;\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar__link .sidebar__icon {\n    width: 56px;\n    margin-right: 24px;\n    padding: 0;\n  }\n}\n\n.sidebar__img {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 50px;\n  height: 56px;\n  padding-right: 5px;\n}\n\n.sidebar__img .icon {\n  font-size: 19px;\n}\n\n.sidebar__user {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n  height: 62px;\n  border-radius: 12px;\n  color: #11142D;\n  cursor: pointer;\n  transition: background .25s;\n}\n\n.sidebar__user:hover, .sidebar__user.active {\n  background: #3F8CFF;\n  color: #ffffff;\n}\n\n.sidebar__user:hover .sidebar__status, .sidebar__user.active .sidebar__status {\n  color: #ffffff;\n}\n\n.sidebar__user:hover .icon, .sidebar__user.active .icon {\n  fill: #ffffff;\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar__user {\n    transition: all .25s;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar__user {\n    padding-left: 8px;\n  }\n}\n\n.sidebar__ava {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  font-size: 0;\n}\n\n.sidebar__ava .sidebar__pic {\n  width: 100%;\n  min-height: 100%;\n  border-radius: 50%;\n}\n\n.sidebar__arrow {\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 24px;\n  height: 24px;\n  font-size: 0;\n}\n\n.sidebar__arrow .icon {\n  font-size: 16px;\n  fill: #11142D;\n}\n\n.sidebar__desc {\n  flex: 0 0 calc(100% - 64px);\n  width: calc(100% - 64px);\n  padding: 0 5px 0 16px;\n}\n\n.sidebar__man {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 14px;\n  line-height: 1.42857;\n  font-weight: 600;\n}\n\n.sidebar__status {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #808191;\n}\n\n.sidebar__bottom {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  height: 72px;\n  padding: 0 40px;\n  box-shadow: inset 0px 1px 0px rgba(0, 0, 0, 0.05);\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar__bottom {\n    transition: padding .25s;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar__bottom {\n    padding: 0 35px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar__bottom {\n    padding: 0 40px;\n  }\n}\n\n.sidebar .switch {\n  margin-right: auto;\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar .switch_theme .switch__in {\n    padding-left: 60px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar .switch_theme .switch__in {\n    padding-left: 56px;\n  }\n}\n\n.sidebar__banner {\n  position: relative;\n  margin-top: 50px;\n  padding: 8px 8px 20px;\n  border-radius: 16px;\n  background: #CFC8FF;\n  text-align: center;\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar__banner {\n    display: none;\n  }\n}\n\n.sidebar__banner:before {\n  content: \"\";\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  right: 8px;\n  bottom: -8px;\n  z-index: -1;\n  border-radius: 12px;\n  background: rgba(207, 200, 255, 0.5);\n}\n\n.sidebar__banner:not(:last-child) {\n  margin-bottom: 40px;\n}\n\n.sidebar__preview {\n  margin-bottom: 6px;\n  font-size: 0;\n}\n\n.sidebar__banner .sidebar__btn {\n  min-width: 171px;\n  color: #5F75EE;\n}\n\n.sidebar__banner .sidebar__btn:hover {\n  color: #6C5DD3;\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar.active {\n    width: 96px;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar.active {\n    width: 256px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar.active {\n    transform: translateX(0);\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar.active .sidebar__inner {\n    width: 56px;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar.active .sidebar__inner {\n    width: 100%;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar.active .sidebar__burger {\n    border-color: #E4E4E4;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar.active .sidebar__burger {\n    border-color: transparent;\n  }\n}\n\n.sidebar.active .sidebar__top {\n  padding: 0;\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar.active .sidebar__top {\n    padding-left: 40px;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar.active .sidebar__top .sidebar__logo {\n    opacity: 0;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar.active .sidebar__top .sidebar__logo {\n    opacity: 1;\n  }\n}\n\n.sidebar.active .sidebar__icon {\n  margin-right: 21px;\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar.active .sidebar__icon {\n    margin-right: 0;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar.active .sidebar__caption {\n    padding: 0;\n    text-align: center;\n  }\n  .sidebar.active .sidebar__caption span {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar.active .sidebar__caption {\n    padding: 0 20px;\n    text-align: left;\n  }\n  .sidebar.active .sidebar__caption span {\n    display: inline;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar.active .sidebar__caption {\n    padding-left: 15px;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar.active .sidebar__group:before {\n    left: -20px;\n    right: -20px;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar.active .sidebar__group:before {\n    left: 20px;\n    right: 20px;\n  }\n}\n\n.sidebar.active .sidebar__wrapper .sidebar__logo {\n  height: 80px;\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar.active .sidebar__wrapper .sidebar__logo {\n    height: 0;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar.active .sidebar__item {\n    padding-left: 0;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar.active .sidebar__item {\n    padding-left: 3px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sidebar.active .sidebar__item {\n    padding-left: 0;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar.active .sidebar__counter {\n    position: absolute;\n    top: 15px;\n    left: 22px;\n    min-width: 10px;\n    height: 10px;\n    font-size: 0;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar.active .sidebar__counter {\n    position: static;\n    min-width: 24px;\n    height: 24px;\n    font-size: 12px;\n  }\n}\n\n.sidebar.active .sidebar__details {\n  padding: 5px 0 17px;\n  background: none;\n}\n\n.sidebar.active .sidebar__link .sidebar__icon {\n  width: 56px;\n  padding: 0;\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar.active .sidebar__user {\n    padding-left: 8px;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar.active .sidebar__user {\n    padding: 0 20px;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .sidebar.active .sidebar__bottom {\n    padding: 0 35px;\n  }\n  .sidebar.active .sidebar__bottom .switch_theme .switch__in {\n    padding-left: 60px;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .sidebar.active .sidebar__bottom {\n    padding: 0 40px;\n  }\n  .sidebar.active .sidebar__bottom .switch_theme .switch__in {\n    padding-left: 56px;\n  }\n}\n\nbody.dark .sidebar {\n  background: #242731;\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .sidebar__pic_black {\n  display: none;\n}\n\nbody.dark .sidebar__pic_white {\n  display: inline-block;\n}\n\nbody.dark .sidebar__icon .icon {\n  fill: #ffffff;\n}\n\nbody.dark .sidebar__item:hover {\n  color: #ffffff;\n}\n\nbody.dark .sidebar__group:before {\n  background: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .sidebar__details {\n  background: rgba(228, 228, 228, 0.04);\n}\n\nbody.dark .sidebar__details:before {\n  background: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .sidebar__link:hover {\n  background: rgba(228, 228, 228, 0.04);\n  color: #ffffff;\n}\n\nbody.dark .sidebar__link:hover .icon {\n  fill: #ffffff;\n  opacity: 1;\n}\n\nbody.dark .sidebar__man {\n  color: #ffffff;\n}\n\nbody.dark .sidebar__arrow .icon {\n  fill: #ffffff;\n}\n\nbody.dark .sidebar__bottom {\n  box-shadow: inset 0px 1px 0px rgba(228, 228, 228, 0.1);\n}\n\n@media only screen and (max-width: 1023px) {\n  body.dark .sidebar__burger {\n    border-color: rgba(228, 228, 228, 0.1);\n  }\n}\n\nbody.dark .sidebar__burger:before, body.dark .sidebar__burger:after {\n  background: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .sidebar__top {\n    border-color: rgba(228, 228, 228, 0.1);\n  }\n}\n\nbody.dark .sidebar__close .icon {\n  fill: #ffffff;\n}\n\nbody.dark .sidebar__btn.btn_white {\n  background: #6C5DD3;\n  color: #ffffff;\n}\n\nbody.dark .sidebar__btn.btn_white:hover {\n  background: #1B1D21;\n}\n\nbody.dark .sidebar.active .sidebar__burger {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\n@media only screen and (max-width: 1023px) {\n  body.dark .sidebar.active .sidebar__burger {\n    border-color: transparent;\n  }\n}\n\n.switch {\n  display: inline-block;\n  position: relative;\n  user-select: none;\n  cursor: pointer;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  font-size: 0;\n  transition: opacity .25s;\n}\n\n.switch__input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n\n.switch__in {\n  display: inline-block;\n}\n\n.switch__box {\n  position: relative;\n  display: block;\n  width: 64px;\n  height: 24px;\n  background: rgba(228, 228, 228, 0.5);\n  border-radius: 16px;\n  transition: all .25s;\n}\n\n.switch__box:before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 2px;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 4px solid #ffffff;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);\n  background: #3F8CFF;\n  transition: all .25s;\n}\n\n.switch__icon {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  font-size: 0;\n}\n\n.switch__icon .icon {\n  font-size: 24px;\n  fill: #3F8CFF;\n}\n\n.switch__icon .icon-moon {\n  display: none;\n}\n\n.switch__input:checked + .switch__flex .switch__box:before {\n  transform: translate(24px, -50%);\n}\n\n.switch_theme .switch__in {\n  padding-left: 56px;\n}\n\n@media (hover: hover) {\n  .switch:hover {\n    opacity: .8;\n  }\n}\n\nbody.dark .switch_theme .switch__input + .switch__in .switch__box {\n  background: #12141B;\n}\n\nbody.dark .switch_theme .switch__input + .switch__in .switch__box:before {\n  width: 4px;\n  height: 16px;\n  border-width: 2px;\n  border-radius: 2px;\n  transform: translate(48px, -50%);\n  border-color: #3F8CFF;\n}\n\nbody.dark .switch_theme .switch__input + .switch__in .icon-moon {\n  display: inline-block;\n}\n\nbody.dark .switch_theme .switch__input + .switch__in .icon-sun {\n  display: none;\n}\n\n.slider {\n  margin-bottom: 56px;\n}\n\n@media only screen and (max-width: 767px) {\n  .slider {\n    margin-bottom: 48px;\n  }\n}\n\n.slider__container {\n  position: relative;\n  background: #6C5DD3;\n  border-radius: 24px;\n}\n\n.slider__container:before, .slider__container:after {\n  content: \"\";\n  position: absolute;\n  background: #CFC8FF;\n  border-radius: 24px;\n}\n\n.slider__container:before {\n  top: 8px;\n  left: 8px;\n  right: 8px;\n  bottom: -8px;\n  z-index: -1;\n}\n\n.slider__container:after {\n  top: 16px;\n  left: 20px;\n  right: 20px;\n  bottom: -16px;\n  z-index: -2;\n}\n\n.slider__item {\n  display: flex;\n  padding: 42px 0 56px 32px;\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  .slider__item {\n    flex-direction: column-reverse;\n    padding: 0 32px 54px;\n    text-align: center;\n  }\n}\n\n.slider__details {\n  flex-shrink: 0;\n  width: 185px;\n  padding-top: 13px;\n}\n\n@media only screen and (max-width: 767px) {\n  .slider__details {\n    width: 100%;\n    padding: 0;\n  }\n}\n\n.slider__preview {\n  margin: 0 auto;\n  font-size: 0;\n}\n\n@media only screen and (max-width: 767px) {\n  .slider__preview {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 282px;\n    height: 282px;\n    padding: 20px;\n  }\n}\n\n.slider__pic {\n  max-width: 214px;\n  max-height: 214px;\n}\n\n.slider__title {\n  margin-bottom: 14px;\n}\n\n.slider__text {\n  margin-bottom: 14px;\n}\n\n@media only screen and (max-width: 767px) {\n  .slider__text {\n    margin-bottom: 24px;\n  }\n}\n\n.slider__close {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 2;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #ffffff;\n  font-size: 0;\n}\n\n.slider__close .icon {\n  font-size: 12px;\n  transition: transform .25s;\n}\n\n.slider__close:hover .icon {\n  transform: rotate(90deg);\n}\n\n.slider .owl-dots {\n  position: absolute;\n  left: 217px;\n  right: 0;\n  bottom: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@media only screen and (max-width: 767px) {\n  .slider .owl-dots {\n    left: 0;\n    right: 0;\n    bottom: 24px;\n  }\n}\n\n.slider .owl-carousel button.owl-dot {\n  position: relative;\n  width: 12px;\n  height: 12px;\n}\n\n.slider .owl-carousel button.owl-dot:before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 4px;\n  height: 4px;\n  background: #ffffff;\n  border-radius: 50%;\n  transition: all .25s;\n}\n\n.slider .owl-carousel button.owl-dot:hover:before, .slider .owl-carousel button.owl-dot.active:before {\n  box-shadow: 0 0 0 2px #A0D7E7;\n}\n\n.slider .owl-carousel button.owl-dot:not(:last-child) {\n  margin-right: 10px;\n}\n\nbody.dark .slider__close {\n  background: #242731;\n  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.3);\n}\n\nbody.dark .slider__close .icon {\n  fill: #ffffff;\n}\n\n.btn {\n  min-width: 166px;\n  height: 56px;\n  padding: 0 20px;\n  border-radius: 16px/16px;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  line-height: 1.42857;\n  font-weight: 700;\n  transition: all .25s;\n}\n\n.btn .icon, .btn__text {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.btn .icon {\n  position: relative;\n  top: -2px;\n  font-size: 20px;\n}\n\n.btn .icon:not(:last-child) {\n  margin-right: 10px;\n}\n\n.btn_white {\n  background: #ffffff;\n  color: #1B1D21;\n}\n\n.btn_white:hover {\n  color: #6C5DD3;\n}\n\n.btn_purple {\n  background: #6C5DD3;\n  color: #ffffff;\n}\n\n.btn_purple:hover {\n  background: #5a49ce;\n}\n\n.btn_blue {\n  background: #3F8CFF;\n  color: #ffffff;\n}\n\n.btn_blue:hover {\n  background: #1b77ff;\n}\n\n.btn_blue-dark {\n  background: #0049C6;\n  color: #ffffff;\n}\n\n.btn_blue-dark:hover {\n  background: #0056ea;\n}\n\n.btn_black {\n  background: #1B1D21;\n  color: #ffffff;\n}\n\n.btn_black .icon {\n  fill: #ffffff;\n}\n\n.btn_black:hover {\n  background: #6C5DD3;\n}\n\n.btn_gray {\n  background: #E4E4E4;\n  color: #11142D;\n}\n\n.btn_gray:hover {\n  background: rgba(228, 228, 228, 0.5);\n}\n\n.btn_wide {\n  min-width: 100%;\n}\n\n.btn[href] {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n\nbody.dark .btn_white {\n  background: #242731;\n  color: #ffffff;\n}\n\nbody.dark .btn_white:hover {\n  background: #1B1D21;\n}\n\nbody.dark .btn_gray {\n  background: rgba(228, 228, 228, 0.1);\n  color: #ffffff;\n}\n\nbody.dark .btn_gray:hover {\n  opacity: .8;\n}\n\n.widget {\n  padding: 32px;\n  border-radius: 24px;\n  background: #ffffff;\n}\n\n.widget__head {\n  display: flex;\n  align-items: center;\n  height: 88px;\n  padding: 0 32px;\n}\n\n.widget > .widget__title {\n  margin-bottom: 32px;\n}\n\n.widget__title {\n  font-family: 'Poppins', sans-serif;\n  font-size: 18px;\n  line-height: 1.33333;\n}\n\n.widget__top {\n  display: flex;\n  align-items: center;\n  margin-bottom: 32px;\n}\n\n.widget__next {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 24px;\n  height: 24px;\n  font-size: 0;\n}\n\n.widget__next .icon {\n  font-size: 10px;\n  fill: #11142D;\n  transition: fill .25s;\n}\n\n.widget__next:hover .icon {\n  fill: #6C5DD3;\n}\n\n.widget__item {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.widget__item:before {\n  content: \"\";\n  position: absolute;\n  top: -12px;\n  left: -12px;\n  right: -12px;\n  bottom: -12px;\n  border-radius: 16px;\n  background: #6C5DD3;\n  opacity: 0;\n  transition: opacity .25s;\n}\n\n.widget__item:hover:before {\n  opacity: 1;\n}\n\n.widget__item:not(:last-child) {\n  margin-bottom: 40px;\n}\n\n.widget__preview {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 56px;\n  height: 56px;\n  border-radius: 16px;\n  overflow: hidden;\n  font-size: 0;\n}\n\n.widget__pic {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.widget__details {\n  position: relative;\n  z-index: 2;\n  flex-grow: 1;\n  padding-left: 24px;\n}\n\n@media only screen and (max-width: 1419px) {\n  .widget__details {\n    padding-left: 16px;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .widget__details {\n    padding-left: 24px;\n  }\n}\n\n.widget__item .widget__category {\n  position: relative;\n  margin-bottom: 3px;\n  padding-right: 30px;\n  color: #11142D;\n  transition: color .25s;\n}\n\n.widget__item .widget__category .icon {\n  position: absolute;\n  top: 50%;\n  right: 9px;\n  transform: translateY(-50%);\n  font-size: 10px;\n  fill: #11142D;\n  transition: fill .25s;\n}\n\n.widget__info {\n  color: #808191;\n  transition: color .25s;\n}\n\n.widget__item:hover .widget__category,\n.widget__item:hover .widget__info {\n  color: #ffffff;\n}\n\n.widget__item:hover .widget__category .icon,\n.widget__item:hover .widget__info .icon {\n  fill: #ffffff;\n}\n\n.widget__wrap {\n  padding: 24px;\n  border-radius: 16px;\n  background: #ffffff;\n}\n\n.widget__chart_earning {\n  height: 205px;\n  margin-top: -20px;\n  margin-left: -20px;\n  margin-bottom: 15px;\n}\n\n.widget__chart_impressions {\n  height: 320px;\n  margin-left: -20px;\n}\n\n@media only screen and (max-width: 767px) {\n  .widget__chart_impressions {\n    margin-left: -10px;\n    margin-right: 10px;\n  }\n}\n\n.widget__chart_users {\n  flex-shrink: 0;\n  width: 120px;\n  height: 80px;\n  margin-top: -5px;\n}\n\n.widget__chart_earning-month {\n  max-width: 120px;\n  height: 120px;\n  margin: 0 auto;\n}\n\n.widget__chart_items {\n  height: 240px;\n}\n\n@media only screen and (max-width: 767px) {\n  .widget__chart_items {\n    margin-bottom: 16px;\n  }\n}\n\n.widget__col:first-child {\n  margin-bottom: 32px;\n}\n\n.widget__counter {\n  margin-bottom: 12px;\n}\n\n.widget__foot {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n}\n\n.widget__foot .widget__link {\n  color: #5F75EE;\n  transition: color .25s;\n}\n\n.widget__foot .widget__link:hover {\n  color: #6C5DD3;\n}\n\n.widget__flex {\n  display: flex;\n}\n\n.widget__legend {\n  display: flex;\n  justify-content: center;\n}\n\n.widget__color {\n  display: flex;\n  align-items: center;\n  color: #808191;\n}\n\n.widget__color:not(:last-child) {\n  margin-right: 24px;\n}\n\n.widget__bg {\n  width: 20px;\n  height: 20px;\n  border-radius: 8px;\n  margin-right: 8px;\n}\n\n.widget__text_mb32 {\n  margin-bottom: 32px;\n}\n\n.widget__text_mb40 {\n  margin-bottom: 40px;\n}\n\n.widget_shadow {\n  position: relative;\n}\n\n.widget_shadow:before {\n  content: \"\";\n  position: absolute;\n  top: 22px;\n  left: 18px;\n  right: 18px;\n  bottom: -40px;\n  z-index: -2;\n  background: #E3E6EC;\n  opacity: 0.91;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  .widget_shadow:before {\n    filter: blur(46.985px);\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .widget_responsive {\n    position: relative;\n    padding: 32px;\n    background: #ffffff;\n    border-radius: 24px;\n  }\n  .widget_responsive:before {\n    content: \"\";\n    position: absolute;\n    top: 22px;\n    left: 18px;\n    right: 18px;\n    bottom: -40px;\n    z-index: -2;\n    background: #E3E6EC;\n    opacity: 0.91;\n    filter: blur(86.985px);\n    border-radius: 24px;\n  }\n}\n\n@media only screen and (max-width: 1339px) and (max-width: 767px) {\n  .widget_responsive:before {\n    filter: blur(46.985px);\n  }\n}\n\n.widget_chart {\n  padding: 32px 8px 8px;\n}\n\n.widget_chart .widget__title {\n  padding: 0 24px;\n}\n\n.widget_pink {\n  background: #FFEBF6;\n}\n\n.widget_purple {\n  background: #6C5DD3;\n}\n\n.widget_stat {\n  position: relative;\n  text-align: center;\n}\n\n.widget_stat:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n  background: #E3E6EC;\n  opacity: 0.91;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  .widget_stat:before {\n    filter: blur(46.985px);\n  }\n}\n\n.widget_stat .widget__title {\n  margin-bottom: 12px;\n}\n\n.widget_stat > .widget__text {\n  max-width: 185px;\n  margin: 0 auto 18px;\n  color: #808191;\n}\n\n.widget_stat .widget__btn.btn_white {\n  box-shadow: 0 10px 20px rgba(227, 230, 236, 0.6);\n  color: #5F75EE;\n}\n\n.widget_stat .widget__btn.btn_white:hover {\n  color: #1B1D21;\n}\n\n.widget_empty {\n  background: none;\n  box-shadow: none;\n  border-radius: 0;\n}\n\n.widget_stat.widget_empty:before {\n  display: none;\n}\n\n.widget_p0 {\n  padding: 0;\n}\n\n.widget_pt0 {\n  padding-top: 0;\n}\n\n.widget_pb60 {\n  padding-bottom: 58px;\n}\n\n.widget_users .widget__flex {\n  padding: 26px 32px 40px;\n  box-shadow: inset 0px -1px 0px #E4E4E4;\n}\n\n.widget_users .widget__flex:first-child {\n  padding-top: 0;\n}\n\n.widget_users .widget__desc {\n  margin-right: auto;\n}\n\n.widget_users .widget__category {\n  line-height: 1.3;\n  color: #808191;\n}\n\n.widget_users .widget__percent {\n  font-weight: 600;\n  line-height: 1.3;\n  color: #7FBA7A;\n}\n\n.widget_after:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: -1;\n  bottom: -8px;\n  border-radius: 24px;\n  background: rgba(255, 255, 255, 0.5);\n}\n\nbody.dark .widget {\n  background: #242731;\n}\n\nbody.dark .widget__item .widget__category {\n  color: #ffffff;\n}\n\nbody.dark .widget__item .widget__category .icon {\n  fill: #ffffff;\n}\n\nbody.dark .widget__wrap {\n  background: #242731;\n}\n\nbody.dark .widget__next .icon {\n  fill: #ffffff;\n}\n\nbody.dark .widget_shadow:before {\n  background: #000;\n  opacity: 0.51;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .widget_shadow:before {\n    filter: blur(46.985px);\n  }\n}\n\nbody.dark .widget_pink {\n  background: #3F8CFF;\n}\n\nbody.dark .widget_stat:before {\n  background: #000;\n  opacity: 0.51;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .widget_stat:before {\n    filter: blur(46.985px);\n  }\n}\n\nbody.dark .widget_stat .widget__btn.btn_white {\n  box-shadow: none;\n  background: #1F2128;\n}\n\nbody.dark .widget_stat .widget__btn.btn_white:hover {\n  color: #ffffff;\n}\n\nbody.dark .widget_empty {\n  background: none;\n  box-shadow: none;\n}\n\nbody.dark .widget_users .widget__flex {\n  box-shadow: inset 0px -1px 0px rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .widget_purple {\n  background: #6C5DD3;\n}\n\nbody.dark .widget_after:after {\n  background: rgba(36, 39, 49, 0.5);\n}\n\n.header {\n  position: relative;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  max-width: 298px;\n  margin-left: auto;\n}\n\n@media only screen and (max-width: 1339px) {\n  .header {\n    max-width: 100%;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .header {\n    height: 96px;\n    max-width: calc(100% + 32px);\n    margin: 0 -16px;\n    padding: 0 32px;\n    border-bottom: 1px solid #E4E4E4;\n  }\n}\n\n.header .search {\n  width: 214px;\n  margin-left: -8px;\n  margin-right: auto;\n}\n\n@media only screen and (max-width: 1339px) {\n  .header .search {\n    width: auto;\n    flex-grow: 1;\n    margin-right: 50px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .header .search {\n    flex-grow: 0;\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .header .notifications {\n    margin-right: 25px;\n  }\n}\n\n.header__user {\n  display: none;\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  font-size: 0;\n}\n\n@media only screen and (max-width: 767px) {\n  .header__user {\n    display: block;\n  }\n}\n\n.header__pic {\n  width: 100%;\n  min-height: 100%;\n  border-radius: 50%;\n}\n\n.header__burger {\n  display: none;\n  width: 32px;\n  height: 40px;\n  margin-right: auto;\n  font-size: 0;\n}\n\n@media only screen and (max-width: 767px) {\n  .header__burger {\n    display: inline-block;\n  }\n}\n\n.header__burger:before, .header__burger:after {\n  content: \"\";\n  display: inline-block;\n  width: 32px;\n  height: 2px;\n  margin: 3px auto;\n  border-radius: 1px;\n  background: #1B1D21;\n}\n\n.header__search {\n  display: none;\n  width: 40px;\n  height: 40px;\n  margin-right: 25px;\n  border-radius: 50%;\n  box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);\n  font-size: 0;\n  transition: all .25s;\n}\n\n@media only screen and (max-width: 767px) {\n  .header__search {\n    display: inline-block;\n  }\n}\n\n.header__search .icon {\n  font-size: 20px;\n  fill: #1B1D21;\n}\n\n.header__search.active {\n  background: #6C5DD3;\n}\n\n.header__search.active .icon {\n  fill: #ffffff;\n}\n\nbody.dark .header__burger:before, body.dark .header__burger:after {\n  background: #ffffff;\n}\n\nbody.dark .header__search {\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);\n}\n\nbody.dark .header__search .icon {\n  fill: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .header {\n    border-color: rgba(228, 228, 228, 0.1);\n  }\n}\n\n.search {\n  position: relative;\n  z-index: 3;\n}\n\n@media only screen and (max-width: 767px) {\n  .search {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    z-index: 10;\n    visibility: hidden;\n  }\n  .search.show {\n    visibility: visible;\n    opacity: 1;\n  }\n}\n\n.search__field {\n  position: relative;\n  z-index: 2;\n}\n\n.search__input {\n  width: 100%;\n  height: 48px;\n  padding: 0 10px 0 44px;\n  border-radius: 12px;\n  background: transparent;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  color: #11142D;\n  transition: background .25s;\n}\n\n@media only screen and (max-width: 767px) {\n  .search__input {\n    height: 56px;\n    background: #E4E4E4;\n    border-radius: 0;\n  }\n}\n\n.search__input::placeholder {\n  color: #808191;\n}\n\n.search__toggle {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 42px;\n  font-size: 0;\n}\n\n.search__toggle .icon {\n  fill: #1B1D21;\n  transition: fill .25s;\n}\n\n.search__toggle .icon-search {\n  font-size: 20px;\n}\n\n.search__toggle .icon-close {\n  display: none;\n  font-size: 16px;\n}\n\n.search__toggle:hover .icon {\n  fill: #6C5DD3;\n}\n\n.search__result {\n  position: absolute;\n  top: -4px;\n  left: -4px;\n  right: -4px;\n  padding: 70px 16px 24px;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 10px 30px rgba(227, 230, 236, 0.5);\n  visibility: hidden;\n  opacity: 0;\n  transition: all .25s;\n}\n\n@media only screen and (max-width: 767px) {\n  .search__result {\n    top: 0;\n    left: 0;\n    right: 0;\n    box-shadow: 0 30px 30px rgba(27, 29, 33, 0.3);\n  }\n}\n\n.search__info {\n  color: #808191;\n}\n\n.search__item {\n  display: flex;\n  align-items: center;\n  padding: 16px 0;\n  color: #11142D;\n  transition: color .25s;\n}\n\n.search__item:hover {\n  color: #6C5DD3;\n}\n\n.search__item:not(:last-child) {\n  border-bottom: 1px solid #E4E4E4;\n}\n\n.search__preview {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  margin-right: 15px;\n  border-radius: 12px;\n  overflow: hidden;\n  font-size: 0;\n}\n\n.search__pic {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.search__text {\n  position: relative;\n  padding-right: 30px;\n  line-height: 1.42857;\n  font-weight: 600;\n}\n\n.search__text .icon {\n  position: absolute;\n  top: 5px;\n  right: 9px;\n  font-size: 10px;\n  fill: #11142D;\n  transition: all .25s;\n}\n\n.search__item:hover .icon {\n  transform: translateX(4px);\n  fill: #6C5DD3;\n}\n\n.search__btn {\n  height: 40px;\n}\n\n.search.active .search__input {\n  background: rgba(228, 228, 228, 0.3);\n}\n\n@media only screen and (max-width: 767px) {\n  .search.active .search__input {\n    background: #E4E4E4;\n  }\n}\n\n.search.active .search__toggle .icon-search {\n  display: none;\n}\n\n.search.active .search__toggle .icon-close {\n  display: inline-block;\n}\n\n.search.active .search__result {\n  visibility: visible;\n  opacity: 1;\n}\n\nbody.dark .search__toggle .icon {\n  fill: #ffffff;\n}\n\nbody.dark .search__toggle:hover .icon {\n  fill: #6C5DD3;\n}\n\nbody.dark .search__input {\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .search__input {\n    background: #1F2128;\n  }\n}\n\nbody.dark .search__result {\n  background: #242731;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .search__result {\n    box-shadow: 0 30px 30px rgba(0, 0, 0, 0.5);\n  }\n}\n\nbody.dark .search__item {\n  color: #ffffff;\n}\n\nbody.dark .search__text .icon {\n  fill: #ffffff;\n}\n\nbody.dark .search__item:not(:last-child) {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .search.active .search__input {\n  background: rgba(228, 228, 228, 0.03);\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .search.active .search__input {\n    background: #1F2128;\n  }\n}\n\n.notifications {\n  position: relative;\n}\n\n@media only screen and (max-width: 767px) {\n  .notifications {\n    position: static;\n  }\n}\n\n.notifications__open {\n  position: relative;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  font-size: 0;\n  transition: all .25s;\n}\n\n@media only screen and (max-width: 767px) {\n  .notifications__open {\n    width: 40px;\n    height: 40px;\n    box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);\n  }\n}\n\n.notifications__open .icon {\n  font-size: 24px;\n  fill: #1B1D21;\n  transition: fill .25s;\n}\n\n@media only screen and (max-width: 767px) {\n  .notifications__open .icon {\n    font-size: 20px;\n  }\n}\n\n.notifications__open:hover {\n  box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);\n}\n\n.notifications__counter {\n  position: absolute;\n  top: 0;\n  right: -12px;\n  display: inline-block;\n  min-width: 24px;\n  line-height: 24px;\n  border-radius: 50%;\n  background: #FF754C;\n  font-size: 12px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  .notifications__counter {\n    top: 5px;\n    right: 5px;\n    min-width: 12px;\n    height: 12px;\n    font-size: 0;\n  }\n}\n\n.notifications__wrap {\n  position: absolute;\n  top: calc(100% + 24px);\n  right: -12px;\n  width: 360px;\n  padding: 32px 8px 36px;\n  box-shadow: 0 10px 36px rgba(227, 230, 236, 0.6);\n  background: #ffffff;\n  border-radius: 24px;\n  visibility: hidden;\n  opacity: 0;\n  transition: all .25s;\n}\n\n@media only screen and (max-width: 767px) {\n  .notifications__wrap {\n    top: calc(100% + 1px);\n    right: 0;\n    left: 0;\n    width: auto;\n    padding: 24px 16px;\n    box-shadow: 0 30px 30px rgba(27, 29, 33, 0.3);\n  }\n}\n\n.notifications__info {\n  margin-bottom: 32px;\n  padding: 0 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  .notifications__info {\n    margin-bottom: 16px;\n    padding: 0;\n  }\n}\n\n.notifications__list {\n  margin-bottom: 32px;\n}\n\n@media only screen and (max-width: 767px) {\n  .notifications__list {\n    margin-bottom: 24px;\n  }\n}\n\n.notifications__item {\n  display: flex;\n  align-items: center;\n  padding: 16px 28px 16px 20px;\n  border-radius: 12px;\n  background: transparent;\n  cursor: pointer;\n  transition: background .25s;\n}\n\n@media only screen and (max-width: 767px) {\n  .notifications__item {\n    padding: 0;\n  }\n}\n\n.notifications__item:hover {\n  background: #6C5DD3;\n}\n\n@media only screen and (max-width: 767px) {\n  .notifications__item:hover {\n    background: none;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .notifications__item:not(:last-child) {\n    margin-bottom: 20px;\n  }\n}\n\n.notifications__ava {\n  position: relative;\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  margin-right: 24px;\n  font-size: 0;\n}\n\n@media only screen and (max-width: 767px) {\n  .notifications__ava {\n    margin-right: 16px;\n  }\n}\n\n.notifications__ava > .notifications__pic {\n  width: 100%;\n  min-height: 100%;\n  border-radius: 50%;\n}\n\n.notifications__status {\n  position: absolute;\n  top: 0;\n  right: -1px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 21px;\n  height: 21px;\n  border: 2px solid #ffffff;\n  border-radius: 50%;\n  font-size: 0;\n}\n\n.notifications__status .notifications__pic {\n  max-width: 10px;\n}\n\n.notifications__details {\n  flex-grow: 1;\n}\n\n.notifications__line {\n  display: flex;\n  margin-bottom: 6px;\n}\n\n.notifications__user {\n  margin-right: auto;\n  color: #11142D;\n  transition: color .25s;\n}\n\n.notifications__time, .notifications__text {\n  color: #B2B3BD;\n  transition: color .25s;\n}\n\n.notifications__time {\n  flex-shrink: 0;\n  margin-left: 20px;\n}\n\n.notifications__project {\n  padding-left: 5px;\n  color: #5F75EE;\n  transition: all .25s;\n}\n\n.notifications__item:hover .notifications__user,\n.notifications__item:hover .notifications__time,\n.notifications__item:hover .notifications__text,\n.notifications__item:hover .notifications__project {\n  color: #ffffff;\n}\n\n.notifications__btns {\n  text-align: center;\n}\n\n.notifications__btn {\n  min-width: 230px;\n}\n\n.notifications.active .notifications__open {\n  background: #6C5DD3;\n  box-shadow: 0 5px 10px rgba(227, 230, 236, 0.6);\n}\n\n.notifications.active .notifications__open .icon {\n  fill: #ffffff;\n}\n\n.notifications.active .notifications__wrap {\n  visibility: visible;\n  opacity: 1;\n}\n\nbody.dark .notifications__open {\n  background: #242731;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .notifications__open {\n    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);\n  }\n}\n\nbody.dark .notifications__open .icon {\n  fill: #ffffff;\n}\n\nbody.dark .notifications__open:hover {\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);\n}\n\nbody.dark .notifications__wrap {\n  background: #242731;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .notifications__wrap {\n    box-shadow: 0 30px 30px rgba(0, 0, 0, 0.5);\n  }\n}\n\nbody.dark .notifications__user {\n  color: #ffffff;\n}\n\nbody.dark .notifications.active .notifications__open {\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.7);\n}\n\n.banner__container {\n  position: relative;\n  padding: 64px 64px 76px;\n  border-radius: 24px;\n  background: #6C5DD3;\n  overflow: hidden;\n}\n\n@media only screen and (max-width: 1339px) {\n  .banner__container {\n    padding: 50px 56px;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .banner__container {\n    padding: 50px 40px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .banner__container {\n    padding: 10px 32px 32px;\n    text-align: center;\n  }\n}\n\n.banner__wrap {\n  max-width: 400px;\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 1179px) {\n  .banner__wrap {\n    max-width: 300px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .banner__wrap {\n    max-width: 100%;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .banner__title {\n    margin-bottom: 6px;\n    line-height: 1.2;\n  }\n}\n\n.banner__text {\n  margin-bottom: 16px;\n}\n\n.banner__btn {\n  min-width: 209px;\n}\n\n.banner__preview {\n  position: absolute;\n  top: 40px;\n  right: 90px;\n  width: 543px;\n  font-size: 0;\n}\n\n@media only screen and (max-width: 1419px) {\n  .banner__preview {\n    width: 450px;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .banner__preview {\n    right: 50px;\n    width: 330px;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .banner__preview {\n    top: 50%;\n    transform: translateY(-50%);\n    width: 180px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .banner__preview {\n    position: static;\n    transform: translateY(0);\n    width: 260px;\n    height: 260px;\n    padding: 30px;\n    margin: 0 auto;\n    text-align: center;\n  }\n}\n\n.banner__preview .banner__pic {\n  width: 100%;\n}\n\n.banner:not(:last-child) {\n  margin-bottom: 32px;\n}\n\n@media only screen and (max-width: 767px) {\n  .sorting {\n    padding: 0 24px;\n  }\n}\n\n.sorting__row {\n  display: flex;\n  margin: 0 -8px;\n}\n\n@media only screen and (max-width: 1339px) {\n  .sorting__row {\n    display: block;\n    margin: 0;\n  }\n}\n\n.sorting__col {\n  flex: 0 0 calc(50% - 16px);\n  width: calc(50% - 16px);\n  margin: 0 8px;\n}\n\n@media only screen and (max-width: 1339px) {\n  .sorting__col {\n    width: 100%;\n    margin: 0;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .sorting__col:not(:last-child) {\n    margin-bottom: 16px;\n  }\n}\n\n.sorting__dropdowns {\n  display: flex;\n  margin: 0 -8px;\n}\n\n@media only screen and (max-width: 767px) {\n  .sorting__dropdowns {\n    display: block;\n    margin: 0;\n  }\n}\n\n.sorting__dropdowns .dropdown {\n  flex: 0 0 calc(50% - 16px);\n  width: calc(50% - 16px);\n  margin: 0 8px;\n}\n\n@media only screen and (max-width: 767px) {\n  .sorting__dropdowns .dropdown {\n    width: 100%;\n    margin: 0;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sorting__dropdowns .dropdown:not(:last-child) {\n    margin-bottom: 16px;\n  }\n}\n\n.sorting__line {\n  display: flex;\n  align-items: center;\n}\n\n@media only screen and (max-width: 767px) {\n  .sorting__line {\n    display: block;\n  }\n}\n\n.sorting__search {\n  position: relative;\n  flex-grow: 1;\n}\n\n.sorting__line .sorting__search {\n  margin-right: 45px;\n}\n\n@media only screen and (max-width: 1179px) {\n  .sorting__line .sorting__search {\n    margin-right: 30px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .sorting__line .sorting__search {\n    margin: 0 0 16px;\n  }\n}\n\n.sorting__input {\n  width: 100%;\n  height: 56px;\n  padding: 0 20px 0 55px;\n  border: none;\n  border-radius: 16px;\n  background: rgba(228, 228, 228, 0.2);\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1B1D21;\n}\n\n.sorting__input::placeholder {\n  color: #808191;\n}\n\n.sorting__open {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 55px;\n  font-size: 0;\n}\n\n.sorting__open .icon {\n  font-size: 20px;\n  fill: #11142D;\n  transition: fill .25s;\n}\n\n.sorting__open:hover .icon {\n  fill: #6C5DD3;\n}\n\n.sorting__actions {\n  display: flex;\n  align-items: center;\n}\n\n@media only screen and (max-width: 767px) {\n  .sorting__actions {\n    justify-content: flex-end;\n  }\n}\n\n.sorting__action {\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: #ffffff;\n  font-size: 0;\n  transition: box-shadow .25s;\n}\n\n.sorting__action .icon {\n  font-size: 17px;\n  fill: #11142D;\n}\n\n.sorting__action .icon-edit {\n  font-size: 19px;\n}\n\n.sorting__action .icon-box {\n  font-size: 15px;\n}\n\n.sorting__action:hover {\n  box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);\n}\n\n.sorting__action:not(:last-child) {\n  margin-right: 24px;\n}\n\n.sorting:not(:last-child) {\n  margin-bottom: 15px;\n}\n\nbody.dark .sorting__input {\n  background: rgba(228, 228, 228, 0.04);\n  color: #ffffff;\n}\n\nbody.dark .sorting__open .icon {\n  fill: #ffffff;\n}\n\nbody.dark .sorting__action {\n  background: #242731;\n}\n\nbody.dark .sorting__action .icon {\n  fill: #ffffff;\n}\n\nbody.dark .sorting__action:hover {\n  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.25);\n}\n\n.dropdown {\n  position: relative;\n}\n\n.dropdown__head {\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 56px;\n  padding: 0 46px 0 21px;\n  border: 2px solid transparent;\n  background: rgba(228, 228, 228, 0.3);\n  border-radius: 16px;\n  font-weight: 600;\n  color: #808191;\n  transition: all .25s;\n  cursor: pointer;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.dropdown__head:before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  right: 20px;\n  transform: translateY(-50%);\n  width: 14px;\n  height: 8px;\n  background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='8'%3E%3Cpath fill='%231b1d21' d='M.293.293A1 1 0 0 1 1.613.21l.094.083L7 5.585 12.293.293a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 .083 1.32l-.083.094-6 6a1 1 0 0 1-1.32.083l-.094-.083-6-6a1 1 0 0 1 0-1.414z'/%3E%3C/svg%3E\") no-repeat 50% 50%/100% auto;\n  transition: transform .25s;\n}\n\n.dropdown__body {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  z-index: 20;\n  width: 310px;\n  padding: 32px;\n  border: 1px solid #E4E4E4;\n  background: #ffffff;\n  border-radius: 24px;\n  visibility: hidden;\n  opacity: 0;\n  box-shadow: 0 20px 16px rgba(227, 230, 236, 0.6);\n  transition: all .25s;\n}\n\n@media only screen and (max-width: 1179px) {\n  .dropdown__body {\n    right: 0;\n    width: auto;\n    padding: 24px 21px;\n  }\n}\n\n.dropdown__item {\n  display: block;\n}\n\n.dropdown__item:not(:last-child) {\n  margin-bottom: 24px;\n}\n\n.dropdown__title {\n  position: relative;\n  margin-bottom: 3px;\n  padding-right: 30px;\n  color: #11142D;\n  transition: color .25s;\n}\n\n.dropdown__title:before {\n  content: \"\";\n  position: absolute;\n  top: 5px;\n  right: 8px;\n  width: 6px;\n  height: 10px;\n  background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='10'%3E%3Cpath fill='%2311142d' d='M.293.293A1 1 0 0 1 1.613.21l.094.083 4 4a1 1 0 0 1 .083 1.32l-.083.094-4 4A1 1 0 0 1 .21 8.387l.083-.094L3.585 5 .293 1.707A1 1 0 0 1 .21.387L.293.293z'/%3E%3C/svg%3E\") no-repeat 50% 50%/100% auto;\n  transition: transform .25s;\n}\n\n.dropdown__info {\n  color: #808191;\n  transition: color .25s;\n}\n\n.dropdown__item:hover .dropdown__title:before {\n  transform: translateX(5px);\n}\n\n.dropdown__item:hover .dropdown__title,\n.dropdown__item:hover .dropdown__info {\n  color: #6C5DD3;\n}\n\n.dropdown.active .dropdown__head {\n  border-color: #5F75EE;\n  background: #ffffff;\n  color: #11142D;\n}\n\n.dropdown.active .dropdown__head:before {\n  transform: translateY(-50%) rotate(180deg);\n}\n\n.dropdown.active .dropdown__body {\n  visibility: visible;\n  opacity: 1;\n}\n\nbody.dark .dropdown__head {\n  background: rgba(228, 228, 228, 0.04);\n}\n\nbody.dark .dropdown__head:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='8'%3E%3Cpath fill='%23ffffff' d='M.293.293A1 1 0 0 1 1.613.21l.094.083L7 5.585 12.293.293a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 .083 1.32l-.083.094-6 6a1 1 0 0 1-1.32.083l-.094-.083-6-6a1 1 0 0 1 0-1.414z'/%3E%3C/svg%3E\");\n}\n\nbody.dark .dropdown__body {\n  border-color: rgba(228, 228, 228, 0.1);\n  background: #242731;\n  box-shadow: 0 20px 16px rgba(0, 0, 0, 0.5);\n}\n\nbody.dark .dropdown__title {\n  color: #ffffff;\n}\n\nbody.dark .dropdown__title:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='10'%3E%3Cpath fill='%23ffffff' d='M.293.293A1 1 0 0 1 1.613.21l.094.083 4 4a1 1 0 0 1 .083 1.32l-.083.094-4 4A1 1 0 0 1 .21 8.387l.083-.094L3.585 5 .293 1.707A1 1 0 0 1 .21.387L.293.293z'/%3E%3C/svg%3E\");\n}\n\nbody.dark .dropdown.active .dropdown__head {\n  background: rgba(228, 228, 228, 0.04);\n  color: #ffffff;\n}\n\n.products > .products__title {\n  margin-bottom: 16px;\n}\n\n.products > .products__info {\n  margin-bottom: 20px;\n  color: #808191;\n}\n\n.products__table {\n  display: table;\n  width: 100%;\n}\n\n@media only screen and (max-width: 767px) {\n  .products__table {\n    display: block;\n    margin-top: -72px;\n  }\n}\n\n.products__row {\n  display: table-row;\n}\n\n@media only screen and (max-width: 767px) {\n  .products__row {\n    display: flex;\n    align-items: center;\n    padding: 24px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .products__row:not(.products__row_head) {\n    border-top: 1px solid #E4E4E4;\n  }\n}\n\n.products__row_head .products__cell {\n  padding-top: 24px;\n  padding-bottom: 24px;\n  font-size: 13px;\n  line-height: 1.38462;\n  font-weight: 500;\n  color: #B2B3BD;\n}\n\n@media only screen and (max-width: 767px) {\n  .products__row_head .products__cell {\n    padding: 0;\n  }\n}\n\n.products__cell {\n  display: table-cell;\n  vertical-align: middle;\n  padding-left: 20px;\n  padding-top: 32px;\n  padding-bottom: 32px;\n  border-bottom: 1px solid #E4E4E4;\n}\n\n@media only screen and (max-width: 1179px) {\n  .products__cell {\n    padding-left: 15px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .products__cell {\n    display: block;\n    padding: 0;\n    border: none;\n  }\n}\n\n.products__cell:first-child {\n  width: 20px;\n  padding: 0;\n  font-size: 0;\n}\n\n@media only screen and (max-width: 767px) {\n  .products__cell:first-child {\n    margin-right: 24px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .products__cell:nth-child(n+3) {\n    display: none;\n  }\n}\n\n.products__item {\n  display: inline-flex;\n  align-items: center;\n  color: #11142D;\n}\n\n.products__preview {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 96px;\n  height: 72px;\n  border-radius: 8px;\n  background: #A0D7E7;\n  font-size: 0;\n}\n\n@media only screen and (max-width: 1179px) {\n  .products__preview {\n    width: 86px;\n    height: 64px;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .products__preview {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .products__preview {\n    display: block;\n    width: 72px;\n    height: 55px;\n  }\n}\n\n.products__preview:before {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 7px;\n  right: 7px;\n  height: 8px;\n  border-radius: 0 0 8px 8px;\n  background: #E7FAFF;\n}\n\n.products__pic {\n  max-height: 100%;\n}\n\n.products__details {\n  padding-left: 24px;\n}\n\n@media only screen and (max-width: 1179px) {\n  .products__details {\n    padding-left: 16px;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .products__details {\n    padding: 0;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .products__details {\n    padding-left: 24px;\n  }\n}\n\n.products__cell .products__title {\n  margin-bottom: 9px;\n}\n\n.products__color {\n  display: flex;\n  align-items: center;\n}\n\n.products__bg {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  border-radius: 4px;\n}\n\n@media only screen and (max-width: 1179px) {\n  .products__bg {\n    border-radius: 50%;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .products__bg {\n    width: 9px;\n    height: 32px;\n    margin-right: 31px;\n    border-radius: 9px;\n  }\n}\n\n.products__rating {\n  color: #808191;\n}\n\n.products__color .products__text {\n  margin-left: 8px;\n}\n\n@media only screen and (max-width: 1179px) {\n  .products__color .products__text {\n    display: none;\n  }\n}\n\n.products__more {\n  padding-top: 40px;\n  text-align: center;\n}\n\n@media only screen and (max-width: 1023px) {\n  .products__more {\n    padding-top: 32px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .products__more {\n    border-top: 1px solid #E4E4E4;\n    padding: 24px 24px 0;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .products__more .products__btn {\n    min-width: 100%;\n  }\n}\n\n.products__cost {\n  position: relative;\n  cursor: pointer;\n}\n\n.products__cost .products__tooltip {\n  position: absolute;\n  top: 10%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  min-width: 160px;\n  padding: 32px 26px;\n  background: #ffffff;\n  border-radius: 24px;\n  box-shadow: 0 20px 30px rgba(227, 230, 236, 0.9);\n  visibility: hidden;\n  opacity: 0;\n  transition: all .2s;\n}\n\n.products__cost:hover .products__tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n.products__sale {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n  color: #808191;\n}\n\n.products__sale .products__icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n  border-radius: 6px;\n}\n\n.products__sale .products__pic {\n  max-width: 8px;\n}\n\n.products__progress {\n  position: relative;\n  width: 100%;\n  height: 2px;\n  border-radius: 1px;\n  background: #E4E4E4;\n}\n\n.products__progress span {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  border-radius: 1px;\n  background: #6C5DD3;\n}\n\n.products__price:not(:last-child) {\n  margin-bottom: 10px;\n}\n\n.products__transaction {\n  color: #808191;\n}\n\n.products__status {\n  display: inline-block;\n  padding: 3px 16px;\n  border-radius: 4px;\n  color: #ffffff;\n}\n\n.products__body {\n  display: none;\n  align-items: center;\n  margin: 0 24px 24px;\n  padding: 4px;\n  border: 1px solid #E4E4E4;\n  border-radius: 8px;\n}\n\n@media only screen and (max-width: 767px) {\n  .products__body {\n    display: flex;\n  }\n}\n\n.products__line {\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n}\n\n.products_main .products__money {\n  color: #5F75EE;\n}\n\n.products_main .products__cell:nth-child(2) {\n  font-size: 0;\n}\n\n.products_main .products__col:first-child {\n  flex: 0 0 30%;\n  padding-right: 8px;\n}\n\n.products_main .products__col:nth-child(2) {\n  flex: 0 0 44%;\n  padding-right: 8px;\n}\n\n.products_main .products__col:nth-child(3) {\n  flex: 0 0 26%;\n}\n\n.products_history .products__col:first-child {\n  flex: 0 0 42%;\n  padding-right: 8px;\n}\n\n.products_history .products__col:nth-child(2) {\n  flex: 0 0 32%;\n  padding-right: 8px;\n}\n\n.products_history .products__col:nth-child(3) {\n  flex: 0 0 26%;\n}\n\n@media only screen and (max-width: 767px) {\n  .products_statement .products__cell {\n    display: block;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .products_statement .products__cell:not(:first-child):not(:nth-child(3)) {\n    display: none;\n  }\n}\n\n.products_statement .products__col:first-child {\n  flex: 0 0 42%;\n  padding-right: 8px;\n}\n\n.products_statement .products__col:nth-child(2) {\n  flex: 0 0 32%;\n  padding-right: 8px;\n}\n\n.products_statement .products__col:nth-child(3) {\n  flex: 0 0 26%;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .products__row:not(.products__row_head) {\n    border-color: rgba(228, 228, 228, 0.1);\n  }\n}\n\nbody.dark .products__cell {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .products__item {\n  color: #ffffff;\n}\n\nbody.dark .products__body {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .products__more {\n    border-color: rgba(228, 228, 228, 0.1);\n  }\n}\n\n.checkbox {\n  display: inline-block;\n  position: relative;\n  user-select: none;\n  cursor: pointer;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.checkbox__input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n\n.checkbox__in {\n  display: flex;\n}\n\n.checkbox__tick {\n  position: relative;\n  flex: 0 0 20px;\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  border: 2px solid #E4E4E4;\n  transition: all .25s;\n}\n\n.checkbox__tick:before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 10px;\n  height: 9px;\n  opacity: 0;\n  background: url(\"data:image/svg+xml,%3Csvg width='10' height='9' viewBox='0 0 10 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.5 5.375L1.5 3.375L0 4.875L3.5 8.375L10 1.875L8.5 0.375L3.5 5.375Z' fill='white'/%3E%3C/svg%3E%0A\") no-repeat 50% 50%/100% auto;\n  transition: opacity .25s;\n}\n\n.checkbox__text {\n  margin-left: 8px;\n  padding-top: 2px;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: #808191;\n}\n\n.checkbox:hover .checkbox__tick {\n  border-color: #6C5DD3;\n}\n\n.checkbox__input:checked + .checkbox__in .checkbox__tick {\n  background: #6C5DD3;\n  border-color: #6C5DD3;\n}\n\n.checkbox__input:checked + .checkbox__in .checkbox__tick:before {\n  opacity: 1;\n}\n\n.checkbox__input:checked + .checkbox__in .checkbox__text {\n  color: #11142D;\n}\n\nbody.dark .checkbox__tick {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .checkbox__input:checked + .checkbox__in .checkbox__text {\n  color: #ffffff;\n}\n\n.radio {\n  display: inline-block;\n  position: relative;\n  user-select: none;\n  cursor: pointer;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.radio__input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n\n.radio__in {\n  display: flex;\n}\n\n.radio__tick {\n  position: relative;\n  flex: 0 0 20px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #E4E4E4;\n  transition: all .25s;\n}\n\n.radio__tick:before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #ffffff;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);\n  opacity: 0;\n  transition: opacity .25s;\n}\n\n.radio__text {\n  margin-left: 8px;\n  padding-top: 3px;\n  font-size: 13px;\n  line-height: 1.2;\n  color: #808191;\n  transition: color .25s;\n}\n\n.radio:hover .radio__tick {\n  background: #6C5DD3;\n}\n\n.radio__input:checked + .radio__in .radio__tick {\n  background: #6C5DD3;\n}\n\n.radio__input:checked + .radio__in .radio__tick:before {\n  opacity: 1;\n}\n\n.radio__input:checked + .radio__in .radio__text {\n  color: #11142D;\n}\n\nbody.dark .radio__tick {\n  background: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .radio__input:checked + .radio__in .radio__text {\n  color: #ffffff;\n}\n\n.details__container {\n  position: relative;\n  padding: 32px 32px 38px;\n  background: #ffffff;\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  .details__container {\n    padding-bottom: 32px;\n  }\n}\n\n.details__container:before {\n  content: \"\";\n  position: absolute;\n  top: 28px;\n  left: 18px;\n  right: 18px;\n  bottom: -28px;\n  z-index: -1;\n  background: #E3E6EC;\n  opacity: 0.91;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  .details__container:before {\n    filter: blur(46.985px);\n  }\n}\n\n.details__title {\n  margin-bottom: 40px;\n}\n\n@media only screen and (max-width: 767px) {\n  .details__title {\n    margin-bottom: 24px;\n  }\n}\n\n.details__row {\n  display: flex;\n  margin-bottom: 30px;\n}\n\n@media only screen and (max-width: 767px) {\n  .details__row {\n    display: block;\n  }\n}\n\n.details__col:first-child {\n  flex-shrink: 0;\n  width: 145px;\n  padding-right: 16px;\n}\n\n@media only screen and (max-width: 767px) {\n  .details__col:first-child {\n    display: flex;\n    align-items: flex-end;\n    width: auto;\n    margin: 0 -5px 32px;\n    padding: 0;\n  }\n}\n\n.details__col:nth-child(2) {\n  flex-grow: 1;\n}\n\n.details__top {\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #E4E4E4;\n}\n\n@media only screen and (max-width: 767px) {\n  .details__top {\n    flex: 0 0 calc(50% - 10px);\n    margin: 0 5px;\n    padding: 0;\n    border: none;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .details__bottom {\n    flex: 0 0 calc(50% - 10px);\n    margin: 0 5px;\n  }\n}\n\n.details__number {\n  margin-bottom: 16px;\n}\n\n.details__line {\n  display: flex;\n  align-items: center;\n  color: #5F75EE;\n  transition: color .25s;\n}\n\n.details__line:hover {\n  color: #6C5DD3;\n}\n\n.details__preview {\n  font-size: 0;\n}\n\n.details__line .details__preview {\n  width: 32px;\n  flex-shrink: 0;\n  margin-right: 16px;\n}\n\n.details__statistics {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n@media only screen and (max-width: 767px) {\n  .details__statistics {\n    margin-bottom: 32px;\n  }\n}\n\n.details__status {\n  display: flex;\n  align-items: center;\n}\n\n.details__status .details__icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n  margin-right: 4px;\n  border-radius: 50%;\n  font-size: 0;\n}\n\n.details__status .details__icon .icon {\n  font-size: 6px;\n  fill: #ffffff;\n}\n\n.details__box {\n  position: relative;\n  padding: 5px 5px 13px;\n  border-radius: 16px;\n  background: #3F8CFF;\n}\n\n.details__chart_activity {\n  height: 25px;\n  flex-grow: 1;\n  padding-right: 13px;\n}\n\n.details__chart_counter {\n  height: 200px;\n}\n\n.details__chart_counter .apexcharts-tooltip.apexcharts-theme-light {\n  background: #1B1D21;\n  border: none;\n  color: #ffffff;\n}\n\n.details__chart_report {\n  height: 215px;\n}\n\n.details__info {\n  color: #B2B3BD;\n}\n\n.details__list {\n  display: flex;\n  border-radius: 16px;\n  border: 1px solid #E4E4E4;\n}\n\n@media only screen and (max-width: 767px) {\n  .details__list {\n    flex-wrap: wrap;\n  }\n}\n\n.details__item {\n  padding: 24px;\n}\n\n.details__item:not(:last-child) {\n  border-right: 1px solid #E4E4E4;\n}\n\n@media only screen and (max-width: 767px) {\n  .details__item:not(:last-child) {\n    border-right: none;\n  }\n}\n\n.details__list_three .details__item {\n  flex: 0 0 33.333%;\n  width: 33.333%;\n}\n\n@media only screen and (max-width: 767px) {\n  .details__list_three .details__item {\n    flex: 0 0 100%;\n    width: 100%;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .details__list_three .details__item:not(:first-child) {\n    border-top: 1px solid #E4E4E4;\n  }\n}\n\n.details__list_four .details__item {\n  flex: 0 0 25%;\n  width: 25%;\n}\n\n@media only screen and (max-width: 767px) {\n  .details__list_four .details__item {\n    flex: 0 0 50%;\n    width: 50%;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .details__list_four .details__item:nth-child(2n+1) {\n    border-right: 1px solid #E4E4E4;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .details__list_four .details__item:nth-child(n+3) {\n    border-top: 1px solid #E4E4E4;\n  }\n}\n\n.details__head {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.details__head .details__preview {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n  border-radius: 6px;\n  font-size: 0;\n}\n\n.details__head .details__pic {\n  max-width: 8px;\n}\n\n.details__indicator {\n  position: relative;\n  height: 2px;\n  border-radius: 1px;\n  background: #E4E4E4;\n}\n\n.details__progress {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n}\n\n.details__remove {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 2;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: #ffffff;\n  font-size: 0;\n}\n\n.details__remove .icon {\n  font-size: 10px;\n  transition: transform .25s;\n}\n\n.details__remove:hover .icon {\n  transform: rotate(90deg);\n}\n\n.details .dropdown {\n  position: absolute;\n  top: 16px;\n  right: 20px;\n  width: 200px;\n}\n\n@media only screen and (max-width: 767px) {\n  .details .dropdown {\n    position: relative;\n    top: auto;\n    right: auto;\n    width: 100%;\n    margin-bottom: 20px;\n  }\n}\n\n.details:not(:last-child) {\n  margin-bottom: 28px;\n}\n\n.details_statements:not(:last-child) {\n  margin-bottom: 68px;\n}\n\n@media only screen and (max-width: 767px) {\n  .details_statements:not(:last-child) {\n    margin-bottom: 32px;\n  }\n}\n\n.details_statements .details__col:first-child {\n  width: 170px;\n  padding-right: 25px;\n}\n\n@media only screen and (max-width: 767px) {\n  .details_statements .details__col:first-child {\n    width: auto;\n    padding: 0;\n  }\n}\n\n.details_statements .details__counter {\n  margin-bottom: 10px;\n}\n\n.details_statements .details__line .details__info {\n  color: #5F75EE;\n}\n\nbody.dark .details__container {\n  background: #242731;\n}\n\nbody.dark .details__container:before {\n  background: #000;\n  opacity: 0.51;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .details__container:before {\n    filter: blur(46.985px);\n  }\n}\n\nbody.dark .details__remove {\n  background: #242731;\n}\n\nbody.dark .details__remove .icon {\n  fill: #ffffff;\n}\n\nbody.dark .details__list {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .details__top {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .details__item {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .details__indicator {\n  background: rgba(228, 228, 228, 0.1);\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .details__list_four .details__item:nth-child(n+3) {\n    border-color: rgba(228, 228, 228, 0.1);\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .details__list_three .details__item:not(:first-child) {\n    border-color: rgba(228, 228, 228, 0.1);\n  }\n}\n\n.quality__item {\n  display: flex;\n  align-items: center;\n}\n\n.quality__item_chart {\n  position: relative;\n  padding-right: 60px;\n}\n\n.quality__item[href] {\n  color: #11142D;\n}\n\n.quality__item:not(:last-child) {\n  margin-bottom: 48px;\n}\n\n.quality__preview {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  margin-right: 14px;\n  border-radius: 12px;\n  font-size: 0;\n}\n\n.quality__preview .quality__pic {\n  max-height: 100%;\n}\n\n.quality__chart {\n  position: absolute;\n  top: 73%;\n  right: -32px;\n  transform: translateY(-50%);\n  width: 110px;\n  height: 110px;\n}\n\n.quality__details {\n  position: relative;\n  z-index: 2;\n  flex-grow: 1;\n}\n\n.quality__percent {\n  position: absolute;\n  top: 39%;\n  left: 51%;\n  pointer-events: none;\n  transform: translate(-50%, -50%);\n}\n\n.quality__info {\n  margin-top: 5px;\n  color: #808191;\n}\n\n.quality__btn {\n  margin-top: 40px;\n}\n\n.quality__btn_mt30 {\n  margin-top: 30px;\n}\n\n.quality__line {\n  display: flex;\n}\n\n.quality__line .quality__price {\n  margin-left: auto;\n  padding-left: 10px;\n  color: #7FBA7A;\n}\n\n.quality__category {\n  position: relative;\n  padding-right: 20px;\n}\n\n.quality__category .icon {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  font-size: 10px;\n  transition: transform .25s;\n}\n\n.quality__money {\n  display: inline-block;\n  margin-top: 8px;\n  padding: 3px 10px;\n  background: #6C5DD3;\n  border-radius: 8px;\n  color: #ffffff;\n}\n\n.quality_big .quality__list {\n  margin: -8px -16px;\n}\n\n.quality_big .quality__item {\n  position: relative;\n  padding: 8px 16px;\n  background: transparent;\n  border-radius: 12px;\n  transition: all .25s;\n}\n\n.quality_big .quality__item:before {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 10px;\n  right: 10px;\n  height: 0;\n  border-radius: 0 0 8px 8px;\n  background: #CFC8FF;\n  transition: height .25s;\n}\n\n.quality_big .quality__item:hover {\n  background: #6C5DD3;\n  color: #ffffff;\n}\n\n.quality_big .quality__item:hover:before {\n  height: 6px;\n}\n\n.quality_big .quality__item:not(:last-child) {\n  margin-bottom: 24px;\n}\n\n.quality_big .quality__item:hover .quality__category {\n  color: #ffffff;\n}\n\n.quality_big .quality__item:hover .quality__category .icon {\n  fill: #ffffff;\n}\n\n.quality_big .quality__item:hover .quality__info {\n  color: #ffffff;\n}\n\n.quality_big .quality__preview {\n  position: relative;\n  width: 88px;\n  height: 80px;\n  margin-right: 24px;\n}\n\n.quality_big .quality__preview:before {\n  content: \"\";\n  position: absolute;\n}\n\nbody.dark .quality__item {\n  color: #ffffff;\n}\n\nbody.dark .quality__category .icon {\n  fill: #ffffff;\n}\n\n.goal__container {\n  min-height: 220px;\n  margin: 0 -16px 26px;\n}\n\n.goal__preview {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 220px;\n  font-size: 0;\n}\n\n.goal__pic {\n  position: relative;\n  z-index: 2;\n  max-height: 100%;\n}\n\n.goal__bg {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: 50%;\n  border-radius: 16px;\n}\n\n.goal__item:not(:last-child) {\n  margin-bottom: 32px;\n}\n\n.goal__head {\n  display: flex;\n  margin-bottom: 13px;\n}\n\n.goal__percent {\n  flex-shrink: 0;\n  margin-left: auto;\n  padding-left: 15px;\n}\n\n.goal__indicator {\n  position: relative;\n  height: 8px;\n  background: #E4E4E4;\n  border-radius: 4px;\n}\n\n.goal__progress {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  border-radius: 4px;\n}\n\n.goal .owl-carousel .owl-item img {\n  width: auto;\n}\n\n.goal .owl-nav {\n  position: absolute;\n  top: 0;\n  left: 16px;\n  z-index: 2;\n  display: flex;\n}\n\n.goal .owl-carousel .owl-nav button.owl-prev,\n.goal .owl-carousel .owl-nav button.owl-next {\n  width: 24px;\n  height: 24px;\n  background: #ffffff;\n  border-radius: 50%;\n  box-shadow: 0 5px 10px #E3E6EC;\n  font-size: 0;\n  transition: all .25s;\n}\n\n.goal .owl-carousel .owl-nav button.owl-prev .icon,\n.goal .owl-carousel .owl-nav button.owl-next .icon {\n  font-size: 10px;\n  fill: #11142D;\n  transition: fill .25s;\n}\n\n.goal .owl-carousel .owl-nav button.owl-prev:hover,\n.goal .owl-carousel .owl-nav button.owl-next:hover {\n  background: #6C5DD3;\n}\n\n.goal .owl-carousel .owl-nav button.owl-prev:hover .icon,\n.goal .owl-carousel .owl-nav button.owl-next:hover .icon {\n  fill: #ffffff;\n}\n\n.goal .owl-carousel .owl-nav button.owl-prev {\n  margin-right: 8px;\n}\n\nbody.dark .goal__indicator {\n  background: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .goal .owl-carousel .owl-nav button.owl-prev,\nbody.dark .goal .owl-carousel .owl-nav button.owl-next {\n  background: #242731;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);\n}\n\nbody.dark .goal .owl-carousel .owl-nav button.owl-prev .icon,\nbody.dark .goal .owl-carousel .owl-nav button.owl-next .icon {\n  fill: #ffffff;\n}\n\nbody.dark .goal .owl-carousel .owl-nav button.owl-prev:hover,\nbody.dark .goal .owl-carousel .owl-nav button.owl-next:hover {\n  background: #6C5DD3;\n}\n\n.schedules__container {\n  position: relative;\n  display: flex;\n  padding: 32px 32px 32px 16px;\n  border-radius: 24px;\n  background: #ffffff;\n}\n\n@media only screen and (max-width: 1339px) {\n  .schedules__container {\n    display: block;\n    padding: 0;\n    background: none;\n    border-radius: 0;\n  }\n}\n\n.schedules__container:before {\n  content: \"\";\n  position: absolute;\n  top: 35px;\n  left: 35px;\n  right: 35px;\n  bottom: -35px;\n  z-index: -5;\n  background: #E3E6EC;\n  opacity: 0.91;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  .schedules__container:before {\n    filter: blur(46.985px);\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .schedules__container:before {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .schedules__col {\n    position: relative;\n    padding: 32px;\n    border-radius: 24px;\n    background: #ffffff;\n  }\n  .schedules__col:before {\n    content: \"\";\n    position: absolute;\n    top: 35px;\n    left: 35px;\n    right: 35px;\n    bottom: -35px;\n    z-index: -5;\n    background: #E3E6EC;\n    opacity: 0.91;\n    filter: blur(86.985px);\n    border-radius: 24px;\n  }\n}\n\n@media only screen and (max-width: 1339px) and (max-width: 767px) {\n  .schedules__col:before {\n    filter: blur(46.985px);\n  }\n}\n\n.schedules__col:first-child {\n  flex-shrink: 0;\n  width: 310px;\n}\n\n@media only screen and (max-width: 1339px) {\n  .schedules__col:first-child {\n    width: 100%;\n    margin-bottom: 32px;\n  }\n}\n\n.schedules__col:first-child .schedules__title {\n  display: none;\n}\n\n@media only screen and (max-width: 1339px) {\n  .schedules__col:first-child .schedules__title {\n    display: block;\n  }\n}\n\n.schedules__col:nth-child(2) {\n  flex-grow: 1;\n  padding-left: 16px;\n}\n\n@media only screen and (max-width: 1339px) {\n  .schedules__col:nth-child(2) {\n    padding-left: 32px;\n  }\n}\n\n.schedules__list {\n  margin-top: -8px;\n}\n\n@media only screen and (max-width: 1339px) {\n  .schedules__list {\n    display: flex;\n    flex-wrap: wrap;\n    margin: -32px -32px 0;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .schedules__list {\n    display: block;\n    margin: 0 -16px;\n  }\n}\n\n.schedules__item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 8px 16px;\n  border-radius: 12px;\n  background: transparent;\n  color: #11142D;\n  transition: all .25s;\n}\n\n@media only screen and (max-width: 1339px) {\n  .schedules__item {\n    flex: 0 0 calc(50% - 32px);\n    width: calc(50% - 32px);\n    margin: 32px 16px 0;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .schedules__item {\n    flex: 0 0 100%;\n    width: 100%;\n    margin: 0;\n  }\n}\n\n.schedules__item:before {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 10px;\n  right: 10px;\n  height: 6px;\n  border-radius: 0 0 6px 6px;\n  background: #CFC8FF;\n  opacity: 0;\n  transition: opacity .25s;\n}\n\n.schedules__item:hover {\n  color: #6C5DD3;\n}\n\n.schedules__item:hover .icon {\n  fill: #6C5DD3;\n}\n\n.schedules__item.active {\n  background: #6C5DD3;\n  color: #ffffff;\n}\n\n.schedules__item.active:before {\n  opacity: 1;\n}\n\n.schedules__item:not(:last-child) {\n  margin-bottom: 24px;\n}\n\n@media only screen and (max-width: 1339px) {\n  .schedules__item:not(:last-child) {\n    margin-bottom: 0;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .schedules__item:not(:last-child) {\n    margin-bottom: 24px;\n  }\n}\n\n.schedules__date {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 88px;\n  height: 80px;\n  margin-right: 24px;\n  padding-top: 7px;\n  border-radius: 12px;\n}\n\n.schedules__date:before {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 9px;\n  right: 9px;\n  height: 7px;\n  border-radius: 0 0 10px 10px;\n}\n\n.schedules__date.bg-pink-light:before {\n  background: rgba(255, 235, 246, 0.5);\n}\n\n.schedules__date.bg-purple-light:before {\n  background: rgba(207, 200, 255, 0.5);\n}\n\n.schedules__date.bg-blue-light:before {\n  background: rgba(160, 215, 231, 0.5);\n}\n\n.schedules__date.bg-yellow-light:before {\n  background: rgba(255, 226, 172, 0.5);\n}\n\n.schedules__name {\n  line-height: 1;\n  color: #808191;\n}\n\n.schedules__details {\n  flex-grow: 1;\n}\n\n.schedules__category {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px;\n  padding-right: 35px;\n}\n\n.schedules__category .icon {\n  position: absolute;\n  top: 5px;\n  right: 20px;\n  font-size: 10px;\n  transition: all .25s;\n}\n\n.schedules__info {\n  margin-bottom: 8px;\n  color: #808191;\n}\n\n.schedules__time {\n  display: inline-block;\n  padding: 3px 10px;\n  background: #6C5DD3;\n  border-radius: 8px;\n  color: #ffffff;\n}\n\n.schedules__item.active .schedules__name,\n.schedules__item.active .schedules__info {\n  color: #ffffff;\n}\n\n.schedules__item.active .schedules__category .icon {\n  transform: translateX(4px);\n  fill: #ffffff;\n}\n\n.schedules__item.active .schedules__date {\n  background: transparent;\n}\n\n.schedules__item.active .schedules__date:before {\n  background: transparent;\n}\n\n.schedules__item.active .schedules__time {\n  background: #FFEBF6;\n  color: #11142D;\n}\n\n.schedules__top {\n  display: flex;\n  align-items: center;\n  margin-bottom: 32px;\n}\n\n@media only screen and (max-width: 767px) {\n  .schedules__top {\n    margin: -16px 0 20px;\n  }\n}\n\n.schedules__arrows {\n  display: none;\n  margin-left: auto;\n  margin-right: -16px;\n}\n\n@media only screen and (max-width: 767px) {\n  .schedules__arrows {\n    display: flex;\n  }\n}\n\n.schedules__arrow {\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);\n  background: #ffffff;\n  font-size: 0;\n  transition: background .25s;\n}\n\n.schedules__arrow .icon {\n  font-size: 10px;\n  fill: #11142D;\n  transition: fill .25s;\n}\n\n.schedules__arrow:hover {\n  background: #6C5DD3;\n}\n\n.schedules__arrow:hover .icon {\n  fill: #ffffff;\n}\n\n.schedules__arrow:not(:last-child) {\n  margin-right: 8px;\n}\n\n.schedules__col > .schedules__title {\n  margin-bottom: 32px;\n}\n\n.schedules__btn {\n  display: none;\n}\n\n@media only screen and (max-width: 1339px) {\n  .schedules__btn {\n    display: inline-block;\n    margin-top: 32px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .schedules__inner {\n    display: flex;\n    margin: 0 -32px;\n    padding-bottom: 32px;\n    overflow: auto;\n    overflow-x: auto;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    -webkit-overflow-scrolling: touch;\n  }\n  .schedules__inner::-webkit-scrollbar {\n    display: none;\n  }\n  .schedules__inner:before, .schedules__inner:after {\n    content: \"\";\n    display: inline-block;\n    flex-shrink: 0;\n    width: 32px;\n    height: 1px;\n  }\n}\n\n.schedules__graphic {\n  position: relative;\n  max-width: 586px;\n  border-radius: 16px;\n  border: 1px solid #E4E4E4;\n}\n\n@media only screen and (max-width: 1339px) {\n  .schedules__graphic {\n    max-width: 100%;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .schedules__graphic {\n    min-width: 586px;\n    margin-bottom: 7px;\n  }\n}\n\n.schedules__graphic:before {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 14px;\n  right: 14px;\n  height: 7px;\n  border-radius: 0 0 7px 7px;\n  border-width: 0 1px 1px;\n  border-style: solid;\n  border-color: #E4E4E4;\n}\n\n.schedules__head {\n  display: flex;\n  align-items: center;\n  height: 68px;\n  border-bottom: 1px solid #E4E4E4;\n}\n\n.schedules__option {\n  flex-shrink: 0;\n  width: 138px;\n  padding-left: 32px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #808191;\n}\n\n.schedules__week {\n  display: flex;\n  flex-grow: 1;\n}\n\n.schedules__cell {\n  flex: 0 0 16.666%;\n  width: 16.666%;\n}\n\n.schedules__day {\n  position: relative;\n  display: inline-block;\n  min-width: 32px;\n  margin-left: -16px;\n  background: transparent;\n  border-radius: 50%;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 32px;\n}\n\n.schedules__day:before {\n  content: \"\";\n  position: absolute;\n  top: 6px;\n  right: -4px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.schedules__day.active {\n  background: #FF754C;\n  color: #ffffff;\n}\n\n.schedules__day.green:before {\n  background: #7FBA7A;\n}\n\n.schedules__day.purple:before {\n  background: #6C5DD3;\n}\n\n.schedules__day.gray:before {\n  background: #E4E4E4;\n}\n\n.schedules__body {\n  position: relative;\n  padding: 26px 0 22px;\n}\n\n.schedules__grid {\n  position: absolute;\n  top: 0;\n  left: 138px;\n  right: 0;\n  bottom: 0;\n}\n\n.schedules__line {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: #E4E4E4;\n  pointer-events: none;\n}\n\n.schedules__line:first-child {\n  left: 8.33%;\n}\n\n.schedules__line:nth-child(2) {\n  left: 25%;\n}\n\n.schedules__line:nth-child(3) {\n  left: 41.66%;\n}\n\n.schedules__line:nth-child(4) {\n  left: 58.33%;\n}\n\n.schedules__line:nth-child(5) {\n  left: 75%;\n}\n\n.schedules__row {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n}\n\n.schedules__row:not(:last-child) {\n  margin-bottom: 18px;\n}\n\n.schedules__task {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 32px;\n  padding: 0 2px;\n  border-radius: 8px;\n}\n\n.schedules__task .schedules__text {\n  padding: 0 15px;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 28px;\n}\n\n@media only screen and (max-width: 1023px) {\n  .schedules__task .schedules__text {\n    padding: 0 10px;\n  }\n}\n\n.schedules__legend {\n  display: flex;\n  margin-top: 32px;\n  padding: 0 16px;\n}\n\n@media only screen and (max-width: 767px) {\n  .schedules__legend {\n    flex-wrap: wrap;\n    margin-top: -10px;\n    padding: 0;\n  }\n}\n\n.schedules__status {\n  position: relative;\n  padding-left: 20px;\n  font-size: 12px;\n  line-height: 1.2;\n  font-weight: 500;\n  color: #808191;\n}\n\n@media only screen and (max-width: 767px) {\n  .schedules__status {\n    margin-top: 10px;\n  }\n}\n\n.schedules__status:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n}\n\n.schedules__status.green:before {\n  background: #7FBA7A;\n}\n\n.schedules__status.purple:before {\n  background: #6C5DD3;\n}\n\n.schedules__status.gray:before {\n  background: #E4E4E4;\n}\n\n.schedules__status:not(:last-child) {\n  margin-right: 120px;\n}\n\n@media only screen and (max-width: 1339px) {\n  .schedules__status:not(:last-child) {\n    margin-right: auto;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .schedules__status:not(:last-child) {\n    margin-right: 15px;\n  }\n}\n\n.schedules:not(:last-child) {\n  margin-bottom: 36px;\n}\n\nbody.dark .schedules__container {\n  background: #242731;\n}\n\n@media only screen and (max-width: 1339px) {\n  body.dark .schedules__container {\n    background: none;\n  }\n}\n\nbody.dark .schedules__container:before {\n  background: #000;\n  opacity: 0.51;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .schedules__container:before {\n    filter: blur(46.985px);\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  body.dark .schedules__col {\n    background: #242731;\n  }\n  body.dark .schedules__col:before {\n    background: #000;\n    opacity: 0.51;\n    filter: blur(86.985px);\n    border-radius: 24px;\n  }\n}\n\n@media only screen and (max-width: 1339px) and (max-width: 767px) {\n  body.dark .schedules__col:before {\n    filter: blur(46.985px);\n  }\n}\n\nbody.dark .schedules__item {\n  color: #ffffff;\n}\n\nbody.dark .schedules__category .icon {\n  fill: #ffffff;\n}\n\nbody.dark .schedules__name, body.dark .schedules__number {\n  color: #5F75EE;\n}\n\nbody.dark .schedules__item:hover {\n  color: #6C5DD3;\n}\n\nbody.dark .schedules__item:hover .icon {\n  fill: #6C5DD3;\n}\n\nbody.dark .schedules__item.active,\nbody.dark .schedules__item.active .schedules__number {\n  color: #ffffff;\n}\n\nbody.dark .schedules__item.active .icon {\n  fill: #ffffff;\n}\n\nbody.dark .schedules__graphic {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .schedules__graphic:before {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .schedules__head {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .schedules__day.gray:before, body.dark .schedules__status.gray:before {\n  background: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .schedules__line {\n  background: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .schedules__task .schedules__text {\n  background: rgba(36, 39, 49, 0.8);\n}\n\nbody.dark .schedules__arrow {\n  background: #242731;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.35);\n}\n\nbody.dark .schedules__arrow .icon {\n  fill: #ffffff;\n}\n\n.tabs__row {\n  display: flex;\n  margin: -20px 0 14px -16px;\n}\n\n@media only screen and (max-width: 767px) {\n  .tabs__row {\n    display: block;\n    margin: -20px -16px;\n  }\n}\n\n.tabs__col:first-child {\n  flex: 0 0 53%;\n  width: 53%;\n}\n\n@media only screen and (max-width: 767px) {\n  .tabs__col:first-child {\n    width: 100%;\n  }\n}\n\n.tabs__col:nth-child(2) {\n  flex: 0 0 47%;\n  width: 47%;\n  padding-top: 20px;\n}\n\n@media only screen and (max-width: 767px) {\n  .tabs__col:nth-child(2) {\n    display: none;\n  }\n}\n\n.tabs__list {\n  margin-left: -16px;\n}\n\n.tabs__item {\n  display: flex;\n  align-items: center;\n  padding: 20px 16px;\n  border-radius: 16px;\n  color: #11142D;\n  transition: all .25s;\n}\n\n.tabs__item:hover {\n  color: #6C5DD3;\n}\n\n.tabs__item:hover .icon {\n  fill: #6C5DD3;\n}\n\n.tabs__item.active {\n  background: #FFEBF6;\n  color: #11142D;\n}\n\n.tabs__item.active .icon {\n  fill: #11142D;\n}\n\n.tabs__preview {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 88px;\n  height: 80px;\n  margin-right: 16px;\n  border-radius: 12px;\n  font-size: 0;\n}\n\n@media only screen and (max-width: 1339px) {\n  .tabs__preview {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .tabs__preview {\n    display: block;\n  }\n}\n\n.tabs__pic {\n  max-height: 100%;\n}\n\n.tabs__details {\n  flex-grow: 1;\n}\n\n.tabs__category {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-bottom: 3px;\n  padding-right: 20px;\n}\n\n.tabs__category .icon {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  font-size: 10px;\n  transition: transform .25s;\n}\n\n.tabs__info {\n  margin-bottom: 8px;\n  color: #808191;\n}\n\n.tabs__price {\n  display: inline-block;\n  padding: 3px 10px;\n  background: #6C5DD3;\n  border-radius: 8px;\n  color: #ffffff;\n}\n\n.tabs__nav {\n  display: flex;\n  padding: 3px;\n  border-radius: 12px;\n  border: 1px solid #E4E4E4;\n}\n\n@media only screen and (max-width: 767px) {\n  .tabs__nav {\n    display: none;\n  }\n}\n\n.tabs__link {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex: 0 0 25%;\n  width: 25%;\n  padding: 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.2;\n  color: #808191;\n  transition: all .25s;\n}\n\n.tabs__link:hover {\n  color: #6C5DD3;\n}\n\n.tabs__link:hover .icon {\n  fill: #6C5DD3;\n}\n\n.tabs__link.active {\n  background: #6C5DD3;\n  color: #ffffff;\n}\n\n.tabs__link.active .icon {\n  fill: #ffffff;\n}\n\n.tabs__icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 24px;\n  height: 24px;\n  margin-bottom: 5px;\n  font-size: 0;\n}\n\n.tabs__icon .icon {\n  font-size: 18px;\n  fill: #11142D;\n  transition: fill .25s;\n}\n\n.tabs__chart {\n  max-width: 190px;\n  height: 140px;\n  margin: 0 auto 20px;\n}\n\n.tabs__desc {\n  text-align: center;\n}\n\n.tabs__title {\n  margin-bottom: 10px;\n}\n\n.tabs__date {\n  margin-bottom: 50px;\n  color: #808191;\n}\n\n.tabs__btn {\n  min-width: 180px;\n}\n\nbody.dark .tabs__item {\n  color: #ffffff;\n}\n\nbody.dark .tabs__item:hover {\n  color: #6C5DD3;\n}\n\nbody.dark .tabs__item:hover .icon {\n  fill: #6C5DD3;\n}\n\nbody.dark .tabs__item.active {\n  color: #11142D;\n}\n\nbody.dark .tabs__item.active .tabs__category .icon {\n  fill: #11142D;\n}\n\nbody.dark .tabs__category .icon {\n  fill: #ffffff;\n}\n\nbody.dark .tabs__nav {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .tabs__icon .icon {\n  fill: #ffffff;\n}\n\nbody.dark .tabs__link:hover {\n  color: #ffffff;\n}\n\n.payment__row {\n  display: flex;\n}\n\n@media only screen and (max-width: 767px) {\n  .payment__row {\n    display: block;\n  }\n}\n\n.payment__details {\n  flex-shrink: 0;\n  width: 225px;\n  margin-right: 16px;\n  padding: 32px;\n  border-radius: 16px;\n  box-shadow: 0 10px 36px rgba(227, 230, 236, 0.6);\n  text-align: center;\n}\n\n@media only screen and (max-width: 767px) {\n  .payment__details {\n    width: 100%;\n    margin: 0 0 32px;\n  }\n}\n\n.payment__preview {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 80px;\n  height: 80px;\n  margin-bottom: 32px;\n  border-radius: 24px;\n  font-size: 0;\n}\n\n.payment__preview .payment__pic {\n  max-height: 100%;\n}\n\n.payment__pic_white {\n  display: none;\n}\n\n.payment__mail {\n  margin-bottom: 16px;\n  color: #7FBA7A;\n}\n\n.payment__info {\n  width: 100%;\n  max-width: 140px;\n  color: #B2B3BD;\n}\n\n.payment__details .payment__info {\n  margin: 0 auto 32px;\n}\n\n.payment__logo {\n  font-size: 0;\n}\n\n.payment__details .payment__logo {\n  display: inline-block;\n}\n\n.payment__logo .payment__pic {\n  max-width: 87px;\n  max-height: 30px;\n}\n\n.payment__variants {\n  flex-grow: 1;\n}\n\n.payment__label {\n  display: block;\n  position: relative;\n  user-select: none;\n  cursor: pointer;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.payment__label:not(:last-child) {\n  margin-bottom: 18px;\n}\n\n.payment__radio {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n\n.payment__in {\n  display: flex;\n  padding: 34px 32px;\n  border-radius: 16px;\n  box-shadow: inset 0 0 0 1px #E3E6EC;\n  transition: box-shadow .25s;\n}\n\n.payment__tick {\n  position: relative;\n  flex: 0 0 16px;\n  width: 16px;\n  height: 16px;\n  margin-right: 36px;\n  border-radius: 4px;\n  border: 2px solid #E4E4E4;\n  transition: all .25s;\n}\n\n@media only screen and (max-width: 767px) {\n  .payment__tick {\n    margin-right: 24px;\n  }\n}\n\n.payment__tick:before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 8px;\n  height: 7px;\n  opacity: 0;\n  background: url(\"data:image/svg+xml,%3Csvg width='10' height='9' viewBox='0 0 10 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.5 5.375L1.5 3.375L0 4.875L3.5 8.375L10 1.875L8.5 0.375L3.5 5.375Z' fill='white'/%3E%3C/svg%3E%0A\") no-repeat 50% 50%/100% auto;\n  transition: opacity .25s;\n}\n\n.payment__desc .payment__logo {\n  display: flex;\n  align-items: center;\n  height: 30px;\n  margin-top: -8px;\n}\n\n.payment__desc .payment__info {\n  display: block;\n  margin-top: 16px;\n}\n\n.payment__btn {\n  min-width: 132px;\n  height: 40px;\n  margin-top: 16px;\n}\n\n.payment__label:hover .payment__in {\n  box-shadow: inset 0 0 0 1px #6C5DD3;\n}\n\n.payment__radio:checked + .payment__in {\n  box-shadow: inset 0 0 0 2px #6C5DD3;\n}\n\n.payment__radio:checked + .payment__in .payment__tick {\n  background: #6C5DD3;\n  border-color: #6C5DD3;\n}\n\n.payment__radio:checked + .payment__in .payment__tick:before {\n  opacity: 1;\n}\n\nbody.dark .payment__pic_black {\n  display: none;\n}\n\nbody.dark .payment__pic_white {\n  display: inline-block;\n}\n\nbody.dark .payment__details {\n  box-shadow: 0 10px 36px rgba(0, 0, 0, 0.35);\n}\n\nbody.dark .payment__tick {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .payment__in {\n  box-shadow: inset 0 0 0 1px rgba(228, 228, 228, 0.1);\n}\n\n.inbox__tags {\n  display: flex;\n  flex-wrap: wrap;\n  margin: -18px 0 28px -18px;\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__tags {\n    margin: -10px 0 24px -10px;\n  }\n}\n\n.inbox__tag {\n  margin: 18px 0 0 18px;\n  border: 2px solid #FF754C;\n  border-radius: 12px;\n  padding: 6px 16px;\n  line-height: 1.42857;\n  font-weight: 600;\n  color: #11142D;\n  transition: all .25s;\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__tag {\n    margin: 10px 0 0 10px;\n  }\n}\n\n.inbox__tag:hover, .inbox__tag.active {\n  background: #6C5DD3;\n  border-color: #6C5DD3;\n  color: #ffffff;\n}\n\n.inbox__container {\n  position: relative;\n  padding: 32px;\n  border-radius: 24px;\n  background: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__container {\n    padding: 32px 24px;\n  }\n}\n\n.inbox__container:before {\n  content: \"\";\n  position: absolute;\n  top: 32px;\n  left: 18px;\n  right: 18px;\n  bottom: -32px;\n  z-index: -1;\n  background: #E3E6EC;\n  opacity: 0.91;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__container:before {\n    filter: blur(46.985px);\n  }\n}\n\n.inbox__container > .inbox__title {\n  margin-bottom: 16px;\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__container > .inbox__title {\n    margin: 0;\n  }\n}\n\n.inbox__list {\n  margin: 0 -16px;\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__list {\n    margin: 0;\n  }\n}\n\n.inbox__item {\n  display: flex;\n  padding: 32px 16px;\n  border-radius: 12px;\n  background: transparent;\n  color: #808191;\n  cursor: pointer;\n  transition: all .25s;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__item {\n    padding: 24px 0;\n    border-radius: 0;\n    border-bottom: 1px solid #E4E4E4;\n  }\n}\n\n.inbox__ava {\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  font-size: 0;\n}\n\n.inbox__ava .inbox__pic {\n  width: 100%;\n  min-height: 100%;\n  border-radius: 50%;\n}\n\n.inbox__details {\n  flex: 0 0 calc(100% - 48px);\n  width: calc(100% - 48px);\n  padding-left: 24px;\n}\n\n@media only screen and (max-width: 1339px) {\n  .inbox__details {\n    padding-left: 16px;\n  }\n}\n\n.inbox__head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__head {\n    height: 48px;\n    display: flex;\n    align-items: center;\n  }\n}\n\n.inbox__author {\n  color: #5F75EE;\n  transition: color .25s;\n}\n\n.inbox__time {\n  margin-left: 10px;\n}\n\n.inbox__item .inbox__title {\n  margin-bottom: 18px;\n  color: #11142D;\n  transition: color .25s;\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__item .inbox__title {\n    margin-left: -64px;\n  }\n}\n\n.inbox__text {\n  margin-bottom: 16px;\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__text {\n    margin-left: -64px;\n  }\n}\n\n.inbox__text p:not(:last-child) {\n  margin-bottom: 20px;\n}\n\n.inbox__item:hover {\n  background: rgba(228, 228, 228, 0.3);\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__item:hover {\n    background: none;\n  }\n}\n\n.inbox__item.active {\n  background: #6C5DD3;\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__item.active {\n    background: none;\n    color: #808191;\n  }\n}\n\n.inbox__item.active .actions__btn {\n  border-color: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__item.active .actions__btn {\n    border-color: #E4E4E4;\n  }\n}\n\n.inbox__item.active .actions__btn .icon {\n  fill: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__item.active .actions__btn .icon {\n    fill: #1B1D21;\n  }\n}\n\n.inbox__item.active .inbox__title,\n.inbox__item.active .inbox__author {\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__item.active .inbox__title {\n    color: #11142D;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__item.active .inbox__author {\n    color: #808191;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox .actions {\n    margin-left: -64px;\n  }\n}\n\n.inbox__foot {\n  padding-top: 12px;\n  text-align: center;\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__foot {\n    padding-top: 24px;\n  }\n}\n\n.inbox__foot .inbox__btn {\n  min-width: 180px;\n}\n\n.inbox__control {\n  display: flex;\n  margin-bottom: 60px;\n}\n\n@media only screen and (max-width: 1339px) {\n  .inbox__control {\n    margin-bottom: 32px;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .inbox__control {\n    display: block;\n  }\n}\n\n.inbox__btns {\n  display: flex;\n  align-items: center;\n  margin-right: auto;\n}\n\n@media only screen and (max-width: 1179px) {\n  .inbox__btns {\n    margin: 0 -8px;\n  }\n}\n\n.inbox__btns .inbox__btn {\n  min-width: 140px;\n}\n\n@media only screen and (max-width: 1339px) {\n  .inbox__btns .inbox__btn {\n    min-width: 120px;\n    height: 48px;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .inbox__btns .inbox__btn {\n    flex: 0 0 calc(50% - 16px);\n    min-width: calc(50% - 16px);\n    margin: 0 8px;\n  }\n}\n\n.inbox__btns .inbox__btn:not(:last-child) {\n  margin-right: 16px;\n}\n\n@media only screen and (max-width: 1179px) {\n  .inbox__btns .inbox__btn:not(:last-child) {\n    margin-right: 8px;\n  }\n}\n\n.inbox__more {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  font-size: 0;\n  transition: box-shadow .25s;\n}\n\n@media only screen and (max-width: 1179px) {\n  .inbox__more {\n    display: none;\n  }\n}\n\n.inbox__more .icon {\n  font-size: 6px;\n  fill: #11142D;\n}\n\n.inbox__more:hover {\n  box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);\n}\n\n.inbox__box {\n  display: flex;\n}\n\n.inbox__box:not(:last-child) {\n  margin-bottom: 40px;\n  padding-bottom: 40px;\n  border-bottom: 1px solid #E4E4E4;\n}\n\n@media only screen and (max-width: 1179px) {\n  .inbox__box:not(:last-child) {\n    margin-bottom: 32px;\n    padding: 0;\n    border: none;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__box:not(:last-child) {\n    margin-bottom: 24px;\n  }\n}\n\n.inbox__box .inbox__author {\n  color: #11142D;\n}\n\n.inbox__box .inbox__time {\n  margin-left: 24px;\n  color: #B2B3BD;\n}\n\n.inbox__box .inbox__title {\n  margin-bottom: 32px;\n}\n\n@media only screen and (max-width: 1179px) {\n  .inbox__box .inbox__title {\n    font-size: 18px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox__box .inbox__title {\n    margin: 0 0 24px -64px;\n  }\n}\n\n.inbox__box .inbox__text {\n  color: #808191;\n}\n\n.inbox .files {\n  margin-top: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox .files {\n    margin: 16px 0 0 -64px;\n  }\n}\n\n.inbox .sorting {\n  margin-bottom: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  .inbox .sorting {\n    padding: 0;\n  }\n}\n\nbody.dark .inbox__tag {\n  color: #ffffff;\n}\n\nbody.dark .inbox__container {\n  background: #242731;\n}\n\nbody.dark .inbox__container:before {\n  background: #000;\n  opacity: 0.51;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .inbox__container:before {\n    filter: blur(46.985px);\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .inbox__item {\n    border-color: rgba(228, 228, 228, 0.1);\n  }\n}\n\nbody.dark .inbox__item:hover {\n  background: rgba(228, 228, 228, 0.04);\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .inbox__item:hover {\n    background: none;\n  }\n}\n\nbody.dark .inbox__item.active {\n  background: #6C5DD3;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .inbox__item.active {\n    background: none;\n  }\n}\n\nbody.dark .inbox__title {\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .inbox__author {\n    color: #ffffff;\n  }\n}\n\nbody.dark .inbox__item.active .inbox__title {\n  color: #ffffff;\n}\n\nbody.dark .inbox__item.active .inbox__author {\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .inbox__item.active .actions__btn {\n    border-color: rgba(228, 228, 228, 0.1);\n  }\n  body.dark .inbox__item.active .actions__btn .icon {\n    fill: #ffffff;\n  }\n}\n\nbody.dark .inbox__more .icon {\n  fill: #ffffff;\n}\n\nbody.dark .inbox__more:hover {\n  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.35);\n}\n\nbody.dark .inbox__box {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .inbox__box .inbox__author {\n  color: #ffffff;\n}\n\n.actions {\n  display: flex;\n}\n\n.actions__btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1px solid #E4E4E4;\n  font-size: 0;\n  transition: all .25s;\n}\n\n.actions__btn .icon {\n  font-size: 12px;\n  fill: #1B1D21;\n  opacity: .4;\n  transition: all .25s;\n}\n\n.actions__btn:hover .icon {\n  opacity: .75;\n}\n\n.actions__btn:not(:last-child) {\n  margin-right: 16px;\n}\n\nbody.dark .actions__btn {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .actions__btn .icon {\n  fill: #ffffff;\n}\n\n.files__list {\n  display: flex;\n  margin: -8px -4px 0;\n}\n\n@media only screen and (max-width: 1339px) {\n  .files__list {\n    display: block;\n    margin: 0;\n  }\n}\n\n.files__item {\n  display: flex;\n  align-items: center;\n  padding: 4px;\n  border-radius: 16px;\n  color: #11142D;\n  transition: opacity .25s;\n}\n\n.files__item.purple {\n  background: rgba(207, 200, 255, 0.5);\n}\n\n.files__item.purple .files__preview {\n  background: #CFC8FF;\n}\n\n.files__item.blue {\n  background: #E7FAFF;\n}\n\n.files__item.blue .files__preview {\n  background: #A0D7E7;\n}\n\n.files__item:hover {\n  opacity: .8;\n}\n\n.files > .files__item:not(:last-child) {\n  margin-bottom: 10px;\n}\n\n.files__list .files__item {\n  flex: 0 0 calc(50% - 8px);\n  width: calc(50% - 8px);\n  margin: 4px 4px 0;\n}\n\n@media only screen and (max-width: 1339px) {\n  .files__list .files__item {\n    width: 100%;\n    margin: 0;\n  }\n}\n\n@media only screen and (max-width: 1339px) {\n  .files__list .files__item:not(:last-child) {\n    margin-bottom: 16px;\n  }\n}\n\n.files__preview {\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  overflow: hidden;\n  font-size: 0;\n}\n\n.files__pic {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.files__details {\n  flex: 0 0 calc(100% - 48px);\n  width: calc(100% - 48px);\n  padding-left: 16px;\n}\n\n.files__title {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #5F75EE;\n}\n\nbody.dark .files__item {\n  background: rgba(228, 228, 228, 0.1);\n  color: #ffffff;\n}\n\nbody.dark .files__title {\n  color: #ffffff;\n}\n\n.editor__wrap {\n  background: #fafafa;\n  border-radius: 12px;\n}\n\n.editor__head {\n  display: flex;\n  padding: 24px;\n  border-bottom: 1px solid #E4E4E4;\n}\n\n@media only screen and (max-width: 767px) {\n  .editor__head {\n    padding: 24px 16px;\n  }\n}\n\n.editor__control {\n  display: flex;\n  flex-wrap: wrap;\n  margin: -16px auto 0 -16px;\n}\n\n.editor__action {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  margin: 16px 0 0 16px;\n  border-radius: 4px;\n  background: #E4E4E4;\n  font-size: 0;\n  transition: all .25s;\n}\n\n.editor__action .icon {\n  font-size: 12px;\n  fill: #808191;\n  transition: fill .25s;\n}\n\n.editor__action:hover, .editor__action.active {\n  background: rgba(27, 29, 33, 0.3);\n}\n\n.editor__action:hover .icon, .editor__action.active .icon {\n  fill: #ffffff;\n}\n\n.editor__add {\n  position: relative;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  margin-left: 30px;\n  border-radius: 50%;\n  background: #1B1D21;\n  transition: all .25s;\n}\n\n.editor__add:before, .editor__add:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: #ffffff;\n}\n\n.editor__add:before {\n  width: 8px;\n  height: 2px;\n}\n\n.editor__add:after {\n  width: 2px;\n  height: 8px;\n}\n\n.editor__add:hover {\n  background: rgba(27, 29, 33, 0.8);\n}\n\n.editor__body {\n  padding: 32px 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  .editor__body {\n    padding: 24px 16px;\n  }\n}\n\n.editor__textarea {\n  width: 100%;\n  height: 110px;\n  border: none;\n  background: none;\n  resize: none;\n  font-size: 14px;\n}\n\n.editor__gallery {\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 360px;\n  margin: -16px 0 0 -8px;\n}\n\n.editor__preview {\n  position: relative;\n  flex: 0 0 calc(50% - 16px);\n  width: calc(50% - 16px);\n  margin: 16px 8px 0;\n  font-size: 0;\n  cursor: pointer;\n}\n\n.editor__pic {\n  border-radius: 8px;\n}\n\n.editor__close {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 2;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #ffffff;\n  font-size: 0;\n  visibility: hidden;\n  opacity: 0;\n  transition: all .25s;\n}\n\n@media only screen and (max-width: 1023px) {\n  .editor__close {\n    top: 5px;\n    right: 5px;\n    visibility: visible;\n    opacity: 1;\n  }\n}\n\n.editor__close .icon {\n  font-size: 6px;\n  fill: #1B1D21;\n  transition: transform .25s;\n}\n\n.editor__close:hover .icon {\n  transform: rotate(90deg);\n}\n\n.editor__preview:hover .editor__close {\n  visibility: visible;\n  opacity: 1;\n}\n\n.editor__btn {\n  min-width: 232px;\n  margin-top: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  .editor__btn {\n    min-width: 100%;\n    margin-top: 16px;\n  }\n}\n\n.editor__btn.btn_wide {\n  min-width: 100%;\n}\n\n.editor .files {\n  width: 100%;\n  margin-top: 24px;\n}\n\nbody.dark .editor__wrap {\n  background: rgba(228, 228, 228, 0.03);\n}\n\nbody.dark .editor__head {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .editor__action {\n  background: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .editor__action.active {\n  background: #1B1D21;\n}\n\nbody.dark .editor__textarea {\n  color: #ffffff;\n}\n\nbody.dark .editor__close {\n  background: #242731;\n}\n\nbody.dark .editor__close .icon {\n  fill: #ffffff;\n}\n\n.notification__tags {\n  display: flex;\n  flex-wrap: wrap;\n  margin: -18px 0 28px -18px;\n}\n\n@media only screen and (max-width: 767px) {\n  .notification__tags {\n    margin: -10px 0 24px -10px;\n  }\n}\n\n.notification__tag {\n  margin: 18px 0 0 18px;\n  border: 2px solid #E4E4E4;\n  border-radius: 12px;\n  padding: 6px 16px;\n  line-height: 1.42857;\n  font-weight: 600;\n  color: #11142D;\n  transition: all .25s;\n}\n\n@media only screen and (max-width: 767px) {\n  .notification__tag {\n    margin: 10px 0 0 10px;\n  }\n}\n\n.notification__tag:hover, .notification__tag.active {\n  background: #6C5DD3;\n  border-color: #6C5DD3;\n  color: #ffffff;\n}\n\n.notification__container {\n  position: relative;\n  padding: 32px;\n  border-radius: 24px;\n  background: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  .notification__container {\n    padding: 32px 24px;\n  }\n}\n\n.notification__container:before {\n  content: \"\";\n  position: absolute;\n  top: 32px;\n  left: 32px;\n  right: 32px;\n  bottom: -32px;\n  z-index: -1;\n  background: #E3E6EC;\n  opacity: 0.91;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  .notification__container:before {\n    filter: blur(46.985px);\n  }\n}\n\n.notification__title {\n  margin-bottom: 32px;\n}\n\n@media only screen and (max-width: 767px) {\n  .notification__title {\n    margin-bottom: 16px;\n  }\n}\n\n.notification__list {\n  margin: 0 -16px;\n}\n\n@media only screen and (max-width: 767px) {\n  .notification__list {\n    margin: 0;\n  }\n}\n\n.notification__item {\n  display: flex;\n  padding: 32px 16px;\n  border-radius: 12px;\n  background: transparent;\n  color: #808191;\n  cursor: pointer;\n  transition: all .25s;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n@media only screen and (max-width: 767px) {\n  .notification__item {\n    padding: 24px 0;\n    border-radius: 0;\n    border-bottom: 1px solid #E4E4E4;\n  }\n}\n\n.notification__ava {\n  position: relative;\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  font-size: 0;\n}\n\n.notification__ava > .notification__pic {\n  width: 100%;\n  min-height: 100%;\n  border-radius: 50%;\n}\n\n.notification__status {\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid #ffffff;\n  font-size: 0;\n}\n\n.notification__details {\n  flex-grow: 1;\n  padding: 0 24px;\n}\n\n@media only screen and (max-width: 1339px) {\n  .notification__details {\n    padding-right: 0;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .notification__details {\n    padding: 0 24px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .notification__details {\n    padding: 0 0 0 16px;\n  }\n}\n\n.notification__author {\n  margin-bottom: 9px;\n  color: #11142D;\n  transition: color .25s;\n}\n\n.notification__line {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.notification__line .notification__category {\n  margin-right: 8px;\n}\n\n.notification__info {\n  margin-right: 8px;\n  color: #5F75EE;\n}\n\n@media only screen and (max-width: 767px) {\n  .notification .actions {\n    margin-left: -64px;\n  }\n}\n\n.notification__item .notification__text {\n  margin-bottom: 16px;\n}\n\n.notification__item .notification__text p:not(:last-child) {\n  margin-bottom: 20px;\n}\n\n.notification__item:hover {\n  background: rgba(228, 228, 228, 0.3);\n}\n\n@media only screen and (max-width: 767px) {\n  .notification__item:hover {\n    background: none;\n  }\n}\n\n.notification__item.active {\n  background: #6C5DD3;\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  .notification__item.active {\n    background: none;\n    color: #808191;\n  }\n}\n\n.notification__item.active .actions__btn {\n  border-color: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  .notification__item.active .actions__btn {\n    border-color: #E4E4E4;\n  }\n}\n\n.notification__item.active .actions__btn .icon {\n  fill: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  .notification__item.active .actions__btn .icon {\n    fill: #1B1D21;\n  }\n}\n\n.notification__item.active .notification__title,\n.notification__item.active .notification__author,\n.notification__item.active .notification__info {\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  .notification__item.active .notification__title {\n    color: #11142D;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .notification__item.active .notification__author {\n    color: #5F75EE;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .notification__item.active .notification__info {\n    color: #808191;\n  }\n}\n\n.notification__preview {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 96px;\n  height: 96px;\n  border-radius: 8px;\n  font-size: 0;\n}\n\n@media only screen and (max-width: 1339px) {\n  .notification__preview {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .notification__preview {\n    display: block;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .notification__preview {\n    display: none;\n  }\n}\n\n.notification__preview:before {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 7px;\n  right: 7px;\n  height: 7px;\n  border-radius: 0 0 7px 7px;\n}\n\n.notification__preview.bg-purple-light:before {\n  background: rgba(207, 200, 255, 0.5);\n}\n\n.notification__preview.bg-blue-light:before {\n  background: rgba(160, 215, 231, 0.5);\n}\n\n.notification__preview.bg-yellow:before {\n  background: rgba(255, 206, 115, 0.5);\n}\n\n.notification__preview .notification__pic {\n  max-height: 100%;\n}\n\n.notification__btns {\n  padding-top: 24px;\n  text-align: center;\n}\n\n.notification__btn {\n  min-width: 180px;\n}\n\n.notification__photo {\n  margin-bottom: 40px;\n  font-size: 0;\n}\n\n.notification__photo .notification__pic {\n  width: 100%;\n}\n\n.notification__body {\n  padding: 0 24px;\n}\n\n.notification__body:not(:last-child) {\n  margin-bottom: 32px;\n}\n\n.notification__stage {\n  margin-bottom: 16px;\n}\n\n.notification__parameters {\n  display: flex;\n  margin-bottom: 24px;\n}\n\n.notification__parameter {\n  display: flex;\n  align-items: center;\n  color: #5F75EE;\n}\n\n.notification__parameter:not(:last-child) {\n  margin-right: 16px;\n}\n\n.notification__icon {\n  margin-right: 10px;\n  font-size: 0;\n}\n\nbody.dark .notification__container {\n  background: #242731;\n}\n\nbody.dark .notification__container:before {\n  background: #000;\n  opacity: 0.51;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .notification__container:before {\n    filter: blur(46.985px);\n  }\n}\n\nbody.dark .notification__tag {\n  border-color: rgba(228, 228, 228, 0.1);\n  color: #ffffff;\n}\n\nbody.dark .notification__tag:hover {\n  border-color: #6C5DD3;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .notification__item {\n    border-color: rgba(228, 228, 228, 0.1);\n  }\n}\n\nbody.dark .notification__item:hover {\n  background: rgba(228, 228, 228, 0.04);\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .notification__item:hover {\n    background: none;\n  }\n}\n\nbody.dark .notification__item.active {\n  background: #6C5DD3;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .notification__item.active {\n    background: none;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .notification__item.active .actions__btn {\n    border-color: rgba(228, 228, 228, 0.1);\n  }\n  body.dark .notification__item.active .actions__btn .icon {\n    fill: #ffffff;\n  }\n}\n\nbody.dark .notification__item.active .notification__author {\n  color: #ffffff;\n}\n\nbody.dark .notification__item.active .notification__info {\n  color: #5F75EE;\n}\n\nbody.dark .notification__author {\n  color: #ffffff;\n}\n\n.filters__container {\n  position: relative;\n  padding: 32px;\n  background: #ffffff;\n  border-radius: 24px;\n}\n\n.filters__container:before {\n  content: \"\";\n  position: absolute;\n  top: 32px;\n  left: 17px;\n  right: 17px;\n  bottom: -32px;\n  z-index: -1;\n  background: #E3E6EC;\n  opacity: 0.91;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  .filters__container:before {\n    filter: blur(46.985px);\n  }\n}\n\n.filters__item:not(:last-child) {\n  margin-bottom: 32px;\n  padding-bottom: 32px;\n  border-bottom: 1px solid #E4E4E4;\n}\n\n.filters__title {\n  margin-bottom: 24px;\n}\n\n.filters__variants {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-bottom: 32px;\n}\n\n.filters .checkbox:not(:last-child) {\n  margin-bottom: 20px;\n}\n\n.filters__control {\n  display: flex;\n  align-items: center;\n}\n\n.filters__btns {\n  display: flex;\n  margin: 0 -5px;\n}\n\n.filters__btn {\n  flex: 0 0 calc(50% - 10px);\n  min-width: calc(50% - 10px);\n  height: 44px;\n  margin: 0 5px;\n  padding: 0;\n  font-size: 14px;\n}\n\n.filters__line {\n  display: flex;\n  margin-bottom: 32px;\n}\n\n.filters .radio:not(:last-child) {\n  margin-right: 32px;\n}\n\n.filters__reset {\n  line-height: 1.42857;\n  font-weight: 600;\n  color: #808191;\n  transition: color .25s;\n}\n\n.filters__reset:hover {\n  color: #6C5DD3;\n}\n\nbody.dark .filters__container {\n  background: #242731;\n}\n\nbody.dark .filters__container:before {\n  background: #000;\n  opacity: 0.51;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .filters__container:before {\n    filter: blur(46.985px);\n  }\n}\n\nbody.dark .filters__item {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\n.activity__row {\n  display: flex;\n}\n\n@media only screen and (max-width: 1179px) {\n  .activity__row {\n    display: block;\n  }\n}\n\n.activity__col:first-child {\n  flex-grow: 1;\n}\n\n@media only screen and (max-width: 1179px) {\n  .activity__col:first-child {\n    margin-bottom: 32px;\n  }\n}\n\n.activity__col:nth-child(2) {\n  flex-shrink: 0;\n  width: 426px;\n  padding: 32px 0 0 65px;\n}\n\n@media only screen and (max-width: 1339px) {\n  .activity__col:nth-child(2) {\n    width: 370px;\n    padding-left: 32px;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .activity__col:nth-child(2) {\n    width: 100%;\n    padding: 0;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .activity__col:nth-child(2) {\n    padding: 0 16px;\n  }\n}\n\n.activity__container {\n  position: relative;\n  padding: 32px;\n  background: #ffffff;\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  .activity__container {\n    padding: 32px 24px;\n  }\n}\n\n.activity__container:before {\n  content: \"\";\n  position: absolute;\n  top: 26px;\n  left: 19px;\n  right: 19px;\n  bottom: -26px;\n  z-index: -1;\n  background: #E3E6EC;\n  opacity: 0.91;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  .activity__container:before {\n    filter: blur(46.985px);\n  }\n}\n\n.activity__title {\n  margin-bottom: 32px;\n}\n\n@media only screen and (max-width: 767px) {\n  .activity__title {\n    margin-bottom: 16px;\n  }\n}\n\n.activity__inner {\n  display: flex;\n}\n\n@media only screen and (max-width: 1339px) {\n  .activity__inner {\n    display: block;\n  }\n}\n\n.activity__variants {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex-shrink: 0;\n  width: 130px;\n  padding-right: 15px;\n}\n\n@media only screen and (max-width: 1339px) {\n  .activity__variants {\n    display: none;\n  }\n}\n\n.activity__variants .checkbox:not(:last-child) {\n  margin-bottom: 16px;\n}\n\n.activity__list {\n  margin-right: -16px;\n}\n\n@media only screen and (max-width: 767px) {\n  .activity__list {\n    margin: 0;\n  }\n}\n\n.activity__item {\n  position: relative;\n  display: flex;\n  padding: 32px 16px;\n  overflow: hidden;\n  border-radius: 12px;\n  color: #808191;\n  cursor: pointer;\n  transition: all .25s;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n@media only screen and (max-width: 767px) {\n  .activity__item {\n    padding: 24px 0;\n    border-radius: 0;\n    border-bottom: 1px solid #E4E4E4;\n  }\n}\n\n.activity__item:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: transparent;\n  transition: background .25s;\n}\n\n@media only screen and (max-width: 767px) {\n  .activity__item:before {\n    display: none;\n  }\n}\n\n.activity__item:hover {\n  background: rgba(228, 228, 228, 0.3);\n}\n\n.activity__item.active {\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  .activity__item.active {\n    color: #808191;\n  }\n}\n\n.activity__item.active:before {\n  background: #6C5DD3;\n}\n\n.activity__ava {\n  position: relative;\n  z-index: 2;\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  font-size: 0;\n}\n\n.activity__ava > .activity__pic {\n  width: 100%;\n  min-height: 100%;\n  border-radius: 50%;\n}\n\n.activity__status {\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #FF9A7B;\n  border: 2px solid #ffffff;\n  font-size: 0;\n}\n\n.activity__details {\n  position: relative;\n  z-index: 2;\n  flex-grow: 1;\n  padding: 0 32px 0 24px;\n}\n\n@media only screen and (max-width: 1339px) {\n  .activity__details {\n    padding-right: 0;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .activity__details {\n    padding: 0 24px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .activity__details {\n    padding: 0 0 0 16px;\n  }\n}\n\n.activity__author {\n  margin-bottom: 9px;\n  color: #11142D;\n  transition: color .25s;\n}\n\n.activity__details .activity__line {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.activity__line .activity__category {\n  margin-right: 8px;\n}\n\n.activity__info {\n  margin-right: 8px;\n  color: #5F75EE;\n  transition: color .25s;\n}\n\n.activity__item .activity__text p:not(:last-child) {\n  margin-bottom: 20px;\n}\n\n.activity__item.active .activity__author,\n.activity__item.active .activity__info {\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  .activity__item.active .activity__author {\n    color: #11142D;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .activity__item.active .activity__info {\n    color: #5F75EE;\n  }\n}\n\n.activity__preview {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 96px;\n  height: 84px;\n  background: #A0D7E7;\n  border-radius: 8px;\n  font-size: 0;\n}\n\n@media only screen and (max-width: 1339px) {\n  .activity__preview {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .activity__preview {\n    display: block;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .activity__preview {\n    display: none;\n  }\n}\n\n.activity__preview:before {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 7px;\n  right: 7px;\n  height: 7px;\n  border-radius: 0 0 7px 7px;\n  background: #E7FAFF;\n}\n\n.activity__preview .activity__pic {\n  max-height: 100%;\n}\n\n.activity__btns {\n  padding-top: 24px;\n  text-align: center;\n}\n\n.activity__btn {\n  min-width: 180px;\n}\n\n.activity:not(:first-child) {\n  margin-top: 48px;\n}\n\n@media only screen and (max-width: 767px) {\n  .activity:not(:first-child) {\n    margin-top: 32px;\n  }\n}\n\nbody.dark .activity__container {\n  background: #242731;\n}\n\nbody.dark .activity__container:before {\n  background: #000;\n  opacity: 0.51;\n  filter: blur(86.985px);\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .activity__container:before {\n    filter: blur(46.985px);\n  }\n}\n\nbody.dark .activity__author {\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .activity__item {\n    border-color: rgba(228, 228, 228, 0.1);\n  }\n}\n\nbody.dark .activity__item:hover {\n  background: rgba(228, 228, 228, 0.04);\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .activity__item:hover {\n    background: none;\n  }\n}\n\nbody.dark .activity__item.active .activity__author {\n  color: #ffffff;\n}\n\n.field__label {\n  margin-bottom: 16px;\n  font-size: 12px;\n  line-height: 1.33333;\n  font-weight: 500;\n  color: #B2B3BD;\n}\n\n.field__input, .field__textarea {\n  width: 100%;\n  border-radius: 8px;\n  background: rgba(228, 228, 228, 0.3);\n  border: 2px solid transparent;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: #11142D;\n  transition: all .25s;\n}\n\n.field__input:focus, .field__textarea:focus {\n  border-color: #6C5DD3;\n  background: #ffffff;\n}\n\n.field__input {\n  height: 56px;\n  padding: 0 23px;\n}\n\n.field__textarea {\n  height: 157px;\n  padding: 15px 23px;\n  resize: none;\n}\n\nbody.dark .field__input, body.dark .field__textarea {\n  color: #ffffff;\n  background: rgba(228, 228, 228, 0.04);\n}\n\n.popup {\n  position: relative;\n  max-width: 630px;\n  margin: 15px auto;\n  background: #ffffff;\n  border-radius: 24px;\n}\n\n.popup__form {\n  padding: 32px;\n  border-radius: 24px;\n}\n\n.popup__title {\n  margin-bottom: 48px;\n}\n\n@media only screen and (max-width: 767px) {\n  .popup__title {\n    margin-bottom: 42px;\n  }\n}\n\n.popup__tags {\n  display: flex;\n  flex-wrap: wrap;\n  margin: -13px 0 32px -13px;\n}\n\n@media only screen and (max-width: 767px) {\n  .popup__tags {\n    display: none;\n  }\n}\n\n.popup__tag {\n  margin: 13px 0 0 13px;\n  border: 2px solid #FF754C;\n  border-radius: 12px;\n  padding: 6px 16px;\n  line-height: 1.42857;\n  font-weight: 600;\n  color: #11142D;\n  transition: all .25s;\n}\n\n.popup__tag:hover, .popup__tag.active {\n  background: #6C5DD3;\n  border-color: #6C5DD3;\n  color: #ffffff;\n}\n\n.popup__select {\n  min-width: 100%;\n  height: 56px;\n  margin-bottom: 32px;\n  padding: 0 40px 0 24px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: none;\n  border-radius: 12px;\n  background: rgba(228, 228, 228, 0.25) url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='7' fill='none'%3E%3Cpath fill-rule='evenodd' d='M9.293.333a.5.5 0 0 1 .39.812L5.39 6.512a.5.5 0 0 1-.781 0L.317 1.146a.5.5 0 0 1 .39-.812h8.586z' fill='%23b5b5be'/%3E%3C/svg%3E\") no-repeat calc(100% - 16px) 50%/11px 7px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #808191;\n  transition: all .25s;\n}\n\n.popup__select::-ms-expand {\n  display: none;\n}\n\n.popup__select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #000;\n}\n\n.popup__user:not(:last-child) {\n  margin-bottom: 32px;\n  padding-bottom: 32px;\n  border-bottom: 1px solid #E4E4E4;\n}\n\n@media only screen and (max-width: 767px) {\n  .popup__user:not(:last-child) {\n    padding-bottom: 24px;\n  }\n}\n\n.popup__category {\n  margin-bottom: 32px;\n  color: #B2B3BD;\n}\n\n.popup__line {\n  display: flex;\n}\n\n.popup__ava {\n  flex-shrink: 0;\n  width: 64px;\n  height: 64px;\n  font-size: 0;\n}\n\n@media only screen and (max-width: 767px) {\n  .popup__ava {\n    width: 80px;\n    height: 80px;\n  }\n}\n\n.popup__ava .popup__pic {\n  width: 100%;\n  min-height: 100%;\n  border-radius: 50%;\n  image-orientation: from-image;\n}\n\n.popup__details {\n  flex: 0 0 calc(100% - 64px);\n  width: calc(100% - 64px);\n  padding-left: 40px;\n}\n\n@media only screen and (max-width: 767px) {\n  .popup__details {\n    flex: 0 0 calc(100% - 80px);\n    width: calc(100% - 80px);\n    padding-left: 24px;\n  }\n}\n\n.popup__btns {\n  display: flex;\n  margin-bottom: 16px;\n}\n\n@media only screen and (max-width: 767px) {\n  .popup__btns {\n    display: block;\n    margin: 0 0 32px;\n  }\n}\n\n.popup__btns .popup__btn {\n  min-width: 166px;\n  height: 40px;\n}\n\n@media only screen and (max-width: 767px) {\n  .popup__btns .popup__btn {\n    min-width: 100%;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .popup__btns .popup__btn.btn_gray {\n    background: #ffffff;\n  }\n}\n\n.popup__btns .popup__btn:not(:last-child), .popup__loading:not(:last-child) {\n  margin-right: 16px;\n}\n\n@media only screen and (max-width: 767px) {\n  .popup__btns .popup__btn:not(:last-child), .popup__loading:not(:last-child) {\n    margin: 0;\n  }\n}\n\n.popup__loading {\n  position: relative;\n  overflow: hidden;\n  border-radius: 16px;\n}\n\n.popup__file {\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-size: 140px;\n  opacity: 0;\n}\n\n.popup__loading:hover .popup__btn {\n  background: #5a49ce;\n}\n\n.popup__text {\n  color: #B2B3BD;\n}\n\n@media only screen and (max-width: 767px) {\n  .popup__text {\n    margin-left: -104px;\n  }\n}\n\n.popup__fieldset {\n  margin-bottom: 24px;\n}\n\n.popup__fieldset > .popup__field:not(:last-child) {\n  margin-bottom: 20px;\n}\n\n.popup__row {\n  display: flex;\n  margin: 0 -8px;\n}\n\n@media only screen and (max-width: 767px) {\n  .popup__row {\n    display: block;\n    margin: 0;\n  }\n}\n\n.popup__row:not(:last-child) {\n  margin-bottom: 20px;\n}\n\n.popup__row .popup__field {\n  flex: 0 0 calc(50% - 16px);\n  width: calc(50% - 16px);\n  margin: 0 8px;\n}\n\n@media only screen and (max-width: 767px) {\n  .popup__row .popup__field {\n    width: 100%;\n    margin: 0;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .popup__row .popup__field:not(:last-child) {\n    margin-bottom: 24px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .popup__form > .popup__btn {\n    min-width: 100%;\n  }\n}\n\n.popup .mfp-close {\n  position: absolute;\n  top: 20px;\n  right: 32px;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  line-height: normal;\n  opacity: 1;\n  font-size: 0;\n  background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'%3E%3Cpath fill='%2311142d' d='M1.613.2l.094.083L5 3.585 8.293.293a1 1 0 0 1 1.414 0 1 1 0 0 1 .083 1.32l-.083.094L6.415 5l3.292 3.293a1 1 0 0 1-1.32 1.497l-.094-.083L5 6.415 1.707 9.707A1 1 0 0 1 .21 8.387l.083-.094L3.585 5 .293 1.707a1 1 0 0 1 0-1.414A1 1 0 0 1 1.613.21z'/%3E%3C/svg%3E\") no-repeat 50% 50%/10px auto;\n  transition: box-shadow .25s;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n@media only screen and (max-width: 767px) {\n  .popup .mfp-close {\n    right: 20px;\n    box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);\n  }\n}\n\n.popup .mfp-close:hover {\n  box-shadow: 0 5px 20px rgba(227, 230, 236, 0.85);\n}\n\n.mfp-container {\n  padding: 20px;\n}\n\n@media only screen and (max-width: 767px) {\n  .mfp-container {\n    padding: 0;\n  }\n}\n\n@media (max-width: 900px) {\n  .mfp-container {\n    padding: 30px 20px;\n  }\n}\n\n.mfp-bg {\n  background: rgba(27, 29, 33, 0.7);\n}\n\n.mfp-zoom-in .popup {\n  opacity: 0;\n  transition: all 0.2s ease-in-out;\n  transform: scale(0.8);\n}\n\n.mfp-zoom-in.mfp-bg {\n  opacity: 0;\n  transition: all 0.2s ease-out;\n}\n\n.mfp-zoom-in.mfp-ready .popup {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.mfp-zoom-in.mfp-ready.mfp-bg {\n  opacity: 0.8;\n}\n\n.mfp-zoom-in.mfp-removing .popup {\n  transform: scale(0.8);\n  opacity: 0;\n}\n\n.mfp-zoom-in.mfp-removing.mfp-bg {\n  opacity: 0;\n}\n\nbody.dark .popup {\n  background: #242731;\n}\n\nbody.dark .popup__tag {\n  color: #ffffff;\n}\n\nbody.dark .popup__user {\n  border-color: rgba(228, 228, 228, 0.1);\n}\n\nbody.dark .popup .mfp-close {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'%3E%3Cpath fill='%23ffffff' d='M1.613.2l.094.083L5 3.585 8.293.293a1 1 0 0 1 1.414 0 1 1 0 0 1 .083 1.32l-.083.094L6.415 5l3.292 3.293a1 1 0 0 1-1.32 1.497l-.094-.083L5 6.415 1.707 9.707A1 1 0 0 1 .21 8.387l.083-.094L3.585 5 .293 1.707a1 1 0 0 1 0-1.414A1 1 0 0 1 1.613.21z'/%3E%3C/svg%3E\");\n}\n\n@media only screen and (max-width: 767px) {\n  body.dark .popup .mfp-close {\n    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.35);\n  }\n}\n\nbody.dark .popup .mfp-close:hover {\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.35);\n}\n\nbody.dark .popup__select {\n  background-color: rgba(228, 228, 228, 0.04);\n}\n\nbody.dark .popup__btns .popup__btn.btn_gray {\n  background: none;\n}\n\nbody.dark .mfp-bg {\n  background: rgba(27, 29, 33, 0.9);\n}\n\n.color-green {\n  color: #7FBA7A;\n}\n\n.color-red {\n  color: #FF754C;\n}\n\n.color-white {\n  color: #ffffff;\n}\n\n.color-blue {\n  color: #3F8CFF;\n}\n\n.color-blue-dark {\n  color: #5F75EE;\n}\n\n.color-purple {\n  color: #6C5DD3;\n}\n\n.color-gray {\n  color: #808191;\n}\n\n.bg-blue {\n  background: #3F8CFF;\n}\n\n.bg-blue-opacity {\n  background: rgba(63, 140, 255, 0.3);\n}\n\n.bg-blue-light {\n  background: #A0D7E7;\n}\n\n.bg-blue-light-opacity {\n  background: rgba(160, 215, 231, 0.3);\n}\n\n.bg-yellow {\n  background: #FFCE73;\n}\n\n.bg-yellow-opacity {\n  background: rgba(255, 206, 115, 0.3);\n}\n\n.bg-yellow-light {\n  background: #FFE2AC;\n}\n\n.bg-pink {\n  background: #FFA2C0;\n}\n\n.bg-pink-opacity {\n  background: rgba(255, 162, 192, 0.3);\n}\n\n.bg-pink-light {\n  background: #FFEBF6;\n}\n\n.bg-green {\n  background: #7FBA7A;\n}\n\n.bg-green-opacity {\n  background: rgba(127, 186, 122, 0.3);\n}\n\n.bg-purple {\n  background: #6C5DD3;\n}\n\n.bg-purple-opacity {\n  background: rgba(108, 93, 211, 0.3);\n}\n\n.bg-purple-light {\n  background: #CFC8FF;\n}\n\n.bg-red {\n  background: #FF754C;\n}\n\n.bg-red-opacity {\n  background: rgba(255, 117, 76, 0.3);\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.m-auto {\n  margin: auto;\n}\n\n.ml-auto {\n  margin-left: auto;\n}\n\n.mr-auto {\n  margin-right: auto;\n}\n\n.align-baseline {\n  align-items: baseline;\n}\n\n@media only screen and (max-width: 1179px) {\n  .desktop-hide {\n    display: none;\n  }\n}\n\n.desktop-show {\n  display: none;\n}\n\n@media only screen and (max-width: 1179px) {\n  .desktop-show {\n    display: block;\n  }\n}\n\n@media only screen and (max-width: 1179px) {\n  .desktop-text-right {\n    text-align: right;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .tablet-hide {\n    display: none;\n  }\n}\n\n.tablet-show {\n  display: none;\n}\n\n@media only screen and (max-width: 1023px) {\n  .tablet-show {\n    display: block;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .tablet-text-right {\n    text-align: right;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .mobile-hide {\n    display: none;\n  }\n}\n\n.mobile-show {\n  display: none;\n}\n\n@media only screen and (max-width: 767px) {\n  .mobile-show {\n    display: block;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .mobile-text-right {\n    text-align: right;\n  }\n}\n\n.title {\n  font-size: 16px;\n  line-height: 1.1875;\n  font-weight: 600;\n}\n\n.title_lg, .title_md, .title_sm {\n  font-family: 'Poppins', sans-serif;\n  font-weight: 600;\n  letter-spacing: -1px;\n}\n\n.title_lg {\n  font-size: 96px;\n  line-height: 1.25;\n}\n\n.title_md {\n  font-size: 72px;\n  line-height: 1.22222;\n}\n\n.title_sm {\n  font-size: 64px;\n  line-height: 1.125;\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  font-family: 'Poppins', sans-serif;\n}\n\n.h1,\n.h2,\n.h3 {\n  font-weight: 600;\n  letter-spacing: -1px;\n}\n\n.h4,\n.h5,\n.h6 {\n  font-weight: 500;\n}\n\n.h1 {\n  font-size: 56px;\n  line-height: 1.14286;\n}\n\n@media only screen and (max-width: 1339px) {\n  .h1 {\n    font-size: 48px;\n    line-height: 1.5;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .h1 {\n    font-size: 40px;\n    line-height: 1.5;\n  }\n}\n\n.h2 {\n  font-size: 48px;\n  line-height: 1.5;\n}\n\n@media only screen and (max-width: 1339px) {\n  .h2 {\n    font-size: 40px;\n    line-height: 1.5;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .h2 {\n    font-size: 32px;\n    line-height: 1.5;\n    letter-spacing: -.5px;\n  }\n}\n\n.h3 {\n  font-size: 40px;\n  line-height: 1.5;\n}\n\n@media only screen and (max-width: 1023px) {\n  .h3 {\n    font-size: 32px;\n    line-height: 1.5;\n    letter-spacing: -.5px;\n  }\n}\n\n.h4 {\n  font-size: 32px;\n  line-height: 1.5;\n  letter-spacing: -.5px;\n}\n\n.h5 {\n  font-size: 24px;\n  line-height: 1.33333;\n}\n\n.h6 {\n  font-size: 18px;\n  line-height: 1.33333;\n}\n\n.caption {\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.38462;\n}\n\n.caption-sm {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.33333;\n}\n","/* Magnific Popup CSS */\n.mfp-bg {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1042;\n  overflow: hidden;\n  position: fixed;\n  background: #0b0b0b;\n  opacity: 0.8; }\n\n.mfp-wrap {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1043;\n  position: fixed;\n  outline: none !important;\n  -webkit-backface-visibility: hidden; }\n\n.mfp-container {\n  text-align: center;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  padding: 0 8px;\n  box-sizing: border-box; }\n\n.mfp-container:before {\n  content: '';\n  display: inline-block;\n  height: 100%;\n  vertical-align: middle; }\n\n.mfp-align-top .mfp-container:before {\n  display: none; }\n\n.mfp-content {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0 auto;\n  text-align: left;\n  z-index: 1045; }\n\n.mfp-inline-holder .mfp-content,\n.mfp-ajax-holder .mfp-content {\n  width: 100%;\n  cursor: auto; }\n\n.mfp-ajax-cur {\n  cursor: progress; }\n\n.mfp-zoom-out-cur, .mfp-zoom-out-cur .mfp-image-holder .mfp-close {\n  cursor: -moz-zoom-out;\n  cursor: -webkit-zoom-out;\n  cursor: zoom-out; }\n\n.mfp-zoom {\n  cursor: pointer;\n  cursor: -webkit-zoom-in;\n  cursor: -moz-zoom-in;\n  cursor: zoom-in; }\n\n.mfp-auto-cursor .mfp-content {\n  cursor: auto; }\n\n.mfp-close,\n.mfp-arrow,\n.mfp-preloader,\n.mfp-counter {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none; }\n\n.mfp-loading.mfp-figure {\n  display: none; }\n\n.mfp-hide {\n  display: none !important; }\n\n.mfp-preloader {\n  color: #CCC;\n  position: absolute;\n  top: 50%;\n  width: auto;\n  text-align: center;\n  margin-top: -0.8em;\n  left: 8px;\n  right: 8px;\n  z-index: 1044; }\n  .mfp-preloader a {\n    color: #CCC; }\n    .mfp-preloader a:hover {\n      color: #FFF; }\n\n.mfp-s-ready .mfp-preloader {\n  display: none; }\n\n.mfp-s-error .mfp-content {\n  display: none; }\n\nbutton.mfp-close,\nbutton.mfp-arrow {\n  overflow: visible;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  -webkit-appearance: none;\n  display: block;\n  outline: none;\n  padding: 0;\n  z-index: 1046;\n  box-shadow: none;\n  touch-action: manipulation; }\n\nbutton::-moz-focus-inner {\n  padding: 0;\n  border: 0; }\n\n.mfp-close {\n  width: 44px;\n  height: 44px;\n  line-height: 44px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  text-decoration: none;\n  text-align: center;\n  opacity: 0.65;\n  padding: 0 0 18px 10px;\n  color: #FFF;\n  font-style: normal;\n  font-size: 28px;\n  font-family: Arial, Baskerville, monospace; }\n  .mfp-close:hover,\n  .mfp-close:focus {\n    opacity: 1; }\n  .mfp-close:active {\n    top: 1px; }\n\n.mfp-close-btn-in .mfp-close {\n  color: #333; }\n\n.mfp-image-holder .mfp-close,\n.mfp-iframe-holder .mfp-close {\n  color: #FFF;\n  right: -6px;\n  text-align: right;\n  padding-right: 6px;\n  width: 100%; }\n\n.mfp-counter {\n  position: absolute;\n  top: 0;\n  right: 0;\n  color: #CCC;\n  font-size: 12px;\n  line-height: 18px;\n  white-space: nowrap; }\n\n.mfp-arrow {\n  position: absolute;\n  opacity: 0.65;\n  margin: 0;\n  top: 50%;\n  margin-top: -55px;\n  padding: 0;\n  width: 90px;\n  height: 110px;\n  -webkit-tap-highlight-color: transparent; }\n  .mfp-arrow:active {\n    margin-top: -54px; }\n  .mfp-arrow:hover,\n  .mfp-arrow:focus {\n    opacity: 1; }\n  .mfp-arrow:before,\n  .mfp-arrow:after {\n    content: '';\n    display: block;\n    width: 0;\n    height: 0;\n    position: absolute;\n    left: 0;\n    top: 0;\n    margin-top: 35px;\n    margin-left: 35px;\n    border: medium inset transparent; }\n  .mfp-arrow:after {\n    border-top-width: 13px;\n    border-bottom-width: 13px;\n    top: 8px; }\n  .mfp-arrow:before {\n    border-top-width: 21px;\n    border-bottom-width: 21px;\n    opacity: 0.7; }\n\n.mfp-arrow-left {\n  left: 0; }\n  .mfp-arrow-left:after {\n    border-right: 17px solid #FFF;\n    margin-left: 31px; }\n  .mfp-arrow-left:before {\n    margin-left: 25px;\n    border-right: 27px solid #3F3F3F; }\n\n.mfp-arrow-right {\n  right: 0; }\n  .mfp-arrow-right:after {\n    border-left: 17px solid #FFF;\n    margin-left: 39px; }\n  .mfp-arrow-right:before {\n    border-left: 27px solid #3F3F3F; }\n\n.mfp-iframe-holder {\n  padding-top: 40px;\n  padding-bottom: 40px; }\n  .mfp-iframe-holder .mfp-content {\n    line-height: 0;\n    width: 100%;\n    max-width: 900px; }\n  .mfp-iframe-holder .mfp-close {\n    top: -40px; }\n\n.mfp-iframe-scaler {\n  width: 100%;\n  height: 0;\n  overflow: hidden;\n  padding-top: 56.25%; }\n  .mfp-iframe-scaler iframe {\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);\n    background: #000; }\n\n/* Main image in popup */\nimg.mfp-img {\n  width: auto;\n  max-width: 100%;\n  height: auto;\n  display: block;\n  line-height: 0;\n  box-sizing: border-box;\n  padding: 40px 0 40px;\n  margin: 0 auto; }\n\n/* The shadow behind the image */\n.mfp-figure {\n  line-height: 0; }\n  .mfp-figure:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 40px;\n    bottom: 40px;\n    display: block;\n    right: 0;\n    width: auto;\n    height: auto;\n    z-index: -1;\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);\n    background: #444; }\n  .mfp-figure small {\n    color: #BDBDBD;\n    display: block;\n    font-size: 12px;\n    line-height: 14px; }\n  .mfp-figure figure {\n    margin: 0; }\n\n.mfp-bottom-bar {\n  margin-top: -36px;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  cursor: auto; }\n\n.mfp-title {\n  text-align: left;\n  line-height: 18px;\n  color: #F3F3F3;\n  word-wrap: break-word;\n  padding-right: 36px; }\n\n.mfp-image-holder .mfp-content {\n  max-width: 100%; }\n\n.mfp-gallery .mfp-image-holder .mfp-figure {\n  cursor: pointer; }\n\n@media screen and (max-width: 800px) and (orientation: landscape), screen and (max-height: 300px) {\n  /**\n       * Remove all paddings around the image on small screen\n       */\n  .mfp-img-mobile .mfp-image-holder {\n    padding-left: 0;\n    padding-right: 0; }\n  .mfp-img-mobile img.mfp-img {\n    padding: 0; }\n  .mfp-img-mobile .mfp-figure:after {\n    top: 0;\n    bottom: 0; }\n  .mfp-img-mobile .mfp-figure small {\n    display: inline;\n    margin-left: 5px; }\n  .mfp-img-mobile .mfp-bottom-bar {\n    background: rgba(0, 0, 0, 0.6);\n    bottom: 0;\n    margin: 0;\n    top: auto;\n    padding: 3px 5px;\n    position: fixed;\n    box-sizing: border-box; }\n    .mfp-img-mobile .mfp-bottom-bar:empty {\n      padding: 0; }\n  .mfp-img-mobile .mfp-counter {\n    right: 5px;\n    top: 3px; }\n  .mfp-img-mobile .mfp-close {\n    top: 0;\n    right: 0;\n    width: 35px;\n    height: 35px;\n    line-height: 35px;\n    background: rgba(0, 0, 0, 0.6);\n    position: fixed;\n    text-align: center;\n    padding: 0; } }\n\n@media all and (max-width: 900px) {\n  .mfp-arrow {\n    -webkit-transform: scale(0.75);\n    transform: scale(0.75); }\n  .mfp-arrow-left {\n    -webkit-transform-origin: 0;\n    transform-origin: 0; }\n  .mfp-arrow-right {\n    -webkit-transform-origin: 100%;\n    transform-origin: 100%; }\n  .mfp-container {\n    padding-left: 6px;\n    padding-right: 6px; } }\n","body {\n\tmin-width: 375px;\n\t@include fi;\n\tfont-size: 14px;\n\tline-height: (24/14);\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n\tcolor: $text;\n\t&.dark {\n\t\tbackground: $dark;\n\t\tcolor: $wh; }\n\t&.no-scroll {\n\t\toverflow: hidden; } }\n\nbutton,\ninput,\ntextarea,\nselect {\n\t@include fi; }\n\nimg {\n\tdisplay: block;\n\tmax-width: 100%; }\n\n@include dark {\n\t.apexcharts-tooltip.apexcharts-theme-light {\n\t\tcolor: $text; }\n\n\t.apexcharts-gridlines-horizontal line {\n\t\tstroke: $border-dark; } }\n\n\n","// media queries\n@mixin w {\n  @media only screen and (max-width: \"1419px\") {\n    @content; } }\n@mixin x {\n  @media only screen and (max-width: \"1339px\") {\n    @content; } }\n@mixin d {\n  @media only screen and (max-width: \"1179px\") {\n    @content; } }\n@mixin t {\n  @media only screen and (max-width: \"1023px\") {\n    @content; } }\n@mixin m {\n  @media only screen and (max-width: \"767px\") {\n    @content; } }\n@mixin a {\n  @media only screen and (max-width: \"639px\") {\n    @content; } }\n@mixin s {\n  @media only screen and (max-width: \"474px\") {\n    @content; } }\n\n// fonts\n@mixin fi {\n  font-family: 'Inter', sans-serif; }\n@mixin fp {\n  font-family: 'Poppins', sans-serif; }\n\n$bl: #1B1D21;\n$wh: #ffffff;\n$purple: #6C5DD3;\n$purple-light: #CFC8FF;\n$text: #11142D;\n$gray-dark: #808191;\n$gray-light: #B2B3BD;\n$red: #FF754C;\n$pink: #FFA2C0;\n$pink-light: #FFEBF6;\n$yellow: #FFCE73;\n$yellow-light: #FFE2AC;\n$blue: #3F8CFF;\n$blue-light: #A0D7E7;\n$blue-dark: #0049C6;\n$border: #E4E4E4;\n$green: #7FBA7A;\n$link: #5F75EE;\n\n// dark theme\n$dark: #242731;\n$dark1: #1F2128;\n$border-dark: rgba($border, .1);\n\n@mixin shadow {\n  background: #E3E6EC;\n  opacity: 0.91;\n  filter: blur(86.985px);\n  border-radius: 24px;\n  @include m {\n    filter: blur(46.985px); } }\n\n@mixin shadow-dark {\n  background: #000;\n  opacity: 0.51;\n  filter: blur(86.985px);\n  border-radius: 24px;\n  @include m {\n    filter: blur(46.985px); } }\n\n\n","// selectors\n@mixin nl {\n  &:not(:last-child) {\n    @content; } }\n@mixin nf {\n  &:not(:first-child) {\n    @content; } }\n\n// width\n@mixin r($width) {\n  @media only screen and (max-width: $width+ \"px\") {\n    @content; } }\n\n@mixin rmin($width) {\n  @media only screen and (min-width: $width+ \"px\") {\n    @content; } }\n\n// height\n@mixin rh($height) {\n  @media only screen and (max-height: $height + \"px\") {\n    @content; } }\n\n@mixin rhmin($height) {\n  @media only screen and (min-height: $height + \"px\") {\n    @content; } }\n\n@mixin fs($sizeValue: 16) {\n  font-size: $sizeValue + px;\n  font-size: $sizeValue / 10 + rem; }\n\n@mixin text-overflow {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n@mixin hover {\n  @media (hover: hover) {\n    &:hover {\n      @content; } } }\n\n%pseudo {\n  position: relative;\n  &:before,&:after {\n    content: ' ';\n    position: absolute;\n    top: 0;\n    left: 0; } }\n@mixin pseudo {\n  @extend %pseudo; }\n\n@mixin coverdiv {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n\n@mixin cover {\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 50%; }\n\n@mixin bg-size($width: 100%, $height: 100%) {\n  background-size: $width $height; }\n\n// retina, also available as +hdpi\n@mixin retina {\n  @media only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2) {\n    @content; } }\n\n@mixin box {\n  @include box-sizing(border-box); }\n// vertical-align at center\n@mixin vcenter {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%,-50%); }\n\n//simple gradient\n@mixin g($color1, $color2) {\n  background-image: linear-gradient($color1, $color2); }\n\n@mixin gh($color1, $color2) {\n  background-image: linear-gradient(left, $color1, $color2); }\n\n// font-family\n@mixin font($alias, $name) {\n  @font-face {\n    font-family: $alias;\n    src: url(\"fonts/\" + $name + \".woff2\") format(\"woff2\"), url(\"fonts/\" + $name + \".woff\") format(\"woff\");\n    font-weight: normal;\n    font-style: normal; } }\n// to use:\n//+font(black, cytiapro-black-webfont)\n\n// ROTATE\n@mixin rotate($deg: 0, $m11: 0, $m12: 0, $m21: 0, $m22: 0) {\n  transform: rotate($deg + deg);\n  filter: progid:DXImageTransform.Microsoft.Matrix(M11=$m11, M12=$m12,M21=$m21, M22=$m22, sizingMethod='auto expand');\n  zoom: 1; }\n\n// TRANSITION\n\n@mixin tr($what) {\n  transition: $what; }\n\n@mixin hide-text {\n  font: 0/0 a;\n  text-shadow: none;\n  color: transparent; }\n\n@mixin hidetext {\n  @include hide-text; }\n\n@mixin justify {\n  text-align: justify;\n  line-height: 0;\n  font-size: 0;\n  text-justify: newspaper;\n  zoom: 1;\n  text-align-last: justify;\n  &:after {\n    content: \"\";\n    display: inline-block;\n    width: 100%;\n    height: 0px;\n    visibility: hidden;\n    overflow: hidden; } }\n@mixin vertical {\n  text-align: center;\n  font-size: 0;\n  &:before {\n    content: \"\";\n    display: inline-block;\n    vertical-align: middle;\n    width: 0;\n    height: 100%; } }\n\n@mixin clr {\n  &:after {\n    content: \" \";\n    display: table;\n    clear: both; }\n  *zoom: 1; }\n\n@mixin placeholder-color($color) {\n  &::placeholder {\n    color: $color; } }\n\n@mixin placeholder {\n  &::placeholder {\n    @content; } }\n\n@mixin gray {\n  filter: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale\");\n  // Firefox 10+\n  filter: gray;\n  // IE6-9\n  -webkit-filter: grayscale(100%);\n  // Chrome 19+ & Safari 6+\n  filter: progid:DXImageTransform.Microsoft.BasicImage(grayScale=1);\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(grayScale=1)\"; }\n\n@mixin gray-half {\n  filter: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='saturate' values='0.5'/></filter></svg>#grayscale\");\n  // Firefox 10+\n  filter: gray alpha(opacity = 50);\n  // IE6-9\n  -webkit-filter: grayscale(50%);\n }  // Chrome 19+ & Safari 6+\n\n@mixin gray-zero {\n  filter: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='1 0 0 0 0, 0 1 0 0 0, 0 0 1 0 0, 0 0 0 1 0'/></filter></svg>#grayscale\");\n  -webkit-filter: grayscale(0%); }\n\n@mixin unselectable {\n  user-select: none; }\n\n@mixin nosel {\n  @include unselectable; }\n\n@mixin prevent-text {\n  word-break: break-all;\n  word-break: break-word;\n  hyphens: auto; }\n\n@mixin font-smoothing($val: antialiased) {\n  font-smoothing: $val; }\n\n@mixin selection {\n  & ::selection {\n    @content; } }\n@mixin sel {\n  @include selection; }\n\n@mixin gpu {\n  transform: translate3d(0, 0, 0); }\n\n@mixin scrollbar {\n  &::-webkit-scrollbar {\n    @content; } }\n\n@mixin scrollbar-track {\n  &::-webkit-scrollbar-track {\n    @content; } }\n\n@mixin scrollbar-thumb {\n  &::-webkit-scrollbar-thumb {\n    @content; } }\n\n@mixin scrollbar-track-piece {\n  &::-webkit-scrollbar-track-piece {\n    @content; } }\n\n//triangle\n@mixin arr($width, $height, $bg, $direction) {\n  width: 0px;\n  height: 0px;\n  border-style: solid;\n  @if $direction == t {\n    border-width: 0 $width / 2 + px $height + px $width / 2 + px;\n    border-color: transparent transparent $bg transparent; }\n  @if $direction == r {\n    border-width: $height / 2 + px 0 $height / 2 + px $width + px;\n    border-color: transparent transparent transparent $bg; }\n  @if $direction == b {\n    border-width: $height + px $width / 2 + px 0 $width / 2 + px;\n    border-color: $bg transparent transparent transparent; }\n  @if $direction == l {\n    border-width: $height / 2 + px $width + px $height / 2 + px 0;\n    border-color: transparent $bg transparent transparent; }\n  @if $direction == tl {\n    border-width: $height + px $width + px 0 0;\n    border-color: $bg transparent transparent transparent; }\n  @if $direction == tr {\n    border-width: 0 $width + px $height + px 0;\n    border-color: transparent $bg transparent transparent; }\n  @if $direction == br {\n    border-width: 0 0 $height + px $width + px;\n    border-color: transparent transparent $bg transparent; }\n  @if $direction == bl {\n    border-width: $width + px 0 0 $height + px;\n    border-color: transparent transparent transparent $bg; } }\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n@mixin rotate($var) {\n  transform: rotate($var+deg); }\n\n@mixin blur($var) {\n  filter: blur($var); }\n@mixin scale($var) {\n  transform: scale($var); }\n\n@mixin counter($var, $sep) {\n  counter-reset: list + $var;\n  > li {\n    &:before {\n      content: counter(list + $var) $sep;\n      counter-increment: list + $var; } } }\n\n@mixin f($name, $font-size: null, $letter-spacing: null) {\n  $font-family: null;\n  @if $name == \"l\" {\n    $font-family: \"light\"; }\n  font-family: $font-family;\n  font-weight: normal;\n  @if $font-size != null {\n    font-size: $font-size + px; }\n  @if $letter-spacing != null {\n    letter-spacing: ($letter-spacing / 1000) + em; } }\n\n@mixin dark {\n  body.dark {\n    @content; } }\n",".page {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmin-height: 100vh;\n\t@include t {\n\t\toverflow: hidden; }\n\t&__wrapper {\n\t\tflex-grow: 1;\n\t\tpadding-left: 256px;\n\t\ttransition: all .25s;\n\t\t@include t {\n\t\t\tpadding-left: 96px; }\n\t\t@include m {\n\t\t\tpadding-left: 0; } }\n\t&__center {\n\t\tmax-width: 1200px;\n\t\tmargin: 0 auto;\n\t\t@include x {\n\t\t\twidth: 100%;\n\t\t\tmax-width: 930px;\n\t\t\tpadding: 0 70px 40px; }\n\t\t@include t {\n\t\t\tpadding: 0 32px 40px; }\n\t\t@include m {\n\t\t\tpadding: 0 16px 32px; } }\n\t&__row {\n\t\tdisplay: flex;\n\t\t@include x {\n\t\t\tdisplay: block; }\n\t\t&_head {\n\t\t\t@include x {\n\t\t\t\tdisplay: flex;\n\t\t\t\tmargin: 0 -16px;\n\t\t\t\tpadding: 40px 0; }\n\t\t\t@include t {\n\t\t\t\tflex-direction: column-reverse;\n\t\t\t\tmargin: 0;\n\t\t\t\tpadding: 25px 0; }\n\t\t\t@include m {\n\t\t\t\tpadding: 0; }\n\t\t\t.page__col {\n\t\t\t\tpadding-top: 48px;\n\t\t\t\t@include x {\n\t\t\t\t\tflex: 0 0 calc(50% - 32px);\n\t\t\t\t\tmax-width: calc(50% - 32px);\n\t\t\t\t\tmargin: 0 16px;\n\t\t\t\t\tpadding: 0; }\n\t\t\t\t@include t {\n\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\t&:nth-child(2) {\n\t\t\t\t\t\tmargin-bottom: 30px; } }\n\t\t\t\t@include m {\n\t\t\t\t\t&:first-child {\n\t\t\t\t\t\tpadding: 16px 16px 28px; }\n\t\t\t\t\t&:nth-child(2) {\n\t\t\t\t\t\tmargin: 0; } } } }\n\t\t&_border {\n\t\t\t.page__col {\n\t\t\t\t&:nth-child(2) {\n\t\t\t\t\tborder-left: 1px solid $border;\n\t\t\t\t\t@include x {\n\t\t\t\t\t\tborder: none; } } } }\n\t\t&_responsive {\n\t\t\t@include x {\n\t\t\t\tdisplay: flex;\n\t\t\t\tmargin: 0 -40px; }\n\t\t\t@include d {\n\t\t\t\tdisplay: block;\n\t\t\t\tmargin: 0; }\n\t\t\t&.page__row_head {\n\t\t\t\t@include x {\n\t\t\t\t\tpadding: 0; }\n\t\t\t\t@include d {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tmargin: 0 -16px;\n\t\t\t\t\tpadding: 40px 0; }\n\t\t\t\t@include t {\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tpadding: 25px 0; }\n\t\t\t\t@include m {\n\t\t\t\t\tpadding: 0; } }\n\t\t\t&.page__row_head .page__col {\n\t\t\t\t@include x {\n\t\t\t\t\tpadding-top: 40px;\n\t\t\t\t\tpadding-bottom: 40px; }\n\t\t\t\t@include d {\n\t\t\t\t\tflex: 0 0 calc(50% - 32px);\n\t\t\t\t\tmax-width: calc(50% - 32px);\n\t\t\t\t\tmargin: 0 16px;\n\t\t\t\t\tpadding: 0; }\n\t\t\t\t@include t {\n\t\t\t\t\tflex: 0 0 100%;\n\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmargin: auto; }\n\t\t\t\t&:nth-child(2) {\n\t\t\t\t\t@include t {\n\t\t\t\t\t\tmargin-bottom: 30px; }\n\t\t\t\t\t@include m {\n\t\t\t\t\t\tmargin-bottom: 0; } } }\n\t\t\t.page__col {\n\t\t\t\t@include x {\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tpadding-left: 40px;\n\t\t\t\t\tpadding-right: 40px; }\n\t\t\t\t@include d {\n\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\tpadding-right: 0; }\n\t\t\t\t&:first-child {\n\t\t\t\t\t@include x {\n\t\t\t\t\t\tflex: 0 0 55%;\n\t\t\t\t\t\tmax-width: 55%; }\n\t\t\t\t\t@include d {\n\t\t\t\t\t\tmax-width: 100%; } }\n\t\t\t\t&:nth-child(2) {\n\t\t\t\t\t@include x {\n\t\t\t\t\t\tflex: 0 0 45%;\n\t\t\t\t\t\tmax-width: 45%;\n\t\t\t\t\t\tborder-left: 1px solid $border; }\n\t\t\t\t\t@include d {\n\t\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\t\tborder: none; } } } } }\n\t&__col {\n\t\tpadding: 0 64px 44px;\n\t\t@include w {\n\t\t\tpadding: 0 48px 44px; }\n\t\t@include x {\n\t\t\tpadding: 0; }\n\t\t&:first-child {\n\t\t\tflex: 0 0 calc(100% - 426px);\n\t\t\tmax-width: calc(100% - 426px);\n\t\t\t@include w {\n\t\t\t\tflex: 0 0 calc(100% - 390px);\n\t\t\t\tmax-width: calc(100% - 390px); }\n\t\t\t@include x {\n\t\t\t\tmax-width: 100%; } }\n\t\t&:nth-child(2) {\n\t\t\tflex-shrink: 0;\n\t\t\twidth: 426px;\n\t\t\t@include w {\n\t\t\t\twidth: 390px; }\n\t\t\t@include x {\n\t\t\t\twidth: 100%; } } }\n\t&__row:not(.page__row_head):not(.page__row_responsive) &__col:nth-child(2) {\n\t\t@include x {\n\t\t\tmargin-top: 32px; } }\n\t&__row:not(.page__row_head) &__col:nth-child(2) {\n\t\t@include d {\n\t\t\tmargin-top: 32px; }\n\t\t// +m\n }\t\t/// padding: 0 16px\n\t.page__col.page__col_w50 {\n\t\tflex: 0 0 50%;\n\t\tmax-width: 50%;\n\t\t@include x {\n\t\t\tflex: 0 0 50%;\n\t\t\tmax-width: 50%;\n\t\t\tmargin: 0;\n\t\t\tpadding-left: 40px;\n\t\t\tpadding-right: 40px; }\n\t\t@include d {\n\t\t\tpadding: 0; }\n\t\t&:first-child {\n\t\t\t@include d {\n\t\t\t\tmax-width: 100%;\n\t\t\t\tmargin-bottom: 30px; } }\n\t\t&:nth-child(2) {\n\t\t\t@include d {\n\t\t\t\tmax-width: 100%; } }\n\t\t@include nl {\n\t\t\t@include d {\n\t\t\t\tmargin-bottom: 0; } } }\n\t&__row:not(.page__row_head) .page__col.page__col_w50 {\n\t\t@include nl {\n\t\t\t@include d {\n\t\t\t\tmargin-bottom: 32px; } } }\n\t&__widgets {\n\t\tdisplay: flex;\n\t\tmargin: 0 -16px;\n\t\t@include m {\n\t\t\tdisplay: block;\n\t\t\tmargin: 0; }\n\t\t@include nl {\n\t\t\tmargin-bottom: 43px;\n\t\t\t@include m {\n\t\t\t\tmargin-bottom: 32px; } } }\n\t&__widgets .widget {\n\t\tflex: 0 0 calc(50% - 32px);\n\t\twidth: calc(50% - 32px);\n\t\tmargin: 0 16px;\n\t\t@include m {\n\t\t\twidth: 100%;\n\t\t\tmargin: 0;\n\t\t\t@include nl {\n\t\t\t\tmargin-bottom: 32px; } } }\n\t&__group {\n\t\t@include x {\n\t\t\tdisplay: flex;\n\t\t\talign-items: flex-start;\n\t\t\tmargin: 0 -16px; }\n\t\t@include m {\n\t\t\tdisplay: block;\n\t\t\tmargin: 0; }\n\t\t.widget {\n\t\t\t@include x {\n\t\t\t\tflex: 0 0 calc(50% - 32px);\n\t\t\t\tmax-width: calc(50% - 32px);\n\t\t\t\tmargin: 0 16px; }\n\t\t\t@include m {\n\t\t\t\tmax-width: 100%;\n\t\t\t\tmargin: 0; }\n\t\t\t@include nl {\n\t\t\t\tmargin-bottom: 69px;\n\t\t\t\t@include x {\n\t\t\t\t\tmargin-bottom: 0; }\n\t\t\t\t@include m {\n\t\t\t\t\tmargin-bottom: 32px; } } } }\n\t&__content {\n\t\tpadding: 0 64px 64px;\n\t\t@include w {\n\t\t\tpadding: 0 48px 48px; }\n\t\t@include x {\n\t\t\tpadding: 0 0 40px; }\n\t\t@include t {\n\t\t\tpadding: 0; }\n\t\t&_pt64 {\n\t\t\tpadding-top: 64px;\n\t\t\tborder-top: 1px solid $border;\n\t\t\t@include x {\n\t\t\t\tmargin-top: 32px;\n\t\t\t\tpadding: 0;\n\t\t\t\tborder: none; } } }\n\t&__stat {\n\t\tposition: relative;\n\t\tpadding: 50px 32px 40px;\n\t\tborder-radius: 24px;\n\t\tbackground: $wh;\n\t\t@include m {\n\t\t\tpadding: 32px 0; }\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 43px;\n\t\t\tleft: 32px;\n\t\t\tright: 32px;\n\t\t\tbottom: -43px;\n\t\t\tz-index: -1;\n\t\t\t@include shadow; }\n\t\t&_pt32 {\n\t\t\tpadding-top: 32px; }\n\t\t&_sm {\n\t\t\t.sorting {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 32px;\n\t\t\t\tright: 40px;\n\t\t\t\t@include m {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\ttop: auto;\n\t\t\t\t\tright: auto; } } } }\n\t&__flex {\n\t\tdisplay: flex;\n\t\t@include d {\n\t\t\tdisplay: block; }\n\t\t.widget {\n\t\t\t&:first-child {\n\t\t\t\tflex-shrink: 0;\n\t\t\t\twidth: 298px;\n\t\t\t\tmargin-right: 32px;\n\t\t\t\t@include d {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmargin: 0 0 32px; } }\n\t\t\t&:nth-child(2) {\n\t\t\t\tflex-grow: 1; } } }\n\t&__welcome_sm {\n\t\t@include d {\n\t\t\tfont-size: 32px; } }\n\t&__hello {\n\t\t@include x {\n\t\t\tfont-size: 18px;\n\t\t\tline-height: (24/18); }\n\t\t@include m {\n\t\t\tfont-size: 16px; } }\n\t&__title {\n\t\tmargin-bottom: 32px;\n\t\t@include m {\n\t\t\tpadding: 0 24px; } }\n\t&__nav {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 48px;\n\t\t@include d {\n\t\t\tmargin-bottom: 32px; } }\n\t&__nav &__link {\n\t\tpadding: 7px 18px;\n\t\tborder-radius: 12px;\n\t\tfont-weight: 600;\n\t\tcolor: $gray-dark;\n\t\ttransition: all .25s;\n\t\t&:hover,\n\t\t&.active {\n\t\t\tbackground: $purple;\n\t\t\tcolor: $wh; } }\n\t&.toggle &__wrapper {\n\t\t@include d {\n\t\t\tpadding-left: 96px; }\n\t\t@include t {\n\t\t\ttransform: translateX(160px); }\n\t\t@include m {\n\t\t\tpadding-left: 0;\n\t\t\ttransform: translateX(256px); } }\n\t&_other {\n\t\t@include d {\n\t\t\toverflow: hidden; } }\n\t&_other &__center {\n\t\t@include x {\n\t\t\tpadding-bottom: 0; }\n\t\t@include d {\n\t\t\tpadding-bottom: 40px; } } }\n\n@include dark {\n\t.page {\n\t\t&__row_border .page__col:nth-child(2) {\n\t\t\tborder-color: $border-dark; }\n\t\t&__stat {\n\t\t\tbackground: $dark;\n\t\t\t&:before {\n\t\t\t\t@include shadow-dark; } }\n\t\t&__content_pt64 {\n\t\t\tborder-color: $border-dark; } } }\n",".sidebar {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tflex-shrink: 0;\n\twidth: 256px;\n\theight: 100vh;\n\tpadding: 140px 0 72px;\n\tbackground: $wh;\n\tborder-right: 1px solid $border;\n\t@include d {\n\t\tpadding-top: 96px;\n\t\toverflow: hidden;\n\t\ttransition: width .25s, transform .25s; }\n\t@include t {\n\t\tz-index: 10;\n\t\twidth: 96px; }\n\t@include m {\n\t\twidth: 256px;\n\t\ttransform: translateX(-100%); }\n\t&__wrapper {\n\t\tmax-height: 100%;\n\t\tpadding: 0 20px 30px;\n\t\toverflow-y: auto;\n\t\t-ms-overflow-style: none;\n\t\tscrollbar-width: none;\n\t\t-webkit-overflow-scrolling: touch;\n\t\t@include m {\n\t\t\tpadding: 20px; }\n\t\t&::-webkit-scrollbar {\n\t\t\tdisplay: none; } }\n\t&__inner {\n\t\twidth: 215px;\n\t\toverflow: hidden;\n\t\ttransition: width .25s;\n\t\t@include t {\n\t\t\twidth: 56px; }\n\t\t@include m {\n\t\t\twidth: 100%; } }\n\t&__top {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\theight: 140px;\n\t\t@include d {\n\t\t\tjustify-content: stretch;\n\t\t\theight: 96px;\n\t\t\tpadding-left: 40px;\n\t\t\ttransition: all .25s; }\n\t\t@include t {\n\t\t\tpadding: 0; }\n\t\t@include m {\n\t\t\tpadding-left: 40px;\n\t\t\tborder-bottom: 1px solid $border; } }\n\t&__logo {\n\t\tfont-size: 0; }\n\t&__top &__logo {\n\t\t@include d {\n\t\t\ttransition: opacity .2s; }\n\t\t@include t {\n\t\t\topacity: 0; }\n\t\t@include m {\n\t\t\topacity: 1; } }\n\t&__logo &__pic {\n\t\twidth: 176px;\n\t\t@include d {\n\t\t\twidth: 140px; }\n\t\t&_white {\n\t\t\tdisplay: none; } }\n\t&__close {\n\t\tposition: relative;\n\t\ttop: -3px;\n\t\tdisplay: none;\n\t\tmargin-right: 25px;\n\t\tfont-size: 0;\n\t\t@include m {\n\t\t\tdisplay: inline-block; }\n\t\t.icon {\n\t\t\tfont-size: 20px;\n\t\t\tfill: $text; } }\n\t&__wrapper &__logo {\n\t\tdisplay: none;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\theight: 0;\n\t\toverflow: hidden;\n\t\tmargin: 0 -20px;\n\t\t@include d {\n\t\t\tdisplay: flex; }\n\t\t@include t {\n\t\t\theight: 80px; }\n\t\t@include m {\n\t\t\tdisplay: none; } }\n\t&__burger {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tdisplay: none;\n\t\twidth: 96px;\n\t\theight: 96px;\n\t\tpadding: 20px;\n\t\tborder-bottom: 1px solid transparent;\n\t\tfont-size: 0;\n\t\t@include d {\n\t\t\tdisplay: inline-block; }\n\t\t@include t {\n\t\t\tborder-color: $border; }\n\t\t@include m {\n\t\t\tdisplay: none; }\n\t\t&:before,\n\t\t&:after {\n\t\t\tcontent: \"\";\n\t\t\tdisplay: inline-block;\n\t\t\twidth: 32px;\n\t\t\theight: 2px;\n\t\t\tmargin: 3px auto;\n\t\t\tborder-radius: 1px;\n\t\t\tbackground: $bl; } }\n\t&__list {\n\t\tmargin-bottom: 20px;\n\t\t@include m {\n\t\t\tmargin: 0; } }\n\t&__group {\n\t\t@include nl {\n\t\t\tposition: relative;\n\t\t\tmargin-bottom: 40px;\n\t\t\tpadding-bottom: 30px;\n\t\t\t@include m {\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t\tpadding-bottom: 15px; }\n\t\t\t&:before {\n\t\t\t\tcontent: \"\";\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 20px;\n\t\t\t\tright: 20px;\n\t\t\t\tbottom: 0;\n\t\t\t\theight: 1px;\n\t\t\t\tbackground: #F0F3F6;\n\t\t\t\t@include d {\n\t\t\t\t\ttransition: all .25s; }\n\t\t\t\t@include t {\n\t\t\t\t\tleft: -20px;\n\t\t\t\t\tright: -20px; }\n\t\t\t\t@include m {\n\t\t\t\t\tleft: 20px;\n\t\t\t\t\tright: 20px; } } } }\n\t&__caption {\n\t\tmargin-bottom: 16px;\n\t\tpadding-left: 20px;\n\t\tcolor: $gray-dark;\n\t\t@include d {\n\t\t\twhite-space: nowrap;\n\t\t\ttransition: padding .25s; }\n\t\t@include t {\n\t\t\tpadding-left: 0;\n\t\t\ttext-align: center;\n\t\t\tspan {\n\t\t\t\tdisplay: none; } }\n\t\t@include m {\n\t\t\tpadding-left: 20px;\n\t\t\ttext-align: left;\n\t\t\tspan {\n\t\t\t\tdisplay: inline; } } }\n\t&__item {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: 56px;\n\t\tpadding: 0 20px;\n\t\tborder-radius: 12px;\n\t\tbackground: transparent;\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t\tcolor: $gray-dark;\n\t\ttransition: color .25s;\n\t\ttransition: all .25s;\n\t\t@include d {\n\t\t\tposition: relative;\n\t\t\tpadding-left: 3px; }\n\t\t@include t {\n\t\t\tpadding-left: 0; }\n\t\t@include m {\n\t\t\tpadding-left: 3px; }\n\t\t&:hover {\n\t\t\tcolor: $purple;\n\t\t\t@include t {\n\t\t\t\tcolor: $gray-dark; } }\n\t\t&.active {\n\t\t\tbackground: $purple;\n\t\t\tcolor: $wh; } }\n\t&__icon {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tmargin-right: 16px;\n\t\tfont-size: 0;\n\t\t@include d {\n\t\t\twidth: 56px;\n\t\t\theight: 56px;\n\t\t\tmargin-right: 0;\n\t\t\ttransition: margin .25s; }\n\t\t@include t {\n\t\t\tmargin-right: 21px; }\n\t\t@include m {\n\t\t\tmargin-right: 0; }\n\t\t.icon {\n\t\t\tfont-size: 21px;\n\t\t\tfill: $bl;\n\t\t\topacity: 0.4;\n\t\t\ttransition: all .25s;\n\t\t\t&-message {\n\t\t\t\tfont-size: 19px; } } }\n\t&__item:hover .icon {\n\t\tfill: $purple;\n\t\topacity: 1;\n\t\t@include t {\n\t\t\tfill: $bl;\n\t\t\topacity: .4; } }\n\t&__item.active .icon {\n\t\topacity: 1;\n\t\tfill: $wh; }\n\t&__item &__text {\n\t\tmargin-right: auto; }\n\t&__counter {\n\t\tflex-shrink: 0;\n\t\tmin-width: 24px;\n\t\tmargin-left: 10px;\n\t\tpadding: 0 3px;\n\t\tborder-radius: 12px;\n\t\tbackground: $red;\n\t\ttext-align: center;\n\t\tfont-size: 12px;\n\t\tline-height: 24px;\n\t\tfont-weight: 500;\n\t\tcolor: $wh;\n\t\t@include d {\n\t\t\ttransition: all .25s; }\n\t\t@include t {\n\t\t\tposition: absolute;\n\t\t\ttop: 15px;\n\t\t\tleft: 22px;\n\t\t\tmin-width: 10px;\n\t\t\theight: 10px;\n\t\t\tfont-size: 0; }\n\t\t@include m {\n\t\t\tposition: static;\n\t\t\tmin-width: 24px;\n\t\t\theight: 24px;\n\t\t\tfont-size: 12px; } }\n\t&__profile {\n\t\tmargin-top: 25px;\n\t\t@include t {\n\t\t\tmargin-top: 20px; }\n\t\t@include m {\n\t\t\tdisplay: none; } }\n\t&__details {\n\t\tposition: relative;\n\t\tdisplay: none;\n\t\tpadding: 20px 10px 33px;\n\t\tmargin-bottom: -15px;\n\t\tbackground: #F7F7F7;\n\t\tborder-radius: 12px;\n\t\ttransition: padding .25s, background .25s;\n\t\t@include x {\n\t\t\tpadding: 10px 10px 25px; }\n\t\t@include t {\n\t\t\tpadding: 5px 0 17px;\n\t\t\tbackground: none; }\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 8px;\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t\twidth: 72px;\n\t\t\theight: 4px;\n\t\t\tborder-radius: 2px;\n\t\t\tbackground: $border;\n\t\t\t@include x {\n\t\t\t\tdisplay: none; } } }\n\t&__link {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: 56px;\n\t\tborder-radius: 12px;\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t\tcolor: $gray-dark;\n\t\ttransition: all .25s;\n\t\t&:hover {\n\t\t\tbackground: $wh;\n\t\t\tbox-shadow: 0px 6px 8px rgba(0, 0, 0, 0.04); } }\n\t&__link &__icon {\n\t\twidth: 50px;\n\t\tmargin: 0;\n\t\tpadding-right: 6px;\n\t\ttext-align: center;\n\t\ttransition: all .25s;\n\t\t@include t {\n\t\t\twidth: 56px;\n\t\t\tmargin-right: 24px;\n\t\t\tpadding: 0; } }\n\t&__img {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: 50px;\n\t\theight: 56px;\n\t\tpadding-right: 5px;\n\t\t.icon {\n\t\t\tfont-size: 19px; } }\n\t&__user {\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: 0 20px;\n\t\theight: 62px;\n\t\tborder-radius: 12px;\n\t\tcolor: $text;\n\t\tcursor: pointer;\n\t\ttransition: background .25s;\n\t\t&:hover,\n\t\t&.active {\n\t\t\tbackground: $blue;\n\t\t\tcolor: $wh;\n\t\t\t.sidebar__status {\n\t\t\t\tcolor: $wh; }\n\t\t\t.icon {\n\t\t\t\tfill: $wh; } }\n\t\t@include d {\n\t\t\ttransition: all .25s; }\n\t\t@include t {\n\t\t\tpadding-left: 8px; } }\n\t&__ava {\n\t\tflex-shrink: 0;\n\t\twidth: 40px;\n\t\theight: 40px;\n\t\tfont-size: 0; }\n\t&__ava &__pic {\n\t\twidth: 100%;\n\t\tmin-height: 100%;\n\t\tborder-radius: 50%; }\n\t&__arrow {\n\t\tflex-shrink: 0;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tfont-size: 0;\n\t\t.icon {\n\t\t\tfont-size: 16px;\n\t\t\tfill: $text; } }\n\t&__desc {\n\t\tflex: 0 0 calc(100% - 64px);\n\t\twidth: calc(100% - 64px);\n\t\tpadding: 0 5px 0 16px; }\n\t&__man {\n\t\t@include text-overflow;\n\t\tfont-size: 14px;\n\t\tline-height: (20/14);\n\t\tfont-weight: 600; }\n\t&__status {\n\t\t@include text-overflow;\n\t\tcolor: $gray-dark; }\n\t&__bottom {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: 72px;\n\t\tpadding: 0 40px;\n\t\tbox-shadow: inset 0px 1px 0px rgba(0, 0, 0, 0.05);\n\t\t@include d {\n\t\t\ttransition: padding .25s; }\n\t\t@include t {\n\t\t\tpadding: 0 35px; }\n\t\t@include m {\n\t\t\tpadding: 0 40px; } }\n\t.switch {\n\t\tmargin-right: auto; }\n\t.switch_theme .switch__in {\n\t\t@include t {\n\t\t\tpadding-left: 60px; }\n\t\t@include m {\n\t\t\tpadding-left: 56px; } }\n\t&__banner {\n\t\tposition: relative;\n\t\tmargin-top: 50px;\n\t\tpadding: 8px 8px 20px;\n\t\tborder-radius: 16px;\n\t\tbackground: #CFC8FF;\n\t\ttext-align: center;\n\t\t@include d {\n\t\t\tdisplay: none; }\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 8px;\n\t\t\tleft: 8px;\n\t\t\tright: 8px;\n\t\t\tbottom: -8px;\n\t\t\tz-index: -1;\n\t\t\tborder-radius: 12px;\n\t\t\tbackground: rgba(#CFC8FF, .5); }\n\t\t@include nl {\n\t\t\tmargin-bottom: 40px; } }\n\t&__preview {\n\t\tmargin-bottom: 6px;\n\t\tfont-size: 0; }\n\t&__banner &__btn {\n\t\tmin-width: 171px;\n\t\tcolor: $link;\n\t\t&:hover {\n\t\t\tcolor: $purple; } }\n\t&.active {\n\t\t@include d {\n\t\t\twidth: 96px; }\n\t\t@include t {\n\t\t\twidth: 256px; }\n\t\t@include m {\n\t\t\ttransform: translateX(0); } }\n\t&.active &__inner {\n\t\t@include d {\n\t\t\twidth: 56px; }\n\t\t@include t {\n\t\t\twidth: 100%; } }\n\t&.active &__burger {\n\t\t@include d {\n\t\t\tborder-color: $border; }\n\t\t@include t {\n\t\t\tborder-color: transparent; } }\n\t&.active &__top {\n\t\tpadding: 0;\n\t\t@include t {\n\t\t\tpadding-left: 40px; } }\n\t&.active &__top &__logo {\n\t\t@include d {\n\t\t\topacity: 0; }\n\t\t@include t {\n\t\t\topacity: 1; } }\n\t&.active &__icon {\n\t\tmargin-right: 21px;\n\t\t@include t {\n\t\t\tmargin-right: 0; } }\n\t&.active &__caption {\n\t\t@include d {\n\t\t\tpadding: 0;\n\t\t\ttext-align: center;\n\t\t\tspan {\n\t\t\t\tdisplay: none; } }\n\t\t@include t {\n\t\t\tpadding: 0 20px;\n\t\t\ttext-align: left;\n\t\t\tspan {\n\t\t\t\tdisplay: inline; } }\n\t\t@include m {\n\t\t\tpadding-left: 15px; } }\n\t&.active &__group:before {\n\t\t@include d {\n\t\t\tleft: -20px;\n\t\t\tright: -20px; }\n\t\t@include t {\n\t\t\tleft: 20px;\n\t\t\tright: 20px; } }\n\t&.active &__wrapper &__logo {\n\t\theight: 80px;\n\t\t@include t {\n\t\t\theight: 0; } }\n\t&.active &__item {\n\t\t@include d {\n\t\t\tpadding-left: 0; }\n\t\t@include t {\n\t\t\tpadding-left: 3px; }\n\t\t@include m {\n\t\t\tpadding-left: 0; } }\n\t&.active &__counter {\n\t\t@include d {\n\t\t\tposition: absolute;\n\t\t\ttop: 15px;\n\t\t\tleft: 22px;\n\t\t\tmin-width: 10px;\n\t\t\theight: 10px;\n\t\t\tfont-size: 0; }\n\t\t@include t {\n\t\t\tposition: static;\n\t\t\tmin-width: 24px;\n\t\t\theight: 24px;\n\t\t\tfont-size: 12px; } }\n\t&.active &__details {\n\t\tpadding: 5px 0 17px;\n\t\tbackground: none; }\n\t&.active &__link &__icon {\n\t\twidth: 56px;\n\t\tpadding: 0; }\n\t&.active &__user {\n\t\t@include d {\n\t\t\tpadding-left: 8px; }\n\t\t@include t {\n\t\t\tpadding: 0 20px; } }\n\t&.active &__bottom {\n\t\t@include d {\n\t\t\tpadding: 0 35px;\n\t\t\t.switch_theme .switch__in {\n\t\t\t\tpadding-left: 60px; } }\n\t\t@include t {\n\t\t\tpadding: 0 40px;\n\t\t\t.switch_theme .switch__in {\n\t\t\t\tpadding-left: 56px; } } } }\n\n@include dark {\n\t.sidebar {\n\t\tbackground: #242731;\n\t\tborder-color: $border-dark;\n\t\t&__pic_black {\n\t\t\tdisplay: none; }\n\t\t&__pic_white {\n\t\t\tdisplay: inline-block; }\n\t\t&__icon .icon {\n\t\t\tfill: $wh; }\n\t\t&__item:hover {\n\t\t\tcolor: $wh; }\n\t\t&__group:before {\n\t\t\tbackground: rgba($border-dark, .1); }\n\t\t&__details {\n\t\t\tbackground: rgba($border, .04);\n\t\t\t&:before {\n\t\t\t\tbackground: $border-dark; } }\n\t\t&__link:hover {\n\t\t\tbackground: rgba($border, .04);\n\t\t\tcolor: $wh;\n\t\t\t.icon {\n\t\t\t\tfill: $wh;\n\t\t\t\topacity: 1; } }\n\t\t&__man {\n\t\t\tcolor: $wh; }\n\t\t&__arrow .icon {\n\t\t\tfill: $wh; }\n\t\t&__bottom {\n\t\t\tbox-shadow: inset 0px 1px 0px rgba($border-dark, .1); }\n\t\t&__burger {\n\t\t\t@include t {\n\t\t\t\tborder-color: $border-dark; }\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tbackground: $wh; } }\n\t\t&__top {\n\t\t\t@include m {\n\t\t\t\tborder-color: $border-dark; } }\n\t\t&__close {\n\t\t\t.icon {\n\t\t\t\tfill: $wh; } }\n\t\t&__btn.btn_white {\n\t\t\tbackground: $purple;\n\t\t\tcolor: $wh;\n\t\t\t&:hover {\n\t\t\t\tbackground: $bl; } }\n\t\t&.active .sidebar__burger {\n\t\t\tborder-color: $border-dark;\n\t\t\t@include t {\n\t\t\t\tborder-color: transparent; } } } }\n\n\n\n",".switch {\n\tdisplay: inline-block;\n\tposition: relative;\n\tuser-select: none;\n\tcursor: pointer;\n\t-webkit-tap-highlight-color: rgba(0,0,0,0);\n\tfont-size: 0;\n\ttransition: opacity .25s;\n\t&__input {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\topacity: 0; }\n\t&__in {\n\t\tdisplay: inline-block; }\n\t&__box {\n\t\tposition: relative;\n\t\tdisplay: block;\n\t\twidth: 64px;\n\t\theight: 24px;\n\t\tbackground: rgba($border, .5);\n\t\tborder-radius: 16px;\n\t\ttransition: all .25s;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 2px;\n\t\t\ttransform: translateY(-50%);\n\t\t\twidth: 20px;\n\t\t\theight: 20px;\n\t\t\tborder-radius: 50%;\n\t\t\tborder: 4px solid $wh;\n\t\t\tbox-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);\n\t\t\tbackground: $blue;\n\t\t\ttransition: all .25s; } }\n\t&__icon {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 0;\n\t\ttransform: translateY(-50%);\n\t\tfont-size: 0;\n\t\t.icon {\n\t\t\tfont-size: 24px;\n\t\t\tfill: $blue; }\n\t\t.icon-moon {\n\t\t\tdisplay: none; } }\n\t&__input:checked + &__flex &__box:before {\n\t\ttransform: translate(24px,-50%); }\n\t&_theme &__in {\n\t\tpadding-left: 56px; }\n\t@include hover {\n\t\topacity: .8; } }\n\n@include dark {\n\t.switch_theme .switch__input + .switch__in .switch__box {\n\t\tbackground: #12141B; }\n\t.switch_theme .switch__input + .switch__in .switch__box:before {\n\t\twidth: 4px;\n\t\theight: 16px;\n\t\tborder-width: 2px;\n\t\tborder-radius: 2px;\n\t\ttransform: translate(48px,-50%);\n\t\tborder-color: $blue; }\n\t.switch_theme .switch__input + .switch__in .icon-moon {\n\t\tdisplay: inline-block; }\n\t.switch_theme .switch__input + .switch__in .icon-sun {\n\t\tdisplay: none; } }\n\n",".slider {\n\tmargin-bottom: 56px;\n\t@include m {\n\t\tmargin-bottom: 48px; }\n\t&__container {\n\t\tposition: relative;\n\t\tbackground: $purple;\n\t\tborder-radius: 24px;\n\t\t&:before,\n\t\t&:after {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tbackground: #CFC8FF;\n\t\t\tborder-radius: 24px; }\n\t\t&:before {\n\t\t\ttop: 8px;\n\t\t\tleft: 8px;\n\t\t\tright: 8px;\n\t\t\tbottom: -8px;\n\t\t\tz-index: -1; }\n\t\t&:after {\n\t\t\ttop: 16px;\n\t\t\tleft: 20px;\n\t\t\tright: 20px;\n\t\t\tbottom: -16px;\n\t\t\tz-index: -2; } }\n\t&__item {\n\t\tdisplay: flex;\n\t\tpadding: 42px 0 56px 32px;\n\t\tcolor: $wh;\n\t\t@include m {\n\t\t\tflex-direction: column-reverse;\n\t\t\tpadding: 0 32px 54px;\n\t\t\ttext-align: center; } }\n\t&__details {\n\t\tflex-shrink: 0;\n\t\twidth: 185px;\n\t\tpadding-top: 13px;\n\t\t@include m {\n\t\t\twidth: 100%;\n\t\t\tpadding: 0; } }\n\t&__preview {\n\t\tmargin: 0 auto;\n\t\tfont-size: 0;\n\t\t@include m {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\twidth: 282px;\n\t\t\theight: 282px;\n\t\t\tpadding: 20px; } }\n\t&__pic {\n\t\tmax-width: 214px;\n\t\tmax-height: 214px; }\n\t&__title {\n\t\tmargin-bottom: 14px; }\n\t&__text {\n\t\tmargin-bottom: 14px;\n\t\t@include m {\n\t\t\tmargin-bottom: 24px; } }\n\t&__close {\n\t\tposition: absolute;\n\t\ttop: 8px;\n\t\tright: 8px;\n\t\tz-index: 2;\n\t\twidth: 40px;\n\t\theight: 40px;\n\t\tborder-radius: 50%;\n\t\tbackground: $wh;\n\t\tfont-size: 0;\n\t\t.icon {\n\t\t\tfont-size: 12px;\n\t\t\ttransition: transform .25s; }\n\t\t&:hover .icon {\n\t\t\ttransform: rotate(90deg); } }\n\t.owl-dots {\n\t\tposition: absolute;\n\t\tleft: 217px;\n\t\tright: 0;\n\t\tbottom: 30px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\t@include m {\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 24px; } }\n\t.owl-carousel button.owl-dot {\n\t\tposition: relative;\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\twidth: 4px;\n\t\t\theight: 4px;\n\t\t\tbackground: $wh;\n\t\t\tborder-radius: 50%;\n\t\t\ttransition: all .25s; }\n\t\t&:hover,\n\t\t&.active {\n\t\t\t&:before {\n\t\t\t\tbox-shadow: 0 0 0 2px #A0D7E7; } }\n\t\t@include nl {\n\t\t\tmargin-right: 10px; } } }\n\n@include dark {\n\t.slider {\n\t\t&__close {\n\t\t\tbackground: $dark;\n\t\t\tbox-shadow: 0 10px 10px rgba(#000, .3);\n\t\t\t.icon {\n\t\t\t\tfill: $wh; } } } }\n",".btn {\n\tmin-width: 166px;\n\theight: 56px;\n\tpadding: 0 20px;\n\tborder-radius: 16px/16px;\n\t@include fi;\n\tfont-size: 14px;\n\tline-height: (20/14);\n\tfont-weight: 700;\n\ttransition: all .25s;\n\t.icon,\n\t&__text {\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle; }\n\t.icon {\n\t\tposition: relative;\n\t\ttop: -2px;\n\t\tfont-size: 20px;\n\t\t@include nl {\n\t\t\tmargin-right: 10px; } }\n\t&_white {\n\t\tbackground: $wh;\n\t\tcolor: $bl;\n\t\t&:hover {\n\t\t\tcolor: $purple; } }\n\t&_purple {\n\t\tbackground: $purple;\n\t\tcolor: $wh;\n\t\t&:hover {\n\t\t\tbackground: darken($purple, 5); } }\n\t&_blue {\n\t\tbackground: $blue;\n\t\tcolor: $wh;\n\t\t&:hover {\n\t\t\tbackground: darken($blue, 7); } }\n\t&_blue-dark {\n\t\tbackground: $blue-dark;\n\t\tcolor: $wh;\n\t\t&:hover {\n\t\t\tbackground: lighten($blue-dark, 7); } }\n\t&_black {\n\t\tbackground: $bl;\n\t\tcolor: $wh;\n\t\t.icon {\n\t\t\tfill: $wh; }\n\t\t&:hover {\n\t\t\tbackground: $purple; } }\n\t&_gray {\n\t\tbackground: $border;\n\t\tcolor: $text;\n\t\t&:hover {\n\t\t\tbackground: rgba($border, .5); } }\n\t&_wide {\n\t\tmin-width: 100%; }\n\t&[href] {\n\t\tdisplay: inline-flex;\n\t\tjustify-content: center;\n\t\talign-items: center; } }\n\n@include dark {\n\t.btn {\n\t\t&_white {\n\t\t\tbackground: $dark;\n\t\t\tcolor: $wh;\n\t\t\t&:hover {\n\t\t\t\tbackground: $bl; } }\n\t\t&_gray {\n\t\t\tbackground: $border-dark;\n\t\t\tcolor: $wh;\n\t\t\t&:hover {\n\t\t\t\topacity: .8; } } } }\n",".widget {\n\tpadding: 32px;\n\tborder-radius: 24px;\n\tbackground: $wh;\n\t&__head {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: 88px;\n\t\tpadding: 0 32px; }\n\t& > &__title {\n\t\tmargin-bottom: 32px; }\n\t&__title {\n\t\t@include fp;\n\t\tfont-size: 18px;\n\t\tline-height: (24/18); }\n\t&__top {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tmargin-bottom: 32px; }\n\t&__next {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tfont-size: 0;\n\t\t.icon {\n\t\t\tfont-size: 10px;\n\t\t\tfill: $text;\n\t\t\ttransition: fill .25s; }\n\t\t&:hover .icon {\n\t\t\tfill: $purple; } }\n\t&__item {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: -12px;\n\t\t\tleft: -12px;\n\t\t\tright: -12px;\n\t\t\tbottom: -12px;\n\t\t\tborder-radius: 16px;\n\t\t\tbackground: $purple;\n\t\t\topacity: 0;\n\t\t\ttransition: opacity .25s; }\n\t\t&:hover:before {\n\t\t\topacity: 1; }\n\t\t@include nl {\n\t\t\tmargin-bottom: 40px; } }\n\t&__preview {\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t\twidth: 56px;\n\t\theight: 56px;\n\t\tborder-radius: 16px;\n\t\toverflow: hidden;\n\t\tfont-size: 0; }\n\t&__pic {\n\t\tmax-width: 100%;\n\t\tmax-height: 100%; }\n\t&__details {\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\tflex-grow: 1;\n\t\tpadding-left: 24px;\n\t\t@include w {\n\t\t\tpadding-left: 16px; }\n\t\t@include x {\n\t\t\tpadding-left: 24px; } }\n\t&__item &__category {\n\t\tposition: relative;\n\t\tmargin-bottom: 3px;\n\t\tpadding-right: 30px;\n\t\tcolor: $text;\n\t\ttransition: color .25s;\n\t\t.icon {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tright: 9px;\n\t\t\ttransform: translateY(-50%);\n\t\t\tfont-size: 10px;\n\t\t\tfill: $text;\n\t\t\ttransition: fill .25s; } }\n\t&__info {\n\t\tcolor: $gray-dark;\n\t\ttransition: color .25s; }\n\t&__item:hover &__category,\n\t&__item:hover &__info {\n\t\tcolor: $wh;\n\t\t.icon {\n\t\t\tfill: $wh; } }\n\t&__wrap {\n\t\tpadding: 24px;\n\t\tborder-radius: 16px;\n\t\tbackground: $wh; }\n\t&__chart {\n\t\t&_earning {\n\t\t\theight: 205px;\n\t\t\tmargin-top: -20px;\n\t\t\tmargin-left: -20px;\n\t\t\tmargin-bottom: 15px; }\n\t\t&_impressions {\n\t\t\theight: 320px;\n\t\t\tmargin-left: -20px;\n\t\t\t@include m {\n\t\t\t\tmargin-left: -10px;\n\t\t\t\tmargin-right: 10px; } }\n\t\t&_users {\n\t\t\tflex-shrink: 0;\n\t\t\twidth: 120px;\n\t\t\theight: 80px;\n\t\t\tmargin-top: -5px; }\n\t\t&_earning-month {\n\t\t\tmax-width: 120px;\n\t\t\theight: 120px;\n\t\t\tmargin: 0 auto; }\n\t\t&_items {\n\t\t\theight: 240px;\n\t\t\t@include m {\n\t\t\t\tmargin-bottom: 16px; } } }\n\t&__col:first-child {\n\t\tmargin-bottom: 32px; }\n\t&__counter {\n\t\tmargin-bottom: 12px; }\n\t&__foot {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\theight: 40px; }\n\t&__foot &__link {\n\t\tcolor: $link;\n\t\ttransition: color .25s;\n\t\t&:hover {\n\t\t\tcolor: $purple; } }\n\t&__flex {\n\t\tdisplay: flex; }\n\t&__legend {\n\t\tdisplay: flex;\n\t\tjustify-content: center; }\n\t&__color {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tcolor: $gray-dark;\n\t\t@include nl {\n\t\t\tmargin-right: 24px; } }\n\t&__bg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tborder-radius: 8px;\n\t\tmargin-right: 8px; }\n\t&__text {\n\t\t&_mb32 {\n\t\t\tmargin-bottom: 32px; }\n\t\t&_mb40 {\n\t\t\tmargin-bottom: 40px; } }\n\t&_shadow {\n\t\tposition: relative;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 22px;\n\t\t\tleft: 18px;\n\t\t\tright: 18px;\n\t\t\tbottom: -40px;\n\t\t\tz-index: -2;\n\t\t\t@include shadow; } }\n\t&_responsive {\n\t\t@include x {\n\t\t\tposition: relative;\n\t\t\tpadding: 32px;\n\t\t\tbackground: $wh;\n\t\t\tborder-radius: 24px;\n\t\t\t&:before {\n\t\t\t\tcontent: \"\";\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 22px;\n\t\t\t\tleft: 18px;\n\t\t\t\tright: 18px;\n\t\t\t\tbottom: -40px;\n\t\t\t\tz-index: -2;\n\t\t\t\t@include shadow; } } }\n\t&_chart {\n\t\tpadding: 32px 8px 8px;\n\t\t.widget__title {\n\t\t\tpadding: 0 24px; } }\n\t&_pink {\n\t\tbackground: #FFEBF6; }\n\t&_purple {\n\t\tbackground: $purple; }\n\t&_center {}\n\t&_stat {\n\t\tposition: relative;\n\t\ttext-align: center;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\t@include coverdiv;\n\t\t\tz-index: -1;\n\t\t\t@include shadow; } }\n\t&_stat &__title {\n\t\tmargin-bottom: 12px; }\n\t&_stat > &__text {\n\t\tmax-width: 185px;\n\t\tmargin: 0 auto 18px;\n\t\tcolor: $gray-dark; }\n\t&_stat &__btn.btn_white {\n\t\tbox-shadow: 0 10px 20px rgba(#E3E6EC, .6);\n\t\tcolor: $link;\n\t\t&:hover {\n\t\t\tcolor: $bl; } }\n\t&_empty {\n\t\tbackground: none;\n\t\tbox-shadow: none;\n\t\tborder-radius: 0; }\n\t&_stat.widget_empty:before {\n\t\tdisplay: none; }\n\t&_p0 {\n\t\tpadding: 0; }\n\t&_pt0 {\n\t\tpadding-top: 0; }\n\t&_pb60 {\n\t\tpadding-bottom: 58px; }\n\t&_users &__flex {\n\t\tpadding: 26px 32px 40px;\n\t\tbox-shadow: inset 0px -1px 0px $border;\n\t\t&:first-child {\n\t\t\tpadding-top: 0; } }\n\t&_users &__desc {\n\t\tmargin-right: auto; }\n\t&_users &__category {\n\t\tline-height: 1.3;\n\t\tcolor: $gray-dark; }\n\t&_users &__percent {\n\t\tfont-weight: 600;\n\t\tline-height: 1.3;\n\t\tcolor: $green; }\n\t&_after:after {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tz-index: -1;\n\t\tbottom: -8px;\n\t\tborder-radius: 24px;\n\t\tbackground: rgba($wh, .5); } }\n\n@include dark {\n\t.widget {\n\t\tbackground: $dark;\n\t\t&__item .widget__category {\n\t\t\tcolor: $wh;\n\t\t\t.icon {\n\t\t\t\tfill: $wh; } }\n\t\t&__wrap {\n\t\t\tbackground: $dark; }\n\t\t&__next .icon {\n\t\t\tfill: $wh; }\n\t\t&_shadow:before {\n\t\t\t@include shadow-dark; }\n\t\t&_pink {\n\t\t\tbackground: $blue; }\n\t\t&_stat:before {\n\t\t\t@include shadow-dark; }\n\t\t&_stat .widget__btn.btn_white {\n\t\t\tbox-shadow: none;\n\t\t\tbackground: $dark1;\n\t\t\t&:hover {\n\t\t\t\tcolor: $wh; } }\n\t\t&_empty {\n\t\t\tbackground: none;\n\t\t\tbox-shadow: none; }\n\t\t&_users .widget__flex {\n\t\t\tbox-shadow: inset 0px -1px 0px $border-dark; }\n\t\t&_purple {\n\t\t\tbackground: $purple; }\n\t\t&_after:after {\n\t\t\tbackground: rgba($dark, .5); } } }\n",".header {\n\tposition: relative;\n\tz-index: 10;\n\tdisplay: flex;\n\talign-items: center;\n\tmax-width: 298px;\n\tmargin-left: auto;\n\t@include x {\n\t\tmax-width: 100%; }\n\t@include m {\n\t\theight: 96px;\n\t\tmax-width: calc(100% + 32px);\n\t\tmargin: 0 -16px;\n\t\tpadding: 0 32px;\n\t\tborder-bottom: 1px solid $border; }\n\t.search {\n\t\twidth: 214px;\n\t\tmargin-left: -8px;\n\t\tmargin-right: auto;\n\t\t@include x {\n\t\t\twidth: auto;\n\t\t\tflex-grow: 1;\n\t\t\tmargin-right: 50px; }\n\t\t@include m {\n\t\t\tflex-grow: 0;\n\t\t\tmargin-left: 0;\n\t\t\tmargin-right: 0; } }\n\t.notifications {\n\t\t@include m {\n\t\t\tmargin-right: 25px; } }\n\t&__user {\n\t\tdisplay: none;\n\t\tflex-shrink: 0;\n\t\twidth: 40px;\n\t\theight: 40px;\n\t\tfont-size: 0;\n\t\t@include m {\n\t\t\tdisplay: block; } }\n\t&__pic {\n\t\twidth: 100%;\n\t\tmin-height: 100%;\n\t\tborder-radius: 50%; }\n\t&__burger {\n\t\tdisplay: none;\n\t\twidth: 32px;\n\t\theight: 40px;\n\t\tmargin-right: auto;\n\t\tfont-size: 0;\n\t\t@include m {\n\t\t\tdisplay: inline-block; }\n\t\t&:before,\n\t\t&:after {\n\t\t\tcontent: \"\";\n\t\t\tdisplay: inline-block;\n\t\t\twidth: 32px;\n\t\t\theight: 2px;\n\t\t\tmargin: 3px auto;\n\t\t\tborder-radius: 1px;\n\t\t\tbackground: $bl; } }\n\t&__search {\n\t\tdisplay: none;\n\t\twidth: 40px;\n\t\theight: 40px;\n\t\tmargin-right: 25px;\n\t\tborder-radius: 50%;\n\t\tbox-shadow: 0 5px 10px rgba(#E3E6EC, .6);\n\t\tfont-size: 0;\n\t\ttransition: all .25s;\n\t\t@include m {\n\t\t\tdisplay: inline-block; }\n\t\t.icon {\n\t\t\tfont-size: 20px;\n\t\t\tfill: $bl; }\n\t\t&.active {\n\t\t\tbackground: $purple;\n\t\t\t.icon {\n\t\t\t\tfill: $wh; } } } }\n\n@include dark {\n\t.header {\n\t\t&__burger {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tbackground: $wh; } }\n\t\t&__search {\n\t\t\tbox-shadow: 0 5px 10px rgba(#000, .3);\n\t\t\t.icon {\n\t\t\t\tfill: $wh; } }\n\t\t@include m {\n\t\t\tborder-color: $border-dark; } } }\n",".search {\n\tposition: relative;\n\tz-index: 3;\n\t@include m {\n\t\tposition: absolute;\n\t\ttop: 100%;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tz-index: 10;\n\t\tvisibility: hidden;\n\t\topacity: {}\n\t\t&.show {\n\t\t\tvisibility: visible;\n\t\t\topacity: 1; } }\n\t&__field {\n\t\tposition: relative;\n\t\tz-index: 2; }\n\t&__input {\n\t\twidth: 100%;\n\t\theight: 48px;\n\t\tpadding: 0 10px 0 44px;\n\t\tborder-radius: 12px;\n\t\tbackground: transparent;\n\t\t@include fi;\n\t\tfont-size: 14px;\n\t\tcolor: $text;\n\t\ttransition: background .25s;\n\t\t@include m {\n\t\t\theight: 56px;\n\t\t\tbackground: $border;\n\t\t\tborder-radius: 0; }\n\t\t@include placeholder {\n\t\t\tcolor: $gray-dark; } }\n\t&__toggle {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tbottom: 0;\n\t\twidth: 42px;\n\t\tfont-size: 0;\n\t\t.icon {\n\t\t\tfill: $bl;\n\t\t\ttransition: fill .25s;\n\t\t\t&-search {\n\t\t\t\tfont-size: 20px; }\n\t\t\t&-close {\n\t\t\t\tdisplay: none;\n\t\t\t\tfont-size: 16px; } }\n\t\t&:hover .icon {\n\t\t\tfill: $purple; } }\n\t&__result {\n\t\tposition: absolute;\n\t\ttop: -4px;\n\t\tleft: -4px;\n\t\tright: -4px;\n\t\tpadding: 70px 16px 24px;\n\t\tborder-radius: 12px;\n\t\tbackground: $wh;\n\t\tbox-shadow: 0 10px 30px rgba(#E3E6EC, .5);\n\t\tvisibility: hidden;\n\t\topacity: 0;\n\t\ttransition: all .25s;\n\t\t@include m {\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbox-shadow: 0 30px 30px rgba($bl, .3); } }\n\t&__info {\n\t\tcolor: $gray-dark; }\n\t&__item {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: 16px 0;\n\t\tcolor: $text;\n\t\ttransition: color .25s;\n\t\t&:hover {\n\t\t\tcolor: $purple; }\n\t\t@include nl {\n\t\t\tborder-bottom: 1px solid $border; } }\n\t&__preview {\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t\twidth: 40px;\n\t\theight: 40px;\n\t\tmargin-right: 15px;\n\t\tborder-radius: 12px;\n\t\toverflow: hidden;\n\t\tfont-size: 0; }\n\t&__pic {\n\t\tmax-width: 100%;\n\t\tmax-height: 100%; }\n\t&__text {\n\t\tposition: relative;\n\t\tpadding-right: 30px;\n\t\tline-height: (20/14);\n\t\tfont-weight: 600;\n\t\t.icon {\n\t\t\tposition: absolute;\n\t\t\ttop: 5px;\n\t\t\tright: 9px;\n\t\t\tfont-size: 10px;\n\t\t\tfill: $text;\n\t\t\ttransition: all .25s; } }\n\t&__item:hover .icon {\n\t\ttransform: translateX(4px);\n\t\tfill: $purple; }\n\t&__btn {\n\t\theight: 40px; }\n\t&.active &__input {\n\t\tbackground: rgba($border, .3);\n\t\t@include m {\n\t\t\tbackground: $border; } }\n\t&.active &__toggle {\n\t\t.icon {\n\t\t\t&-search {\n\t\t\t\tdisplay: none; }\n\t\t\t&-close {\n\t\t\t\tdisplay: inline-block; } } }\n\t&.active &__result {\n\t\tvisibility: visible;\n\t\topacity: 1; } }\n\n@include dark {\n\t.search {\n\t\t&__toggle {\n\t\t\t.icon {\n\t\t\t\tfill: $wh; }\n\t\t\t&:hover .icon {\n\t\t\t\tfill: $purple; } }\n\t\t&__input {\n\t\t\tcolor: $wh;\n\t\t\t@include m {\n\t\t\t\tbackground: $dark1; } }\n\t\t&__result {\n\t\t\tbackground: $dark;\n\t\t\tbox-shadow: 0 10px 30px rgba(#000, .1);\n\t\t\t@include m {\n\t\t\t\tbox-shadow: 0 30px 30px rgba(#000, .5); } }\n\t\t&__item {\n\t\t\tcolor: $wh; }\n\t\t&__text .icon {\n\t\t\tfill: $wh; }\n\t\t&__item:not(:last-child) {\n\t\t\tborder-color: $border-dark; }\n\t\t&.active .search__input {\n\t\t\tbackground: rgba($border-dark, .03);\n\t\t\t@include m {\n\t\t\t\tbackground: $dark1; } } } }\n",".notifications {\n\tposition: relative;\n\t@include m {\n\t\tposition: static; }\n\t&__open {\n\t\tposition: relative;\n\t\twidth: 48px;\n\t\theight: 48px;\n\t\tborder-radius: 50%;\n\t\tfont-size: 0;\n\t\ttransition: all .25s;\n\t\t@include m {\n\t\t\twidth: 40px;\n\t\t\theight: 40px;\n\t\t\tbox-shadow: 0 5px 10px rgba(#E3E6EC, .6); }\n\t\t.icon {\n\t\t\tfont-size: 24px;\n\t\t\tfill: $bl;\n\t\t\ttransition: fill .25s;\n\t\t\t@include m {\n\t\t\t\tfont-size: 20px; } }\n\t\t&:hover {\n\t\t\tbox-shadow: 0 5px 10px rgba(#E3E6EC, .6); } }\n\t&__counter {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: -12px;\n\t\tdisplay: inline-block;\n\t\tmin-width: 24px;\n\t\tline-height: 24px;\n\t\tborder-radius: 50%;\n\t\tbackground: $red;\n\t\tfont-size: 12px;\n\t\tfont-weight: 600;\n\t\tcolor: $wh;\n\t\t@include m {\n\t\t\ttop: 5px;\n\t\t\tright: 5px;\n\t\t\tmin-width: 12px;\n\t\t\theight: 12px;\n\t\t\tfont-size: 0; } }\n\t&__wrap {\n\t\tposition: absolute;\n\t\ttop: calc(100% + 24px);\n\t\tright: -12px;\n\t\twidth: 360px;\n\t\tpadding: 32px 8px 36px;\n\t\tbox-shadow: 0 10px 36px rgba(#E3E6EC, .6);\n\t\tbackground: $wh;\n\t\tborder-radius: 24px;\n\t\tvisibility: hidden;\n\t\topacity: 0;\n\t\ttransition: all .25s;\n\t\t@include m {\n\t\t\ttop: calc(100% + 1px);\n\t\t\tright: 0;\n\t\t\tleft: 0;\n\t\t\twidth: auto;\n\t\t\tpadding: 24px 16px;\n\t\t\tbox-shadow: 0 30px 30px rgba($bl, .3); } }\n\t&__info {\n\t\tmargin-bottom: 32px;\n\t\tpadding: 0 24px;\n\t\t@include m {\n\t\t\tmargin-bottom: 16px;\n\t\t\tpadding: 0; } }\n\t&__list {\n\t\tmargin-bottom: 32px;\n\t\t@include m {\n\t\t\tmargin-bottom: 24px; } }\n\t&__item {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: 16px 28px 16px 20px;\n\t\tborder-radius: 12px;\n\t\tbackground: transparent;\n\t\tcursor: pointer;\n\t\ttransition: background .25s;\n\t\t@include m {\n\t\t\tpadding: 0; }\n\t\t&:hover {\n\t\t\tbackground: $purple;\n\t\t\t@include m {\n\t\t\t\tbackground: none; } }\n\t\t@include nl {\n\t\t\t@include m {\n\t\t\t\tmargin-bottom: 20px; } } }\n\t&__ava {\n\t\tposition: relative;\n\t\tflex-shrink: 0;\n\t\twidth: 48px;\n\t\theight: 48px;\n\t\tmargin-right: 24px;\n\t\tfont-size: 0;\n\t\t@include m {\n\t\t\tmargin-right: 16px; } }\n\t&__ava > &__pic {\n\t\twidth: 100%;\n\t\tmin-height: 100%;\n\t\tborder-radius: 50%; }\n\t&__status {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: -1px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: 21px;\n\t\theight: 21px;\n\t\tborder: 2px solid $wh;\n\t\tborder-radius: 50%;\n\t\tfont-size: 0; }\n\t&__status &__pic {\n\t\tmax-width: 10px; }\n\t&__details {\n\t\tflex-grow: 1; }\n\t&__line {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 6px; }\n\t&__user {\n\t\tmargin-right: auto;\n\t\tcolor: $text;\n\t\ttransition: color .25s; }\n\t&__time,\n\t&__text {\n\t\tcolor: $gray-light;\n\t\ttransition: color .25s; }\n\t&__time {\n\t\tflex-shrink: 0;\n\t\tmargin-left: 20px; }\n\t&__project {\n\t\tpadding-left: 5px;\n\t\tcolor: $link;\n\t\ttransition: all .25s; }\n\t&__item:hover &__user,\n\t&__item:hover &__time,\n\t&__item:hover &__text,\n\t&__item:hover &__project {\n\t\tcolor: $wh; }\n\t&__btns {\n\t\ttext-align: center; }\n\t&__btn {\n\t\tmin-width: 230px; }\n\t&.active &__open {\n\t\tbackground: $purple;\n\t\tbox-shadow: 0 5px 10px rgba(#E3E6EC, .6);\n\t\t.icon {\n\t\t\tfill: $wh; } }\n\t&.active &__wrap {\n\t\tvisibility: visible;\n\t\topacity: 1; } }\n\n@include dark {\n\t.notifications {\n\t\t&__open {\n\t\t\tbackground: $dark;\n\t\t\t@include m {\n\t\t\t\tbox-shadow: 0 5px 10px rgba(#000, .3); }\n\t\t\t.icon {\n\t\t\t\tfill: $wh; }\n\t\t\t&:hover {\n\t\t\t\tbox-shadow: 0 5px 10px rgba(#000, .3); } }\n\t\t&__wrap {\n\t\t\tbackground: $dark;\n\t\t\tbox-shadow: 0 10px 40px rgba(#000, .3);\n\t\t\t@include m {\n\t\t\t\tbox-shadow: 0 30px 30px rgba(#000, .5); } }\n\t\t&__user {\n\t\t\tcolor: $wh; }\n\t\t&.active .notifications__open {\n\t\t\tbox-shadow: 0 5px 10px rgba(#000, .7); } } }\n\n",".banner {\n\t&__container {\n\t\tposition: relative;\n\t\tpadding: 64px 64px 76px;\n\t\tborder-radius: 24px;\n\t\tbackground: $purple;\n\t\toverflow: hidden;\n\t\t@include x {\n\t\t\tpadding: 50px 56px; }\n\t\t@include t {\n\t\t\tpadding: 50px 40px; }\n\t\t@include m {\n\t\t\tpadding: 10px 32px 32px;\n\t\t\ttext-align: center; } }\n\t&__wrap {\n\t\tmax-width: 400px;\n\t\tcolor: $wh;\n\t\t@include d {\n\t\t\tmax-width: 300px; }\n\t\t@include m {\n\t\t\tmax-width: 100%; } }\n\t&__title {\n\t\t@include d {\n\t\t\tmargin-bottom: 6px;\n\t\t\tline-height: 1.2; } }\n\t&__text {\n\t\tmargin-bottom: 16px; }\n\t&__btn {\n\t\tmin-width: 209px; }\n\t&__preview {\n\t\tposition: absolute;\n\t\ttop: 40px;\n\t\tright: 90px;\n\t\twidth: 543px;\n\t\tfont-size: 0;\n\t\t@include w {\n\t\t\twidth: 450px; }\n\t\t@include x {\n\t\t\tright: 50px;\n\t\t\twidth: 330px; }\n\t\t@include d {\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\t\t\twidth: 180px; }\n\t\t@include m {\n\t\t\tposition: static;\n\t\t\ttransform: translateY(0);\n\t\t\twidth: 260px;\n\t\t\theight: 260px;\n\t\t\tpadding: 30px;\n\t\t\tmargin: 0 auto;\n\t\t\ttext-align: center; } }\n\t&__preview &__pic {\n\t\twidth: 100%; }\n\t@include nl {\n\t\tmargin-bottom: 32px; } }\n",".sorting {\n\t@include m {\n\t\tpadding: 0 24px; }\n\t&__row {\n\t\tdisplay: flex;\n\t\tmargin: 0 -8px;\n\t\t@include x {\n\t\t\tdisplay: block;\n\t\t\tmargin: 0; } }\n\t&__col {\n\t\tflex: 0 0 calc(50% - 16px);\n\t\twidth: calc(50% - 16px);\n\t\tmargin: 0 8px;\n\t\t@include x {\n\t\t\twidth: 100%;\n\t\t\tmargin: 0; }\n\t\t@include nl {\n\t\t\t@include x {\n\t\t\t\tmargin-bottom: 16px; } } }\n\t&__dropdowns {\n\t\tdisplay: flex;\n\t\tmargin: 0 -8px;\n\t\t@include m {\n\t\t\tdisplay: block;\n\t\t\tmargin: 0; }\n\t\t.dropdown {\n\t\t\tflex: 0 0 calc(50% - 16px);\n\t\t\twidth: calc(50% - 16px);\n\t\t\tmargin: 0 8px;\n\t\t\t@include m {\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin: 0; }\n\t\t\t@include nl {\n\t\t\t\t@include m {\n\t\t\t\t\tmargin-bottom: 16px; } } } }\n\t&__line {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\t@include m {\n\t\t\tdisplay: block; } }\n\t&__search {\n\t\tposition: relative;\n\t\tflex-grow: 1; }\n\t&__line &__search {\n\t\tmargin-right: 45px;\n\t\t@include d {\n\t\t\tmargin-right: 30px; }\n\t\t@include m {\n\t\t\tmargin: 0 0 16px; } }\n\t&__input {\n\t\twidth: 100%;\n\t\theight: 56px;\n\t\tpadding: 0 20px 0 55px;\n\t\tborder: none;\n\t\tborder-radius: 16px;\n\t\tbackground: rgba($border, .2);\n\t\t@include fi;\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t\tcolor: $bl;\n\t\t@include placeholder {\n\t\t\tcolor: $gray-dark; } }\n\t&__open {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tbottom: 0;\n\t\twidth: 55px;\n\t\tfont-size: 0;\n\t\t.icon {\n\t\t\tfont-size: 20px;\n\t\t\tfill: $text;\n\t\t\ttransition: fill .25s; }\n\t\t&:hover .icon {\n\t\t\tfill: $purple; } }\n\t&__actions {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\t@include m {\n\t\t\tjustify-content: flex-end; } }\n\t&__action {\n\t\tflex-shrink: 0;\n\t\twidth: 48px;\n\t\theight: 48px;\n\t\tborder-radius: 50%;\n\t\tbackground: $wh;\n\t\tfont-size: 0;\n\t\ttransition: box-shadow .25s;\n\t\t.icon {\n\t\t\tfont-size: 17px;\n\t\t\tfill: $text;\n\t\t\t&-edit {\n\t\t\t\tfont-size: 19px; }\n\t\t\t&-box {\n\t\t\t\tfont-size: 15px; } }\n\t\t&:hover {\n\t\t\tbox-shadow: 0 5px 20px rgba(#E3E6EC, .85); }\n\t\t@include nl {\n\t\t\tmargin-right: 24px; } }\n\t@include nl {\n\t\tmargin-bottom: 15px; } }\n\n@include dark {\n\t.sorting {\n\t\t&__input {\n\t\t\tbackground: rgba($border, .04);\n\t\t\tcolor: $wh; }\n\t\t&__open {\n\t\t\t.icon {\n\t\t\t\tfill: $wh; } }\n\t\t&__action {\n\t\t\tbackground: $dark;\n\t\t\t.icon {\n\t\t\t\tfill: $wh; }\n\t\t\t&:hover {\n\t\t\t\tbox-shadow: 0 12px 20px rgba(#000, .25); } } } }\n",".dropdown {\n\tposition: relative;\n\t&__head {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: 56px;\n\t\tpadding: 0 46px 0 21px;\n\t\tborder: 2px solid transparent;\n\t\tbackground: rgba($border, .3);\n\t\tborder-radius: 16px;\n\t\tfont-weight: 600;\n\t\tcolor: $gray-dark;\n\t\ttransition: all .25s;\n\t\tcursor: pointer;\n\t\t-webkit-tap-highlight-color: rgba(0,0,0,0);\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tright: 20px;\n\t\t\ttransform: translateY(-50%);\n\t\t\twidth: 14px;\n\t\t\theight: 8px;\n\t\t\tbackground: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='8'%3E%3Cpath fill='%231b1d21' d='M.293.293A1 1 0 0 1 1.613.21l.094.083L7 5.585 12.293.293a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 .083 1.32l-.083.094-6 6a1 1 0 0 1-1.32.083l-.094-.083-6-6a1 1 0 0 1 0-1.414z'/%3E%3C/svg%3E\") no-repeat 50% 50% / 100% auto;\n\t\t\ttransition: transform .25s; } }\n\t&__body {\n\t\tposition: absolute;\n\t\ttop: calc(100% + 8px);\n\t\tleft: 0;\n\t\tz-index: 20;\n\t\twidth: 310px;\n\t\tpadding: 32px;\n\t\tborder: 1px solid $border;\n\t\tbackground: $wh;\n\t\tborder-radius: 24px;\n\t\tvisibility: hidden;\n\t\topacity: 0;\n\t\tbox-shadow: 0 20px 16px rgba(#E3E6EC, .6);\n\t\ttransition: all .25s;\n\t\t@include d {\n\t\t\tright: 0;\n\t\t\twidth: auto;\n\t\t\tpadding: 24px 21px; } }\n\t&__item {\n\t\tdisplay: block;\n\t\t@include nl {\n\t\t\tmargin-bottom: 24px; } }\n\t&__title {\n\t\tposition: relative;\n\t\tmargin-bottom: 3px;\n\t\tpadding-right: 30px;\n\t\tcolor: $text;\n\t\ttransition: color .25s;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 5px;\n\t\t\tright: 8px;\n\t\t\twidth: 6px;\n\t\t\theight: 10px;\n\t\t\tbackground: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='10'%3E%3Cpath fill='%2311142d' d='M.293.293A1 1 0 0 1 1.613.21l.094.083 4 4a1 1 0 0 1 .083 1.32l-.083.094-4 4A1 1 0 0 1 .21 8.387l.083-.094L3.585 5 .293 1.707A1 1 0 0 1 .21.387L.293.293z'/%3E%3C/svg%3E\") no-repeat 50% 50% / 100% auto;\n\t\t\ttransition: transform .25s; } }\n\t&__info {\n\t\tcolor: $gray-dark;\n\t\ttransition: color .25s; }\n\t&__item:hover &__title:before {\n\t\ttransform: translateX(5px); }\n\t&__item:hover &__title,\n\t&__item:hover &__info {\n\t\tcolor: $purple; }\n\t&.active &__head {\n\t\tborder-color: $link;\n\t\tbackground: $wh;\n\t\tcolor: $text;\n\t\t&:before {\n\t\t\ttransform: translateY(-50%) rotate(180deg); } }\n\t&.active &__body {\n\t\tvisibility: visible;\n\t\topacity: 1; } }\n\n@include dark {\n\t.dropdown {\n\t\t&__head {\n\t\t\tbackground: rgba($border, .04);\n\t\t\t&:before {\n\t\t\t\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='8'%3E%3Cpath fill='%23ffffff' d='M.293.293A1 1 0 0 1 1.613.21l.094.083L7 5.585 12.293.293a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 .083 1.32l-.083.094-6 6a1 1 0 0 1-1.32.083l-.094-.083-6-6a1 1 0 0 1 0-1.414z'/%3E%3C/svg%3E\"); } }\n\t\t&__body {\n\t\t\tborder-color: $border-dark;\n\t\t\tbackground: $dark;\n\t\t\tbox-shadow: 0 20px 16px rgba(#000, .5); }\n\t\t&__title {\n\t\t\tcolor: $wh;\n\t\t\t&:before {\n\t\t\t\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='10'%3E%3Cpath fill='%23ffffff' d='M.293.293A1 1 0 0 1 1.613.21l.094.083 4 4a1 1 0 0 1 .083 1.32l-.083.094-4 4A1 1 0 0 1 .21 8.387l.083-.094L3.585 5 .293 1.707A1 1 0 0 1 .21.387L.293.293z'/%3E%3C/svg%3E\"); } }\n\t\t&.active .dropdown__head {\n\t\t\tbackground: rgba($border, .04);\n\t\t\tcolor: $wh; } } }\n\n\n",".products {\n\t& > &__title {\n\t\tmargin-bottom: 16px; }\n\t& > &__info {\n\t\tmargin-bottom: 20px;\n\t\tcolor: $gray-dark; }\n\t&__table {\n\t\tdisplay: table;\n\t\twidth: 100%;\n\t\t@include m {\n\t\t\tdisplay: block;\n\t\t\tmargin-top: -72px; } }\n\t&__row {\n\t\tdisplay: table-row;\n\t\t@include m {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tpadding: 24px; }\n\t\t&:not(.products__row_head) {\n\t\t\t@include m {\n\t\t\t\tborder-top: 1px solid $border; } } }\n\t&__row_head &__cell {\n\t\tpadding-top: 24px;\n\t\tpadding-bottom: 24px;\n\t\tfont-size: 13px;\n\t\tline-height: (18/13);\n\t\tfont-weight: 500;\n\t\tcolor: $gray-light;\n\t\t@include m {\n\t\t\tpadding: 0; } }\n\t&__cell {\n\t\tdisplay: table-cell;\n\t\tvertical-align: middle;\n\t\tpadding-left: 20px;\n\t\tpadding-top: 32px;\n\t\tpadding-bottom: 32px;\n\t\tborder-bottom: 1px solid $border;\n\t\t@include d {\n\t\t\tpadding-left: 15px; }\n\t\t@include m {\n\t\t\tdisplay: block;\n\t\t\tpadding: 0;\n\t\t\tborder: none; }\n\t\t&:first-child {\n\t\t\twidth: 20px;\n\t\t\tpadding: 0;\n\t\t\tfont-size: 0;\n\t\t\t@include m {\n\t\t\t\tmargin-right: 24px; } }\n\t\t&:nth-child(n+3) {\n\t\t\t@include m {\n\t\t\t\tdisplay: none; } } }\n\t&__item {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tcolor: $text; }\n\t&__preview {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t\twidth: 96px;\n\t\theight: 72px;\n\t\tborder-radius: 8px;\n\t\tbackground: #A0D7E7;\n\t\tfont-size: 0;\n\t\t@include d {\n\t\t\twidth: 86px;\n\t\t\theight: 64px; }\n\t\t@include t {\n\t\t\tdisplay: none; }\n\t\t@include m {\n\t\t\tdisplay: block;\n\t\t\twidth: 72px;\n\t\t\theight: 55px; }\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 100%;\n\t\t\tleft: 7px;\n\t\t\tright: 7px;\n\t\t\theight: 8px;\n\t\t\tborder-radius: 0 0 8px 8px;\n\t\t\tbackground: #E7FAFF; } }\n\t&__pic {\n\t\tmax-height: 100%; }\n\t&__details {\n\t\tpadding-left: 24px;\n\t\t@include d {\n\t\t\tpadding-left: 16px; }\n\t\t@include t {\n\t\t\tpadding: 0; }\n\t\t@include m {\n\t\t\tpadding-left: 24px; } }\n\t&__cell &__title {\n\t\tmargin-bottom: 9px; }\n\t&__color {\n\t\tdisplay: flex;\n\t\talign-items: center; }\n\t&__bg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tflex-shrink: 0;\n\t\tborder-radius: 4px;\n\t\t@include d {\n\t\t\tborder-radius: 50%; }\n\t\t@include m {\n\t\t\twidth: 9px;\n\t\t\theight: 32px;\n\t\t\tmargin-right: 31px;\n\t\t\tborder-radius: 9px; } }\n\t&__rating {\n\t\tcolor: $gray-dark; }\n\t&__color &__text {\n\t\tmargin-left: 8px;\n\t\t@include d {\n\t\t\tdisplay: none; } }\n\t&__more {\n\t\tpadding-top: 40px;\n\t\ttext-align: center;\n\t\t@include t {\n\t\t\tpadding-top: 32px; }\n\t\t@include m {\n\t\t\tborder-top: 1px solid $border;\n\t\t\tpadding: 24px 24px 0; } }\n\t&__more &__btn {\n\t\t@include m {\n\t\t\tmin-width: 100%; } }\n\t&__cost {\n\t\tposition: relative;\n\t\tcursor: pointer; }\n\t&__cost &__tooltip {\n\t\tposition: absolute;\n\t\ttop: 10%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%,-50%);\n\t\tmin-width: 160px;\n\t\tpadding: 32px 26px;\n\t\tbackground: $wh;\n\t\tborder-radius: 24px;\n\t\tbox-shadow: 0 20px 30px rgba(#E3E6EC, .9);\n\t\tvisibility: hidden;\n\t\topacity: 0;\n\t\ttransition: all .2s; }\n\t&__cost:hover &__tooltip {\n\t\tvisibility: visible;\n\t\topacity: 1; }\n\t&__sale {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tmargin-bottom: 8px;\n\t\tcolor: $gray-dark; }\n\t&__sale &__icon {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tmargin-right: 8px;\n\t\tborder-radius: 6px; }\n\t&__sale &__pic {\n\t\tmax-width: 8px; }\n\t&__progress {\n\t\tposition: relative;\n\t\twidth: 100%;\n\t\theight: 2px;\n\t\tborder-radius: 1px;\n\t\tbackground: $border;\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tbottom: 0;\n\t\t\tborder-radius: 1px;\n\t\t\tbackground: $purple; } }\n\t&__price {\n\t\t@include nl {\n\t\t\tmargin-bottom: 10px; } }\n\t&__transaction {\n\t\tcolor: $gray-dark; }\n\t&__status {\n\t\tdisplay: inline-block;\n\t\tpadding: 3px 16px;\n\t\tborder-radius: 4px;\n\t\tcolor: $wh; }\n\t&__body {\n\t\tdisplay: none;\n\t\talign-items: center;\n\t\tmargin: 0 24px 24px;\n\t\tpadding: 4px;\n\t\tborder: 1px solid $border;\n\t\tborder-radius: 8px;\n\t\t@include m {\n\t\t\tdisplay: flex; } }\n\t&__line {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-grow: 1; }\n\t&_main &__money {\n\t\tcolor: $link; }\n\t&_main &__cell:nth-child(2) {\n\t\tfont-size: 0; }\n\t&_main &__col {\n\t\t&:first-child {\n\t\t\tflex: 0 0 30%;\n\t\t\tpadding-right: 8px; }\n\t\t&:nth-child(2) {\n\t\t\tflex: 0 0 44%;\n\t\t\tpadding-right: 8px; }\n\t\t&:nth-child(3) {\n\t\t\tflex: 0 0 26%; } }\n\t&_history &__col {\n\t\t&:first-child {\n\t\t\tflex: 0 0 42%;\n\t\t\tpadding-right: 8px; }\n\t\t&:nth-child(2) {\n\t\t\tflex: 0 0 32%;\n\t\t\tpadding-right: 8px; }\n\t\t&:nth-child(3) {\n\t\t\tflex: 0 0 26%; } }\n\t&_statement &__cell {\n\t\t@include m {\n\t\t\tdisplay: block; }\n\t\t&:not(:first-child):not(:nth-child(3)) {\n\t\t\t@include m {\n\t\t\t\tdisplay: none; } } }\n\t&_statement &__col {\n\t\t&:first-child {\n\t\t\tflex: 0 0 42%;\n\t\t\tpadding-right: 8px; }\n\t\t&:nth-child(2) {\n\t\t\tflex: 0 0 32%;\n\t\t\tpadding-right: 8px; }\n\t\t&:nth-child(3) {\n\t\t\tflex: 0 0 26%; } } }\n\n@include dark {\n\t.products {\n\t\t&__row:not(.products__row_head) {\n\t\t\t@include m {\n\t\t\t\tborder-color: $border-dark; } }\n\t\t&__cell {\n\t\t\tborder-color: $border-dark; }\n\t\t&__item {\n\t\t\tcolor: $wh; }\n\t\t&__body {\n\t\t\tborder-color: $border-dark; }\n\t\t&__more {\n\t\t\t@include m {\n\t\t\t\tborder-color: $border-dark; } } } }\n\n",".checkbox {\n\tdisplay: inline-block;\n\tposition: relative;\n\tuser-select: none;\n\tcursor: pointer;\n\t-webkit-tap-highlight-color: rgba(0,0,0,0);\n\t&__input {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\topacity: 0; }\n\t&__in {\n\t\tdisplay: flex; }\n\t&__tick {\n\t\tposition: relative;\n\t\tflex: 0 0 20px;\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tborder-radius: 4px;\n\t\tborder: 2px solid $border;\n\t\ttransition: all .25s;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\ttransform: translate(-50%,-50%);\n\t\t\twidth: 10px;\n\t\t\theight: 9px;\n\t\t\topacity: 0;\n\t\t\tbackground: url(\"data:image/svg+xml,%3Csvg width='10' height='9' viewBox='0 0 10 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.5 5.375L1.5 3.375L0 4.875L3.5 8.375L10 1.875L8.5 0.375L3.5 5.375Z' fill='white'/%3E%3C/svg%3E%0A\") no-repeat 50% 50% / 100% auto;\n\t\t\ttransition: opacity .25s; } }\n\t&__text {\n\t\tmargin-left: 8px;\n\t\tpadding-top: 2px;\n\t\tfont-size: 13px;\n\t\tfont-weight: 600;\n\t\tline-height: 1.3;\n\t\tcolor: $gray-dark; }\n\t&:hover &__tick {\n\t\tborder-color: $purple; }\n\t&__input:checked + &__in &__tick {\n\t\tbackground: $purple;\n\t\tborder-color: $purple;\n\t\t&:before {\n\t\t\topacity: 1; } }\n\t&__input:checked + &__in &__text {\n\t\tcolor: $text; } }\n\n@include dark {\n\t.checkbox {\n\t\t&__tick {\n\t\t\tborder-color: $border-dark; }\n\t\t&__input:checked + .checkbox__in .checkbox__text {\n\t\t\tcolor: $wh; } } }\n\n",".radio {\n\tdisplay: inline-block;\n\tposition: relative;\n\tuser-select: none;\n\tcursor: pointer;\n\t-webkit-tap-highlight-color: rgba(0,0,0,0);\n\t&__input {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\topacity: 0; }\n\t&__in {\n\t\tdisplay: flex; }\n\t&__tick {\n\t\tposition: relative;\n\t\tflex: 0 0 20px;\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tborder-radius: 50%;\n\t\tbackground: $border;\n\t\ttransition: all .25s;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\ttransform: translate(-50%,-50%);\n\t\t\twidth: 10px;\n\t\t\theight: 10px;\n\t\t\tborder-radius: 50%;\n\t\t\tbackground: $wh;\n\t\t\tbox-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);\n\t\t\topacity: 0;\n\t\t\ttransition: opacity .25s; } }\n\t&__text {\n\t\tmargin-left: 8px;\n\t\tpadding-top: 3px;\n\t\tfont-size: 13px;\n\t\tline-height: 1.2;\n\t\tcolor: $gray-dark;\n\t\ttransition: color .25s; }\n\t&:hover &__tick {\n\t\tbackground: $purple; }\n\t&__input:checked + &__in &__tick {\n\t\tbackground: $purple;\n\t\t&:before {\n\t\t\topacity: 1; } }\n\t&__input:checked + &__in &__text {\n\t\tcolor: $text; } }\n\n@include dark {\n\t.radio {\n\t\t&__tick {\n\t\t\tbackground: $border-dark; }\n\t\t&__input:checked + .radio__in .radio__text {\n\t\t\tcolor: $wh; } } }\n\n",".details {\n\t&__container {\n\t\tposition: relative;\n\t\tpadding: 32px 32px 38px;\n\t\tbackground: $wh;\n\t\tborder-radius: 24px;\n\t\t@include m {\n\t\t\tpadding-bottom: 32px; }\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 28px;\n\t\t\tleft: 18px;\n\t\t\tright: 18px;\n\t\t\tbottom: -28px;\n\t\t\tz-index: -1;\n\t\t\t@include shadow; } }\n\t&__title {\n\t\tmargin-bottom: 40px;\n\t\t@include m {\n\t\t\tmargin-bottom: 24px; } }\n\t&__row {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 30px;\n\t\t@include m {\n\t\t\tdisplay: block; } }\n\t&__col {\n\t\t&:first-child {\n\t\t\tflex-shrink: 0;\n\t\t\twidth: 145px;\n\t\t\tpadding-right: 16px;\n\t\t\t@include m {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: flex-end;\n\t\t\t\twidth: auto;\n\t\t\t\tmargin: 0 -5px 32px;\n\t\t\t\tpadding: 0; } }\n\t\t&:nth-child(2) {\n\t\t\tflex-grow: 1; } }\n\t&__top {\n\t\tmargin-bottom: 16px;\n\t\tpadding-bottom: 16px;\n\t\tborder-bottom: 1px solid $border;\n\t\t@include m {\n\t\t\tflex: 0 0 calc(50% - 10px);\n\t\t\tmargin: 0 5px;\n\t\t\tpadding: 0;\n\t\t\tborder: none; } }\n\t&__bottom {\n\t\t@include m {\n\t\t\tflex: 0 0 calc(50% - 10px);\n\t\t\tmargin: 0 5px; } }\n\t&__number {\n\t\tmargin-bottom: 16px; }\n\t&__line {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tcolor: $link;\n\t\ttransition: color .25s;\n\t\t&:hover {\n\t\t\tcolor: $purple; } }\n\t&__preview {\n\t\tfont-size: 0; }\n\t&__line &__preview {\n\t\twidth: 32px;\n\t\tflex-shrink: 0;\n\t\tmargin-right: 16px; }\n\t&__statistics {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tmargin-bottom: 20px;\n\t\t@include m {\n\t\t\tmargin-bottom: 32px; } }\n\t&__status {\n\t\tdisplay: flex;\n\t\talign-items: center; }\n\t&__status &__icon {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tmargin-right: 4px;\n\t\tborder-radius: 50%;\n\t\tfont-size: 0;\n\t\t.icon {\n\t\t\tfont-size: 6px;\n\t\t\tfill: $wh; } }\n\t&__box {\n\t\tposition: relative;\n\t\tpadding: 5px 5px 13px;\n\t\tborder-radius: 16px;\n\t\tbackground: $blue; }\n\t&__chart {\n\t\t&_activity {\n\t\t\theight: 25px;\n\t\t\tflex-grow: 1;\n\t\t\tpadding-right: 13px; }\n\t\t&_counter {\n\t\t\theight: 200px;\n\t\t\t.apexcharts-tooltip.apexcharts-theme-light {\n\t\t\t\tbackground: $bl;\n\t\t\t\tborder: none;\n\t\t\t\tcolor: $wh; } }\n\t\t&_report {\n\t\t\theight: 215px; } }\n\t&__info {\n\t\tcolor: $gray-light; }\n\t&__list {\n\t\tdisplay: flex;\n\t\tborder-radius: 16px;\n\t\tborder: 1px solid $border;\n\t\t@include m {\n\t\t\tflex-wrap: wrap; } }\n\t&__item {\n\t\tpadding: 24px;\n\t\t@include nl {\n\t\t\tborder-right: 1px solid $border;\n\t\t\t@include m {\n\t\t\t\tborder-right: none; } } }\n\t&__list_three &__item {\n\t\tflex: 0 0 33.333%;\n\t\twidth: 33.333%;\n\t\t@include m {\n\t\t\tflex: 0 0 100%;\n\t\t\twidth: 100%; }\n\t\t@include nf {\n\t\t\t@include m {\n\t\t\t\tborder-top: 1px solid $border; } } }\n\t&__list_four &__item {\n\t\tflex: 0 0 25%;\n\t\twidth: 25%;\n\t\t@include m {\n\t\t\tflex: 0 0 50%;\n\t\t\twidth: 50%; }\n\t\t&:nth-child(2n+1) {\n\t\t\t@include m {\n\t\t\t\tborder-right: 1px solid $border; } }\n\t\t&:nth-child(n+3) {\n\t\t\t@include m {\n\t\t\t\tborder-top: 1px solid $border; } } }\n\t&__head {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tmargin-bottom: 8px; }\n\t&__head &__preview {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tmargin-right: 8px;\n\t\tborder-radius: 6px;\n\t\tfont-size: 0; }\n\t&__head &__pic {\n\t\tmax-width: 8px; }\n\t&__indicator {\n\t\tposition: relative;\n\t\theight: 2px;\n\t\tborder-radius: 1px;\n\t\tbackground: $border; }\n\t&__progress {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tbottom: 0; }\n\t&__remove {\n\t\tposition: absolute;\n\t\ttop: 8px;\n\t\tright: 8px;\n\t\tz-index: 2;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tborder-radius: 50%;\n\t\tbackground: $wh;\n\t\tfont-size: 0;\n\t\t.icon {\n\t\t\tfont-size: 10px;\n\t\t\ttransition: transform .25s; }\n\t\t&:hover .icon {\n\t\t\ttransform: rotate(90deg); } }\n\t.dropdown {\n\t\tposition: absolute;\n\t\ttop: 16px;\n\t\tright: 20px;\n\t\twidth: 200px;\n\t\t@include m {\n\t\t\tposition: relative;\n\t\t\ttop: auto;\n\t\t\tright: auto;\n\t\t\twidth: 100%;\n\t\t\tmargin-bottom: 20px; } }\n\t@include nl {\n\t\tmargin-bottom: 28px; }\n\t&_statements {\n\t\t@include nl {\n\t\t\tmargin-bottom: 68px;\n\t\t\t@include m {\n\t\t\t\tmargin-bottom: 32px; } } }\n\t&_statements &__col:first-child {\n\t\twidth: 170px;\n\t\tpadding-right: 25px;\n\t\t@include m {\n\t\t\twidth: auto;\n\t\t\tpadding: 0; } }\n\t&_statements &__counter {\n\t\tmargin-bottom: 10px; }\n\t&_statements &__line &__info {\n\t\tcolor: $link; } }\n\n@include dark {\n\t.details {\n\t\t&__container {\n\t\t\tbackground: $dark;\n\t\t\t&:before {\n\t\t\t\t@include shadow-dark; } }\n\t\t&__remove {\n\t\t\tbackground: $dark;\n\t\t\t.icon {\n\t\t\t\tfill: $wh; } }\n\t\t&__list {\n\t\t\tborder-color: $border-dark; }\n\t\t&__top {\n\t\t\tborder-color: $border-dark; }\n\t\t&__item {\n\t\t\tborder-color: $border-dark; }\n\t\t&__indicator {\n\t\t\tbackground: $border-dark; }\n\t\t&__list_four .details__item:nth-child(n+3) {\n\t\t\t@include m {\n\t\t\t\tborder-color: $border-dark; } }\n\t\t&__list_three .details__item {\n\t\t\t@include nf {\n\t\t\t\t@include m {\n\t\t\t\t\tborder-color: $border-dark; } } } } }\n",".quality {\n\t&__item {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\t&_chart {\n\t\t\tposition: relative;\n\t\t\tpadding-right: 60px; }\n\t\t&[href] {\n\t\t\tcolor: $text; }\n\t\t@include nl {\n\t\t\tmargin-bottom: 48px; } }\n\t&__preview {\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t\twidth: 48px;\n\t\theight: 48px;\n\t\tmargin-right: 14px;\n\t\tborder-radius: 12px;\n\t\tfont-size: 0; }\n\t&__preview &__pic {\n\t\tmax-height: 100%; }\n\t&__chart {\n\t\tposition: absolute;\n\t\ttop: 73%;\n\t\tright: -32px;\n\t\ttransform: translateY(-50%);\n\t\twidth: 110px;\n\t\theight: 110px; }\n\t&__details {\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\tflex-grow: 1; }\n\t&__percent {\n\t\tposition: absolute;\n\t\ttop: 39%;\n\t\tleft: 51%;\n\t\tpointer-events: none;\n\t\ttransform: translate(-50%,-50%); }\n\t&__info {\n\t\tmargin-top: 5px;\n\t\tcolor: $gray-dark; }\n\t&__btn {\n\t\tmargin-top: 40px;\n\t\t&_mt30 {\n\t\t\tmargin-top: 30px; } }\n\t&__line {\n\t\tdisplay: flex; }\n\t&__line &__price {\n\t\tmargin-left: auto;\n\t\tpadding-left: 10px;\n\t\tcolor: $green; }\n\t&__category {\n\t\tposition: relative;\n\t\tpadding-right: 20px;\n\t\t.icon {\n\t\t\tposition: absolute;\n\t\t\ttop: 5px;\n\t\t\tright: 5px;\n\t\t\tfont-size: 10px;\n\t\t\ttransition: transform .25s; } }\n\t&__money {\n\t\tdisplay: inline-block;\n\t\tmargin-top: 8px;\n\t\tpadding: 3px 10px;\n\t\tbackground: $purple;\n\t\tborder-radius: 8px;\n\t\tcolor: $wh; }\n\t&_big &__list {\n\t\tmargin: -8px -16px; }\n\t&_big &__item {\n\t\tposition: relative;\n\t\tpadding: 8px 16px;\n\t\tbackground: transparent;\n\t\tborder-radius: 12px;\n\t\ttransition: all .25s;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 100%;\n\t\t\tleft: 10px;\n\t\t\tright: 10px;\n\t\t\theight: 0;\n\t\t\tborder-radius: 0 0 8px 8px;\n\t\t\tbackground: $purple-light;\n\t\t\ttransition: height .25s; }\n\t\t&:hover {\n\t\t\tbackground: $purple;\n\t\t\tcolor: $wh;\n\t\t\t&:before {\n\t\t\t\theight: 6px; } }\n\t\t@include nl {\n\t\t\tmargin-bottom: 24px; } }\n\t&_big &__item:hover &__category {\n\t\tcolor: $wh;\n\t\t.icon {\n\t\t\tfill: $wh; } }\n\t&_big &__item:hover &__info {\n\t\tcolor: $wh; }\n\t&_big &__preview {\n\t\tposition: relative;\n\t\twidth: 88px;\n\t\theight: 80px;\n\t\tmargin-right: 24px;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute; } } }\n\n@include dark {\n\t.quality {\n\t\t&__item {\n\t\t\tcolor: $wh; }\n\t\t&__category .icon {\n\t\t\tfill: $wh; } } }\n",".goal {\n\t&__container {\n\t\tmin-height: 220px;\n\t\tmargin: 0 -16px 26px; }\n\t&__preview {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\theight: 220px;\n\t\tfont-size: 0; }\n\t&__pic {\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\tmax-height: 100%; }\n\t&__bg {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tright: 0;\n\t\twidth: 50%;\n\t\tborder-radius: 16px; }\n\t&__item {\n\t\t@include nl {\n\t\t\tmargin-bottom: 32px; } }\n\t&__head {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 13px; }\n\t&__percent {\n\t\tflex-shrink: 0;\n\t\tmargin-left: auto;\n\t\tpadding-left: 15px; }\n\t&__indicator {\n\t\tposition: relative;\n\t\theight: 8px;\n\t\tbackground: $border;\n\t\tborder-radius: 4px; }\n\t&__progress {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tbottom: 0;\n\t\tborder-radius: 4px; }\n\t.owl-carousel .owl-item img {\n\t\twidth: auto; }\n\t.owl-nav {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 16px;\n\t\tz-index: 2;\n\t\tdisplay: flex; }\n\t.owl-carousel .owl-nav button.owl-prev,\n\t.owl-carousel .owl-nav button.owl-next {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tbackground: $wh;\n\t\tborder-radius: 50%;\n\t\tbox-shadow: 0 5px 10px #E3E6EC;\n\t\tfont-size: 0;\n\t\ttransition: all .25s;\n\t\t.icon {\n\t\t\tfont-size: 10px;\n\t\t\tfill: $text;\n\t\t\ttransition: fill .25s; }\n\t\t&:hover {\n\t\t\tbackground: $purple;\n\t\t\t.icon {\n\t\t\t\tfill: $wh; } } }\n\t.owl-carousel .owl-nav button.owl-prev {\n\t\tmargin-right: 8px; } }\n\n@include dark {\n\t.goal {\n\t\t&__indicator {\n\t\t\tbackground: $border-dark; }\n\t\t.owl-carousel .owl-nav button.owl-prev,\n\t\t.owl-carousel .owl-nav button.owl-next {\n\t\t\tbackground: $dark;\n\t\t\tbox-shadow: 0 5px 10px rgba(#000, .3);\n\t\t\t.icon {\n\t\t\t\tfill: $wh; }\n\t\t\t&:hover {\n\t\t\t\tbackground: $purple; } } } }\n\n\n",".schedules {\n\t&__container {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tpadding: 32px 32px 32px 16px;\n\t\tborder-radius: 24px;\n\t\tbackground: $wh;\n\t\t@include x {\n\t\t\tdisplay: block;\n\t\t\tpadding: 0;\n\t\t\tbackground: none;\n\t\t\tborder-radius: 0; }\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 35px;\n\t\t\tleft: 35px;\n\t\t\tright: 35px;\n\t\t\tbottom: -35px;\n\t\t\tz-index: -5;\n\t\t\t@include shadow;\n\t\t\t@include x {\n\t\t\t\tdisplay: none; } } }\n\t&__col {\n\t\t@include x {\n\t\t\tposition: relative;\n\t\t\tpadding: 32px;\n\t\t\tborder-radius: 24px;\n\t\t\tbackground: $wh;\n\t\t\t&:before {\n\t\t\t\tcontent: \"\";\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 35px;\n\t\t\t\tleft: 35px;\n\t\t\t\tright: 35px;\n\t\t\t\tbottom: -35px;\n\t\t\t\tz-index: -5;\n\t\t\t\t@include shadow; } }\n\t\t&:first-child {\n\t\t\tflex-shrink: 0;\n\t\t\twidth: 310px;\n\t\t\t@include x {\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin-bottom: 32px; }\n\t\t\t.schedules__title {\n\t\t\t\tdisplay: none;\n\t\t\t\t@include x {\n\t\t\t\t\tdisplay: block; } } }\n\t\t&:nth-child(2) {\n\t\t\tflex-grow: 1;\n\t\t\tpadding-left: 16px;\n\t\t\t@include x {\n\t\t\t\tpadding-left: 32px; } } }\n\t&__list {\n\t\tmargin-top: -8px;\n\t\t@include x {\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\t\t\tmargin: -32px -32px 0; }\n\t\t@include m {\n\t\t\tdisplay: block;\n\t\t\tmargin: 0 -16px; } }\n\t&__item {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: 8px 16px;\n\t\tborder-radius: 12px;\n\t\tbackground: transparent;\n\t\tcolor: $text;\n\t\ttransition: all .25s;\n\t\t@include x {\n\t\t\tflex: 0 0 calc(50% - 32px);\n\t\t\twidth: calc(50% - 32px);\n\t\t\tmargin: 32px 16px 0; }\n\t\t@include m {\n\t\t\tflex: 0 0 100%;\n\t\t\twidth: 100%;\n\t\t\tmargin: 0; }\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 100%;\n\t\t\tleft: 10px;\n\t\t\tright: 10px;\n\t\t\theight: 6px;\n\t\t\tborder-radius: 0 0 6px 6px;\n\t\t\tbackground: $purple-light;\n\t\t\topacity: 0;\n\t\t\ttransition: opacity .25s; }\n\t\t&:hover {\n\t\t\tcolor: $purple;\n\t\t\t.icon {\n\t\t\t\tfill: $purple; } }\n\t\t&.active {\n\t\t\tbackground: $purple;\n\t\t\tcolor: $wh;\n\t\t\t&:before {\n\t\t\t\topacity: 1; } }\n\t\t@include nl {\n\t\t\tmargin-bottom: 24px;\n\t\t\t@include x {\n\t\t\t\tmargin-bottom: 0; }\n\t\t\t@include m {\n\t\t\t\tmargin-bottom: 24px; } } }\n\t&__date {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t\twidth: 88px;\n\t\theight: 80px;\n\t\tmargin-right: 24px;\n\t\tpadding-top: 7px;\n\t\tborder-radius: 12px;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 100%;\n\t\t\tleft: 9px;\n\t\t\tright: 9px;\n\t\t\theight: 7px;\n\t\t\tborder-radius: 0 0 10px 10px; }\n\t\t&.bg-pink-light:before {\n\t\t\tbackground: rgba($pink-light, .5); }\n\t\t&.bg-purple-light:before {\n\t\t\tbackground: rgba($purple-light, .5); }\n\t\t&.bg-blue-light:before {\n\t\t\tbackground: rgba($blue-light, .5); }\n\t\t&.bg-yellow-light:before {\n\t\t\tbackground: rgba($yellow-light, .5); } }\n\t&__name {\n\t\tline-height: 1;\n\t\tcolor: $gray-dark; }\n\t&__details {\n\t\tflex-grow: 1; }\n\t&__category {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tmargin-bottom: 5px;\n\t\tpadding-right: 35px;\n\t\t.icon {\n\t\t\tposition: absolute;\n\t\t\ttop: 5px;\n\t\t\tright: 20px;\n\t\t\tfont-size: 10px;\n\t\t\ttransition: all .25s; } }\n\t&__info {\n\t\tmargin-bottom: 8px;\n\t\tcolor: $gray-dark; }\n\t&__time {\n\t\tdisplay: inline-block;\n\t\tpadding: 3px 10px;\n\t\tbackground: $purple;\n\t\tborder-radius: 8px;\n\t\tcolor: $wh; }\n\t&__item.active &__name,\n\t&__item.active &__info {\n\t\tcolor: $wh; }\n\t&__item.active &__category .icon {\n\t\ttransform: translateX(4px);\n\t\tfill: $wh; }\n\t&__item.active &__date {\n\t\tbackground: transparent;\n\t\t&:before {\n\t\t\tbackground: transparent; } }\n\t&__item.active &__time {\n\t\tbackground: $pink-light;\n\t\tcolor: $text; }\n\t&__top {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tmargin-bottom: 32px;\n\t\t@include m {\n\t\t\tmargin: -16px 0 20px; } }\n\t&__arrows {\n\t\tdisplay: none;\n\t\tmargin-left: auto;\n\t\tmargin-right: -16px;\n\t\t@include m {\n\t\t\tdisplay: flex; } }\n\t&__arrow {\n\t\tflex-shrink: 0;\n\t\twidth: 48px;\n\t\theight: 48px;\n\t\tborder-radius: 50%;\n\t\tbox-shadow: 0 5px 20px rgba(#E3E6EC, .85);\n\t\tbackground: $wh;\n\t\tfont-size: 0;\n\t\ttransition: background .25s;\n\t\t.icon {\n\t\t\tfont-size: 10px;\n\t\t\tfill: $text;\n\t\t\ttransition: fill .25s; }\n\t\t&:hover {\n\t\t\tbackground: $purple;\n\t\t\t.icon {\n\t\t\t\tfill: $wh; } }\n\t\t@include nl {\n\t\t\tmargin-right: 8px; } }\n\t&__col > &__title {\n\t\tmargin-bottom: 32px; }\n\t&__btn {\n\t\tdisplay: none;\n\t\t@include x {\n\t\t\tdisplay: inline-block;\n\t\t\tmargin-top: 32px; } }\n\t&__inner {\n\t\t@include m {\n\t\t\tdisplay: flex;\n\t\t\tmargin: 0 -32px;\n\t\t\tpadding-bottom: 32px;\n\n\t\t\toverflow: auto;\n\t\t\toverflow-x: auto;\n\t\t\t-ms-overflow-style: none;\n\t\t\tscrollbar-width: none;\n\t\t\t-webkit-overflow-scrolling: touch;\n\t\t\t&::-webkit-scrollbar {\n\t\t\t  display: none; }\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tcontent: \"\";\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tflex-shrink: 0;\n\t\t\t\twidth: 32px;\n\t\t\t\theight: 1px; } } }\n\t&__graphic {\n\t\tposition: relative;\n\t\tmax-width: 586px;\n\t\tborder-radius: 16px;\n\t\tborder: 1px solid $border;\n\t\t@include x {\n\t\t\tmax-width: 100%; }\n\t\t@include m {\n\t\t\tmin-width: 586px;\n\t\t\tmargin-bottom: 7px; }\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 100%;\n\t\t\tleft: 14px;\n\t\t\tright: 14px;\n\t\t\theight: 7px;\n\t\t\tborder-radius: 0 0 7px 7px;\n\t\t\tborder-width: 0 1px 1px;\n\t\t\tborder-style: solid;\n\t\t\tborder-color: $border; } }\n\t&__head {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: 68px;\n\t\tborder-bottom: 1px solid $border; }\n\t&__option {\n\t\tflex-shrink: 0;\n\t\twidth: 138px;\n\t\tpadding-left: 32px;\n\t\tfont-size: 13px;\n\t\tfont-weight: 600;\n\t\tcolor: $gray-dark; }\n\t&__week {\n\t\tdisplay: flex;\n\t\tflex-grow: 1; }\n\t&__cell {\n\t\tflex: 0 0 16.666%;\n\t\twidth: 16.666%; }\n\t&__day {\n\t\tposition: relative;\n\t\tdisplay: inline-block;\n\t\tmin-width: 32px;\n\t\tmargin-left: -16px;\n\t\tbackground: transparent;\n\t\tborder-radius: 50%;\n\t\ttext-align: center;\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t\tline-height: 32px;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 6px;\n\t\t\tright: -4px;\n\t\t\twidth: 10px;\n\t\t\theight: 10px;\n\t\t\tborder-radius: 50%; }\n\t\t&.active {\n\t\t\tbackground: $red;\n\t\t\tcolor: $wh; }\n\t\t&.green:before {\n\t\t\tbackground: $green; }\n\t\t&.purple:before {\n\t\t\tbackground: $purple; }\n\t\t&.gray:before {\n\t\t\tbackground: $border; } }\n\t&__body {\n\t\tposition: relative;\n\t\tpadding: 26px 0 22px; }\n\t&__grid {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 138px;\n\t\tright: 0;\n\t\tbottom: 0; }\n\t&__line {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\twidth: 1px;\n\t\tbackground: $border;\n\t\tpointer-events: none;\n\t\t&:first-child {\n\t\t\tleft: 8.33%; }\n\t\t&:nth-child(2) {\n\t\t\tleft: 25%; }\n\t\t&:nth-child(3) {\n\t\t\tleft: 41.66%; }\n\t\t&:nth-child(4) {\n\t\t\tleft: 58.33%; }\n\t\t&:nth-child(5) {\n\t\t\tleft: 75%; } }\n\t&__row {\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\t@include nl {\n\t\t\tmargin-bottom: 18px; } }\n\t&__task {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\talign-items: center;\n\t\theight: 32px;\n\t\tpadding: 0 2px;\n\t\tborder-radius: 8px; }\n\t&__task &__text {\n\t\tpadding: 0 15px;\n\t\tbackground: rgba($wh, .8);\n\t\tborder-radius: 6px;\n\t\tfont-size: 12px;\n\t\tfont-weight: 500;\n\t\tline-height: 28px;\n\t\t@include t {\n\t\t\tpadding: 0 10px; } }\n\t&__legend {\n\t\tdisplay: flex;\n\t\tmargin-top: 32px;\n\t\tpadding: 0 16px;\n\t\t@include m {\n\t\t\tflex-wrap: wrap;\n\t\t\tmargin-top: -10px;\n\t\t\tpadding: 0; } }\n\t&__status {\n\t\tposition: relative;\n\t\tpadding-left: 20px;\n\t\tfont-size: 12px;\n\t\tline-height: 1.2;\n\t\tfont-weight: 500;\n\t\tcolor: $gray-dark;\n\t\t@include m {\n\t\t\tmargin-top: 10px; }\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\twidth: 12px;\n\t\t\theight: 12px;\n\t\t\tborder-radius: 50%; }\n\t\t&.green:before {\n\t\t\tbackground: $green; }\n\t\t&.purple:before {\n\t\t\tbackground: $purple; }\n\t\t&.gray:before {\n\t\t\tbackground: $border; }\n\t\t@include nl {\n\t\t\tmargin-right: 120px;\n\t\t\t@include x {\n\t\t\t\tmargin-right: auto; }\n\t\t\t@include m {\n\t\t\t\tmargin-right: 15px; } } }\n\t@include nl {\n\t\tmargin-bottom: 36px; } }\n\n@include dark {\n\t.schedules {\n\t\t&__container {\n\t\t\tbackground: $dark;\n\t\t\t@include x {\n\t\t\t\tbackground: none; }\n\t\t\t&:before {\n\t\t\t\t@include shadow-dark; } }\n\t\t&__col {\n\t\t\t@include x {\n\t\t\t\tbackground: $dark;\n\t\t\t\t&:before {\n\t\t\t\t\t@include shadow-dark; } } }\n\t\t&__item {\n\t\t\tcolor: $wh; }\n\t\t&__category .icon {\n\t\t\tfill: $wh; }\n\t\t&__name,\n\t\t&__number {\n\t\t\tcolor: $link; }\n\t\t&__item:hover {\n\t\t\tcolor: $purple;\n\t\t\t.icon {\n\t\t\t\tfill: $purple; } }\n\t\t&__item.active,\n\t\t&__item.active .schedules__number {\n\t\t\tcolor: $wh; }\n\t\t&__item.active .icon {\n\t\t\tfill: $wh; }\n\t\t&__graphic {\n\t\t\tborder-color: $border-dark;\n\t\t\t&:before {\n\t\t\t\tborder-color: $border-dark; } }\n\t\t&__head {\n\t\t\tborder-color: $border-dark; }\n\t\t&__day.gray:before,\n\t\t&__status.gray:before {\n\t\t\tbackground: $border-dark; }\n\t\t&__line {\n\t\t\tbackground: $border-dark; }\n\t\t&__task .schedules__text {\n\t\t\tbackground: rgba($dark, .8); }\n\t\t&__arrow {\n\t\t\tbackground: $dark;\n\t\t\tbox-shadow: 0 5px 20px rgba(#000, .35);\n\t\t\t.icon {\n\t\t\t\tfill: $wh; } } } }\n\n\n\n\n\n\n\n",".tabs {\n\t&__row {\n\t\tdisplay: flex;\n\t\tmargin: -20px 0 14px -16px;\n\t\t@include m {\n\t\t\tdisplay: block;\n\t\t\tmargin: -20px -16px; } }\n\t&__col {\n\t\t&:first-child {\n\t\t\tflex: 0 0 53%;\n\t\t\twidth: 53%;\n\t\t\t@include m {\n\t\t\t\twidth: 100%; } }\n\t\t&:nth-child(2) {\n\t\t\tflex: 0 0 47%;\n\t\t\twidth: 47%;\n\t\t\tpadding-top: 20px;\n\t\t\t@include m {\n\t\t\t\tdisplay: none; } } }\n\t&__list {\n\t\tmargin-left: -16px; }\n\t&__item {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: 20px 16px;\n\t\tborder-radius: 16px;\n\t\tcolor: $text;\n\t\ttransition: all .25s;\n\t\t&:hover {\n\t\t\tcolor: $purple;\n\t\t\t.icon {\n\t\t\t\tfill: $purple; } }\n\t\t&.active {\n\t\t\tbackground: $pink-light;\n\t\t\tcolor: $text;\n\t\t\t.icon {\n\t\t\t\tfill: $text; } } }\n\t&__preview {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t\twidth: 88px;\n\t\theight: 80px;\n\t\tmargin-right: 16px;\n\t\tborder-radius: 12px;\n\t\tfont-size: 0;\n\t\t@include x {\n\t\t\tdisplay: none; }\n\t\t@include d {\n\t\t\tdisplay: block; } }\n\t&__pic {\n\t\tmax-height: 100%; }\n\t&__details {\n\t\tflex-grow: 1; }\n\t&__category {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tmargin-bottom: 3px;\n\t\tpadding-right: 20px;\n\t\t.icon {\n\t\t\tposition: absolute;\n\t\t\ttop: 5px;\n\t\t\tright: 5px;\n\t\t\tfont-size: 10px;\n\t\t\ttransition: transform .25s; } }\n\t&__item:hover &__category {}\n\t&__info {\n\t\tmargin-bottom: 8px;\n\t\tcolor: $gray-dark; }\n\t&__price {\n\t\tdisplay: inline-block;\n\t\tpadding: 3px 10px;\n\t\tbackground: $purple;\n\t\tborder-radius: 8px;\n\t\tcolor: $wh; }\n\t&__nav {\n\t\tdisplay: flex;\n\t\tpadding: 3px;\n\t\tborder-radius: 12px;\n\t\tborder: 1px solid $border;\n\t\t@include m {\n\t\t\tdisplay: none; } }\n\t&__link {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex: 0 0 25%;\n\t\twidth: 25%;\n\t\tpadding: 8px;\n\t\tborder-radius: 12px;\n\t\tfont-size: 12px;\n\t\tfont-weight: 500;\n\t\tline-height: 1.2;\n\t\tcolor: $gray-dark;\n\t\ttransition: all .25s;\n\t\t&:hover {\n\t\t\tcolor: $purple;\n\t\t\t.icon {\n\t\t\t\tfill: $purple; } }\n\t\t&.active {\n\t\t\tbackground: $purple;\n\t\t\tcolor: $wh;\n\t\t\t.icon {\n\t\t\t\tfill: $wh; } } }\n\t&__icon {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tmargin-bottom: 5px;\n\t\tfont-size: 0;\n\t\t.icon {\n\t\t\tfont-size: 18px;\n\t\t\tfill: $text;\n\t\t\ttransition: fill .25s; } }\n\t&__chart {\n\t\tmax-width: 190px;\n\t\theight: 140px;\n\t\tmargin: 0 auto 20px; }\n\t&__desc {\n\t\ttext-align: center; }\n\t&__title {\n\t\tmargin-bottom: 10px; }\n\t&__date {\n\t\tmargin-bottom: 50px;\n\t\tcolor: $gray-dark; }\n\t&__btn {\n\t\tmin-width: 180px; } }\n\n@include dark {\n\t.tabs {\n\t\t&__item {\n\t\t\tcolor: $wh;\n\t\t\t&:hover {\n\t\t\t\tcolor: $purple;\n\t\t\t\t.icon {\n\t\t\t\t\tfill: $purple; } }\n\t\t\t&.active {\n\t\t\t\tcolor: $text;\n\t\t\t\t.tabs__category .icon {\n\t\t\t\t\tfill: $text; } } }\n\t\t&__category .icon {\n\t\t\tfill: $wh; }\n\t\t&__nav {\n\t\t\tborder-color: $border-dark; }\n\t\t&__icon .icon {\n\t\t\tfill: $wh; }\n\t\t&__link:hover {\n\t\t\tcolor: $wh; } } }\n",".payment {\n\t&__row {\n\t\tdisplay: flex;\n\t\t@include m {\n\t\t\tdisplay: block; } }\n\t&__details {\n\t\tflex-shrink: 0;\n\t\twidth: 225px;\n\t\tmargin-right: 16px;\n\t\tpadding: 32px;\n\t\tborder-radius: 16px;\n\t\tbox-shadow: 0 10px 36px rgba(#E3E6EC, .6);\n\t\ttext-align: center;\n\t\t@include m {\n\t\t\twidth: 100%;\n\t\t\tmargin: 0 0 32px; } }\n\t&__preview {\n\t\tdisplay: inline-flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: 80px;\n\t\theight: 80px;\n\t\tmargin-bottom: 32px;\n\t\tborder-radius: 24px;\n\t\tfont-size: 0; }\n\t&__preview &__pic {\n\t\tmax-height: 100%; }\n\t&__pic_white {\n\t\tdisplay: none; }\n\t&__mail {\n\t\tmargin-bottom: 16px;\n\t\tcolor: $green; }\n\t&__info {\n\t\twidth: 100%;\n\t\tmax-width: 140px;\n\t\tcolor: $gray-light; }\n\t&__details &__info {\n\t\tmargin: 0 auto 32px; }\n\t&__logo {\n\t\tfont-size: 0; }\n\t&__details &__logo {\n\t\tdisplay: inline-block; }\n\t&__logo &__pic {\n\t\tmax-width: 87px;\n\t\tmax-height: 30px; }\n\t&__variants {\n\t\tflex-grow: 1; }\n\t&__label {\n\t\tdisplay: block;\n\t\tposition: relative;\n\t\tuser-select: none;\n\t\tcursor: pointer;\n\t\t-webkit-tap-highlight-color: rgba(0,0,0,0);\n\t\t@include nl {\n\t\t\tmargin-bottom: 18px; } }\n\t&__radio {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\topacity: 0; }\n\t&__in {\n\t\tdisplay: flex;\n\t\tpadding: 34px 32px;\n\t\tborder-radius: 16px;\n\t\tbox-shadow: inset 0 0 0 1px #E3E6EC;\n\t\ttransition: box-shadow .25s; }\n\t&__tick {\n\t\tposition: relative;\n\t\tflex: 0 0 16px;\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tmargin-right: 36px;\n\t\tborder-radius: 4px;\n\t\tborder: 2px solid $border;\n\t\ttransition: all .25s;\n\t\t@include m {\n\t\t\tmargin-right: 24px; }\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\ttransform: translate(-50%,-50%);\n\t\t\twidth: 8px;\n\t\t\theight: 7px;\n\t\t\topacity: 0;\n\t\t\tbackground: url(\"data:image/svg+xml,%3Csvg width='10' height='9' viewBox='0 0 10 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.5 5.375L1.5 3.375L0 4.875L3.5 8.375L10 1.875L8.5 0.375L3.5 5.375Z' fill='white'/%3E%3C/svg%3E%0A\") no-repeat 50% 50% / 100% auto;\n\t\t\ttransition: opacity .25s; } }\n\t&__desc &__logo {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: 30px;\n\t\tmargin-top: -8px; }\n\t&__desc &__info {\n\t\tdisplay: block;\n\t\tmargin-top: 16px; }\n\t&__btn {\n\t\tmin-width: 132px;\n\t\theight: 40px;\n\t\tmargin-top: 16px; }\n\t&__label:hover &__in {\n\t\tbox-shadow: inset 0 0 0 1px $purple; }\n\t&__radio:checked + &__in {\n\t\tbox-shadow: inset 0 0 0 2px $purple; }\n\t&__radio:checked + &__in &__tick {\n\t\tbackground: $purple;\n\t\tborder-color: $purple;\n\t\t&:before {\n\t\t\topacity: 1; } } }\n\n@include dark {\n\t.payment {\n\t\t&__pic_black {\n\t\t\tdisplay: none; }\n\t\t&__pic_white {\n\t\t\tdisplay: inline-block; }\n\t\t&__details {\n\t\t\tbox-shadow: 0 10px 36px rgba(#000, .35); }\n\t\t&__tick {\n\t\t\tborder-color: $border-dark; }\n\t\t&__in {\n\t\t\tbox-shadow: inset 0 0 0 1px $border-dark; } } }\n\n\n",".inbox {\n\t&__tags {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tmargin: -18px 0 28px -18px;\n\t\t@include m {\n\t\t\tmargin: -10px 0 24px -10px; } }\n\t&__tag {\n\t\tmargin: 18px 0 0 18px;\n\t\tborder: 2px solid $red;\n\t\tborder-radius: 12px;\n\t\tpadding: 6px 16px;\n\t\tline-height: (20/14);\n\t\tfont-weight: 600;\n\t\tcolor: $text;\n\t\ttransition: all .25s;\n\t\t@include m {\n\t\t\tmargin: 10px 0 0 10px; }\n\t\t&:hover,\n\t\t&.active {\n\t\t\tbackground: $purple;\n\t\t\tborder-color: $purple;\n\t\t\tcolor: $wh; } }\n\t&__container {\n\t\tposition: relative;\n\t\tpadding: 32px;\n\t\tborder-radius: 24px;\n\t\tbackground: $wh;\n\t\t@include m {\n\t\t\tpadding: 32px 24px; }\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 32px;\n\t\t\tleft: 18px;\n\t\t\tright: 18px;\n\t\t\tbottom: -32px;\n\t\t\tz-index: -1;\n\t\t\t@include shadow; } }\n\t&__container > &__title {\n\t\tmargin-bottom: 16px;\n\t\t@include m {\n\t\t\tmargin: 0; } }\n\t&__list {\n\t\tmargin: 0 -16px;\n\t\t@include m {\n\t\t\tmargin: 0; } }\n\t&__item {\n\t\tdisplay: flex;\n\t\tpadding: 32px 16px;\n\t\tborder-radius: 12px;\n\t\tbackground: transparent;\n\t\tcolor: $gray-dark;\n\t\tcursor: pointer;\n\t\ttransition: all .25s;\n\t\t-webkit-tap-highlight-color: rgba(0,0,0,0);\n\t\t@include m {\n\t\t\tpadding: 24px 0;\n\t\t\tborder-radius: 0;\n\t\t\tborder-bottom: 1px solid $border; } }\n\t&__ava {\n\t\tflex-shrink: 0;\n\t\twidth: 48px;\n\t\theight: 48px;\n\t\tfont-size: 0; }\n\t&__ava &__pic {\n\t\twidth: 100%;\n\t\tmin-height: 100%;\n\t\tborder-radius: 50%; }\n\t&__details {\n\t\tflex: 0 0 calc(100% - 48px);\n\t\twidth: calc(100% - 48px);\n\t\tpadding-left: 24px;\n\t\t@include x {\n\t\t\tpadding-left: 16px; } }\n\t&__head {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\talign-items: center;\n\t\tmargin-bottom: 16px;\n\t\t@include m {\n\t\t\theight: 48px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center; } }\n\t&__author {\n\t\tcolor: $link;\n\t\ttransition: color .25s; }\n\t&__time {\n\t\tmargin-left: 10px; }\n\t&__item &__title {\n\t\tmargin-bottom: 18px;\n\t\tcolor: $text;\n\t\ttransition: color .25s;\n\t\t@include m {\n\t\t\tmargin-left: -64px; } }\n\t&__text {\n\t\tmargin-bottom: 16px;\n\t\t@include m {\n\t\t\tmargin-left: -64px; }\n\t\tp {\n\t\t\t@include nl {\n\t\t\t\tmargin-bottom: 20px; } } }\n\t&__item:hover {\n\t\tbackground: rgba($border, .3);\n\t\t@include m {\n\t\t\tbackground: none; } }\n\t&__item.active {\n\t\tbackground: $purple;\n\t\tcolor: $wh;\n\t\t@include m {\n\t\t\tbackground: none;\n\t\t\tcolor: $gray-dark; }\n\t\t.actions__btn {\n\t\t\tborder-color: $wh;\n\t\t\t@include m {\n\t\t\t\tborder-color: $border; }\n\t\t\t.icon {\n\t\t\t\tfill: $wh;\n\t\t\t\t@include m {\n\t\t\t\t\tfill: $bl; } } }\n\t\t.inbox__title,\n\t\t.inbox__author {\n\t\t\tcolor: $wh; }\n\t\t.inbox__title {\n\t\t\t@include m {\n\t\t\t\tcolor: $text; } }\n\t\t.inbox__author {\n\t\t\t@include m {\n\t\t\t\tcolor: $gray-dark; } } }\n\t.actions {\n\t\t@include m {\n\t\t\tmargin-left: -64px; } }\n\t&__foot {\n\t\tpadding-top: 12px;\n\t\ttext-align: center;\n\t\t@include m {\n\t\t\tpadding-top: 24px; } }\n\t&__foot &__btn {\n\t\tmin-width: 180px; }\n\t&__control {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 60px;\n\t\t@include x {\n\t\t\tmargin-bottom: 32px; }\n\t\t@include d {\n\t\t\tdisplay: block; } }\n\t&__btns {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tmargin-right: auto;\n\t\t@include d {\n\t\t\tmargin: 0 -8px; } }\n\t&__btns &__btn {\n\t\tmin-width: 140px;\n\t\t@include x {\n\t\t\tmin-width: 120px;\n\t\t\theight: 48px; }\n\t\t@include d {\n\t\t\tflex: 0 0 calc(50% - 16px);\n\t\t\tmin-width: calc(50% - 16px);\n\t\t\tmargin: 0 8px; }\n\t\t@include nl {\n\t\t\tmargin-right: 16px;\n\t\t\t@include d {\n\t\t\t\tmargin-right: 8px; } } }\n\t&__more {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t\twidth: 48px;\n\t\theight: 48px;\n\t\tborder-radius: 50%;\n\t\tfont-size: 0;\n\t\ttransition: box-shadow .25s;\n\t\t@include d {\n\t\t\tdisplay: none; }\n\t\t.icon {\n\t\t\tfont-size: 6px;\n\t\t\tfill: $text; }\n\t\t&:hover {\n\t\t\tbox-shadow: 0 5px 20px rgba(#E3E6EC, .85); } }\n\t&__box {\n\t\tdisplay: flex;\n\t\t@include nl {\n\t\t\tmargin-bottom: 40px;\n\t\t\tpadding-bottom: 40px;\n\t\t\tborder-bottom: 1px solid $border;\n\t\t\t@include d {\n\t\t\t\tmargin-bottom: 32px;\n\t\t\t\tpadding: 0;\n\t\t\t\tborder: none; }\n\t\t\t@include m {\n\t\t\t margin-bottom: 24px; } } }\n\t&__box &__author {\n\t\tcolor: $text; }\n\t&__box &__time {\n\t\tmargin-left: 24px;\n\t\tcolor: $gray-light; }\n\t&__box &__title {\n\t\tmargin-bottom: 32px;\n\t\t@include d {\n\t\t\tfont-size: 18px; }\n\t\t@include m {\n\t\t\tmargin: 0 0 24px -64px; } }\n\t&__box &__text {\n\t\tcolor: $gray-dark; }\n\t.files {\n\t\tmargin-top: 24px;\n\t\t@include m {\n\t\t\tmargin: 16px 0 0 -64px; } }\n\t.sorting {\n\t\tmargin-bottom: 24px;\n\t\t@include m {\n\t\t\tpadding: 0; } } }\n\n@include dark {\n\t.inbox {\n\t\t&__tag {\n\t\t\tcolor: $wh; }\n\t\t&__container {\n\t\t\tbackground: $dark;\n\t\t\t&:before {\n\t\t\t\t@include shadow-dark; } }\n\t\t&__item {\n\t\t\t@include m {\n\t\t\t\tborder-color: $border-dark; } }\n\t\t&__item:hover {\n\t\t\tbackground: rgba($border-dark, .04);\n\t\t\t@include m {\n\t\t\t\tbackground: none; } }\n\t\t&__item.active {\n\t\t\tbackground: $purple;\n\t\t\t@include m {\n\t\t\t\tbackground: none; } }\n\t\t&__title {\n\t\t\tcolor: $wh; }\n\t\t&__author {\n\t\t\t@include m {\n\t\t\t\tcolor: $wh; } }\n\t\t&__item.active .inbox__title {\n\t\t\tcolor: $wh; }\n\t\t&__item.active .inbox__author {\n\t\t\tcolor: $wh; }\n\t\t&__item.active .actions__btn {\n\t\t\t@include m {\n\t\t\t\tborder-color: $border-dark;\n\t\t\t\t.icon {\n\t\t\t\t\tfill: $wh; } } }\n\t\t&__more {\n\t\t\t.icon {\n\t\t\t\tfill: $wh; }\n\t\t\t&:hover {\n\t\t\t\tbox-shadow: 0 12px 20px rgba(#000, .35); } }\n\t\t&__box {\n\t\t\tborder-color: $border-dark; }\n\t\t&__box .inbox__author {\n\t\t\tcolor: $wh; } } }\n",".actions {\n\tdisplay: flex;\n\t&__btn {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t\twidth: 32px;\n\t\theight: 32px;\n\t\tborder-radius: 50%;\n\t\tborder: 1px solid $border;\n\t\tfont-size: 0;\n\t\ttransition: all .25s;\n\t\t.icon {\n\t\t\tfont-size: 12px;\n\t\t\tfill: $bl;\n\t\t\topacity: .4;\n\t\t\ttransition: all .25s; }\n\t\t&:hover .icon {\n\t\t\topacity: .75; }\n\t\t@include nl {\n\t\t\tmargin-right: 16px; } } }\n\n@include dark {\n\t.actions {\n\t\t&__btn {\n\t\t\tborder-color: $border-dark;\n\t\t\t.icon {\n\t\t\t\tfill: $wh; } } } }\n",".files {\n\t&__list {\n\t\tdisplay: flex;\n\t\tmargin: -8px -4px 0;\n\t\t@include x {\n\t\t\tdisplay: block;\n\t\t\tmargin: 0; } }\n\t&__item {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: 4px;\n\t\tborder-radius: 16px;\n\t\tcolor: $text;\n\t\ttransition: opacity .25s;\n\t\t&.purple {\n\t\t\tbackground: rgba($purple-light, .5);\n\t\t\t.files__preview {\n\t\t\t\tbackground: $purple-light; } }\n\t\t&.blue {\n\t\t\tbackground: #E7FAFF;\n\t\t\t.files__preview {\n\t\t\t\tbackground: $blue-light; } }\n\t\t&:hover {\n\t\t\topacity: .8; } }\n\t& > &__item {\n\t\t@include nl {\n\t\t\tmargin-bottom: 10px; } }\n\t&__list &__item {\n\t\tflex: 0 0 calc(50% - 8px);\n\t\twidth: calc(50% - 8px);\n\t\tmargin: 4px 4px 0;\n\t\t@include x {\n\t\t\twidth: 100%;\n\t\t\tmargin: 0; }\n\t\t@include nl {\n\t\t\t@include x {\n\t\t\t\tmargin-bottom: 16px; } } }\n\t&__preview {\n\t\tflex-shrink: 0;\n\t\twidth: 48px;\n\t\theight: 48px;\n\t\tborder-radius: 12px;\n\t\toverflow: hidden;\n\t\tfont-size: 0; }\n\t&__pic {\n\t\tmax-width: 100%;\n\t\tmax-height: 100%; }\n\t&__details {\n\t\tflex: 0 0 calc(100% - 48px);\n\t\twidth: calc(100% - 48px);\n\t\tpadding-left: 16px; }\n\t&__title {\n\t\tmax-width: 100%;\n\t\t@include text-overflow;\n\t\tcolor: $link; } }\n\n@include dark {\n\t.files {\n\t\t&__item {\n\t\t\tbackground: $border-dark;\n\t\t\tcolor: $wh; }\n\t\t&__title {\n\t\t\tcolor: $wh; } } }\n",".editor {\n\t&__wrap {\n\t\tbackground: #fafafa;\n\t\tborder-radius: 12px; }\n\t&__head {\n\t\tdisplay: flex;\n\t\tpadding: 24px;\n\t\tborder-bottom: 1px solid $border;\n\t\t@include m {\n\t\t\tpadding: 24px 16px; } }\n\t&__control {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tmargin: -16px auto 0 -16px; }\n\t&__action {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tmargin: 16px 0 0 16px;\n\t\tborder-radius: 4px;\n\t\tbackground: $border;\n\t\tfont-size: 0;\n\t\ttransition: all .25s;\n\t\t.icon {\n\t\t\tfont-size: 12px;\n\t\t\tfill: $gray-dark;\n\t\t\ttransition: fill .25s; }\n\t\t&:hover,\n\t\t&.active {\n\t\t\tbackground: rgba($bl, .3);\n\t\t\t.icon {\n\t\t\t\tfill: $wh; } } }\n\t&__add {\n\t\tposition: relative;\n\t\tflex-shrink: 0;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tmargin-left: 30px;\n\t\tborder-radius: 50%;\n\t\tbackground: $bl;\n\t\ttransition: all .25s;\n\t\t&:before,\n\t\t&:after {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\ttransform: translate(-50%,-50%);\n\t\t\tbackground: $wh; }\n\t\t&:before {\n\t\t\twidth: 8px;\n\t\t\theight: 2px; }\n\t\t&:after {\n\t\t\twidth: 2px;\n\t\t\theight: 8px; }\n\t\t&:hover {\n\t\t\tbackground: rgba($bl, .8); } }\n\t&__body {\n\t\tpadding: 32px 24px;\n\t\t@include m {\n\t\t\tpadding: 24px 16px; } }\n\t&__textarea {\n\t\twidth: 100%;\n\t\theight: 110px;\n\t\tborder: none;\n\t\tbackground: none;\n\t\tresize: none;\n\t\tfont-size: 14px; }\n\t&__gallery {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tmax-width: 360px;\n\t\tmargin: -16px 0 0 -8px; }\n\t&__preview {\n\t\tposition: relative;\n\t\tflex: 0 0 calc(50% - 16px);\n\t\twidth: calc(50% - 16px);\n\t\tmargin: 16px 8px 0;\n\t\tfont-size: 0;\n\t\tcursor: pointer; }\n\t&__pic {\n\t\tborder-radius: 8px; }\n\t&__close {\n\t\tposition: absolute;\n\t\ttop: 8px;\n\t\tright: 8px;\n\t\tz-index: 2;\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tborder-radius: 50%;\n\t\tbackground: $wh;\n\t\tfont-size: 0;\n\t\tvisibility: hidden;\n\t\topacity: 0;\n\t\ttransition: all .25s;\n\t\t@include t {\n\t\t\ttop: 5px;\n\t\t\tright: 5px;\n\t\t\tvisibility: visible;\n\t\t\topacity: 1; }\n\t\t.icon {\n\t\t\tfont-size: 6px;\n\t\t\tfill: $bl;\n\t\t\ttransition: transform .25s; }\n\t\t&:hover .icon {\n\t\t\ttransform: rotate(90deg); } }\n\t&__preview:hover &__close {\n\t\tvisibility: visible;\n\t\topacity: 1; }\n\t&__btn {\n\t\tmin-width: 232px;\n\t\tmargin-top: 24px;\n\t\t@include m {\n\t\t\tmin-width: 100%;\n\t\t\tmargin-top: 16px; }\n\t\t&.btn_wide {\n\t\t\tmin-width: 100%; } }\n\t.files {\n\t\twidth: 100%;\n\t\tmargin-top: 24px; } }\n\n@include dark {\n\t.editor {\n\t\t&__wrap {\n\t\t\tbackground: rgba($border-dark, .03); }\n\t\t&__head {\n\t\t\tborder-color: $border-dark; }\n\t\t&__action {\n\t\t\tbackground: $border-dark;\n\t\t\t&.active {\n\t\t\t\tbackground: $bl; } }\n\t\t&__textarea {\n\t\t\tcolor: $wh; }\n\t\t&__close {\n\t\t\tbackground: $dark;\n\t\t\t.icon {\n\t\t\t\tfill: $wh; } } } }\n",".notification {\n\t&__tags {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tmargin: -18px 0 28px -18px;\n\t\t@include m {\n\t\t\tmargin: -10px 0 24px -10px; } }\n\t&__tag {\n\t\tmargin: 18px 0 0 18px;\n\t\tborder: 2px solid $border;\n\t\tborder-radius: 12px;\n\t\tpadding: 6px 16px;\n\t\tline-height: (20/14);\n\t\tfont-weight: 600;\n\t\tcolor: $text;\n\t\ttransition: all .25s;\n\t\t@include m {\n\t\t\tmargin: 10px 0 0 10px; }\n\t\t&:hover,\n\t\t&.active {\n\t\t\tbackground: $purple;\n\t\t\tborder-color: $purple;\n\t\t\tcolor: $wh; } }\n\t&__container {\n\t\tposition: relative;\n\t\tpadding: 32px;\n\t\tborder-radius: 24px;\n\t\tbackground: $wh;\n\t\t@include m {\n\t\t\tpadding: 32px 24px; }\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 32px;\n\t\t\tleft: 32px;\n\t\t\tright: 32px;\n\t\t\tbottom: -32px;\n\t\t\tz-index: -1;\n\t\t\t@include shadow; } }\n\t&__title {\n\t\tmargin-bottom: 32px;\n\t\t@include m {\n\t\t\tmargin-bottom: 16px; } }\n\t&__list {\n\t\tmargin: 0 -16px;\n\t\t@include m {\n\t\t\tmargin: 0; } }\n\t&__item {\n\t\tdisplay: flex;\n\t\tpadding: 32px 16px;\n\t\tborder-radius: 12px;\n\t\tbackground: transparent;\n\t\tcolor: $gray-dark;\n\t\tcursor: pointer;\n\t\ttransition: all .25s;\n\t\t-webkit-tap-highlight-color: rgba(0,0,0,0);\n\t\t@include m {\n\t\t\tpadding: 24px 0;\n\t\t\tborder-radius: 0;\n\t\t\tborder-bottom: 1px solid $border; } }\n\t&__ava {\n\t\tposition: relative;\n\t\tflex-shrink: 0;\n\t\twidth: 48px;\n\t\theight: 48px;\n\t\tfont-size: 0; }\n\t&__ava > &__pic {\n\t\twidth: 100%;\n\t\tmin-height: 100%;\n\t\tborder-radius: 50%; }\n\t&__status {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tborder-radius: 50%;\n\t\tborder: 2px solid $wh;\n\t\tfont-size: 0; }\n\t&__details {\n\t\tflex-grow: 1;\n\t\tpadding: 0 24px;\n\t\t@include x {\n\t\t\tpadding-right: 0; }\n\t\t@include d {\n\t\t\tpadding: 0 24px; }\n\t\t@include m {\n\t\t\tpadding: 0 0 0 16px; } }\n\t&__author {\n\t\tmargin-bottom: 9px;\n\t\tcolor: $text;\n\t\ttransition: color .25s; }\n\t&__line {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tmargin-bottom: 16px; }\n\t&__line &__category {\n\t\tmargin-right: 8px; }\n\t&__info {\n\t\tmargin-right: 8px;\n\t\tcolor: $link; }\n\t.actions {\n\t\t@include m {\n\t\t\tmargin-left: -64px; } }\n\t&__item &__text {\n\t\tmargin-bottom: 16px;\n\t\tp {\n\t\t\t@include nl {\n\t\t\t\tmargin-bottom: 20px; } } }\n\t&__item:hover {\n\t\tbackground: rgba($border, .3);\n\t\t@include m {\n\t\t\tbackground: none; } }\n\t&__item.active {\n\t\tbackground: $purple;\n\t\tcolor: $wh;\n\t\t@include m {\n\t\t\tbackground: none;\n\t\t\tcolor: $gray-dark; }\n\t\t.actions__btn {\n\t\t\tborder-color: $wh;\n\t\t\t@include m {\n\t\t\t\tborder-color: $border; }\n\t\t\t.icon {\n\t\t\t\tfill: $wh;\n\t\t\t\t@include m {\n\t\t\t\t\tfill: $bl; } } }\n\t\t.notification__title,\n\t\t.notification__author,\n\t\t.notification__info {\n\t\t\tcolor: $wh; }\n\t\t.notification__title {\n\t\t\t@include m {\n\t\t\t\tcolor: $text; } }\n\t\t.notification__author {\n\t\t\t@include m {\n\t\t\t\tcolor: $link; } }\n\t\t.notification__info {\n\t\t\t@include m {\n\t\t\t\tcolor: $gray-dark; } } }\n\t&__preview {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t\twidth: 96px;\n\t\theight: 96px;\n\t\tborder-radius: 8px;\n\t\tfont-size: 0;\n\t\t@include x {\n\t\t\tdisplay: none; }\n\t\t@include d {\n\t\t\tdisplay: block; }\n\t\t@include m {\n\t\t\tdisplay: none; }\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 100%;\n\t\t\tleft: 7px;\n\t\t\tright: 7px;\n\t\t\theight: 7px;\n\t\t\tborder-radius: 0 0 7px 7px; }\n\t\t&.bg-purple-light:before {\n\t\t\tbackground: rgba($purple-light, .5); }\n\t\t&.bg-blue-light:before {\n\t\t\tbackground: rgba($blue-light, .5); }\n\t\t&.bg-yellow:before {\n\t\t\tbackground: rgba($yellow, .5); } }\n\t&__preview &__pic {\n\t\tmax-height: 100%; }\n\t&__btns {\n\t\tpadding-top: 24px;\n\t\ttext-align: center; }\n\t&__btn {\n\t\tmin-width: 180px; }\n\t&__photo {\n\t\tmargin-bottom: 40px;\n\t\tfont-size: 0; }\n\t&__photo &__pic {\n\t\twidth: 100%; }\n\t&__body {\n\t\tpadding: 0 24px;\n\t\t@include nl {\n\t\t\tmargin-bottom: 32px; } }\n\t&__stage {\n\t\tmargin-bottom: 16px; }\n\t&__parameters {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 24px; }\n\t&__parameter {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tcolor: $link;\n\t\t@include nl {\n\t\t\tmargin-right: 16px; } }\n\t&__icon {\n\t\tmargin-right: 10px;\n\t\tfont-size: 0; } }\n\n@include dark {\n\t.notification {\n\t\t&__container {\n\t\t\tbackground: $dark;\n\t\t\t&:before {\n\t\t\t\t@include shadow-dark; } }\n\t\t&__tag {\n\t\t\tborder-color: $border-dark;\n\t\t\tcolor: $wh;\n\t\t\t&:hover {\n\t\t\t\tborder-color: $purple; } }\n\t\t&__item {\n\t\t\t@include m {\n\t\t\t\tborder-color: $border-dark; } }\n\t\t&__item:hover {\n\t\t\tbackground: rgba($border-dark, .04);\n\t\t\t@include m {\n\t\t\t\tbackground: none; } }\n\t\t&__item.active {\n\t\t\tbackground: $purple;\n\t\t\t@include m {\n\t\t\t\tbackground: none; } }\n\t\t&__item.active .actions__btn {\n\t\t\t@include m {\n\t\t\t\tborder-color: $border-dark;\n\t\t\t\t.icon {\n\t\t\t\t\tfill: $wh; } } }\n\t\t&__item.active .notification__author {\n\t\t\tcolor: $wh; }\n\t\t&__item.active .notification__info {\n\t\t\tcolor: $link; }\n\t\t&__author {\n\t\t\tcolor: $wh; } } }\n",".filters {\n\t&__container {\n\t\tposition: relative;\n\t\tpadding: 32px;\n\t\tbackground: $wh;\n\t\tborder-radius: 24px;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 32px;\n\t\t\tleft: 17px;\n\t\t\tright: 17px;\n\t\t\tbottom: -32px;\n\t\t\tz-index: -1;\n\t\t\t@include shadow; } }\n\t&__item {\n\t\t@include nl {\n\t\t\tmargin-bottom: 32px;\n\t\t\tpadding-bottom: 32px;\n\t\t\tborder-bottom: 1px solid $border; } }\n\t&__title {\n\t\tmargin-bottom: 24px; }\n\t&__variants {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tmargin-bottom: 32px; }\n\t.checkbox {\n\t\t@include nl {\n\t\t\tmargin-bottom: 20px; } }\n\t&__control {\n\t\tdisplay: flex;\n\t\talign-items: center; }\n\t&__btns {\n\t\tdisplay: flex;\n\t\tmargin: 0 -5px; }\n\t&__btn {\n\t\tflex: 0 0 calc(50% - 10px);\n\t\tmin-width: calc(50% - 10px);\n\t\theight: 44px;\n\t\tmargin: 0 5px;\n\t\tpadding: 0;\n\t\tfont-size: 14px; }\n\t&__line {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 32px; }\n\t.radio {\n\t\t@include nl {\n\t\t\tmargin-right: 32px; } }\n\t&__reset {\n\t\tline-height: (20/14);\n\t\tfont-weight: 600;\n\t\tcolor: $gray-dark;\n\t\ttransition: color .25s;\n\t\t&:hover {\n\t\t\tcolor: $purple; } } }\n\n@include dark {\n\t.filters {\n\t\t&__container {\n\t\t\tbackground: $dark;\n\t\t\t&:before {\n\t\t\t\t@include shadow-dark; } }\n\t\t&__item {\n\t\t\tborder-color: $border-dark; } } }\n\n",".activity {\n\t&__row {\n\t\tdisplay: flex;\n\t\t@include d {\n\t\t\tdisplay: block; } }\n\t&__col {\n\t\t&:first-child {\n\t\t\tflex-grow: 1;\n\t\t\t@include d {\n\t\t\t\tmargin-bottom: 32px; } }\n\t\t&:nth-child(2) {\n\t\t\tflex-shrink: 0;\n\t\t\twidth: 426px;\n\t\t\tpadding: 32px 0 0 65px;\n\t\t\t@include x {\n\t\t\t\twidth: 370px;\n\t\t\t\tpadding-left: 32px; }\n\t\t\t@include d {\n\t\t\t\twidth: 100%;\n\t\t\t\tpadding: 0; }\n\t\t\t@include m {\n\t\t\t\tpadding: 0 16px; } } }\n\t&__container {\n\t\tposition: relative;\n\t\tpadding: 32px;\n\t\tbackground: $wh;\n\t\tborder-radius: 24px;\n\t\t@include m {\n\t\t\tpadding: 32px 24px; }\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 26px;\n\t\t\tleft: 19px;\n\t\t\tright: 19px;\n\t\t\tbottom: -26px;\n\t\t\tz-index: -1;\n\t\t\t@include shadow; } }\n\t&__title {\n\t\tmargin-bottom: 32px;\n\t\t@include m {\n\t\t\tmargin-bottom: 16px; } }\n\t&__inner {\n\t\tdisplay: flex;\n\t\t@include x {\n\t\t\tdisplay: block; } }\n\t&__variants {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tflex-shrink: 0;\n\t\twidth: 130px;\n\t\tpadding-right: 15px;\n\t\t@include x {\n\t\t\tdisplay: none; }\n\t\t.checkbox {\n\t\t\t@include nl {\n\t\t\t\tmargin-bottom: 16px; } } }\n\t&__list {\n\t\tmargin-right: -16px;\n\t\t@include m {\n\t\t\tmargin: 0; } }\n\t&__item {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tpadding: 32px 16px;\n\t\toverflow: hidden;\n\t\tborder-radius: 12px;\n\t\tcolor: $gray-dark;\n\t\tcursor: pointer;\n\t\ttransition: all .25s;\n\t\t-webkit-tap-highlight-color: rgba(0,0,0,0);\n\t\t@include m {\n\t\t\tpadding: 24px 0;\n\t\t\tborder-radius: 0;\n\t\t\tborder-bottom: 1px solid $border; }\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\t@include coverdiv;\n\t\t\tbackground: transparent;\n\t\t\ttransition: background .25s;\n\t\t\t@include m {\n\t\t\t\tdisplay: none; } }\n\t\t&:hover {\n\t\t\tbackground: rgba($border, .3); }\n\t\t&.active {\n\t\t\tcolor: $wh;\n\t\t\t@include m {\n\t\t\t\tcolor: $gray-dark; }\n\t\t\t&:before {\n\t\t\t\tbackground: $purple; } } }\n\t&__ava {\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\tflex-shrink: 0;\n\t\twidth: 48px;\n\t\theight: 48px;\n\t\tfont-size: 0; }\n\t&__ava > &__pic {\n\t\twidth: 100%;\n\t\tmin-height: 100%;\n\t\tborder-radius: 50%; }\n\t&__status {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tborder-radius: 50%;\n\t\tbackground: #FF9A7B;\n\t\tborder: 2px solid $wh;\n\t\tfont-size: 0; }\n\t&__details {\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\tflex-grow: 1;\n\t\tpadding: 0 32px 0 24px;\n\t\t@include x {\n\t\t\tpadding-right: 0; }\n\t\t@include d {\n\t\t\tpadding: 0 24px; }\n\t\t@include m {\n\t\t\tpadding: 0 0 0 16px; } }\n\t&__author {\n\t\tmargin-bottom: 9px;\n\t\tcolor: $text;\n\t\ttransition: color .25s; }\n\t&__details &__line {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tmargin-bottom: 16px; }\n\t&__line &__category {\n\t\tmargin-right: 8px; }\n\t&__info {\n\t\tmargin-right: 8px;\n\t\tcolor: $link;\n\t\ttransition: color .25s; }\n\t&__item &__text {\n\t\tp {\n\t\t\t@include nl {\n\t\t\t\tmargin-bottom: 20px; } } }\n\t&__item.active {\n\t\t.activity__author,\n\t\t.activity__info {\n\t\t\tcolor: $wh; }\n\t\t.activity__author {\n\t\t\t@include m {\n\t\t\t\tcolor: $text; } }\n\t\t.activity__info {\n\t\t\t@include m {\n\t\t\t\tcolor: $link; } } }\n\t&__preview {\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t\twidth: 96px;\n\t\theight: 84px;\n\t\tbackground: $blue-light;\n\t\tborder-radius: 8px;\n\t\tfont-size: 0;\n\t\t@include x {\n\t\t\tdisplay: none; }\n\t\t@include d {\n\t\t\tdisplay: block; }\n\t\t@include m {\n\t\t\tdisplay: none; }\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 100%;\n\t\t\tleft: 7px;\n\t\t\tright: 7px;\n\t\t\theight: 7px;\n\t\t\tborder-radius: 0 0 7px 7px;\n\t\t\tbackground: #E7FAFF; } }\n\t&__preview &__pic {\n\t\tmax-height: 100%; }\n\t&__btns {\n\t\tpadding-top: 24px;\n\t\ttext-align: center; }\n\t&__btn {\n\t\tmin-width: 180px; }\n\t@include nf {\n\t\tmargin-top: 48px;\n\t\t@include m {\n\t\t\tmargin-top: 32px; } } }\n\n@include dark {\n\t.activity {\n\t\t&__container {\n\t\t\tbackground: $dark;\n\t\t\t&:before {\n\t\t\t\t@include shadow-dark; } }\n\t\t&__author {\n\t\t\tcolor: $wh; }\n\t\t&__item {\n\t\t\t@include m {\n\t\t\t\tborder-color: $border-dark; } }\n\t\t&__item:hover {\n\t\t\tbackground: rgba($border-dark, .04);\n\t\t\t@include m {\n\t\t\t\tbackground: none; } }\n\t\t&__item.active .activity__author {\n\t\t\tcolor: $wh; } } }\n\n\n",".field {\n\t&__label {\n\t\tmargin-bottom: 16px;\n\t\tfont-size: 12px;\n\t\tline-height: (16/12);\n\t\tfont-weight: 500;\n\t\tcolor: $gray-light; }\n\t&__input,\n\t&__textarea {\n\t\twidth: 100%;\n\t\tborder-radius: 8px;\n\t\tbackground: rgba($border, .3);\n\t\tborder: 2px solid transparent;\n\t\t@include fi;\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t\tcolor: $text;\n\t\ttransition: all .25s;\n\t\t&:focus {\n\t\t\tborder-color: $purple;\n\t\t\tbackground: $wh; } }\n\t&__input {\n\t\theight: 56px;\n\t\tpadding: 0 23px; }\n\t&__textarea {\n\t\theight: 157px;\n\t\tpadding: 15px 23px;\n\t\tresize: none; } }\n\n@include dark {\n\t.field {\n\t\t&__input,\n\t\t&__textarea {\n\t\t\tcolor: $wh;\n\t\t\tbackground: rgba($border-dark, .04); } } }\n",".popup {\n\tposition: relative;\n\tmax-width: 630px;\n\tmargin: 15px auto;\n\tbackground: $wh;\n\tborder-radius: 24px;\n\t&__form {\n\t\tpadding: 32px;\n\t\tborder-radius: 24px; }\n\t&__title {\n\t\tmargin-bottom: 48px;\n\t\t@include m {\n\t\t\tmargin-bottom: 42px; } }\n\t&__tags {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tmargin: -13px 0 32px -13px;\n\t\t@include m {\n\t\t\tdisplay: none; } }\n\t&__tag {\n\t\tmargin: 13px 0 0 13px;\n\t\tborder: 2px solid $red;\n\t\tborder-radius: 12px;\n\t\tpadding: 6px 16px;\n\t\tline-height: (20/14);\n\t\tfont-weight: 600;\n\t\tcolor: $text;\n\t\ttransition: all .25s;\n\t\t&:hover,\n\t\t&.active {\n\t\t\tbackground: $purple;\n\t\t\tborder-color: $purple;\n\t\t\tcolor: $wh; } }\n\t&__select {\n\t\tmin-width: 100%;\n\t\theight: 56px;\n\t\tmargin-bottom: 32px;\n\t\tpadding: 0 40px 0 24px;\n\t\t-webkit-appearance: none;\n\t\t-moz-appearance: none;\n\t\tappearance: none;\n\t\tborder: none;\n\t\tborder-radius: 12px;\n\t\tbackground: rgba(#E4E4E4, .25) url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='7' fill='none'%3E%3Cpath fill-rule='evenodd' d='M9.293.333a.5.5 0 0 1 .39.812L5.39 6.512a.5.5 0 0 1-.781 0L.317 1.146a.5.5 0 0 1 .39-.812h8.586z' fill='%23b5b5be'/%3E%3C/svg%3E\") no-repeat calc(100% - 16px) 50% / 11px 7px;\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t\tcolor: $gray-dark;\n\t\ttransition: all .25s;\n\t\t&::-ms-expand {\n\t\t\tdisplay: none; }\n\t\t&:-moz-focusring {\n\t\t\tcolor: transparent;\n\t\t\ttext-shadow: 0 0 0 #000; } }\n\t&__user {\n\t\t@include nl {\n\t\t\tmargin-bottom: 32px;\n\t\t\tpadding-bottom: 32px;\n\t\t\tborder-bottom: 1px solid $border;\n\t\t\t@include m {\n\t\t\t\tpadding-bottom: 24px; } } }\n\t&__category {\n\t\tmargin-bottom: 32px;\n\t\tcolor: $gray-light; }\n\t&__line {\n\t\tdisplay: flex; }\n\t&__ava {\n\t\tflex-shrink: 0;\n\t\twidth: 64px;\n\t\theight: 64px;\n\t\tfont-size: 0;\n\t\t@include m {\n\t\t\twidth: 80px;\n\t\t\theight: 80px; } }\n\t&__ava &__pic {\n\t\twidth: 100%;\n\t\tmin-height: 100%;\n\t\tborder-radius: 50%;\n\t\timage-orientation: from-image; }\n\t&__details {\n\t\tflex: 0 0 calc(100% - 64px);\n\t\twidth: calc(100% - 64px);\n\t\tpadding-left: 40px;\n\t\t@include m {\n\t\t\tflex: 0 0 calc(100% - 80px);\n\t\t\twidth: calc(100% - 80px);\n\t\t\tpadding-left: 24px; } }\n\t&__btns {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 16px;\n\t\t@include m {\n\t\t\tdisplay: block;\n\t\t\tmargin: 0 0 32px; } }\n\t&__btns &__btn {\n\t\tmin-width: 166px;\n\t\theight: 40px;\n\t\t@include m {\n\t\t\tmin-width: 100%; }\n\t\t&.btn_gray {\n\t\t\t@include m {\n\t\t\t\tbackground: $wh; } } }\n\t&__btns &__btn,\n\t&__loading {\n\t\t@include nl {\n\t\t\tmargin-right: 16px;\n\t\t\t@include m {\n\t\t\t\tmargin: 0; } } }\n\t&__loading {\n\t\tposition: relative;\n\t\toverflow: hidden;\n\t\tborder-radius: 16px; }\n\t&__file {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tfont-size: 140px;\n\t\topacity: 0; }\n\t&__loading:hover &__btn {\n\t\tbackground: darken($purple, 5); }\n\t&__text {\n\t\tcolor: $gray-light;\n\t\t@include m {\n\t\t\tmargin-left: -104px; } }\n\t&__fieldset {\n\t\tmargin-bottom: 24px; }\n\t&__fieldset > &__field {\n\t\t@include nl {\n\t\t\tmargin-bottom: 20px; } }\n\t&__row {\n\t\tdisplay: flex;\n\t\tmargin: 0 -8px;\n\t\t@include m {\n\t\t\tdisplay: block;\n\t\t\tmargin: 0; }\n\t\t@include nl {\n\t\t\tmargin-bottom: 20px; } }\n\t&__row &__field {\n\t\tflex: 0 0 calc(50% - 16px);\n\t\twidth: calc(50% - 16px);\n\t\tmargin: 0 8px;\n\t\t@include m {\n\t\t\twidth: 100%;\n\t\t\tmargin: 0; }\n\t\t@include nl {\n\t\t\t@include m {\n\t\t\t\tmargin-bottom: 24px; } } }\n\t&__form > &__btn {\n\t\t@include m {\n\t\t\tmin-width: 100%; } }\n\t.mfp-close {\n\t\tposition: absolute;\n\t\ttop: 20px;\n\t\tright: 32px;\n\t\twidth: 48px;\n\t\theight: 48px;\n\t\tborder-radius: 50%;\n\t\tline-height: normal;\n\t\topacity: 1;\n\t\tfont-size: 0;\n\t\tbackground: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'%3E%3Cpath fill='%2311142d' d='M1.613.2l.094.083L5 3.585 8.293.293a1 1 0 0 1 1.414 0 1 1 0 0 1 .083 1.32l-.083.094L6.415 5l3.292 3.293a1 1 0 0 1-1.32 1.497l-.094-.083L5 6.415 1.707 9.707A1 1 0 0 1 .21 8.387l.083-.094L3.585 5 .293 1.707a1 1 0 0 1 0-1.414A1 1 0 0 1 1.613.21z'/%3E%3C/svg%3E\") no-repeat 50% 50% / 10px auto;\n\t\ttransition: box-shadow .25s;\n\t\t-webkit-tap-highlight-color: rgba(0,0,0,0);\n\t\t@include m {\n\t\t\tright: 20px;\n\t\t\tbox-shadow: 0 5px 20px rgba(#E3E6EC, .85); }\n\t\t&:hover {\n\t\t\tbox-shadow: 0 5px 20px rgba(#E3E6EC, .85); } } }\n\n.mfp-container {\n\tpadding: 20px;\n\t@include m {\n\t\tpadding: 0; } }\n\n@media (max-width: 900px) {\n\t.mfp-container {\n\t\tpadding: 30px 20px; } }\n\n.mfp-bg {\n\tbackground: rgba($bl, .7); }\n\n.mfp-zoom-in {\n  .popup {\n    opacity: 0;\n    transition: all 0.2s ease-in-out;\n    transform: scale(0.8); }\n  &.mfp-bg {\n    opacity: 0;\n    transition: all 0.2s ease-out; }\n  &.mfp-ready {\n    .popup {\n      opacity: 1;\n      transform: scale(1); }\n    &.mfp-bg {\n      opacity: 0.8; } }\n  &.mfp-removing {\n    .popup {\n      transform: scale(0.8);\n      opacity: 0; }\n    &.mfp-bg {\n      opacity: 0; } } }\n\n@include dark {\n\t.popup {\n\t\tbackground: $dark;\n\t\t&__tag {\n\t\t\tcolor: $wh; }\n\t\t&__user {\n\t\t\tborder-color: $border-dark; }\n\t\t.mfp-close {\n\t\t\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'%3E%3Cpath fill='%23ffffff' d='M1.613.2l.094.083L5 3.585 8.293.293a1 1 0 0 1 1.414 0 1 1 0 0 1 .083 1.32l-.083.094L6.415 5l3.292 3.293a1 1 0 0 1-1.32 1.497l-.094-.083L5 6.415 1.707 9.707A1 1 0 0 1 .21 8.387l.083-.094L3.585 5 .293 1.707a1 1 0 0 1 0-1.414A1 1 0 0 1 1.613.21z'/%3E%3C/svg%3E\");\n\t\t\t@include m {\n\t\t\t\tbox-shadow: 0 5px 20px rgba(#000, .35); }\n\t\t\t&:hover {\n\t\t\t\tbox-shadow: 0 5px 20px rgba(#000, .35); } }\n\t\t&__select {\n\t\t\tbackground-color: rgba($border-dark, .04); }\n\t\t&__btns .popup__btn.btn_gray {\n\t\t\tbackground: none; } }\n\n\t.mfp-bg {\n\t\tbackground: rgba($bl, .9); } }\n",".color {\n\t &-green {\n\t\t color: $green; }\n\t &-red {\n\t\t color: $red; }\n\t &-white {\n\t\t color: $wh; }\n\t &-blue {\n\t\t color: $blue; }\n\t &-blue-dark {\n\t\t color: $link; }\n\t // &-yellow\n\t\t//  color: $yellow\n\t &-purple {\n\t\t color: $purple; }\n\t &-gray {\n\t\t color: $gray-dark; }\n\t // &-turquoise\n }\t\t//  color: $turquoise\n\n.bg {\n\t&-blue {\n\t\tbackground: $blue;\n\t\t&-opacity {\n\t\t\tbackground: rgba($blue, .3); } }\n\t&-blue-light {\n\t\tbackground: $blue-light;\n\t\t&-opacity {\n\t\t\tbackground: rgba($blue-light, .3); } }\n\t&-yellow {\n\t\tbackground: $yellow;\n\t\t&-opacity {\n\t\t\tbackground: rgba($yellow, .3); } }\n\t&-yellow-light {\n\t\tbackground: $yellow-light; }\n\t&-pink {\n\t\tbackground: $pink;\n\t\t&-opacity {\n\t\t\tbackground: rgba($pink, .3); } }\n\t&-pink-light {\n\t\tbackground: $pink-light; }\n\t&-green {\n\t\tbackground: $green;\n\t\t&-opacity {\n\t\t\tbackground: rgba($green, .3); } }\n\t&-purple {\n\t\tbackground: $purple;\n\t\t&-opacity {\n\t\t\tbackground: rgba($purple, .3); } }\n\t&-purple-light {\n\t\tbackground: $purple-light; }\n\t&-red {\n\t\tbackground: $red;\n\t\t&-opacity {\n\t\t\tbackground: rgba($red, .3); } } }\n\n.text {\n\t&-right {\n\t\ttext-align: right; }\n\t&-center {\n\t\ttext-align: center; }\n\t&-uppercase {\n\t\ttext-transform: uppercase; } }\n\n.m-auto {\n\tmargin: auto; }\n.ml-auto {\n\tmargin-left: auto; }\n.mr-auto {\n\tmargin-right: auto; }\n\n.align {\n\t&-baseline {\n\t\talign-items: baseline; } }\n\n.desktop {\n\t&-hide {\n\t\t@include d {\n\t\t\tdisplay: none; } }\n\t&-show {\n\t\tdisplay: none;\n\t\t@include d {\n\t\t\tdisplay: block; } }\n\t&-text-right {\n\t\t@include d {\n\t\t\ttext-align: right; } } }\n\n.tablet {\n\t&-hide {\n\t\t@include t {\n\t\t\tdisplay: none; } }\n\t&-show {\n\t\tdisplay: none;\n\t\t@include t {\n\t\t\tdisplay: block; } }\n\t&-text-right {\n\t\t@include t {\n\t\t\ttext-align: right; } } }\n\n.mobile {\n\t&-hide {\n\t\t@include m {\n\t\t\tdisplay: none; } }\n\t&-show {\n\t\tdisplay: none;\n\t\t@include m {\n\t\t\tdisplay: block; } }\n\t&-text-right {\n\t\t@include m {\n\t\t\ttext-align: right; } } }\n\n.title {\n\tfont-size: 16px;\n\tline-height: (19/16);\n\tfont-weight: 600;\n\t&_lg,\n\t&_md,\n\t&_sm {\n\t\t@include fp;\n\t\tfont-weight: 600;\n\t\tletter-spacing: -1px; }\n\t&_lg {\n\t\tfont-size: 96px;\n\t\tline-height: (120/96); }\n\t&_md {\n\t\tfont-size: 72px;\n\t\tline-height: (88/72); }\n\t&_sm {\n\t\tfont-size: 64px;\n\t\tline-height: (72/64); } }\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n\t@include fp; }\n\n.h1,\n.h2,\n.h3 {\n\tfont-weight: 600;\n\tletter-spacing: -1px; }\n\n.h4,\n.h5,\n.h6 {\n\tfont-weight: 500; }\n\n.h1 {\n\tfont-size: 56px;\n\tline-height: (64/56);\n\t@include x {\n\t\tfont-size: 48px;\n\t\tline-height: (72/48); }\n\t@include m {\n\t\tfont-size: 40px;\n\t\tline-height: (60/40); } }\n\n.h2 {\n\tfont-size: 48px;\n\tline-height: (72/48);\n\t@include x {\n\t\tfont-size: 40px;\n\t\tline-height: (60/40); }\n\t@include m {\n\t\tfont-size: 32px;\n\t\tline-height: (48/32);\n\t\tletter-spacing: -.5px; } }\n\n.h3 {\n\tfont-size: 40px;\n\tline-height: (60/40);\n\t@include t {\n\t\tfont-size: 32px;\n\t\tline-height: (48/32);\n\t\tletter-spacing: -.5px; } }\n\n.h4 {\n\tfont-size: 32px;\n\tline-height: (48/32);\n\tletter-spacing: -.5px; }\n\n.h5 {\n\tfont-size: 24px;\n\tline-height: (32/24); }\n\n.h6 {\n\tfont-size: 18px;\n\tline-height: (24/18); }\n\n.caption {\n\tfont-size: 13px;\n\tfont-weight: 600;\n\tline-height: (18/13); }\n\n.caption-sm {\n\tfont-size: 12px;\n\tfont-weight: 500;\n\tline-height: (16/12); }\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
